export const spells = [
    {
        level: "0",
        name: "Enhanced Diplomacy",
        type: ["buff"],
        school: "divination",
        tags: [],
        longDesc: `You imbue the subject with divine diplomacy skills. The creature gets a +2 competence bonus on a single Diplomacy or Intimidate check. It must choose to use the bonus before making the roll to which it applies. You can apply this bonus to a single creature at the start of any store, but you must choose the recipient before any rolls have been made.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute or until dischard",
        savingThrow: "Will Negates(harmless)",
        spellResistance: "yes(harmless)",
        components: "V, S",
        },
        {
        level: "0",
        name: "Guidance",
        type: ["buff"],
        school: "divination",
        tags: [],
        longDesc: `This spell imbues the subject with a touch of divine guidance. The creature gets a +1 competence bonus on a single attack roll, saving throw, or skill check. It must choose to use the bonus before making the roll to which it applies.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute or until discharged",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
            level: "0",
            name: "Primal Savagery",
            type: ["buff","damage"],
            school: "transmutation",
            tags: [],
            longDesc: `You transform either a hand or your mouth into a savage weapon, allowing you to make either a claw or bite attack (bite deals 1d4, claw deals 1d8, both are primary weapons), this attack is done as apart of casting the spell. If you already have a natural attack of the type, you can instead improve the attack, improving its damage by 2 dice steps. Every 5 levels the damage of the natural attack improves by 1 step (this applies whether its improving a natural attack, or you're gaining a natural attack).`,
            castingTime: "1 standard action",
            range: "personal",
            area: "",
            effect: "",
            targets: "you",
            duration: "instantaneous",
            savingThrow: "",
            spellResistance: "",
            components: "V, S, ",
        },
        {
            level: "1",
            name: "Back in Action",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `You touch an unconscious creature below 0 hit points, urging it to get back in the action. They heal 1d6 + caster level hit points (max +5). If this healing retuns them to consciousness, they may stand up from prone as an immediate action, and it doesn't provoke attacks of opportunity.`,
            castingTime: "1 standard action",
            range: "touch",
            area: "",
            effect: "",
            targets: "1 living creature",
            duration: "instantaneous",
            savingThrow: "will (harmless)",
            spellResistance: "yes",
            components: "V, S, ",
        },
        {
        level: "0",
        name: "Haunted Fey Aspect",
        type: ["buff"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `You surround yourself with disturbing illusions, making you look and sound like a bizarre, insane fey creature. You gain DR 1/cold iron against a single opponent until the end of the spell, or until you take damage.`,
        castingTime: "1 standard action",
        range: "Personal",
        area: "",
        effect: "",
        targets: "You",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "S, ",
        },
        {
        level: "0",
        name: "Resistance",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You imbue the subject with magical energy that protects it from harm, granting it a +1 resistance bonus on saves.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "0",
        name: "Root",
        type: ["buff"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `This spell strengthens the subject's connection to the ground below, bolstering its defense against combat maneuvers. It gains a +2 insight bonus to its CMD to resist being moved or tripped and a +2 competence bonus on all Acrobatics checks made to balance or remain standing on earth, sand, stone, or a similar rocky substance.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "0",
        name: "Daze",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell clouds the mind of a humanoid creature with 4 or fewer Hit Dice so that it takes no actions. Humanoids of 5 or more HD are not affected. A dazed subject is not stunned, so attackers get no special advantage against it. After a creature has been dazed by this spell, it is immune to the effects of this spell for 1 minute.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one humanoid creature of 4 HD or less",
        duration: "1 round",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "0",
        name: "Flare",
        type: ["control"],
        school: "evocation",
        tags: ["light"],
        longDesc: `This cantrip creates a burst of light. If you cause the light to burst in front of a single creature, that creature is dazzled for 1 minute unless it makes a successful Fortitude save. Sightless creatures, as well as creatures already dazzled, are not affected by flare.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "burst of light",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "0",
        name: "Touch of Fatigue",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `You channel negative energy through your touch, fatiguing the target. You must succeed on a touch attack to strike a target. The subject is immediately fatigued for the spell's duration. This spell has no effect on a creature that is already fatigued. Unlike with normal fatigue, the effect ends as soon as the spell's duration expires.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
            level: "2",
            name: "Quick Throwing",
            type: ["buff","utility"],
            school: "transmutation",
            tags: [],
            longDesc: `Those under the effects of this spell become faster in the use of thrown weapons. They can draw thrown weapons (including rocks if they have the rock throwing ability) on their bodies or within their space without the need for the Quick Draw feat, allowing them to make their full normal rate of attacks with such weapons. This has no effects on other forms of ranged weapon ammunition. You can also cast this spell to instantly die or kill an ally (doesn't work if the ally is under an enemies control).`,
            castingTime: "1 standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "one creature/level, no two of which can be more than 30 ft. apart",
            duration: "1 round/level",
            savingThrow: "Fortitude negates (harmless)",
            spellResistance: "yes(harmless)",
            components: "V, S, M,",
        },
        {
        level: "0",
        name: "Acid Splash",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["acid"],
        longDesc: `You fire a small orb of acid at the target. You must succeed on a ranged touch attack to hit your target. The orb deals 1d3 points of acid damage per 3 caster levels (min, max 5d3). This acid disappears after 1 round.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one missile of acid",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "0",
        name: "Bleed",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `You cause a living creature that is below 0 hit points but stabilized to resume dying. Upon casting this spell, you target a living creature that has -1 or fewer hit points. That creature begins dying, taking 1d6 point of damage per round. The creature can be stabilized later normally. This spell causes a creature that is dying to take 1 point of damage.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "0",
        name: "Disrupt Undead",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `You direct a ray of positive energy. You must make a ranged touch attack to hit, and if the ray hits an undead creature, it deals 1d6 points of damage to it per 3 caster levels (min 1d6, max 5d6)`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "ray",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
            level: "0",
            name: "Toll the Dead",
            type: ["damage"],
            school: "necromancy",
            tags: [],
            longDesc: `The creature must make a will saving throw or take 1d6 negative energy damage. If the creature is below 50% hit points it suffers a -2 penalty on its saving throw and instead takes 2d6. Every 4 levels the dice increases by 1 dice step, and if its below 50% hit points the penalty to its save increases by -2.`,
            castingTime: "1 standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "1 living creature",
            duration: "instantaneous",
            savingThrow: "will negates",
            spellResistance: "yes",
            components: "V, S",
        },
        {
            level: "0",
            name: "Mind Sliver",
            type: ["damage", "control"],
            school: "enchantment",
            tags: [],
            longDesc: `You drive a disorienting spike of psychic energy into the mind of one creature you can see within range. The target must succeed on a will saving or take 1d6 untyped damage and subtract 1d4 from the next saving throw it makes before the end of your next turn. Every 5 caster levels the damage increases by 1d6 and the penalty on the save increases by 1 dice step.`,
            castingTime: "1 standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "1 intelligent creature",
            duration: "instantaneous and 1 round",
            savingThrow: "will negates",
            spellResistance: "yes",
            components: "V",
        },
        {
            level: "0",
            name: "Booming Blade",
            type: ["damage"],
            school: "evocation",
            tags: ["sonic"],
            longDesc: `You brandish the weapon used in the spell's casting and make a melee attack with it against one creature. On a hit, the target suffers the weapon attack's normal effects and then becomes sheathed in booming energy for 1 round. If the target willingly moves 5 feet or more before then, the target takes 1d8 electricity damage, and the spell ends. Every 5 caster levels the damage increases by 1d8.`,
            castingTime: "1 standard action",
            range: "touch",
            area: "",
            effect: "",
            targets: "1 melee weapon",
            duration: "1 round",
            savingThrow: "none",
            spellResistance: "yes",
            components: "S, M,",
        },
        {
        level: "0",
        name: "Fiery Beam",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `You cause a small beam of fire to strike the target with a successful ranged touch attack. The spell deals 1d3 points of fire damage per 3 caster levels (min 1d3, max 5d3).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "beam of fire",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "Yes",
        components: "V, S, ",
        },
        {
        level: "0",
        name: "Jolt",
        type: ["damage"],
        school: "transmutation",
        tags: ["electricity"],
        longDesc: `You cause a spark of electricity to strike the target with a successful ranged touch attack. The spell deals 1d3 points of electricity damage per 3 caster levels (min 1d3, max 5d3).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "spark of electricity",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "Yes",
        components: "V, S, ",
        },
        {
        level: "0",
        name: "Ray of Frost",
        type: ["damage"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `A ray of freezing air and ice projects from your pointing finger. You must succeed on a ranged touch attack with the ray to deal damage to a target. The ray deals 1d3 points of cold damage per 3 caster levels (min 1d3, max 5d3).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "ray",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "0",
        name: "Stabilize",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `Upon casting this spell, you target a living creature that has -1 or fewer hit points. That creature is automatically stabilized and heals 1 hit point at the start of each of its turns until it is conscious. If it takes damage again, this effect ends.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "0",
        name: "Virtue",
        type: ["healing"],
        school: "transmutation",
        tags: [],
        longDesc: `With a touch, you infuse a creature with a tiny surge of life, granting the subject 1 temporary hit point.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min.",
        savingThrow: "none",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
            level: "0",
            name: "Vigor",
            type: ["buff"],
            school: "transmutation",
            tags: [],
            longDesc: `This spell infuses the subject with a small surge of strength. The creature gets a +1 competence bonus on a single melee damage roll. It must choose to use the bonus before making the roll to which it applies. Ranged or spell attacks are unaffected by this spell.`,
            castingTime: "1 standard action",
            range: "touch",
            area: "",
            effect: "",
            targets: "creature touched",
            duration: "1 min or until discharged",
            savingThrow: "will negates(harmless)",
            spellResistance: "yes",
            components: "V, S",
        },
        {
        level: "0",
        name: "Breeze",
        type: ["utility"],
        school: "evocation",
        tags: ["air"],
        longDesc: `You create a light wind that blows against the target, from a direction of your choice. The breeze grants the subject a +2 bonus on saves against very hot conditions, severe heat, breath weapons, and saves against cloud vapors and gases (such as cloudkill, stinking cloud, and inhaled poisons). This spell does not function without air or underwater. You can only have one breeze active at any one time. If you cast this spell while another casting is still in effect, the previous casting is dispelled.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature or object",
        duration: "1 hour (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "0",
        name: "Dancing Lights",
        type: ["utility"],
        school: "evocation",
        tags: ["light"],
        longDesc: `Depending on the version selected, you create up to four lights that resemble lanterns or torches (and cast that amount of light), or up to four glowing spheres of light (which look like will-o'-wisps), or one faintly glowing, vaguely humanoid shape. The dancing lights must stay within a 10-foot-radius area in relation to each other but otherwise move as you desire (no concentration required): forward or back, up or down, straight or turning corners, or the like. The lights can move up to 100 feet per round. A light winks out if the distance between you and it exceeds the spell's range. You can only have one dancing lights spell active at any one time. If you cast this spell while another casting is still in effect, the previous casting is dispelled.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "Up to four lights, all within a 10-ft.-radius area",
        targets: "",
        duration: "1 minute",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "0",
        name: "Detect Magic",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `You detect magical auras. The amount of information revealed depends on how long you study a particular area or subject. 1st Round: Presence or absence of magical auras. 2nd Round: Number of different magical auras and the power of the most potent aura. 3rd Round: The strength and location of each aura. If the items or creatures bearing the auras are in line of sight, you can make Knowledge (arcana) skill checks to determine the school of magic involved in each. (Make one check per aura: DC 15 + spell level, or 15 + 1/2 caster level for a nonspell effect.) If the aura emanates from a magic item, you can attempt to identify its properties (see Spellcraft). Magical areas, multiple types of magic, or strong local magical emanations may distort or conceal weaker auras. Aura Strength: An aura's power depends on a spell's functioning spell level or an item's caster level; see the accompanying table. If an aura falls into more than one category, detect magic indicates the stronger of the two. Spell or Object Aura Power Faint Moderate Strong Overwhelming Functioning spell (spell level) 3rd or lower 4th-6th 7th-9th 10th+ (deity-level) Magic item (caster level) 5th or lower 6th-11th 12th-20th 21st+ (artifact) Lingering Aura: A magical aura lingers after its original source dissipates (in the case of a spell) or is destroyed (in the case of a magic item). If detect magic is cast and directed at such a location, the spell indicates an aura strength of dim (even weaker than a faint aura). How long the aura lingers at this dim level depends on its original power: Original Strength Duration of Lingering Aura Faint 1d6 rounds Moderate 1d6 minutes Strong 1d6x10 minutes Overwhelming 1d6 days Outsiders and elementals are not magical in themselves, but if they are summoned, the conjuration spell registers. Each round, you can turn to detect magic in a new area. The spell can penetrate barriers, but 1 foot of stone, 1 inch of common metal, a thin sheet of lead, or 3 feet of wood or dirt blocks it.`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "cone-shaped emanation",
        effect: "",
        targets: "",
        duration: "concentration, up to 1 min./level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "0",
        name: "Light",
        type: ["utility"],
        school: "evocation",
        tags: ["light"],
        longDesc: `This spell causes a touched object to glow like a torch. This causes it to emit normal light in a 20 foot radius, and dim light for an additional 20 feet past that. In an area of normal or bright light, this spell has no effect. The effect is immobile, but it can be cast on a movable object. In the Akashic Paths if you cast this on an object you carry around, it also effectively increases your vision range by 10 feet on maps with particulate conditions, and 20 feet on maps without them. You can only have one light spell active at any one time. If you cast this spell while another casting is still in effect, the previous casting is dispelled. Light can be used to counter or dispel any darkness spell of equal or lower spell level.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "object touched",
        duration: "10 min./level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, M,DF,",
        },
        {
        level: "0",
        name: "Mage Hand",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You point your finger at an object and can lift it and move it at will from a distance. As a move action, you can propel the object as far as 15 feet in any direction, though the spell ends if the distance between you and the object ever exceeds the spell's range.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one non-magical, unattended object weighing up to 5 lbs.",
        duration: "concentration",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "0",
        name: "Mending",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell repairs damaged objects, restoring 1d6 + 1 per 2 levels hit points to the object. If the object has the broken condition, this condition is removed if the object is restored to at least half its original hit points. All of the pieces of an object must be present for this spell to function. Magic items can be repaired by this spell, but you must have a caster level equal to or higher than that of the object. Magic items that are destroyed (at 0 hit points or less) can be repaired with this spell, but this spell does not restore their magic abilities. This spell does not affect creatures (including constructs). This spell has no effect on objects that have been warped or otherwise transmuted, but it can still repair damage done to such items.`,
        castingTime: "standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one object of up to 1 lb./level",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, ",
        },
        {
        level: "0",
        name: "Spark",
        type: ["utility"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `You can make an unattended Fine flammable object catch on fire. This works as if you were using flint and steel except that you can use spark in any sort of weather and it takes much less time to actually ignite an object.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one Fine object",
        duration: "instantaneous",
        savingThrow: "Fortitude negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Abjuring Step",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell creates a subtle and complicated force effect that is most effective when used by a still or slow-moving spellcaster or formula user. While you are subject to this spell, you can take two 5-foot steps each round and still cast spells and use spell-like abilities without provoke attacks of opportunity.
        \nThis spell automatically discharges as soon as you make an attack, cast a harmful spell against another creature, or move more than 5 feet with a single move action. If the action that discharges the spell also provokes attacks of opportunity, that action still provokes attacks of opportunity as normal.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level or until discharged",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M",
        },
        {
        level: "1",
        name: "Acid Maw",
        type: ["buff"],
        school: "transmutation",
        tags: ["acid"],
        longDesc: `Your cause a creatures bite attack deals an additional 1d4 points of acid damage, and the acid deals another 1d4 points of acid damage to the target on the next round. The acid continues to deal damage for 1 additional round per 4 caster levels (to a maximum of 6 total rounds at caster level 20th). This ongoing acid damage doesn't stack from multiple attacks, but the duration resets if a newer bite would cause the ongoing damage to last longer than the duration remaining from a previous one. The acid does not harm the creature this spell is cast on.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 2 ft./level)",
        area: "",
        effect: "",
        targets: "one ally",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "1",
        name: "Anticipate Peril",
        type: ["buff"],
        school: "divination",
        tags: [],
        longDesc: `A creature affected by anticipate peril gains a preternatural sense of danger. The first time during this spell's duration that the target has to make an initiative check, the creature adds an insight bonus on that initiative check equal to the spell's caster level (maximum +5). Once this bonus applies, the effects of the spell end.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level or until activated",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Aspect of the Falcon",
        type: ["buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You take on an aspect of a falcon. Your eyes become wide and raptor-like, and you grow feathers on the sides of your head. You gain a +3 competence bonus on Perception checks, a +1 competence bonus on ranged attacks, and increase the critical threat range of your ranged attacks by 1, this increase in range is flat and is not multiplied by any other affect.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        {
        level: "1",
        name: "Aspect of the Nightingale",
        type: ["buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You take on an aspect of a nightingale. Your voice becomes clear and pleasant. You gain a +2 competence bonus on Perform checks and a +2 competence bonus on Diplomacy checks. Once per minute, if you are subject to a charm effect that allows a saving throw, you may roll twice and take the more favorable result.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        {
        level: "1",
        name: "Bestow Planar Infusion I",
        type: ["buff"],
        school: "evocation",
        tags: [],
        longDesc: `This spell draws upon the latent planar energy of the caster's surroundings, allowing her to temporarily infuse a creature with the plane's power. The touched creature gains that plane's basic infusion for the spell's duration. This spell has no effect if cast on the Material Plane, and it ends as soon as the spell's target leaves the plane with which it has been infused. Details on planar infusions can be found in each plane's Infusion section, as presented in Chapter 3 of this book. Once a creature gains the benefits of bestow planar infusion I, it remains attuned to that plane for 24 hours. Additional castings of bestow planar infusion I during this time bestow the same infusion that was granted by the initial casting that day. Planar infusions that can be used a limited number of times per day are not refreshed by multiple castings of bestow planar infusion I.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 hour/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Bless",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `Bless fills your allies with courage. Each ally gains a +1 morale bonus on attack rolls and on saving throws against fear effects. Bless counters and dispels bane.`,
        castingTime: "1 standard action",
        range: "50 ft.",
        area: "The caster and all allies within a 50-ft. burst, centered on the caster",
        effect: "",
        targets: "",
        duration: "1 min./level",
        savingThrow: "none",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
            level: "1",
            name: "Wrath",
            type: ["buff"],
            school: "enchantment(compulsion)",
            tags: ["emotion","mind-affecting"],
            longDesc: `You focus your anger against an enemy. Choose one enemy creature that you can see. You gain a +1 morale bonus on attack rolls and weapon damage rolls against that designated creature for every three caster levels you have (at least +1, maximum +3). You also receive this bonus on caster level checks made to overcome the creature's Spell Resistance, if any. At 12th level, you gain the benefits of the Improved Critical feat on attack rolls made against the designated creature. If you are already doubling your critical threat range you instead gain a flat +1 bonus to your critical threat range.`,
            castingTime: "1 standard action",
            range: "personal",
            area: "",
            effect: "",
            targets: "",
            duration: "1 minute",
            savingThrow: "",
            spellResistance: "",
            components: "V, S, M",
        },
        {
        level: "1",
        name: "Blessed Fist",
        type: ["buff"],
        school: "transmutation",
        tags: ["good"],
        longDesc: `The target is considered to be armed even when unarmed, so it doesn't provoke attacks of opportunity when it attacks foes with unarmed strikes. Its unarmed strikes can deal lethal or nonlethal damage (target's choice). If the target already has this ability (such as from the monk unarmed strike ability or the Improved Unarmed Strike feat), its unarmed strikes gain a +1 enhancement bonus on attack rolls and damage rolls, and they count as good-aligned weapons for the purposes of overcoming damage reduction.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Blurred Movement",
        type: ["buff"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `This spell functions as blur, except that the blurring occurs only when you move at least 10 feet on your turn and ceases at the end of your movement. It is therefore mainly used to thwart attacks on your turn, such as attacks of opportunity. If you move at least twice your speed on your turn, the blurring lasts until the start of your next turn.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Bouncy Body",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The target's flesh becomes flexible and rubbery. It gains a +2 circumstance bonus on grapple combat maneuver checks and Escape Artist checks, as well as to its CMD against combat maneuver checks to grapple. Anytime the target would take falling damage, it treats falls as 20 feet shorter (minimum 0) for the purpose of determining damage. In addition, if the target falls against a hard surface, it can attempt an Acrobatics check (DC = the distance fallen) to attempt to bounce upward; success means the creature bounces upward half the distance fallen.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 minutes/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Bristle",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You give a creature the ability to redirect a portion of its innate toughness away from its own defense and toward the amount of damage it deals with natural and unarmed attacks. Each round, as a swift action at the start of its turn, the creature can choose to reduce some or all of its natural armor bonus to AC and gain an enhancement bonus on all damage rolls for natural attacks equal to that amount. The reduction to natural armor, and thus the enhancement bonus on damage rolls, cannot exceed 1 point per 3 caster levels, to a maximum penalty/bonus of -5/+5 at 15th level. A creature cannot reduce its natural armor bonus to less than 0 with this spell. All attacks directed against the creature use its adjusted AC until the start of its next turn, at which time it can choose to modify its AC again or keep it at its current level. Creatures make this decision without any need for conscious thought or reflection; even creatures with no Intelligence score can benefit from this spell, although they always opt for the maximum possible reduction and bonus, regardless of any tactical advantage they might lose.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "1",
        name: "Burst of Adrenaline",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You draw upon your body's inner reserves of strength, leaving you winded. When you are about to make a d20 roll based on Strength, Dexterity, or Constitution, you can cast this spell to gain a +8 enhancement bonus to Strength, Dexterity, or Constitution for that roll, but you are fatigued for 1 round afterward. You can't use this Spell while fatigued.`,
        castingTime: "1 immediate action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Burst of Insight",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You plumb the depths of your mind for insight, leaving you momentarily frazzled. When you are about to make a d20 roll based on Intelligence, Wisdom, or Charisma, you can cast this spell to gain a +8 enhancement bonus to Intelligence, Wisdom, or Charisma for that roll, but you are dazed for 1 round afterward.`,
        castingTime: "1 immediate action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Divine Favor",
        type: ["buff"],
        school: "evocation",
        tags: [],
        longDesc: `Calling upon the strength and wisdom of a deity, you gain a +1 luck bonus on attack and weapon damage rolls for every three caster levels you have (at least +1, maximum +3). The bonus doesn't apply to spell damage.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Embrace Destiny",
        type: ["buff"],
        school: "divination",
        tags: [],
        longDesc: `Upon completing this spell, roll a single d20 and record the result. At any point during the duration of this spell, you may use that roll for a single ability check, attack roll, initiative check, saving throw, or skill check, using the recorded result in place of a roll. This spell cannot be used to replace a roll that has already been made; the recorded result must be used instead of a roll. Once you have used this recorded result or the duration of the spell ends, the spell's effect ends. You can't have more than one instance of embrace destiny active on you at the same time.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (see text)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
            level: "1",
            name: "Hobble",
            type: ["control"],
            school: "transmutation",
            tags: [],
            longDesc: `This spell disrupts the method the targets uses for movement. Creatures under the effects of this spell move at half their base speed (rounded down to the nearest 5-foot increment) but can still take 5-foot steps as normal. Incorporeal creatures and creatures flying with perfect maneuverability are immune to the effects of this spell. Each round, a target receives another save to end the effect.`,
            castingTime: "1 standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "one creature/level, no two of which can be more than 20 feet apart",
            duration: "1 round/level",
            savingThrow: "Fortitude negates",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
            level: "1",
            name: "Enlarge Tail",
            type: ["buff"],
            school: "transmutation",
            tags: [],
            longDesc: `If you possess a tail that cannot be used to attack, you can now make tail attacks with it. It is a secondary natural attack that deals 1d6 points of bludgeoning damage (for medium creatures). If you already possessed a tail attack, it gains 5 feet of reach and a +1 bonus on its attack rolls and a +2 bonus on its damage rolls. If you have multiple tail attacks, select just one to gain the benefit of this spell, though you can cast it on each tail seperately if you desire.`,
            castingTime: "1 standard action",
            range: "personal",
            area: "",
            effect: "",
            targets: "your tail",
            duration: "1 hour/level",
            savingThrow: "",
            spellResistance: "",
            components: "V, S",
        },
        {
            level: "1",
            name: "Huntmaster's Weapon",
            type: ["buff"],
            school: "transmutation",
            tags: ["imbument"],
            longDesc: `Choose one creature type (and subtype, if applicable) from the ranger's favored enemy list. When you cast this spell, the targeted weapon hums with destructive energy and functions as a +1 weapon against creatures of the selected type.
            \nYou can discharge this spell in order to make an especially powerful attack with the weapon. The weapon's critical range and its critical multiplier increase by a flat +1 (unmodified by other abilities). If you make this attack as part of a charge action, you gain an enhancement bonus of +30 feet to your base speed while performing the charge. If you throw the weapon as part of this attack, its range increment increases to 80 feet. It also gains the bane special ability against the selected creature type and automatically bypasses any damage reduction (except DR/—) regardless of the creature's type.
            \nAny creature other than you treats the weapon as a normal weapon of its type. You can have only one huntmaster's weapon in effect at a time. If you cast the spell again, any previous instance of the spell immediately ends.`,
            castingTime: "1 standard action",
            range: "touch",
            area: "",
            effect: "",
            targets: "1 manufactured weapon",
            duration: "1 minute or until discharged",
            savingThrow: "will negates (harmless, object)",
            spellResistance: "yes (harmless, object)",
            components: "V, S, M/DF",
            additionalInfoTags:["Imbument"],
        },
        {
        level: "1",
        name: "Enlarge Person",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell causes instant growth of a humanoid creature, doubling its height and multiplying its weight by 8. This increase changes the creature's size category to the next larger one. The target gains a +2 size bonus to Strength, a -2 size penalty to Dexterity (to a minimum of 1), and a -1 penalty on attack rolls and AC due to its increased size. A humanoid creature whose size increases to Large has a space of 10 feet and a natural reach of 10 feet. This spell does not change the target's speed. If insufficient room is available for the desired growth, the creature attains the maximum possible size and may make a Strength check (using its increased Strength) to burst any enclosures in the process. If it fails, it is constrained without harm by the materials enclosing it-the spell cannot be used to crush a creature by increasing its size. All equipment worn or carried by a creature is similarly enlarged by the spell. Melee weapons affected by this spell deal more damage (see page 145). Other magical properties are not affected by this spell. Any enlarged item that leaves an enlarged creature's possession (including a projectile or thrown weapon) instantly returns to its normal size. This means that thrown and projectile weapons deal their normal damage. Magical properties of enlarged items are not increased by this spell. Multiple magical effects that increase size do not stack. Enlarge person counters and dispels reduce person.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one humanoid creature",
        duration: "1 min./level (D)",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Entropic Shield",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `A magical field appears around you, glowing with a chaotic blast of multicolored hues. This field deflects incoming arrows, rays, and other ranged attacks. Each ranged attack directed at you for which the attacker must make an attack roll has a 20% miss chance (similar to the effects of concealment). Other attacks that simply work at a distance are not affected.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Expeditious Retreat",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell increases your base land speed by 30 feet. This adjustment is treated as an enhancement bonus. There is no effect on other modes of movement, such as burrow, climb, fly, or swim. As with any effect that increases your speed, this spell affects your jumping distance (see the Acrobatics skill).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Face Of the Devourer",
        type: ["buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You transform the target's face into a hideous shape, such as a half-melted visage with insect legs instead of teeth, seeping pits instead of eyes, and suckered tongues dangling from its misshapen mouth. You do not choose what shape the target's face takes, and the shape is different every time you cast the spell. This transformation does not interfere with the target's senses or its ability to breathe, though it might prevent it from speaking. The target gains a +4 circumstance bonus on Intimidate checks. If the target does not normally have a bite attack, it gains a bite attack as a natural weapon for the duration of the spell. This bite attack deals 1d6 points of damage if the target is Medium, 1d4 points of damage if the target is Small, or 1d8 points of damage if the creature is Large. The target may use this bite as a primary attack or a secondary attack.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Fallback Strategy",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `While this spell is active, you may reroll one attack roll, combat maneuver check, or skill check before the result of the roll or check is known. You must take the result of the reroll, even if it's worse than the original roll. Once the reroll is used, the spell ends. You can have no more than one fallback strategy active on you at the same time.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level or until discharged",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Feather Step",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `For the duration of this spell, the subject ignores the adverse movement effects of difficult terrain, and can even take 5-foot steps in difficult terrain.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "10 minutes/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Gravity Bow",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Gravity bow significantly increases the weight and density of arrows or bolts fired from your bow or crossbow the instant before they strike their target and then return them to normal a few moments later. Any arrow fired from a bow or crossbow you are carrying when the spell is cast deals damage as if one size larger than it actually is. For instance, an arrow fired from a Medium longbow normally deals 1d8 points of damage, but it would instead deal 2d6 points of damage if fired from a gravity bow (see page 145 of the Core Rulebook for more information). Only you can benefit from this spell. If anyone else uses your bow to make an attack the arrows deal damage as normal for their size.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Heightened Awareness",
        type: ["buff"],
        school: "divination",
        tags: [],
        longDesc: `You enter a heightened state of awareness that allows you to notice more about your surroundings and recall information effortlessly. You gain a +2 competence bonus on Perception checks and on all Knowledge checks that you are trained in. If this spell is active when you have to make an initiative check, you can instantly dismiss this spell and gain a +4 bonus on that check.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 minutes/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, M, DF",
        },
        {
        level: "1",
        name: "Hermean Potential",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You gift the target with the ability to perfect its actions via mental clarity. On the next attack roll, saving throw, ability check, or skill check the target attempts, it rolls twice and takes the more favorable result. For every 5 caster levels you have, the target can roll twice on an additional attack roll, saving throw, ability check, or skill check (to a maximum of 5 rolls at 20th level).
        \nHermean potential is countered and dispelled by ill omen, but does not itself counter or dispel ill omen.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level",
        savingThrow: "will negates(harmless)",
        spellResistance: "no",
        components: "V, S, M",
        },
        {
        level: "1",
        name: "Hunter's Howl",
        type: ["buff"],
        school: "necromancy",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `With a single primal howl, you strike fear in your opponents. You gain a bonus +2 on weapon attacks and damage rolls, and a +2 bonus on bluff, knowledge checks, sense motive, and survival checks against creatures who fail the save against this spell. Creatures who fail the save also count as your favoured enemy for any other ability. This is a mind-affecting fear effect. Every 4 caster levels the bonuses you gain increase by +1, to a max of +4 at caster level 12.`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "20-ft-radius burst",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "none",
        components: "V, S",
        },
        {
            level: "3",
            name: "Hunter's Eye",
            type: ["buff","utility"],
            school: "divination",
            tags: [],
            longDesc: `Sharpening your perceptive abilities and tuning them against obfuscating effects, hunter's eye greatly enhances your senses against the target creature. You gain the ability to perceive the target when it is invisible or ethereal as though using the see invisibility spell, and receive a +20 competence bonus on Perception checks to locate the target.
            \nYou ignore concealment provided by fog or mist, blur, displacement, invisibility, and similar effects affecting the target, but not concealment provided by darkness. This spell provides no benefits to your allies and no benefits against creatures other than the target.`,
            castingTime: "1 standard action",
            range: "medium (100 ft. + 10 ft./level)",
            area: "",
            effect: "",
            targets: "one creature",
            duration: "1 minute/level",
            savingThrow: "none",
            spellResistance: "yes",
            components: "V, S, DF",
            },
        {
            level: "2",
            name: "Hunter's Mark",
            type: ["buff","utility"],
            school: "divinitation",
            tags: [],
            longDesc: `You choose a creature you can see within range and mystically mark it as your quarry. Until the spell ends, you deal an extra 1d6 damage to the target whenever you hit it with a weapon attack, and you gain a bonus on perception checks to locate the creature equal to your caster level (max +10). Every 5 levels the bonus damage increases by 1d6 (max 4d6). Additionally, if you miss an attack against the creature due to concealment, you can roll again and take the new result. You can only have a single Hunter's Mark, Hunter's Insight, or Hunt Master's Death Mark active at a time.`,
            castingTime: "1 standard action",
            range: "medium (100ft. + 10ft./level)",
            area: "",
            effect: "",
            targets: "1 creature",
            duration: "1 minute",
            savingThrow: "none",
            spellResistance: "none",
            components: "V, S",
        },
        {
            level: "1",
            name: "Hunter's Insight",
            type: ["buff","utility"],
            school: "divinitation",
            tags: [],
            longDesc: `You choose a creature you can see within range and mystically mark it as your quarry. For 1 round you deal an extra 1d6 damage to the target whenever you hit it with a weapon attack, and you gain a bonus on perception checks to locate the creature equal to your caster level (max +10). Every 5 levels the bonus damage increases by 1d6 (max 4d6). Additionally, if you miss an attack against the creature due to concealment, you can roll again and take the new result. You can only have a single Hunter's Mark, Hunter's Insight, or Hunt Master's Death Mark active at a time.`,
            castingTime: "1 swift action",
            range: "medium (100ft. + 10ft./level)",
            area: "",
            effect: "",
            targets: "1 creature",
            duration: "1 round",
            savingThrow: "none",
            spellResistance: "none",
            components: "V, S",
        },
        {
            level: "4",
            name: "Hunt Master's Death Mark",
            type: ["buff","utility"],
            school: "divinitation",
            tags: [],
            longDesc: `You call out a creature you can see within range and mark it for death. For 1 round all creatures deal an extra 1d6 damage to the target whenever they hit it with a weapon attack, and if an attack against the creature misses due to concealment, they can roll again and take the new result. You can only have a single Hunter's Mark, Hunter's Insight, or Hunt Master's Death Mark active at a time.`,
            castingTime: "1 swift action",
            range: "medium (100ft. + 10ft./level)",
            area: "",
            effect: "",
            targets: "1 ",
            duration: "1 round",
            savingThrow: "none",
            spellResistance: "none",
            components: "V, S",
        },
        {
        level: "1",
        name: "Ironbeard",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell causes a brushy beard of stiff iron to erupt from the face of a willing target. The ironbeard grants a +1 armor bonus to AC, and this bonus stacks with any armor worn by the creature. The ironbeard may also be used as a weapon equivalent to cold iron armor spikes. The ironbeard makes it difficult to speak, so any spellcasting with a verbal component has a 20% spell failure chance.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Jump",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The subject gets a +10 enhancement bonus on Acrobatics checks made to attempt high jumps or long jumps. The enhancement bonus increases to +20 at caster level 5th, and to +30 (the maximum) at caster level 9th.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Keen Senses",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The subject gains a +4 competence bonus on Perception checks and gains low-light vision. Subjects that have low-light vision double the distance they can see under the effects of this spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, M, DF",
        },
        {
        level: "1",
        name: "Keif Vigor",
        type: ["buff"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `The target gains a +2 enhancement bonus to its Strength. Once per round as a free action, the target can choose to increase the enhancement bonus by 2 for 1 round; if it does so, it takes 1d6 points of nonlethal damage and the spell's duration decreases by 1 additional round. For every 5 caster levels you have, the target can choose to increase the enhancement bonus by an additional 2, taking an additional 1d6 points of nonlethal damage and decreasing the duration by 1 additional round per increase to the Strength bonus, to a maximum enhancement bonus of +10 and 4d6 points of nonlethal damage at caster level 15th. The subject can't spend more rounds than remain in the duration. When the spell ends, the subject becomes fatigued.`,
        castingTime: "1 standard action",
        range: "Touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "1 round/level; see text",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "1",
        name: "Linebreaker",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You gain a +20 foot bonus to your base speed when charging and a +2 bonus on combat maneuver checks made to bull rush or overrun.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Long Arm",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Your arms temporarily grow in length, increasing your reach with those limbs by 5 feet.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Longshot",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell reduces the effect of range, granting a +10-foot bonus to the range increment of any weapon used by the subject.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,DF,",
        },
        {
        level: "1",
        name: "Longstrider",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell gives you a +10 foot enhancement bonus to your base speed. It has no effect on other modes of movement, such as burrow, climb, fly, or swim.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 hour/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M, ",
        },
        {
        level: "1",
        name: "Mage Armor",
        type: ["buff"],
        school: "conjuration(creation)",
        tags: ["force"],
        longDesc: `An invisible but tangible field of force surrounds the subject of a mage armor spell, providing a +4 armor bonus to AC. Unlike mundane armor, mage armor entails no armor check penalty, arcane spell failure chance, or speed reduction. Since mage armor is made of force, incorporeal creatures can't bypass it the way they do normal armor.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 hour/level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Magic Fang",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Magic fang gives one natural weapon or unarmed strike of the subject a +1 enhancement bonus on attack and damage rolls. The spell can affect a slam attack, fist, bite, or other natural weapon. The spell does not change an unarmed strike's damage from nonlethal damage to lethal damage.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF",
        },
        {
        level: "1",
        name: "Magic Weapon",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Magic weapon gives a weapon a +1 enhancement bonus on attack and damage rolls. An enhancement bonus does not stack with a masterwork weapon's +1 bonus on attack rolls. You can't cast this spell on a natural weapon, such as an unarmed strike (instead, see magic fang). A monk's unarmed strike is considered a weapon, and thus it can be enhanced by this spell. A weapon can have only a single imbument at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "weapon touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Marid's Mastery",
        type: ["buff"],
        school: "transmutation",
        tags: ["water"],
        longDesc: `The target gains a +2 bonus on attack and damage rolls if it and its opponent are touching water. If the opponent or the target is touching the ground and not water, the target takes a -4 penalty on attack and damage rolls.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "willing creature touched",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Moment of Greatness",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `Each creature affected by this spell is given the potential for greater success and glory. If the affected creature is benefiting from a morale bonus of any type, it can double that morale bonus on one roll or check, before making the roll. Once an affected creature uses this spell's effect, the spell is discharged for that subject.`,
        castingTime: "1 standard action",
        range: "50 ft.",
        area: "",
        effect: "",
        targets: "The caster and allies within a 50-ft. burst centered on the caster",
        duration: "1 minute/level or until discharged",
        savingThrow: "none",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "1",
        name: "Nereid's Grace",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You radiate the unearthly grace of a nereid. If you're not wearing armor, you gain a deflection bonus to your AC and CMD equal to your Charisma bonus (maximum +3). The maximum increases by 1 for every 6 levels you possess (maximum +6 at 18th level).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Phantom Blood",
        type: ["buff"],
        school: "necromancy",
        tags: [],
        longDesc: `You bolster your life energy. If the loss of hit points at the end of a temporary effect that modifies your Constitution (such as barbarian's rage or bloodrager's bloodrage) would cause you to become unconscious or kill you, you gain temporary hit points equal to your caster level (maximum 10). Each casting of this spell grants you temporary hit points only once.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 minutes/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Protection from Chaos",
        type: ["buff"],
        school: "abjuration",
        tags: ["lawful"],
        longDesc: `This spell wards a creature from attacks by that alignment of creature, from mental control, and from summoned creatures. It creates a magical barrier around the subject at a distance of 1 foot. The barrier moves with the subject and has three major effects.
        \nFirst, the subject gains a +2 deflection bonus to AC and a +2 resistance bonus on saves. Both these bonuses apply against attacks made or effects created by those aligned creatures.
        \nSecond, the subject immediately receives another saving throw (if one was allowed to begin with) against any spells or effects that possess or exercise mental control over the creature (including enchantment [charm] effects and enchantment [compulsion] effects, such as charm person, command, and dominate person). This saving throw is made with a +2 morale bonus, using the same DC as the original effect. If successful, such effects are suppressed for the duration of this spell. The effects resume when the duration of this spell expires. While under the effects of this spell, the target is immune to any new attempts to possess or exercise mental control over the target. This spell does not expel a controlling life force (such as a ghost or spellcaster using magic jar), but it does prevent them from controlling the target. This second effect only functions against spells and effects created by that alignment of creatures or objects, subject to GM discretion.      
        \nThird, the spell prevents bodily contact by summoned creatures of that alignment. This causes the natural weapon attacks of such creatures to fail and the creatures to recoil if such attacks require touching the warded creature. Summoned creatures that are not of that alignment are immune to this effect. The protection against contact by summoned creatures ends if the warded creature makes an attack against or tries to force the barrier against the blocked creature. Spell Resistance can allow a creature to overcome this protection and touch the warded creature.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level(D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no; see text",
        components: "V, S, M/DF",
        },
        {
        level: "1",
        name: "Protection from Evil",
        type: ["buff"],
        school: "abjuration",
        tags: ["good"],
        longDesc: `This spell wards a creature from attacks by evil creatures, from mental control, and from summoned creatures. It creates a magical barrier around the subject at a distance of 1 foot. The barrier moves with the subject and has three major effects. First, the subject gains a +2 deflection bonus to AC and a +2 resistance bonus on saves. Both these bonuses apply against attacks made or effects created by evil creatures. Second, the subject immediately receives another saving throw (if one was allowed to begin with) against any spells or effects that possess or exercise mental control over the creature (including enchantment [charm] effects and enchantment [compulsion] effects such as charm person, command, and dominate person). This saving throw is made with a +2 morale bonus, using the same DC as the original effect. If successful, such effects are suppressed for the duration of this spell. The effects resume when the duration of this spell expires. While under the effects of this spell, the target is immune to any new attempts to possess or exercise mental control over the target. This spell does not expel a controlling life force (such as a ghost or spellcaster using magic jar), but it does prevent them from controlling the target. This second effect only functions against spells and effects created by evil creatures or objects, subject to GM discretion. Third, the spell prevents bodily contact by evil summoned creatures. This causes the natural weapon attacks of such creatures to fail and the creatures to recoil if such attacks require touching the warded creature. Summoned creatures that are not evil are immune to this effect. The protection against contact by summoned creatures ends if the warded creature makes an attack against or tries to force the barrier against the blocked creature. Spell resistance can allow a creature to overcome this protection and touch the warded creature.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no; see text",
        components: "V, S, M,DF,",
        },
        {
        level: "1",
        name: "Protection from Good",
        type: ["buff"],
        school: "abjuration",
        tags: ["evil"],
        longDesc: `This spell wards a creature from attacks by that alignment of creature, from mental control, and from summoned creatures. It creates a magical barrier around the subject at a distance of 1 foot. The barrier moves with the subject and has three major effects.
        \nFirst, the subject gains a +2 deflection bonus to AC and a +2 resistance bonus on saves. Both these bonuses apply against attacks made or effects created by those aligned creatures.
        \nSecond, the subject immediately receives another saving throw (if one was allowed to begin with) against any spells or effects that possess or exercise mental control over the creature (including enchantment [charm] effects and enchantment [compulsion] effects, such as charm person, command, and dominate person). This saving throw is made with a +2 morale bonus, using the same DC as the original effect. If successful, such effects are suppressed for the duration of this spell. The effects resume when the duration of this spell expires. While under the effects of this spell, the target is immune to any new attempts to possess or exercise mental control over the target. This spell does not expel a controlling life force (such as a ghost or spellcaster using magic jar), but it does prevent them from controlling the target. This second effect only functions against spells and effects created by that alignment of creatures or objects, subject to GM discretion.           
        \nThird, the spell prevents bodily contact by summoned creatures of that alignment. This causes the natural weapon attacks of such creatures to fail and the creatures to recoil if such attacks require touching the warded creature. Summoned creatures that are not of that alignment are immune to this effect. The protection against contact by summoned creatures ends if the warded creature makes an attack against or tries to force the barrier against the blocked creature. Spell Resistance can allow a creature to overcome this protection and touch the warded creature.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level(D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no; see text",
        components: "V, S, M/DF",
        },
        {
        level: "1",
        name: "Protection from Law",
        type: ["buff"],
        school: "abjuration",
        tags: ["chaotic"],
        longDesc: `This spell wards a creature from attacks by that alignment of creature, from mental control, and from summoned creatures. It creates a magical barrier around the subject at a distance of 1 foot. The barrier moves with the subject and has three major effects.
        \nFirst, the subject gains a +2 deflection bonus to AC and a +2 resistance bonus on saves. Both these bonuses apply against attacks made or effects created by those aligned creatures.
        \nSecond, the subject immediately receives another saving throw (if one was allowed to begin with) against any spells or effects that possess or exercise mental control over the creature (including enchantment [charm] effects and enchantment [compulsion] effects, such as charm person, command, and dominate person). This saving throw is made with a +2 morale bonus, using the same DC as the original effect. If successful, such effects are suppressed for the duration of this spell. The effects resume when the duration of this spell expires. While under the effects of this spell, the target is immune to any new attempts to possess or exercise mental control over the target. This spell does not expel a controlling life force (such as a ghost or spellcaster using magic jar), but it does prevent them from controlling the target. This second effect only functions against spells and effects created by that alignment of creatures or objects, subject to GM discretion.               
        \nThird, the spell prevents bodily contact by summoned creatures of that alignment. This causes the natural weapon attacks of such creatures to fail and the creatures to recoil if such attacks require touching the warded creature. Summoned creatures that are not of that alignment are immune to this effect. The protection against contact by summoned creatures ends if the warded creature makes an attack against or tries to force the barrier against the blocked creature. Spell Resistance can allow a creature to overcome this protection and touch the warded creature.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level(D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no; see text",
        components: "V, S, M/DF",
        },
        {
        level: "1",
        name: "Reduce Person",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell causes instant diminution of a humanoid creature, halving its height, length, and width and dividing its weight by 8. This decrease changes the creature's size category to the next smaller one. The target gains a +2 size bonus to Dexterity, a -2 size penalty to Strength (to a minimum of 1), and a +1 bonus on attack rolls and AC due to its reduced size. A Small humanoid creature whose size decreases to Tiny has a space of 2-1/2 feet and a natural reach of 0 feet (meaning that it must enter an opponent's square to attack). A Large humanoid creature whose size decreases to Medium has a space of 5 feet and a natural reach of 5 feet. This spell doesn't change the target's speed. All equipment worn or carried by a creature is similarly reduced by the spell. Melee and projectile weapons deal less damage. Other magical properties are not affected by this spell. Any reduced item that leaves the reduced creature's possession (including a projectile or thrown weapon) instantly returns to its normal size. This means that thrown weapons deal their normal damage (projectiles deal damage based on the size of the weapon that fired them). Multiple magical effects that reduce size do not stack. Reduce person counters and dispels enlarge person.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one humanoid creature",
        duration: "1 min./level (D)",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Rite of Bodily Purity",
        type: ["buff"],
        school: "abjuration",
        tags: ["medatative"],
        longDesc: `You gain a +2 resistance bonus on saving throws to resist diseases, drugs, and poisons. Additionally, at any time during the spell's duration, whenever you fail a saving throw to resist a disease, drug, or poison, you can expend the spell's remaining duration as an immediate action in order to reroll that saving throw. You must take the second result, even if it's worse. The +2 resistance bonus granted by the spell applies to the reroll, but after you make this reroll, the spell ends.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "24 hours or until discharged",
        savingThrow: "",
        spellResistance: "",
        components: "V, M",
        },
        {
        level: "1",
        name: "Rite of Centered Mind",
        type: ["buff"],
        school: "abjuration",
        tags: ["medatative"],
        longDesc: `You gain a +1 resistance bonus on saving throws to resist mind-affecting effects. This resistance bonus is increased to +2 if the effect is an emotion or fear effect. Additionally, at any time during the spell's duration, whenever you fail a saving throw to resist a mind-affecting effect, you can expend the spell's remaining duration as an immediate action in order to reroll that saving throw. You must take the second result, even if it's worse. The +2 resistance bonus granted by the spell applies to the reroll, but after you make this reroll, the spell ends.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "24 hours or until discharged",
        savingThrow: "",
        spellResistance: "",
        components: "V,M",
        },
        {
        level: "1",
        name: "Shield",
        type: ["buff"],
        school: "abjuration",
        tags: ["force"],
        longDesc: `Shield creates an invisible shield of force that hovers in front of you. It negates magic missile attacks directed at you. The disk also provides a +4 shield bonus to AC. This bonus applies against incorporeal touch attacks, since it is a force effect. The shield has no armor check penalty or arcane spell failure chance.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Shield Of Faith",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell creates a shimmering, magical field around the target that averts and deflects attacks. The spell grants the subject a +2 deflection bonus to AC, with an additional +1 to the bonus for every six levels you have (maximum +5 deflection bonus at 18th level).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Shillelagh",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Your own bludgeoning weapon gains a +1 enhancement bonus on attack and damage rolls. A double weapon gains this enhancement for both ends of the weapon. It deals damage as if it were two size categories larger (a Small club or quarterstaff so transmuted deals 1d8 points of damage, a Medium 2d6, and a Large 3d6), +1 for its enhancement bonus. These effects only occur when the weapon is wielded by you. If you do not wield it, the weapon behaves as if unaffected by this spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one touched nonmagical bludgeoning weapon",
        duration: "1 min./level",
        savingThrow: "Will negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, DF",
        },
        {
        level: "1",
        name: "Shock Shield",
        type: ["buff"],
        school: "abjuration",
        tags: ["electricity", "force"],
        longDesc: `This spell creates an invisible shield similar to but not as strong as the shield spell. This shield hovers in front of you and negates magic missile attacks directed at you. The disk provides a +2 shield bonus to AC. This bonus applies against incorporeal touch attacks. At any time, as a free action, you may dismiss your shield, at which point it deals 1d4 points of electrical damage to all creatures within a 5-foot burst around you. For each round it is active, the damage increases by 1d4 (max 5d4). A Reflex saving throw halves the damage. Once the spell is at maximum damage, the shield bonus increases to +4.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Spiked Armor",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The targeted suit of armor or shield sprouts thousands of tiny iron spikes like porcupine quills. These do not harm the armor's wearer (though donning or removing armor under the effects of this spell takes twice as long), but they act as armor spikes or shield spikes (as appropriate). Any creature attacking the wearer with natural weapons takes 1 point of piercing damage for each attack that hits. At 5th level, the spikes gain a +1 enhancement bonus on attack and damage rolls; this bonus increases to +2 at 10th level. At 15th level, the spikes also gain the anarchic weapon quality.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 suit of metal armor or 1 metal shield",
        duration: "10 minutes/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M",
        },
        {
        level: "1",
        name: "Stunning Barrier",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You are closely surrounded by a barely visible magical field. The field provides a +1 deflection bonus to AC and a +1 resistance bonus on saves. Any creature that strikes you with a melee attack is stunned for 1 round (Will negates). Once the field has stunned an opponent, the spell is discharged.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level or until discharged",
        savingThrow: "none and Will negates (see text)",
        spellResistance: "no and yes (see text)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Sun Metal",
        type: ["buff"],
        school: "transmutation",
        tags: ["fire", "imbument"],
        longDesc: `[imbument] The target weapon ignites into flame that does not hurt the weapon or the wielder, but damages those hit by the weapon. When the weapon's wielder hits with this weapon, it deals an additional 1d4 points of fire damage. This damage is not multiplied in the case of a critical hit. This effect immediately ends if the weapon is submerged in water. It does not function on weapons with the frost or icy burst weapon special ability or any other effect that grants a weapon extra cold damage.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one melee weapon",
        duration: "1 round/level (see text)",
        savingThrow: "Fortitude negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, ",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "1",
        name: "Sunder Breaker",
        type: ["buff"],
        school: "abjuration",
        tags: ["force"],
        longDesc: `You place an invisible ward upon the target. The next time a creature succeeds at a sunder combat maneuver against the target, the attacker's weapon takes 1d6 points of damage per caster level (maximum 10d6). If the attacker used a natural weapon for the sunder, the attacker takes half this damage. Spell resistance applies to this damage. The attacker can attempt a Fortitude save to halve this damage. The ward on the target counts as a magical trap and can be detected and disabled as such.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level (D) or until discharged",
        savingThrow: "Will negates (harmless) and see text",
        spellResistance: "yes (harmless) and see text",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Timely Inspiration",
        type: ["buff"],
        school: "divination",
        tags: [],
        longDesc: `A word of arcane-empowered inspiration can snatch victory from seeming defeat. Cast this spell when a creature fails an attack roll or skill check. The target gains a +1 competence bonus per five caster levels (maximum +3 bonus) on the attack roll or skill check retroactively. If the bonus is enough to make the failure a success, the roll succeeds.`,
        castingTime: "1 immediate action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "will negates(harmless)",
        spellResistance: "yes (harmless)",
        components: "V, ",
        },
        {
        level: "1",
        name: "True Strike",
        type: ["buff"],
        school: "divination",
        tags: [],
        longDesc: `You gain temporary, intuitive insight into the immediate future during your next attack. Your next single attack roll (if it is made before the end of the next round) gains a +20 insight bonus. Additionally, you are not affected by the miss chance that applies to attackers trying to strike a concealed target.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "see text",
        savingThrow: "",
        spellResistance: "",
        components: "V, ",
        },
        {
        level: "1",
        name: "Unbreakable Heart",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `The target creature gains a +4 morale bonus on saving throws against mind-affecting effects that rely on negative emotions (such as crushing despair, rage, or fear effects) or that would force him to harm an ally (such as confusion). If the target is already under such an effect when receiving this spell, that effect is suppressed for the duration of this spell. It does not affect mind-affecting effects based on positive emotions (such as good hope or the inspire courage bard ability). A creature can still be charmed or otherwise magically controlled while under this spell's effects, but if such a creature ever receives a new saving throw against that effect as a result of being ordered to attempt to harm or otherwise oppose a true ally, he can roll that saving throw twice and take the better result as his actual roll. Calm emotions counters and dispels unbreakable heart.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "1 creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Unerring Weapon",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell causes a weapon to veer closer to vital areas, improving the result of a critical threat. This transmutation grants a +2 bonus on attack rolls to confirm critical hits plus 1 additional bonus point per four caster levels (maximum total bonus +7). If the spell is cast on projectiles, the effect ends on a specific projectile whenever that projectile is used to make an attack, regardless of whether the attack hits. For this spell, shuriken are considered projectiles.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one weapon or 20 projectiles, all of which must be together at the time of casting",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Veil of Heaven",
        type: ["buff"],
        school: "abjuration",
        tags: ["good"],
        longDesc: `You surround yourself with a veil of positive energy, making it harder for evil outsiders to harm you. For the duration of this spell, you gain a +2 sacred bonus to AC and on saves. Both of these bonuses apply only against attacks or effects created by outsiders with the evil subtype. You can dismiss this spell as a swift action to deal 1d8 points of damage + 1 point per paladin level to all such outsiders within 5 feet. A Will save halves this damage. If you are an evil caster this instead gives its bonuses against good creatures and the bonuses become profane bonuses. This spell cannot be cast by casters who are neither good or evil.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you or all creatures within 5 ft.; see text",
        duration: "10 minutes/level (D)",
        savingThrow: "Will half",
        spellResistance: "none",
        components: "V, S, M",
        },
        {
        level: "1",
        name: "Veil of Positive Energy",
        type: ["buff"],
        school: "abjuration",
        tags: ["good"],
        longDesc: `You surround yourself with a veil of positive energy, making it harder for undead creatures to harm you. For the duration of this spell, you gain a +2 sacred bonus to AC and on saves. Both of these bonuses apply only against attacks or effects created by undead creatures. You can dismiss this spell as a swift action to deal 1d8 points of damage + 1 point per paladin level to all such undead within 5 feet. A Will save halves this damage. If you are an evil caster this instead gives its bonuses against living creatures and the bonuses become profane bonuses. This spell cannot be cast by casters who are neither good or evil.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you or all creatures within 5 ft.; see text",
        duration: "10 minutes/level (D)",
        savingThrow: "Will half",
        spellResistance: "none",
        components: "V, S, M",
        },
        {
        level: "1",
        name: "Wave Shield",
        type: ["buff"],
        school: "abjuration",
        tags: ["water"],
        longDesc: `You create a rushing torrent of water in the rough outline of a shield. The water protects you from one physical or fire attack, granting you DR/- and fire resistance equal to half your caster level (minimum 1) on that attack. Once the spell has reduced the damage of one attack against you, it is discharged.`,
        castingTime: "1 immediate action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round or until discharged",
        savingThrow: "",
        spellResistance: "",
        components: "V, ",
        },
        {
        level: "1",
        name: "Weapons Against Evil",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Each weapon this spell affects each shines with pale light that dimly illuminates a 5-foot square. These weapons also ignore the DR of evil creatures that have DR 5 or lower, as long as the damage reduction is not DR/epic.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one weapon/level, no two of which can be more than 20 ft. apart",
        duration: "1 round/level",
        savingThrow: "Fortitude negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, DF,",
        },
        {
        level: "1",
        name: "Hedging Weapons",
        type: ["buff", "damage"],
        school: "abjuration",
        tags: ["force"],
        longDesc: `A weapon made from divine force appears and floats near you. This weapon takes the shape of a weapon of choice, and can either have a crit range of 18-20 x2, 19-20 x3, or x4. You gain one additional weapon at 6th level and every 4 caster levels thereafter-two at 6th, three at 10th, four at 14th, and a maximum of five weapons at 18th level. The weapon averts and deflects attacks, granting you a +1 deflection bonus to AC for each weapon summoned (maximum +5 at 18th level). As a standard action, you can grasp a weapon and throw it as a ranged attack at any target you can see within 30 feet of you (even if it's a type of weapon that can't normally be thrown). On a successful hit, the weapon deals 2d6 points of force damage to the target. Each weapon thrown lowers the total deflection bonus to your AC by 1 as it disappears immediately after the attack action. The spell immediately ends once you throw all the weapons.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Positive Pulse",
        type: ["buff", "damage"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell causes a wave of positive energy to spread from a point you designate, damaging foes vulnerable to positive energy and bolstering living creatures. Each creature damaged by positive energy in the area (such as undead) must succeed at a Will save or take 1d6 points of damage, plus 1 point for every 2 caster levels (maximum +5) (scales with positive spell power). Haunts manifesting in the spell's area also take this damage. This spell does not heal creatures healed by positive energy; such creatures instead gain a +2 bonus on saving throws against death effects, energy drain, negative energy, and effects directly caused by haunts. This bonus lasts for 1 round.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "5-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous plus 1 round (see text)",
        savingThrow: "Will negates or Will negates (harmless); see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Blend",
        type: ["buff", "utility"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `You draw upon your link to the wilderness to change the coloration of yourself and your equipment to match that of your surroundings. This grants you a +4 circumstance bonus on Stealth checks and allows you to make Stealth checks without cover or concealment, but only while you move no more than half your base speed or less. If you move more than half your base speed on your turn, you gain no benefit from this spell until the start of your next turn. If you make an attack, this spell ends (as invisibility).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 minutes/level",
        savingThrow: "",
        spellResistance: "",
        components: "S, ",
        },
        {
        level: "1",
        name: "Challenge",
        type: ["buff", "utility"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You challenge an evil creature to bring the fight to you, or suffer the consequences. You gain a +2 sacred bonus on all melee attacks against the subject of the spell. At the end of its turn, if the target has not made at least one attack on you, it becomes sickened. If you move away from the target, the spell ends. If the caster is evil this targets good creatures and the bonuses become profane. A caster who is neither good or evil cannot cast this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 minute/level (D)",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, DF",
        },
        {
        level: "1",
        name: "Cheetah's Sprint",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `A wild surge of energy courses through your body and propels you into a sprint. If you take a charge or run action before the end of your turn, you can move a total distance of up to 10 times your base land speed. This adjustment is an enhancement bonus. There is no effect on other modes of movement, such as burrow, climb, fly, or swim. As with other effects that increase your speed, this spell affects your jumping distance.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round",
        savingThrow: "",
        spellResistance: "",
        components: "V, ",
        },
        {
        level: "1",
        name: "Feather Fall",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `The affected creatures or objects fall slowly. Feather fall instantly changes the rate at which the targets fall to a mere 60 feet per round (equivalent to the end of a fall from a few feet), and the subjects take no damage upon landing while the spell is in effect. When the spell duration expires, a normal rate of falling resumes. The spell affects one or more Medium or smaller creatures (including gear and carried objects up to each creature's maximum load) or objects, or the equivalent in larger creatures: a Large creature or object counts as two Medium creatures or objects, a Huge creature or object counts as four Medium creatures or objects, and so forth. This spell has no special effect on ranged weapons unless they are falling quite a distance. If the spell is cast on a falling item, the object does half normal damage based on its weight, with no bonus for the height of the drop. Feather fall works only upon free-falling objects. It does not affect a sword blow or a charging or flying creature.`,
        castingTime: "1 immediate action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one Medium or smaller freefalling object or creature/level, no two of which may be more than 20 ft. apart",
        duration: "until landing or 1 round/level",
        savingThrow: "Will negates (harmless) or Will negates (object)",
        spellResistance: "yes (object)",
        components: "V, ",
        },
        {
        level: "1",
        name: "Lucky Number",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You are able to tweak tiny variables affecting a creature's immediate future in order to grant the target a bit of luck at the right time. Roll a d20; once during the duration of lucky number, when the target creature rolls that result (regardless of what type of dice the target rolls), the creature has the option to either reroll the result or add a +2 luck bonus to the result. The creature must decide to use this ability before the success or failure of the original roll is known. A creature can have only one lucky number at a time. If lucky number is cast on a creature already affected by that spell, the new number replaces the previous one.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one willing creature",
        duration: "24 hours or until discharged",
        savingThrow: "no",
        spellResistance: "no",
        components: "V, S",
        },
        {
        level: "1",
        name: "Monkey Fish",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `Your hands and feet alter to make you better at climbing and swimming. You gain a 10 foot climb speed and swim speed. This spell has no effect if you are wearing medium or heavy armor or carrying a medium or heavy load.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Vanish",
        type: ["buff", "utility"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `The creature or object touched becomes invisible. If the recipient is a creature carrying gear, that vanishes, too. If you cast the spell on someone else, neither you nor your allies can see the subject, unless you can normally see invisible things or you employ magic to do so. Items dropped or put down by an invisible creature become visible; items picked up disappear if tucked into the clothing or pouches worn by the creature. Light, however, never becomes invisible, although a source of light can become so (thus, the effect is that of a light with no visible source). Any part of an item that the subject carries but that extends more than 10 feet from it becomes visible. Of course, the subject is not magically silenced, and certain other conditions can render the recipient detectable (such as swimming in water or stepping in a puddle). If a check is required, a stationary invisible creature has a +40 bonus on its Stealth checks. This bonus is reduced to +20 if the creature is moving. The spell ends if the subject attacks any creature. For purposes of this spell, an attack includes any spell targeting a foe or whose area or effect includes a foe. Exactly who is a foe depends on the invisible character's perceptions. Actions directed at unattended objects do not break the spell. Causing harm indirectly is not an attack. Thus, an invisible being can open doors, talk, eat, climb stairs, summon monsters and have them attack, cut the ropes holding a rope bridge while enemies are on the bridge, remotely trigger traps, open a portcullis to release attack dogs, and so forth. If the subject attacks directly, however, it immediately becomes visible along with all its gear. Spells such as bless that specifically affect allies but not foes are not attacks for this purpose, even when they include foes in their area.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level (up to 5 rounds) (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Adhesive Spittle",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `Once during this spell's duration, you can spit a viscous liquid as a standard action. This liquid functions as a tanglefoot bag, except you do not have to make a successful attack roll to hit your target. The DCs to counteract this adhesive (to avoid being stuck to the floor, to fly, to break the adhesive, or to cast a spell) use the spell's DC rather than a tanglefoot bag's normal DCs. The adhesive persists for 2d4 rounds after you spit it.`,
        castingTime: "1 standard action",
        range: "15 ft.",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level or until discharged (see text)",
        savingThrow: "Reflex partial",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Advanced Scurvy",
        type: ["control"],
        school: "necromancy",
        tags: ["disease", "evil"],
        longDesc: `The subject contracts an advanced form of scurvy. He becomes constantly fatigued, suffers from bone pain (-1 penalty on Strength-and Dexterity-based checks), wounds easily (add +1 point of damage to any bleed effects affecting the target), experiences loose teeth, and is slow to heal (natural healing occurs at half the normal rate). Scurvy can be treated magically or can be overcome with proper nutrition; eating the right foods ends the fatigue and bone pain within 1-2 days and provides a full cure 2d6 days after that.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "instantaneous",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Bane",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["fear", "mind-affecting"],
        longDesc: `Bane fills your enemies with fear and doubt. Each affected creature takes a -1 penalty on attack rolls and a -1 penalty on saving throws against fear effects. Bane counters and dispels bless.`,
        castingTime: "1 standard action",
        range: "50 ft.",
        area: "50-ft.-radius burst, centered on you",
        effect: "",
        targets: "",
        duration: "1 min./level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Barbed Chains",
        type: ["control"],
        school: "conjuration(summoning)",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `You summon a chain from another realm, causing it to burst out from the ground and strike a target within the spell's range. You can have the chain either make a melee attack (dealing 1d6 points of slashing damage) or attempt a trip combat maneuver against the target. The chain uses your base attack bonus plus your key spellcasting ability score modifier as its attack bonus and combat maneuver bonus. On a successful hit or combat maneuver check, the target must attempt a Will save. If it fails its save, the creature is shaken for 1d4 rounds. You summon one additional chain every 3 levels after 1st, for a total of two chains at 4th level, three at 7th level, and a maximum of four at 10th level. Multiple chains can attack the same target but the shaken effect doesn't stack.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./level)",
        area: "",
        effect: "a chain sharpened at one end",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Will partial (see text)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Bungle",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: [],
        longDesc: `The target takes a -20 penalty on its next attack roll or check that requires a d20 roll. The action must be one deliberately taken by the target on its turn. Creatures with more than 10 HD are unaffected by this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one humanoid",
        duration: "concentration + 2 rounds or until triggered",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Calm Animals",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `This spell soothes and quiets animals, rendering them docile and harmless. Only ordinary animals (those with Intelligence scores of 1 or 2) can be affected by this spell. All the subjects must be of the same kind, and no two may be more than 30 feet apart. The maximum number of HD of animals you can affect is equal to 2d4 + caster level. The affected creatures remain where they are and do not attack or flee. They are not helpless and defend themselves normally if attacked. Any threat breaks the spell on the threatened creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "animals within 30 ft. of each other",
        duration: "1 min./level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Cause Fear",
        type: ["control"],
        school: "necromancy",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `The affected creature becomes frightened. If the subject succeeds on a Will save, it is shaken for 1 round. Creatures with 6 or more HD are immune to this effect. Cause fear counters and dispels remove fear.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature with 5 or fewer HD",
        duration: "1d4 rounds or 1 round; see text",
        savingThrow: "Will partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Charm Animal",
        type: ["control"],
        school: "enchantment(charm)",
        tags: ["mind-affecting"],
        longDesc: `This spell functions like charm person, except that it affects a creature of the animal type.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one animal",
        duration: "1 hour/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Charm Person",
        type: ["control"],
        school: "enchantment(charm)",
        tags: ["mind-affecting"],
        longDesc: `This charm makes a humanoid creature regard you as friendly. The humanoid will not attack you and will attempt to exclude you from all area of affect abilities or spells it has (it wont turn off that ablity if it us unable to avoid you), it can also count for flanking or as an ally for any other ability you have, and will accept harmless spells cast by you. It will not attempt to help you in any other way and you have no other control over it, such as protecting you from another creature, and will attempt to attack all other party members as normal. If you attack, damage, or cast any non-harmless spells on the creature, it gets an immediate resave with a +5 bonus (once per attack or ability).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one humanoid creature",
        duration: "1 hour/level",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "1",
        name: "Color Spray",
        type: ["control"],
        school: "illusion(pattern)",
        tags: ["mind-affecting"],
        longDesc: `A vivid cone of clashing colors springs forth from your hand, causing creatures to become stunned, perhaps also blinded, and possibly knocking them unconscious. Each creature within the cone is affected according to its HD. 2 HD or less: The creature is unconscious, blinded, and stunned for 2d4 rounds, then blinded and stunned for 1d4 rounds, and then stunned for 1 round. (Only living creatures are knocked unconscious.) 3 or 4 HD: The creature is blinded and stunned for 1d4 rounds, then stunned for 1 round. 5 or more HD: The creature is stunned for 1 round. Sightless creatures are not affected by color spray.`,
        castingTime: "1 standard action",
        range: "15 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous; see text",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Command",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["language-dependent", "mind-affecting"],
        longDesc: `You give the subject a single command, which it obeys to the best of its ability at its earliest opportunity. You may select from the following options. 
        \nApproach: On its turn, the subject moves toward you as quickly and directly as possible for 1 round. The creature may do nothing but move during its turn, and it provokes attacks of opportunity for this movement as normal. 
        \nDrop: On its turn, the subject drops whatever it is holding. It can't pick up any dropped item until its next turn. 
        \nFall: On its turn, the subject falls to the ground and remains prone for 1 round. It may act normally while prone but takes any appropriate penalties. 
        \nFlee: On its turn, the subject moves away from you as quickly as possible for 1 round. It may do nothing but move during its turn, and it provokes attacks of opportunity for this movement as normal. 
        \nHalt: The subject stands in place for 1 round. It may not take any actions but is not considered helpless. 
        \nIf the subject can't carry out your command on its next turn, the spell automatically fails.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "1",
        name: "Compel Hostility",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `Whenever a creature you can see that threatens you makes an attack against one of your allies, as an immediate action, you can compel that creature to attack you instead. When you compel a creature to attack you, you must first overcome that creature's spell resistance, and the creature can attempt a Will saving throw to ignore the compulsion. If you have any summoned creatures, you can instead choose them to be the target of the attack.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "see text",
        spellResistance: "see text",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Damp Powder",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell causes ammunition already loaded into the target firearm is ruined with moisture. Any attempt to fire that ammunition fails, with no chance for misfire, and the user must then take a full-round action to clear the weapon before reloading and firing it. If aware of this spell's effect prior to firing the altered ammunition (a DC 16 Spellcraft check to identify the spell being cast or similar effect), the firearm's user can spend a standard action to clear the altered ammunition from the firearm. Doing so destroys that ammunition.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 loaded firearm",
        duration: "instantaneous",
        savingThrow: "Will negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, M, DF",
        },
        {
        level: "1",
        name: "Doom",
        type: ["control"],
        school: "necromancy",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `This spell fills a single subject with a feeling of horrible dread that causes it to become shaken.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 min./level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Entangle",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell causes tall grass, weeds, and other plants to wrap around creatures in the area of effect or those that enter the area. Creatures that fail their save gain the entangled condition. Creatures that make their save can move as normal, but those that remain in the area must save again at the end of your turn. Creatures that move into the area must save immediately. Those that fail must end their movement and gain the entangled condition. Entangled creatures can attempt to break free as a move action, making a Strength or Escape Artist check. The DC for this check is equal to the DC of the spell. The entire area of effect is considered difficult terrain while the effect lasts. If the plants in the area are covered in thorns, those in the area take 1 point of damage each time they fail a save against the entangle or fail a check made to break free. Other effects, depending on the local plants, might be possible at GM discretion.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "plants in a 40-ft.-radius spread",
        effect: "",
        targets: "",
        duration: "1 min./level (D)",
        savingThrow: "Reflex partial; see text",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "1",
        name: "Flare Burst",
        type: ["control"],
        school: "evocation",
        tags: ["light"],
        longDesc: `This spell functions as flare, except it affects all creatures in a 10-foot-radius burst from the target point.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "10-ft.-radius burst of light",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "1",
        name: "Forbid Action",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["language-dependent", "mind-affecting"],
        longDesc: `You forbid the target a single course of action, which it avoids to the best of its ability. You may demand the target not take actions that fall into one of the following options. 
        \nAttack: The target cannot take any action that involves an attack roll, or uses a spell or ability that targets a foe or an area that includes a foe. 
        \nCast: Target cannot cast spells or use spell-like abilities. 
        \nCommunicate: The target cannot take any actions that allow it to communicate with anyone. This includes such acts as speaking, Bluff checks to pass secret messages, writing, and using telepathy. It does not prevent verbalizations made for purposes other than communication, such as command words or the verbal component of spellcasting. 
        \nDraw: Target cannot ready or prepare any item, weapon, component, or equipment. 
        \nMove: The target can take no act that would cause it to end up in a different location. The target does not resist being moved by others (and thus can be picked up or dragged, or can float along on a raft), but does not consciously attempt to move (including not directing a mount to move). The target is free to take any actions not forbidden by the caster. For example, a target affected by this spell's demand to not move is still free to cast spells, make attacks, or shout for help.`,
        castingTime: "1 standard action",
        range: "close (25 ft. +5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "1",
        name: "Fumbletongue",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This enchantment causes a creature to be unable to speak intelligibly. Any effort the target makes to talk, in any language, comes out as a useless mix of unconnected words and noises. Even magic words are affected to some extent; the target has a 20% spell failure chance for any spell it attempts to cast with verbal components, and a 20% chance to incorrectly use a command word to activate a magic item. This spell has no effect on telepathic communication, or the vocalizations of creatures that lack a spoken language.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1d4 rounds",
        savingThrow: "Will Negates",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "1",
        name: "Glue Seal",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You cover a solid surface with a layer of sticky glue. Anyone in the area when the spell is cast must attempt a Reflex save. Those who fail become entangled, but can break free by succeeding at a combat maneuver check or an Escape Artist check as a standard action against the DC of this spell. The area of the spell is considered difficult terrain. A creature moving through the glue must succeed at a combat maneuver check or an Escape Artist check as part of its move action (DC = the spell's DC). Creatures that fail lose their movement and become entangled in the first square they enter. The spell can also be used to create a sticky coating on an item. A creature holding a targeted item can attempt a Reflex saving throw against the spell's DC. If the initial saving throw succeeds, the item is unaffected. If it fails, the item is stuck in place. If an affected item is connected to another item (such as a sword in a sheath or a cork in a potion bottle), it cannot be separated from the other item unless the creature succeeds at a combat maneuver check or a Strength check as a move action to free it (DC = the spell's DC). A creature must succeed at saving throw each time it attempts to use the sticky item; otherwise, the item becomes stuck to the creature. Sticky armor or clothing imposes a -10 circumstance penalty on Escape Artist checks and combat maneuver checks to escape a grapple attempted by the wearer, as well as to the wearer's CMD to avoid being grappled.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one object or one 5-ft. square",
        duration: "1 minute/level (D)",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Grasping Corpse",
        type: ["control"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `You can cause one nearby corpse to animate for a brief moment. Choose a creature within 30 feet of the corpse (even if the creature is outside the spell's range). The corpse shambles toward the creature and then attempts to trip or grapple it (your choice). The corpse does not provoke attacks of opportunity. Attempt a special combat maneuver check against the chosen creature. Your CMB for this combat maneuver is equal to your caster level plus your highest mental modifier. If you chose to trip the creature, it falls prone if you equal or exceed its CMD. If you chose to grapple, the creature gains the grappled condition until it breaks free from the corpse. Treat your save DC for a spell of this level as the CMD of the grasping corpse. Alternatively, destroying the corpse with damage ends the grapple. The corpse has 12 hit points and DR 5/slashing.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one corpse",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Grease",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `A grease spell covers a solid surface with a layer of slippery grease. Any creature in the area when the spell is cast must make a successful Reflex save or fall. A creature can walk within or through the area of grease at half normal speed with a DC 10 Acrobatics check. Failure means it can't move that round (and must then make a Reflex save or fall), while failure by 5 or more means it falls (see the Acrobatics skill for details). Creatures that do not move on their turn do not need to make this check and are not considered flat-footed. The spell can also be used to create a greasy coating on an item. Material objects not in use are always affected by this spell, while an object wielded or employed by a creature requires its bearer to make a Reflex saving throw to avoid the effect. If the initial saving throw fails, the creature immediately drops the item. A saving throw must be made in each round that the creature attempts to pick up or use the greased item. A creature wearing greased armor or clothing gains a +10 circumstance bonus on Escape Artist checks and combat maneuver checks made to escape a grapple, and to their CMD to avoid being grappled.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one object or 10-ft. square",
        duration: "1 min./level (D)",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Haze Of Dreams",
        type: ["control"],
        school: "enchantment(charm)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You fill an enemy's head with waking dreams, a reminder of the pleasures, delights, and terrors to be found in the dream world. While in this strange dream state, the target moves at half its normal speed (round down to the next 5-foot increment), which affects the creature's jumping distance as normal for decreased speed. Multiple haze of dreams effects do not stack, nor does this spell's effect stack with slow.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, M,",
        },
        {
        level: "1",
        name: "Hex Vulnerability",
        type: ["control"],
        school: "necromancy",
        tags: ["curse"],
        longDesc: `The targeted creature becomes susceptible to a repeat use of your harmful hexes, even if you could not otherwise target that creature with a particular hex for a certain time period. For example, normally after you target a creature with a charm hex, you cannot target it again for 1 day. But after casting this spell on a creature, you could try the charm hex repeatedly as long as the spell persists. The end of this spell has no effect on any active or ongoing hex on a creature. For example, if the creature failed its save against a second use of your charm hex, it remains charmed for the normal duration, even if the spell expires before the hex does.
                \nEach subsequent casting of this spell on a target within a 24-hour period gives the target a +4 bonus on its save against the spell and imposes a –4 penalty on your caster level check to overcome the target's spell resistance with this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "1",
        name: "Hydraulic Push",
        type: ["control"],
        school: "evocation",
        tags: ["water"],
        longDesc: `You call forth a quick blast of water that knocks over and soaks one creature or square. You can use this blast of water to make a bull rush against any one creature or object. Your CMB for this bull rush is equal to your caster level plus your highest mental modifier. This bull rush does not provoke an attack of opportunity. Hydraulic push extinguishes any normal fires on a creature, object, or in a single 5-foot square which it is targeted against. Magical fires are unaffected.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature or object",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Hypnotism",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `Your gestures and droning incantation fascinate nearby creatures, causing them to stop and stare blankly at you. Roll 2d4 to see how many total HD of creatures you affect. Creatures with fewer HD are affected before creatures with more HD. Only creatures that can see or hear you are affected, but they do not need to understand you to be fascinated. If you use this spell while not in combat, the DC increases by +2.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "several living creatures, no two of which may be more than 30 ft. apart",
        effect: "",
        targets: "",
        duration: "2d4 rounds",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Ill Omen",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You afflict the target with bad luck. On the next d20 roll the target makes, it must roll twice and take the less favorable result. For every five caster levels you have, the target must roll twice on an additional d20 roll (to a maximum of five rolls at 20th level).
                \nA target who can speak and has at least one free hand and who is aware of the spell and its effects (such as from a Spellcraft check to identify the spell as it is cast) can negate one reroll by spending a move action to utter a brief prayer or good luck charm to appease the spirits of ill fortune.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level or until discharged",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "1",
        name: "Itching Curse",
        type: ["control"],
        school: "necromancy",
        tags: ["curse"],
        longDesc: `You curse the target with a distracting, unbearable itch. Unless the target scratches as a move action, it takes a -1 penalty on attack rolls, saving throws, skill checks, and ability checks.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature with 5 HD or fewer",
        duration: "1 hour/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Knight's Calling",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You compel an enemy to come and fight you. On its turn, the target moves its speed toward you, avoiding any other dangers along its path (including any movement that would provoke attacks of opportunity). The target may do nothing but move on its turn. If the target ends its move adjacent to you, you can make an attack of opportunity against the target.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 Round",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, DF,",
        },
        {
        level: "1",
        name: "Litany of sloth",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["language-dependent", "mind-affecting"],
        longDesc: `With a litany against the wages of sloth, you slow the target's defenses. The target cannot make attacks of opportunity or cast spells defensively.
                        \nWhile subject to this spell, the target cannot be the target of another spell that has the word “litany” in the title.`,
        castingTime: "1 swift action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Mudball",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["earth"],
        longDesc: `When you cast this spell, you conjure a single ball of sticky mud and launch it at an enemy's face as a ranged touch attack. If the mudball hits, the target is blinded. Each round at the beginning of its turn, a creature blinded by this spell can attempt a Reflex saving throw to shake off the mud, ending the effect. The mudball can also be wiped off by the creature affected by it or by a creature adjacent to the creature affected by it as a standard action.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "single fist-sized blob of sticky mud",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex negates; see text",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Murderous Command",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You give the target a mental urge to kill its nearest ally, which it obeys to the best of its ability. The target attacks its nearest ally on its next turn with a melee weapon or natural weapon. If necessary, it moves to or charges to the nearest ally in order to make this attack. If it is unable to reach its closest ally on its next turn, the target uses its turn to get as close as possible to the ally.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "1",
        name: "Nauseating Dart",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["poison"],
        longDesc: `You spit a poisonous stinger around the size of a quill at a creature within range, as though you had fired a dart from a blowgun. You must succeed at a ranged attack to hit your target. The stinger deals 1d2 points of piercing damage and poisons the target, causing it to become nauseated for 1 round unless it succeeds at a Fortitude save.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one poisonous stinger",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Fortitude partial (see text)",
        spellResistance: "no",
        components: "S, DF",
        },
        {
        level: "1",
        name: "Peacebond",
        type: ["control"],
        school: "abjuration",
        tags: [],
        longDesc: `You lock a weapon in place on its owner's body, or within the weapon's sheath or holster. Anyone who then tries to draw the weapon must spend a standard action and succeed at a Strength check (DC equal to the saving throw DC) to do so, provoking attacks of opportunity whether the attempt succeeds or fails.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one sheathed or slung weapon",
        duration: "1 minute/level",
        savingThrow: "Will negates (object)",
        spellResistance: "yes (object)",
        components: "S, ",
        },
        {
        level: "1",
        name: "Ray of Enfeeblement",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `A coruscating ray springs from your hand. You must succeed on a ranged touch attack to strike a target. The subject takes a penalty to Strength equal to 1d6+1 per two caster levels (maximum 1d6+5). The subject's Strength score cannot drop below 1. A successful Fortitude save reduces this penalty by half. This penalty does not stack with itself. Apply the highest penalty instead.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "ray",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Fortitude half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Ray of Sickening",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell functions as ray of exhaustion, except the target is sickened if it fails its save and unaffected if it makes its save.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "ray",
        targets: "",
        duration: "1 min./level",
        savingThrow: "Fortitude partial; see text",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Shadow Trap",
        type: ["control"],
        school: "illusion(shadow)",
        tags: ["shadow"],
        longDesc: `You pin the target's shadow to its current location, causing the target to become entangled and preventing it from moving farther than 5 feet from its original position, as if its shadow were anchored to the terrain. Each round on its turn, the target can attempt a new saving throw to end the effect as a full-round action. A flying creature can only hover in place or fall while entangled in this manner. This spell automatically fails when cast on a creature that doesn't throw a shadow, and it ends if the creature is entirely in an area with no illumination.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Sleep",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `A sleep spell causes a magical slumber to come upon 4 HD of creatures. Creatures with the fewest HD are affected first. Among creatures with equal HD, those who are closest to the spell's point of origin are affected first. HD that are not sufficient to affect a creature are wasted. Sleeping creatures are helpless. Slapping or wounding awakens an affected creature, but normal noise does not. Awakening a creature is a standard action (an application of the aid another action). Sleep does not target unconscious creatures, constructs, or undead creatures.`,
        castingTime: "1 round",
        range: "medium (100 ft. + 10 ft./level)",
        area: "one or more living creatures within a 10-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "1 min./level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Stumble Gap",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You create a shallow extradimensional hole perfectly sized to trip anyone who steps within it. This hole occupies a single 5-foot square with a depth of six inches. Any creature occupying the square when you first create the hole, or who later steps into the square containing the hole, must make a Reflex saving throw to avoid falling prone in an adjacent square and taking 1d6 points of damage. A creature that makes its saving throw still stumbles ever so slightly and takes a -1 penalty on all rolls and checks for 1 round. The spell has no effect on creatures adjacent to the square containing the hole.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "see text",
        targets: "",
        duration: "1 round + 1 round/level",
        savingThrow: "Reflex partial",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Thunderstomp",
        type: ["control"],
        school: "evocation",
        tags: ["earth"],
        longDesc: `You stomp your foot or strike your weapon against the ground or floor, creating a ripple of power that you can use to trip a creature. Attempt the combat maneuver check to trip the target, but instead of your base attack bonus you can use your caster level, and instead of your Strength modifier you can use your highest mental modifier. This trip attempt does not provoke an attack of opportunity. This spell has no effect if you cannot reach the ground or floor, or if your target is not in contact with the ground or floor.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Touch of Blindness",
        type: ["control"],
        school: "necromancy",
        tags: ["darkness", "shadow"],
        longDesc: `A touch from your hand, which is engulfed in darkness, disrupts a creature's vision by coating its eyes in supernatural darkness. Each touch causes the target to become blinded for 1 round unless it makes a successful Fortitude saving throw. You can use this melee touch attack up to one time per caster level. Any touch attack not used after 1 round per caster level is lost.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature or creatures touched (up to one/level)",
        duration: "1 round/level (see text)",
        savingThrow: "Fortitude negates",
        spellResistance: "Yes",
        components: "V, ",
        },
        {
        level: "1",
        name: "Touch of Gracelessness",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `With a single touch, you reduce a creature to a fumbling clown. The target takes a penalty to its Dexterity equal to 1d6+1 per two caster levels (maximum 1d6+5). This penalty cannot drop the target's Dexterity score below 1. In addition, if the subject moves more than half its speed, it falls prone. If the subject flies, its maneuverability is reduced by one step (perfect maneuverability becomes good, good becomes average, and so on). A successful Fortitude save halves the penalty to Dexterity and negates the possibility of falling prone or the reduction to fly maneuverabilities.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Unlock Flesh",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `By touching a creature with a bladed instrument, you cause the creature's flesh to loosen and slide against its skeletal moorings. A living creature touched becomes staggered by the disturbing and uncomfortable sensation for 1 round per level. Each round on its turn, the subject can attempt a new saving throw to end the effect. This is a standard action that does not provoke attacks of opportunity. A corporeal undead creature targeted by this spell instead takes 1d6 points of damage per caster level (maximum 5d6 at 5th level) as wet, oozing chunks of flesh slough off its desiccated bones (a successful Fortitude save halves this damage). Incorporeal creatures, or creatures that do not have flesh, are immune to this spell's effects.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level or instantaneous; see text",
        savingThrow: "fort negates",
        spellResistance: "yes",
        components: "V, S, F",
        },
        {
        level: "1",
        name: "Unprepared Combatant",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `The target takes a -4 penalty on initiative checks and Reflex saves.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Weaken Powder",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `Ammunition in the target firearm generates less of an explosive charge when fired. With such ammunition, the firearm's range increment is halved and the firer takes a -2 penalty on damage rolls. If aware of this spell's effect prior to firing the altered ammunition (a DC 16 Spellcraft check to identify the spell being cast or similar effect), the firearm's user can spend a standard action to clear the altered ammunition from the firearm. Doing so destroys that ammunition.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 loaded firearm",
        duration: "instantaneous",
        savingThrow: "Will negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, M, DF",
        },
        {
        level: "1",
        name: "Web Bolt",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You launch a ball of webbing at a target, which must make a save or be affected as if by a web spell occupying only the creature's space. If the creature saves or breaks free of the webbing, the remaining webs dissolve and the square is not considered difficult terrain. The spell has no effect if the target is not on or adjacent to a solid surface that can support the webbing.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "fist-sized blob of webbing",
        targets: "",
        duration: "1 min./level",
        savingThrow: "Reflex negates; see text",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Delusional Pride",
        type: ["control", "buff"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `The target becomes so distracted by an overblown sense of its worth that it takes a -2 penalty on attacks and skill checks. However, this feeling also gives the target a +2 morale bonus on saves against charm and compulsion effects.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 minute",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Ear-Piercing Scream",
        type: ["control", "damage"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `You unleash a powerful scream, inaudible to all but a single target. The target is dazed for 1 round and takes 1d6 points of sonic damage per two caster levels (maximum 5d6). A successful save negates the daze effect and halves the damage.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous; see text",
        savingThrow: "Fortitude partial (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Break",
        type: ["control", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You can attempt to break or at least damage any one Medium or smaller object within range. If the target fails its Fortitude saving throw, it gains the broken condition. If cast on a broken item, that item is destroyed on a failed save.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one Medium or smaller object",
        duration: "instantaneous",
        savingThrow: "Fortitude negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Obscuring Mist",
        type: ["control", "utility"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `A misty vapor arises around you. It is stationary. The vapor obscures all sight, including darkvision, beyond 5 feet. A creature 5 feet away has concealment (attacks have a 20% miss chance). Creatures farther away have total concealment (50% miss chance, and the attacker cannot use sight to locate the target). A moderate wind (11+ mph), such as from a gust of wind spell, disperses the fog in 4 rounds. A strong wind (21+ mph) disperses the fog in 1 round. A fireball, flame strike, or similar spell burns away the fog in the explosive or fiery spell's area. A wall of fire burns away the fog in the area into which it deals damage. This spell does not function underwater.`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "",
        effect: "cloud spreads in 20-ft. radius from you, 20 ft. high",
        targets: "",
        duration: "1 min./level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Biting Words",
        type: ["damage"],
        school: "evocation",
        tags: ["language-dependent", "sonic"],
        longDesc: `Your voice becomes suffused with magic so that you can harm your opponents with but a word. As a standard action, you can target one opponent within 30 feet with a ranged touch attack by speaking to it, dealing an amount of damage equal to 1d6 + your Strength or Charisma modifier, whichever is higher. The damage dealt is bludgeoning, piercing, and slashing damage and can be reduced by damage reduction. Each attack you make reduces the spell's remaining duration by 1 minute. If an attack reduces the remaining duration to 0 minutes or less, the spell ends after the attack resolves.
                \nYou can attack with biting words by shouting instead of speaking intelligibly. When doing so, the amount of damage dealt by the attack is reduced to 1d4 + 1/2 your Strength or Charisma modifier (whichever is higher), but the spell doesn't count as having the language-dependent descriptor for that attack.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "Will negates(harmless)",
        spellResistance: "no",
        components: "V, S",
        },
        {
        level: "1",
        name: "Burning Hands",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `A cone of searing flame shoots from your fingertips. Any creature in the area of the flames takes 1d4 points of fire damage per caster level (maximum 5d4). Flammable materials burn if the flames touch them. A character can extinguish burning items as a full-round action.`,
        castingTime: "1 standard action",
        range: "15 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
            level: "1",
            name: "Thunderwave",
            type: ["damage"],
            school: "evocation",
            tags: ["electricity","sonic"],
            longDesc: `You create a dazzling wave of electricity and sound that fills the area. Thunderwave inflicts 1 point of electricity damage per caster level (max 5) to all creatures within the area of effect (no save). The true power of the spell, though, lies not in the damage it inflicts but in the overwhelming pain the lightning creates. The sudden flash and jolt dazes living creatures for 1 round if they fail a saving throw. Creatures that save are instead dazzled for 1 round. Any creature wearing metal armor takes a -2 penalty to its saving throw against this spell.`,
            castingTime: "1 standard action",
            range: "15 ft.",
            area: "cone-shaped burst",
            effect: "",
            targets: "",
            duration: "instantaneous",
            savingThrow: "fortitude partial",
            spellResistance: "yes",
            components: "V, S, ",
        },
        {
            level: "2",
            name: "Binding Ice",
            type: ["damage"],
            school: "evocation",
            tags: ["cold"],
            longDesc: `A wave of blistering cold flows from your fingertips. Any creature in the area of the cold takes 1d4 points of cold damage per caster level (maximum 5d4) and becomes entangled to the ground for 1d4 rounds. The reflex save halves the damage and negates the entangle. A creature can spend a standard action to break the entanglement of themselves or an ally.`,
            castingTime: "1 standard action",
            range: "15 ft.",
            area: "cone-shaped burst",
            effect: "",
            targets: "",
            duration: "instantaneous",
            savingThrow: "Reflex half",
            spellResistance: "yes",
            components: "V, S, ",
            },
        {
            level: "1",
            name: "Acid Spray",
            type: ["damage"],
            school: "evocation",
            tags: ["acid"],
            longDesc: `A cone of corrosive acid shoots from your fingertips. Any creature in the area of the acid takes 1d3 points of acid damage per caster level (maximum 5d3). A creature who fails the reflex save also becomes covered in acid, taking half as much acid damage at the start of their next turn unless they spend a movement action scraping the acid off.`,
            castingTime: "1 standard action",
            range: "15 ft.",
            area: "cone-shaped burst",
            effect: "",
            targets: "",
            duration: "instantaneous",
            savingThrow: "Reflex half",
            spellResistance: "yes",
            components: "V, S, ",
            },
        {
            level: "2",
            name: "Scorch",
            type: ["damage"],
            school: "evocation",
            tags: ["fire"],
            longDesc: `A blast of searing flame shoots from your fingertips. Any creature in the area of the flames takes 1d4 points of fire damage per caster level (maximum 10d4). Flammable materials burn if the flames touch them. A character can extinguish burning items as a full-round action.`,
            castingTime: "1 standard action",
            range: "30 ft. line, 10ft. wide",
            area: "cone-shaped burst",
            effect: "",
            targets: "",
            duration: "instantaneous",
            savingThrow: "Reflex half",
            spellResistance: "yes",
            components: "V, S",
        },
        {
        level: "1",
        name: "Chill Touch",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `A touch from your hand, which glows with blue energy, disrupts the life force of living creatures. Each touch channels negative energy that deals 1d6 points of damage. The touched creature also takes 1 point of Strength damage unless it makes a successful Fortitude saving throw. You can use this melee touch attack up to one time per level. An undead creature you touch takes no damage of either sort, but it must make a successful Will saving throw or flee as if panicked for 1d4 rounds + 1 round per caster level.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature or creatures touched (up to one/level)",
        duration: "instantaneous",
        savingThrow: "Fortitude partial or Will negates; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Corrosive Touch",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["acid"],
        longDesc: `Your successful melee touch attack deals 1d6 points of acid damage per caster level (maximum 5d6). This also lowers the creatures armor bonus to armor class by -1 for 3 rounds (if it has one). Every 2 caster levels the reduction to armor class increases by -1 to a max of -5 at caster level 10.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature or object touched",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Firebelly",
        type: ["damage"],
        school: "abjuration",
        tags: [],
        longDesc: `A magical fire warms your belly, granting fire resistance 5 and making your gut hot to the touch (but not enough to damage you or anything else). As a standard action, you can breathe a 15-foot cone of flame that deals 1d4 points of fire damage (Reflex half, SR applies). Each time you use this breath weapon, reduce the remaining duration of the spell by 1 minute.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "Reflex half; see text",
        spellResistance: "yes; see text",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Frostbite",
        type: ["damage"],
        school: "transmutation",
        tags: ["cold"],
        longDesc: `Your melee touch attack deals 1d6 points of nonlethal cold damage + 1 point per level, and the target is fatigued. The fatigued condition ends when the target recovers from the nonlethal damage. This spell cannot make a creature exhausted even if it is already fatigued. You can use this melee touch attack up to one time per level.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Inflict Light Wounds",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `When laying your hand upon a creature, you channel negative energy that deals 1d8 points of damage + 1 point per caster level (maximum +5). Since undead are powered by negative energy, this spell cures such a creature of a like amount of damage, rather than harming it.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Litany of the Red Crusader",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `Each time the target creature takes piercing or slashing damage, it takes 1 point of bleed damage; this bleed damage stacks with itself. While subject to this spell, the target cannot be the target of another spell that has the word “litany” in the title.`,
        castingTime: "1 swift action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round",
        savingThrow: "fortitude negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Magic Missile",
        type: ["damage"],
        school: "evocation",
        tags: ["force"],
        longDesc: `A missile of magical energy darts forth from your fingertip and strikes its target, dealing 1d4+1 points of force damage. The missile strikes unerringly, even if the target is in melee combat, so long as it has less than total cover or total concealment. Specific parts of a creature can't be singled out. Objects are not damaged by the spell. For every two caster levels beyond 1st, you gain an additional missile-two at 3rd level, three at 5th, four at 7th, and the maximum of five missiles at 9th level or higher. If you shoot multiple missiles, you can have them strike a single creature or several creatures. A single missile can strike only one creature. You must designate targets before you check for spell resistance or roll damage.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "up to five creatures, no two of which can be more than 15 ft. apart",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Magic Stone",
        type: ["damage"],
        school: "transmutation",
        tags: [],
        longDesc: `You transmute as many as three pebbles, which can be no larger than sling bullets, so that they strike with great force when thrown or slung. If hurled, they have a range increment of 20 feet. The spell gives them a +1 enhancement bonus on attack and damage rolls. The user of the stones makes a normal ranged attack. Each stone has its base damage increased to 1d6 points of damage, or 2d6 against undead.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "up to three pebbles touched",
        duration: "30 minutes or until discharged",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Mighty Fist of the Earth",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["earth"],
        longDesc: `You create a fist-sized rock that flies toward one enemy. Make an unarmed strike attack roll against the target as if it were in your threatened area. If the attack is successful, the rock deals bludgeoning damage to the target as if you had hit the target with your unarmed strike.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "1",
        name: "Produce Flame",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `Flames as bright as a torch appear in your open hand. The flames harm neither you nor your equipment. In addition to providing illumination, the flames can be hurled or used to touch enemies. You can strike an opponent with a melee touch attack, dealing fire damage equal to 1d6 + 1 point per caster level (maximum +5). Alternatively, you can hurl the flames up to 120 feet as a thrown weapon. When doing so, you attack with a ranged touch attack (with no range penalty) and deal the same damage as with the melee attack. No sooner do you hurl the flames than a new set appears in your hand. Each attack you make reduces the remaining duration by 1 minute. If an attack reduces the remaining duration to 0 minutes or less, the spell ends after the attack resolves. This spell does not function underwater.`,
        castingTime: "1 standard action",
        range: "0 ft.",
        area: "",
        effect: "flame in your palm",
        targets: "",
        duration: "1 min./level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Shocking Grasp",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `Your successful melee touch attack deals 1d6 points of electricity damage per caster level (maximum 5d6). When delivering the jolt, you gain a +3 bonus on attack rolls if the opponent is wearing metal armor (or is carrying a metal weapon or is made of metal).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature or object touched",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Snowball",
        type: ["damage"],
        school: "evocation",
        tags: ["cold", "water"],
        longDesc: `You throw a ball of elemental ice and snow at a single target as a ranged touch attack. The snowball deals 1d6 points of cold damage per caster level you have (maximum 5d6). On a successful hit the target must make a successful Fortitude saving throw or be staggered for 1 round.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one ball of ice and snow",
        targets: "",
        duration: "instantaneous",
        savingThrow: "fortitude partial (see text)",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Touch of Combustion",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `Your successful melee touch attack causes the target to ignite in a violent burst of flame, dealing 1d6 points of fire damage. If it fails its saving throw, the target also catches on fire. If the target catches fire, on the first round thereafter, creatures adjacent to it (including you) must each succeed at a Reflex save or take 1d4 points of fire damage.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature or object touched",
        duration: "instantaneous",
        savingThrow: "Reflex negates; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Burning Disarm",
        type: ["damage", "control"],
        school: "transmutation",
        tags: ["fire"],
        longDesc: `This spell causes a metal object to instantly become red hot. A creature holding the item may attempt a Reflex save to drop it and take no damage (even if it is not their turn), otherwise the hot metal deals 1d4 points of fire damage per caster level (maximum 5d4). Circumstances that prevent the creature from dropping the item (such as a locked gauntlet) mean the creature gets no saving throw. The heat does not harm the item, and it does not get hot enough or last long enough to ignite flammable objects. The item cools to its previous temperature almost instantly. If cast underwater, burning disarm deals half damage and boils the surrounding water.`,
        castingTime: "1 standard action",
        range: "Short (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "Held metal item of one creature or 15 lbs. of unattended metal",
        duration: "Instantaneous",
        savingThrow: "Reflex negates (object, see text)",
        spellResistance: "Yes (object)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Static Shock",
        type: ["damage", "control"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `Fire a shock bolt at the target, you can choose to deliver it through either a melee or ranged touch attack. It deals 1d4 electricity damage per caster level (max 5d4), however they can make a reflex save to halve the damage. If they fail the reflex save and take electricity damage from this spell, they must also make a will save or become stunned for 1d2 rounds, or until they take damage.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels) or touch",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "instantaneous",
        savingThrow: "reflex half and will negates",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "1",
        name: "Celestial Healing",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: ["good"],
        longDesc: `You anoint a wounded creature with the blood of an outsider with the good subtype (such as an angel) or holy water, giving it fast healing 1. If the creature is good, the fast healing doubles, and stacks with any other fast healing they have, if they are evil, it instead gives no benefit. The target radiates the aura of a good creature for the duration of the spell and can sense the righteousness of the magic, though this has no long-term effect on the target's alignment. If the target has its own evil aura, this is not suppressed by celestial healing, and can also be detected normally.`,
        castingTime: "1 round",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/2 levels",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Cure Light Wounds",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `When laying your hand upon a living creature, you channel positive energy that cures 1d8 points of damage + 1 point per caster level (maximum +5). Since undead are powered by negative energy, this spell deals damage to them instead of curing their wounds. An undead creature can apply spell resistance, and can attempt a Will save to take half damage.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will half (harmless); see text",
        spellResistance: "yes (harmless); see text",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Goodberry",
        type: ["healing"],
        school: "transmutation",
        tags: [],
        longDesc: `Casting goodberry makes 2d4 magical berries. Each berry berry cures 1d4 point of damage when eaten, a creature can place up to 5 berries in their mouth as a movement action (+5 per size above medium they are, -2 per size below medium), and later eat any amount they have in their mouths as a swift action. Alternatively, up to twice the normal limit of barries can be fed to another creature as if feeding them a potion. All healing from a casting of berries counts as a single casting of this spell. Creatures with berries in their mouths have a hard time using their mouths, as such they are unable to use bite attacks, and have a 25% spell failure chance on all spells that have a verbal component, plus an additional 2% for each berry past the first in their mouth. Barries last through floors. When you summon the berries, they appear in your hand.`,
        castingTime: "1 standard action",
        range: "0ft",
        area: "",
        effect: "2d4 fresh berries",
        targets: "",
        duration: "1 floor/4 levels",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "1",
        name: "Infernal Healing",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: ["evil"],
        longDesc: `You anoint a wounded creature with devil's blood or unholy water, giving it fast healing 1. This ability cannot repair damage caused by silver weapons, good-aligned weapons, or spells or effects with the good descriptor. The target detects as an evil creature for the duration of the spell and can sense the evil of the magic, though this has no long-term effect on the target's alignment.`,
        castingTime: "1 round",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Instant Clot",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `Bleed effects on the target immediately end when this spell is cast, and no blood flows out when the target is damaged by a slashing or piercing weapon. The target takes the full amount of damage from attacks, but because the wounds produce no blood, they do not attract creatures with the ability to sense blood, such as sharks. If the target suffers another bleed effect while this spell is in effect, the bleed effect ends and the spell is immediately dismissed.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round/level (D)",
        savingThrow: "no (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S",
        },
        {
        level: "1",
        name: "Invigorate",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `Positive energy infuses your body curing 1d4 points of damage + 1 point per 2 caster levels (maximum +5).`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "",
        spellResistance: "",
        components: "V, S,",
        },
        {
        level: "1",
        name: "Liberating Command",
        type: ["healing"],
        school: "transmutation",
        tags: [],
        longDesc: `If the target is bound, grappled, or otherwise restrained, he may make an Escape Artist check to escape as an immediate action. He gains a competence bonus on this check equal to twice your caster level (maximum +20). This spell has no effect if the target could not get free by using the Escape Artist skill (for example, if he were under the effects of a hold person spell or paralyzed by Strength damage).`,
        castingTime: "1 immediate action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, ",
        },
        {
        level: "1",
        name: "Remove Fear",
        type: ["healing"],
        school: "abjuration",
        tags: [],
        longDesc: `You instill courage in the subject, granting it a +4 morale bonus against fear effects for 10 minutes. If the subject is under the influence of a fear effect when receiving the spell, that effect is suppressed for the duration of the spell. Remove fear counters and dispels cause fear.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature plus one additional creature per four levels, no two of which can be more than 30 ft. apart",
        duration: "10 minutes; see text",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Remove Sickness",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You quell feelings of illness and nausea in the target, giving it a +4 morale bonus on saving throws against disease, nausea, and sickened effects. If the subject is already under the influence of one of these effects when receiving the spell, that effect is suppressed for the duration of the spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "10 minutes/level; see text",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Repair Undead",
        type: ["healing"],
        school: "necromancy",
        tags: [],
        longDesc: `When you touch an undead creature, you channel negative energy that heals 1d8 points of damage + 1 point per caster level (maximum +5). This spell has no effect on living creatures, except those that are healed by negative energy are also healed by the spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one undead creature touched (see text)",
        duration: "instantaneous",
        savingThrow: "Will half (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Saving Finale",
        type: ["healing"],
        school: "evocation",
        tags: ["mind-affecting"],
        longDesc: `You must have a bardic performance or a hex on the target in effect to cast this spell. With a flourish, you can immediately end your bardic performance or hex when a creature within range affected by your bardic performance or hex fails a Saving Throw, allowing the subject to immediately reroll the failed Saving Throw.`,
        castingTime: "1 immediate action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "instantaneous",
        savingThrow: "will negates(harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Spindrift Spritz",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: ["water"],
        longDesc: `You can cast this spell only as a response to a target attempting a saving throw against an effect that would cause the fatigued, shaken, sickened, or staggered conditions. The target can roll its saving throw twice and take the higher result.`,
        castingTime: "1 immediate action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S",
        },
        {
        level: "1",
        name: "Word of Resolve",
        type: ["healing"],
        school: "abjuration",
        tags: [],
        longDesc: `You focus your aura on one ally, allowing it to reroll a failed saving throw against a charm or fear effect with a +4 sacred bonus.`,
        castingTime: "1 immediate action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one ally",
        duration: "instantaneous",
        savingThrow: "will negates(harmless)",
        spellResistance: "yes (harmless)",
        components: "V, DF,",
        },
        {
        level: "1",
        name: "Swallow Your Fear",
        type: ["healing", "buff"],
        school: "enchantment",
        tags: [],
        longDesc: `You make the affected subjects ready for battle despite their fear. If a target is suffering from a fear effect of any kind, he gains a +2 morale bonus to Strength and Constitution, a +1 morale bonus on Will saves, and a -2 penalty to AC. If the subject is frightened, he remains in place and gains the confused condition for the remainder of the fear effect, except he treats all results of 'attack self ' as 'do nothing' and treats 'attack nearest creature' as 'act normally.' If the subject is panicked, he remains in place and gains the confused condition for the duration of the fear effect.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature plus one additional creature per four levels, no two of which can be more than 30 ft. apart",
        duration: "10 minutes; see text",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Dancing Lantern",
        type: ["utility"],
        school: "transmutation",
        tags: ["fire", "light"],
        longDesc: `You can animate a lantern and order it to follow you. The lantern floats at shoulder height and remains within 5 feet of you, no matter how fast you move. The lantern cannot support any additional weight. The lantern illuminates its normal area, even if it does not have any oil in it. For the purposes of spells or effects targeting it the lantern always acts as if in your possession even when not directly on your person.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "animates one lantern",
        targets: "",
        duration: "1 hour/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Darting Duplicate",
        type: ["utility"],
        school: "illusion(figment)",
        tags: [],
        longDesc: `An illusory duplicate of you steps clumsily into an adjacent square, presenting a tempting target before winking out of existence. Any creature that threatens that square must succeed at a Will save or make an attack of opportunity against the image. The image's AC is equal to 10 + 1/2 your caster level, but as a figment, the image is unaffected by any attack.`,
        castingTime: "1 swift action",
        range: "5 ft.",
        area: "",
        effect: "visual figment of the caster",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Deathwatch",
        type: ["utility"],
        school: "necromancy",
        tags: [],
        longDesc: `Using the powers of necromancy, you can determine the condition of creatures near death within the spell's range. You instantly know whether each creature within the area is dead, fragile (alive and wounded, with 3 or fewer hit points left), fighting off death (alive with 4 or more hit points), healthy, undead, or neither alive nor dead (such as a construct). Deathwatch sees through any spell or ability that allows creatures to feign death.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "cone-shaped emanation",
        effect: "",
        targets: "",
        duration: "10 min./level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Desperate Weapon",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You create a one-handed object that you might expect to see in your current surroundings, which you can then use as an improvised weapon. The spell conjures such an object near your hand such that you can retrieve it as you complete the spell. No matter what sort of object you picked, it functions as a one-handed improvised weapon appropriate for your size and that deals 1d6 points of damage for a Medium creature (1d4 for Small creatures). The item deals the type of damage you choose (bludgeoning, piercing, or slashing) when casting the spell, though the object you request must conform to the damage type. The spell ends prematurely if the improvised weapon leaves your grasp. The object has no value and can't be used for other functions other than as an improvised weapon (for instance, this spell doesn't allow you to conjure an expensive spyglass and sell it or use its other abilities, but you could still use it to beat someone over the head). The conjured object can't already be a manufactured weapon, even in a location where you might expect to see manufactured weapons. It can be an object that would normally make for an unusual improvised weapon, like a herring at a fish market, and it still deals its full damage.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "one-handed improvised weapon",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, ",
        },
        {
        level: "1",
        name: "Detect Aberration",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `This spell functions like detect animals or plants, except it detects creatures of the aberration type.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "cone-shaped emanation",
        effect: "",
        targets: "",
        duration: "concentration, up to 10 minutes/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Detect Secret Doors",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `You can detect secret doors, compartments, caches, and so forth. Only passages, doors, or openings that have been specifically constructed to escape detection are detected by this spell. The amount of information revealed depends on how long you study a particular area or subject. 1st Round: Presence or absence of secret doors. 2nd Round: Number of secret doors and the location of each. If an aura is outside your line of sight, then you discern its direction but not its exact location. Each Additional Round: The mechanism or trigger for one particular secret portal closely examined by you. Each round, you can turn to detect secret doors in a new area. The spell can penetrate barriers, but 1 foot of stone, 1 inch of common metal, a thin sheet of lead, or 3 feet of wood or dirt blocks it.`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "cone-shaped emanation",
        effect: "",
        targets: "",
        duration: "concentration, up to 1 min./level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Disguise Self",
        type: ["utility"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `You make yourself - including clothing, armor, weapons, and equipment - look different. You can use this to stop a monster from believing you are a foe. This works like the function of the bluff skill to avoid monsters from knowing you are a player, but you gain a +10 bonus to the roll. If a monster ever sees you take an action that indicates you are a player, they will know instantly, however the first action taken when they do not know they are flat-footed against. Any creature that interacts with the illusion is allowed a will save to disbelieve. You cannot change your creature type or size category, (although you can appear as another subtype), so this will not work if the map contains no monsters that would look humanoid and your size.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "1",
        name: "Duelist's Parry",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `Your reflexes snap into action, allowing you to deflect a blow. This spell can be cast only when an opponent makes a melee attack against you, and only before the attack roll has been made. Make a parry attempt with a light or one-handed weapon you're wielding, as if using the swashbuckler's opportune parry and riposte deed (except that this does not require panache). You cannot riposte as part of this spell's effect.`,
        castingTime: "1 immediate action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "",
        spellResistance: "",
        components: "V,S",
        },
        {
        level: "1",
        name: "Expeditious Construction",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: ["earth"],
        longDesc: `You create a low wall or other simple structure of packed earth or loose stone measuring 3 feet thick, 3 feet tall, and 10 feet long per 3 caster levels you possess (minimum 10 feet). Each square of the structure can appear only in unoccupied spaces atop earthen or stone surfaces able to support it. The wall grants cover as per a low wall and can be climbed with a successful DC 5 Climb check. Large and larger creatures don't need to attempt a Climb check to climb over it. At your discretion, you can make the structure half as long but thicker by forming it into a berm consisting of a steep slope on each side. Characters moving uphill (to an adjacent square of higher elevation) must spend 2 squares of movement to enter a square of steep slope. Characters running or charging downhill (moving to an adjacent square of lower elevation) must attempt a DC 10 Acrobatics check upon entering the first steep slope square. Mounted characters attempt a DC 10 Ride check instead. Characters who fail this check stumble and must end their movement 1d2 x 5 feet later. Characters who fail by 5 or more fall prone in the square where they end their movement. A steep slope increases the DC of Acrobatics checks by 2.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "a low wall 10 feet long per 3 levels (minimum 10 feet) (S)",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Expeditious Excavation",
        type: ["utility"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `You can excavate and move earth, dust, and sand up to the size of a 5-foot cube. If you are buried, you may open a 5-foot cube around yourself, but the spell cannot be used for tunneling. Besides its mundane applications, you can open a 5-foot-deep pit at a creature's feet. A Medium or smaller creature falls prone in the pit unless it succeeds on a Reflex save. With a successful save, it can choose to land harmlessly on its feet in the pit or hop to an adjacent square; this movement does not provoke attacks of opportunity. A creature can escape a 5-foot-deep pit with a DC 5 Climb check. Larger creatures may ignore pits smaller than their size. The earth excavated by this spell is ordinarily distributed harmlessly across the spell's range, but you may choose to throw up a burst of grit and debris when you dig a pit. This cloud of debris provides concealment to any creatures in the square affected and all adjacent squares for 1 round. Expeditious excavation has no effect on solid rock or earth creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "dirt in a 5-ft. cube",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Find Traps",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `When cast this spell gives a +5 insight bonus on perception checks to detect where a trap is (as long as its within its emination), if you spend 2 rounds focusing on a location it automatically reveals whether a trap is in the area and gives another +5 insight bonus to detect them (stacking with the other insight bonus up to +10)`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "cone-shaped emanation",
        effect: "",
        targets: "",
        duration: "concentration, up to 1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Gentle Breeze",
        type: ["utility"],
        school: "evocation",
        tags: ["air"],
        longDesc: `You create a light wind that blows only against the target, from a direction of your choice. The breeze grants the target a +2 circumstance bonus on saves against fire and heat effects, and saves against clouds, vapors, and gases (such as cloudkill, stinking cloud, and inhaled poisons). There must be air present to use this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature or object",
        duration: "1 hour (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Guardian Armor",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `This spell teleports the suit of armor you are wearing off of your body and onto an ally within range; the target must be the same size and general shape as you. This armor appears on the target's body fully formed and properly donned, granting the creature the immediate benefit of its protection. If the target of guardian armor was already wearing armor, the armor wearing it is removed from the target's body and falls undamaged into an adjacent square.`,
        castingTime: "1 immediate action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one willing creature; see below",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Hide from Animals",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `Animals cannot sense the warded creatures. Even extraordinary or supernatural sensory capabilities, such as blindsense, blindsight, scent, and tremorsense, cannot detect or locate warded creatures. Animals simply act as though the warded creatures are not there. If a warded character touches an animal or attacks any creature, even with a spell, the spell ends for all recipients.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one creature touched/level",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "S, DF",
        },
        {
        level: "1",
        name: "Ice Armor",
        type: ["utility"],
        school: "transmutation",
        tags: ["cold", "water"],
        longDesc: `You create a suit of armor on yourself made of ice. While cold to the touch, it does not harm the wearer, especially if worn over normal clothing. It offers the same protection as a breastplate, except it has hardness 0 and 30 hit points. At caster level 3, and every 3 caster levels after that, the armor also gains a +1 enhancement bonus. If the intended wearer is immersed in water when you cast this spell, the armor gains an enhancement bonus equal to 1/2 level (minimum 1). Attacks against the wearer that create heat or fire degrade the armor, reducing its armor bonus by 1 for every 5 points of fire damage the wearer takes; when the armor's bonus to AC reaches 0, the armor is destroyed and the spell ends. Because the ice is slightly buoyant, the wearer gains a +2 circumstance bonus on Swim checks, except when swimming downward.`,
        castingTime: "1 standard action",
        range: "0 ft.; see text",
        area: "",
        effect: "a suit of armor made of ice",
        targets: "",
        duration: "1 minute/level or until destroyed",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Icicle Dagger",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: ["cold"],
        longDesc: `You create a masterwork dagger out of ice. The dagger deals 1 point of cold damage in addition to normal dagger damage. If the dagger leaves your hand for more than 1 round, it melts and the spell ends. At 3rd level, the dagger functions as a +1 frost dagger. Every 4 levels after 3rd, the ice dagger deals an additional +1 enhancement bonus and the cold damage increases by an additional 1d6. At 10th level it also it gains the returning property when thrown, melting away and reforming in your hand just before your next turn.`,
        castingTime: "1 standard action",
        range: "0 ft.",
        area: "",
        effect: "one icicle",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Jury-Rig",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `When you cast this spell, a spectral force binds a broken weapon together, relieving the broken condition for a short time. While under the effects of this spell, an item with the broken condition suffers no adverse effects from that condition, and is treated as if it is not broken. The object regains no hit points, and damage can still destroy the object.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one broken object of up to 2 lbs./level",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Ki Arrow",
        type: ["utility"],
        school: "conjuration",
        tags: [],
        longDesc: `You imbue an arrow with your power and throw it at a target up to 100 feet away. Make a ranged attack roll. If it hits, the target takes damage from the arrow as if you had hit it with a single unarmed strike (including your Strength bonus).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 arrow touched",
        duration: "instantaneous",
        savingThrow: "Fortitude (object)",
        spellResistance: "yes (object)",
        components: "S, ",
        },
        {
        level: "1",
        name: "Know the Enemy",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `You commune with the divine, reflecting on one type of creature. You may make a Knowledge check regarding that creature type with a +5 insight bonus. this bonus increases by 1 every level after 5th to a max of +15`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Line in the Sand",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `You create a glowing crimson line around the area. Against creatures in the area, you can attempt a number of additional attacks of opportunity per round equal to your highest mental modifier. The spell does not allow you to make more than one attack against a creature for each action it takes that provokes such attacks.`,
        castingTime: "1 standard action",
        range: "5 ft.",
        area: "5-ft. burst centered on you",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Mirror Strike",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You briefly alter the flow of time to split a melee attack into two attacks. Before the end of your next turn, when you make your next melee attack roll, compare the result to the AC of two opponents within your reach. If the selected opponents are flanking you, you gain a +2 bonus on your attack roll (and confirmation attack roll, see below). If you hit both enemies, you can deal half damage to each. Hitting only one opponent allows you to deal that opponent normal damage for your attack. On a critical threat, you can make only one attack roll to confirm the critical hit against both opponents. If you confirm against both, you deal half your critical hit damage to each. Your hit is a normal hit rather than a critical if you confirm against only one opponent. If you fail to use the effect before the end of your next turn, the spell ends.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "see text",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Negate Aroma",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `With a gesture, this spell allows you to dismiss even the foulest or most distinctive scents. When cast, the targeted creatures or objects lose all natural and unnatural odors. A creature under the effect of negate aroma cannot be tracked, located, or pinpointed by the scent special quality. In addition, this spell prevents the target creature from using the stench special ability and similar odor-based abilities (such as those possessed by troglodytes). Negate aroma does not prevent the target from acquiring outside smells or odors. Dowsing the creature with a pungent substance effectively negates the benefits of the spell until the substance is neutralized or washed away.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature or object/level touched",
        duration: "1 hour/level (D)",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M, DF",
        },
        {
        level: "1",
        name: "Sanctuary",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `Any opponent attempting to directly attack the warded creature, even with a targeted spell, must attempt a Will save. If the save succeeds, the opponent can attack normally and is unaffected by that casting of the spell. If the save fails, the opponent can't follow through with the attack, that part of its action is lost, and it can't directly attack the warded creature for the duration of the spell. Those not attempting to attack the subject remain unaffected. This spell does not prevent the warded creature from being attacked or affected by area of effect spells. The subject cannot attack without breaking the spell but may use nonattack spells or otherwise act.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Silent Image",
        type: ["utility"],
        school: "illusion(figment)",
        tags: [],
        longDesc: `This spell creates the visual illusion of an object, creature, or force, as visualized by you. The illusion does not create sound, smell, texture, or temperature. You can move the image within the limits of the size of the effect.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "visual figment that cannot extend beyond four 10-ft. Cubes + one 10-ft. cube/level (S)",
        targets: "",
        duration: "concentration",
        savingThrow: "Will disbelief (if interacted with)",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Stone Shield",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: ["earth"],
        longDesc: `A 1-inch-thick slab of stone springs up from the ground, interposing itself between you and an opponent of your choice. The stone shield provides you with cover from that enemy (Core Rulebook 195) until the beginning of your next turn, granting you a +4 bonus to Armor Class and a +2 bonus on Reflex saving throws. If the opponent's attack misses you by 4 or less, the attack strikes the shield instead. The stone shield has hardness 8 and 15 hit points. If the shield is destroyed, the spell ends and the shield crumbles away into nothingness. Spells and effects that damage an area deal damage to the shield. You cannot use this spell if you are not adjacent to a large area of earth or stone such as the ground or a wall. At 4th level, a qinggong monk (Ultimate Magic) may select this spell as a ki power costing 1 ki point to activate.`,
        castingTime: "1 immediate action",
        range: "0 ft.",
        area: "",
        effect: "stone wall whose area is one 5-ft. square",
        targets: "",
        duration: "1 round",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Summon Minor Ally",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions as summon nature's ally I, except you can summon 1d3 Tiny or smaller animals, such as bats, lizards, monkeys, rats, ravens, toads, or weasels. The summoned animals must all be the same type of creature.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "1d3 summoned creatures",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "1",
        name: "Summon Minor Monster",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions as summon monster I, except you can summon 1d3 Tiny or smaller animals, such as bats, lizards, monkeys, rats, ravens, toads, or weasels. The summoned animals must all be the same type of creature. As with animals summoned with summon monster I, you may apply one alignment-appropriate template to these animals.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "1d3 summoned creatures",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Summon Monster I",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell summons an extraplanar creature (typically an outsider, elemental, or magical beast native to another plane). It appears where you designate and acts immediately, on your turn. It attacks your opponents to the best of its ability. If you can communicate with the creature, you can direct it not to attack, to attack particular enemies, or to perform other actions. The spell conjures one of the creatures from the 1st Level list on Table from: https://www.d20pfsrd.com/magic/all-spells/s/summon-monster/. You choose which kind of creature to summon but can only summon creatures from the core list (not alternative options), and you can choose a different one each time you cast the spell. A summoned monster cannot summon or otherwise conjure another creature, nor can it use any teleportation or planar travel abilities. Creatures cannot be summoned into an environment that cannot support them. Creatures summoned using this spell cannot use spells or spell-like abilities that duplicate spells with expensive material components (such as wish). When you use a summoning spell to summon a creature with an alignment or elemental subtype, it is a spell of that type. Creatures marked with an "*" are summoned with the celestial template, if you are good, and the fiendish template, if you are evil. If you are neutral, you may choose which template to apply to the creature. Creatures marked with an "*" always have an alignment that matches yours, regardless of their usual alignment. Summoning these creatures makes the summoning spell's type match your alignment`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, F,DF,",
        },
        {
        level: "1",
        name: "Summon Nature's Ally I",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell summons to your side a natural creature (typically an animal, fey, magical beast, outsider with the elemental subtype, or a giant). The summoned ally appears where you designate and acts immediately, on your turn. It attacks your opponents to the best of its ability. If you can communicate with the creature, you can direct it not to attack, to attack particular enemies, or to perform other actions as you command. A summoned monster cannot summon or otherwise conjure another creature, nor can it use any teleportation or planar travel abilities. Creatures cannot be summoned into an environment that cannot support them. Creatures summoned using this spell cannot use spells or spell-like abilities that duplicate spells that have expensive material components (such as wish). The spell conjures one of the creatures from the 1st Level list on Table 10-2. You choose which kind of creature to summon, and you can change that choice each time you cast the spell. All the creatures on the table are neutral unless otherwise noted. When you use a summoning spell to summon a creature with an alignment or elemental subtype, it is a spell of that type. All creatures summoned with this spell without alignment subtypes have an alignment that matches yours, regardless of their usual alignment. Summoning these creatures makes the summoning spell's type match your alignment.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "1",
        name: "Touch of the Sea",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You cause webs to grow between the target's fingers and its feet to transform into flippers, granting a swim speed of 30 feet along with the standard +8 bonus on Swim checks and the ability to take 10 even if distracted or endangered. You can also use the run action while swimming, provided you swim in a straight line. This transformation causes any boots or gloves the target is wearing to meld into its form (although magic items with a continuous effect continue to function). This spell does not grant the target any ability to breathe water.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M, ",
        },
        {
        level: "1",
        name: "Windy Escape",
        type: ["utility"],
        school: "transmutation",
        tags: ["air"],
        longDesc: `You respond to an attack by briefly becoming vaporous and insubstantial, allowing the attack to pass harmlessly through you. You gain DR 10/magic against this attack and are immune to any poison, sneak attacks, or critical hit effect from that attack. You cannot use windy escape against an attack of opportunity you provoked by casting a spell, using a spell-like ability, or using any other magical ability that provokes an attack of opportunity when used.`,
        castingTime: "1 immediate action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Rally Point",
        type: ["utility", "buff"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "good", "mind-affecting"],
        longDesc: `You create a spot that has the power to briefly hearten any good creature who comes into contact with it. A good creature who enters this square (even if simply as part of its normal move) gains a +2 morale bonus on attacks, saving throws, and 2 temporary hit points per caster level for 1 round. Evil creatures gain no benefit from this spell.
                        \nA creature cannot benefit more than once from the same casting of this spell.`,
        castingTime: "1 standard action",
        range: "5 ft",
        area: "one 5-ft. square",
        effect: "",
        targets: "one creature",
        duration: "1 minute/level (D)",
        savingThrow: "will negates(harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "1",
        name: "Stone Fist",
        type: ["utility", "buff"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `This spell transforms your hands into living stone. While this spell is in effect, your unarmed strikes do not provoke attacks of opportunity and can deal lethal damage, and their damage increases by 1 step. In addition, your unarmed strikes ignore the hardness of any object with a hardness less than 8. Stone to flesh immediately dispels stone fist. Should you be the target of transmute rock to mud, this spell immediately ends and you take 4d6 points of damage.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M, ",
        },
        {
        level: "1",
        name: "Sundering Shards",
        type: ["utility", "buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You channel power into a melee weapon. If the weapon's wielder destroys an item with a successful sunder combat maneuver, she can release the extra power in the weapon, shattering the sundered item into jagged shards that deal 1d6 points of piercing and slashing damage to the creature that was wearing, carrying, or wielding the now-shattered item. Any creature (other than the wielder of the weapon targeted by this spell) adjacent to that creature must succeed at a Reflex saving throw or take 1d6 points of piercing and slashing damage from flying shards. The shards also count as whatever special materials the sundered item was made of (for example, the shards from a shattered cold iron weapon are cold iron). Once the weapon's extra power is unleashed, the spell is discharged.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "melee weapon touched",
        duration: "1 hour/level or until discharged",
        savingThrow: "Reflex negates (see text)",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "1",
        name: "Animate Rope",
        type: ["utility", "control"],
        school: "transmutation",
        tags: [],
        longDesc: `You can animate a nonliving rope-like object. The maximum length assumes a rope with a 1-inch diameter. Reduce the maximum length by 50% for every additional inch of thickness, and increase it by 50% for each reduction of the rope's diameter by half. The possible commands are 'coil' (form a neat, coiled stack), 'coil and knot,' 'loop,' 'loop and knot,' 'tie and knot,' and the opposites of all of the above ('uncoil,' and so forth). You can give one command each round as a move action, as if directing an active spell. The rope can enwrap only a creature or an object within 1 foot of it - it does not snake outward - so it must be thrown near the intended target. Doing so requires a successful ranged touch attack roll (range increment 10 feet). A typical 1-inch-diameter hemp rope has 2 hit points, AC 10, and requires a DC 23 Strength check to burst it. The rope does not deal damage, but it can be used as a trip line or to cause a single opponent that fails a Reflex saving throw to become entangled. A creature capable of spellcasting that is bound by this spell must make a concentration check with a DC of 15 + the spell's level to cast a spell. An entangled creature can slip free with a DC 20 Escape Artist check. The rope itself and any knots tied in it are not magical. The spell cannot affect objects carried or worn by a creature.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one rope-like object, length up to 50 ft. + 5 ft./level; see text",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Faerie Fire",
        type: ["utility", "control"],
        school: "evocation",
        tags: ["light"],
        longDesc: `A pale glow surrounds and outlines the subjects. Outlined subjects shed light as candles. Creatures outlined by faerie fire take a -20 penalty on all Stealth checks. Outlined creatures do not benefit from the concealment normally provided by darkness (though a 2nd-level or higher magical darkness effect functions normally), blur, displacement, invisibility, or similar effects. The light is too dim to have any special effect on undead or dark-dwelling creatures vulnerable to light. The faerie fire can be blue, green, or violet, according to your choice at the time of casting. The faerie fire does not cause any harm to the objects or creatures thus outlined.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "creatures and objects within a 5-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "1 min./level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "1",
        name: "Handy Grapnel",
        type: ["utility", "control"],
        school: "transmutation",
        tags: [],
        longDesc: `You cause the target rope to shrink and reshape itself into an arrow, bolt, or similar piece of ammunition, which you can shoot at any Medium or larger object. With a successful attack roll against an AC equal to 5 plus the hardness of the target object, the handy grapnel strikes and embeds itself in that object with the strength of an iron grappling hook. As a move action, you can command the rope to extend from the arrow. If you are within a distance equal to the length of the rope and have a hand free, the end of the rope swings directly into your hand. With another move action, you can command the handy grapnel to retract itself up to the grappling hook, pulling up any creature or object supported by the rope at a speed of 50 feet per round. Once embedded, the rope can be used for climbing or any other purpose a rope could serve, and it can bear up to 200 pounds per level of the caster at a time (maximum 1,000 pounds). If this weight limit is exceeded, the handy grapnel comes loose and any creature or object supported by the rope falls.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one ropelike object, length up to 50 ft. + 5 ft./level",
        duration: "1 minute/level (D)",
        savingThrow: "Fortitude negates (object)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "1",
        name: "Thorn Javelin",
        type: ["utility", "control"],
        school: "conjuration(creation)",
        tags: ["poison"],
        longDesc: `A wooden thorn the size of a javelin (appropriate for your size) appears in your open hand. You can wield this thorn as a javelin, and you are proficient in its use. Any creature struck by the javelin must succeed at a Fortitude save or be sickened for 1 round. If you throw the javelin, another one appears in your hand. Any javelin that leaves your grasp disappears at the end of your turn. Each javelin attack you make reduces the spell's remaining duration by 1 minute. If an attack reduces the remaining duration to 0 minutes or less, the spell ends after that attack resolves.`,
        castingTime: "1 standard action",
        range: "0 ft.",
        area: "",
        effect: "javelin-like thorn",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "1",
        name: "Hero's Defiance",
        type: ["utility", "healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `The instant before you are reduced to 0 or fewer hit points, you can expend a use of an ability that would heal you, plus an additional 1d6 hit points. If this ability can't be activated as a swift or immediate action it costs 2x the normal spell points. Any ability you activate this way only affects you, even if it would normally affect other creatures. 
        If this healing brings your hit point total above 0 hit points, you do not fall, and may continue to act. Alternatively, instead of using an ability that heals you can just heal 1d6.`,
        castingTime: "1 immediate action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "",
        spellResistance: "",
        components: "V, ",
        },
        {
        level: "2",
        name: "Aid",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `Aid grants the target a +1 morale bonus on attack rolls and saves against fear effects, plus temporary hit points equal to 1d8 + caster level (to a maximum of 1d8+10 temporary hit points at caster level 10th).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "1 min./level",
        savingThrow: "none",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
            level: "2",
            name: "Blade of Bright Victory",
            type: ["buff"],
            school: "transmutation",
            tags: ["good"],
            longDesc: `You create a bond between your weapon and a celestial spirit. The weapon gains the ghost touch property. You may change your weapon's damage type (bludgeoning, piercing, slashing) as a swift action. You gain a sacred bonus to your CMD against disarm and sunder attacks directed at your bonded weapon; this bonus is equal to half your caster level.`,
            castingTime: "1 standard action",
            range: "touch",
            area: "",
            effect: "",
            targets: "1 weapon",
            duration: "1 min./level",
            savingThrow: "will negates(harmless)",
            spellResistance: "no",
            components: "V, S",
        },
        {
        level: "2",
        name: "Align Weapon",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Align weapon makes a weapon chaotic, evil, good, or lawful, as you choose. A weapon that is aligned can bypass the damage reduction of certain creatures. This spell has no effect on a weapon that already has an alignment. You can't cast this spell on a natural weapon, such as an unarmed strike. When you make a weapon chaotic, evil, good, or lawful, align weapon is a chaotic, evil, good, or lawful spell, respectively.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "weapon touched or 50 projectiles (all of which must be together at the time of casting)",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Allegro",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell allows you to act more swiftly while maintaining a bardic performance or hex on yourself. You must already be maintaining a bardic performance or hex on yourself before you can cast allegro. You gain the benefits of the spell haste for as long as you maintain that bardic performance or the hex buff duration. If you cease maintaining the bardic performance/hex or it is interrupted, this spell's duration ends. As an immediate action while you are maintaining a bardic performance or hex, you can dismiss allegro to reroll a Reflex save or Dexterity-based skill check. You must choose to reroll before the result of the original roll is known. You must take the result of the reroll, even if it's worse than the original roll. Allegro dispels and is dispelled by slow.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D) or until discharged",
        savingThrow: "none",
        spellResistance: "",
        components: "V, ",
        },
        {
        level: "2",
        name: "Alter Self",
        type: ["buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `When you cast this spell, you can assume the form of any Small or Medium creature of the humanoid type. If the form you assume has any of the following abilities, you gain the listed ability: darkvision 60 feet, low-light vision, scent, and swim 30 feet. Small creature: If the form you take is that of a Small humanoid, you gain a +2 size bonus to your Dexterity. Medium creature: If the form you take is that of a Medium humanoid, you gain a +2 size bonus to your Strength.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Angelic Aspect, Lesser",
        type: ["buff"],
        school: "transmutation",
        tags: ["good"],
        longDesc: `You take on an aspect of an angelic being, including some of its physical characteristics. You gain low-light vision, resistance to acid 5, resistance to cold 5, and the benefits of protection from evil.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Animal Aspect",
        type: ["buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You gain some of the beneficial qualities of an animal. Your base form is largely unchanged and your size is unaltered, but some of your body parts are altered. Armor or gear you are wearing adjusts to your new shape for the duration of the spell. When you cast animal aspect, choose one of the following animals to gain the associated benefits. You can only have one animal aspect or greater animal aspect spell active on you at a time. Frog: Your legs become elongated and muscular. You gain a +4 competence bonus on Acrobatics checks, and you always jump as if you had a running start. Gorilla: Your arms become long, flexible, and strong like those of a great ape. Your unarmed damage die type increases by one step, and you gain a +4 competence bonus on combat maneuver checks when making the grapple or reposition combat maneuver. Monkey: Your hands and arms become dexterous like those of a simian. You gain a +4 competence bonus on Climb checks, and you can throw objects as if you had the Throw Anything feat. Otter: Your hands and feet gain webbing, and your lungs gain capacity, allowing you to move through the water with ease. You gain a Swim speed equal to half your speed, and all the benefits of having a swim speed. Additionally, you can hold your breath for 4 rounds per point of Constitution before being forced to make Constitution checks to keep holding your breath. Raccoon: Your hands become extremely dexterous, and your feet become padded. You gain a +2 competence bonus on Disable Device, Sleight of Hand, and Stealth checks. Raptor: Your legs become built for running speed, like those of a deinonychus. You gain a enhancement bonus of +20 feet to your base speed. Tree Lizard: Your hands and feet gain climbing claws and climbing pads. You gain a climb speed equal to half your normal speed and all the benefits of having a natural climb speed.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "none",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Arrow Of Law",
        type: ["buff"],
        school: "evocation",
        tags: ["lawful"],
        longDesc: `You fire a shimmering arrow of pure order from your holy symbol at any one target in range as a ranged touch attack. A chaotic creature struck by an arrow of law takes 1d8 points of damage per two caster levels (maximum 5d8). A chaotic outsider instead takes 1d6 points of damage per caster level (maximum 10d6) and is dazed for 1 round. A successful Will save reduces the damage to half and negates the daze effect. This spell deals only half damage to creatures that are neither chaotic nor lawful, and they are not dazed. The arrow has no effect on lawful creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "arrow-shaped projectile of lawful energy",
        targets: "",
        duration: "instantaneous (1 round); see text",
        savingThrow: "Will partial (see text)",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Aspect of the Bear",
        type: ["buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You take on an aspect of a bear. You gain a +2 enhancement bonus to natural armor and a +2 enhancement bonus on CMB rolls. You can also perform bull rush, grapple, and overrun combat maneuvers without provoking attacks of opportunity.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Barkskin",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Barkskin toughens a creature's skin. The effect grants a +2 enhancement bonus to the creature's existing natural armor bonus. This enhancement bonus increases by 1 for every three caster levels above 3rd, to a maximum of +5 at 12th level. The enhancement bonus provided by barkskin stacks with the target's natural armor bonus, but not with other enhancement bonuses to natural armor. A creature without natural armor has an effective natural armor bonus of +0.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "10 min./level",
        savingThrow: "none",
        spellResistance: "yes (harmless)",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Bear's Endurance",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The affected creature gains greater vitality and stamina. The spell grants the subject a +4 enhancement bonus to Constitution, which adds the usual benefits to hit points, Fortitude saves, Constitution checks, and so forth. Hit points gained by a temporary increase in Constitution score are not temporary hit points. They go away when the subject's Constitution drops back to normal. They are not lost first as temporary hit points are.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Bestow Insight",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: [],
        longDesc: `When casting this spell, choose a single skill that you have at least one rank in. The target gains a +2 insight bonus on skill checks with this skill and is considered trained in that skill. The insight bonus increases by 1 for every four levels of the caster (maximum +6). Furthermore, once before the spell's duration, the target can choose to roll two checks and take the greater result. Doing so ends the spell's other effects.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one creature touched",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Blade Tutor's Spirit",
        type: ["buff"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You summon an insubstantial spirit of force that resembles a cloudy vapor hovering around your fists or any melee weapons you wield. The spirit compensates for your defensive or reckless melee attacks, nudging your weapons in the proper direction. When you voluntarily use one or more actions or feats that apply penalties to attack rolls with your melee weapons (such as a charge, fighting defensively, or using the Power Attack feat), the spirit reduces the total penalty on affected attacks by 1 (to a minimum penalty of 0). The penalty is reduced by an additional 1 for every 5 caster levels you possess (to a minimum penalty of 0). Only penalties incurred by voluntary use of feats or maneuvers are reduced by this spell. The spirit can't be attacked or harmed by physical attacks, but disintegrate, dispel magic, a rod of cancellation, or a sphere of annihilation can affect it. A protective spirit's AC against touch attacks is equal to 10 + your Dexterity modifier.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Blood Armor",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Your blood becomes as hard as iron upon contact with air. Each time you take at least 5 points of piercing or slashing damage, your armor gains a +1 enhancement bonus to your AC. An outfit of regular clothing counts as armor that grants no AC bonus for the purpose of this spell. This enhancement bonus stacks with itself to a maximum enhancement bonus of +5. This spell has no effect while underwater or in environments that lack air.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Blur",
        type: ["buff"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `The subject's outline appears blurred, shifting, and wavering. This distortion grants the subject concealment (20% miss chance). A see invisibility spell does not counteract the blur effect, but a true seeing spell does. Opponents that cannot see the subject ignore the spell's effect (though fighting an unseen opponent carries penalties of its own).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, ",
        },
        {
        level: "2",
        name: "Bone Fists",
        type: ["buff"],
        school: "necromancy",
        tags: [],
        longDesc: `The bones of your targets' joints grow thick and sharp, protruding painfully through the skin at the knuckles, elbows, shoulders, spine, and knees. The targets each gain a +1 bonus to natural armor and a +2 bonus on damage rolls with natural weapons, and they are treated as having armor spikes, with which they are proficient.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 creature/level, no two of which can be more than 30 feet apart",
        duration: "1 minute/level",
        savingThrow: "none (harmless)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Bullet Shield",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `The warded creature gains a +4 deflection bonus to AC against firearm and ranged attacks, with an additional +1 to the bonus for every five caster levels you have (to a maximum of +8 at 20th level). Though the spell is called bullet shield, it also grants this protection from attacks made from firearms with the scatter weapon quality.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 minutes/level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Bullet Ward",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You toss several adamantine bullets into the air, which then hover protectively nearby and intercept firearm attacks targeting you. The number of bullets protecting you is equal to half your caster level (maximum 4). When an opponent takes a shot at you with a firearm, as an immediate action you can designate a hovering bullet to attempt to block the attack, increasing your AC against that attack by 10. Doing this destroys the adamantine bullet whether or not the attack hits. The spell is discharged when all affected adamantine bullets are destroyed or taken from you. Each adamantine bullet has AC 24, 20 hit points, and hardness 20.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 minutes/level or until discharged",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Bull's Strength",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The subject becomes stronger. The spell grants a +4 enhancement bonus to Strength, adding the usual benefits to melee attack rolls, melee damage rolls, and other uses of the Strength modifier.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Cat's Grace",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The transmuted creature becomes more graceful, agile, and coordinated. The spell grants a +4 enhancement bonus to Dexterity, adding the usual benefits to AC, Reflex saves, and other uses of the Dexterity modifier.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Certain Grip",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The subject's grip and footing become sure, granting a +4 competence bonus on Climb checks, on Acrobatics checks to balance, and to CMD against bull rush, drag, reposition, and trip attempts. While affected by this spell, the target is also immune to the disarm combat maneuver.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 minutes/level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Death from Below",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You grant the target a dodge bonus to its Armor Class against attacks from larger creatures. The bonus is equal to +1 for every size category the attacker is larger than the target of the spell, to a maximum of +1 per 3 caster levels. If the spell's target is a gnome, the maximum bonus is equal to +1 per 2 caster levels.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Defending Bone",
        type: ["buff"],
        school: "necromancy",
        tags: [],
        longDesc: `You animate a bone with necromantic energy, giving it the power to float near your body and interpose itself against physical attacks. This gives you damage reduction 5/bludgeoning. Once the bone has prevented a total of 5 points of damage per caster level (maximum 50 points), it is destroyed and the spell is discharged. This spell has no effect if you have damage reduction from another source.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 hour/level or until discharged",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Eagle's Splendor",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The transmuted creature becomes more poised, articulate, and personally forceful. The spell grants a +4 enhancement bonus to Charisma, adding the usual benefits to Charisma-based skill checks and other uses of the Charisma modifier. Bards, paladins, and sorcerers (and other spellcasters who rely on Charisma) affected by this spell do not gain any additional bonus spells for the increased Charisma, but the save DCs for spells they cast while under this spell's effect do increase.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Effortless Armor",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Armor you wear no longer reduces your speed. You also reduce the armor's armor check penalty by 1 + 1 per five caster levels (maximum 5).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Elemental Weapons",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument]You imbue the target weapon with elemental power, its deals 1d6 points of damage of your chosen element (fire, cold, electricity, acid). A weapon can have only one imbument spell at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 weapon",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no",
        components: "V,S,M",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "2",
        name: "Extreme Flexibility",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You gain a +1 dodge bonus to AC, a +4 circumstance bonus on Escape Artist checks and combat maneuver checks to escape a grapple, and a +4 circumstance bonus to your CMD against grapple attempts.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "False Life",
        type: ["buff"],
        school: "necromancy",
        tags: [],
        longDesc: `You harness the power of unlife to grant yourself a limited ability to avoid death. While this spell is in effect, you gain temporary hit points equal to 1d10 + 1 per caster level (maximum +10).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 hour/level or until discharged; see text",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Fox's Cunning",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The target becomes smarter. The spell grants a +4 enhancement bonus to Intelligence, adding the usual benefits to Intelligence based skill checks and other uses of the Intelligence modifier. You do not gain additional spell points for having this spell cast on you (though it may increase your maximum spell points), but the save DCs for spells they cast while under this spell's effect do increase.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Gird Ally",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You create a magical field around summoned creatures you control that deflects attacks made against them. The targets gain a deflection bonus to their AC equal to 1 + 1 for every 6 caster levels you possess (maximum +4 deflection bonus at 18th level). A summoner can target his eidolon with this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one summoned creature you control/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Grace",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `Until the end of your turn, your movement does not provoke attacks of opportunity.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "see text",
        savingThrow: "",
        spellResistance: "",
        components: "V, ",
        },
        {
        level: "2",
        name: "Holy Shield",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You gain the ability to magically project the defense of your shield to protect another creature at a distance. As a swift action, you designate one target within 30 feet. The target gains your shield's shield bonus and enhancement bonus to Armor Class until your next turn; you gain no benefit from the shield's shield bonus or enhancement bonus while using this spell and cannot use any of the shield's other properties or abilities (such as magical abilities, making a shield bash, or providing cover with a tower shield). As a swift action, you may move the protection to another target (including yourself); if you move the protection to yourself, you may use any of the shield's properties or abilities as normal. If the shielded creature exceeds the 30-foot range, your shield's protection automatically reverts to you. Any circumstance that would make you lose your shield bonus (such as an enemy breaking the shield, you dropping the shield, or you becoming helpless or unconscious) means the protected creature loses the shield's benefit.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 minute/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Inheritor's Smite",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You channel the power of righteousness into your weapon arm, allowing you to strike with great force. Your next melee attack (if made before the end of your next turn) gains a +5 sacred bonus on the attack roll. If the attack hits, you may immediately attempt a bull rush combat maneuver (with a +5 sacred bonus on your combat maneuver check) against the target without provoking an attack of opportunity; if your combat maneuver check exceeds the defender's CMD by more than 5, you do not need to move with the target to push it back more than 5 feet.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "see text",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Insightful Strikes",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument] You imbue a one-handed, light, crossbow, or firearm to instead allow you to use your intelligence to determine its attack modifier instead of the usual ability score (if it would be higher). This only applies as long as you wield the weapon. A weapon can have only one imbument at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 weapon",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V,S,M",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "2",
        name: "Ironskin",
        type: ["buff"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `Your skin hardens and takes on the color and texture of rough iron. You gain a +4 enhancement bonus to your existing natural armor bonus (if you do not have a natural armor bonus, you are considered to have an effective natural armor bonus of +0). This enhancement bonus increases by 1 for every 4 caster levels above 4th, to a maximum of +7 at 15th level. While you're under the effects of this spell, if an opponent confirms a critical hit or sneak attack against you with a physical weapon (not a spell or magical effect), you can dismiss this spell to negate the critical hit or sneak attack and treat it is as a normal hit. Dismissing the spell in this way is not an action, but you must be conscious and aware of the attack to do so.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D; see text)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Litany of Defense",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Invoking this litany strengthens your defenses. The highest enhancement bonus your armor has is tripled and you are immune to fear. While subject to this spell, the target cannot be the target of another spell that has the word “litany” in the title.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Lockjaw",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You give a creature the ability to use one of its natural attacks or unarmed strikes to firmly attach itself to an opponent. Choose one of the creature's natural attacks (usually a claw or bite attack). The creature gains the grab ability with that natural attack, including the +4 bonus on combat maneuver checks to start or maintain a grapple. A creature with multiple natural attacks can strike at its grappled opponent with its other natural attacks, but cannot attack any other creature.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M, ",
        },
        {
        level: "2",
        name: "Masterwork Transformation",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `If cast on a weapon it gains a +1 to attack, if cast on armor or a shield reduce its armor check penalty by 2, and increases its maximum dexterity bonus by +1.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one weapon, suit of armor, or shield",
        duration: "24 hours",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M, ",
        },
        {
        level: "2",
        name: "Mindshock",
        type: ["buff"],
        school: "divination",
        tags: ["mind-affecting", "pain"],
        longDesc: `You charge yourself with violent psychic energy so attacks you make with weapons, natural weapons, and unarmed strikes cause the target to recall pain suffered in the past. Such attacks deal 1d4 points of nonlethal damage in addition to their normal damage, though creatures immune to mind-affecting or pain effects ignore this additional damage. In addition, when you confirm a critical hit, the target is confused for 1 round by the pain. Creatures immune to critical hits, mind-affecting, or pain effects ignore the confusion. Even if you confirm multiple critical hits while this spell is in effect, an individual creature can only be confused by a single casting of mindshock once.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "",
        components: "V, S",
        },
        {
        level: "2",
        name: "Mirror Image",
        type: ["buff"],
        school: "illusion(figment)",
        tags: [],
        longDesc: `This spell creates a number of illusory doubles of you that inhabit your square. These doubles make it difficult for enemies to precisely locate and attack you. When mirror image is cast, 1d4 images plus one image per three caster levels (maximum eight images total) are created. These images remain in your space and move with you, mimicking your movements, sounds, and actions exactly. Whenever you are attacked or are the target of a spell that requires an attack roll, there is a possibility that the attack targets one of your images instead. If the attack is a hit, roll randomly to see whether the selected target is real or a figment. If it is a figment, the figment is destroyed. If the attack misses by 5 or less, one of your figments is destroyed by the near miss. Area spells affect you normally and do not destroy any of your figments. Spells and effects that do not require an attack roll affect you normally and do not destroy any of your figments. Spells that require a touch attack are harmlessly discharged if used to destroy a figment. An attacker must be able to see the figments to be fooled. If you are invisible or the attacker is blind, the spell has no effect (although the normal miss chances still apply).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Muffle Sound",
        type: ["buff"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `You suppress sounds made by the targets, granting them a +4 bonus on Stealth checks, The targets have a 20% chance of spell failure when casting spells with verbal components or using abilities that have audible components (such as some bardic performances). This spell does not hamper the targets' ability to hear other sounds and provides no protection against language-dependent or sonic spells and effects.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 ally/level",
        duration: "1 minute/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Natural Rhythm",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You enhance a creature's ability to harm an opponent based on the number of times it has already injured that opponent with a natural attack. Each time the creature successfully strikes an opponent with a natural attack or unarmed strike, the subject gains a cumulative +1 bonus on damage rolls made against that opponent when making natural or unarmed attacks (maximum +5 bonus). If an attack misses, the bonus to damage for all attacks resets to +0.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M, ",
        },
        {
        level: "2",
        name: "Owl's Wisdom",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The transmuted creature becomes wiser. The spell grants a +4 enhancement bonus to Wisdom, adding the usual benefit to Wisdom-related skills. They do not gain any additional spell points for the increased Wisdom but it may increase their maximum spell points, and the save DCs for some of your abilities may increase.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Perceive Cues",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Your senses become preternaturally keen, and you gain insight into subtle behavioral cues. For the duration of the spell, you receive a +5 competence bonus on Perception and Sense Motive checks. This bonus increases to +10 at caster level 8, and +20 at caster level 16`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "10 minutes/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M",
        },
        {
        level: "2",
        name: "Perfect Placement",
        type: ["buff"],
        school: "divination",
        tags: [],
        longDesc: `Affected creatures gain tactical knowledge and maximize their efficiency on the field of battle. Each gains a +1 insight bonus to AC and Reflex saves. Against attacks of opportunity, the insight bonus to AC increases to +3.`,
        castingTime: "1 standard action",
        range: "close (25 ft. plus 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
            level: "2",
            name: "Tactical Miscalculation",
            type: ["buff"],
            school: "enchantment (compulsion)",
            tags: ["emotion", "mind-affecting"],
            longDesc: `The target becomes fixated on avoiding damage and fails to spot even the most opportune moments to attack. Whenever a creature the target threatens would provoke an attack of opportunity from the target, the target must succeed at a Will save or be unable to make the attack of opportunity against that creature.`,
            castingTime: "1 standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "one creature",
            duration: "1 round/level",
            savingThrow: "see text;",
            spellResistance: "yes",
            components: "V, S",
        },
        {
        level: "2",
        name: "Pouncing Fury",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `When you charge, you can make a full attack at the end of that charge, but only with claw attacks you have, and you can make only one attack per claw. If you have abilities that grant bonuses on damage rolls or that apply other special effects to charge attacks, only the first claw attack benefits from these bonuses. When you make a claw attack as an attack of opportunity, you can expend one additional use of your attacks of opportunity to make an additional claw attack against the target that provoked the attack.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Protection from Arrows",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `The warded creature gains resistance to ranged weapons. The subject gains damage reduction 10/magic against ranged weapons. This spell doesn't grant you the ability to damage creatures with similar damage reduction. Once the spell has prevented a total of 10 points of damage per caster level (maximum 100 points), it is discharged.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 hour/level or until discharged",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Protection from Chaos, Communal",
        type: ["buff"],
        school: "abjuration",
        tags: ["lawful"],
        longDesc: `This spell functions like protection from chaos, except you divide the duration in 1-minute intervals among the creatures touched.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creatures touched",
        duration: "1 min./level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no; see text",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Protection from Evil, Communal",
        type: ["buff"],
        school: "abjuration",
        tags: ["good"],
        longDesc: `This spell functions like protection from evil, except you divide the duration in 1-minute intervals among the creatures touched.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creatures touched",
        duration: "1 min./level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no; see text",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Protection from Good, Communal",
        type: ["buff"],
        school: "abjuration",
        tags: ["evil"],
        longDesc: `This spell functions like protection from good, except you divide the duration in 1-minute intervals among the creatures touched.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creatures touched",
        duration: "1 min./level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no; see text",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Protection from Law, Communal",
        type: ["buff"],
        school: "abjuration",
        tags: ["evil"],
        longDesc: `This spell functions like protection from law, except you divide the duration in 1-minute intervals among the creatures touched.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creatures touched",
        duration: "1 min./level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no; see text",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Protection From Outsiders",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell wards a creature from attacks by outsiders with a specific racial subtype, from mental control exerted by creatures of the chosen subtype, and from summoned creatures of that subtype. Only the subtypes of specific outsider races-angel, azata, demon, oni, psychopomp, protean, and so on-can be chosen as the subtype this spell protects against. Alignment subtypes or other general subtypes (like elemental, extraplanar, or native) cannot be selected. Outsiders without an outsider racial subtype (like genies, night hags, yeth hounds, or xills) are not affected by this spell. This spell creates a magical barrier around the subject at a distance of 1 foot. The barrier moves with the subject and has three major effects. First, the subject gains a +4 deflection bonus to AC and a +4 resistance bonus on saves when targeted by creatures of the chosen subtype. Second, the subject immediately receives another saving throw (if one was allowed to begin with) against any spells or effects that possess or exercise mental control over the target creature. This functions in the same fashion as protection from evil, but only when the effect stems from outsiders of the chosen subtype, and the target's saving throw is made with a +4 morale bonus (using the same DC as the original effect). Third, the spell prevents bodily contact by summoned creatures of the chosen subtype in the same manner as detailed in protection from evil. This spell's descriptor varies depending on the outsider race selected, gaining the alignment descriptors opposite to the alignment of the outsider race-for example, lawful and good if the race is chaotic and evil, chaotic if the selected race is lawful, or none if the selected race is neutral.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no; see text",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Resist Energy",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This abjuration grants a creature limited protection from damage of whichever one of five energy types you select: acid, cold, electricity, fire, or sonic. The subject gains resist energy 10 against the energy type chosen, meaning that each time the creature is subjected to such damage (whether from a natural or magical source), that damage is reduced by 10 points before being applied to the creature's hit points. The value of the energy resistance granted increases to 20 points at 7th level and to a maximum of 30 points at 11th level. The spell protects the recipient's equipment as well. Resist energy absorbs only damage. The subject could still suffer unfortunate side effects. Resist energy overlaps (and does not stack with) protection from energy. If a character is warded by protection from energy and resist energy, the protection spell absorbs damage until its power is exhausted.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 min./level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Savage Maw",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Your teeth extend and sharpen, transforming your mouth into a maw of razor-sharp fangs. You gain a bite attack that deals 1d4 points of damage plus your Strength modifier. If you confirm a critical hit with this attack, it also deals 1 point of bleed damage. If you already have a bite attack, your bite deals 2 points of bleed damage on a critical hit. You are considered proficient with this attack. If used as part of a full-attack action, the bite is considered a secondary attack, is made at your full base attack bonus -5, and adds half your Strength modifier to its damage. You can end this spell before its normal duration by making a bestial roar as a swift action. When you do, you can make an Intimidate check to demoralize all foes within a 30-foot radius that can hear the roar.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D), special (see below)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Scale Spikes",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `When the target is affected by this spell, its scales grow jagged spikes. These spikes act like +1 armor spikes. Armor spikes deal extra piercing damage (1d6 with medium creature) on a successful grapple attack, but can also be used as a weapon, which you can use to also make a regular melee attack (or off-hand attack) with the spikes, and they count as a light weapon in this case. (You can't also make an attack with armor spikes if you have already made an attack with another off-hand weapon, and vice versa.) An enhancement bonus to a suit of armor does not improve the spikes' effectiveness, unless they are enchanted as weapons (like this spell does, giving it a +1 to attack and damage). Your armor spikes deal +1 additional damage for each point of your natural armor.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature/level that has a natural armor bonus of at least +1",
        duration: "1 minute/level",
        savingThrow: "Fort negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Shield Of Fortification",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You create a magical barrier that protects a target's vital areas. When the target is struck by a critical hit or a sneak attack, there is a 25% chance that the critical hit or sneak attack is negated and damage is instead rolled normally. This benefit does not stack with other effects that can turn critical hits or sneak attacks into normal attacks, such as the fortification armor special ability.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Shield Of Shards",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This defensive spell must be cast on a shield you are currently wielding, and fractures the shield into two shards, plus one additional shard per 2 caster levels (to a maximum of 12 shards at 20th level). While shield of shards is active, you lose your shield's bonus to AC as its broken pieces orbit you. On your turn, you can direct the shards to attack an adjacent opponent as a move action. The shards' attack bonus is equal to your caster level + the modifier for the ability score that determines your spell save DCs. The shards deal an amount of slashing and piercing damage equal to 1d4 points + 1 point per shard beyond the first, and have a threat range of 19-20. They are considered magic weapons for the purpose of bypassing damage reduction. Additionally, if your shield is made from a special material (such as adamantine), the shards penetrate damage reduction and hardness as if they were weapons made from the same material. At the end of this spell's duration, the shards reform into their original shield form. You regain its shield bonus to AC, provided you still have a free hand in which to wield it. Otherwise, the shield falls at your feet in your square.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "one shield you wield",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Silk To Steel",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You imbue an ordinary scarf (or similar piece of clothing) with the strength of steel without altering its weight or flexibility. Each round on your turn, you can decide to use the scarf to defend yourself (gaining a +2 shield bonus to your Armor Class) or to attack as if the scarf were a whip.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one scarf",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Stone Throwing",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The subject gains the rock throwing and rock catching abilities. It can use these abilities with any solid, mostly inflexible object with a hardness of at least 5. The subject can hurl rocks up to two categories smaller than its own size. The range increment for this attack is 20 feet, and rocks can be hurled a maximum of 5 range increments. Damage is based on the size of the subject-1d8 points of damage for a Large creature, 1d6 for a Medium creature, or 1d4 for a Small creature-plus 1-1/2 times the thrower's Strength bonus. For every size category smaller than Large the subject is, it receives a cumulative -5 penalty on Reflex saves to catch rocks (or similar projectiles) thrown at it.`,
        castingTime: "1 standard action",
        range: "",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Tactical Acumen",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `Tactical acumen grants you and your allies a mastery of battlefield tactics. Whenever you would gain a bonus on attack rolls or to AC due to battlefield position, such as flanking, higher ground, or cover, you gain an additional +1 insight bonus. This bonus increases by +1 for every five caster levels above 5th you possess (maximum +4).`,
        castingTime: "1 standard action",
        range: "30 ft",
        area: "The caster and all allies within a 30-ft.-radius burst, centered on the caster",
        effect: "",
        targets: "one creature",
        duration: "1 round/level (D)",
        savingThrow: "Will negates(harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Telekinetic Strikes",
        type: ["buff"],
        school: "evocation",
        tags: ["force"],
        longDesc: `The touched creature's limbs are charged with telekinetic force. For the duration of the spell, the target's unarmed attacks or natural weapons deal an additional 1d4 points of force damage on each successful unarmed melee attack.`,
        castingTime: "1 standard action",
        range: "Touch",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 minute/level",
        savingThrow: "Will negates(harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Umbral Weapon",
        type: ["buff"],
        school: "illusion",
        tags: ["cold", "shadow"],
        longDesc: `A shadowy afterimage trails behind the targeted weapon, potentially damaging foes even when the weapon misses. Once per round, when the weapon's wielder misses a creature with the target weapon, the wielder can reroll the attack. If the reroll hits, the spell hits the targeted creature and deals 1d8 points of cold damage, plus 1 additional point per 2 caster levels (maximum +10). If an attacked creature has spell resistance, you must attempt a caster level check (1d20 + caster level) against that spell resistance the first time the spell damages the target. If the creature successfully resists umbral weapon, the spell is dispelled. If not, the creature takes damage as normal.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "melee weapon touched",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Unliving Rage",
        type: ["buff"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell functions as rage, except it affects only undead creatures and bolsters them with necromantic energy rather than emotion. Each affected creature gains a +2 profane bonus to Strength and Charisma, a +1 profane bonus on Will saves, and a -2 penalty to AC. The effect is otherwise identical to a barbarian's rage.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one willing undead creature per 3 levels, no two of which can be more than 30 ft. apart",
        duration: "concentration + 1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Vine Strike",
        type: ["buff"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `Bristles burst from your body, lodging in your opponent and blossoming into entangling vines as you pummel your target. While this spell is in effect, one of your natural attacks or unarmed strikes deals an additional 1d6 points of damage, and each creature hit with that natural weapon or unarmed strike must succeed at a Reflex save or be entangled for the duration of the spell; on a successful Reflex save, the creature is immune to the entangled effect for 1 round. A creature entangled by this spell can spend a standard action to remove the vines, but can be entangled again by further unarmed strikes.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "Reflex negates (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Visualization of the Body",
        type: ["buff"],
        school: "transmutation",
        tags: ["medatative"],
        longDesc: `You focus your mind on one aspect of your body, aligning the energies within your body to enhance that element. Choose a single physical ability score (Constitution, Dexterity, or Strength). You can only have one version of this spell active on you at a time.
        \nIf you choose Strength or Dexterity, you gain a +5 bonus on skill checks associated with that ability score. If you choose Constitution, your maximum and current hit points increase by an amount equal to your Hit Dice.
        \nAt any time during the spell's duration, you can expend the spell's remaining duration as an immediate action in order to gain a one-time physical enhancement associated with the ability score you chose to visualize, as detailed below. After you do so, the spell ends.
        \n\nConstitution: You immediately regain a number of hit points equal to 1d8 + your total character level.
        \nDexterity: You gain a +4 dodge bonus to your Armor Class for 3 rounds.
        \nStrength: You gain a +6 bonus on all Strength checks to break objects and on checks to escape or establish grapples for 1 minute.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "24 hours or until discharged",
        savingThrow: "",
        spellResistance: "",
        components: "V,M",
        },
        {
        level: "2",
        name: "Warding Weapon",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `The focus of this spell flies upward above your head and takes a defensive position within your space. It lunges at opponents, as if guided by a martially trained hand, parrying and turning back melee attacks aimed at you, but does not strike back at any opponent nor does it damage them. The weapon serves only as a defense. While it protects you, you can cast spells without provoking attacks of opportunity, without the need to cast them defensively. A creature with the Disruptive feat (Core Rulebook 122) can easily bypass this spell's defenses. You provoke attacks of opportunity for casting spells against these creatures even when subject to this spell, though you can still choose to cast defensively.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Weapon Of Awe",
        type: ["buff"],
        school: "transmutation",
        tags: ["emotion"],
        longDesc: `You transform a single weapon into an awe-inspiring instrument. The weapon gains a +2 sacred bonus on damage rolls, and if the weapon scores a critical hit, the target of that critical hit becomes shaken for 1 round with no saving throw. This is a mind-affecting fear effect. A ranged weapon affected by this spell applies these effects to its ammunition. You can't cast this spell on a natural weapon, but you can cast it on an unarmed strike.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "weapon touched",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Wild Instinct",
        type: ["buff"],
        school: "divination",
        tags: [],
        longDesc: `This spell sharpens your senses, allowing you to perceive threats you would otherwise miss. You become aware of sounds and smells you would normally overlook, and even retain the ability to detect threats when soundly asleep. For the duration of the spell, you gain a +5 bonus on initiative checks.`,
        castingTime: "standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 hour/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Enemy's Heart",
        type: ["buff", " damage"],
        school: "necromancy",
        tags: ["death", "evil"],
        longDesc: `You cut out an enemy's heart and consume it, absorbing that enemy's power as your own. As part of casting this spell, you perform a coup de grace with a slashing weapon on a helpless, living adjacent target. If the target dies, you eat its heart to gain the spell's benefits. If the target survives, the spell is not wasted and you can try again as long as you continue concentrating on the spell. When you consume the heart, you gain 1d8 temporary hit points +1 per Hit Die of the target, a +2 profane bonus to strength, and your effective caster level goes up by +1.`,
        castingTime: "1 full-round action, special see below",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "concentration/1 minute per HD of the subject; see text",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "2",
        name: "Instrument Of Agony",
        type: ["buff", "control"],
        school: "transmutation",
        tags: [],
        longDesc: `You cause a weapon to exude a palpable aura of divine fury. While wielding this weapon, a creature gains a +2 morale bonus on Intimidate checks. When an attack made using the targeted weapon hits, the wielder can spend a free action to discharge the effect to inflict agony on the creature the weapon hit. If that creature has spell resistance, it applies against this effect. If the creature fails a Will save, it is nauseated for 1d4+1 rounds. If it succeeds at the saving throw, the creature is instead sickened for 1 round. The sickened condition created by the instrument is a mind-affecting effect.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "weapon touched",
        duration: "1 minutes/level",
        savingThrow: "Will negates (harmless, object), see text",
        spellResistance: "yes (harmless, object), see text",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Sickening Strikes",
        type: ["buff", "control"],
        school: "transmutation",
        tags: ["disease"],
        longDesc: `You are imbued with disease, and any creature you strike with a melee attack must make a Fortitude save or be sickened for 1 minute. Creatures that are immune to disease are immune to this sickened effect.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "fort negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Steal Size",
        type: ["buff", "control"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell reduces the target's size by one size category, as if it were affected by reduce person. You grow in size by one category, as if affected by enlarge person ( if y ou c an b e targeted by that spell). If the spell is dispelled or otherwise ends for either you or the target, both you and the target return to your normal sizes.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one humanoid creature larger than you",
        duration: "1 minute/level (D)",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Time Shudder",
        type: ["buff", "control", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You cause a ripple in time that affects all creatures in the area. At the start of each creature's turn, there is a 50% chance the creature is hasted (as haste); otherwise it is slowed (as slow).`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "30-ft.-radius emanation centered on you",
        effect: "",
        targets: "",
        duration: "1 round",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Blood Blaze",
        type: ["buff", "damage"],
        school: "transmutation",
        tags: ["fire"],
        longDesc: `The target gains a 5-foot-radius aura that causes the blood of creatures in that area to ignite upon contact with air. Any creature (including the spell's target) within the aura that takes at least 5 points of piercing, slashing, or bleed damage from a single attack automatically creates a spray of burning blood. The spray strikes a creature in a randomly determined square adjacent to the injured creature. The spray deals 1d6 points of fire damage to any creature in that square, and 1 point of splash damage to all creatures within 5 feet of the spray's target, including the target of this spell. A creature can only create one spray of burning blood per round. Creatures that do not have blood (including oozes and most constructs and undead) do not create blood sprays when attacked.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level (D)",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Healing Token",
        type: ["buff", "healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You imbue touched creatures with a holy symbol on their skin that has a connection to your own divine power.
                    \nAny creature with a token of healing can make a plea for healing in a language you understand as a standard action. When they do this, you are silently alerted to the plea for healing and can magically heal the target as an immediate action anytime before the end of your next turn.
                    \nThe magical healing you use to do this can be either a supernatural ability that heals damage (if you have uses available) or a spell or spell-like ability that belongs to the healing subschool (if you can cast any). In either case, to use the ability or cast the spell through this spell, you must be able to include or target that creature, and the ability's activation time or spell's casting time must be no longer than one standard action.
                    \nIf the ability or healing spell you use through a token would affect multiple creatures, such as mass cure light wounds, the ability or spell affects the creature that pleaded for healing as well as any other creatures within the healing spell's normal range that are also marked by a holy symbol imbued with this spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one touched creater per 3 caster levels",
        duration: "10 minutes/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Escaping Ward",
        type: ["buff", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `This ward grants you extra maneuverability when you avoid attacks against larger foes. While affected by this spell, when you are attacked and missed by a creature that is at least one size category larger than you, you can, as an immediate action, move up to 5 feet away from the attacking creature. You can increase this movement by 5 feet for every 5 caster levels. This movement does not provoke attacks of opportunity.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Glide",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You take no damage from falls (as if from feather fall). In addition, you can move up to 5 feet in any horizontal direction for every 1 foot you fall, at a speed of 60 feet per round. You cannot use this spell to actually gain height, merely coast in other directions as you fall. If subjected to a strong wind or any other effect that causes you to rise you can take advantage of it in order to increase the distance you can glide. The spell ends as soon as your feet touch the ground regardless of its remaining duration. If the spell expires while you are still in the air you fall the remaining distance as normal.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "until landing or 1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Invisibility",
        type: ["buff", "utility"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `The creature or object touched becomes invisible. If the recipient is a creature carrying gear, that vanishes, too. If you cast the spell on someone else, neither you nor your allies can see the subject, unless you can normally see invisible things or you employ magic to do so. Items dropped or put down by an invisible creature become visible; items picked up disappear if tucked into the clothing or pouches worn by the creature. Light, however, never becomes invisible, although a source of light can become so (thus, the effect is that of a light with no visible source). Any part of an item that the subject carries but that extends more than 10 feet from it becomes visible. Of course, the subject is not magically silenced, and certain other conditions can render the recipient detectable (such as swimming in water or stepping in a puddle). If a check is required, a stationary invisible creature has a +40 bonus on its Stealth checks. This bonus is reduced to +20 if the creature is moving. The spell ends if the subject attacks any creature. For purposes of this spell, an attack includes any spell targeting a foe or whose area or effect includes a foe. Exactly who is a foe depends on the invisible character's perceptions. Actions directed at unattended objects do not break the spell. Causing harm indirectly is not an attack. Thus, an invisible being can open doors, talk, eat, climb stairs, summon monsters and have them attack, cut the ropes holding a rope bridge while enemies are on the bridge, remotely trigger traps, open a portcullis to release attack dogs, and so forth. If the subject attacks directly, however, it immediately becomes visible along with all its gear. Spells such as bless that specifically affect allies but not foes are not attacks for this purpose, even when they include foes in their area.`,
        castingTime: "1 standard action",
        range: "personal or touch",
        area: "",
        effect: "",
        targets: "you or a creature or object weighing no more than 100 lbs./level",
        duration: "1 min./level (D)",
        savingThrow: "Will negates (harmless) or Will negates (harmless, object)",
        spellResistance: "yes (harmless) or yes (harmless, object)",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Kinetic Reverberation",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell converts the momentum and force from melee attacks made against the target of the spell, reflecting them back upon the attacker's weapon. After making a successful melee attack against the target, an attacker must make a Fortitude saving throw for the weapon used. If the weapon fails the save, it takes damage equal to the damage rolled against the target. Creatures using natural attacks or unarmed strikes are unaffected by this spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "Fortitude negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Sacred Space",
        type: ["buff", "utility"],
        school: "evocation",
        tags: ["good"],
        longDesc: `This spell sanctifies an area with heavenly power. The DC to resist spells or spell-like abilities with the good descriptor or channeled energy that damages evil outsiders (as when using Alignment Channel) increases by +2. In addition, evil outsiders take a –1 penalty on attack rolls, damage rolls, and saving throws, and they cannot be called or summoned into a sacred space. Creatures who are direct opposing alignment to yours have these penalties and bonuses to ability DC's doubled against them. If you are evil this spell is cast against good creatures instead. Creatures that are not good or evil cannot cast this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "20-ft.-radius emanation",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M",
        },
        {
        level: "2",
        name: "Stabilize Powder",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `Ammunition currently loaded in the target firearm is less prone to misfire. Decrease the misfire range by 1 + 1 per five caster levels (maximum +5, minimum misfire 0) for the ammunition currently loaded into that firearm.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 loaded firearm",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Contest of Skill",
        type: ["buff", "utility", "control"],
        school: "transmutation",
        tags: ["curse"],
        longDesc: `The creature targeted by this spell is infused with magical power, altering the odds of combat to weaken lucky strikes. Critical threats made by the affected creature automatically fail to confirm. Critical threats that automatically confirm due to class features or feats, such as the fighter's weapon mastery, are unaffected by this spell.
        \nIn addition, when the initial target of this spell fails its Will save to resist contest of skill, it can select one additional creature within range of the spell to suffer the effects of the spell as well (Will negates). If this secondary target negates this spell with a successful save, the duration of contest of skill on the primary target is reduced to 1 round.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creater",
        duration: "1 minutes/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "2",
        name: "Animal Trance",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting", "sonic"],
        longDesc: `Your swaying motions and music (or singing, or chanting) compel animals and magical beasts to do nothing but watch you. Only a creature with an Intelligence score of 1 or 2 can be fascinated by this spell. Roll 2d6 to determine the total number of HD worth of creatures that you fascinate. The closest targets are selected first until no more targets within range can be affected.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "animals or magical beasts with Intelligence 1 or 2",
        duration: "concentration",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "2",
        name: "Arcane Disruption",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["curse", "mind-affecting"],
        longDesc: `This spell makes it difficult for the subject to cast arcane spells, use spell-like abilities, and use some abilities granted by arcane spellcasting classes. The subject must succeed at a concentration check (DC = 10 + 1/2 its caster level) in order to cast an arcane spell, use any spell-like ability (even those that come from a divine source), use arcane spell completion or spell trigger magic items, or use any of the following class features that come from an arcane spellcasting class: arcane school powers, arcanist exploits, bardic performances, magus arcana, or witch hexes. Spells, spell-like abilities, or class features that take a free, swift, or immediate action aren't affected by this spell, nor are mythic spells or mythic powers. While under the effect of this spell, if the subject must attempt a concentration check to cast an arcane spell or use an arcane spell-like ability for any reason other than the effect of this spell (such as casting defensively, being injured while casting, and so on), it takes a penalty on that check equal to 1/2 its caster level.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Binding Earth",
        type: ["control"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `If the target of this spell fails its Fortitude save, areas of earth and stone floor act as a snapping quagmire that pulls the target down and damages it if it attempts to move through such terrain. If the target is a creature, it treats all areas of earth and stone it moves through as difficult terrain. Furthermore, for each 5 feet a creature moves through such areas, it takes 1d6 points of damage. Creatures with a burrow speed or the earth glide ability are unaffected by binding earth. If cast on an unattended object resting on an area of stone or earth, the stone or earth warps and wraps around it, pulling it firmly to the ground. A DC 15 Strength check is required to pull the object free from snapping earth or stone.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature or unattended object (see text)",
        duration: "1 round/level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Blinding Ray",
        type: ["control"],
        school: "evocation",
        tags: ["good", "light"],
        longDesc: `You blast your enemies with blinding rays of sunlight. You may fire one ray, plus one additional ray for every four levels beyond 3rd (to a maximum of three rays at 11th level). Each ray requires a ranged touch attack to hit. If a ray hits, it explodes into powerful motes of light, and the target must save or be blinded for 1 round. If the target has light blindness, light sensitivity, or is otherwise vulnerable to bright light, it instead must save or be blinded for 1d4 rounds and take 1d4 points of damage per two caster levels (maximum 5d4). Any creature blinded by a ray sheds light as a sunrod for the duration of its blindness. The rays may be fired at the same or different targets, but all rays must be aimed at targets within 30 feet of each other and fired simultaneously.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one or more rays of light",
        targets: "",
        duration: "instantaneous (see text)",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Blindness/Deafness",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `You call upon the powers of unlife to render the subject blinded or deafened, as you choose.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "permanent (D)",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "2",
        name: "Cacophonous Call",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You fill your target's mind with a blaring cacophony of discordant sounds, making it hard for the target to act and concentrate. The creature gains the nauseated condition for the duration of the spell if it fails its Will save.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "One Creature",
        duration: "1 round/level",
        savingThrow: "Will Negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Cloud of Seasickness",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["poison"],
        longDesc: `Cloud of seasickness creates a bank of fog like that created by fog cloud, except that the vapors are sickening. Living creatures in the cloud become sickened. This condition lasts as long as the creature is in the cloud and for 1d4+1 rounds after it leaves. (Roll separately for each nauseated character.) Any creature that succeeds on its save but remains in the cloud must continue to save each round on your turn. This is a poison effect.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "cloud spreads in 20-ft. radius, 20 ft. high",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Fortitude negates; see text",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Command Undead",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell allows you a degree of control over an undead creature. If the subject is intelligent, it perceives your words and actions favorably (treat its attitude as friendly). It will not attack you while the spell lasts. You can give the subject orders, but you must win an opposed Charisma check to convince it to do anything it wouldn't ordinarily do. Retries are not allowed. An intelligent commanded undead never obeys suicidal or obviously harmful orders, but it might be convinced that something very dangerous is worth doing. A nonintelligent undead creature gets no saving throw against this spell. When you control a mindless being, you can communicate only basic commands, such as 'come here,' 'go there,' 'fight,' 'stand still,' and so on. Nonintelligent undead won't resist suicidal or obviously harmful orders. Any act by you or your apparent allies that threatens the commanded undead (regardless of its Intelligence) breaks the spell. Your commands are not telepathic. The undead creature must be able to hear you.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one undead creature",
        duration: "1 day/level",
        savingThrow: "Will negates; see text",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Create Pit",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You create a 10-foot-by-10-foot extradimensional hole with a depth of 10 feet per two caster levels (maximum 30 feet). You must create the pit on a horizontal surface of sufficient size. Since it extends into another dimension, the pit has no weight and does not otherwise displace the original underlying material. You can create the pit in the deck of a ship as easily as in a dungeon floor or the ground of a forest. Any creature standing in the area where you first conjured the pit must make a Reflex saving throw to avoid falling into it. In addition, the edges of the pit are sloped, and any creature ending its turn on a square adjacent to the pit must make a Reflex saving throw with a +2 bonus to avoid falling into it. Creatures subjected to an effect intended to push them into the pit (such as bull rush) do not get a saving throw to avoid falling in if they are affected by the pushing effect. Creatures who fall into the pit take falling damage as normal. The pit's coarse stone walls have a Climb DC of 25. When the duration of the spell ends, creatures within the hole rise up with the bottom of the pit until they are standing on the surface over the course of a single round.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "10-ft.-by-10-ft. hole, 10 ft. deep/2 levels",
        targets: "",
        duration: "1 round + 1 round/level",
        savingThrow: "Reflex negates",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Daze Monster",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell functions like daze, but it can affect any one living creature of any type. Creatures of 7 or more HD are not affected.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one living creature of 6 HD or less",
        duration: "1 round",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Diminish Resistance",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `You weaken a creature's resistance against one energy type you select: acid, cold, electricity, fire, or sonic. The creature's resistance to that energy type decreases by 5 (minimum 0), plus an additional 5 for every 5 caster levels beyond 3rd (to a maximum of 20 at 18th level).`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level (D)",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Disfiguring Touch",
        type: ["control"],
        school: "transmutation",
        tags: ["curse"],
        longDesc: `With a touch, you cause the victim of this spell to suffer a painful curse that causes it to grow hideously disfigured. The physical appearance of the deformity is subject to the caster's whim (most demon worshipers choose deformities that reflect their Abyssal patron's shape or form). The target takes one of the following penalties. • -2 decrease to an ability score (minimum 1). • -2 penalty on attack rolls or saving throws. • Land speed reduced by 5 feet. You may also invent other effects, but they should be no more powerful than those described above.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 day/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Early Judgement",
        type: ["control"],
        school: "divination",
        tags: [],
        longDesc: `Depending on the creature's alignment and its adherence to its ethos, you can provide it a brief glimpse of the reward or punishment that waits for it when it dies by showing it a mental image of its destined plane in the afterlife. If the target is good-aligned, it is fascinated for 1d4 rounds on a failed save. If the target is neutral-aligned, it is confused for 1d4 rounds on a failed save. If the target is evil-aligned, it is shaken for 1d4 rounds on a failed save.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one humanoid creature",
        duration: "1d4 rounds",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Enthrall",
        type: ["control"],
        school: "enchantment(charm)",
        tags: ["language-dependent", "mind-affecting", "sonic"],
        longDesc: `When you cast this spell, all enemies within range who can hear you must make a will save, if they fail, they are held enthralled by you, being fascinated until you stop concentrating on this spell. If a creature breaks free of the fascination, but can hear you at the start of your turn, it must make a new will save with a +2 bonus to their save or become fascinated again. If your enthrall ends, all creatures who were currently fascinated remain fascinated for an additional 1d4 rounds. This is a language dependant mind-effecting affect.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "any number of creatures",
        duration: "concentration",
        savingThrow: "Will negates; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Euphoric Cloud",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["poison"],
        longDesc: `You create a bank of fog similar to that created by fog cloud except its vapors are intoxicating. Living creatures in the cloud become fascinated. This condition lasts as long as a creature is in the cloud and for 1d4+1 rounds after it leaves. Any creature that succeeds at its save but remains in the cloud must continue to save each round on your turn.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "fog spreads in 20-ft. radius, 20 ft. high",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Fortitude negates (see text)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Fear the Sun",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `Each target that fails its saving throw gains light blindness, as per the universal monster rule. When exposed to bright light, affected targets are blinded for 1 full round and are dazzled in successive rounds. If you cast this spell in the presence of bright light, any target that fails its save is blinded immediately, and dazzled starting at the beginning of its first turn.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "up to one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Fester",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `Necrotic energy permeates the target, blocking healing abilities. The subject gains Spell Resistance equal to 12 + your caster level against effects that restore hit points or grant temporary hit points. In addition, any healing provided by effects that ignore Spell Resistance (such as fast healing, regeneration, and some spells) are halved. If the target succeeds on a Fortitude Saving Throw, fester lasts only a single round.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "",
        duration: "1 round/level or 1 round; see text",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Fleshcurdle",
        type: ["control"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You warp the target creature's flesh, discoloring it and causing it to become misshapen and impairing its function. When you cast this spell, you must choose one of three types of effects to inflict on the target-movement, attacks, or defense. Attacks: One of the creature's natural attacks takes a -2 penalty on attack and damage rolls, only scores a critical hit on a natural 20, and only deals x2 damage on a confirmed critical hit. Defense: The creature's natural armor bonus decreases by -4, to a minimum bonus of +0. Movement: One of the creature's movement speeds (chosen by you) is halved. Most undead are susceptible to fleshcurdle, but amorphous creatures and creatures without flesh are immune (such as elementals, oozes, plants, gaseous or incorporeal creatures, and skeletons).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living or undead creature",
        duration: "1 round/level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Fog Cloud",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `A bank of fog billows out from the point you designate. The fog obscures all sight, including darkvision, beyond 5 feet. A creature within 5 feet has concealment (attacks have a 20% miss chance). Creatures farther away have total concealment (50% miss chance, and the attacker can't use sight to locate the target). A moderate wind (11+ mph) disperses the fog in 4 rounds; a strong wind (21+ mph) disperses the fog in 1 round. The spell does not function underwater.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft. level)",
        area: "",
        effect: "fog spreads in 20-ft. radius",
        targets: "",
        duration: "10 min./level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Fury of the Sun",
        type: ["control"],
        school: "transmutation",
        tags: ["curse", "fire"],
        longDesc: `You curse the target to suffer unbearable heat. On a failed saving throw, the target is immediately subjected to severe heat, takes 1d4 points of nonlethal damage, and is suffering from heatstroke (fatigued). At the start of each of the creatures turns it must make a fortitude save DC 15 or take an additional 1d4 points of nonlethal damage. Every time the creature rolls this save the DC increases by 1, and it gets a -4 penalty if it is wearing heavy armor or clothing. As long as the creature has nonlethal damage from this spell it is fatigued.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "fort negates",
        spellResistance: "yes",
        components: "V,S",
        },
        {
        level: "2",
        name: "Ghoul Touch",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `Imbuing you with negative energy, this spell allows you to paralyze a single living humanoid for the duration of the spell with a successful melee touch attack. A paralyzed subject exudes a carrion stench that causes all living creatures (except you) in a 10-foot-radius spread to become sickened (Fortitude negates). A neutralize poison spell removes the effect from a sickened creature, and creatures immune to poison are unaffected by the stench. This is a poison effect.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living humanoid touched",
        duration: "1d6+2 rounds",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Gusting Sphere",
        type: ["control"],
        school: "evocation",
        tags: ["air"],
        longDesc: `A swirling ball of wind rolls in whichever direction you point, hurling those it strikes with great force. The sphere is treated in all ways as an area of severe wind (Core Rulebook 439), applying a -4 penalty on ranged weapon attacks that pass through it. The sphere moves 30 feet per round. As part of this movement, it can ascend or jump up to 30 feet to strike a target. If it enters a space containing a Medium or smaller creature, it stops moving for that round and generates a sharp thrust of wind to bull rush the creature. The sphere's CMB for bull rush combat maneuvers uses your caster level in place of its base attack bonus, with a +2 bonus for its Strength score (14). Whether or not the bull rush is successful, the creature takes 1d6 points of nonlethal bludgeoning damage from the attack. If the bull rush fails, the creature is still subject to the severe winds from the sphere as long as they remain in the same square as it. A gusting sphere rolls over objects or barriers that are less than 4 feet tall. The sphere moves as long as you actively direct it (a move action for you); otherwise, it merely stays at rest. A gusting sphere immediately dissipates if it exceeds the spell's range.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "5-ft.-diameter sphere of air",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Fortitude negates (object) or Reflex negates; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Haunting Mists",
        type: ["control"],
        school: "illusion(figment)",
        tags: ["fear", "shadow"],
        longDesc: `An illusion of misty vapor inhabited by shadowy shapes arises around you. It is stationary. The illusory mist obscures all sight, including darkvision, beyond 5 feet. A creature 5 feet away has concealment (attacks have a 20% miss chance). Creatures farther away have total concealment (50% miss chance, and the attacker cannot use sight to locate the target). All creatures within the mist must save or take 1d2 points of Wisdom damage and gain the shaken condition. The shaken condition lasts as long as the creature remains in the mist.`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "",
        effect: "cloud spreads in 20-ft. radius, 20 ft. high",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "Will partial (see text)",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Hideous Laughter",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell afflicts the subject with uncontrollable laughter. It collapses into gales of manic laughter, falling prone. The subject can take no actions while laughing, but is not considered helpless. After the spell ends, it can act normally. On the creature's next turn, it may attempt a new saving throw to end the effect. This is a full round action that does not provoke attacks of opportunity. If this save is successful, the effect ends. If not, the creature continues laughing for the entire duration. A creature with an Intelligence score of 2 or lower is not affected. A creature whose type is different from the caster's receives a +4 bonus on its saving throw, because humor doesn't 'translate' well.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature; see text",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Hold Animal",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell functions like hold person, except that it affects an animal instead of a humanoid.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one animal",
        duration: "1 round/level ; see text",
        savingThrow: "Will negates; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Hypnotic Pattern",
        type: ["control"],
        school: "illusion(pattern)",
        tags: ["mind-affecting"],
        longDesc: `A twisting pattern of subtle, shifting colors weaves through the air, fascinating creatures within it. Roll 2d4 and add your caster level (maximum 10) to determine the total number of HD of creatures affected. Creatures with the fewest HD are affected first; and, among creatures with equal HD, those who are closest to the spell's point of origin are affected first. HD that are not sufficient to affect a creature are wasted. Affected creatures become fascinated by the pattern of colors. Sightless creatures are not affected.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "colorful lights in a 10-ft.-radius spread",
        targets: "",
        duration: "Concentration + 2 rounds",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Ice Slick",
        type: ["control"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `You create a blast of intense cold, coating all solid surfaces in the area with a thin coating of ice. Any creature in the area when the spell is cast takes 1d6 points of cold damage + 1 point per caster level (maximum +10) and falls prone; creatures that succeed at a Reflex save take half damage and don't fall prone. Spell resistance applies to this initial effect. A creature can walk within or through the area of ice at half its normal speed with a successful DC 10 Acrobatics check. Failure by 4 or less means the creature can't move that round (and must succeed at a Reflex save or fall); failure by 5 or more means it falls. Creatures that do not move on their turn do not need to attempt this check. A 5-foot square of ice has hardness 0 and 3 hit points. The ice is an instantaneous effect, but persists as nonmagical ice. Under temperate conditions, the ice lasts 1 minute per level. In tropical environments, it might last only half as long. In cold environments where ice and snow persist without melting, it could last indefinitely.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "5-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous (see text)",
        savingThrow: "Reflex partial (see text)",
        spellResistance: "see text",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Limp Lash",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `You create a dark whip-shaped field of energy that wraps around an enemy's neck, leaving everything except his head paralyzed until you let go of the whip or it is destroyed. You must make a ranged touch attack with this spell. If you strike your target, he takes a 1d6 penalty to his Strength, Dexterity, and Constitution each round. This penalty cannot reduce any attribute to less than 1, and once any of these attributes reaches 1 the target collapses and his body, except his head, becomes paralyzed. While paralyzed in this way, the target retains full use of his senses, including the ability to feel pain, and can speak (including casting spells with only verbal components). The whip has a maximum length of 20 feet, 15 hit points, and a hardness of 5. The spell ends immediately if you let go of the whip or it is destroyed. When the spell ends, all penalties the target took from this spell also end.`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "special (see below)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Lipstitch",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `A rare spell without verbal components, lipstitch sews the target's lips tightly together if it fails a saving throw, such that no clear speech, bite attacks, spellcasting, or use of command words is possible. The target takes 1d6 points of damage as the stitches weave through flesh. The victim can still make enough noise to be heard at a distance with a DC 10 Perception check.
        \nThe thread created by lipstitch can be burst with a DC 20 Strength check as a standard action or can be sliced open with a piercing or slashing weapon (wielded by the target or an ally) as a full-round action. Cutting the thread provokes attacks of opportunity, while making a Strength check does not. Either option causes 1d6 points of damage and 1 point of bleed damage. The target has a 20% chance of failing to cast spells with verbal components until the bleeding is stopped. The effects of multiple castings of this spell do not stack. Optionally, the thread can be removed more carefully over the course of a minute with a DC 20 Heal check. If the check fails, the target takes damage and bleeds as described above. If the check succeeds, the stitches are removed with no harm. Creatures with no mouths are unaffected by lipstitch. Creatures with multiple mouths lose the use of only one mouth per casting—the particular mouth is chosen by the caster.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "Fort negates",
        spellResistance: "yes",
        components: "S, M",
        },
        {
        level: "2",
        name: "Mad Hallucination",
        type: ["control"],
        school: "illusion(phantasm)",
        tags: [],
        longDesc: `This spell induces a hallucinogenic reality in the mind of your target. Surfaces seem to swim, and movement constantly distracts the eye. The target takes a -2 penalty on Will saving throws, caster level checks, Intelligence-based skill checks, and Wisdom-based skill checks.`,
        castingTime: "1 standard action",
        range: "close (20 ft.)",
        area: "",
        effect: "",
        targets: "one humanoid creature",
        duration: "5 minute/level (maximum 1 hour)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Oppressive Boredom",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You fill your target with boredom. The target loses all interest in its current task and must make a Will save against the spell's effect in order to perform its next action. If the target fails, it takes no action that round. The boredom lasts until the duration expires or the target breaks the spell's effect with a successful Will save.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level or until broken (see text)",
        savingThrow: "Will negates (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Pernicious Poison",
        type: ["control"],
        school: "necromancy",
        tags: ["poison"],
        longDesc: `You weaken the target's defenses against poison. The target gains a -4 penalty on saves against poison, and poisons affecting the target continue for another 2 frequency increments (for example, black adder venom lasts 8 rounds instead of 6, and arsenic lasts for 6 minutes instead of 4). Attempts to cure the poisoned target with skill or magic take a -4 penalty.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 minute/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Piercing Shriek",
        type: ["control"],
        school: "evocation",
        tags: ["pain", "sonic"],
        longDesc: `You emit an ear-splitting shriek which can be heard only by the target of this spell; all other observers merely see you screaming silently. The target suffers wracking pain from the scream, gaining the staggered condition. This spell has no effect on deaf creatures and cannot penetrate an area of silence.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "2",
        name: "Pox Pustules",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `You inflict a painful, itching rash on the target creature. The target is sickened and takes a -4 penalty to Dexterity (this penalty cannot lower Dexterity below 0). The target can spend a move action scratching furiously at the rash to remove the sickened condition (but not the Dexterity penalty) until the start of its next turn.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M, ",
        },
        {
        level: "2",
        name: "Pyrotechnics",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `Pyrotechnics turns a fire into a burst of blinding fireworks or a thick cloud of choking smoke, depending on your choice. The spell uses one fire source, which is immediately extinguished. A fire so large that it exceeds a 20-foot cube is only partly extinguished. Magical fires are not extinguished, although a fire-based creature used as a source takes 1 point of damage per caster level. Fireworks: The fireworks are a flashing, fiery, momentary burst of glowing, colored aerial lights. This effect causes creatures within 120 feet of the fire source to become blinded for 1d4+1 rounds (Will negates). These creatures must have line of sight to the fire to be affected. Spell resistance can prevent blindness. Smoke Cloud: A stream of smoke billows out from the fire, forming a choking cloud that spreads 20 feet in all directions and lasts for 1 round per caster level. All sight, even darkvision, is ineffective in or through the cloud. All within the cloud take -4 penalties to Strength and Dexterity (Fortitude negates). These effects last for 1d4+1 rounds after the cloud dissipates or after the creature leaves the area of the cloud. Spell resistance does not apply.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "one fire source, up to a 20-ft. cube",
        duration: "1d4+1 rounds, or 1d4+1 rounds after creatures leave the smoke cloud; see text",
        savingThrow: "Will negates or Fortitude negates; see text",
        spellResistance: "yes or no; see text",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Qualm",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `The target is suddenly beset with unexplainable doubts about the effectiveness of its actions and the righteousness of its cause. The creature takes a -10 penalty on its ability checks, skill checks, and concentration checks, until the duration ends, or until it spends its entire turn doing absolutely nothing (it spends a full-round action gaining focus). Spending an entire turn doing nothing discharges the spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 minute/level or until discharged",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Scare",
        type: ["control"],
        school: "necromancy",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `This spell functions like cause fear, except that it causes all targeted creatures of less than 6 HD to become frightened.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one living creature per three levels, no two of which can be more than 30 ft. apart",
        duration: "1 round/level or 1 round; see text for cause fear",
        savingThrow: "Will partial",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Shackle",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You summon a set of Small or Medium masterwork restraints into being. When you cast this spell, you can choose whether the restraints are manacles or fetters (manacles specifically designed to fit around the ankles). You also summon the restraints' key to your person; the Disable Device DC to open the locked restraints is equal to 15 + your caster level + the modifier of your primary casting ability score. Typically, the restraints appear in your hands. However, as part of the spell's casting, you can make a melee touch attack against a creature; if you succeed and the creature then fails a Reflex saving throw against the spell's DC, the locked fetters appear clasped on the creature or locked manacles clasp you and the creature together. You can instead have manacles restrain the target's limbs in front of or behind it. If you cast the spell as a full-round action, you can make melee touch attacks against two creatures you can reach. If you succeed at both attacks and both creatures fail their Reflex saving throws, you can cause the set of manacles to bind the targets together. As you increase in level, the restraints become stronger and you gain more control over them. If you are 6th level or higher, you can make the restraints mithral, or you can summon Tiny or Large restraints. If you are 12th level or higher, you can summon Diminutive or Huge restraints. If you use an emerald worth at least 1,000 gp as a material component while casting this spell, as a standard action once during its duration, you can affect any creature bound by these restraints as per dimensional anchor with a duration of 1 minute per caster level. If you are 18th level or higher and use an emerald worth at least 1,000 gp as a material component while casting this spell, the restraints' hardness increases to 30, they have 60 hit points, and they can't be broken with a successful Strength check. (The emerald must be worth at least 2,000 gp if you also wish to use the dimensional anchor effect described earlier.) If you cast this spell before the duration of a previous casting has lapsed, you can create a new set of restraints or reset the previous spell's duration. If you used an expensive material component during a previous casting, you must again use a component when creating new restraints or resetting the duration if you wish to maintain the special effect. You do not need to touch these previously created shackles to renew their duration, though you must be on the same plane as the shackles. When this spell ends, the restraints disappear, and any ongoing effects created by the spell end.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "one set of restraints; see text",
        targets: "",
        duration: "1 hour/level",
        savingThrow: "Reflex negates; see text",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Shadow Anchor",
        type: ["control"],
        school: "illusion(shadow)",
        tags: ["shadow"],
        longDesc: `The target's shadow becomes a flexible tether to its current square. The creature can move up to 5 feet from that square without penalty. Moving farther than 5 feet from the tether point requires the target to make a bull rush combat maneuver check against a CMB of 10 + 1/2 your caster level + your highest mental modifier. The target takes a -1 penalty for every 5 feet of distance between it and its tethered square. Failing this check means the target's move is wasted and it cannot move farther away. If it fails this check by 10 or more, it is pulled 5 feet toward the tether square and is knocked prone. If it beats the check by 10 or more, the spell ends. This spell does not work on creatures that do not cast shadows or reflections. If the target uses a teleportation effect or leaves the current plane, the spell ends.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "a shadowy shadow tether",
        targets: "creature touched",
        duration: "1 round/level (D); see text",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "S, ",
        },
        {
        level: "2",
        name: "Sickening Entanglement",
        type: ["control"],
        school: "transmutation",
        tags: ["poison"],
        longDesc: `This spell functions as entangle, except the plants are coated with an irritating sap that creates a painful, itching rash on creatures that touch them. Any creature that enters the area or ends its turn there must succeed at a Fortitude save or be sickened as long as it remains in the area and for 1d4 rounds afterward. This is a poison effect.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "plants in a 40-ft.-radius spread",
        effect: "",
        targets: "",
        duration: "1 min./level (D)",
        savingThrow: "Reflex partial and Fortitude negates (see text)",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Soften Earth and Stone",
        type: ["control"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `When this spell is cast, all natural, undressed earth or stone in the spell's area is softened. Wet earth becomes thick mud, dry earth becomes loose sand or dirt, and stone becomes soft clay that is easily molded or chopped. You affect a 10-foot square area to a depth of 1 to 4 feet, depending on the toughness or resilience of the ground at that spot. Magical, enchanted, dressed, or worked stone cannot be affected. Earth or stone creatures are not affected. A creature in mud must succeed on a Reflex save or be caught for 1d2 rounds and unable to move, attack, or cast spells. A creature that succeeds on its save can move through the mud at half speed, and it can't run or charge. Loose dirt is not as troublesome as mud, but all creatures in the area can move at only half their normal speed and can't run or charge over the surface. Stone softened into clay does not hinder movement, but it does allow characters to cut, shape, or excavate areas they may not have been able to affect before. While this spell does not affect dressed or worked stone, cavern ceilings or vertical surfaces such as cliff faces can be affected. Usually, this causes a moderate collapse or landslide as the loosened material peels away from the face of the wall or roof and falls (treat as a cave-in with no bury zone, see Chapter 13). A moderate amount of structural damage can be dealt to a manufactured structure by softening the ground beneath it, causing it to settle. However, most well-built structures will only be damaged by this spell, not destroyed.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "10-ft. square/level; see text",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Splinter Spell Resistance",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `You create an aura around the target weapon that weakens a foe's magical defenses. The first time each round the weapon damages a creature with spell resistance, that creature's spell resistance is reduced by 5 for 1 round. This reduction is not cumulative for multiple attacks within the same round, even if the target is struck by different weapons, each affected by a different casting of splinter spell resistance. However, the same creature's spell resistance can be reduced on multiple rounds by subsequent hits.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "melee or thrown weapon or up to 50 pieces of ammunition touched",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Spore Burst",
        type: ["control"],
        school: "conjuration",
        tags: ["poison"],
        longDesc: `You cause a willing creature's body to sprout small, puffy mushrooms that remain for 1 round per caster level or until the creature uses them. As a standard action, the target can cause these mushrooms to burst open, releasing a cloud of toxic spores that affect all creatures in a 20-foot-radius spread. Those in the area must succeed at Fortitude saves or be sickened for 1d6 rounds as they are overcome by sneezing and coughing. The caster is immune to this poison effect, as are all creatures of the plant type.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one creature; see text",
        duration: "see text",
        savingThrow: "special; see text",
        spellResistance: "no",
        components: "V, S, M, ",
        },
        {
        level: "2",
        name: "Steal Breath",
        type: ["control"],
        school: "transmutation",
        tags: ["air"],
        longDesc: `You pull the breath from a creature's lungs, dealing damage and leaving it unable to speak, use breath weapons, or cast spells with verbal components. If the target fails its saving throw, it takes 2d6 points of damage, and it cannot speak, use breath weapons, or anything else requiring breathing, and a visible line of swirling air leaves the target's mouth and enters your mouth. If, during the duration, the target moves out of range or line of effect to you, the spell immediately ends. This spell has no effect on creatures that do not need to breathe air.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round (see text)",
        savingThrow: "Fortitude negates; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Thunder Fire",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `The firearm targeted creates a thunderous report, even if the firearm is not loaded. Every creature within 15 feet of the creature wielding or carrying the firearm must succeed at a Fortitude save or be deafened for 1 minute. The creature wielding or carrying the firearm takes a -4 penalty on this saving throw, and his misfire range increases by 1 for 1d4 rounds. If the firearm was loaded when it was targeted by this spell, that ammunition is wasted.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 loaded firearm",
        duration: "instantaneous",
        savingThrow: "Will negates (object), see text",
        spellResistance: "yes (object), see text",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Touch of Bloodletting",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell causes any existing wounds that the target possesses to bleed profusely. If the creature's current total hit points are less than its maximum, this spell causes the creature to take 1 point of bleed damage each round and become exhausted for the duration of the spell. A successful DC 15 Heal check or any spell that cures hit point damage negates the effects of this spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Touch of Idiocy",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `With a touch, you reduce the target's mental faculties. Your successful melee touch attack applies a 1d6 penalty to the target's Intelligence, Wisdom, and Charisma scores. This penalty can't reduce any of these scores below 1. This spell's effect may make it impossible for the target to cast some or all of its spells, if the requisite ability score drops below the minimum required to cast spells of that level.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "10 min./level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Touch of Mercy",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["good", "mind-affecting"],
        longDesc: `The target creature deals only nonlethal damage with all of its weapon attacks. Damage taken by creatures or objects that are not subject to nonlethal damage is not converted to nonlethal and remains lethal damage. The weapon retains all of its other normal properties.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Tremor Blast",
        type: ["control"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `You create a minor earthquake that can trip creatures. Attempt a single combat maneuver check and apply the result against the CMD of every creature in the area. If your roll equals or exceeds a creature's CMD, that creature is knocked prone. This trip attack does not provoke an attack of opportunity (though you do provoke one for casting the spell), nor are you knocked prone if you fail the check by 10 or more. Unlike with a regular trip attack, you can trip any creature touching the ground, regardless of size. Improved Trip does not affect this spell in any way. Though the earthquake is small and focused on the ground, if the area is particularly unstable, the spell might cause items to topple, stones to shake loose from the walls or ceiling, and so on at the GM's discretion.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "2",
        name: "Twilight Haze",
        type: ["control"],
        school: "illusion(shadow)",
        tags: ["darkness", "shadow"],
        longDesc: `You create a gray haze that obscures sight (as fog cloud) and causes the illumination level within it to dim by one step (as per darkness). Since this spell produces an illusion rather than a true physical fog, it is unaffected by wind and can be cast underwater.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "fog spreads in 20-ft. radius",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Twisted Futures",
        type: ["control"],
        school: "divination",
        tags: [],
        longDesc: `By rearranging the threads of fate, you disrupt fortunate outcomes for other creatures. A creature affected by this spell is unable to benefit from effects that grant the ability to roll multiple times and take the higher result (like the swashbuckler's charmed life ability) or to choose the die result in lieu of rolling (like the wizard's prescience school power or the cyclops's flash of insight ability). This doesn't affect abilities that force a creature to take the lower of two rolls, such as ill omen or a pugwampi's unluck aura. A cyclops can't use its flash of insight ability to save against this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Unnatural Lust",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `Your target is filled with lust and desire for a single creature or object as designated by you at the time of casting. That creature or object must be within the spell's range and perceivable by the target of the spell. The target is filled with the compulsion to rush to the subject of its lust and passionately kiss or caress that subject on its next turn, taking no other actions. If the target would not normally have lustful feelings toward the designated creature or object, it receives a +4 bonus on its saving throw.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Warp Wood",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `You cause wood to bend and warp, permanently destroying its straightness, form, and strength. A warped door springs open (or becomes stuck, requiring a Strength check to open, at your option). A boat or ship springs a leak. Warped ranged weapons are useless. A warped melee weapon causes a -4 penalty on attack rolls. You may warp one Small or smaller object or its equivalent per caster level. A Medium object counts as two Small objects, a Large object as four, a Huge object as eight, a Gargantuan object as 16, and a Colossal object as 32. Alternatively, you can unwarp wood (effectively warping it back to normal) with this spell. Make whole, on the other hand, does no good in repairing a warped item. You can combine multiple consecutive warp wood spells to warp (or unwarp) an object that is too large for you to warp with a single spell. Until the object is completely warped, it suffers no ill effects.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 Small wooden object/level, all within a 20-ft. radius",
        duration: "instantaneous",
        savingThrow: "Will negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Web",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `Web creates a many-layered mass of strong, sticky strands. These strands trap those caught in them. The strands are similar to spiderwebs but far larger and tougher. These masses must be anchored to two or more solid and diametrically opposed points or else the web collapses upon itself and disappears. Creatures caught within a web become grappled by the sticky fibers. Attacking a creature in a web doesn't cause you to become grappled. Anyone in the effect's area when the spell is cast must make a Reflex save. If this save succeeds, the creature is inside the web but is otherwise unaffected. If the save fails, the creature gains the grappled condition, but can break free by making a combat maneuver check or Escape Artist check as a standard action against the DC of this spell. The entire area of the web is considered difficult terrain. Anyone moving through the webs must make a combat maneuver check or Escape Artist check as part of their move action, with a DC equal to the spell's DC. Creatures that fail lose their movement and become grappled in the first square of webbing that they enter. If you have at least 5 feet of web between you and an opponent, it provides cover. If you have at least 20 feet of web between you, it provides total cover. The strands of a web spell are flammable. A flaming weapon can slash them away as easily as a hand brushes away cobwebs. Any fire can set the webs alight and burn away one 5-foot square in 1 round. All creatures within flaming webs take 2d4 points of fire damage from the flames.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "webs in a 20-ft.-radius spread",
        targets: "",
        duration: "10 min./level (D)",
        savingThrow: "Reflex negates; see text",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Whip of Spiders",
        type: ["control"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `You summon hundreds of Diminutive spiders, which cling together in the form of a whip made for a creature of your size. You can wield this object as if it were an actual whip, except you make a melee touch attack with it instead of a regular attack. Any creature you strike with the whip takes swarm damage as if it were attacked by a spider swarm (1d6 points of damage plus poison and distraction, Bestiary 258). The swarm whip is able to damage creatures with armor or natural armor, even if a normal whip could not. It cannot be used to make bull rush, grapple, or trip attacks, and (unlike a swarm) is subject to a miss chance for concealment and cover. The whip is immune to all weapon damage, is never staggered or reduced to a dying state by damage, and is immune to any spell or effect that targets a specific number of creatures (including single-target spells such as disintegrate). The whip takes half again as much damage from spells or effects that affect an area, but since it is considered part of your gear, it takes damage only if you fail a saving throw on a 1 or if it is specifically targeted by an opponent. The whip does not have a swarm's susceptibility to high winds. As a standard action, you can transform the whip into a spider swarm (all squares of the swarm must be within 15 feet of you); thereafter it functions as summon swarm. The spider swarm has 3 hit points and persists in that form for 2 rounds or until the end of this spell's duration, whichever comes first.`,
        castingTime: "1 standard action",
        range: "0 ft.",
        area: "",
        effect: "whiplike swarm",
        targets: "",
        duration: "1 round/level (D (see text)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Winter Grasp",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["cold", "water"],
        longDesc: `Ice encrusts the ground, radiating supernatural cold and making it hard for creatures to maintain their balance. This icy ground is treated as normal ice, forcing creatures to spend 2 squares of movement to enter an icy square and increasing the DC of Acrobatics checks in the area by 5. A creature that begins its turn in the affected area takes 1d6 points of cold damage and takes a -2 penalty on saving throws against spells with the cold descriptor for 1 round.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "20-ft.-radius spread",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M, DF",
        },
        {
        level: "2",
        name: "Blistering Invective",
        type: ["control", "damage"],
        school: "evocation",
        tags: ["fire", "language-dependent"],
        longDesc: `You unleash an insulting tirade so vicious and spiteful that enemies who hear it are physically scorched by your fury. When you cast this spell, make an Intimidate check to demoralize each enemy within 30 feet of you. Enemies that are demoralized this way take 1d10 points of fire damage and must succeed at a Reflex save or catch fire. Spell Resistance can negate the fire damage caused by this spell, but does not protect the creature from the demoralizing effect.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "30-ft.-radius",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex partial, see text",
        spellResistance: "special, see below",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Burst of Radiance",
        type: ["control", "damage"],
        school: "evocation",
        tags: ["good", "light"],
        longDesc: `This spell fills the area with a brilliant flash of shimmering light. Creatures in the area are blinded for 1d4 rounds, or dazzled for 1d4 rounds if they succeed at a Reflex save. Evil creatures in the area of the burst take 1d4 points of damage per caster level (max 5d4), whether they succeed at the Reflex save or not.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "10-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex partial",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Elemental Touch",
        type: ["control", "damage"],
        school: "evocation",
        tags: ["acid", "cold", "electricity", "fire"],
        longDesc: `Upon completing the casting of this spell, elemental energy infuses your hands. Choose an energy type: acid, cold, electricity, or fire. You gain a melee touch attack causing 1d6 points of damage of that energy type, along with a special effect described below. You also deal energy damage and the related special effect when you attack with your hands using an unarmed strike, a single claw, or a single slam attack. This bonus damage can never apply to multiple weapons. 
        \nAcid: Your touch attack causes 1 point of ongoing acid damage per round for 1 round per three caster levels. The target must make a Fortitude save or be sickened for the duration of the ongoing acid damage. 
        \nCold: The target must make a Fortitude save or be fatigued. A creature that is already fatigued suffers no additional effect. 
        \nElectricity: The target must make a Fortitude save or be staggered for 1 round. 
        \nFire: Your hands ignite and shed light as a torch. Your touch may cause targets to catch on fire (Core Rulebook). Subsequent attacks inflict the normal damage, but the additional effects do not stack. This spell grants no special protection to anything held in or worn on your hands. 
        \nWhen you cast this spell to deal acid, cold, electricity, or fire damage, it is a spell of that type.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Fire Sneeze",
        type: ["control", "damage"],
        school: "evocation",
        tags: ["air", "fire"],
        longDesc: `This spell causes you to begin sneezing gouts of fire that can not only set creatures ablaze but also drop them flat on their backs. Once you cast this spell, you must sneeze each round as a standard action-you can take no other standard action as long as this spell is in effect, nor can you take full-round actions. Each time you sneeze, you produce a 10-foot-long cone of fire and wind. All creatures caught in this cone take 2d6 points of fire damage-a successful Reflex save halves this damage. Any creature that fails to resist this spell with a Reflex save must immediately make a DC 12 Fortitude save or be knocked prone by the blast of wind associated with the sneeze.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round + 1 round/2 levels",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Frost Fall",
        type: ["control", "damage"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `The area of this spell is covered in chilling frost, dealing 3d6 points of cold damage to all creatures within it. Creatures that the spell initially damages must succeed at a Fortitude save or become staggered for 1 round. The area remains chilled for the spell's duration. Any creature that starts your turn within the spell's area takes 1d6 points of cold damage (Fortitude saving throw for half) but does not become staggered even on a failed saving throw.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "5-foot radius burst",
        effect: "",
        targets: "",
        duration: "1 round/2 levels",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Stricken Heart",
        type: ["control", "damage"],
        school: "necromancy",
        tags: ["death"],
        longDesc: `This spell covers your hand with a writhing black aura. As part of casting the spell, you can make a melee touch attack that deals 2d6 points of negative energy damage and causes the target to be staggered for 1 round. If the attack is a critical hit, the target is staggered for 1 minute instead. Creatures immune to precision damage are immune to the staggered effect.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Anti-Summoning Shield",
        type: ["control", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `Within the area of effect, this spell impedes the use of spells of the summoning subschool and other effects that summon creatures. Any such spells, spell-like abilities, or similar summoning effects used within the area have a percent chance of failure equals 5% x your caster level, to a maximum 75% chance of failure. If the summoning effect already has a percent chance of failure (as is often the case with the summon spell-like ability of outsiders), these percentages stack. This spell does not affect summoners attempting to summon their eidolon, but it does affect summoners casting other summoning spells.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "50-ft.-radius",
        effect: "",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "2",
        name: "Darkness",
        type: ["control", "utility"],
        school: "evocation",
        tags: ["darkness"],
        longDesc: `This spell causes an object to radiate darkness out to a 20-foot radius. This darkness causes the illumination level in the area to drop one step, from bright light to normal light, from normal light to dim light, or from dim light to darkness. This spell has no effect in an area that is already dark. Creatures with light vulnerability or sensitivity take no penalties in normal light. All creatures gain concealment (20% miss chance) in dim light. All creatures gain total concealment (50% miss chance) in darkness. Creatures with darkvision can see in an area of dim light or darkness without penalty. Nonmagical sources of light, such as torches and lanterns, do not increase the light level in an area of darkness. Magical light sources only increase the light level in an area if they are of a higher spell level than darkness. If darkness is cast on a small object that is then placed inside or under a lightproof covering, the spell's effect is blocked until the covering is removed. This spell does not stack with itself. Darkness can be used to counter or dispel any light spell of equal or lower spell level.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "object touched",
        duration: "1 min./level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, M,DF,",
        },
        {
        level: "2",
        name: "Gust of Wind",
        type: ["control", "utility"],
        school: "evocation",
        tags: ["air"],
        longDesc: `This spell creates a severe blast of air (approximately 50 mph) that originates from you, affecting all creatures in its path. All flying creatures in this area take a -4 penalty on Fly skill checks. Tiny or smaller flying creatures must make a DC 25 Fly skill check or be blown back 2d6 x 10 feet and take 2d6 points of damage. Small or smaller flying creatures must make a DC 20 Fly skill check to move against the force of the wind. A Tiny or smaller creature on the ground is knocked down and rolled 1d4 x 10 feet, taking 1d4 points of nonlethal damage per 10 feet. Small creatures are knocked prone by the force of the wind. Medium or smaller creatures are unable to move forward against the force of the wind unless they succeed at a DC 15 Strength check. Large or larger creatures may move normally within a gust of wind effect. This spell can't move a creature beyond the limit of it's range. Any creature, regardless of size, takes a -4 penalty on ranged attacks and Perception checks in the area of a gust of wind. The force of the gust automatically extinguishes candles, torches, and similar unprotected flames. It causes protected flames, such as those in lanterns, to dance wildly and has a 50% chance to extinguish those lights. In addition to the effects noted, a gust of wind can do anything that a sudden blast of wind would be expected to do. It can create a stinging spray of sand or dust, fan a large fire, overturn delicate awnings or hangings, heel over a small boat, and blow gases or vapors to the edge of its range.`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "",
        effect: "line-shaped gust of severe wind emanating out from you to the extreme of the range",
        targets: "",
        duration: "1 round",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Twisted Space",
        type: ["control", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You distort the space around a creature, twisting the path of its melee attacks unpredictably, but always toward a nearby creature that the target threatens. Until the start of your next turn, melee attacks made by the target creature affect a random target instead of their intended target.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round",
        savingThrow: "Will Negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Acid Arrow",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["acid"],
        longDesc: `An arrow of acid springs from your hand and speeds to its target. You must succeed on a ranged touch attack to hit your target. The arrow deals 2d6 points of acid damage with no splash damage. For every three caster levels you possess, the acid, unless neutralized, lasts for another round (to a maximum of 6 additional rounds at 18th level), dealing another 2d6 points of damage in each round, increasing by 1d6 for each round it has lasted.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "one arrow of acid",
        targets: "",
        duration: "1 round + 1 round per three levels",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,F,",
        },
        {
        level: "2",
        name: "Acid Darts",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["acid"],
        longDesc: `You call forth two corrosive projectiles resembling darts, plus one more for every two caster levels beyond 3rd (to a maximum of eight darts at 15th level), which hover in front of you. When these darts appear, you can launch some or all of them at the same target or different targets. Each darts requires a ranged touch attack roll to hit and deals 1d4 points of acid damage, and 1d4 point of acid damage on the turn after you struck them with this spell. You provoke no attacks of opportunity when launching them. Any darts you do not launch as part of casting this spell remains floating near you for the spell's duration. On rounds subsequent to your casting of this spell, you can spend a swift action to launch one of these remaining darts or a standard action to launch any number of these remaining darts. If you fail to launch a darts before the duration ends, that darts disappears and is wasted.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "Two or more corrosive darts",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Admonishing Ray",
        type: ["damage"],
        school: "evocation",
        tags: ["force"],
        longDesc: `You blast your enemies with rays of nonlethal force. You may fire one ray, plus one additional ray for every four levels you possess beyond 3rd (to a maximum of three rays at 11th level). Each ray requires a ranged touch attack to hit and deals 4d6 points of nonlethal damage. This is a force effect. The rays may be fired at the same or different targets, but all rays must be fired simultaneously and aimed at targets within 30 feet of each other.`,
        castingTime: "1 standard action",
        range: "close (25 f. + 5 f./2 levels)",
        area: "",
        effect: "one or more rays",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "2",
        name: "Aggressive Thundercloud",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `A crackling, spherical storm cloud flies in whichever direction you point and deals electricity damage to those it strikes. It has a fly speed of 20 feet with perfect maneuverability. If it enters a space that contains a creature, the storm stops moving for the round and deals 3d6 points of electricity damage to that creature, though a successful Reflex save negates that damage. It provides concealment (20% miss chance) to anything within it, and its flickering light illuminates the same area a candle would. The sphere moves as long as you actively direct it (as a move action for you); otherwise, it stays at rest and crackles with lightning. It can be moved by wind effects and counts as a Small creature for the purpose of determining how winds affect it. The sphere has no physical substance and cannot exert any force on corporeal creatures or objects. It disperses if it exceeds the spell's range.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "5-ft.-diameter sphere",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Reflex negates",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Bloodbath",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `You cut yourself with the dagger, dealing yourself 1d6 points of bleed damage. So long as you keep taking this bleed damage, your targets each bleed for 1d6 points of damage at the beginning of their turns. The bleed damage on any target ends if that target receives magical healing, or if your bleed damage ends for any reason. This spell has no effect if you're immune to bleed damage or can otherwise reduce or ignore the bleed damage to yourself.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./level)",
        area: "",
        effect: "",
        targets: "up to one living creature/level, no two of which can be more than 30 feet apart",
        duration: "1 round/level (D)",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Boiling Blood",
        type: ["damage"],
        school: "transmutation",
        tags: [],
        longDesc: `The blood of the targeted creatures begins to boil. If a target fails its save, it takes 1d6 point of fire damage per round. This spell has no effect on creatures that don't have blood. If a target has the orc subtype, it doesn't take fire damage and instead gains a +2 morale bonus to Strength.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature per three levels, no two of which may be more than 30 ft. apart",
        duration: "concentration + 1 round/level (D)",
        savingThrow: "Fortitude negates (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Burning Arc",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `This spell causes an arc of flame to leap from your fingers, burning a number of enemies nearby. It deals 1d6 points of fire damage per caster level (maximum 10d6). For every additional target the discharge arcs to, reduce the number of damage dice by half (rounded down). Therefore, at 9th level, your burning arc deals 9d6 points of fire damage to the primary target, then 4d6 points of fire damage to a secondary target, then 2d6 points of fire damage to an additional target. Each target can attempt a Reflex saving throw for half damage. The Reflex DC to halve the damage of the secondary bolts is 2 lower than the DC to halve the damage of the primary bolt. You may choose secondary targets as you like, but they must all be within 15 feet of the primary target, and no target can be struck more than once. You can choose to affect fewer secondary targets than the maximum.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one primary target plus one additional target/3 levels (each of which must be within 15 ft. of the primary target)",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Burning Gaze",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `Your eyes burn like hot coals, allowing you to set objects or foes alight with a glance. As a standard action as long as this spell's effects persist, you may direct your burning gaze against a single creature or object within 30 feet of your location. Targeted creatures must succeed at a Fortitude save or take 1d6 points of fire damage. Unattended objects do not get a save. Creatures damaged by the spell must make a Reflex save or catch fire. Each round, burning creatures may attempt a Reflex save to quench the flames; failure results in another 1d6 points of fire damage. Flammable items worn by a creature must also save or take the same damage as the creature. If a creature or object is already on fire, it suffers no additional effects from burning gaze. Note that this spell does not grant an actual gaze attack- foes and allies are not in danger of catching on fire simply by meeting your gaze.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "Fortitude negates (see text)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
            level: "3",
            name: "Amplify Elixir",
            type: ["buff"],
            school: "transmutation",
            tags: [],
            longDesc: `This spell greatly enhances the effects of any potion or gear items you consume. For the duration of this spell, any potion or gear items that you consume are treated as if it were empowered. Increase all variable numeric effects of the potion or gear by half. If the potion or gear does not have any variable numeric effects, it is instead treated as if it were extended (double the duration of the potion or gear). If the potion or gear does not have any variable numeric effects, or has an instantaneous duration, amplify gear has no effect.`,
            castingTime: "1 standard action",
            range: "personal",
            area: "",
            effect: "",
            targets: "you",
            duration: "1 round/level",
            savingThrow: "",
            spellResistance: "",
            components: "S",
        },
        {
            level: "3",
            name: "Dragon Turtle Shell",
            type: ["buff"],
            school: "abjuration",
            tags: [],
            longDesc: `When you are struck by an opponent's natural attacks, the damage is resolved as if the attack came from a creature one size smaller per 5 caster levels (maximum of four size categories smaller at CL 20th). It is not possible to reduce the base damage of a creature's natural attack below 1d2 with this spell.`,
            castingTime: "1 standard action",
            range: "personal",
            area: "",
            effect: "",
            targets: "you",
            duration: "1 round/level",
            savingThrow: "",
            spellResistance: "",
            components: "V, S, M",
        },
        {
            level: "3",
            name: "Shared Training",
            type: ["buff","utility"],
            school: "divination",
            tags: ["mind-affecting"],
            longDesc: `Select one teamwork feat you have. You can grant this feat to allies within range for the duration of the spell. Allies do not need to meet the prerequisites of this teamwork feat. At caster level 9th, you can grant two teamwork feats you have to your allies. At caster level 13th, you can grant three teamwork feats, and at caster level 17th, you can grant up to four teamwork feats.`,
            castingTime: "1 standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "you plus one willing creature per 3 levels, no two of which can be more than 30 ft. apart",
            duration: "1 minutes/level",
            savingThrow: "none",
            spellResistance: "none",
            components: "V, S",
        },
        {
            level: "2",
            name: "Bloody Tears and Jagged Smile",
            type: ["buff","utility"],
            school: "necromancy",
            tags: [],
            longDesc: `Your eyes turn black and weep blood, and your teeth become jagged fangs. You gain a bite attack (1d3 points of damage if you are Small, 1d4 points of damage if you are Medium). You gain a +4 profane bonus on Intimidate checks and on your spell DCs for spells with the fear descriptor. You perceive creatures as if using deathwatch.`,
            castingTime: "1 standard action",
            range: "personal and see text",
            area: "",
            effect: "",
            targets: "you and see text",
            duration: "1 minutes/level",
            savingThrow: "none",
            spellResistance: "yes",
            components: "V, S",
        },
        {
            level: "2",
            name: "Dousing Rain",
            type: ["utility"],
            school: "evocation",
            tags: ["water"],
            longDesc: `With a beckoning gesture, you call forth a downpour of rain. For the duration of the spell, the following effects apply within the affected area. Nonmagical fires are automatically extinguished, and all creatures and objects in the area gain fire resistance 5. The conjured water is conductive, and whenever a doused creature takes electricity damage, it takes 1 additional point of electricity damage. At 6th, 12th, and 18th levels, the fire resistance increases by 5 and the additional electricity damage increases by 1 point.`,
            castingTime: "1 standard action",
            range: "medium (100 ft. + 10 ft./level)",
            area: "cylinder (10-ft. radius, 40 ft. high)",
            effect: "",
            targets: "",
            duration: "1 round/level (D)",
            savingThrow: "none",
            spellResistance: "no",
            components: "V, S, M",
        },
        {
        level: "2",
        name: "Chill Metal",
        type: ["damage"],
        school: "transmutation",
        tags: ["cold"],
        longDesc: `Chill metal makes metal extremely cold. Unattended, nonmagical metal gets no saving throw. Magical metal is allowed a saving throw against the spell. A creature takes cold damage if its equipment is chilled. It takes full damage if its armor, shield, or weapon is affected, if it is otherwise touching it, it takes minimum damage. The spell starts by dealing no damage, but each round of its duration it increases by 1d4.
                
        Chill metal counters and dispels heat metal.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "metal equipment of one creature per two levels, no two of which can be more than 30 ft. apart; or 25 lbs. of metal/level, none of which can be more than 30 ft. away from any of the rest",
        duration: "7 rounds",
        savingThrow: "Will negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Corrosive Blast",
        type: ["damage"],
        school: "evocation",
        tags: ["acid"],
        longDesc: `You launch a globe of acid that deals 2d6 acid damage in a 10ft radius. At level 7 and 11 you can fire an additional corrosive blast. Creatures within the area make a reflex save for half, if a creature is struck by multiple it only makes one save for all blasts. At the end of your next turn creatures that failed the reflex save take another 1d6 acid damage, increasing by +1 for each additional blast that struck it.`,
        castingTime: "1 standard action",
        range: "close (25ft + 5ft/2 levels)",
        area: "10ft radius spread",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "2",
        name: "Defoliate",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `You hurl a tiny ball of negative energy, destroying plant life either in a line 60 feet long or a 10-foot-radius spread. This effect removes the cover and concealment provided by trees and undergrowth, eliminates the movement penalties associated with undergrowth, and so forth. You may also target a single plant creature with this spell. You must succeed on a ranged touch attack to hit your target. An affected plant creature takes 1d8 points of damage per caster level (max 10d8).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "see text",
        effect: "",
        targets: "see text",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M, ",
        },
        {
        level: "2",
        name: "Divine Trident",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `A 4-foot-long, blazing, forked bolt of electricity springs forth from your hand. You wield this spear-like bolt as if it were a trident. Attacks with the trident are melee touch attacks. The bolt deals 1d8 points of electricity damage + 1 point per 2 caster levels (maximum +10), is a one-handed weapon, has crit range of 20x2, and has the brace special feature. Since the bolt is immaterial, your Strength modifier does not apply to the damage. The bolt can ignite combustible materials such as parchment, straw, dry sticks, and cloth.`,
        castingTime: "1 standard action",
        range: "0 ft. trident-like bolt of electricity",
        area: "",
        effect: "",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Dread Bolt",
        type: ["damage"],
        school: "evocation",
        tags: ["evil"],
        longDesc: `You unleash a crackling missile of darkness from your unholy symbol at any one target in range as a ranged touch attack. A good creature struck by dread bolt takes 1d8 points of damage per two caster levels (maximum 5d8). A good outsider instead takes 1d6 points of damage per caster level (maximum 10d6) and is sickened for 1 round. A successful Will save reduces the damage to half and negates the sickened effect. This spell deals only half damage to creatures that are neither good nor evil, and they are not sickened. The bolt has no effect on evil creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "arrow-shaped projectile of evil energy",
        targets: "",
        duration: "instantaneous (1d4 rounds)",
        savingThrow: "Will partial (see text)",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Fiery Shuriken",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["fire"],
        longDesc: `You call forth two fiery projectiles resembling shuriken, plus one more for every two caster levels beyond 3rd (to a maximum of eight shuriken at 15th level), which hover in front of you. When these shuriken appear, you can launch some or all of them at the same target or different targets. Each shuriken requires a ranged touch attack roll to hit and deals 1d8 points of fire damage. You provoke no attacks of opportunity when launching them. Any shuriken you do not launch as part of casting this spell remains floating near you for the spell's duration. On rounds subsequent to your casting of this spell, you can spend a swift action to launch one of these remaining shuriken or a standard action to launch any number of these remaining shuriken. If you fail to launch a shuriken before the duration ends, that shuriken disappears and is wasted.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "Two or more fiery shuriken",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Fire Breath",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `Up to thrice during this spell's duration, you can belch forth a cone of fire as a standard action. The first cone deals 4d6 points of fire damage to every creature in the area. The second cone of flame deals 2d6 points of fire damage to every creature in the area. The third cone of flame deals 1d6 points of fire damage to every creature in the area. A successful Reflex save halves this damage. After the third cone of flame, the spell ends.`,
        castingTime: "1 standard action",
        range: "15 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "1 round/level or until discharged; see text",
        savingThrow: "Reflex half; see text",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Flame Blade",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `A 3-foot-long, blazing beam of red-hot fire springs forth from your hand. You wield this blade-like beam as if it were a scimitar. Attacks with the flame blade are melee touch attacks. The blade deals 1d8 points of fire damage + 1 point per two caster levels (maximum +10). Since the blade is immaterial, your Strength modifier does not apply to the damage. A flame blade can ignite combustible materials such as parchment, straw, dry sticks, and cloth.`,
        castingTime: "1 standard action",
        range: "0 ft.",
        area: "",
        effect: "sword-like beam",
        targets: "",
        duration: "1 min./level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Flaming Sphere",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `A burning globe of fire rolls in whichever direction you point and burns those it strikes. It moves 30 feet per round. As part of this movement, it can ascend or jump up to 30 feet to strike a target. If it enters a space with a creature, it stops moving for the round and deals 3d6 points of fire damage to that creature, though a successful Reflex save negates that damage. A flaming sphere rolls over barriers less than 4 feet tall. It ignites flammable substances it touches and illuminates the same area as a torch would. The sphere moves as long as you actively direct it (a move action for you); otherwise, it merely stays at rest and burns. It can be extinguished by any means that would put out a normal fire of its size. The surface of the sphere has a spongy, yielding consistency and so does not cause damage except by its flame. It cannot push aside unwilling creatures or batter down large obstacles. A flaming sphere winks out if it exceeds the spell's range.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "5-ft.-diameter sphere",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Reflex negates",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
            level: "3",
            name: "Deceptive Fire",
            type: ["damage"],
            school: "evocation",
            tags: ["fire"],
            longDesc: `A burning globe of fire shoots out from your hand 45 feet in a straight line, dealing 1d6 points of fire damage per 2 caster levels to any creature it passes through. Once it reaches its destination, it stays there until the start of your next turn, damaging any creature who passes through it. At the start of your next turn, the sphere returns to you, traveling in a straight line, dealing 1d6 untyped damage per caster level to any creature it passes through. A reflex save halves the damage.`,
            castingTime: "1 standard action",
            range: "45ft",
            area: "",
            effect: "5-ft.-diameter sphere",
            targets: "",
            duration: "1 round",
            savingThrow: "Reflex half",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
            level: "4",
            name: "Mysthral's Fire Dance",
            type: ["damage","utility"],
            school: "conjuration",
            tags: ["fire"],
            longDesc: `You summon 3 enchanted flames to surround you. You gain a 30 foot bonus to your movement speed that degrades 10ft per round. Once per round for the next 3 rounds (doesn't activate the round this is cast) if an enemy is within 15 feet of you at any point, one of the fires leaps off from you towards the enemy. It makes a touch attack against the enemy, using a bonus of your highest mental modifier and your dexterity modifier. This requires a ranged touch attack (but this does not provoke attacks of opportunity). If it hits, it does 4d6 points of fire damage. You do not choose whether this fire is launched or not, it happens automatically as soon as the enemy is within range (you also cannot choose to miss the attack on purpose).`,
            castingTime: "movement",
            range: "personal",
            area: "",
            effect: "",
            targets: "you",
            duration: "3 rounds",
            savingThrow: "none",
            spellResistance: "yes",
            components: "V, S",
        },
        {
            level: "4",
            name: "Mysthral's Kiss",
            type: ["damage","control"],
            school: "enchantment",
            tags: ["emotion", "mind-affecting","charm"],
            longDesc: `You launch a charming kiss at an enemy. This requires a ranged touch attack to hit. If it does, the target suffers 1d6 points of damage per 2 caster levels and must make a will save or they become be infatuated by you, acting as if under the effects of the unnatural lust spell with you as the target of their affection. This lasts one round, and then they are charmed by you as the charm person spell for 1 round. If the initial save is successful, they instead just become charmed by you for 1 round, but this spell can no longer charm or infatuate them. If a creature is immune to mind-affecting effects, they are also immune to this spell's damage. If the creature is currently infatuated or charmed by you because of this spell, your spells gain 15 spell power against them.`,
            castingTime: "standard",
            range: "close (25ft + 5ft/2 levels)",
            area: "",
            effect: "",
            targets: "one creature",
            duration: "1 round",
            savingThrow: "Will partial; see text",
            spellResistance: "yes",
            components: "V, S",
        },
        {
            level: "6",
            name: "Astral Comet",
            type: ["damage","healing"],
            school: "conjuration(healing)",
            tags: ["good"],
            longDesc: `You launch a comet in a straight line 90 feet. To enemies, this deals 1d8 points of damage per 2 caster levels, but to allies, it instead heals that amount. For every ally within the area, the damage gains 10 spell power, for every enemy, the healing gains 10 spell power. Reflex halves the healing or damage.`,
            castingTime: "1 standard action",
            range: "90ft",
            area: "90 ft. line",
            effect: "",
            targets: "",
            duration: "instantaneous",
            savingThrow: "Reflex half",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
        level: "2",
        name: "Flurry of Snowballs",
        type: ["damage"],
        school: "evocation",
        tags: ["cold", "water"],
        longDesc: `throw a flurry of snowballs, any creature in the area takes 4d6 points of cold damage from being pelted with the icy spheres. Creatures who fail the reflex save must then make a fortitude save with a -4 penalty. If they also fail the fortitude save, they are staggered for 1 round.`,
        castingTime: "1 standard action",
        range: "30 ft",
        area: "",
        effect: "cone-shaped burst",
        targets: "",
        duration: "instantaneous",
        savingThrow: "reflex half",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Frigid Touch",
        type: ["damage"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `This spell causes your hand to glow with a pale blue radiance. Your melee touch attack deals 4d6 points of cold damage and causes the target to be staggered for 1 round. If the attack is a critical hit, the target is staggered for 1 minute instead.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Frost Lance",
        type: ["damage"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `You blast your enemies with a lance of blistering ice. You may fire one lance, plus one additional lance for every four levels beyond 3rd (to a maximum of three lances at 11th level). Each lance requires a ranged touch attack to hit and deals 5d6 points of cold damage. The lances may be fired at the same or different targets, but all lances must be aimed at targets within 30 feet of each other and fired simultaneously. This spell gains 25% critical spell damage.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one or more lances",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Fungal Blisters",
        type: ["damage"],
        school: "transmutation",
        tags: [],
        longDesc: `When you cast this spell, horrible, fungal growths sprout forth all over your body. You develop 1d2+1 of these blisters per 2 caster levels. Each time you are dealt more than 5 points of bludgeoning, piercing, or slashing damage from a single attack, one of these blisters bursts, releasing a cloud of harmful spores in a 5-foot-radius burst centered on you. These spores enter the lungs of all living creatures within the cloud that need to breathe and deal 1d6+1 points of damage for every 2 caster levels you have (Fortitude negates). This is a disease effect, and you and plants aren't affected by the spores. It is possible for more than one blister to burst in a single round. If you are reduced to 0 or fewer hit points, all remaining blisters burst, and the resulting spores deal the cumulative amount of damage and affected creatures make a single save vs all blisters at once.
        \nYou are not able to cast this spell while wearing heavy armor. If you don heavy armor during the spell's duration, all remaining blisters burst as if you had been reduced to 0 or fewer hit points.`,
        castingTime: "1 standard action",
        range: "Personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level or until discharged (see text)",
        savingThrow: "fortitude negates (see text)",
        spellResistance: "yes",
        components: "V, S",
        },
        {
            level: "2",
            name: "Invigorating Poison",
            type: ["utility","healing","buff"],
            school: "transmutation",
            tags: [],
            longDesc: `The body of the target creature gains a metabolic response that allows it to benefit from normally deadly toxins. When a poison would cause ability damage to the target creature, the target instead gains a +4 alchemical bonus to that ability score. The spell then immediately ends, but the bonus lasts for a number of minutes equal to the amount of ability damage the poison would have caused. If the poison would deal more than one type of ability damage, each bonus has a separate duration. If the poison has effects other than ability damage (such as unconsciousness or ability drain), these effects apply normally. This spell affects only a single poison; if multiple poisons affect the target simultaneously, this spell prevents only ability damage and grants the appropriate bonuses for the poison that would cause the most damage.`,
            castingTime: "1 standard action",
            range: "touch",
            area: "",
            effect: "",
            targets: "creature touched",
            duration: "10 minutes/level",
            savingThrow: "fortitude negates (harmless)",
            spellResistance: "yes (harmless)",
            components: "V, S, M/DF",
        },
        {
        level: "2",
        name: "Heat Metal",
        type: ["damage"],
        school: "transmutation",
        tags: ["fire"],
        longDesc: `Heat metal causes metal objects to become red-hot. Unattended, nonmagical metal gets no saving throw. Magical metal is allowed a saving throw against the spell. An item in a creature's possession uses the creature's saving throw bonus unless its own is higher. A creature takes fire damage if its equipment is heated. It takes full damage if its armor, shield, or weapon is affected. The creature takes minimum damage if it's not wearing or wielding such an item. On the first round of the spell, the metal becomes warm and uncomfortable to touch but deals no damage, then for each round of its duration it deals 1d4 additional fire damage. Any cold intense enough to damage the creature negates fire damage from the spell (and vice versa) on a point-for-point basis. If cast underwater, heat metal deals half damage and boils the surrounding water. Heat metal counters and dispels chill metal.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "metal equipment of one creature per two levels, no two of which can be more than 30 ft. apart; or 25 lbs. of metal/level, all of which must be within a 30-ft. circle",
        duration: "7 rounds",
        savingThrow: "Will negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, DF",
        },
        {
            level: "2",
            name: "Explosive Guard",
            type: ["utility"],
            school: "evocation",
            tags: ["fire"],
            longDesc: `You create a fiery explosion to reduce the impact of an attack about to hit you (you must choose to cast this spell before the damage is rolled). It must be a physical attack or elemental spell. Reduce the damage by 1d4 per caster level (max 10d4). This reduction in damage scales with fire spell power, and can critically hit to reduce more damage. If it is a critical hit, any damage in excess to the damage you took is dealt to the attacker as fire damage. You cannot cast this spell again until either the floor ends, or you personally defeat an enemy.`,
            castingTime: "immediate action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "",
            duration: "instantaneous",
            savingThrow: "none",
            spellResistance: "no",
            components: "S",
        },
        {
            level: "2",
            name: "Flame Ward",
            type: ["utility"],
            school: "evocation",
            tags: ["fire"],
            longDesc: `Expend a different spell when you are about to take damage (this spell is lost until the floor ends). You reduce the damage by 1d10 per level of the spell, and the enemy takes an equal amount of fire damage. This scales with fire spell power.`,
            castingTime: "immediate action",
            range: "personal",
            area: "",
            effect: "",
            targets: "",
            duration: "instantaneous",
            savingThrow: "none",
            spellResistance: "no",
            components: "S, V",
        },
        {
            level: "3",
            name: "Gia's Skin",
            type: ["utility"],
            school: "conjuration",
            tags: ["earth"],
            longDesc: `Roll a dice with a size equal to your acid spell power. You gain temporary hit points equal to that roll until the end of that creatures turn. This can critically cast (this gains your acid spell critical chance and spell critical power, but not acid spell power), causing it to also reduce all damage you take by your highest mental modifier until the temporary hit points end. You cannot cast this spell again until either the floor ends, or you critically cast a different acid/earth spell.`,
            castingTime: "immediate action",
            range: "personal",
            area: "",
            effect: "A protective barrier",
            targets: "you",
            duration: "1 turn",
            savingThrow: "none",
            spellResistance: "no",
            components: "S",
        },
        {
            level: "2",
            name: "Flicker",
            type: ["utility"],
            school: "transmutation",
            tags: ["electricity"],
            longDesc: `You cast this spell after you have been hit by an attack, but before the damage is dealt. Make a reflex save, gaining a bonus equal to your caster level with electricity spells, reduce the damage you take by that roll, and then move feet up to 1/4 your electricity spell power. The damage reduction scales with electricity spell power, and can criticall cast, granting you a miss chance equal to your electricity spell critical power for 1 round. You cannot cast this spell again until either the floor ends, or you critically cast a different electricity/air spell.`,
            castingTime: "immediate action",
            range: "personal",
            area: "",
            effect: "",
            targets: "you",
            duration: "instantaneous",
            savingThrow: "none",
            spellResistance: "no",
            components: "S",
        },
        {
            level: "2",
            name: "Ice Barrier",
            type: ["utility"],
            school: "conjuration",
            tags: ["cold"],
            longDesc: `When an ally is attacked, but before the damage is dealt, you can cast this spell. The ally gains 1d2 temporary hit points per caster level (max 10d3) for 1 round. This scales with cold spell power.`,
            castingTime: "immediate action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "1 ally",
            duration: "1 round",
            savingThrow: "none",
            spellResistance: "no",
            components: "S, M",
        },
        {
            level: "3",
            name: "Ice Block",
            type: ["utility"],
            school: "transmutation",
            tags: ["cold"],
            longDesc: `You cast this spell when you are about to be reduced below 0 hit points. You cannot be reduced below 0 hit points until the next time your turn ends. You cannot cast this spell again until the floor ends.`,
            castingTime: "immediate action",
            range: "personal",
            area: "",
            effect: "",
            targets: "you",
            duration: "1 round",
            savingThrow: "none",
            spellResistance: "no",
            components: "S",
        },
        {
            level: "5",
            name: "Effigy",
            type: ["utility"],
            school: "conjuration",
            tags: ["fire"],
            longDesc: `After you defeat an enemy, you can cast this spell the same round it is defeated. The creature immediately takes a full-round to attack its allies, though it cannot activate any extraordinary, supernatural, or spell-like abilities (its passive abilities still function, however nothing based on its biology does). All damage it deals is converted to fire damage.`,
            castingTime: "movement and swift action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "1 enemy",
            duration: "instantaneous",
            savingThrow: "none",
            spellResistance: "no",
            components: "S, V, M",
        },
        {
        level: "2",
        name: "Ice Knives",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["cold"],
        longDesc: `You call forth two frozen projectiles resembling knives, plus one more for every two caster levels beyond 3rd (to a maximum of eight knives at 15th level), which hover in front of you. When these knives appear, you can launch some or all of them at the same target or different targets. Each knive requires a ranged touch attack roll to hit and deals 1d6 points of cold damage, with a crit range of 19-20x3. You provoke no attacks of opportunity when launching them. Any knives you do not launch as part of casting this spell remains floating near you for the spell's duration. On rounds subsequent to your casting of this spell, you can spend a swift action to launch one of these remaining knives or a standard action to launch any number of these remaining knives. If you fail to launch a knives before the duration ends, that knives disappears and is wasted. Additionally you can choose to grab one from the air as a swift action to attack with it for the round, it deals the same damage as it would if you fired it (except any bonuses you may have, and it counts as a dagger, but deals cold damage), and vanishes at the end of your round.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "Two or more frozen knives",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Inflict Moderate Wounds",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell functions like inflict light wounds, except that you deal 3d8 points of damage + 1 point per caster level (maximum +10).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Lightning Sphere",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You launch a slow moving orb of electricity, which deals 1d6 points of electricity damage (max 10d6) to all creatures within the area when collides with a surface or a creature, however they may make a fortitude saving throw to reduce the damage by half, creatures that fail the fortitude save must also make a will save dc+4 or they become stunned until the start of their turn. This orb however is very slow moving, and unless it is fired at a location within 10ft, it takes 1 round to arrive at its desired location.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "15ft radius burst",
        effect: "1 orb of lightning",
        targets: "square intersection",
        duration: "instantaneous",
        savingThrow: "fortitude half",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "2",
        name: "Molten Orb",
        type: ["damage"],
        school: "evocation",
        tags: ["earth", "fire"],
        longDesc: `You create a fist-sized, red-hot ball of molten metal that you immediately hurl as a splash weapon. A direct hit deals 2d6 points of fire damage. Every creature within 5 feet of where the ball hits takes 1d6 points of fire damage from the splash (Reflex half). Each of these creatures takes an additional 1d6 points of fire damage on its turn for the next 1d3 rounds, unless it is cooled off (with water, snow, or any effect that deals 5 or more points of cold damage).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "ranged attack",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Scorching Ray",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `You blast your enemies with a searing beam of fire. You may fire one ray, plus one additional ray for every four levels beyond 3rd (to a maximum of three rays at 11th level). Each ray requires a ranged touch attack to hit and deals 4d6 points of fire damage. The rays may be fired at the same or different targets, but all rays must be aimed at targets within 30 feet of each other and fired simultaneously.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one or more rays",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
            level: "1",
            name: "Nimbus of Light",
            type: ["damage"],
            school: "evocation",
            tags: ["light"],
            longDesc: `You blast your enemies with a searing beam of light. This ray requires a touch attack to hit and deals 1d4 points of light damage per 2 caster levels (max 5d4). This damage increases to 1d6 damage per caster level (max 10d6) against undead or creatures vulnerable to light, and 1d8 per caster level to undead vulnerable to light. This spell scales with fire spell power.`,
            castingTime: "1 standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "ray of light",
            targets: "",
            duration: "instantaneous",
            savingThrow: "none",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
            level: "5",
            name: "Divine Punishment",
            type: ["damage"],
            school: "evocation",
            tags: ["light"],
            longDesc: `Focuses the power of the gods upon the target. At the start of the creatures next 8 rounds, it suffers 1d6 + 1 per caster level (max 1d6+15) light damage at the start of each of its turns. The damage increases to 1d6 + 2 per caster level if the creature is undead or vulnerable to light, and 1d6 + 3 per caster level if the creature is both. This spell can stack on the target up to 3 times, increasing the damage with each stack. If you have 3 stacks of this spell on a creature, its critical chance per damage tick increases by 4%. This spell scales with fire spell power.`,
            castingTime: "1 standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "1 creature",
            duration: "8 rounds",
            savingThrow: "none",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
            level: "9",
            name: "Divine Wrath",
            type: ["damage","healing"],
            school: "evocation",
            tags: ["light"],
            longDesc: `You call down divine wrath on your foes, dealing 2d6 light damage per caster level. Damage is halved on a Will save. Allies caught within the blast are healed for 1d6 positive energy damage per caster level. The damage of this spell scales with fire spell power, and the healing scales with positive energy spell power.`,
            castingTime: "1 standard action",
            range: "medium (100 ft. + 10 ft./level)",
            area: "cylinder (15-ft. radius, 60-ft. high)",
            effect: "",
            targets: "",
            duration: "instantaneous",
            savingThrow: "Will half",
            spellResistance: "yes",
            components: "V, S,",
        },
        {
        level: "2",
        name: "Shock Arrow",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You may throw the arrow up to Medium range or fire it from a bow up to the bow's maximum range. Either use is a ranged touch attack. The arrow deals 2d6 points of electricity damage + 1 point per level (maximum +10). If fired from the bow it deals the bows damage +1 per caster level (max +10) but as electricity damage. At 7th and 11th level you can throw or fire an additional arrow, each target must be within 30ft of each other.`,
        castingTime: "1 standard action",
        range: "Medium (100 ft. + 10 ft./level) or see text",
        area: "",
        effect: "arrow of electricity",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "2",
        name: "Sonic Scream",
        type: ["damage"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `Up to three times during this spell's duration, you can emit a cone of powerful sound as a standard action. The first cone deals 4d4 points of sonic damage to every creature in the area. The second deals 2d4 points of sonic damage to every creature in the area. The third deals 1d4 points of sonic damage to every creature in the area. A successful Reflex save against a cone halves that cone's damage. After the third cone of sound, the spell ends. Until you use all three cones, you cannot use your voice for any magic-related purpose (bardic performance, verbal spellcasting, and so on), and cannot speak at any volume lower than a shout.`,
        castingTime: "1 standard action",
        range: "15 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "1 round/level or until discharged (see text)",
        savingThrow: "Reflex half (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Spear Of Purity",
        type: ["damage"],
        school: "evocation",
        tags: ["good"],
        longDesc: `You hurl a pure white or golden spear of light from your holy symbol, affecting any one target within range as a ranged touch attack. An evil creature struck by the spear takes 1d8 points of damage per two caster levels (maximum 5d8). An evil outsider instead takes 1d6 points of damage per caster level (maximum 10d6) and is blinded for 1 round. A successful Will save reduces the damage to half and negates the blinded effect. This spell deals only half damage to creatures that are neither evil nor good, and they are not blinded. The spear has no effect on good creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "spear-shaped projectile of good energy",
        targets: "",
        duration: "instantaneous (1 round)",
        savingThrow: "Will partial (see text)",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Spiritual Weapon",
        type: ["damage"],
        school: "evocation",
        tags: ["force"],
        longDesc: `A weapon made of force appears and attacks foes at a distance, as you direct it, dealing 1d8 force damage per hit, + 1 point per three caster levels. You can choose for the weapon to have a crit range of 18-20 x2, 19-20 x3, or x4. It strikes the opponent you designate, starting with one attack in the round the spell is cast and continuing each round thereafter on your turn. It uses your base attack bonus (possibly allowing it multiple attacks per round in subsequent rounds) plus your mental modifier as its attack bonus. It strikes as a spell, not as a weapon. It does not get a flanking bonus or help a combatant get one. Your feats or combat actions do not affect the weapon. If the weapon goes beyond the spell range, if it goes out of your sight, or if you are not directing it, the weapon returns to you and hovers. Each round after the first, you can use a move action to redirect the weapon to a new target. If you do not, the weapon continues to attack the previous round's target. On any round that the weapon switches targets, it gets one attack. Subsequent rounds of attacking that target allow the weapon to make multiple attacks if your base attack bonus would allow it to. Even if the spiritual weapon is a ranged weapon, use the spell's range, not the weapon's normal range increment, and switching targets still is a move action. A spiritual weapon cannot be attacked or harmed by physical attacks, but dispel magic, disintegrate, a sphere of annihilation, or a rod of cancellation affects it. A spiritual weapon's touch AC is 12. If an attacked creature has spell resistance, you make a caster level check against that spell resistance the first time the spiritual weapon strikes it. If the weapon is successfully resisted, the spell is dispelled. If not, the weapon has its normal full effect on that creature for the duration of the spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "magic weapon of force",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Spontaneous Immolation",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `You point your finger at a creature, causing it to spontaneously burst into flame. The target takes 3d6 points of fire damage, receives 1 immolation, and catches on fire. A successful Fortitude save reduces this damage by half and prevents the target from catching on fire or taking the immolation. Each round at the start of the creature's turn it continues to burn. A burning target can attempt a new save to extinguish the flames (DC equal to the DC of the spell); otherwise it takes another 2d6 fire damage and gives 1 immolation stack (see burning citadel discipline info). Every 5 caster levels, the immolation if it fails the fortitude save increases by 1.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "Fortitude half and Reflex (see description)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Stone Discus",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["earth"],
        longDesc: `You create a stone discus, which flies at an enemy. You can create one discus, plus one additional discus at 5th and 9th caster levels. For each discus you create, you decide whether its edge is blunt (and deals bludgeoning damage) or sharp (and deals slashing damage). Each discus requires a ranged attack to hit and deals 4d6 points of damage. The discuses can be launched at more than one target, but all must be aimed at targets within 30 feet of each other and launched simultaneously. At caster level 5th, the discuses count as magic and silver. At caster level 10th, they also count as cold iron. At caster level 15th, they also count as adamantine. The damage of this spell scales with acid spell power.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one or more stone discuses",
        targets: "",
        duration: "Instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Storm of Blades",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You create floating swords of the type used as the material component for this spell (such as a rapier or scimitar) and magically propel them at your target. You can create one sword for every 2 caster levels that you possess, up to a maximum of five swords at 10th level. You must have line of effect between you and the target, and the target must be within the spell's range. You make a ranged attack roll for each sword (with no penalties for range increments or using melee weapons as ranged weapons); each attack has the same threat range and critical modifier and deals the same damage as a standard sword of the type expended. Swords created by this spell disappear after striking (or missing) their targets.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Telekinetic Volley",
        type: ["damage"],
        school: "transmutation",
        tags: [],
        longDesc: `When you cast this spell choose one throwing weapon you have, or an object within reach, and then once per round you can launch that object as a standard action, if its a thrown weapon its range incriment is 20 feet, otherwise its 10 feet. you take a -4 penalty to attack for using not throwing weapons with this spell. The attack roll can use your level instead of base attack bonus and highest mental stat instead of dexterity for attack and damage.`,
        castingTime: "1 standard action",
        range: "Touch",
        area: "",
        effect: "",
        targets: "up to one touched object per level weighing up to 5 pounds or a thrown weapon",
        duration: "1 round/level or until discharged (D)",
        savingThrow: "none",
        spellResistance: "no (object)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Thunderclap",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `With a clap of your hands you emit a jolt of electricity from your space in all directions, all creatures within 10 feet of you must make a reflex save or take 1d4 electricity damage per 2 caster levels (max 5d4).`,
        castingTime: "1 swift action",
        range: "10 ft",
        area: "10ft radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "S",
        },
        {
            level: "2",
            name: "Electric Chain",
            type: ["damage"],
            school: "evocation",
            tags: ["electricity"],
            longDesc: `You cause a chain of electricity to appear between you and another creature. When you cast this spell, the target makes a reflex saving throw, if they fail, the chain connects. At the end of each of your turns they suffer 2d6 electricity damage as long as you are within 20 feet of them. Each time this deals damage, further damage increases by 1d6 to a maximum of 6d6.`,
            castingTime: "standard",
            range: "close (25ft. + 5ft./2levels)",
            area: "",
            effect: "",
            targets: "1 creature",
            duration: "1 round/2 levels",
            savingThrow: "reflex negates",
            spellResistance: "yes",
            components: "V,S,M",
        },
        {
        level: "2",
        name: "Wazzup's Blowup",
        type: ["damage"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `You unleash a devastating scream at a target, dealing 1d12 sonic damage (no save, maximum 2d12 per caster level), creatures within 5ft of the target must make a fortitude save or receive half damage. Each round you can continue to concentrate on the spell as a movement action, doing so increases the damage by an additional 1d12 and the radius by 5ft. You can also change the target of this spell and continue concentrating on it as a standard action. Additionally, each round you concentrate you receive a +2 bonus on concentration checks to continue the spell. While the spell is active you suffer a 20% spell failure chance on other spells that include a verbal component, plus an additional 5% for each round you spent concentrating, however, your spells you cast with a verbal component have their DC increased by +1 for every 2 rounds spent concentrating against creatures that were damaged by this spell within the last 1 round. Double this bonus for language dependant spells.`,
        castingTime: "1 standard action",
        range: "close (25ft. +5ft./2 levels)",
        area: "5ft radius burst (see text)",
        effect: "",
        targets: "1 creature",
        duration: "concentration (max 1 round/level)",
        savingThrow: "fortitude partial (see text)",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "2",
        name: "Death Knell",
        type: ["damage", "buff"],
        school: "necromancy",
        tags: ["death", "evil"],
        longDesc: `You draw forth the ebbing life force of a creature and use it to fuel your own power. Upon casting this spell, you touch a living creature that has -1 or fewer hit points. If the subject fails its saving throw, it dies, and you gain 1d8 temporary hit points and a +2 enhancement bonus to Strength. Additionally, your effective caster level goes up by +1, improving spell effects dependent on caster level. This increase in effective caster level does not grant you access to more spells. These effects last for 10 minutes per HD of the subject creature.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "instantaneous/10 minutes per HD of subject; see text",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Defensive Shock",
        type: ["damage", "buff"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `Electrical energy floods your body, shocking the next creature that touches you. Any creature striking you with its body or a handheld weapon takes 1d6 points of electricity damage per two caster levels (maximum 6d6). If the attacker has spell resistance, it applies against this damage. Each time the spell discharges, the number of damage dice it deals is halved (rounded down); when the spell's damage dice reach 0, the spell ends.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level or until discharged",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Fiery Runes",
        type: ["damage", "buff"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `You charge a weapon with a magic rune of fire. When the wielder of the weapon successfully strikes a foe in melee with the weapon, the wielder can discharge the rune as a swift action to deal 1d4+1 points of fire damage to the target. This damage isn't multiplied on a critical hit. If the target has spell resistance, you attempt a caster level check (1d20 + caster level) against that spell resistance when the rune is discharged. If the rune is successfully resisted, the spell is dispelled; otherwise, the rune deals damage normally. For every 2 caster levels beyond 3rd the caster possesses, the rune deals an additional 1d4+1 points of fire damage (2d4+2 at caster level 5th, 3d4+3 at 7th, and so on) to a maximum of 5d4+5 points of fire damage at caster level 11th.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "melee weapon touched",
        duration: "1 minute/level or until discharged (see text)",
        savingThrow: "none",
        spellResistance: "yes (see text)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Fire's Friend",
        type: ["damage", "buff"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `You cloak yourself in flames that do not harm you or your carried equipment but damage other creatures and objects. The flames cast light as a torch. Any creature that attacks you with a non-reach melee weapon or that begins its turn engaged in a grapple with you takes 1d6 points of fire damage and must succeed at a Reflex save or catch fire. The creature can negate the damage (and avoid catching fire) with spell resistance.
        \nAny time you end your movement in the same square as a flammable object or creature, that creature or object must succeed at a Reflex save or catch fire.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Short Circuit",
        type: ["damage", "control"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You fire a bolt of electricity from your hand, striking a target within range. This deals 1d6 points of electricity damage per 2 caster levels (max 5d6). The target can make a reflex saving throw to halve the damage, however on failure, as long as it also took electricity damage from this spell, it must also make a will save at the same dc +2, or it becomes dazed for 1d2 rounds, or until it is damaged. Once the bolt strikes the creature you can aim it at a new target within the original range of the new target -20 feet. You can keep firing it at new creatures as long as you still have range left, however you can never hit the same target twice. Each target past the first, the DC lowers by 2.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "1 bolt of lightning",
        targets: "",
        duration: "instantaneous",
        savingThrow: "reflex half and will",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "2",
        name: "Sound Burst",
        type: ["damage", "control"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `You blast an area with a tremendous cacophony. Every creature in the area takes 1d8 points of sonic damage and must succeed on a Fortitude save to avoid being stunned for 1 round. Creatures that cannot hear are not stunned but are still damaged.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "10-ft.-radius spread",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, F,DF,",
        },
        {
        level: "2",
        name: "Stone Call",
        type: ["damage", "control"],
        school: "conjuration(creation)",
        tags: ["earth"],
        longDesc: `A rain of dirt, gravel, and small pebbles fills the area, dealing 2d6 points of bludgeoning damage to every creature in the area. This damage only occurs once, when the spell is cast. For the remaining duration of the spell, this debris covers the ground, making the entire area difficult terrain. At the end of the duration, the rocks disappear, leaving no aftereffects (other than the damage dealt).`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "cylinder (40-ft. radius, 20 ft. high)",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Tar Ball",
        type: ["damage", "control"],
        school: "transmutation",
        tags: [],
        longDesc: `You create a sticky ball of burning tar that you can hurl at your enemies as a ranged attack. If the tar ball strikes, it deals 1d4 points of fire damage + your Strength modifier, and splashes the target with hot, sticky tar. The tar deals 1d4 points of fire damage each round on the creature's turn for the next 1d4 rounds and gives the target a -2 penalty to Dexterity for that duration. If desired, the target can use a full-round action to attempt to extinguish or cool the tar before taking this additional damage. Extinguishing or cooling the tar requires a DC 15 Reflex save or at least 1 gallon of nonflammable liquid. Rolling on the ground provides the target a +2 bonus on the save. Leaping into a lake or magically cooling the target automatically ends the effect.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "ranged attack",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M, ",
        },
        {
        level: "2",
        name: "Arrow Eruption",
        type: ["damage", "utility"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You create exact duplicates of the arrow or crossbow bolt you used to kill a creature in the previous round and launch one at enemy creatures within a 30-foot radius of the corpse. You can target one creature per caster level (maximum 15) within range of the burst and must make a single attack roll and apply it to each arrow. These duplicate arrows possess all the intrinsic magical properties of the arrow that killed the original creature as well as those passed on to it by your bow. They also enjoy the full benefit of any bonuses or modifiers you applied to the attack from other magical items, feats, and class or racial features. However, this spell cannot reproduce any spells or other limited-use magical effects that you used to enhance that particular attack. This includes such effects as the true strike spell, as well as any area spell you might have placed on the arrow by means of the arcane archer's imbue arrow class feature.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "30-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Boneshaker",
        type: ["damage", "utility"],
        school: "necromancy",
        tags: [],
        longDesc: `By using a bone fetish like a marionette, you take control of a target creature's skeleton. This has a variety of effects depending on whether the target is living or undead. A living creature has its skeleton rattle within its flesh, causing it grievous harm. The target takes 3d6 points of damage, plus 1d6 additional points of damage per 2 caster levels you have. In addition, you can move the target 5 feet. This movement doesn't provoke attacks of opportunity. A successful saving throw halves the damage and negates the movement. An undead creature takes no damage. Instead, you manipulate the undead, forcing it to take an immediate action to either move up to its speed (provoking attacks of opportunity as normal) or make a single attack against a creature of your choice in its reach. Either of these is the most basic version of the action the creature can take (it doesn't activate any special abilities that it could apply to the movement or attack, such as grab). A successful saving throw negates this effect. A mindless undead creature doesn't receive a save against this effect.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one living creature or undead creature with a skeleton",
        duration: "instantaneous",
        savingThrow: "Fortitude partial or negates (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Abeyance",
        type: ["healing"],
        school: "abjuration",
        tags: [],
        longDesc: `Abeyance suppresses the effects of a single curse on a creature. It does not restore any damage or drain that might have been caused by the curse. Abeyance cannot suppress curses that cannot be removed by remove curse, but it can suppress curses such as lycanthropy that require remove curse along with additional measures. An individual curse can be suppressed only once by abeyance, even if cast by a different caster. Abeyance does not allow a creature to divest itself of cursed objects, though it can suppress a curse contracted from an object.`,
        castingTime: "1 minute",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "24 hours",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Blood Of the Martyr",
        type: ["healing"],
        school: "necromancy",
        tags: [],
        longDesc: `You cause the target to bleed from every orifice, and her organs and blood become suffused with positive energy. If the subject fails her Fortitude save, she takes 1d6 points of bleed damage per 4 caster levels (to a maximum of 4d6 at 16th level) when you cast this spell. Any creature that takes a full-round action to sup the blood of the bleeding subject heals a number of hit points equal to twice as many as the subject lost that round due to the bleed effect. The subject must be willing or helpless to sup her blood, which provokes attacks of opportunity. Only one creature can be healed in this way per round. The subject can lick her own wounds in this way to regain half as many hit points as she lost that round. If the bleeding effect is stopped or the spell's duration ends, the subject's blood no longer heals those who drink it, though in the latter case the subject continues to bleed until the bleeding is stopped via magical healing or a successful DC 15 Heal check.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round/level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Comforting Touch",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell swiftly channels positive into your touch to heal a living ally, restoring 1d4 + 1 per 2 levels (maximum +5) points of damage.`,
        castingTime: "1 swift action",
        range: "touch",
        area: "",
        effect: "",
        targets: "ally touched",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless) or Will half, see text",
        spellResistance: "yes (harmless) or yes, see text",
        components: "V, S",
        },
        {
        level: "2",
        name: "Cure Moderate Wounds",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell functions like cure light wounds, except that it cures 3d8 points of damage + 1 point per caster level (maximum +10).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will half (harmless); see text",
        spellResistance: "yes (harmless); see text",
        components: "V, S, ",
        },
        {
            level: "3",
            name: "Cure Serious Wounds",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `This spell functions like cure light wounds, except that it cures 5d8 points of damage + 1 point per caster level (maximum +10).`,
            castingTime: "1 standard action",
            range: "touch",
            area: "",
            effect: "",
            targets: "creature touched",
            duration: "instantaneous",
            savingThrow: "Will half (harmless); see text",
            spellResistance: "yes (harmless); see text",
            components: "V, S, ",
        },
        {
        level: "2",
        name: "Delay Disease",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `The target becomes temporarily immune to disease. Any disease to which it is exposed during the spell's duration does not affect the target until the spell's duration has expired. If the target is currently infected with a disease, you must make a caster level check against the disease's DC to suspend it for the duration of the spell; otherwise, that disease affects the target normally. Delay disease does not cure any damage a disease may have already done.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 day",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Delay Pain",
        type: ["healing"],
        school: "enchantment",
        tags: ["emotion"],
        longDesc: `You override the target's ability to feel pain. Pain effects (such as pain strike** and symbol of pain) do not affect the target until this spell's duration has expired. This does not negate any physical damage, ability damage, or ability drain that a pain effect has already done, but it does negate ongoing penalties from pain while the spell lasts.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 hour/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Delay Poison",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `The subject becomes temporarily immune to poison. Any poison in its system or any poison to which it is exposed during the spell's duration does not affect the subject until the spell's duration has expired. Delay poison does not cure any damage that poison may have already done.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 hour/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Life Pact",
        type: ["healing"],
        school: "necromancy",
        tags: [],
        longDesc: `You bind the life forces of the targets into a mystical pact. If any target is reduced to fewer than 0 hit points, that target automatically triggers the power of the pact. The triggering target drains 1 hit point from all other targets that have at least 1 hit point and are within 30 feet of the triggering target; these hit points are applied to the triggering target as magical healing. This healing can prevent the triggering creature from dying, if the attack would cause the target to have a number of negative hit points equal to its Constitution score. This healing cannot raise the triggering creature above 1 hit point; any excess hit points drained from other targets are wasted. The pact can be triggered once per round. It's not triggered by death effects or effects that do not deal hit point damage.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one willing living creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Litany of Duty",
        type: ["healing"],
        school: "abjuration",
        tags: ["lawful"],
        longDesc: `You repeat a mantra or phrase that reminds you of your duty. You can immediately reroll a failed saving throw against a spell that would force you to take an action against your will, and you gain a +2 bonus against enchantment effects for 1 round. You can use this spell to reroll only a saving throw that you failed within the past round. While subject to this spell, the target cannot be the target of another spell that has the word “litany” in the title.`,
        castingTime: "1 immediate action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Litany of Perseverance",
        type: ["healing"],
        school: "abjuration",
        tags: [],
        longDesc: `With a powerful word of encouragement, you call upon your allies to get to their feet and prepare for combat. The target may use an immediate action to stand up from prone without provoking attacks of opportunity.`,
        castingTime: "1 swift action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one willing creature that is prone",
        duration: "instantaneous",
        savingThrow: "no",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Martyr's Bargain",
        type: ["healing"],
        school: "transmutation",
        tags: ["good"],
        longDesc: `You cast this spell as an immediate action when you are subject to a spell or spell-like ability that deals hit point damage, after attack rolls and saving throws have been rolled but before the damage itself is determined. The damage dealt by the spell and any related effects are then delayed for you (and you only) for a number of rounds equal to your caster level. At the end of that time (or immediately if martyr's bargain is dispelled), the delayed damage takes effect on you as it would have at the time it was cast, but is maximized as if affected by the Maximize Spell metamagic feat. Spells and spell-like abilities that were already maximized gain no additional benefit from this spell. Nothing can prevent this delayed damage from affecting you. You can be affected by only one martyr's bargain spell at a time. If you cast this spell while you are already under the effects of a previous martyr's bargain, the previous spell effect ends and you immediately take the damage it had delayed.`,
        castingTime: "1 immediate action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, ",
        },
        {
        level: "2",
        name: "Path Of Glory",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You cause four 5-foot squares (one of which must be your space) to glow with dim illumination. Starting on your next turn, as a swift action you can extend the glowing area by an additional four 5-foot squares; each new square must be adjacent to a square that was previously glowing. Allies that end their turns on a glowing square (including one who falls unconscious in the square) are healed of 1 point of damage.`,
        castingTime: "1 standard action",
        range: "touch (see text)",
        area: "four 5-ft. squares/level (see text)",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Recentering Drone",
        type: ["healing"],
        school: "abjuration",
        tags: [],
        longDesc: `You emit a calming subsonic drone that allows the targets to temporarily refocus and restore their balance when they're suffering from debilitating conditions. A target with the dazzled, fatigued, shaken, or sickened condition ignores the penalties of those conditions for the duration of this spell. A target with one of the following conditions is treated as having the associated lesser condition for the duration of the spell, as shown by the following table. Condition Lesser Condition Blinded Dazzled Exhausted Fatigued Frightened Shaken Nauseated Sickened At the end of the spell's duration, the targets are again subject to the appropriate penalties if the original conditions affecting the target are still in effect.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/2 levels (no two of which may be more than 30 ft. apart)",
        duration: "concentration",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Reinvigorating Wind",
        type: ["healing"],
        school: "enchantment(compulsion)",
        tags: ["air", "mind-affecting"],
        longDesc: `You exhale deeply, creating a gentle magical wind that invigorates any allies in the affected area, as follows. Any sleeping allies immediately wake up. Fascinated allies are shaken free of the fascinate effect. Flat-footed allies no longer count as flat-footed even if they have not acted yet. The duration of effects that cause any allies to be confused, frightened, paralyzed, slowed, or stunned is decreased by 1d4 rounds (roll separately for each target). If the duration of any such effect is reduced to 0 rounds or fewer, the effect ends for that ally. Finally, any allies lying prone may stand up as an immediate action, provoking attacks of opportunity as normal.`,
        castingTime: "1 standard action",
        range: "30 ft",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes(harmless)",
        components: "V, S, M",
        },
        {
        level: "2",
        name: "Remove Paralysis",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You can free one or more creatures from the effects of temporary paralysis or related magic, including spells and effects that cause a creature to gain the staggered condition. If the spell is cast on one creature, the paralysis is negated. If cast on two creatures, each receives another save with a +4 resistance bonus against the effect that afflicts it. If cast on three or four creatures, each receives another save with a +2 resistance bonus. The spell does not restore ability scores reduced by penalties, damage, or drain.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "up to four creatures, no two of which can be more than 30 ft. apart",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Restoration, Lesser",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `Lesser restoration dispels any magical effects reducing one of the subject's ability scores or cures 1d4 points of temporary ability damage to one of the subject's ability scores. It also eliminates any fatigue suffered by the character, and improves an exhausted condition to fatigued. It does not restore permanent ability drain.`,
        castingTime: "1 Round",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Soothing Word",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `The target of this spell causes several conditions that he suffers from to be lessened in severity one step. If he is nauseated, he is instead sickened. If he is stunned, he is instead dazed. If he is exhausted, he is fatigued. If he is frightened, he is shaken. If he is paralyzed, he is staggered. The duration of the effect is unchanged; the effect is simply reduced to the lesser version. This spell has no effect on conditions not listed above.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Stalwart Resolve",
        type: ["healing"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `The recipient of this spell ignores the effects of ability damage and penalties to a single ability score of your choice, except that damage equal to or greater than the ability score still causes unconsciousness or death. This applies whether or not the ability damage or penalty happened before or during the spell's duration, and whether or not multiple sources are involved. This spell has no effect on ability drain.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Suppress Charms and Compulsions",
        type: ["healing"],
        school: "abjuration",
        tags: [],
        longDesc: `You bolster the subject's sense of willpower and self-worth when you cast this spell. As you cast it, you must decide if you want to grant a bonus to saving throws against charms and compulsions or suppress charms and compulsions. If you grant a bonus to saving throws, you grant all affected creatures a +4 morale bonus on saving throws against charm and compulsion effects for 10 minutes. If instead you suppress charms and compulsions, the spell's duration drops to concentration, to a maximum duration of 1 round per level. As long as you continue to concentrate, the spell suppresses all existing charm and compulsion effects affecting the targets, regardless of whether the effect is beneficial or harmful. New charm or compulsion effects that successfully target such a protected creature are automatically suppressed as long as you continue concentrating. If you cease concentrating, the spell effect immediately ends, and remaining charm or compulsion effects resume for the rest of their remaining durations as normal.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature plus one additional creature per 4 levels, no two of which can be more than 30 ft. apart",
        duration: "10 minutes or concentration (up to 1 round/level); see text",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Surmount Affliction",
        type: ["healing"],
        school: "abjuration",
        tags: [],
        longDesc: `You temporarily overcome one harmful condition. This does not end the effect causing the condition; it just suspends that condition's effect for the duration of the spell. You can surmount any one of the following conditions: blinded, confused, dazed, dazzled, deafened, fatigued, frightened, paralyzed, shaken, or sickened.`,
        castingTime: "1 standard action",
        range: "you",
        area: "",
        effect: "",
        targets: "personal",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Word of Healing",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You empower your words with positive energy, causing them to imbue an creature within range for 1d8 + 1 point per caster level (maximum +5) of positive energy, healing living creatures and damaging undead. An undead creature can apply spell resistance, and can attempt a Will save to take half damage.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 level)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless) or Will half, see text",
        spellResistance: "yes (harmless) or yes, see text",
        components: "V, S",
        },
        {
        level: "2",
        name: "Air Step",
        type: ["utility"],
        school: "transmutation",
        tags: ["air"],
        longDesc: `This spell functions as air walk, except you can rise no higher than 1 foot off the ground, you cannot pass over liquid, and the air you walk on is less stable than solid ground. When walking on air, you ignore difficult terrain that is less than 1 foot high, you do not trigger effects based on weight (such as a pressure plate), and any creature trying to track you through areas you crossed with this spell takes a -10 penalty on its Perception or Survival check to do so. However, because of the instability of the air you walk on, your speed is reduced by 10 feet (to a minimum of 5 feet) and you take a -4 penalty on Acrobatics, Climb, and Ride checks. If you have 1 rank in Fly, your speed is not reduced when using this spell, and you can cross over liquid at half speed. If you have 5 ranks in Fly, you can cross liquid at full speed and do not take the penalties to your skill checks.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Alter Summoned Monster",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `You swap a creature summoned by a conjuration (summoning) spell for a creature you could summon with a summon monster or summon nature's ally spell. The new creature must be an option from a spell of the same level or lower as the spell that summoned the target. The new creature cannot be summoned into an environment that cannot support it. The target can attempt a Will saving throw to negate this effect, but if the target is under your control, it receives no saving throw. Alter summoned monster does not alter the duration of the spell that summoned the target, nor does it affect any additional creatures summoned by the same spell as the target. The new creature has the same conditions and amount of damage as the target creature, and remains affected by all curses, diseases, poisons, and penalties that affected the target, but no other spells or effects carry over. Alter summoned monster is a spell of the same alignment type or types as the creature for which you exchange the target. An eidolon can't be targeted by this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./ 2 levels)",
        area: "",
        effect: "",
        targets: "one summoned creature",
        duration: "instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Aquatic Cavalry",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `You summon a school of hippocampi (one plus one per 3 caster levels; https://www.d20pfsrd.com/bestiary/monster-listings/magical-beasts/hippocampus/) to serve as combat-trained mounts.`,
        castingTime: "1 round",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "1 hippocampus plus 1 hippocampus/3 caster levels",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Climbing Beanstalk",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You cause a thick, sturdy beanstalk to sprout from the ground and grow upward to a height of 10 feet + 5 feet per 2 caster levels. The growing stalk anchors itself to sturdy objects such as walls or ceilings, and grows around objects that do not fully obstruct its square (such as tree branches), but is stopped by solid obstacles. The beanstalk provides numerous hand- and footholds; its climb DC 5. The beanstalk can support up to 200 pounds plus 50 pounds per caster level, or double that amount if anchored on its upper end. If it anchors itself to a sturdy mobile object (such as a ship or a siege engine), breaking the object free requires a DC 23 Strength check or cutting through the beanstalk (hardness 2, 40 hp). If the ground is capable of supporting plant life, the beanstalk continues to live as a normal plant, and it produces nutritious (if unappetizing) beans. Otherwise, the plant dies after 1d6 hours; its husk remains as durable as a small tree.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "5-ft. square of climbable beanstalks",
        targets: "",
        duration: "instantaneous",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        // {
        // level: "2",
        // name: "Dark Whispers",
        // type: ["utility"],
        // school: "illusion(shadow)",
        // tags: ["language-dependent", "shadow"],
        // longDesc: `You communicate through the shadows of one or more targets within range. The shadows have no physical presence and don't move or animate. Instead, your words emerge from the shadow as a clear whisper, absent any accent or other identifying features. The targets can make conversation with the shadow, but must speak aloud to do so. The targets' voices emerge from your own shadow only when they intend to speak to the shadow, but you hear no other sounds from the target's immediate area. Their responses also emerge as clear whispers, absent identifying features, but you can instinctively identify which target is speaking to you through the shadow. Once the spell has been cast, you don't need to have line of effect to the targets or their shadows to communicate back and forth. The shadow communication is audible, so it can be intercepted by adversaries who succeed at a DC 25 Perception check. The spell can be silenced. You can't cast spells on subjects or otherwise establish line of effect through the shadows, but spells that allow you to speak or understand languages work normally across dark whispers.`,
        // castingTime: "1 standard action",
        // range: "long (400 ft. plus 40 ft./level)",
        // area: "",
        // effect: "",
        // targets: "one creature/level",
        // duration: "10 minutes/level (D)",
        // savingThrow: "none",
        // spellResistance: "yes",
        // components: "V, S, DF,",
        // },
        {
        level: "2",
        name: "Darkvision",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `The subject gains the ability to see 60 feet even in total darkness. Darkvision is black and white only but otherwise like normal sight.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 hour/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Death Candle",
        type: ["utility"],
        school: "necromancy",
        tags: ["death", "evil", "fire"],
        longDesc: `This spell functions like death knell, except instead of using the slain target's life energy to enhance yourself, you use it to summon a Small fire elemental resembling a burning, howling version of the slain creature. The elemental acts immediately on your turn and otherwise behaves as if you had summoned it with summon monster II. The elemental remains for a number of rounds equal to the Hit Dice of the slain creature.`,
        castingTime: "1 round",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "instantaneous/10 minutes per HD of subject; see text",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Desecrate",
        type: ["utility"],
        school: "evocation",
        tags: ["evil"],
        longDesc: `This spell imbues an area with negative energy. The DC to resist negative channeled energy within this area gains a +3 profane bonus. Every undead creature entering a desecrated area gains a +1 profane bonus on all attack rolls, damage rolls, and saving throws. An undead creature created within or summoned into such an area gains +1 hit points per HD. If the desecrated area contains an altar, shrine, or other permanent fixture dedicated to your deity or aligned higher power, the modifiers given above are doubled (+6 profane bonus to negative channeled energy DCs, +2 profane bonus and +2 hit points per HD for undead created in the area). Furthermore, anyone who casts animate dead within this area may create as many as double the normal amount of undead (that is, 4 HD per caster level rather than 2 HD per caster level). If the area contains an altar, shrine, or other permanent fixture of a deity, pantheon, or higher power other than your patron, the desecrate spell instead curses the area, cutting off its connection with the associated deity or power. This secondary function, if used, does not also grant the bonuses and penalties relating to undead, as given above. Desecrate counters and dispels consecrate.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "20-ft.-radius emanation",
        effect: "",
        targets: "",
        duration: "2 hours/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Detect Magic, Greater",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `This spell functions as detect magic, except that you can glean much more information from the magical auras that you find, and those auras can be found after a much greater length of time. You can detect a lingering aura for up to 1 day per caster level you have, regardless of the aura's original strength. Additionally, when you use a standard action to concentrate on this spell, you can also study a creature within the spell's area and attempt a Spellcraft check in order to determine the last spell that the creature cast by identifying lingering traces that the spell left in the caster's aura. The DC to identify the spell is equal to 20 + the creature's caster level. Finally, you are able to locate and analyze the signature flourishes in a magical aura that allow you to match a spell to the person who cast it. In order to find these identifiers in a spell's aura, you must spend 1 round focusing on that spell in particular, and succeed at an opposed Knowledge (arcana) check against the caster (or a Knowledge [arcana] check with a DC equal to 15 + the spell level if the caster wants her work to be identified and emphasizes these unique elements rather than obscuring them). Once you learn a caster's set of identifiers, you can remember them as easily as a face or a voice. You can recognize this signature if you succeed at a Spellcraft check when later identifying a spell to determine whether or not that spell was cast by the same individual. The spell greater magic aura (see page 219) can obfuscate this information, making it seem that someone else cast the spell. Greater detect magic grants a saving throw against magic aura (but not greater magic aura).`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "cone-shaped emanation",
        effect: "",
        targets: "",
        duration: "concentration, up to 1 minute/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Eagle Eye",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `Eagle eye creates a magical sensor directly above you. The sensor can appear anywhere above you, to a maximum height equal to the spell's range. You can see from this vantage as if you were actually there, rotating your viewpoint 360 degrees. You perceive with your normal visual senses. A caster using eagle eye can easily see for a considerable distance. The spell does not penetrate any solid surface, although it is unaffected by foliage and the like. It also is able to see through darkness, even magical darkness and smoke up to 60 feet.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "magical sensor",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Eldritch Conduit",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `If the target of this spell fails to resist its effects with a Will save, he becomes outlined in faint radiance, as if via faerie fire. At any time before the eldritch conduit expires, you may cast another spell with an area effect of cone, cylinder, line, or sphere and use the subject of the eldritch conduit as the point of origin for that spell. Doing so ends the spell immediately. The target must be within close range (25 feet + 5 feet/2 levels) in order for you to use the conduit-if the target moves out of range, the eldritch conduit effect persists but cannot be utilized by you until you get back within range.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Force Sword",
        type: ["utility"],
        school: "evocation",
        tags: ["force"],
        longDesc: `You create a +1 longsword of pure force sized appropriately for you that you can wield or give to another creature like any other longsword. At 8th level, the sword functions as a +2 longsword. At 13th level, it functions as a +3 longsword. A force sword cannot be attacked or harmed by physical attacks, but dispel magic, disintegrate, a sphere of annihilation, or a rod of cancellation affects it. If a creature you attack with the sword has spell resistance, you must attempt a caster level check (1d20 + your caster level) against that spell resistance the first time the force sword strikes it. If you fail the check, the spell is dispelled. If you succeed, the weapon has its normal full effect on that creature for the duration of the spell.`,
        castingTime: "1 standard action",
        range: "0 ft.",
        area: "",
        effect: "one sword-shaped weapon of force",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Groundswell",
        type: ["utility"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `This spell allows the target to cause the ground to rise up beneath him. As a swift action, the target can cause the ground to rise 5 feet, while all adjacent squares are treated as steep slopes (Core Rulebook 428). The groundswell precludes flanking from creatures standing at lower elevations than the target. If the target moves after creating a groundswell, the ground returns to its normal elevation at the end of his turn; otherwise, it remains in place until the target moves or uses a swift action to return the ground to normal. A groundswell cannot increase elevation of the ground beyond 5 feet.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Holy Ice Weapon",
        type: ["utility"],
        school: "transmutation",
        tags: ["cold", "good", "water"],
        longDesc: `You create a masterwork weapon that has the qualities of ice and holy water. This weapon must be a common, rare or epic weapon. The weapon deals normal damage for a weapon of that type, plus 1 point of cold damage per caster level (maximum 10). In addition, any creature struck by the weapon is also hit by holy water, dealing 1d4 points of damage if the creature is susceptible to holy water. If the weapon leaves your hands for more than 1 round, it melts and the spell ends. At caster level 6th, the weapon gains the returning weapon special ability when thrown, melting away after an attack and re-forming in your hand just before your next turn.`,
        castingTime: "1 standard action",
        range: "0 ft.",
        area: "",
        effect: "one ice weapon",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Instant Armor",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: ["force"],
        longDesc: `You instantly wrap your body in a suit of armor made from opaque force. At your option, the armor can be decorated with your religion's holy symbol in a prominent place, such as upon the breastplate or helm. While it exists, this armor replaces any garments or other sort of armor worn, magical as well as mundane. You lose access to, and all benefits from, armor replaced by this spell until the spell ends and the instant armor disappears. Instant armor acts in all ways as armor typical of its type (armor bonus, maximum Dexterity bonus, arcane spell failure chance, and so on). Since instant armor is made of force, incorporeal creatures can't bypass it the way they do normal armor. The sort of armor you can create with this spell depends on your caster level. Caster Level Armor Created 5th or lower chainmail 6th-8th banded mail 9th-11th half-plate 12th or higher full plate If you choose to create lesser armor than your level allows you gain a +1 magical enhancement bonus to the armor you do create for every type of armor you pass over. For instance, if you have the capacity to create full plate instant armor you could instead choose to create +1 half-plate, +2 banded mail, or +3 chainmail. You cannot replace these bonuses with armor special properties.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Instant Weapon",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: ["force"],
        longDesc: `You create a melee weapon sized appropriately for you from opaque force. You are considered proficient with this weapon, which acts in all ways as a masterwork weapon typical of its type. The instant weapon has hardness 20 and the same number of hit points as a typical weapon of its type. As a force effect, it can strike and damage incorporeal creatures. If the instant weapon leaves your hand at any time, the spell ends at the beginning of your next turn.`,
        castingTime: "1 standard action",
        range: "0 ft.",
        area: "",
        effect: "melee weapon of opaque force",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Levitate",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `Levitate allows you to move yourself, another creature, or an object up and down as you wish. A creature must be willing to be levitated, and an object must be unattended or possessed by a willing creature. You can mentally direct the recipient to move up or down as much as 20 feet each round; doing so is a move action. You cannot move the recipient horizontally, but the recipient could clamber along the face of a cliff, for example, or push against a ceiling to move laterally (generally at half its base land speed). A levitating creature that attacks with a melee or ranged weapon finds itself increasingly unstable; the first attack has a -1 penalty on attack rolls, the second -2, and so on, to a maximum penalty of -5. A full round spent stabilizing allows the creature to begin again at -1.`,
        castingTime: "1 standard action",
        range: "personal or close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "you or one willing creature or one object (total weight up to 100 lbs./level)",
        duration: "1 min./level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, F,",
        },
        {
        level: "2",
        name: "Minor Image",
        type: ["utility"],
        school: "illusion(figment)",
        tags: [],
        longDesc: `This spell functions like silent image, except that minor image includes some minor sounds but not understandable speech.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "visual figment that cannot extend beyond four 10-ft. cubes + one 10-ft. cube/level (S)",
        targets: "",
        duration: "concentration + 2 rounds",
        savingThrow: "Will disbelief (if interacted with)",
        spellResistance: "no",
        components: "V, S, F,",
        },
        {
        level: "2",
        name: "Miserable Pity",
        type: ["utility"],
        school: "abjuration",
        tags: ["emotion", "mind-affecting"],
        longDesc: `This spell functions as sanctuary, except creatures attempting to attack the target who fail their saves also feel a strong sense of pity toward the target, as if it were weak, pathetic, and not a threat. If the target breaks the spell by attacking, any creature that failed its save against the spell gains a +2 morale bonus on attack rolls against the target for 1 minute.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level and 1 minute; see text",
        savingThrow: "Will negates (see text)",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "2",
        name: "Pilfering Hand",
        type: ["utility"],
        school: "evocation",
        tags: ["force"],
        longDesc: `You create and control an invisible telekinetic force, manipulating it with either startling abruptness or careful deliberateness, allowing you to seize an object from an opponent or remotely manipulate an object. You can utilize this force to one of two ends. Abrupt Maneuver: You instantaneously attempt a disarm or steal combat maneuver against a target within range. Use your caster level as your Combat Maneuver Bonus, adding your highest mental stat in place of your Strength or Dexterity modifier. This combat maneuver attempt does not provoke an attack of opportunity from its target, but casting this spell might. If you are successful, you pull the target object to you, and if you have enough hands free, you can catch it. Otherwise, the object lands in your square as if you dropped it. Careful Maneuver: You attempt a Disable Device check or a Sleight of Hand check to pick-pocket a target within range. This spell lasts as long as you need to accomplish the task, requiring your full concentration for that duration. Once you resolve the skill check, the spell ends. If you are successful on your Sleight of Hand check, you pull the target object to you as with an abrupt maneuver. The target gains a +2 bonus on its Perception check to notice the successful attempt.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one object",
        duration: "see text",
        savingThrow: "none",
        spellResistance: "yes (object)",
        components: "S, ",
        },
        {
        level: "2",
        name: "Reloading Hands",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `Once per round, phantom hands load a single ranged weapon or firearm with conjured ammunition. This ammunition counts as magical for overcoming damage reduction and attacking incorporeal creatures, but is the standard for its type (a normal bullet or pellets and black powder in the case of firearms). Conjured ammunition ceases to exist 1 round after it is removed from the weapon, or at the end of the duration, whichever comes first.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "projectile weapon touched",
        duration: "1 round/caster level (D)",
        savingThrow: "Will negates (object, harmless)",
        spellResistance: "yes (object, harmless)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Retrieve Item",
        type: ["utility"],
        school: "conjuration(calling)",
        tags: [],
        longDesc: `You call a specific nonliving item directly to your hand from a nearby location. First, you must cast the spell on the item while holding it. Thereafter, you can summon the item by speaking a special word (set by you when the spell is cast) and snapping your fingers. The item appears instantly in your hand. If the item is in the possession of another creature, the spell fails.`,
        castingTime: "1 full round",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "an unattended object weighing 1 lb. or less whose longest dimension is 6 inches or less",
        duration: "permanent until discharged",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Returning Weapon",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `For the duration of the spell, the target weapon acts as if it had the returning weapon special ability, returning it to your hand at the end of the attack roll.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one weapon that can be thrown",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Ricochet Shot",
        type: ["utility"],
        school: "evocation",
        tags: [],
        longDesc: `You imbue a projectile weapon with the ability to ricochet any projectiles that hit one target so that they also hit another. When the wielder ricochets a projectile, she selects a primary target to attack. If she hits the primary target, the projectile ricochets instead of being destroyed. The wielder can then select a secondary target that is within 20 feet of the primary target. She makes an attack roll against the secondary target at the same base attack bonus, but does not gain the benefit from any enhancement bonuses or magic qualities on the projectile. If the shot comes from a firearm, the ricochet targets normal AC rather than touch AC. While the spell lasts, the target weapon's wielder can ricochet one projectile per three caster levels you possess, to a maximum of six at caster level 18th. Once the target weapon's wielder ricochets that many shots, the spell is discharged. If the weapon's wielder fails to use all the ricochets before the spell end, those ricochets are wasted.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one projectile weapon",
        duration: "1 round/level or until discharged",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "River Whip",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: ["water"],
        longDesc: `You create a coil of flowing fresh water, functioning a whip appropriate for your size, except you make a melee touch attack instead of a regular attack. Anything you strike with the whip takes damage and is doused with 1 pint of water. A creature with the fire subtype takes an additional 1d6 points of damage. If the target is on fire, it gains a +2 bonus on its next saving throw to extinguish the flames. After you have successfully used the whip to hit a creature a number of times equal to your caster level, the water is expended and the spell is discharged. The water created by this spell is otherwise identical to that produced by create water.`,
        castingTime: "1 standard action",
        range: "0 ft.",
        area: "",
        effect: "whip of water",
        targets: "",
        duration: "1 minute/level (D) or until discharged (see text)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "See Invisibility",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `You can see any objects or beings that are invisible within your range of vision, as well as any that are ethereal, as if they were normally visible. Such creatures are visible to you as translucent shapes, allowing you easily to discern the difference between visible, invisible, and ethereal creatures. The spell does not reveal the method used to obtain invisibility. It does not reveal illusions or enable you to see through opaque objects. It does not reveal creatures who are simply hiding, concealed, or otherwise hard to see.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Sense Fear",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `You sense the fear of those nearby, feeling it in the air around you. You can detect spooked, shaken, scared, frightened, panicked, terrified, and horrified creatures within 30 feet, and you immediately know what level of fear they are experiencing. You determine the creatures' approximate direction from you, though you do not sense a given creature's identity or know which squares the creatures occupy. If you're within 5 feet of a creature whose fear you sense, you pinpoint that creature's location, as if using blindsense.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 minutes/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Shatter",
        type: ["utility"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `Shatter creates a loud, ringing noise that breaks brittle, nonmagical objects; sunders a single solid, nonmagical object; or damages a crystalline creature. Used as an area attack, shatter destroys nonmagical objects of crystal, glass, ceramic, or porcelain. All such unattended objects within a 5-foot radius of the point of origin are smashed into dozens of pieces by the spell. Objects weighing more than 1 pound per your level are not affected, but all other objects of the appropriate composition are shattered. Alternatively, you can target shatter against a single solid nonmagical object, regardless of composition, weighing up to 10 pounds per caster level. Targeted against a crystalline creature (of any weight), shatter deals 1d6 points of sonic damage per caster level (maximum 10d6), with a Fortitude save for half damage.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "5-ft.-radius spread; or one solid object or one crystalline creature",
        effect: "",
        targets: "5-ft.-radius spread; or one solid object or one crystalline creature",
        duration: "instantaneous",
        savingThrow: "Will negates (object); Will negates (object) or Fortitude half; see text",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Silence",
        type: ["utility"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `Upon the casting of this spell, complete silence prevails in the affected area. All sound is stopped: Conversation is impossible, spells with verbal components cannot be cast, and no noise whatsoever issues from, enters, or passes through the area. The spell can be cast on a point in space, but the effect is stationary unless cast on a mobile object. The spell can be centered on a creature, and the effect then radiates from the creature and moves as it moves. An unwilling creature can attempt a Will save to negate the spell and can use spell resistance, if any. Items in a creature's possession or magic items that emit sound receive the benefits of saves and spell resistance, but unattended objects and points in space do not. Creatures in an area of a silence spell are immune to sonic or language-based attacks, spells, and effects.`,
        castingTime: "1 round",
        range: "long (400 ft. + 40 ft./level)",
        area: "20-ft.-radius emanation centered on a creature, object, or point in space",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "Will negates; see text or none (object)",
        spellResistance: "yes; see text or no (object)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Slipstream",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: ["water"],
        longDesc: `You create a low-cresting wave of water that carries the target along the surface of water or the ground. When moving across level ground, the target's speed increases by 10 feet. If going downhill, speed increases by 20 feet instead, but slipstream provides no movement bonus when going uphill. While swimming, the slipstream increases the target's swim speed by 20 feet-if the target does not have a swim speed, this spell grants a swim speed of 20 ft.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 minutes/level (D)",
        savingThrow: "Reflex negates (harmless)",
        spellResistance: "no",
        components: "V, S, M, DF",
        },
        {
        level: "2",
        name: "Spectral Hand",
        type: ["utility"],
        school: "necromancy",
        tags: [],
        longDesc: `A ghostly hand shaped from your life force materializes and moves as you desire, allowing you to deliver low-level, touch range spells at a distance. On casting the spell, you lose 1d4 hit points that return when the spell ends (even if it is dispelled), but not if the hand is destroyed. (The hit points can be healed as normal.) For as long as the spell lasts, any touch range spell of 4th level or lower that you cast can be delivered by the spectral hand. The spell gives you a +2 bonus on your melee touch attack roll, and attacking with the hand counts normally as an attack. The hand always strikes from your direction. The hand cannot flank targets like a creature can. After it delivers a spell, or if it goes beyond the spell range or goes out of your sight, the hand returns to you and hovers. The hand is incorporeal and thus cannot be harmed by normal weapons. It has improved evasion (half damage on a failed Reflex save and no damage on a successful save), your save bonuses, and an AC of 22 (+8 size, +4 natural armor). Your highest mental modifier applies to the hand's AC as if it were the hand's Dexterity modifier. The hand has 1 to 4 hit points, the same number that you lost in creating it.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "one spectral hand",
        targets: "",
        duration: "1 min./level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Spell Gauge",
        type: ["utility"],
        school: "divination",
        tags: ["mind-affecting"],
        longDesc: `You immediately discover some of the spells that the target knows or has prepared. The number of spells revealed to you is equal to your caster level. The target's lowest-level spells are revealed first-ignoring 0-level spells-in a random order. Once all of the target's 1st-level spells are revealed, the spell begins revealing 2nd-level spells, then 3rd-level spells. This spell does not reveal spells of 4th level or higher, nor does it reveal spelllike abilities or other special abilities. If cast on a creature that is not a spellcaster, that has only 0-level spells or spells of 4th level or higher prepared, that has expended all of its spells, or that has not prepared any spells that day, the spell has no effect.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Spider Climb",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `The subject can climb and travel on vertical surfaces or even traverse ceilings as well as a spider does. The affected creature must have its hands free to climb in this manner. The subject gains a climb speed of 20 feet and a +8 racial bonus on Climb skill checks; furthermore, it need not make Climb checks to traverse a vertical or horizontal surface (even upside down). A spider climbing creature retains its Dexterity bonus to Armor Class (if any) while climbing, and opponents get no special bonus to their attacks against it. It cannot, however, use the run action while climbing.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Spiritual Squire",
        type: ["utility"],
        school: "evocation",
        tags: ["force"],
        longDesc: `This spell causes an ally made of pure force to appear in a single 5-foot square within range. The ally takes the form of a servant of your god (if any) or an ancestor. The spiritual squire occupies its space, though you and your allies can move through it, since it is your ally. While the spiritual squire appears to wear armor and carry a weapon, it cannot make attacks and does not threaten any spaces. On your turn, the spiritual squire can do one of the following: retrieve one stowed item from your possessions, carry an object weighing no more than 10 pounds per caster level, hand you an object it is carrying, perform the aid another action on your behalf or for one of your allies, or help one creature of your choice don armor (which then takes half the normal time). When the spiritual squire attempts the aid another action in combat, its attack bonus is equal to your base attack bonus + highest mental modifier. Each round after the first as a swift action, you can order the spiritual squire to move. It has a speed of 30 feet. Being a construct of force, the spiritual squire cannot be harmed by any physical attacks, but disintegrate, dispel magic, a rod of cancellation, or a sphere of annihilation affects it. A spiritual ally's AC against touch attacks is 10.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "2",
        name: "Summon Monster II",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell summons an extraplanar creature (typically an outsider, elemental, or magical beast native to another plane). It appears where you designate and acts immediately, on your turn. It attacks your opponents to the best of its ability. If you can communicate with the creature, you can direct it not to attack, to attack particular enemies, or to perform other actions. The spell conjures one of the creatures from the level on Table from: https://www.d20pfsrd.com/magic/all-spells/s/summon-monster/ of the level equal to the level of this spell. Alternatively you can choose to summon 1d3 creatures from the list 1 level below. You choose which kind of creature to summon (one type of creature at a time if you are summoning multiple) but can only summon creatures from the core list (not alternative options), and you can choose a different one each time you cast the spell. A summoned monster cannot summon or otherwise conjure another creature, nor can it use any teleportation or planar travel abilities. Creatures cannot be summoned into an environment that cannot support them. Creatures summoned using this spell cannot use spells or spell-like abilities that duplicate spells with expensive material components (such as wish). When you use a summoning spell to summon a creature with an alignment or elemental subtype, it is a spell of that type. Creatures marked with an "*" are summoned with the celestial template, if you are good, and the fiendish template, if you are evil. If you are neutral, you may choose which template to apply to the creature. Creatures marked with an "*" always have an alignment that matches yours, regardless of their usual alignment. Summoning these creatures makes the summoning spell's type match your alignment.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, F,DF,",
        },
        {
        level: "2",
        name: "Summon Nature's Ally II",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions as summon nature's ally I, except that you summon one 2nd-level creature or 1d3 1st-level creatures of the same kind.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Summon Swarm",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `You summon a swarm of bats, rats, or spiders (your choice), which attacks all other creatures within its area. (You may summon the swarm so that it shares the area of other creatures.) If no living creatures are within its area, the swarm attacks or pursues the nearest creature as best it can. The caster has no control over its target or direction of travel.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one swarm of bats, rats, or spiders",
        targets: "",
        duration: "concentration + 2 rounds",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Symbol of Mirroring",
        type: ["utility"],
        school: "illusion(figment)",
        tags: [],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to create a mirror image (as the spell) on all creature within its radius, lasting 1 round per level. This effect lasts as long as the creature is within 45 feet of the symbol. It can continue being triggered until it has targeted creatures equal to your caster level, or up to 5 times. When it activates it activates in a burst, affecting the closest creatures first. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 12 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 20 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Tanner's Harassment",
        type: ["utility","buff"],
        school: "enchantment",
        tags: ["mind-affecting", "language-dependent"],
        longDesc: `The spell point cost of this spell varies, read text. After a d20 roll is made by an ally (except you) who can hear you, and is within the range, but before the result is revealed, you can cast this spell to add +1d6 to the result of the roll, when you do the target of the spell is forced to make a will save (they cannot willingly fail), if they do fail they are forced to spend the spell points to pay for this spell. If they succeed on the roll you assisted, you gain a morale bonus on your next d20 roll equal to half the bonus given by this spell (within the duration). If they fail the roll you attempted to aid (whether they succeeded the save or not) you become shaken for rounds equal to the bonus given. This spell cannot cause you to become frightened, but extends the duration of any shaken effect on you. If the player succeeds the will saving throw against this spell you must spend the spell point cost and the bonus is reduced by half. You can cast this spell during the same action you use 'Timed Advice' from the bardic performance perk, and if you do, consider the cost of the perk and the bonus it gives as part of this spell (including potentially being halved, and who has to pay for it). The bonus provided by this spell increases to 1d8 at level 4, 1d10 at level 7, and 1d12 at level 10`,
        castingTime: "1 immediate action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one ally",
        duration: "instantaneous and round/2 levels",
        savingThrow: "Will partial",
        spellResistance: "yes (harmless)",
        components: "V, S",
        },
        {
        level: "2",
        name: "Unholy Ice Weapon",
        type: ["utility"],
        school: "transmutation",
        tags: ["cold", "evil", "water"],
        longDesc: `This spell functions as holy ice weapon, except the weapon is made of frozen unholy water, and instead deals additional damage to creatures that are susceptible to unholy water.`,
        castingTime: "1 standard action",
        range: "0 ft.",
        area: "",
        effect: "one ice weapon",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Winged Sword",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `The weapon targeted by this spell grows small feathered wings. For the duration of the spell, the weapon acts as if it had the throwing weapon special ability. This spell can be used in place of magic stone as a prerequisite for the throwing weapon special ability.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one melee weapon",
        duration: "10 minutes/level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Wood Shape",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `Wood shape enables you to form one existing piece of wood into any shape that suits your purpose. While it is possible to make crude coffers, doors, and so forth, fine detail isn't possible. There is a 30% chance that any shape that includes moving parts simply doesn't work.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one touched piece of wood no larger than 10 cu. ft. + 1 cu. ft./level",
        duration: "instantaneous",
        savingThrow: "Will negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, DF",
        },
        {
        level: "2",
        name: "Hidden Presence",
        type: ["utility", "buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You prevent the targets from having conscious awareness of your presence. You make yourself completely undetectable to the subjects by erasing all awareness of your presence from their minds. The targets can't see, hear, smell, feel, or taste you, including with extraordinary or supernatural senses such as blindsense, blindsight, scent, or tremorsense. They can't pinpoint your location by any means, including detect spells. The targets remain unaware of your actions, provided you don't make any attacks or cause any obvious or directly threatening changes in the targets' environment. If you attack any of the target creatures, the effect ends. If you take an action that creates a sustained and obvious change in the target's environment-for example, attacking a creature other than a target or moving a sizeable or attended object the target can see-the target immediately receives a new saving throw.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "up to one creature per 3 caster levels",
        duration: "1 minute/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Scamper",
        type: ["utility", "buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Your ally moves with astonishing agility and speed until the end of its turn. It can move at full speed while using Acrobatics, and it gains a competence bonus equal to twice your caster level on Acrobatics checks to avoid attacks of opportunity or move through a square occupied by an enemy.`,
        castingTime: "1 swift action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "An Ally (not yourself)",
        duration: "1 round; see text",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Shield Other",
        type: ["utility", "buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell wards the subject and creates a mystic connection between you and the subject so that some of its wounds are transferred to you. The subject gains a +1 deflection bonus to AC and a +1 resistance bonus on saves. Additionally, the subject takes only half damage from all wounds and attacks (including those dealt by special abilities) that deal hit point damage. The amount of damage not taken by the warded creature is taken by you. Forms of harm that do not involve hit points, such as charm effects, temporary ability damage, level draining, and death effects, are not affected. If the subject suffers a reduction of hit points from a lowered Constitution score, the reduction is not split with you because it is not hit point damage. When the spell ends, subsequent damage is no longer divided between the subject and you, but damage already split is not reassigned to the subject. If you and the subject of the spell move out of range of each other, the spell ends.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 hour/level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Aboleth's Lung",
        type: ["utility", "control"],
        school: "transmutation",
        tags: [],
        longDesc: `The targets are able to breathe water, freely. However, they can no longer breathe air. Divide the duration evenly among all the creatures you touch. This spell has no effect on creatures that can already breathe water.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creatures touched",
        duration: "1 hour/level; see text",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M, DF",
        },
        {
        level: "2",
        name: "Adhesive Blood",
        type: ["utility", "control"],
        school: "transmutation",
        tags: [],
        longDesc: `Your blood thickens to becomes a glue-like substance upon contact with air. A piercing or slashing weapon that deals hit point damage to you is stuck fast unless the wielder succeeds at a Reflex save. A creature can pry off a stuck weapon on its turn as a standard action with a successful Strength check against the spell's DC. Strong alcohol or universal solvent dissolves the adhesive. The glue breaks down 5 rounds after you die, or when the duration ends. This glue has no while underwater or in environments that lack air.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "Reflex negates (see text)",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Brow Gasher",
        type: ["utility", "control"],
        school: "necromancy",
        tags: [],
        longDesc: `You imbue a slashing melee weapon with the ability to deal a gruesome head wound. When the target weapon hits a living creature, in addition to the normal effects of that hit, the wielder can discharge this spell as a free action to open a gash on the target's forehead that deals bleed damage equal to half your caster level. At the start of each of the target's turns, when it takes bleed damage, it also takes a cumulative -1 penalty on all attack rolls. When that penalty reaches -3, the target also treats all targets as having concealment (20% miss chance). When the penalty reaches -5, the target is blinded. Stopping the bleed damage ends the effects this spell imposes on the bleeding creature. A target that is immune to bleed damage is also immune to all this spell's effects.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "one slashing melee weapon touched",
        effect: "",
        targets: "",
        duration: "1 round/level or until discharged",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Ghostbane Dirge",
        type: ["utility", "control"],
        school: "transmutation",
        tags: [],
        longDesc: `The target coalesces into a semi-physical form for a short period of time. While subject to the spell, the incorporeal creature takes half damage (50%) from nonmagical attack forms, and full damage from magic weapons, spells, spell-like effects, and supernatural effects.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Will Negates",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "2",
        name: "Glitterdust",
        type: ["utility", "control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `A cloud of golden particles covers everyone and everything in the area, causing creatures to become blinded and visibly outlining invisible things for the duration of the spell. All within the area are covered by the dust, which cannot be removed and continues to sparkle until it fades. Each round at the end of their turn blinded creatures may attempt new saving throws to end the blindness effect. Any creature covered by the dust takes a -40 penalty on Stealth checks.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "creatures and objects within 10-ft.-radius spread",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Will negates (blinding only)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "2",
        name: "Staggering Fall",
        type: ["utility", "control"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell must be cast on a creature as it falls, either from a height or after being knocked prone or tripped. The magic of this spell causes the creature to hit the ground particularly hard, knocking the wind from it. The creature takes an additional 1d6 points of damage from the fall. In addition, the creature becomes staggered for the duration of the spell unless it makes a Will save. Each round the spell's effects persist, the creature may attempt a new Will save as a free action to end the staggered effect early. A creature under the effects of this spell must take a standard action to stand up.`,
        castingTime: "1 immediate action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one falling creature",
        duration: "1 round/level (see below)",
        savingThrow: "Fort. partial (see below)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "2",
        name: "Bladed Dash",
        type: ["utility", "damage"],
        school: "transmutation",
        tags: [],
        longDesc: `When you cast this spell, you immediately move up to 30 feet in a straight line any direction, momentarily leaving a multi-hued cascade of images behind you. This movement does not provoke attacks of opportunity. You may make a single melee attack at your highest base attack bonus against any one creature you are adjacent to at any point along this 30 feet. You gain a circumstance bonus on your attack roll equal to your highest mental stat. You must end the bonus movement granted by this spell in an unoccupied square. If no such space is available along the trajectory, the spell fails. Despite the name, the spell works with any melee weapon.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "You",
        duration: "instantaneous",
        savingThrow: "None",
        spellResistance: "",
        components: "V, ",
        },
        {
        level: "3",
        name: "Ablative Barrier",
        type: ["buff"],
        school: "conjuration(creation)",
        tags: ["force"],
        longDesc: `Invisible layers of solid force surround and protect the target, granting that target a +2 armor bonus to AC. Additionally, the first 5 points of lethal damage the target takes from each attack are converted into nonlethal damage. Against attacks that already deal nonlethal damage, the target gains DR 5/-. Once this spell has converted 5 points of damage to nonlethal damage per caster level (maximum 50 points), the spell is discharged.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 hour/level or until discharged",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Ablative Sphere",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `An immobile, crystalline, weblike globe surrounds you. When the ablative sphere winks into existence, it provides you with improved cover. The barrier does not impede a spell's line of sight or effect. The sphere is 1 inch thick per caster level, has hardness 5, and 3 hit points per inch of thickness. When an ablative sphere loses hit points, the level of cover it provides is reduced. When the ablative sphere has lost one-third of its hit points, it provides cover instead of improved cover. Once it has lost two-thirds of its hit points, it provides only partial cover. Finally, when the ablative sphere's hit points reach 0, the globe is destroyed. When an attack reduces an ablative sphere's hit points to 0, you take any remaining damage.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute per level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Align Weapon, Communal",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument] This spell functions as align weapon, except you divide the duration in 1-minute increments between any number of touched weapons. Every group of up to 50 projectiles (which must be together at the time of casting) counts as one weapon for the purpose of dividing the spell's duration.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "weapons or projectiles touched",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, DF,",
        additionalInfoTags:["Imbument"],
        },
        {
            level: "2",
            name: "Daybreak Blade",
            type: ["buff"],
            school: "evocation",
            tags: ["light","imbument"],
            longDesc: `[imbument] You cause a weapon or pieces of ammunition to exude radiant energy. Creatures that take penalties in bright light take these penalties for 1 round after being struck by such weapon. Undead and creatures harmed by sunlight take an additional 1d6 points of damage from such weapons. This extra damage and half of any other damage you deal with an affected weapons results directly from radiant energy and is not subject to damage resistance. Such a weapons sheds light as if it were a sunrod while wielded or for 1 round after it is fired or thrown.`,
            castingTime: "1 standard action",
            range: "touch",
            area: "",
            effect: "",
            targets: "1 weapon or 50 pieces of ammunition",
            duration: "1 min./level",
            savingThrow: "Fortitude  negates",
            spellResistance: "yes (harmless, object)",
            components: "V, S",
            additionalInfoTags:["Imbument"],
        },
        {
        level: "2",
        name: "Allied Cloak",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You cause a cloak, shawl, poncho, or other outer garment you are wearing to animate to aid and defend you. The cloak provides a +2 shield bonus to your AC. In addition, once each round during your turn, you can take a free action to direct your cloak to use the aid another action to assist your skill check, attack roll, or AC. The cloak has an attack bonus or a total skill bonus equal to your caster level plus your highest mental modifier. The cloak cannot take any other type of action.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 piece of clothing",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Ape Walk",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `(harmless) The subject can climb as well as an ape or monkey, gaining a climb speed of 30 feet and a +8 racial bonus on Climb skill checks. The affected creature must have her hands free to climb in this manner. In addition, as long as she has 10 feet of space in which to make a running start, the subject can make a long jump of up to 10 feet without making an Acrobatics check (an Acrobatics check is still required to jump longer distances).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 minutes/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Arcane Concordance",
        type: ["buff"],
        school: "evocation",
        tags: [],
        longDesc: `A shimmering, blue and gold radiance surrounds you, enhancing arcane spells cast by your allies within its area. Any arcane spell cast by a creature within the area gains a +1 enhancement bonus to the DC of any saving throws against the spell, and can be cast as if one of the following metamagic feats was applied to it (without increasing the spell level or Casting Time): Enlarge Spell, Extend Spell, Silent Spell, or Still Spell (you choose the metamagic feat when you cast arcane concordance).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "10-ft.-radius emanation centered on you",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Badger's Ferocity",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This functions like keen edge, except it affects multiple weapons and requires your concentration. You select the weapons to be affected, and can only affect one weapon per creature. If a creature's weapon exceeds the spell's range, the spell ends for that weapon.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one weapon/3 levels",
        duration: "concentration",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Beacon of Luck",
        type: ["buff"],
        school: "divination",
        tags: [],
        longDesc: `You send out a burst of luck with a 30-foot radius centered around you. While the beacon of luck is in effect, you gain a +2 sacred bonus on all saving throws. As an immediate action before a saving throw is made, allies within the area can choose to benefit from this luck, rolling twice for a saving throw and taking the better result. Once a creature benefits from the beacon of luck in this way, it cannot gain the benefit of this spell for 24 hours.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M",
        },
        {
        level: "3",
        name: "Bestow Grace",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `With this spell you can bestow your divine grace on another creature that shares your moral alignment for a short amount of time, infusing that creature with a portion of your virtue. When you touch the subject, you grant that creature a sacred(or profane if you're evil) bonus to its saving throws equal to its highest mental bonus (if any) on all saving throws.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one creature with the same moral alignment",
        duration: "1 minute/level",
        savingThrow: "will negates(harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Blessing Of the Mole",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The targets gain darkvision 30 feet and a +2 competence bonus on Stealth checks.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "1 creature/level",
        effect: "",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "none (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Blink",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You 'blink' quickly back and forth between the Material Plane and the Ethereal Plane and look as though you're winking in and out of reality at random. Blink has several effects, as follows. Physical attacks against you have a 50% miss chance, and the Blind-Fight feat doesn't help opponents, since you're ethereal and not merely invisible. If the attack is capable of striking ethereal creatures, the miss chance is only 20% (for concealment). If the attacker can see invisible creatures, the miss chance is also only 20%. (For an attacker who can both see and strike ethereal creatures, there is no miss chance.) Likewise, your own attacks have a 20% miss chance, since you sometimes go ethereal just as you are about to strike. Any individually targeted spell has a 50% chance to fail against you while you're blinking unless your attacker can target invisible, ethereal creatures. Your own spells have a 20% chance to activate just as you go ethereal, in which case they typically do not affect the Material Plane (but they might affect targets on the Ethereal Plane). While blinking, you take only half damage from area attacks (but full damage from those that extend onto the Ethereal Plane). Although you are only partially visible, you are not considered invisible and targets retain their Dexterity bonus to AC against your attacks. You do receive a +2 bonus on attack rolls made against enemies that cannot see invisible creatures. You take only half damage from falling, since you fall only while you are material. While blinking, you can step through (but not see through) solid objects. For each 5 feet of solid material you walk through, there is a 50% chance that you become material. If this occurs, you are shunted off to the nearest open space and take 1d6 points of damage per 5 feet so traveled. Since you spend about half your time on the Ethereal Plane, you can see and even attack ethereal creatures. You interact with ethereal creatures roughly the same way you interact with material ones. An ethereal creature is invisible, incorporeal, and capable of moving in any direction, even up or down. As an incorporeal creature, you can move through solid objects, including living creatures. An ethereal creature can see and hear the Material Plane, but everything looks gray and insubstantial. Sight and hearing on the Material Plane are limited to 60 feet. Force effects and abjurations affect you normally. Their effects extend onto the Ethereal Plane from the Material Plane, but not vice versa. An ethereal creature can't attack material creatures, and spells you cast while ethereal affect only other ethereal things. Certain material creatures or objects have attacks or effects that work on the Ethereal Plane. Treat other ethereal creatures and objects as material.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Blood Rage",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `The targets of this spell become angrier as they fight, the pain of their wounds fueling their strength. An affected creature gains a cumulative +2 morale bonus to Strength and a cumulative –1 penalty to AC for every 5 points of damage it takes (maximum +10 Strength, –5 AC) for the duration of the spell. These bonuses last until the spell expires or the target falls unconscious.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one willing living creature per 2 levels, no two of which may be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M",
        },
        {
        level: "3",
        name: "Blood Scent",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You greatly magnify the target's ability to smell the presence of blood. The target is considered to have the scent universal monster ability, but only for purposes of detecting and pinpointing injured creatures (below full hit points). Creatures below half their full hit points or suffering bleed damage are considered strong scents for this ability. Orcs and any creature under the effects of rage gain a +2 morale bonus on attack and damage rolls against creatures they can smell with this spell, or a +4 morale bonus if the target's blood counts as a strong scent.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature/2 levels, no two of which can be more than 30 ft. apart",
        duration: "1 minute/level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Burst of Speed",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Until the end of your turn, you gain a +20-foot bonus to speed (or +10-foot bonus if you are wearing Medium or Heavy armor), your movement does not provoke attacks of opportunity, and you can move through the space of creatures that are larger than you are, but you cannot end your movement this round in a space occupied by a creature.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "See Text",
        savingThrow: "Will negates (harmless)",
        spellResistance: "",
        components: "V, ",
        },
        {
        level: "3",
        name: "Channel Vigor",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You focus the energy of your mind, body, and spirit into a specific part of your being, granting yourself an exceptional ability to perform certain tasks. When you cast the spell, choose one of the following portions of your self as your focus target. Thereafter, you may change the focus target as a move action. You can gain the benefit of only one channel vigor spell at a time. Limbs: You gain the benefits of a haste spell. Mind: You gain a +4 competence bonus on Knowledge and Perception skill checks and on ranged attack rolls. Spirit: You gain a +6 competence bonus on Will saving throws and Bluff and Intimidate checks. Torso: You gain a +6 competence bonus on Fortitude saving throws and concentration checks.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Clay Skin",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `The target's skin becomes as thick and tough as clay, granting the target DR 5/adamantine. Once the spell has prevented a total of 5 points of damage per caster level (maximum 50 points), it is discharged and the spell ends.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 minute/level or until discharged",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes(harmless)",
        components: "V,S,M",
        },
        {
        level: "3",
        name: "Cloak of Winds",
        type: ["buff"],
        school: "abjuration",
        tags: ["air"],
        longDesc: `You shroud a creature in a whirling screen of strong, howling wind. The subject is never checked or blown away by strong winds of windstorm or lesser strength (whether natural or magically created), and ranged attack rolls against the subject take a -4 penalty. Tiny or smaller creatures must succeed at a Fortitude save to successfully touch or attack the subject in melee. Failure knocks the attacker prone and pushes it 5 feet away from the subject per level of the caster. This movement can pass through the squares of other creatures without affecting them and does not provoke attacks of opportunity, but the creature takes 3d6 points of nonlethal damage, plus 1d6 if the creature strikes a solid object that blocks its movement.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Cold Iron Weapons",
        type: ["buff"],
        school: "transmutation",
        tags: ["earth", "imbument"],
        longDesc: `[imbument] The touched weapon becomes cold iron (this doesn't affect its hardness or hit points), and against creatures that have their damage reduction bypassed by cold iron, the weapon deals an additional 2d6 points of damage. If the creature has damage reduction bypassed by cold iron and something else, this only deals 1d6 bonus damage to them. A weapon can have only a single imbument at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 weapon",
        duration: "1 round/level",
        savingThrow: "will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "3",
        name: "Coordinated Effort",
        type: ["buff"],
        school: "divination",
        tags: [],
        longDesc: `Choose a single teamwork feat that you possess. You forge a link with your allies, allowing them to gain the benefits of the chosen feat even if they do not have it themselves. You must be a part of the group qualifying for a given bonus for your allies to gain the benefits. For example, two of your allies flanking an orc would gain no benefit from your Outflank feat, but an ally flanking the orc with you would. Your allies' positioning and actions must still meet the prerequisites listed in the teamwork feat for either of you to receive the listed bonus.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "you plus one willing creature per 3 levels, no two of which can be more than 30 ft. part",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Countless Eyes",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The target sprouts extra eyes all over its body, including on the back of its head. It gains all-around vision and cannot be flanked.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 hour/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Deadly Juggernaut",
        type: ["buff"],
        school: "necromancy",
        tags: ["death"],
        longDesc: `With every enemy life you take, you become increasingly dangerous and difficult to stop. During the duration of the spell, you gain a cumulative +1 luck bonus on melee attack rolls, melee weapon damage rolls, Strength checks, and Strength-based skill checks as well as DR 2/- each time you reduce a qualifying opponent to 0 or few hit points (maximum +5 bonus and DR 10/-) with a melee attack. A qualifying opponent has a number of Hit Dice equal to or greater than your Hit Dice -4.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Displacement",
        type: ["buff"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `The subject of this spell appears to be about 2 feet away from its true location. The creature benefits from a 50% miss chance as if it had total concealment. Unlike actual total concealment, displacement does not prevent enemies from targeting the creature normally. True seeing reveals its true location and negates the miss chance.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, M,",
        },
        {
        level: "3",
        name: "Earth Shell",
        type: ["buff"],
        school: "transmutation",
        tags: ["acid", "earth"],
        longDesc: `While this spell is active every time you cast a spell that deals acid damage you gain DR/1 Adamantine for the rest of the duration. This bonus stacks, however each time you take physical damage the damage reduction reduces by 1. The max amount of damage reduction this spell can give is equal to your caster level, for each 3 points of DR you currently have your natural armor bonus increases by +1.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "You",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Eruptive Pustules",
        type: ["buff"],
        school: "transmutation",
        tags: ["acid"],
        longDesc: `Your skin erupts in swollen, pus-filled bumps that burst open if you are struck. Any creature that strikes you with its body or a hand-held weapon deals normal damage, but at the same time the attacker takes 1d6 points of acid damage and must save or be sickened for 1 round. If the attack against you is a critical hit, the attacker must save or be nauseated instead of sickened. This damage can harm a swarm.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "Fortitude partial (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Flame Arrow",
        type: ["buff"],
        school: "transmutation",
        tags: ["fire"],
        longDesc: `This spell allows you to turn ammunition (such as arrows, crossbow bolts, shuriken, and sling stones) into fiery projectiles. Each piece of ammunition deals an extra 1d6 points of fire damage to any target it hits. A flaming projectile can easily ignite a flammable object or structure, but it won't ignite a creature it strikes.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "fifty projectiles, all of which must be together at the time of casting",
        duration: "10 min./level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Guardian Monument Lesser",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You touch an unattended, non-magical object to create a touchstone for allies in the area, who are protected by a shimmering aura as long as they are in the area.
        \nThe spell grants each subject damage reduction 2/magic. Allies who leave the area and reenter regain the damage reduction.
        \nThe spell ends if the object is moved.
        \nNormally, the area of effect is 40 feet from the touched object.
        \nIf the touched object is a monument, the area increases to a 60-foot radius.`,
        castingTime: "1 full round",
        range: "touch",
        area: "40-ft. radius from touched object or 60-ft. radius from touched object; see text",
        effect: "",
        targets: "",
        duration: "1 hour/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, F",
        },
        {
        level: "3",
        name: "Haste",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The transmuted creatures move and act more quickly than normal. This extra speed has several effects. When making a full attack action, a hasted creature may make one extra attack with one natural or manufactured weapon. The attack is made using the creature's full base attack bonus, plus any modifiers appropriate to the situation. (This effect is not cumulative with similar effects, such as that provided by a speed weapon, nor does it actually grant an extra action, so you can't use it to cast a second spell or otherwise take an extra action in the round.) A hasted creature gains a +1 bonus on attack rolls and a +1 dodge bonus to AC and Reflex saves. Any condition that makes you lose your Dexterity bonus to Armor Class (if any) also makes you lose dodge bonuses. All of the hasted creature's modes of movement (including land movement, burrow, climb, fly, and swim) increase by 30 feet, to a maximum of twice the subject's normal speed using that form of movement. This increase counts as an enhancement bonus, and it affects the creature's jumping distance as normal for increased speed. Multiple haste effects don't stack. Haste dispels and counters slow.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Heart of the Metal",
        type: ["buff"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `You lend the nature of adamantine, cold iron, or silver to the targeted weapons, depending on which component you used, with the following effects. Adamantine: The weapons overcome DR/adamantine and ignore hardness of less than 20. Cold Iron: The weapons overcome DR/cold iron. Silver: The weapons overcome DR/silver. No other advantages or disadvantages of these metal types apply. For example, a weapon given the nature of adamantine is not automatically masterwork. This spell can affect nonmetal weapons. If you grant the target weapons the property of cold iron, the spell lasts half as long as normal.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one weapon per level",
        duration: "1 minute/level (see text)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Heroism",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell imbues a single creature with great bravery and morale in battle. The target gains a +2 morale bonus on attack rolls, saves, and skill checks.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Ice Shell",
        type: ["buff"],
        school: "transmutation",
        tags: ["cold"],
        longDesc: `You cover yourself in a shell of ice. This shell immobilizes you, making you unable to breath, see, speak, or move in any way, thus making you helpless. However the ice also blocks line of effect for spells and attacks, needing to be destroyed before you can be attacked. It has 3 hit points per caster level, and hardness 3, plus 1 per 4 caster levels (max 40 hit points and hardness 6 at casater level 12). It takes 50% extra damage from fire damage, and has cold resistance 30. Any damage dealt over the ice's health is dealt to you as normal.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "You",
        duration: "1 round",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S",
        },
        {
        level: "3",
        name: "Insightful Damage",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument] You imbue a one-handed, light, crossbow, or firearm to instead allow you to use your intelligence to determine its damage modifier instead of the usual ability score (if it would be higher). This only applies as long as you wield the weapon. A weapon can have only one imbument at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 weapon",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V,S,M",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "3",
        name: "Keen Edge",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell makes a weapon magically keen, improving its ability to deal telling blows. This transmutation doubles the threat range of the weapon. A threat range of 20 becomes 19-20, a threat range of 19-20 becomes 17-20, and a threat range of 18-20 becomes 15-20. The spell can be cast only on piercing or slashing weapons. If cast on arrows or crossbow bolts, the keen edge on a particular projectile ends after one use, whether or not the missile strikes its intended target. Treat shuriken as arrows, rather than as thrown weapons, for the purpose of this spell. Multiple effects that increase a weapon's threat range (such as the keen special weapon property and the Improved Critical feat) don't stack. You can't cast this spell on a natural weapon, such as a claw.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one weapon or 50 projectiles, all of which must be together at the time of casting",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Light Lance",
        type: ["buff"],
        school: "evocation",
        tags: ["good", "light"],
        longDesc: `You empower a polearm you are wielding, causing it to gain a +1 and holy enchantment. You must have a free hand when casting the spell and, once you determine the weapon affected by this spell, you cannot switch it to another hand or put it down without prematurely ending the spell. As a standard action while holding a light lance, you can choose not to make an attack and instead hold the lance aloft as a beacon of light and truth, creating an area of bright light with a radius of 90 feet.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "lance of light",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S",
        },
        {
        level: "3",
        name: "Litany of Warding",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `With this litany, you become more aware of your opponents. You can make two additional attacks of opportunity this round. Furthermore, you gain a +2 sacred bonus to AC against attacks of opportunity. While subject to this spell, the target cannot be the target of another spell that has the word “litany” in the title.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round",
        savingThrow: "will negates",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Locate Weakness",
        type: ["buff"],
        school: "divination",
        tags: [],
        longDesc: `You can sense your foes' weak points, granting you greater damage with critical hits. Whenever you score a critical hit, roll the attack's damage dice (but not extra or precision damage dice) twice and take the highest result.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,DF,",
        },
        {
        level: "3",
        name: "Longstrider, Greater",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This functions as longstrider, except it gives you a +20-foot enhancement bonus to your base speed and a +10-foot enhancement bonus to your other modes of movement (burrow, climb, fly, swim, and so on). It does not affect movement modes you do not actually have-for example, if you do not have a swim speed, this spell does not grant you a swim speed.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 hour/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M, ",
        },
        {
        level: "3",
        name: "Magic Circle against Chaos",
        type: ["buff"],
        school: "abjuration",
        tags: ["lawful"],
        longDesc: `All creatures within the area gain the effects of a protection from chaos spell, and chaotic summoned creatures cannot enter the area either. Creatures in the area, or who later enter the area, receive only one attempt to suppress effects that are controlling them. If successful, such effects are suppressed as long as they remain in the area. Creatures that leave the area and come back are not protected. You must overcome a creature's Spell Resistance in order to keep it at bay (as in the third function of protection from chaos), but the deflection and resistance bonuses and the protection from mental control apply regardless of enemies' Spell Resistance.
        \nThis spell is not cumulative with protection from chaos and vice versa.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "10-ft.-radius emanation from touched creature",
        effect: "",
        targets: "",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no; see Text",
        components: "V, S, M/DF",
        },
        {
        level: "3",
        name: "Magic Circle against Evil",
        type: ["buff"],
        school: "abjuration",
        tags: ["good"],
        longDesc: `All creatures within the area gain the effects of a protection from evil spell, and evil summoned creatures cannot enter the area either. Creatures in the area, or who later enter the area, receive only one attempt to suppress effects that are controlling them. If successful, such effects are suppressed as long as they remain in the area. Creatures that leave the area and come back are not protected. You must overcome a creature's Spell Resistance in order to keep it at bay (as in the third function of protection from evil), but the deflection and resistance bonuses and the protection from mental control apply regardless of enemies' Spell Resistance.
        \nThis spell is not cumulative with protection from evil and vice versa.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "10-ft.-radius emanation from touched creature",
        effect: "",
        targets: "",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no; see Text",
        components: "V, S, M/DF",
        },
        {
        level: "3",
        name: "Magic Circle against Good",
        type: ["buff"],
        school: "abjuration",
        tags: ["evil"],
        longDesc: `All creatures within the area gain the effects of a protection from good spell, and good summoned creatures cannot enter the area either. Creatures in the area, or who later enter the area, receive only one attempt to suppress effects that are controlling them. If successful, such effects are suppressed as long as they remain in the area. Creatures that leave the area and come back are not protected. You must overcome a creature's Spell Resistance in order to keep it at bay (as in the third function of protection from good), but the deflection and resistance bonuses and the protection from mental control apply regardless of enemies' Spell Resistance.
        \nThis spell is not cumulative with protection from good and vice versa.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "10-ft.-radius emanation from touched creature",
        effect: "",
        targets: "",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no; see Text",
        components: "V, S, M/DF",
        },
        {
        level: "3",
        name: "Magic Circle against Law",
        type: ["buff"],
        school: "abjuration",
        tags: ["chaotic"],
        longDesc: `All creatures within the area gain the effects of a protection from law spell, and lawful summoned creatures cannot enter the area either. Creatures in the area, or who later enter the area, receive only one attempt to suppress effects that are controlling them. If successful, such effects are suppressed as long as they remain in the area. Creatures that leave the area and come back are not protected. You must overcome a creature's Spell Resistance in order to keep it at bay (as in the third function of protection from law), but the deflection and resistance bonuses and the protection from mental control apply regardless of enemies' Spell Resistance.
        \nThis spell is not cumulative with protection from law and vice versa.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "10-ft.-radius emanation from touched creature",
        effect: "",
        targets: "",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no; see Text",
        components: "V, S, M/DF",
        },
        {
        level: "3",
        name: "Magic Fang, Greater",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell functions like magic fang, except that the enhancement bonus on attack and damage rolls is +1 per four caster levels (maximum +5). This bonus does not allow a natural weapon or unarmed strike to bypass damage reduction aside from magic. Alternatively, you may imbue all of the creature's natural weapons with a +1 enhancement bonus (regardless of your caster level).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 hour/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF",
        },
        {
        level: "3",
        name: "Magic Vestment",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You imbue a suit of armor or a shield with an enhancement bonus of +1 per four caster levels (maximum +5 at 20th level). An outfit of regular clothing counts as armor that grants no AC bonus for the purpose of this spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "armor or shield touched",
        duration: "1 hour/level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Magic Weapon, Greater",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell functions like magic weapon, except that it gives a weapon an enhancement bonus on attack and damage rolls of +1 per four caster levels (maximum +5). This bonus does not allow a weapon to bypass damage reduction aside from magic. Alternatively, you can affect as many as 50 arrows, bolts, or bullets. The projectiles must be of the same kind, and they have to be together (in the same quiver or other container). Projectiles, but not thrown weapons, lose their transmutation after they are used. Treat shuriken as projectiles, rather than as thrown weapons, for the purpose of this spell. A weapon can have only a single imbument at a time.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one weapon or 50 projectiles (all of which must be together at the time of casting)",
        duration: "1 hour/level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,DF,",
        },
        {
        level: "3",
        name: "Monstrous Extremities",
        type: ["buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You change one of the extremities of the creature touched-arms or legs only-into another shape of approximately the same size and mass. You can choose a tentacle, a hoof, or a wing. These new forms do not allow the subject to fly, run faster, or swim better; however, they do act as natural weapons of the appropriate type, and the subject can use them to make secondary attacks while making attacks with weapons as a full-attack action. The secondary attacks are made using the creature's base attack bonus -5 and adding only 1/2 the creature's Strength bonus on damage rolls. The subject cannot hold a weapon or use any item that would ordinarily fit into the slot of the changed extremity. The subject can receive the benefits of this spell multiple times.`,
        castingTime: "1 round",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Protection from Arrows, Communal",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions like protection from arrows, except you divide the duration in 1-hour intervals among the creatures touched. Once the spell absorbs 10 points of damage per caster level (maximum 100 points) for a subject, the spell's effects end for that subject.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creatures touched",
        duration: "1 hour/level or until discharged",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Protection from Energy",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `Protection from energy grants temporary immunity to the type of energy you specify when you cast it (acid, cold, electricity, fire, or sonic). When the spell absorbs 12 points per caster level of energy damage (to a maximum of 120 points at 10th level), it is discharged. Protection from energy overlaps (and does not stack with) resist energy. If a character is warded by protection from energy and resist energy, the protection spell absorbs damage until its power is exhausted.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 min./level or until discharged",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Rage",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `Each affected creature gains a +2 morale bonus to Strength and Constitution, a +1 morale bonus on Will saves, and a -2 penalty to AC. The effect is otherwise identical with a barbarian's rage except that the subjects aren't fatigued at the end of the rage.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one willing living creature per three levels, no two of which may be more than 30 ft. apart",
        duration: "concentration + 1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Reaper's Coterie",
        type: ["buff"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `The target weapon becomes a reservoir of spiritual energy, fueling its destructive power by drawing in a tiny fragment of the essence of each creature it is used to defeat. When the targeted weapon is used to reduce a living creature to 0 or fewer hit points, it gains a +1 profane bonus on damage rolls. This bonus increases by 1 for each creature reduced to 0 hit points or fewer with that weapon, up to a maximum bonus equal to 1/2 your caster level.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "weapon touched",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Resinous Skin",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You coat your body with a resinous substance, protecting you from attacks and binding weapons that strike you. You gain DR 5/piercing, as well as a +4 circumstance bonus to your CMD against disarm attempts and on saving throws against effects that cause you to drop something you are holding. Additionally, you gain a +2 circumstance bonus on combat maneuver checks to initiate a grapple, maintain a grapple, and pin a foe. Any enemy you grapple takes a -2 penalty on attempts to break the grapple and to escape the grapple using Escape Artist. Any weapon, that strikes you becomes stuck unless its wielder succeeds at a Reflex saving throw. Such a weapon can be pulled free of you only with a successful Strength check (DC = your saving throw DC for this spell). This spell has no effect on unarmed strikes or natural weapons.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 minutes/level",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Resist Energy, Communal",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions like resist energy, except you divide the duration in 10-minute intervals among the creatures touched.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creatures touched",
        duration: "10 min./level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Returning Weapon, Communal",
        type: ["buff"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `This spell functions like returning weapon, returning whatever weapon is thrown back to your hand at the end of the attack roll, except you divide the duration in 1-minute intervals among the targeted weapons.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one weapon that can be thrown",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Righteous Vigor",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `Infusing the target with a surge of furious divine energy, you enhance a creature's ability to hit an opponent based on the number of times it has already hit that opponent with a successful attack. Each time the subject successfully strikes an opponent with a successful melee attack, the subject gains a cumulative +1 morale bonus on attack rolls (maximum +4 bonus) and gains 1d8 temporary hit points (to a maximum of 20 temporary hit points). If an attack misses, the attack bonus resets to +0 but any accumulated temporary hit points remain. The temporary hit points disappear at the end of the spell's duration.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "will negates(harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Sanctify Armor",
        type: ["buff"],
        school: "abjuration",
        tags: ["good"],
        longDesc: `You imbue your armor with a righteous aura. It gains a +1 enhancement bonus per four caster levels (maximum +5 at 20th level). When the wearer uses their judgment or smite ability, they gain DR 5/evil for its duration. This stacks with any DR/evil they may have.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "armor touched",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S",
        },
        {
        level: "3",
        name: "Scales of Deflection",
        type: ["buff"],
        school: "abjuration",
        tags: ["draconic"],
        longDesc: `Brilliant draconic iconography matching your draconic heritage (or a kind of dragon whose alignment matches your own) surrounds you. Any touch attack attempted against you resolves against your normal AC. Once such an attack has been resolved, this spell is dismissed at the end of your next turn.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (see text)",
        savingThrow: "",
        spellResistance: "",
        components: "V, M,",
        },
        {
        level: "3",
        name: "Shield Companion",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell creates a special mystical connection between you and a chosen ally, which allows you to transfer its wounds to you. The ally gains a +1 deflection bonus to AC and a +1 resistance bonus on saves. As an immediate action when your linked creature takes damage, you can take that damage yourself to prevent your ally from being harmed (similar to shield other, except the damage is not split between you and the target). Forms of harm that do not involve the loss of hit points, such as charm effects, temporary ability damage, level drain, and death effects, are not affected. If the creature suffers a reduction of hit points from a lowered Constitution score, you cannot take that damage on behalf of your companion creature because it is not hit point damage. When the spell ends, damage directed to you by the spell is not reassigned to the subject. If you and your ally move out of range of each other, the spell ends.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "yourself and another ally",
        duration: "1 hour/level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Shield Of Darkness",
        type: ["buff"],
        school: "evocation",
        tags: ["darkness", "shadow"],
        longDesc: `You shield yourself with darkness, reducing the illumination level in your space to magical darkness and granting you total concealment. Your opponents are automatically aware of which squares you occupy, preventing you from attempting Stealth checks using this concealment unless every square adjacent to you has an illumination level of darkness or lower. Shield of darkness does not hinder your vision, and creatures that can see in magical darkness ignore this effect.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, ",
        },
        {
        level: "3",
        name: "Silver Weapons",
        type: ["buff"],
        school: "transmutation",
        tags: ["earth", "imbument"],
        longDesc: `[imbument] The touched weapon becomes silver (this doesn't affect its hardness or hit points), and against creatures that have their damage reduction bypassed by silver, the weapon deals an additional 2d6 points of damage. If the creature has damage reduction bypassed by silver and something else, this only deals 1d6 bonus damage to them. A weapon can have only a single imbument at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 weapon",
        duration: "1 round/level",
        savingThrow: "will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "3",
        name: "Stunning Barrier, Greater",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions as stunning barrier, except as noted above, and it provides a +2 bonus to AC and on saving throws. It is not discharged until it has stunned a number of creatures equal to your caster level.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level or until discharged",
        savingThrow: "none and Will negates (see text)",
        spellResistance: "no and yes (see text)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Titanic Anchoring",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You become grounded and nearly immovable. You are immune to the pull and push special abilities, and all bull rush, grapple, overrun, reposition, and trip combat maneuvers made by creatures your size or smaller always fail. You gain a +10 bonus to your CMD against those combat maneuver checks made by creatures larger than you.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M",
        },
        {
        level: "3",
        name: "Versatile Weapon",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument] You transform the physical makeup of a weapon as you desire. This spell functions like greater magic weapon, except that it subtly alters the physical properties of a weapon, enabling it to bypass damage reduction of one the following types: bludgeoning, cold iron, piercing, silver, or slashing. The affected weapon still inflicts damage of its normal type and its hardness and hit points are unchanged. This spell can be cast on a natural weapon or unarmed strike. You can only have a single imbument on a weapon at a time.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one weapon or 50 projectiles, all of which must be together at the time of casting",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "3",
        name: "Ward of the Season",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell harnesses the power of the seasons to protect the target and grant a number of bonuses. This spell has one of four different effects. The caster of the spell can select any one of the following four effects, but can change the effect as a standard action that reduces the total remaining duration by 1 hour.
        \nSpring: The target is wrapped in light vines, culminating in a crown of bright, beautiful flowers. While the spell remains in effect, the target is immune to bleed effects and regains 1 hit point per round whenever below 0 hit points, as long as the target is still alive. This stabilizes the target. For each hit point restored in this way, the spell's total remaining duration is reduced by 1 hour.
        \nSummer: The target is surrounded by tiny motes of light. While the spell remains in effect, the target's base speed increases 10 feet. The target may instead increase its base speed by 30 feet for 1 round by reducing the spell's total remaining duration by 1 hour.
        \nFall: A cloak of autumn leaves appears on the target. While the spell remains in effect, the target gains a +2 morale bonus on Fortitude saves. The target can decide to roll twice on any saving throw against disease or poison and take the higher result by reducing the spell's total remaining duration by 1 
        \nWinter: A flutter of snow and crisp air surrounds the target. While this spell remains in effect, the target automatically succeeds at Acrobatics skill checks made to avoid falling while moving across slick or narrow surfaces. The target can move freely through difficult terrain for 1 round by reducing the spell's remaining duration by 1 hour. Difficult terrain created by magic affects the target normally.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 hour/level",
        savingThrow: "Will negates(harmless)",
        spellResistance: "no",
        components: "V, S",
        },
        {
        level: "3",
        name: "Wrathful Mantle",
        type: ["buff"],
        school: "evocation",
        tags: ["force", "light"],
        longDesc: `A shimmering mantle of light shrouds the subject, light like a torch. The subject of the spell gains a +1 resistance bonus on all saving throws per four caster levels (maximum +5 at 20th level). The subject can end the wrathful mantle at any time as a swift action to deal 2d8 points of force damage to all creatures within 5 feet.`,
        castingTime: "1 standard action",
        range: "touch or 5 ft.; see text",
        area: "",
        effect: "",
        targets: "creature touched or all creatures within 5 ft.; see text",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Blade Snare",
        type: ["buff", "control"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell creates an invisible magic field that does not stop weapons (whether manufactured or natural) from moving toward you, but impedes their motion when they are retracted. When you are hit with a melee attack, attempt a caster level check against your opponent's CMD. If your check succeeds, your opponent's attacking weapon or body part becomes caught in the field, as if magically affixed to your body. If your check fails, your opponent may retract its weapon. If your opponent's melee weapon becomes trapped in the field, the opponent may release the weapon and move away from you. If your opponent attacked with a part of its body (such as a fist, a horn, a tail, etc.) or it attacked with a weapon but refuses to release it, your opponent gains the grappled condition. Because you are not using any part of your body to maintain control over your opponent, you do not gain the grappled condition. Once an opponent's weapon is snared, you may attempt a new caster level check against that opponent's CMD on each of your subsequent turns to maintain the grapple. This is a standard action, during which you may make any of the usual grappling actions, but if you choose to pin the opponent, you gain the grappled condition as well. On your opponent's turn, it may try to retract its weapon or limb by attempting a combat maneuver check or Escape Artist check, the DC of which is equal to the spell's saving throw. While blade snare is active, you may make melee attacks and cast spells as normal, though you may not make ranged weapon attacks; the magic field thwarts such attacks. You may not snare more than one limb or weapon in the field at a time. If you already have an opponent's weapon or limb stuck in the field and you are hit by a second melee attack, you must choose which weapon or limb to snare. The other limb or weapon is unaffected by the spell.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Prayer",
        type: ["buff", "control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You bring special favor upon yourself and your allies while bringing disfavor to your enemies. You and each of your allies gain a +1 luck bonus on attack rolls, weapon damage rolls, saves, and skill checks, while each of your foes takes a -1 penalty on such rolls.`,
        castingTime: "1 standard action",
        range: "40 ft.",
        area: "all allies and foes within a 40-ft.-radius burst centered on you",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Elemental Aura",
        type: ["buff", "damage"],
        school: "evocation",
        tags: ["acid", "cold", "electricity", "fire"],
        longDesc: `This spell forms an aura of energy around you, damaging all those that come near you. Choose an energy type: acid, cold, electricity, or fire. Creatures adjacent to you when this spell is cast and at the start of your turn take 2d6 points of energy damage of the selected type. This aura has an additional effect, depending upon the type of energy chosen. Acid: Creatures affected by your aura take 1 point of ongoing acid damage per round for 1 round per three caster levels, and are sickened for the duration of the ongoing acid damage. Cold: Creatures affected by your aura are fatigued. A creature that is already fatigued suffers no additional effect. Electricity: Creatures affected by your aura are staggered for 1 round. Fire: Creatures affected by your aura catch on fire. Creatures adjacent to you are allowed a Reflex save to halve the damage and negate the additional effect. The aura's additional effects do not stack if a creature takes damage from your aura multiple times. You may only have one elemental aura in effect at one time. When you cast this spell to deal acid, cold, electricity, or fire damage, it is a spell of that type.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "Reflex half; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Anchored Step",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `Powerful tendrils grow out of the bottom of your feet or footwear, partially anchoring you to the ground and making it more difficult for others to move you against your will. These tendrils dig into any surface, but leave no trace of your passing. You gain a +10 bonus to your CMD against bull rush, overrun, pull, push, reposition, and trip combat maneuvers, as well as any other effect that would move you from your current position (such as being swallowed whole) or knock you prone. The tendrils slow your movement, however; your speed is reduced by 10 feet (to a minimum of 5 feet). This spell has no effect if you are moving without touching the ground (climbing, flying, swimming, and so on).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 minutes/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Beast Shape I",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `When you cast this spell, you can assume the form of any Small or Medium creature of the animal type. If the form you assume has any of the following abilities, you gain the listed ability: climb 30 feet, fly 30 feet (average maneuverability), swim 30 feet, darkvision 60 feet, low-light vision, and scent. Small animal: If the form you take is that of a Small animal, you gain a +2 size bonus to your Dexterity and a +1 natural armor bonus. Medium animal: If the form you take is that of a Medium animal, you gain a +2 size bonus to your Strength and a +2 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Burrow",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `The subject can burrow at a speed of 15 feet (or 10 feet if it wears medium or heavy armor, or if it carries a medium or heavy load) through sand, loose soil, or gravel, or at a speed of 5 feet through stone. Using burrow requires only as much concentration as walking, so the subject can attack or cast spells normally. The burrowing creature cannot charge or run. Loose material collapses behind the target 1 round after it leaves the area. This spell does not give the target the ability to breathe underground, so when passing through loose material, the creature must hold its breath and take only short trips, or else it may suffocate.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Fly",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `The subject can fly at a speed of 60 feet (or 40 feet if it wears medium or heavy armor, or if it carries a medium or heavy load). It can ascend at half speed and descend at double speed, and its maneuverability is good. Using a fly spell requires only as much concentration as walking, so the subject can attack or cast spells normally. The subject of a fly spell can charge but not run, and it cannot carry aloft more weight than its maximum load, plus any armor it wears. The subject gains a bonus on Fly skill checks equal to 1/2 your caster level. Should the spell duration expire while the subject is still aloft, the magic fails slowly. The subject floats downward 60 feet per round for 1d6 rounds. If it reaches the ground in that amount of time, it lands safely. If not, it falls the rest of the distance, taking 1d6 points of damage per 10 feet of fall. Since dispelling a spell effectively ends it, the subject also descends safely in this way if the fly spell is dispelled, but not if it is negated by an antimagic field.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Gallant Inspiration",
        type: ["buff", "utility"],
        school: "divination",
        tags: [],
        longDesc: `This word of arcane-empowered inspiration often ensures success of a crucial endeavor. Cast this spell when a creature fails an attack roll or skill check. The creature gains a +2d4 competence bonus to the attack roll or skill check retroactively. If the bonus is enough to turn the failure into a success, the roll succeeds.`,
        castingTime: "1 Immediate action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 living creature",
        duration: "Instantaneous",
        savingThrow: "Will negates(harmless)",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "3",
        name: "Gaseous Form",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `The subject and all its gear become insubstantial, misty, and translucent. Its material armor (including natural armor) becomes worthless, though its size, Dexterity, deflection bonuses, and armor bonuses from force effects still apply. The subject gains DR 10/ magic and becomes immune to poison, sneak attacks, and critical hits. It can't attack or cast spells with verbal, somatic, material, or focus components while in gaseous form. This does not rule out the use of certain spells that the subject may have prepared using the feats Silent Spell, Still Spell, and Eschew Materials. The subject also loses supernatural abilities while in gaseous form. If it has a touch spell ready to use, that spell is discharged harmlessly when the gaseous form spell takes effect. A gaseous creature can't run, but it can fly at a speed of 10 feet and automatically succeeds on all Fly skill checks. It can pass through small holes or narrow openings, even mere cracks, with all it was wearing or holding in its hands, as long as the spell persists. The creature is subject to the effects of wind, and it can't enter water or other liquid. It also can't manipulate objects or activate items, even those carried along with its gaseous form. Continuously active items remain active, though in some cases their effects may be moot.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "willing corporeal creature touched",
        duration: "2 min./level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "S, M,DF,",
        },
        {
        level: "3",
        name: "Monstrous Physique I",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `When you cast this spell, you can assume the form of any Small or Medium creature of the monstrous humanoid type. If the form you assume has any of the following abilities, you gain the listed ability: climb 30 feet, fly 30 feet (average maneuverability), swim 30 feet, darkvision 60 feet, low-light vision, and scent. If the form you assume has the aquatic subtype, you gain the aquatic and amphibious subtypes. Small monstrous humanoid: If the form you take is that of a Small monstrous humanoid, you gain a +2 size bonus to your Dexterity and a +1 natural armor bonus. Medium monstrous humanoid: If the form you take is that of a Medium monstrous humanoid, you gain a +2 size bonus to your Strength and a +2 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Pocketful of Vipers",
        type: ["buff", "utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `You set a magical ward upon the create touched, and then if any other creature grapples that creature, 1d3 CR1 summoned venomous snakes appear, slithering out of the creatures pockets and attacking the grappling creature for 1 round/level before disappearing. The snakes appear and immediately start attacking when the target is grappled, and the grappling creature must make a will save or drop the grappled creature immediately, the DC increases by 1 for each snake summoned and that successfully hits and damages the grappling creature. Afterwords the snakes attack on the grappling creatures turn for the rest of the duration or until the grappling creature is dead, and will only attack the original grappling creature.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 hour/level or until discharged (D)",
        savingThrow: "Will negates(harmless)",
        spellResistance: "no",
        components: "V, S, M",
        },
        {
        level: "3",
        name: "Reflexive Barrier",
        type: ["buff", "utility"],
        school: "evocation",
        tags: ["force"],
        longDesc: `In the blink of an eye, you erect a deflective barrier of force to protect one target.
        \nThe target gains a deflection bonus to its AC equal to half your caster level. This bonus lasts until the beginning of your next turn. You can cast this spell as a reaction to an attack, but you must do so before the result of the attack is revealed.`,
        castingTime: "1 immediate action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round",
        savingThrow: "none",
        spellResistance: "no(harmless)",
        components: "V,S",
        },
        {
        level: "3",
        name: "Spider Climb, Communal",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell functions like spider climb, except you divide the duration in 10-minute intervals among the creatures touched.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creatures touched",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M, ",
        },
        {
        level: "3",
        name: "Tactical Formation",
        type: ["buff", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell increases the effectiveness of a group's formation in battle. When cast, all creatures under the effect of the spell must be adjacent to one another, forming an unbroken chain of squares (which may include creatures sharing the same square). This chain does not need to be a straight line. Each target in the chain receives a +2 deflection bonus to AC as long as the targets stay adjacent to at least one other creature affected by the spell; moving more than 5 feet from another target ends the spell with respect to that creature only.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "up to one creature/level, no two of which may be more than 30 ft. apart",
        effect: "",
        targets: "",
        duration: "10 minutes/level",
        savingThrow: "Will negates (harmless);",
        spellResistance: "yes (harmless)",
        components: "V, S",
        },
        {
        level: "3",
        name: "Tail Strike",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: ["draconic"],
        longDesc: `You grow a draconic tail (clothing and armor adjust as necessary), or if you already have a tail, it takes on a draconic appearance. You gain a tail slam attack that deals 1d6 points of damage (1d4 if Small, 1d8 if Large) + your Strength modifier. If you already have a tail attack, you instead extend the reach of your tail attack by 5 feet, or increase the size of the tail by 1 step. If you have a tail sweep attack, this spell increases its radius by 10 feet. If used as part of a full-attack action, the tail slam is considered a secondary attack. You can end this spell before its normal duration by uttering a bestial roar as a swift action. When you do, you can attempt an Intimidate check to demoralize all foes within a 30-foot radius that can hear the roar.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (see text)",
        savingThrow: "",
        spellResistance: "",
        components: "V, M,",
        },
        {
        level: "3",
        name: "Undead Anatomy I",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `When you cast this spell, you can assume the form of any Small or Medium corporeal creature of the undead type, which must be vaguely humanoid-shaped (like a ghoul, skeleton, or zombie). You gain a bite attack (1d6 for Medium forms, 1d4 for Small forms), two claw or slam attacks (1d6 for Medium forms, 1d4 for Small forms), and darkvision 60 feet. If the form you assume has any of the following abilities, you gain the listed ability: climb 30 feet, fly 30 feet (average maneuverability), swim 30 feet, low-light vision, and scent. In this form, you detect as an undead creature (such as with detect undead, but not with magic that reveals your true form, such as true seeing) and are treated as undead for the purposes of channeled energy, cure spells, and inflict spells, but not for other effects that specifically target or react differently to undead (such as searing light). Small undead: If the form you take is that of a Small undead, you gain a +2 size bonus to your Dexterity and a +1 natural armor bonus. Medium undead: If the form you take is that of a Medium undead, you gain a +2 size bonus to your Strength and a +2 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Accursed Glare",
        type: ["control"],
        school: "necromancy",
        tags: ["curse"],
        longDesc: `You channel a fell curse through your glare. If the target fails its saving throw, it begins to obsessively second-guess its actions and attract bad luck. Whenever the target attempts an attack roll or saving throw while the curse lasts, it must roll twice and take the lower result. While you cast this spell, an ally within range of the subject can attempt an Intimidate check as a move action (DC = save DC of this spell); on a success, the ally adds its own glare to yours, granting you a +2 bonus on your caster level check to overcome spell resistance (if any). Multiple allies can attempt Intimidate checks; this bonus stacks.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 day/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Agonizing Rebuke",
        type: ["control"],
        school: "illusion(phantasm)",
        tags: ["emotion", "mind-affecting", "pain"],
        longDesc: `With a word and a gesture, you instill such apprehension in your target that the thought of attacking you causes it mental distress and pain. Each time the target makes an attack against you, targets you with a harmful spell, or otherwise takes and action that would harm you, it takes 2d6 points of nonlethal damage.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 level)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Air Geyser",
        type: ["control"],
        school: "evocation",
        tags: ["air"],
        longDesc: `You create a powerful blast of air capable of flinging an opponent upward. If the target fails its Reflex save, the force of the air deals 2d6 points of bludgeoning damage and hurls the target upward a number of feet equal to 5 x your caster level. If a solid object (such as a ceiling) is encountered, the target strikes the object in the same manner as it would during a normal fall. After this blast of air ceases, the target falls down (unless it was flying), taking falling damage as normal. A successful save means the target takes half damage from the air blast but is not moved by it.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature or object up to Large size",
        duration: "instantaneous",
        savingThrow: "Reflex partial (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Aqueous Orb",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["water"],
        longDesc: `You create a rolling sphere of churning water that can engulf those it strikes. The aqueous orb can move up to 30 feet per round, rolling over barriers less than 10 feet tall. It automatically quenches any nonmagical fires and functions as dispel magic against magical fires as long as those fires are size Large or less. Any creature in the path of the aqueous orb takes 2d6 points of nonlethal damage. A successful Reflex save negates this damage, but a Large or smaller creature that fails its save must make a second save or be engulfed by the aqueous orb and carried along with it. Engulfed creatures are immersed in water and must hold their breath unless capable of breathing water. They gain cover against attacks from outside the aqueous orb but are considered entangled by its churning currents, takes 2d6 points of nonlethal damage at the beginning of their turn each round they remain trapped. Creatures within the orb may attempt a new Reflex save each round to escape into a random square adjacent to the aqueous orb. The orb may hold one Large creature, 4 Medium, or 16 Small or smaller creatures within it. The sphere moves as long as you actively direct it (a move action for you); otherwise, it merely stays at rest and churns in place. An aqueous orb stops if it moves outside the spell's range.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "10-ft.-diameter sphere",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Reflex negates",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Archon's Aura",
        type: ["control"],
        school: "evocation",
        tags: ["good", "lawful"],
        longDesc: `You gain a powerful aura, similar to an archon's aura of menace. Any hostile creature within a 20-foot radius of you must make a Will save to resist the effects of this aura. If the creature fails, it takes a -2 penalty on attack rolls and saving throws and to Armor Class for the duration of this spell, or until it successfully hits you with an attack. A creature that has resisted or broken the cannot be affected again by this particular casting of archon's aura.`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "20-ft. radius centered on you",
        effect: "",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Armor Lock",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `Upon pointing at an armored foe, you cause all of the joints of the target's armor to stiffen as otherworldly chains wrap around the target.
        \nOn a failed Reflex save, a target in heavy metal armor becomes staggered. A target in light or medium metal armor instead becomes entangled. Targets wearing no armor or nonmetallic armor are unaffected. If the target is wearing heavy metal armor and succeeds at its Reflex save, it becomes entangled instead of staggered; a target in light or medium metal armor that succeeds at its saving throw is unaffected by the spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one armored creature",
        duration: "1 round/level (D)",
        savingThrow: "Reflex partial",
        spellResistance: "yes",
        components: "V,S,M",
        },
        {
        level: "3",
        name: "Ash Storm",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["fire"],
        longDesc: `Driving ash blocks all sight (even darkvision) within the spell's area of effect, and falling cinders cause the ground in the area to become difficult terrain.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "cylinder (40-ft. radius, 20 ft. high)",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "3",
        name: "Aura of Cannibalism",
        type: ["control"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `You emanate an aura that saps the strength of others of your kind and channels their energy into you. Each round that a creature starts its turn in the spell's area and shares both your creature type and at least one subtype you possess (if any), that creature must succeed at a Fortitude save or take 1d4 points of damage. You gain a number of temporary hit points equal to the amount of damage you deal with this spell (maximum 10 + your caster level). These temporary hit points go away when the spell ends. As long as you have at least 5 temporary hit points while this spell is in effect, you gain a +1 competence bonus on attack rolls, saving throws, and skill checks. If you have 15 or more temporary hit points, this competence bonus increases to +2.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "20-ft.-radius emanation centered on you",
        effect: "",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Aversion",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You plant a revulsion in the mind of the subject, causing her to avoid an object or location. You must choose a specific object or place. A location chosen in this way can be no larger than a cube measuring 50 feet on a side. The aversion is entirely in the target's mind, so the chosen object or location itself isn't subject to any magical effect. If the target fails her saving throw, she can't come within 60 feet of the chosen object or place. She makes every reasonable effort to avoid the object of the aversion, but will not put herself in danger in order to maintain the aversion. For example, if the object of the aversion is a bridge but a forest fire is closing in and will likely kill the target, she ignores the aversion and crosses the bridge to save herself. If the target must ignore the conditions of the aversion, she is nauseated until she is no longer violating the aversion. If the target succeeds at her saving throw, she is instead sickened while within 60 feet of the object or place, but isn't compelled to stay away from it.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 day/level",
        savingThrow: "Will partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Babble",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell causes the target to break into a fit of bizarre, uncontrollable babbling. The target also becomes nauseated. If the target succeeds at its save, the effects end. If not, the creature continues babbling and is nauseated for the entire duration.
        \nCreatures within 30 feet of the subject that can hear the target's babbling must succeed at a Will save or become fascinated for as long as the babbling persists. Once a creature's fascination ends, it can't become fascinated by the same instance of babble again.
        \nCreatures with an Intelligence score of 2 or lower aren't affected by this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature, see text",
        duration: "1 round/level ",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "3",
        name: "Barrow Haze",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `Barrow haze creates a bank of fog similar to that created by fog cloud, except that the vapors are black and they have a necromantic link to you. The vapors do not interfere with your vision. Because of your link to the haze, if any part of it is within 30 feet of you, any creatures within the haze count as in range for the purpose of using any of your hexes that have a maximum range of 30 feet. For example, suppose you have the slumber hex, you are 25 feet from one edge of the haze, and an opponent is 40 feet farther away at the other extreme of the cloud. You can use your slumber hex on that opponent even though it is actually 65 feet away from you.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "fog spreads in 20-ft. radius, 20 ft. high",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Burdened Thoughts",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You fill a creature's mind with the realization of its earthly weight and responsibilities. Disheartened and wearied by these thoughts, the creature gains heavy encumbrance and is unable to fly (if already flying, it must land as soon as possible). If the creature is three or more size categories larger than you, it's also staggered.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Chain of Perdition",
        type: ["control"],
        school: "evocation",
        tags: ["force"],
        longDesc: `A floating chain of force with hooks at each end appears within an unoccupied space of your choosing within range. This chain is a Medium object that has a 10-foot reach. Physical attacks cannot hit or harm the chain of perdition, but dispel magic, disintegrate, a sphere of annihilation, or a rod of cancellation affects it normally. The chain's AC against touch attacks is 10 + your highest mental stat. The chain can perform the dirty trick (blind or entangle), drag, reposition, and trip combat maneuvers, using your caster level in place of your Combat Maneuver Bonus, and your highest mental stat in place of your Strength or Dexterity modifier. The chain does not provoke attacks of opportunity for making combat maneuvers. It suffers no penalty or miss chance due to darkness, invisibility, or other forms of concealment. As a move action, you can move the chain up to 30 feet. If the chain goes beyond the spell's range or out of your sight, it returns to you. If a creature that the chain attacks has spell resistance, you must make a caster level check (1d20 + caster level) against that spell resistance the first time the chain performs a successful maneuver against that creature. If the chain is successfully resisted, the spell is dispelled. If not, the weapon has its normal full effect on that creature for the duration of the spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "10-ft. chain",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "3",
        name: "Debilitating Pain",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting", "pain"],
        longDesc: `The target is overcome with intense pain, causing it to be stunned on a failed save or dazed for 1 round on a successful save. Once a creature is dazed by this spell it cannot be dazed by it again.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/3 levels",
        savingThrow: "Will partial (see text)",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "3",
        name: "Deep Slumber",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell functions like sleep, except that it affects 10 HD of targets.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "one or more living creatures within a 10-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "1 min./level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Deeper Darkness",
        type: ["control"],
        school: "evocation",
        tags: ["darkness"],
        longDesc: `This spell functions as darkness, except that objects radiate darkness in a 60-foot radius and the light level is lowered by two steps. Bright light becomes dim light and normal light becomes darkness. Areas of dim light and darkness become supernaturally dark. This functions like darkness, but even creatures with darkvision cannot see within the spell's confines. This spell does not stack with itself. Deeper darkness can be used to counter or dispel any light spell of equal or lower spell level.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "object touched",
        duration: "10 min./level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, M,DF,",
        },
        {
        level: "3",
        name: "Disable Construct",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `You can make a melee touch attack to send a pulse into the target, interfering with the magic that endows it with life. If the construct fails its saving throw, it becomes helpless, but it receives a new save each round at the start of its turn to shake off the effect. If the construct is normally immune to magic, the pulse is less effective and the construct receives a +4 bonus on its saving throw.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "construct touched",
        duration: "1 round/level (D)",
        savingThrow: "Will negates",
        spellResistance: "no",
        components: "V, S,",
        },
        {
        level: "3",
        name: "Distracting Cocophony",
        type: ["control"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `The air fills with loud and discordant noise, making concentration difficult. Casting a spell in this area of cacophony requires a concentration check (DC 15 + the level of the spell being cast). Any other concentration checks in the area have their DCs increased by 5. The DC of Perception checks involving hearing is likewise increased by 5.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "20-ft. spread",
        effect: "",
        targets: "",
        duration: "1 round/level(D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V,S",
        },
        {
        level: "3",
        name: "Distressing Tone",
        type: ["control"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `You create a powerful tone that vibrates living flesh. Targets must save or gain the sickened condition. Creatures that are immune to critical hits are immune to this spell.`,
        castingTime: "1 Round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1d4 living creatures",
        duration: "1 round/level",
        savingThrow: "Fort negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Dominate Animal",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell allows you to enchant the targeted animal and direct it with simple commands such as "Attack," "Run," and "Fetch." Suicidal or self-destructive commands (including an order to attack a creature two or more size categories larger than the dominated animal) are simply ignored. Dominate animal establishes a mental link between you and the subject creature. The animal can be directed by silent mental command as long as it remains in range. You need not see the creature to control it. You do not receive direct sensory input from the creature, but you know what it is experiencing. Because you are directing the animal with your own intelligence, it may be able to undertake actions normally beyond its own comprehension. You need not concentrate exclusively on controlling the creature unless you are trying to direct it to do something it normally couldn't do. Changing your instructions or giving a dominated creature a new command is the equivalent of redirecting a spell, so it is a move action.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one animal",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Eldritch Fever",
        type: ["control"],
        school: "necromancy",
        tags: ["curse", "disease", "evil"],
        longDesc: `The target gains the eldritch argue spell blight, which manifests itself as a sickness that is debilitating to spellcasters. A spellcaster with this spellblight is sickened until the curse is removed. When the subject of the curse casts a spell, she is overcome with shaking for 1 round, requiring any spellcasting or the use of a spell-like ability during that time to succeed at a concentration check (DC 15 + twice the spell level of the spell being cast). If she fails the save, the spell and the action to cast it is lost.
        \nWhile a curse, eldritch ague acts much like a disease, and creatures with immunity to disease are also immune to eldritch ague. Remove disease cures eldritch ague; unlike with most spellblights, using this spell to remove the spellblight does not impose a -5 caster level check penalty.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "Instantaneous",
        savingThrow: "fort negates",
        spellResistance: "yes",
        components: "V, S,",
        },
        {
        level: "3",
        name: "Excruciating Deformation",
        type: ["control"],
        school: "transmutation(polymorph)",
        tags: ["evil", "pain"],
        longDesc: `Your touch attack causes your target to become painfully malformed. Its limbs twist and buckle, while its body contorts uncontrollably, shifting and warping. Each round the target suffers excruciating pain and takes 2d6 points of nonlethal damage, 1 point of Dexterity damage, and 1 point of Constitution damage, and its speed is reduced by 10 feet. Once per round as a free action on its turn, the target can attempt a new Fortitude saving throw to resist the spell for 1 round.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "Fortitude partial (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Flash Fire",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `The firearm fires with a blinding flash, even if the firearm is not currently loaded. Every creature within 15 feet of the creature carrying the weapon must succeed at a Fortitude save or be blinded for 1d4 rounds. The creature carrying the firearm takes a -4 penalty on this saving throw. If the firearm is loaded, the ammunition is wasted.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 firearm",
        duration: "instantaneous",
        savingThrow: "Will negates (object); see text",
        spellResistance: "yes (object); see text",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Force Anchor",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["force"],
        longDesc: `You conjure an anchor of pure force that immediately skewers your target on a successful ranged touch attack. If it hits, the attack deals the target 1d4 points of force damage per 2 caster levels (max 5d4) and the anchor becomes firmly lodged in the target's torso. The anchor has no weight, but its wide flukes prevent the target from moving through any space smaller than the creature's size. The anchor also prevents incorporeal targets from moving through solid objects. Whenever the target moves through a square occupied by another creature, the square counts as 2 squares for the purpose of calculating movement, even if the square's occupant is the target's ally.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "one anchor of force",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Forced Mutation",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `The body of the target creature twists and distorts, reshaping into a grotesque figure. Because of the disfigurement, the creature takes a –4 penalty to Constitution and Charisma. The creature also receives one of the following deformities (your choice) from the list in the mutant acquired template: blind, deaf, fragile, fractured mind, lame, poor ability (applied to your choice of Strength, Dexterity, Intelligence, or Wisdom), spasms, and useless arm. The deformity is subject to all limitations described in the mutant template (for example, this spell cannot impose the lame deformity on a creature with a base speed slower than 20 feet).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "yes",
        components: "V,S,M",
        },
        {
        level: "3",
        name: "Halt Undead",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell renders as many as three undead creatures immobile. A nonintelligent undead creature gets no saving throw; an intelligent undead creature does. If the spell is successful, it renders the undead creature immobile for the duration of the spell (similar to the effect of hold person on a living creature). The effect is broken if the halted creatures are attacked or take damage.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "up to three undead creatures, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates (see text)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Haunting Choir",
        type: ["control"],
        school: "necromancy",
        tags: ["mind-affecting", "pain"],
        longDesc: `You create a spectral choir and conduct its tortured, ghostly moans, deluding listeners into believing they are suffering the torments of the dead. The transparent singers occupy a 10-foot cube, but they are intangible and do not interfere with creatures in any physical way, nor can they be attacked. Creatures within 30 feet of the choir experience wracking pain that causes them to take a –2 penalty on attack rolls, skill checks, and ability checks. Individuals who exit the area of effect take these penalties for an additional 2 rounds before the delusion wears off.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "30-ft.-radius emanation",
        effect: "",
        targets: "",
        duration: "concentration + 2 rounds",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Heatstroke",
        type: ["control"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `A wavering red ray projects from your finger. You must succeed on a ranged touch attack with the ray to hit your target. The ray inflicts 1d4 points of nonlethal damage, causing the target to suffer from heatstroke as its body temperature dramatically increases. Except as noted above, this spell otherwise functions as ray of exhaustion. Characters wearing heavy clothing or armor of any sort take a -4 penalty on their saves.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "ray",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "Fortitude partial, see text",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Hold Person",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `The subject becomes paralyzed and freezes in place. It is aware and breathes normally but cannot take any actions, even speech. Each round on its turn, the subject may attempt a new saving throw to end the effect. This is a full-round action that does not provoke attacks of opportunity. A winged creature who is paralyzed cannot flap its wings and falls. A swimmer can't swim and may drown.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one humanoid creature",
        duration: "1 round/level ; see text",
        savingThrow: "Will negates; see text",
        spellResistance: "yes",
        components: "V, S, F,DF,",
        },
        {
        level: "2",
        name: "Hollow Blades",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `All melee and natural attacks from the target deal damage as if the target were one size category smaller than it actually is. While the target is under the effects of this spell, weapons dropped by the target function normally for other creatures, while any melee weapons picked up by the target deal damage as if one size smaller. Ranged attacks and weapons are unaffected by this spell.`,
        castingTime: "1 round",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Hostile Levitation",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `You levitate the target a few inches off the ground, removing solid footing and halving the target's speed. The target also takes a -4 penalty to CMD against bull rush, drag, and reposition attempts. A targeted creature that attacks with a melee or ranged weapon finds itself increasingly unstable; the first attack has a -1 penalty on attack rolls, the second -2, and so on, to a maximum penalty of -5. A full-round action spent stabilizing allows the creature to begin again at -1. This spell fails if cast on a flying creature.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Howling Agony",
        type: ["control"],
        school: "necromancy",
        tags: ["death", "pain"],
        longDesc: `You send wracking pains through the targets' bodies. Because of the pain, affected creatures take a -2 penalty to AC, attacks, melee damage rolls, and Reflex saving throws, and must succeed at a concentration check (DC equal to the DC of this spell) to cast spells. However, if an affected creature spends a move action screaming as loudly as possible, it can act without any other penalties for the remainder of its turn. 'Screaming,'' for the purposes of this spell, includes any vocalization of pain or its telepathic equivalent; creatures that cannot scream (such as creatures without the natural ability to communicate or vocalize) suffer the full effect of the spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Hydrophobia",
        type: ["control"],
        school: "necromancy",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `Targets in the area must succeed at a Will save or become deathly afraid of drowning. If the target is swimming or otherwise submerged in water, it must spend all of its efforts attempting to escape from the water. As long as an affected target remains in water, it takes 1d6 points of nonlethal damage each round as it thrashes about and swallows water. Even out of water, targets cannot imbibe potions or willingly interact with any fluids for the duration of this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "30-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Invisibility Purge",
        type: ["control"],
        school: "evocation",
        tags: [],
        longDesc: `You surround yourself with a sphere of power with a radius of 5 feet per caster level that negates all forms of invisibility. Anything invisible becomes visible while in the area.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Isolate",
        type: ["control"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `You cause the target to become invisible and silent, but only to his allies. Any creature with an attitude of indifferent or worse toward the target, and any creature that wishes the target harm, can see the target normally. The target can see and hear himself, can cast spells with verbal components, and can use command words normally, but any effect that requires allies to see or hear the target does not function. An ally that can see invisible creatures can both see and hear the target of isolate. If the target succeeds at its save, the duration of the spell is reduced to 1 round.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level (D)",
        savingThrow: "Will partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Loathsome Veil",
        type: ["control"],
        school: "illusion(pattern)",
        tags: ["mind-affecting"],
        longDesc: `This spell creates a transparent veil of shifting, multicolored strands of light that form into endlessly varied and alien patterns. One side of the veil, chosen by you at the time of casting, is harmless. The other side twists and turns into impossible shapes, affecting any creature with 60 feet who views the veil. The veil affects a maximum of 24 Hit Dice of creatures. Creatures with the fewest HD are affected first. Among creatures with equal HD, those who are closest to the spell are affected first. The effect is according to the creature's HD. 4 HD or fewer: The creature is nauseated while it can see the veil, nauseated for 1d4 rounds after it last saw the veil, then sickened for 2d4 rounds after it last saw the veil. 8 HD or fewer: The creature is nauseated for 1d4 rounds, sickened while it can see the veil, then sickened for 1d4 rounds after it last saw the veil. 9 or more HD: The creature is sickened while it can see the veil. A successful saving throw ignores all effects of the veil. Sightless creatures are not affected by loathsome veil. Affected creatures can avert or close their eyes to avoid seeing the veil, similar to avoiding a gaze attack.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "transparent pattern 40 ft. long, 20 ft. high",
        targets: "",
        duration: "concentration + 1 round/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Nauseating Trail",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["poison"],
        longDesc: `The target exudes stinking vapors that fill its space. The vapors do not obscure sight, but it nauseates creatures as stinking cloud. The target is immune to these vapors. These vapors persist as the creature moves, filling every square it passes through until it has filled a number of squares equal to 4 x your caster level-if you move through more squares than that, squares in excess of that number at not filled with the vapors. Each creature that enters or ends its turn in the area filled with these vapors must succeed at a Fortitude save or become nauseated for as long as it remains in the square and for 1d4+1 rounds after it leaves.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one willing creature",
        duration: "1 round/level",
        savingThrow: "none and Fortitude negates (see text)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Phantasmal Affliction",
        type: ["control"],
        school: "illusion(phantasm)",
        tags: ["mind-affecting"],
        longDesc: `You cause the creature to believe she has a debilitating affliction. The target can attempt a Will save to recognize the affliction as unreal. If that save fails, the creature suffers an imaginary affliction of your choice. Curse: The target believes she has been cursed. She takes a permanent -4 penalty on attack rolls, saves, ability checks, and skill checks for 1 hour per caster level. After her save to disbelieve, the target attempts a second Will save to negate this effect. Poison: The target believes she has been poisoned. Choose a physical ability score. Each round for 6 rounds, plus 1 round per 5 caster levels, the target takes 1d3 points of damage to the chosen ability score. Each turn, the creature can attempt a Fortitude save to negate the damage and end the ongoing damage. Wasting: The target believes she has contracted a wasting disease. Each day, the creature takes 1d4 points of Constitution damage and becomes fatigued. A successful Fortitude save prevents this damage. Two consecutive successful saves end the effect. Since the affliction exists entirely in the creature's mind, phantasmal affliction is not affected by normal cures like neutralize poison or remove disease, or other effects like delay poison or the Heal skill. Ordinary immunities do not apply in this case (though a creature immune to the affliction receives a +4 bonus on the Will save to disbelieve the illusion). Constitution damage from the affliction can't kill the target. Instead, it causes the target to fall unconscious like other forms of ability damage. Phantasmal affliction is a spell effect and can be dispelled normally. Placebo effectOA counters and dispels phantasmal affliction.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "living creature",
        duration: "see text",
        savingThrow: "Will disbelief, then Fortitude or Will negates (see text)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
            level: "2",
            name: "Placebo Effect",
            type: ["control"],
            school: "illusion(phantasm)",
            tags: ["mind-affecting"],
            longDesc: `The subject temporarily ceases to feel the ill effects of a single ongoing affliction or condition from the following list: blinded, cursed, dazed, deafened, diseased, fatigued, frightened, nauseated, panicked, paralyzed, poisoned, shaken, sickened, staggered, or stunned. If that affliction or condition has a duration, it is suspended until this spell expires. If the subject has multiple instances of the same type of affliction (such as multiple diseases), a single casting of this spell can suspend only one of them. Placebo effect doesn’t remove or temporarily negate any damage that the affliction may have already caused, nor does it provide protection against receiving such conditions again.`,
            castingTime: "1 standard action",
            range: "touch",
            area: "",
            effect: "",
            targets: "creature touched",
            duration: "1 minute/level",
            savingThrow: "Will disbelief (harmless)",
            spellResistance: "yes(harmless)",
            components: "V, M,",
        },
        {
        level: "3",
        name: "Psychic Leech",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `The target experiences feelings of ennui and lethargy, becoming fatigued for the spell's duration. While the target is fatigued and is within the spell's range, you gain a +2 enhancement bonus to Strength and Dexterity. On a successful save, the target is fatigued for only 1d4 rounds and you receive no bonus. This spell has no effect if it targets a creature that is already fatigued.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 minute/level (D)",
        savingThrow: "Will partial",
        spellResistance: "yes",
        components: "S, ",
        },
        {
        level: "3",
        name: "Pugwampi's Grace",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `Hated by adventurers throughout the Inner Sea region, the gremlins known as pugwampis infect those around them with a malignant form of unluck-an effect that this spell emulates. If the target fails its Will save, it becomes infused with the so-called 'grace of the pugwampi.' A creature affected by this spell must roll two d20s whenever a situation calls for a d20 roll (such as an attack roll, a skill check, or a saving throw) and must use the lower of the two results generated. As with the aura shed by actual pugwampies, this spell has no effect on animals, gremlins, or gnolls. The effects of this spell are negated as long as a target gains any sort of luck bonus to a d20 roll (such as those granted by a luckstone or divine favor), but the spell's duration is not impacted by these effects. If the luck bonus goes away before the pugwampi's grace effect ends, the unluck returns and remains until the spell's normal duration runs out.`,
        castingTime: "1 standard action",
        range: "short (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature (see below)",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Quell Energy",
        type: ["control"],
        school: "abjuration",
        tags: [],
        longDesc: `You reduce the target creature's ability to tap into a single energy type (acid, cold, electricity, fire, or sonic) of your choice. This reduces damage of the selected type the creature deals with spells, spell-like abilities, and supernatural abilities by 10 points. Multiple castings of this spell stack. Damage from sources other than the creature, such as objects and magic items, is not reduced. If the damage of one of the creature's effects is negated entirely, any additional effects associated with that damage (such being stunned by sound burst o r set on fi re by a fi re e lemental) a re also negated. At 13th level, you reduce the target's damage by 20 points, and at 19th level, you reduce the target's damage by 30 points. If the target succeeds on its saving throw, the spell's duration is reduced to 1 round.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "Will partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Raging Rubble",
        type: ["control"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `You animate an area of rubble, gravel, or other small stones, creating a dangerous, rolling area of debris. The animated rubble has a space of 10 feet and acts like a swarm, damaging (1d6 hit points) and distracting (DC 12) anything within it. As a move action, you can direct the rubble to move up to 10 feet. If the rubble is attacked, treat it as a Medium animated object with the young creature simple template and the swarm subtype.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one swarm of stones",
        targets: "",
        duration: "concentration + 2 rounds",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Ray of Exhaustion",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `A black ray projects from your pointing finger. You must succeed on a ranged touch attack with the ray to strike a target. The subject is immediately exhausted for the spell's duration. A successful Fortitude save means the creature is only fatigued. A character that is already fatigued instead becomes exhausted. This spell has no effect on a creature that is already exhausted. Unlike normal exhaustion or fatigue, the effect ends as soon as the spell's duration expires.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "ray",
        targets: "",
        duration: "1 min./level",
        savingThrow: "Fortitude partial; see text",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Reckless Infatuation",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You fill your target with feelings of intense infatuation for a specific individual known to the target. At the time of the casting, you designate a single creature as the focus of the target's desire. Thereafter, the target does all it can to remain within 30 feet of the object of its desire. If the target moves outside this range, it gains the staggered condition until it is again near the focus of its desire. If remaining within 30 feet of the focus of its affection would place the target in obvious physical danger, the target can attempt a second save to break the spell's effect. Reckless infatuation counters unadulterated loathing.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 day/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Sands Of Time",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `You temporarily age the target, immediately advancing it to the next age category. The target immediately takes the age penalties to Strength, Dexterity, and Constitution for its new age category, but does not gain the bonuses for that category. A creature whose age is unknown is treated as if the spell advances it to middle age. Ageless or immortal creatures are immune to this spell. If you cast this on an object, construct, or undead creature, it takes 3d6 points of damage + 1 point per caster level (maximum +15) as time weathers and corrodes it. This version of the spell has an instantaneous duration.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "touched creature or object",
        duration: "10 minutes/level or instantaneous (see text)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Shadowmind",
        type: ["control"],
        school: "illusion",
        tags: [],
        longDesc: `You dim your targets' perceptions of light and shadow, convincing them the space they occupy is dark. Each creature that fails its save perceives the world around it as one light level darker than its true illumination level. The spell does not change the light level outside of the targets' perception, and does not create magical darkness. However, the spell creates an illusion of darkness rather than actual darkness, so low-light and darkvision don't allow a target to see in the conditions created by the spell. Even targets that see normally through magical darkness suffer a loss of vision from this spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "up to one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Shifting Sand",
        type: ["control"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `You cause an earthen or sandy surface to shift and churn within the area. The shifting sand is considered difficult terrain. Acrobatics checks in the area take a penalty equal to your caster level (maximum +10). Creatures entering or beginning their turn in the shifting sand must make a Reflex save each round or become entangled until the beginning of their next turn. If they attempt to move while entangled, they must make a second Reflex save or fall prone. As a move action, you may move the area of shifting sand up to 10 feet in any direction. Creatures that are entangled or prone in the spell's area are carried along with the shifting sand in the same direction if possible. This movement does not provoke attacks of opportunity. Unattended Medium or smaller objects may also be carried along or shallowly buried by the shifting sand.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "20-ft. spread",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "Reflex negates; see text",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Sleet Storm",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["cold"],
        longDesc: `Driving sleet blocks all sight (even darkvision) within it and causes the ground in the area to be icy. A creature can walk within or through the area of sleet at half normal speed with a DC 10 Acrobatics check. Failure means it can't move in that round, while failure by 5 or more means it falls (see the Acrobatics skill for details). The sleet extinguishes torches and small fires.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "cylinder (40-ft. radius, 20 ft. high)",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "3",
        name: "Slow",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `An affected creature moves and attacks at a drastically slowed rate. Creatures affected by this spell are staggered and can take only a single move action or standard action each turn, but not both (nor may it take full-round actions). Additionally, it takes a -1 penalty on attack rolls, AC, and Reflex saves. A slowed creature moves at half its normal speed (round down to the next 5-foot increment), which affects the creature's jumping distance as normal for decreased speed. Multiple slow effects don't stack. Slow counters and dispels haste.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Spike Growth",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `Any ground-covering vegetation in the spell's area becomes very hard and sharply pointed without changing its appearance. In areas of bare earth, roots and rootlets act in the same way. Typically, spike growth can be cast in any outdoor setting except open water, ice, heavy snow, sandy desert, or bare stone. Any creature moving on foot into or through the spell's area takes 1d4 points of piercing damage for each 5 feet of movement through the spiked area. Any creature that takes damage from this spell must also succeed on a Reflex save or suffer injuries to its feet and legs that slow its land speed by half. This speed penalty lasts for 24 hours or until the injured creature receives a cure spell (which also restores lost hit points). Another character can remove the penalty by taking 10 minutes to dress the injuries and succeeding on a Heal check against the spell's save DC. Magic traps are hard to detect. A rogue (only) can use the Perception skill to find a spike growth. The DC is 25 + spell level, or DC 28 for spike growth (or DC 27 for spike growth cast by a ranger). Spike growth can't be disabled with the Disable Device skill.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "one 20-ft. square/level",
        effect: "",
        targets: "",
        duration: "1 hour/level",
        savingThrow: "Reflex partial",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "3",
        name: "Spiked Pit",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `This spell functions as create pit, except that the pit is lined with wickedly sharp spikes along its bottom and walls and has a maximum depth of 50 feet. Creatures who fall into the pit take falling damage as normal, plus 2d6 points of piercing damage from the spikes. Any creature or object coming into contact with the spikes along the walls, such as a creature trying to climb out, or rope or other typical aids to climbing, takes 1d6 points of piercing damage each round they are in contact with the walls. For those willing to accept the damage incurred while climbing, the pit's walls have a Climb DC of 20.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "10-ft.-by-10-ft. hole, 10 ft. deep/2 levels",
        targets: "",
        duration: "1 round + 1 round/level",
        savingThrow: "Reflex negates",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Stage Fright",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `You fill your targets with the sudden fear of failure. A creature that fails its saving throw takes a -4 penalty on ability checks, skill checks, and any checks that require concentration (such as casting a spell in difficult circumstances or operating a complex device).`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "1 creature/level, no two of which may be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Stinking Cloud",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `Stinking cloud creates a bank of fog like that created by fog cloud, except that the vapors are nauseating. Living creatures in the cloud become nauseated. This condition lasts as long as the creature is in the cloud and for 1d4+1 rounds after it leaves. (Roll separately for each nauseated character.) Any creature that succeeds on its save but remains in the cloud must continue to save each round on your turn. This is a poison effect.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "cloud spreads in 20-ft. radius, 20 ft. high",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Fortitude negates; see text",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Suggestion",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["language-dependent", "mind-affecting"],
        longDesc: `You influence the actions of the target creature by suggesting a course of activity (limited to a sentence or two). The suggestion must be worded in such a manner as to make the activity sound reasonable. Asking the creature to do some obviously harmful act automatically negates the effect of the spell. The suggested course of activity can continue for the entire duration. If the suggested activity can be completed in a shorter time, the spell ends when the subject finishes what it was asked to do. You can instead specify conditions that will trigger a special activity during the duration. If the condition is not met before the spell duration expires, the activity is not performed. A very reasonable suggestion causes the save to be made with a penalty (such as -1 or -2).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 hour/level or until completed",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, M,",
        },
        {
        level: "3",
        name: "Sundered Serpent Coil",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `This spell functions like black tentacles, except it creates a Large decapitated snake, which erupts from the ground and grapples a creature you specify within its 5-foot reach. As a standard action, you can command the snake to release its grappled target and direct it to attack a different creature.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "one 5-foot square",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Thunderstomp, Greater",
        type: ["control"],
        school: "evocation",
        tags: ["earth"],
        longDesc: `This spell functions as thunderstomp, except as noted. It allows you target multiple creatures with this spell, including creatures more than one size category larger than you. When you attempt the combat maneuver check, apply its result to each creature within the area.`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "60-ft. line",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Unadulterated Loathing",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You fill the target with a terrible loathing aimed at a specific creature. At the time of the casting, you designate a single creature as the object of the target's revulsion. Thereafter, the target does all it can to remain at least 60 feet away from the object of its loathing. As soon as the target moves within this range, it becomes nauseated until it can again get away from the object of its revulsion. If traveling beyond 60 feet of the object of its loathing would place the target in obvious physical danger, the target can attempt a second save to break the spell's effect. Unadulterated loathing counters reckless infatuation.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 day/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Vision of Hell",
        type: ["control"],
        school: "illusion(glamer)",
        tags: ["evil", "fear"],
        longDesc: `You overlay a realistic illusion of a terrifying hellscape upon an area. Structures, equipment, and creatures within the area are not hidden, though environmental features take on an infernal appearance. While you are prepared for these images and are not affected by them, any other creature within the area must make a Will save or become shaken and also take a -2 penalty on saves versus fear effects; the fear and penalty persists as long as the creature remains in the area. Devils and any lawful evil creatures suffer no negative effects from this spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "50-ft.-radius emanation",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "Will negates",
        spellResistance: "no",
        components: "V, M,",
        },
        {
        level: "3",
        name: "Wall of Nausea",
        type: ["control"],
        school: "illusion(pattern)",
        tags: ["mind-affecting"],
        longDesc: `You create a transparent, shimmering wall through which creatures and objects appear to be wildly distorted to viewers. Any creature that passes through the wall is immediately assailed by overwhelming vertigo, becoming nauseated for 1 round unless it succeeds at a Fortitude save; if nauseated, the creature must also succeed at a DC 12 Acrobatics check or fall prone. Creatures gain partial concealment (20% miss chance) against creatures on the other side of the wall. The wall must be vertical and rectangular. It need not touch the ground. The wall must be continuous and unbroken when formed. If its surface is broken by any object or creature when it is cast, the spell fails.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "transparent wall whose area is up to one 10-ft. square/level",
        targets: "",
        duration: "1 round/level",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Waves of Blood",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You cause torrents of roiling blood to push your opponents away from you. This wave attempts a bull rush combat maneuver against all creatures within its area of effect, and you bull rush creatures of any size in this way. Attempt a single combat maneuver check and apply the result to each creature within the area. Your CMB for this bull rush is equal to your caster level plus your highest mental modifier. This bull rush doesn't provoke attacks of opportunity. Any creature in the area must also succeed at a Fortitude saving throw or become sickened for 1d6 rounds by the tide of blood. The area covered by the cone remains slick for 1 round, requiring a successful DC 10 Acrobatics check from any creature attempting to move within it (as if moving on uneven ground). Any creature that falls prone due to failing the check must succeed at a Fortitude save or become sickened until it stands back up.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous and 1 round; see text",
        savingThrow: "Reflex negates, Fortitude negates (see text)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Siphon Might",
        type: ["control", "buff"],
        school: "necromancy",
        tags: [],
        longDesc: `You drain the might of the target and transfer that power to another creature. The subject takes a penalty to Strength equal to 1d6 + 1 per 2 caster levels (maximum 1d6 + 5). This effect can't cause the subject's Strength score to drop below 1. A successful Fortitude save halves this penalty. This penalty doesn't stack with itself or the penalty applied from ray of enfeeblement. You can grant any one creature adjacent to you (including yourself) an enhancement bonus to Strength equal to the Strength penalty imposed by this spell.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "Fortitude half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Earth Tremor",
        type: ["control", "damage"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `You strike the ground and unleash a tremor of seismic force, hurling up earth, rock, and sand. You choose whether the earth tremor affects a 30-foot line, a 20-foot cone-shaped spread, or a 10-foot-radius spread centered on you. The space you occupy is not affected by earth tremor. The area you choose becomes dense rubble that costs 2 squares of movement to enter. Dense rubble adds 5 to the DC of Acrobatics checks and adds 2 to the DC of Stealth checks. Creatures on the ground in the area take 1d4 points of bludgeoning damage per caster level you have (maximum 10d4) or half damage on a successful save. Medium or smaller creatures that fail their saves are knocked prone. This spell can be cast only on a surface of earth, sand, or stone. It has no effect if you are in a wooden or metal structure or if you are not touching the ground.`,
        castingTime: "1 standard action",
        range: "up to 30 ft. (see text)",
        area: "30-ft. line, 20-ft. cone-shaped spread, or 10-ft.-radius spread (see text)",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half (see text)",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Thorny Entanglement",
        type: ["control", "damage"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell functions as entangle, except the plants also grow thorns and can fling them up to 15 feet. Any creature that moves within 15 feet of the spell's area is attacked once on its turn by the animated plants. The plants use your caster level as their base attack bonus and add your highest mental to the attack roll. A volley of thorns counts as a thrown weapon and deals 2d6 points of piercing damage on a successful hit. A creature that enters the spell's area or ends its turn there automatically takes 2d6 points of piercing damage.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "plants in a 40-ft.-radius spread",
        effect: "",
        targets: "",
        duration: "1 min./level (D)",
        savingThrow: "Reflex partial (see text)",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "3",
        name: "Call the Void",
        type: ["control", "damage", "buff", "utility"],
        school: "evocation",
        tags: [],
        longDesc: `This spell surrounds you with an aura of nothingness that channels mysterious energies. Creatures adjacent to you when this spell is cast and at the start of your turn take 2d6 points of damage. In addition, creatures affected by your aura are fatigued, cannot breathe, and cannot speak or cast spells with somatic components. Creatures adjacent to you are allowed a Reflex save to halve the damage and negate the fatigue effect, but cannot breathe or speak regardless of whether their save is successful as long as they are adjacent to you.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "Reflex for half; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Blast Barrier",
        type: ["control", "utility"],
        school: "transmutation",
        tags: ["sonic"],
        longDesc: `When you cast blast barrier, you cause a rippling wall of loose earth, mud, snow, sand, or gravel to spring up in a designated space within the spell's range. This wall provides total cover to all Large or smaller creatures and objects. The barrier can only spring up in an area of natural, unworked ground. The energy that forms the wall's matrix is unstable, and you must concentrate to maintain the wall's shape. A blast barrier has an AC of 9, hardness 0, and 5 hit points per caster level. When a blast barrier reaches 0 hit points, or when you cease concentrating on maintaining it, the energies that maintain the barrier's shape fail with explosive results, sending sharp chunks of the materials comprising the wall and magical energy out along both sides. Any creature that is adjacent to a blast barrier when it explodes takes 2d6 points of slashing damage and 1d6 points of sonic damage per 3 caster levels (maximum 6d6). A successful Reflex save halves the total damage done. Spell resistance applies as well. This instability can make using a blast barrier risky, but many of the spellcasters that pioneered the spell became experts at its tactical applications, often using the barriers to cover an escape while lobbing spells and parting shots, hoping to trigger the barrier's destruction just as their would-be pursuers approached.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5ft./2 levels)",
        area: "",
        effect: "1-ft.-thick wall up to 10 ft. high by 20 ft. wide",
        targets: "",
        duration: "concentration, up to 1 round/2 levels",
        savingThrow: "Reflex half (see below)",
        spellResistance: "yes (see below)",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Distracting Cacophony",
        type: ["control", "utility"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `The air fills with loud and discordant noise, making concentration difficult. Casting a spell in this area of cacophony requires a concentration check (DC 15 + the level of the spell being cast). Any other concentration checks in the area have their DCs increased by 5. The DC of Perception checks involving hearing is likewise increased by 5.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "20-ft. spread",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Draconic Malice",
        type: ["control", "utility"],
        school: "enchantment",
        tags: ["draconic"],
        longDesc: `You surround yourself with a palpable aura of draconic fear and dread. Living creatures within this aura that are normally immune to fear or mind-affecting abilities lose those immunities against your spells, spell-like abilities, and supernatural abilities that create fear effects, as well as any Intimidate checks you attempt to demoralize foes.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "10-foot aura centered on you",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Shining Cord",
        type: ["control", "utility"],
        school: "evocation",
        tags: ["force"],
        longDesc: `When you cast this spell, you make a ranged touch attack against a single opponent within 30 feet. If you hit, a thin silver strand extends from your body to its, forming a connection that allows you to anticipate its actions. For the duration of the spell, you receive a +5 insight bonus on all Perception and Sense Motive checks opposed by the target. You gain a +5 insight bonus on all Spellcraft checks made to identify your opponent's spell as part of a counterspelling attempt. Finally, you gain a +2 dodge bonus to your AC against attacks made against you by the target.
        \nLastly, if either you or the target moves more than 30 feet away from the other, the cord crackles with a surge of light and sends a blast of force along its length to the other end. This blast deals 1d6 points of damage per two caster levels (maximum 10d6) and stuns the one who moved out of range for 1 round—a successful Fortitude save halves the damage and negates the stun effect. This blast ends the spell and severs the connection between you and your target.
        \nAlthough the shining cord makes a visible connection between you and your target, creatures can move through it without ill effect. The cord even passes through solid objects as necessary to maintain the connection between you and the target.`,
        castingTime: "1 standard action",
        range: "30 ft",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "1 round/level or instantaneous see text",
        savingThrow: "fortitude partial",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Strangling Hair",
        type: ["control", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `Your hair animates and extends to grapple and constrict an opponent. Make a grapple check against the target using your caster level as the base attack bonus plus a bonus equal to your highest mental modifier. This grapple check does not provoke attacks of opportunity. If your hair succeeds in grappling a foe, that creature takes 1d6 points of damage or your unarmed strike damage, whichever is greater, and gains the grappled condition. Your hair receives a +5 bonus on grapple checks made against opponents it is already grappling, but cannot move foes or pin foes. Each round that your hair succeeds on a grapple check, it deals an additional 1d6 points of damage. The CMD of your hair, for the purposes of escaping the grapple, is equal to 10 + its CMB. Once you choose a target, your hair continues to attack that target independently of your own actions. You may designate a new target as a move action, which causes your hair to release its current target (if any) and attack the new target that round. Your hair cannot be targeted as a separate creature, but it can be dispelled.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "concentration, up to 1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Acid Rain",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["acid"],
        longDesc: `You summon a downpour of acid in a 20ft radius, each creature within the area or those who enter or end their turn in it takes 1d6 acid damage per caster level (max 5d6), reflex for half. Creatures who fail this reflex save who have DR magic, cold iron, silver, or adamantine, have it reduced by 5 for 3 rounds (this doesn't stack).`,
        castingTime: "1 standard action",
        range: "short (25 ft. + 5 ft./2 levels)",
        area: "20-ft. radius, 20 ft. high",
        effect: "",
        targets: "",
        duration: "1 round/2 levels;",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "3",
        name: "Battering Blast",
        type: ["damage"],
        school: "evocation",
        tags: ["force"],
        longDesc: `You hurl a fist-sized ball of force resembling a sphere of spikes to ram a designated creature or object. You must succeed on a ranged touch attack to strike your target. On a successful hit, you deal 1d6 points of force damage per two caster levels (maximum 5d6). For every 4 caster levels you possess beyond 4th, you gain a second ball of force. A creature struck by any of these is subject to a bull rush attempt. The force has a Strength modifier equal to your highest mental modifier. The CMB for the force's bull rush uses your caster level as its base attack bonus, adding the force's Strength modifier and a +10 bonus for each additional blast directed against the same target. Each sphere of force makes its own separate bull rush attempt-if multiple spheres strike one target, you make multiple CMB checks but only take the highest result to determine success. If the bull rush succeeds, the force pushes the creature away from you in a straight line, and the creature must make a Reflex save or fall prone. This spell pushes an unattended object struck by it 20 feet away from you, provided it weighs no more than 25 pounds per level (maximum 250 pounds). This spell cannot move creatures or objects beyond your range. Used on a door or other obstacle, the spell attempts a Strength check to destroy it if the sheer damage inflicted by the spell doesn't do the job.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature or unattended object",
        duration: "instantaneous",
        savingThrow: "Reflex partial (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Blast Rod",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `A blast of electricity bursts from your outstretched hand, dealing 1d6 electrical damage per caster level (up to a max of 10d6 damage at caster level 10) to targets in its path. A successful Reflex save reduces the damage by half.`,
        castingTime: "1 standard action",
        range: "30ft",
        area: "30ft. cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Burst of Nettles",
        type: ["damage"],
        school: "conjuration",
        tags: ["acid"],
        longDesc: `You release a burst of barbed, acid-filled nettles. Creatures caught in the burst take 3d6 points of damage plus an equal amount of acid damage on the next round. Those that save take half damage from the initial burst and no damage on the next round.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "10-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Call Lightning",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `Immediately upon completion of the spell, and once per round thereafter, you may call down a 5-foot-wide, 30-foot-long, vertical bolt of lightning that deals 3d6 points of electricity damage. The bolt of lightning flashes down in a vertical stroke at whatever target point you choose within the spell's range (measured from your position at the time). Any creature in the target square or in the path of the bolt is affected. You need not call a bolt of lightning immediately; other actions, even spellcasting, can be performed first. Each round after the first you may use a standard action (concentrating on the spell) to call a bolt, and each time that you do, the damage increases by 1d6 (to a max of 10d6). You may call a total number of bolts equal to your caster level (maximum 10 bolts). If you are outdoors and in a stormy area-a rain shower, clouds and wind, hot and cloudy conditions, or even a tornado (including a whirlwind formed by a djinni or an air elemental of at least Large size)-each bolt deals 3d10 points of electricity damage instead of 3d6. This spell functions indoors or underground but not underwater.`,
        castingTime: "1 round",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "one or more 30-ft.-long vertical lines of lightning",
        targets: "",
        duration: "1 min./level",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Chain Missiles",
        type: ["damage"],
        school: "evocation",
        tags: ["force"],
        longDesc: `You fire a potent missile of force, which once striking a creature deals 1d4 points of force damage per caster level (max 10d4), then explodes outwards firing 1 magic missle per caster level (max 10 missiles) at random creatures within 30ft of the target, each dealing 1d4+1 force damage.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "3",
        name: "Contagious Cold",
        type: ["damage"],
        school: "transmutation",
        tags: ["cold"],
        longDesc: `The target creature is covered in blistering cold aura that deals 2d6 points of cold damage each round. The subject can attempt a Fortitude saving throw each round to reduce the damage by half. If a creature dies while this was still effecting them the spell jumps to a new enemy within 30ft, increasing the duration by 1d6 rounds, and increasing the cold damage by 2d6. Taking 5 or more points of fire damage reduces the duration by 1 round, and creatures of the fire subtype have the duration reduced by half automatically.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "Fortitude half (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Damnation",
        type: ["damage"],
        school: "evocation",
        tags: ["good"],
        longDesc: `You pass judgment on your enemies' intentions and punish them with holy power. Each creature in the spell's area takes 1d8 points of damage per spell level, determined by the most powerful effect with the evil descriptor either affecting that creature or in its spell repertoire. A caster who prepares spells takes this damage based on the highest-level evil spell he prepared that day, even if he already cast that spell. A spontaneous spellcaster takes this damage based on the highest-level evil spell she knows, even if she has no remaining spell slots available to cast that spell. A creature with evil spell-like abilities takes this damage based on the highest-level evil spell-like ability it can use. A creature who doesn't cast spells but is the willing beneficiary of evil spells takes this damage based on the highest-level evil spell currently affecting it, including spells that affect an area such as desecrate. A creature subject to the harmful effects of an evil spell are unaffected unless it voluntarily accepted the spell's effects.`,
        castingTime: "1 standard action",
        range: "",
        area: "30-ft.-radius burst centered on you",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Will half",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "3",
        name: "Diamond Spray",
        type: ["damage"],
        school: "evocation",
        tags: ["earth"],
        longDesc: `A cone of tiny, sparkling slivers as hard and sharp as fled diamonds springs from your outstretched fingers at tremendous speed. Any creature in the area of the torrent takes 1d6 points of slashing damage per caster level (maximum 10d6). These magical slivers are treated as adamantine and cold iron for the purpose of overcoming damage reduction. In addition, this spell bypasses up to 1 point of an object's hardness per 2 caster levels (maximum 10).`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V,S,M",
        },
        {
        level: "3",
        name: "Elemental Prod",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity", "fire", "cold", "force"],
        longDesc: `You touch a target and deal 1d6 points of damage per caster level (max 10d6) in two damage types (up to a max of 20d6). The damage types are chosen randomly by rolling 2d4, each element being a result of the dice (1: fire, 2: electricity, 3: cold, 4: force). Creatures of the elemental subtype are also stunned for 1 round. A will save reduces this damage by half, and negates the stun for elementals. This only scales and counts as the elements of the damage types it rolls.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "instantaneous",
        savingThrow: "will halves",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Fire Trail",
        type: ["damage"],
        school: "transmutation",
        tags: ["fire"],
        longDesc: `When you cast this spell, flammable liquid oozes from your pores, dripping onto the ground and spontaneously combusting. The flame does not harm you. During this spell's duration, each time you leave your space, you create a trail of fire that burns within the spaces you move through for 1 round before it burns out. You can leave up to 60 feet of flame trail each round, assuming you are Small or Medium. If you are larger than Medium, the maximum trail length is reduced based on your size. If you are Large, you can leave a trail up to 30 feet long (and 10 feet wide), and if you are Huge, you can leave a trail up to 15 feet long (and 15 feet wide); even larger casters can only leave a trail up to 10 feet long (and as wide as your space) each round. You choose where to leave a flame trail. Creatures that start their turn adjacent to the flame trail take 1d6 points of fire damage. Creatures that start their turn within the flame trail or that enter an area of flame take a number of points of fire damage equal to 1d6 + 1 per caster level (maximum +10). If a creature moves into an area of the flame trail multiple times in a round, it takes this damage each time it enters the area of the flame trail. Flammable objects in or adjacent to the fire trail catch fire.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "trail of flame that follows the caster's movements; see text",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Fireball",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `A fireball spell generates a searing explosion of flame that detonates with a low roar and deals 1d6 points of fire damage per caster level (maximum 10d6) to every creature within the area. Unattended objects also take this damage. The explosion creates almost no pressure. You point your finger and determine the range (distance and height) at which the fireball is to burst. A glowing, pea-sized bead streaks from the pointing digit and, unless it impacts upon a material body or solid barrier prior to attaining the prescribed range, blossoms into the fireball at that point. An early impact results in an early detonation. If you attempt to send the bead through a narrow passage, such as through an arrow slit, you must 'hit' the opening with a ranged touch attack, or else the bead strikes the barrier and detonates prematurely. The fireball sets fire to combustibles and damages objects in the area. It can melt metals with low melting points, such as lead, gold, copper, silver, and bronze. If the damage caused to an interposing barrier shatters or breaks through it, the fireball may continue beyond the barrier if the area permits; otherwise it stops at the barrier just as any other spell effect does.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "20-ft.-radius spread",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
            level: "3",
            name: "Wildfire Blast",
            type: ["damage"],
            school: "evocation",
            tags: ["fire"],
            longDesc: `This spell causes an explosion similar to a fireball, dealing 1d6 points of fire damage per 2 caster levels (maximum 5d6) to every creature within the area. For every creature that the fireball damages, you gain 2 elemental spell power for 5 rounds, increased to 5 if the creature fails their reflex save.`,
            castingTime: "1 standard action",
            range: "medium (100 ft. + 10 ft./level)",
            area: "20-ft.-radius spread",
            effect: "",
            targets: "",
            duration: "instantaneous and 5 rounds",
            savingThrow: "Reflex half",
            spellResistance: "yes",
            components: "V, S, M,",
        },
        {
            level: "2",
            name: "Molten Blast",
            type: ["damage"],
            school: "evocation",
            tags: ["fire"],
            longDesc: `You cause a blast of molten magma to errupt around the creature. This requires a ranged touch attack to hit. The blast deals 2d6 points of fire damage per caster level (max 20d6). This spell can only be cast on the same round as you cast another critical spell, and can only target one of the creatures struck by that critical spell. You are staggered on the round after you cast this spell.`,
            castingTime: "1 movement action",
            range: "medium (100 ft. + 10 ft./level)",
            area: "",
            effect: "",
            targets: "1 creature",
            duration: "instantaneous",
            savingThrow: "none",
            spellResistance: "yes",
            components: "V, S, M,",
        },
        {
            level: "4",
            name: "Gathering The Storm",
            type: ["damage"],
            school: "evocation",
            tags: ["electricity"],
            longDesc: `You unleash a blast of electricity out from yourself, dealing 1d8 points of electricity damage per 2 caster levels (max 10d8) to every creature within the area. For every creature that fails their save against this, you gain a charged bolt that you can unleash as a swift action. The bolt deals the same damage as the spell, has a range of close (25 ft. + 5 ft./2 levels), and requires a ranged touch attack to hit. As long as you have charged bolt stacks, one of your hands is considered occupied as if carrying a charged spell.`,
            castingTime: "full-round",
            range: "",
            area: "60ft. radius burst centered on you",
            effect: "",
            targets: "",
            duration: "instantaneous and 1 minute",
            savingThrow: "reflex halves and none; see text",
            spellResistance: "yes",
            components: "V, S, M,",
        },
        {
        level: "3",
        name: "Firestream",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `A rushing stream of fire sprays from your outstretched hand, dealing 2d6 points of fire damage to every creature in the area. Each round you continue to concentrate on the spell, you can select a new area for it to affect. Firestream sets fire to combustibles and damages objects in the area. It can melt metals with low melting points, such as lead, gold, copper, silver, and bronze. If the damage caused to an interposing barrier shatters or breaks through it, the firestream may continue beyond the barrier if the area permits; otherwise it stops at the barrier just as any other spell effect does.`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "20-ft. line",
        effect: "",
        targets: "",
        duration: "concentration, up to 1 round/level; see text",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Force Punch",
        type: ["damage"],
        school: "evocation",
        tags: ["force"],
        longDesc: `This spell charges your hand with telekinetic force. Your successful melee touch attack deals 1d4 points of force damage per level (maximum 10d4) and causes the target to be pushed away from you in a straight line up to 5 feet per two caster levels. For every size category of the target above Medium, reduce the distance pushed by 5 feet (-5 feet for Large, -10 feet for Huge, -15 for Gargantuan, and -20 feet for Colossal) to a minimum of 0 feet. A successful Fortitude save negates the movement but not the damage.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Fungal Infestation",
        type: ["damage"],
        school: "necromancy",
        tags: ["disease"],
        longDesc: `You coat the target in necrotic fungus that makes its flesh soft and fragile. Toadstools, ringworm, and other disgusting fungal growths sprout from its skin. The target takes 1d3 points of Charisma damage. Any physical attack against the target automatically adds 1d6 points of bleed damage.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1d3 days",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Gloomblind Bolts",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["shadow"],
        longDesc: `You create one or more bolts of negative energy infused with shadow pulled from the Shadow Plane. You can fire one bolt, plus one for every four levels beyond 5th (to a maximum of three bolts at 13th level) at the same or different targets, but all bolts must be aimed at targets within 30 feet of each other and require a ranged touch attack to hit. Each bolt deals 4d6 points of damage to a living creature or heals 4d6 points of damage to an undead creature. Furthermore, the bolt's energy spreads over the skin of creature, possibly blinding it for a short time. Any creature struck by a bolt must succeed at a Reflex saving throw or become blinded for 1 round.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "one or more bolts of energy",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex negates; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Holy Javelin",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["good"],
        longDesc: `You create a shimmering javelin of holy energy to hurl at an enemy as a ranged touched attack. The javelin deals 1d6 points of damage to an evil creature on a successful attack; it dissipates harmlessly against creatures of any other alignment. Each time a creature starts its turn while impaled by the javelin, it takes another 1d6 points of damage. For every 4 caster levels you have, the javelin remains in the creature for an additional round (to a maximum of 5 rounds at 18th level). While the creature remains impaled, it takes a -2 penalty on attack rolls and skill checks. As a move action, the creature (or another adjacent creature) can attempt to pull the javelin out (causing it to immediately disappear) with a DC 12 Strength check. The holy javelin glows like a torch, and this light clearly indicates the impaled creature's location, even if it turns invisible. Since this light is not a light effect, just the glow of a conjured javelin, darkness spells always suppress it, even if they are lower level.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "javelin of divine energy",
        targets: "",
        duration: "1 round + 1 round/4 levels",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Instant Enemy",
        type: ["buff"],
        school: "enchantment",
        tags: [],
        longDesc: `You designate a specific target as your favored enemy, gaining a +2 bonus on weapon attack and damage rolls against them.`,
        castingTime: "1 swift action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature that is not your favored enemy",
        duration: "1 round/2 levels",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S",
        },
        {
        level: "3",
        name: "Ice Spears",
        type: ["damage"],
        school: "conjuration",
        tags: ["cold"],
        longDesc: `One or more giant spears of ice lance up out of the ground. Each stalagmite-like icicle affects a 5-foot square and tapers to a height of 10 feet. You may cause a number of ice spears equal to one spear for every 4 caster levels you possess to burst from the ground. A creature that occupies a square from which a spear extends (or that is within 10 feet of the ground below) takes 2d6 points of piercing damage and 2d6 points of cold damage per square-creatures that take up more than 1 square can be hit by multiple spears if your caster level is high enough. The explosive growth can also trip foes. When the spears erupt from the ground, they attempt a combat maneuver check to trip any targets that take damage from the spears, with a total bonus equal to your caster level plus your mental modifier. Each additional ice spear beyond the first that strikes a single foe grants a +10 bonus on this combat maneuver check. If the check is successful, the ice spears knock the foe prone. A successful Reflex save halves the damage and prevents the trip attempt. If you cast this spell upon an area covered with ice or snow, such as a glacier, frozen lake, or snow-covered field, the spears strike with additional force. Saves against the effect take a -2 penalty, and the spell effect gains a +4 bonus on the combat maneuver check to trip foes. Ice spears created by this spell remain after they do their damage. They melt as normal depending on the surrounding environment. They no longer damage foes in their square, but can provide cover. An ice spear has hardness 5 and 30 hit points.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "1 ice spear/4 levels",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half and see below",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Inflict Serious Wounds",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell functions like inflict light wounds, except that you deal 5d8 points of damage + 2 points per caster level (maximum +15).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Iron Stake",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `This spell creates a 1-foot-long spike of cold iron that you fling at your target as a ranged touch attack. The stake is treated as a magic and cold iron weapon for the purpose of overcoming damage reduction, and deals 1d6 points of piercing damage for every 2 caster levels you have (maximum 10d6 at 20th level). Additionally, if a creature with DR/cold iron takes damage from this spell, it is sickened for 1 round and must attempt a Fortitude save. If it fails, for a number of rounds equal to your caster level, it must succeed at a concentration check (in addition to any normally required concentration checks) to use any spells or spell-like abilities it has-the DC of this check is equal to 15 + twice the spell's level. If the creature fails this concentration check, its spell is wasted.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "",
        duration: "instantaneous or 1 round/level; see text",
        savingThrow: "Fortitude partial",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Life Shield",
        type: ["damage"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You surround yourself with a positive energy field that damages undead opponents. Each time an undead creature damages you with a melee attack, that creature takes an amount of positive energy damage equal to half the damage it dealt to you. This damage is calculated after applying your damage reduction, resistances, and other defenses. Once this spell has dealt 5 points of damage per caster level (maximum 50), it is discharged.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level or until discharged",
        savingThrow: "",
        spellResistance: "",
        components: "S, DF,",
        },
        {
        level: "3",
        name: "Lightning Bolt",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You release a powerful stroke of electrical energy that deals 1d6 points of electricity damage per caster level (maximum 10d6) to each creature within its area. The bolt begins at your fingertips. The lightning bolt sets fire to combustibles and damages objects in its path. It can melt metals with a low melting point, such as lead, gold, copper, silver, or bronze. If the damage caused to an interposing barrier shatters or breaks through it, the bolt may continue beyond the barrier if the spell's range permits; otherwise, it stops at the barrier just as any other spell effect does.`,
        castingTime: "1 standard action",
        range: "120 ft.",
        area: "120-ft. line",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Pain Strike",
        type: ["damage"],
        school: "evocation",
        tags: ["evil", "pain"],
        longDesc: `Pain strike racks the targeted creature with agony, inflicting 1d6 points of nonlethal damage per round for 1 round per level (maximum 10 rounds). Additionally, the affected creature is sickened for the spell's duration, and the caster gains a +4 circumstance bonus on Intimidate checks against the target.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round/level (D)",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Phantasmal Reminder",
        type: ["damage"],
        school: "illusion(phantasm)",
        tags: ["mind-affecting"],
        longDesc: `You create a memory loop of a successful attack made against the target, forcing its conscious mind to recall the details of the attack in such excruciating detail that its physical body is racked by the recollection. This spell can affect only a creature that has taken damage since the end of your last turn. The target first can attempt a Will save to recognize the attack as unreal. If it fails that saving throw, the target must succeed at a Fortitude save or take an amount of damage equal to 1d6 x your caster level (maximum 10d6). Because the damage is a quasi-real memory of existing wounds, this damage can't be reduced or prevented (such as by the shield other spell). If the target of a phantasmal reminder attack succeeds at the Will save to disbelieve the memory loop and either has natural telepathy or is wearing a helm of telepathy, the memory of damage automatically rebounds to affect you. You must immediately attempt a Will save to disbelieve; if you fail, you take half the spell's damage yourself.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round (see text)",
        savingThrow: "Will disbelief, then Fortitude partial; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Purge Spirit",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `Purge spirit rips away at the target's spiritual substance, scattering it over a wide area and hampering the target's ability to reform. The target takes 1d8 points of damage per caster level (maximum 10d8) and is staggered for 1 round. On a successful saving throw, the target takes half damage and is not staggered. This spell affects astrally projected creatures, ethereal creatures, haunts, incorporeal creatures, mediums channeling a spirit, and phantoms, and at the GM's discretion can affect other spirits or creatures made of ectoplasm.
                
        Incorporeal creatures take full damage from purge spirit.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature or haunt",
        duration: "instantaneous",
        savingThrow: "Will partial",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "3",
        name: "Righteous Blood",
        type: ["damage"],
        school: "abjuration",
        tags: ["good"],
        longDesc: `The target creature's innate goodness infuses its body with holy energy. While this energy does not directly empower the target, it can harm embodiments of evil. Any creature that damages the target with a slashing or piercing melee weapon is sprayed by the target's holy blood. If the attacker is a creature with the evil subtype, it takes 1d6 points of damage from divine power each time it successfully hits the target. Creatures that don't have the evil subtype or that are using reach weapons are not subject to this damage. If the target of this spell is also good the damage increases to 1d10. If this spell is cast by an evil caster it instead deals damage to good creatures. If you are neither good or evil you cannot cast this spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "10 minutes/level (D)",
        savingThrow: "Will negates (harmless);",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Searing Light",
        type: ["damage"],
        school: "evocation",
        tags: [],
        longDesc: `Focusing divine power like a ray of the sun, you project a blast of light from your open palm. You must succeed on a ranged touch attack to strike your target. A creature struck by this ray of light takes 1d8 points of damage caster levels (maximum 10d8). An undead creature or one particularly vulnerable to light takes 2d6 points of damage per caster level (maximum 20d6), and an undead creature particularly vulnerable to bright light takes 2d8 points of damage per caster level (maximum 20d8). A construct or inanimate object takes only 1d8 points of damage per two caster levels (maximum 5d8). This spell scales with either fire or positive spell power (your choice).`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "ray",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Sheet Lightning",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You create a dazzling flash of electricity that fills the target area. Sheet lightning inflicts 1 point of electricity damage to all creatures within the area of effect (no save). The true power of the spell, though, lies not in the damage it inflicts but in the overwhelming pain the lightning creates. The sudden flash and jolt dazes living creatures for 1 round if they fail a saving throw. Creatures that save are instead dazzled for 1 round. Any creature wearing metal armor takes a -2 penalty to its saving throw against this spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "20-ft.-radius spread",
        duration: "instantaneous",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Silver Darts",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `A cone of silver darts springs from your hand, this acts like a touch scatter weapon attack, making an attack roll against each creature in the area. The darts have act as a silver weapon that deals 1d6 points of piercing damage per caster level (maximum 10d6), have a critical threat range of 19-20x2 and count as throwing weapons.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        // {
        //     level: "3",
        //     name: "Life Current",
        //     type: ["healing"],
        //     school: "conjuration(healing)",
        //     tags: ["water"],
        //     longDesc: `A cone of silver darts springs from your hand, this acts like a touch scatter weapon attack, making an attack roll against each creature in the area. The darts have act as a silver weapon that deals 1d6 points of piercing damage per caster level (maximum 10d6), have a critical threat range of 19-20x2 and count as throwing weapons.`,
        //     castingTime: "1 standard action",
        //     range: "medium (100 ft. + 10 ft./level)",
        //     area: "",
        //     effect: "",
        //     targets: "",
        //     duration: "1 round",
        //     savingThrow: "will half",
        //     spellResistance: "yes",
        //     components: "V, S, DF,",
        // },
        {
        level: "3",
        name: "Spellcurse",
        type: ["damage"],
        school: "necromancy",
        tags: ["curse"],
        longDesc: `You disrupt any spell energy affecting your target, causing that energy to crackle with power and harm the target. The target takes 1d6 points of damage for each spell with a duration of 1 round or greater currently affecting it. The spells themselves are not dispelled or modified.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "Will half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Thundering Drums",
        type: ["damage"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `You strike the ground in front of you, filling the area in front of you with the thunder of pounding drums. Any creature in the area takes 1d8 points of sonic damage per caster level (maximum 5d8) and is knocked prone. A successful Fortitude save halves the damage and negates being knocked prone.`,
        castingTime: "1 standard action",
        range: "15 ft",
        area: "cone-shaped burst",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "fortitude partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Trial By Fire",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `You test a creature's purity of convictions by exposing it to a sheet of divine fire. Unless the target's alignment is within one step of yours, the spell deals 1d6 points of damage per 2 caster levels (maximum 5d6 points of damage). Half the damage is fire damage, but the other half results directly from divine power and is therefore not subject to being reduced by resistance to fire-based attacks. Additionally, if the target has an element of its alignment that is in direct opposition to your (chaos opposes law and evil opposes good), you can also attempt an Intimidate check to demoralize the target as a free action.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "None",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Trial of Fire and Acid",
        type: ["damage"],
        school: "evocation",
        tags: ["acid", "fire"],
        longDesc: `The target creature is covered in burning acid that deals 1d6 points of acid damage and 1d6 points of fire damage each round. The subject can attempt a Fortitude saving throw each round to reduce the damage by half. Dousing the target in water ends the effect (both the acid and the fire), but rolling on the ground does not extinguish the fire or affect the acid.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "Fortitude half (see text)",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Litany of Smiting",
        type: ["damage", "buff"],
        school: "evocation",
        tags: ["language-dependent", "see-text"],
        longDesc: `By shouting a forceful litany of strictures, you make creatures who have opposing lawful/chaotic alignment to you more susceptible to the attacks of creatures of your same lawful/chaotic alignment. If the target is the opposing alignment, it takes 1.5x the normal damage from attacks made by creatures that have a matching chaotic/lawful alignment to you. If the target also has the subtype matching your opposing alignment, when it is hit with attacks made by creatures with a lawful aura, it is also sickened for 1 round. While subject to this spell, the target cannot be the target of another spell that has the word “litany” in the title. This spell also has the descriptor matching your alignment.`,
        castingTime: "1 swift action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Screaming Flames",
        type: ["damage", "control"],
        school: "evocation",
        tags: ["evil", "fire", "mind-affecting"],
        longDesc: `A sheer wall of flame appears and rushes away from you. Tendrils of fire reach out of it, shaped into skulls screaming in agony. When the wall passes through a creature's space, that creature must succeed at a Reflex save or take 1d8 points of fire damage for every 2 caster levels you have (maximum 5d8). Any creature taking fire damage must also succeed at a Will save or take 1d3 points of Wisdom damage. Deaf creatures receive a +4 circumstance bonus on their Will saves.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "a sheet of flame up to 15 ft. long and 10 ft. high that moves 15 ft. in a straight line.",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half and Will negates (see text)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "3",
        name: "Vampiric Touch",
        type: ["damage", "healing", "utility"],
        school: "necromancy",
        tags: [],
        longDesc: `You must succeed on a melee touch attack. Your touch deals 1d6 points of damage per two caster levels (maximum 10d6). You gain temporary hit points equal to the damage you deal. You can't gain more than the subject's current hit points + the subject's Constitution score (which is enough to kill the subject). The temporary hit points disappear 1 hour later.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "instantaneous/1 hour; see text",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Pellet Blast",
        type: ["damage", "utility"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `This spell creates an explosion of conjured metal pellets, striking everything within its area and dealing 1d8 points of piercing damage per two caster levels, maximum 5d8. This damage is subject to damage reduction. If the material component is made of cold iron, at level 5 it also becomes silver, at level 9 it also becomes adamantine, the resulting blast can overcome damage reduction of the appropriate type. The pellets disappear after the spell is cast and the damage is dealt.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Twilight Knife",
        type: ["damage", "utility"],
        school: "evocation",
        tags: ["force"],
        longDesc: `You create a darkly sinister floating knife that attacks the same creature as you each round. If you choose not to attack a creature, or you make an attack that affects multiple opponents, the knife makes no attack during that round. The knife uses your base attack bonus modified by either your highest mental modifier when making this attack. Unless you specifically will it to do otherwise, or it proves impossible to do so, the knife always maneuvers itself so that it can flank your opponent before making the attack. The knife deals 1d4 points of force damage on a successful hit and has the same threat range and critical multipliers as a normal dagger. In addition, if the target is denied a Dexterity bonus to AC or the knife flanks the target, the knife can make sneak attacks as a rogue, inflicting an extra 1d6 points of force damage per four caster levels on a successful attack. A twilight knife cannot be attacked or harmed by physical attacks, but dispel magic, disintegrate, a sphere of annihilation, or a rod of cancellation affects it. A twilight knife's AC against touch attacks is 12 (10 + size bonus for Tiny object) plus your Dexterity modifier. If an attacked creature has spell resistance, you make a caster level check (1d20 + caster level) against that spell resistance the first time the twilight knife strikes it. If the knife is successfully resisted, the spell is dispelled. If not, the weapon has its normal full effect on that creature for the duration of the spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "floating knife of force",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Vengeful Comets",
        type: ["damage", "utility"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `This spell causes a number of miniature comets (up to one per three caster levels) to orbit in the air above your head. Bits of snow and cold wind drift down from the orbiting comets, granting you a circumstance bonus equal to the number of comets on all saving throws against fire effects. The actual use for the comets, though, is to make vengeful strikes against foes who dare to target you with offensive spells. As an immediate action whenever you are affected by a spell cast by another creature, you can fire one of your vengeful comets as a bolt of icy retribution (provided the source of the offensive spell is within range of your vengeful comet, of course). The comet requires a ranged touch attack to hit. If it hits, a comet deals 1d6 points of bludgeoning damage and 3d6 points of cold damage to the target, plus an additional amount of cold damage equal to the level of the spell you are retaliating against. If the spell you're retaliating against had the fire descriptor, you may opt to fire two comets instead of one.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "1 comet per 3 levels",
        targets: "",
        duration: "1 round/level or until completely discharged (see below)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Flame Turret",
        type: ["damage", "utility"],
        school: "conjuration(creation)",
        tags: ["fire"],
        longDesc: `You conjure a turret of fire that spews fire at the nearest enemy within its 15ft range, it deals 4d6 fire damage each turn at the start of your turn, however the target may make a reflex saving throw to halve it. The turret is destructable, and has AC 10 + CL, 3xCL hit points, and 5 hardness, and it counts as a construct with all saves equal to your caster level. All of these bonuses max at caster level 10. It cannot move. At level 7 and 11, the turret makes an additional attack against a nearby enemy, however never the same enemy, and its range increases by 5 ft.`,
        castingTime: "1 round",
        range: "15 ft.",
        area: "",
        effect: "1 conjured fire turret",
        targets: "",
        duration: "1 round/level",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Accept Affliction",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: ["good"],
        longDesc: `The caster can transfer the effects of afflictions such as curses, diseases, and poisons from the target creature to himself. This spell can also transfer the blinded, deafened, fatigued, nauseated, shaken, and sickened conditions. All aspects of the transferred afflictions (save DCs, remaining duration, removal conditions, and so on) remain the same, but affect the caster instead of the original target. After transferring the affliction or condition, the caster is free to cure it in any way he can.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
            level: "2",
            name: "Renew",
            type: ["healing"],
            tags: [],
            school: "conjuration(healing)",
            longDesc: `The targeted ally restores 1d8 + level (max +10) hit points and can recover an expended maneuver. They cannot initiate the recovered maneuver the round you recover it for them, nor can this recover a maneuver the round they expended it.`,
            castingTime: "1 standard action",
            range: "touch",
            area: "",
            effect: "",
            targets: "creature touched",
            duration: "instantaneous",
            savingThrow: "will half (harmless)",
            spellResistance: "yes (harmless)",
            components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Lightwell",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You conjure a well of healing in a square adjacent to you. As long as the well remains, it heals a random ally within 30ft of it for 2d6 + caster level/2 hit points at the start of each of your turns. The well has 5 hit points per caster level, AC 10, hardness 8, and is just an object.`,
        castingTime: "1 standard action",
        range: "0ft",
        area: "30ft.",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Will half (harmless); see text",
        spellResistance: "yes (harmless); see text",
        components: "V, S, M, DF",
        },
        {
            level: "3",
            name: "Muster for Battle",
            type: ["healing","utility"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `You restore a random maneuver to all allies within the area (excluding you). The highest level this maneuver can be is level 2. At caster level 6 and every 3 caster levels after, the maximum level it can be increases by +1. They cannot initiate the recovered maneuver the round you recover it for them, nor can this recover a maneuver the round they expended it.`,
            castingTime: "1 standard action",
            range: "0ft",
            area: "30ft.",
            effect: "",
            targets: "allies",
            duration: "instantaneous",
            savingThrow: "Will negates (harmless);",
            spellResistance: "yes (harmless); ",
            components: "V, S, M, DF",
        },
        {
            level: "3",
            name: "Desperate Prayer",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `You can cast this spell when an ally is reduced below 0 hit points from an attack against an enemy. When you do, the ally and the enemy that dealt the damage to them are both healed 1d8 + caster level (max +10) hit points, and one of them is selected at random to heal an additional 3d8 hit points.`,
            castingTime: "1 immediate action",
            range: "close(25ft. + 5ft./2 levels)",
            area: "",
            effect: "",
            targets: "1 ally, 1 enemy",
            duration: "instantaneous",
            savingThrow: "Will half (harmless);",
            spellResistance: "yes (harmless); ",
            components: "V, S, M, DF",
        },
        {
            level: "4",
            name: "Holy Nova",
            type: ["healing","damage"],
            school: "evocation",
            tags: ["good","evil"],
            longDesc: `You unleash a holy nova of divine energy in a circle around you. If you are good or evil, all creatures within the area who share your good/evil alignment heal for 1d6 hit points per caster level (max 10d6). All creatures with the opposite alignment instead take 1d4 points of damage per caster level (max 10d4). Neutral allies heal half the amount, and neutral enemies take half the damage. The damage scales with negative spell power, and the healing positive spell power.
            \nIf you are neutral, this heals only neutral creatures, and deals half its normal damage to good and evil enemies.`,
            castingTime: "1 full-round action",
            range: "",
            area: "30ft. radius burst centered on you",
            effect: "",
            targets: "all creatures",
            duration: "instantaneous",
            savingThrow: "Will halves",
            spellResistance: "yes",
            components: "V, S, DF",
        },
        {
            level: "6",
            name: "Judgement Nova",
            type: ["healing","damage"],
            school: "evocation",
            tags: ["good","evil"],
            longDesc: `You unleash a nova of divine energy in a circle around you. If you are good or evil, all allies within the area who share your good/evil alignment heal for 1d8 hit points per caster level (max 15d8), neutral allies heal half. All enemies with the opposite alignment instead take 1d4 points of damage per caster level (max 15d4), while neutral enemies take half the damage. The damage scales with negative spell power, and the healing positive spell power.
            \nIf you are neutral, this heals neutral allies the full amount, heals half its amount to good/evil allies and neutral enemies, and deals half its damage to good/evil enemies.`,
            castingTime: "1 full-round action",
            range: "",
            area: "60ft. radius burst centered on you",
            effect: "",
            targets: "all creatures",
            duration: "instantaneous",
            savingThrow: "Will halves",
            spellResistance: "yes",
            components: "V, S, DF",
        },

        {
        level: "3",
        name: "Delay Poison, Communal",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell functions like delay poison, except you divide the duration in 1-hour intervals among the creatures touched.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creatures touched",
        duration: "1 hour/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Purging Finale",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You must have a bardic performance or hex in effect to cast this spell. With a flourish, you immediately end your bardic performance or your hexes, removing one of the following conditions on a creature within range affected by your bardic performance or a hex that was just ended: cowering, dazzled, exhausted, paralyzed, shaken, or stunned.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Remove Blindness/Deafness",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `Remove blindness/deafness cures blindness or deafness (your choice), whether the effect is normal or magical in nature. The spell does not restore ears or eyes that have been lost, but it repairs them if they are damaged. Remove blindness/deafness counters and dispels blindness/deafness.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Remove Disease",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `Remove disease can cure all diseases from which the subject is suffering. You must make a caster level check (1d20 + caster level) against the DC of each disease affecting the target. Success means that the disease is cured. The spell also kills some hazards and parasites, including green slime and others. Since the spell's duration is instantaneous, it does not prevent reinfection after a new exposure to the same disease at a later date.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Reviving Finale",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You must have a bardic performance or hex in effect to cast this spell. If you are using bardic performances, with a flourish, you immediately end your bardic performance, and allies within the area of the spell regain 4d6 hit points. If you have hexes active, all allies within range with an active hex have it ended and heal 8d6 hit points. This spell has no effect on undead creatures.`,
        castingTime: "1 swift action",
        range: "20 ft.",
        area: "a 20-ft.-radius burst centered on you",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Sacred Bond",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `To use this spell, you first touch the intended recipient, creating a sympathetic field of healing energies between you. Once the spell has been cast, you and the target may cast conjuration (healing) spells with a range of touch upon each other so long as you are within close range (25 ft. + 5 ft./2 levels). Should either you or the target remove your bracelet, the spell immediately ends.`,
        castingTime: "1 round",
        range: "touch; see text",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 minutes/level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Second Wind",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: ["air"],
        longDesc: `You can cast this spell only when you have fewer than one-quarter of your total hit points. With a gasping utterance, you summon invigorating air to fill your lungs. You heal 3d8 points of damage + 1 point per caster level (maximum +10). You can cast this spell either as a swift action on your turn or as an immediate action when you are brought to below 0 hit points. If you do not breathe, you can't benefit from this spell.`,
        castingTime: "swift action or immediate action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "",
        spellResistance: "",
        components: "V",
        },
        {
        level: "3",
        name: "Symbol Of Exsanguination",
        type: ["healing"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to cause creatures within 15 feet of the rune to begin to bleed profusely, taking 1d6 points of bleed damage and becoming sickened for the duration of the bleed. Creatures can make a fortitude save to negate this effect. It can continue being triggered until it has caused 1 creatures per caster level to bleed, or up to 5 times. When it activates it activates in a burst, affecting the closest creatures first. the bleed can be stopped with a DC 15 heal check or with magical healing that heals hit points. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 13 + your level/2. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 15 feet",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "see text",
        savingThrow: "fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Symbol Of Healing",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to heal 2d8 + 1 point per caster level (max +15) to each creature within 15 feet. It can continue being triggered until it has healed 1 creature per caster level, or been triggered 5 times. When it activates it activates in a burst, affecting the closest creatures first. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 13 + your level/2.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 15 feet",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "see text",
        savingThrow: "Will half (harmless) (see text)",
        spellResistance: "yes (harmless) (see text)",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Transfer Regeneration",
        type: ["healing"],
        school: "transmutation",
        tags: [],
        longDesc: `You bestow your regenerative abilities on the target. Your regeneration or fast healing stops functioning for the duration of the spell, and the target gains your regeneration/fast healing. For example, if you have regeneration 5 (acid or fire), your target gains regeneration 5 (acid or fire). This regeneration overlaps (does not stack) with any regeneration the creature already has, including other castings of this spell. This spell has no effect if you don't have the regeneration ability or your regeneration isn't functioning when you cast the spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 willing living creature",
        duration: "1 minute",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Divine Transfer",
        type: ["healing", "buff"],
        school: "necromancy",
        tags: [],
        longDesc: `With a single touch, you transfer some of your life essence to the subject, transferring your hit points and your resolve. When you touch the subject you can transfer up to a number of hit points equal to your Constitution score to the target. These hit points heal the subject, but cannot raise the subject's hit points higher than its normal hit point total. In addition, the subject gains damage reduction bypassed by your opposing good/evil alignment (neutral creatures choose one) equal to your highest mental bonus (if any) for the duration of the spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round/level",
        savingThrow: "fort negates(harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Detoxify",
        type: ["healing", "control"],
        school: "transmutation",
        tags: [],
        longDesc: `You remove a creature's ability to poison others, whether inherent or via poisoned weapons. Whenever an affected creature would inflict poison with an attack, spell, or other method (including auras and other constant methods), that poison is automatically neutralized. This does not grant the subject of the spell any resistance to poison itself.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "10 minutes/level",
        savingThrow: "fortitude negates",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "3",
        name: "Fractions of Heal and Harm",
        type: ["healing", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell channels a portion of the next spell you cast into magic that heals you. The next instantaneous area damage spell of 3rd level or lower that you cast deals only 75% of its damage, but heals you of a number of hit points equal to the remaining 25% of the spell's damage. For example, if you cast this spell and followed it with a fireball that would normally deal 40 hit points of damage, the fireball instead deals 30 hit points of damage and heals you of 10 hit points of damage. The spell affected by this spell must be cast before the end of your next turn. This spell has no effect on spells that do not deal damage or spells higher than 3rd level. This healing is treated as if you had been affected by a cure or inflict spell (whichever would heal you), and is treated as the same spell level as the area-affecting spell for the purpose of effects that relate to the spell level of cure or inflict spells.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Animate Dead, Lesser",
        type: ["utility"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `This spell functions as animate dead, except you can only create a single Small or Medium skeleton or zombie. You cannot create variant skeletons or zombies with this spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one corpse",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Aura Sight",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `This spell makes your eyes glow and allows you to see alignment auras within 120 feet of you. The effect is similar to that of a detect chaos/evil/good/law spell, but aura sight does not require concentration, and it discerns an aura's location and power more quickly. You know the location and power of all chaotic, evil, good, and lawful auras within your sight. An aura's power depends on a creature's Hit Dice or an item's caster level, as noted in the description of the detect evil spell. If an item or a creature bearing an aura is in line of sight, you can attempt a Knowledge (religion) check to determine the aura's strength (one check per aura; DC 15 + spell level, or 15 + 1/2 caster level for a non-spell effect).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Bleed for Your Master",
        type: ["utility"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `When you would be hit by an attack that requires an attack roll, or when you are within an area of effect that allows you to attempt a Reflex saving throw, with a single touch you compel the target to throw itself in front of the blow or shield you from the effect. If an attack roll triggered this spell's casting, the target takes the damage instead of you, even if the attack roll would not normally hit the target's Armor Class. If an area of effect that allows you to attempt a Reflex save triggered this spell's casting, the target instead grants you cover against the effect (+2 bonus on Reflex saves) if it is your size or smaller, or improved cover (+4 bonus on Reflex saves and improved evasion against the effect) if it is larger than you. The target automatically fails its Reflex save against the effect but can still benefit from improved evasion and similar mitigating effects. After taking damage, the target is shaken for 1 minute. If the target was already shaken, it becomes frightened instead.`,
        castingTime: "1 immediate action",
        range: "touch",
        area: "",
        effect: "",
        targets: "One willing target",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Channel the Gift",
        type: ["utility"],
        school: "evocation",
        tags: [],
        longDesc: `You channel your magical power to fuel the target's spellcasting. The next spell the target casts of 3rd level or lower does not expend a spell slot; in effect, you are using your spell slot to power the target's spell. The target must start casting this spell before your next turn, and the spell cannot have a casting time longer than 1 full round. The spell that's cast after channel the gift cannot have a casting time longer than 1 full round.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "ally spellcaster touched",
        duration: "1 round or see text",
        savingThrow: "Will negates (harmless) or none",
        spellResistance: "yes (harmless) or no",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Clairaudience/Clairvoyance",
        type: ["utility"],
        school: "divination(scrying)",
        tags: [],
        longDesc: `Clairaudience/clairvoyance creates an invisible magical sensor at a specific location that enables you to hear or see (your choice) almost as if you were there. You don't need line of sight or line of effect, but the locale must be known--a place familiar to you, or an obvious one. Once you have selected the locale, the sensor doesn't move, but you can rotate it in all directions to view the area as desired. Unlike other scrying spells, this spell does not allow magically or supernaturally enhanced senses to work through it. If the chosen locale is magically dark, you see nothing. If it is naturally pitch black, you can see in a 10-foot radius around the center of the spell's effect. Clairaudience/clairvoyance functions only on the plane of existence you are currently occupying.`,
        castingTime: "10 minutes",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "magical sensor",
        targets: "",
        duration: "1 min./level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, F,DF,",
        },
        {
        level: "3",
        name: "Contingent Action",
        type: ["utility"],
        school: "evocation",
        tags: [],
        longDesc: `You can cast this spell on a single ally at the start of every floor as a free action. The spell grants the target an extra action that becomes available when a condition that you dictate is met. At the time of casting, you dictate the condition, and the target specifies a readied action that occurs when triggered by this condition. The condition needed to trigger the readied action must be clear, although it can be general. If a complicated or convoluted condition is prescribed, the whole combination might fail when triggered. For example, suppose the trigger and the action are stated as 'If the target is attacked while he is not holding a weapon, he draws a weapon.' If the target has no weapon to draw when the trigger occurs, the action fails. If the trigger and the action are 'If an ally within 20 feet falls unconscious, the target moves to a space adjacent to that ally' but the target is chained to a wall when the trigger occurs and can't reach the unconscious ally, the action fails. The readied action must be a standard, a move, or a swift action, and it cannot be used to cast a spell or use a supernatural ability. This action counts as a readied action and doesn't count toward the number of actions the creature can take in a round. When the condition occurs, the target can decide not to use the readied action. Once the condition is triggered, the spell is discharged-whether or not the target uses the readied action or the action is successful. This spell counts as a contingency spell for the purpose of having multiple contingent effects on a creature at the same time.`,
        castingTime: "1 minute",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one willing creature",
        duration: "1 minute/level (D) or until discharged",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Daylight",
        type: ["utility"],
        school: "evocation",
        tags: ["light"],
        longDesc: `You touch an object when you cast this spell, causing the object to shed bright light in a 60-foot radius. This illumination increases the light level for an additional 60 feet by one step (darkness becomes dim light, dim light becomes normal light, and normal light becomes bright light). Creatures that take penalties in bright light take them while within the 60-foot radius of this magical light. Despite its name, this spell is not the equivalent of daylight for the purposes of creatures that are damaged or destroyed by such light. If daylight is cast on a small object that is then placed inside or under a light-proof covering, the spell's effects are blocked until the covering is removed. Daylight brought into an area of magical darkness (or vice versa) is temporarily negated, so that the otherwise prevailing light conditions exist in the overlapping areas of effect. Daylight counters or dispels any darkness spell of equal or lower level, such as darkness.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "object touched",
        duration: "10 min./level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Dispel Magic",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `You can use dispel magic to end one ongoing spell that has been cast on a creature or object, to temporarily suppress the magical abilities of a magic item, or to counter another spellcaster's spell. A dispelled spell ends as if its duration had expired. Some spells, as detailed in their descriptions, can't be defeated by dispel magic. Dispel magic can dispel (but not counter) spell-like effects just as it does spells. The of a spell with an instantaneous duration can't be dispelled, because the magical effect is already over before the dispel magic can take effect. You choose to use dispel magic in one of two ways: a targeted dispel or a counterspell. Targeted Dispel: One object, creature, or spell is the target of the dispel magic spell. You make one dispel check (1d20 + your caster level) and compare that to the spell with highest caster level (DC = 11 + the spell's caster level). If successful, that spell ends. If not, compare the same result to the spell with the next highest caster level. Repeat this process until you have dispelled one spell affecting the target, or you have failed to dispel every spell. For example, a 7th-level caster casts dispel magic, targeting a creature affected by stoneskin (caster level 12th) and fly (caster level 6th). The caster level check results in a 19. This check is not high enough to end the stoneskin (which would have required a 23 or higher), but it is high enough to end the fly (which only required a 17). Had the dispel check resulted in a 23 or higher, the stoneskin would have been dispelled, leaving the fly intact. Had the dispel check been a 16 or less, no spells would have been affected. You can also use a targeted dispel to specifically end one spell affecting the target or one spell affecting an area (such as a wall of fire). You must name the specific spell effect to be targeted in this way. If your caster level check is equal to or higher than the DC of that spell, it ends. No other spells or effects on the target are dispelled if your check is not high enough to end the targeted effect. If you target an object or creature that is the effect of an ongoing spell (such as a monster summoned by summon monster), you make a dispel check to end the spell that conjured the object or creature. If the object that you target is a magic item, you make a dispel check against the item's caster level (DC = 11 + the item's caster level). If you succeed, all the item's magical properties are suppressed for 1d4 rounds, after which the item recovers its magical properties. A suppressed item becomes nonmagical for the duration of the effect. An interdimensional opening (such as a bag of holding) is temporarily closed. A magic item's physical properties are unchanged: A suppressed magic sword is still a sword (a masterwork sword, in fact). Artifacts and deities are unaffected by mortal magic such as this. You automatically succeed on your dispel check against any spell that you cast yourself. Counterspell: When dispel magic is used in this way, the spell targets a spellcaster and is cast as a counterspell. Unlike a true counterspell, however, dispel magic may not work; you must make a dispel check to counter the other spellcaster's spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "one spellcaster, creature, or object",
        effect: "",
        targets: "one spellcaster, creature, or object",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Disrupt Silence",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `You suppress magical sound-dampening effects within the area. Disrupt silence temporarily negates magical silence within its area, so that normal sounds can be heard within the overlapping areas of effect. Additionally, disrupt silence can automatically counter or dispel any magical silence effect of equal or lower level cast upon the same target, such as silence. If you cast disrupt silence on the target of a higher-level silence effect, it functions as dispel magic instead of its normal function.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "10-ft.-radius emanation centered on a creature, object, or point in space",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "S, M,",
        },
        {
        level: "3",
        name: "Explosive Defense",
        type: ["utility"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `You swiftly channel your magic for an explosive effect, though mostly to create a kinetic force. When you cast this spell, you and all creatures in a 10-ft radius burst take 3d6 fire damage, additionally you are launched 15 feet in a direction of your choice, then you are knocked prone. Creatures within the area may make a reflex save to reduce this damage by half. Your movement provokes attacks of opportunity, however if you cast this spell in response to a specific attack from a creature, it doesn't provoke from them.`,
        castingTime: "1 immediate action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "reflex half",
        spellResistance: "no",
        components: "V, S, M",
        },
        {
        level: "3",
        name: "Fearsome Duplicate",
        type: ["utility"],
        school: "illusion(figment)",
        tags: [],
        longDesc: `You create a larger and far more menacing version of yourself that you can send forth, manipulate like a puppet, and use to interact with others. You can make the duplicate up to two size categories larger than you are and determine a theme as to how it alters your original appearance. However, this duplicate always retains some vestiges of your actual appearance. Creatures who already know you gain a +2 bonus on saving throws made to disbelieve this spell. Your duplicate has no actual substance, and you cannot use it to alter its surroundings or to attack or otherwise harm creatures it encounters. You can use the duplicate to speak, and interact verbally with creatures using the Bluff, Diplomacy, and Intimidate skills, and you gain a +2 competence bonus on Intimidate checks when using that skill through the duplicate. You can see, hear, taste, and smell your duplicate's surroundings as if you are actually present using your Perception skill. While you also remain aware of your own immediate surroundings when controlling your duplicate, controlling it does take a toll on your senses. You take a -4 penalty on Perception checks while you control your duplicate. The duplicate moves under your mental command, and while you need not act out its movements, you must take a standard action to control your duplicate for 1 round (concentrating on the spell) or it winks out of existence. You can maintain control of your duplicate even if you have no line of sight or line of effect to it. The duplicate immediately winks out of existence if it is hit by an attack or in the area of a damaging effect, or if it moves beyond the maximum range of the spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "monstrously distorted duplicate of you",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "Will disbelief (if interacted with)",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Feather Step, Mass",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `As feather step, except this spell affects multiple creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "10 minutes/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Final Sacrifice",
        type: ["utility"],
        school: "evocation",
        tags: [],
        longDesc: `You disrupt the conjuring energies within a summoned creature, causing it to violently explode. If the target fails its Fortitude save, it is immediately slain and all creatures within 20 feet of the target take 1d4 points of damage per spell level of the summoning spell that conjured the target. This damage is fire damage unless the target creature has the cold or water subtype, in which case it's cold damage. Creatures caught in this explosion take half damage if they succeed at their Reflex saves against this spell's DC. Final sacrifice can detonate a summoner's eidolon, though an eidolon receives a +4 bonus on its Fortitude save unless the spell is cast by the eidolon's own summoner. If this spell targets an eidolon, creatures within 20 feet of the eidolon take an amount of damage equal to 1d4 + 1/2 the caster level of the summoner who controlled the eidolon.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one summoned creature",
        duration: "instantaneous",
        savingThrow: "Fortitude negates, then Reflex half (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Find Fault",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `You instantly learn many of the target's weaknesses, as if you had made an appropriate Knowledge skill check with a result equal to 20 + your caster level. Additionally, your first melee or ranged attack roll against the creature before the end of your next turn gains a +5 insight bonus. If the creature is polymorphed, disguised, or hidden by an illusion and you are not aware of it's true form, this spell fails as if the target has spell resistance you failed to penetrate (the GM may have you attempt a caster level check to conceal the true reason for the spell's failure).`,
        castingTime: "1 standard action",
        range: "medium (100 ft. plus 10 ft./level)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Healing Thief",
        type: ["utility"],
        school: "necromancy",
        tags: [],
        longDesc: `With this spell you can steal the healing of the target creature. You must succeed at a melee touch attack to strike the target. If you do, until the effect ends, whenever your target is subject to a healing spell or a supernatural effect that heals hit points, the target only receives half the healing (rounded down) and you receive the other half (also rounded down). You must remain within 25 feet (plus 5 feet per two caster levels) of the target to gain this benefit. If you move outside that range, the spell is discharged. Once you steal 5 hit points per your caster level (maximum 50 hit points) of healing from this spell's effect, the spell is discharged.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level or until discharged",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Hide from Undead, Greater",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions as hide from undead, except the spell does not immediately end if a warded creature attempts to turn or command undead, channels positive energy, touches an undead creature, or attacks any creature. Instead, when the warded creature takes one of these actions, an intelligent undead creature can attempt another Will saving throw to negate the effects of the spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one touched creature/level",
        duration: "10 min./level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "3",
        name: "Infernal Challenger",
        type: ["utility"],
        school: "conjuration(calling)",
        tags: ["lawful"],
        longDesc: `This spell summons a bearded devil, causing it to appear where you designate, while doing so you designate a single creature you see as its challenge. For the duration of the spell, the devil does everything in its power to kill the challenger. You do not control the devil or have any influence over how it conducts itself in battle, but the devil cannot harm any creature other than its challenger. The conjured devil remains until any one of the following criteria is met: it is reduced below 0 hit points or otherwise defeated, its challenger is slain, its challenger surrenders, which is a full-round action. Upon any of these occurrences, the devil vanishes. This spell always summons the same bearded devil, and If the devil defeats its challenge (or the challenge surrenders) the bearded devil becomes more powerful, gaining bonuses: +2 on all rolls (including damage rolls) and special ability DCs; +4 to AC and CMD; +9 hp. These bonuses stack each time the bearded devil defeats another foe, but it loses 2 stacks if it is defeated.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one called bearded devil; see text",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Lily Pad Stride",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `Your every footstep creates aquatic plants capable of supporting your weight and that of any creature of your size or smaller that is following you. These lily pads only appear when you cross water or other liquids which do not immediately destroy plants. You can walk across these liquid surfaces without any fear of stumbling (though if knocked prone, dragged under, or otherwise pulled off your feet you still sink in the liquid). For the duration of the spell, any creature of your size or smaller can attempt to follow you by making a DC 10 Acrobatics check every round. Each such check allows it to move at half its normal land speed. If the creature takes a -5 penalty on its check it can move at its normal speed. If a creature fails an Acrobatics check, or if a creature that's larger than you attempts to follow, it falls through, damaging the plants. Each time a creature falls through, all subsequent creatures take a cumulative -5 penalty on their Acrobatics checks when traveling across that particular stretch of plants. As you move, the lily pads disappear behind you once you pass beyond the spell's range. Otherwise, they remain until the spell's duration expires.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "trail of lily pads behind you",
        targets: "",
        duration: "10 minutes/level (D); see text",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M, ",
        },
        {
        level: "3",
        name: "Mad Monkeys",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `You summon a swarm of screeching, mischievous monkeys. The swarm understands and obeys your commands and has the statistics of a monkey swarm (Bestiary 2 212). Creatures failing a saving throw against the mad monkeys' distraction attack are deafened for 1 minute as well as nauseated. The monkeys attempt one disarm or steal combat maneuver each turn as a free action against any creature that begins its turn in the swarm, using your caster level plus your highest mental modifier for its CMB. Recovering an item from the monkeys requires a successful disarm or steal attempt against that CMB + 10. An object stolen by the monkeys takes swarm damage each round the swarm is in possession of the object.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "swarm of monkeys",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Major Image",
        type: ["utility"],
        school: "illusion(figment)",
        tags: [],
        longDesc: `This spell functions like silent image, except that sound, smell, and thermal illusions are included in the spell effect. While concentrating, you can move the image within the range. The image disappears when struck by an opponent unless you cause the illusion to react appropriately.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "visual figment that cannot extend beyond four 10-ft. cubes + one 10-ft. cube/level (S)",
        targets: "",
        duration: "Concentration + 3 rounds",
        savingThrow: "Will disbelief (if interacted with)",
        spellResistance: "no",
        components: "V, S, F,",
        },
        {
        level: "3",
        name: "Meld into Stone",
        type: ["utility"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `Meld into stone enables you to meld your body and possessions into a single block of stone. The stone must be large enough to accommodate your body in all three dimensions. When the casting is complete, you and not more than 100 pounds of nonliving gear merge with the stone. If either condition is violated, the spell fails and is wasted. While in the stone, you remain in contact, however tenuous, with the face of the stone through which you melded. You remain aware of the passage of time and can cast spells on yourself while hiding in the stone. Nothing that goes on outside the stone can be seen, but you can still hear what happens around you. Minor physical damage to the stone does not harm you, but its partial destruction (to the extent that you no longer fit within it) expels you and deals you 5d6 points of damage. The stone's complete destruction expels you and slays you instantly unless you make a DC 18 Fortitude save. Even if you make your save, you still take 5d6 points of damage. Any time before the duration expires, you can step out of the stone through the surface that you entered. If the spell's duration expires or the effect is dispelled before you voluntarily exit the stone, you are violently expelled and take 5d6 points of damage. The following spells harm you if cast upon the stone that you are occupying. Stone to flesh expels you and deals you 5d6 points of damage. Stone shape deals 3d6 points of damage but does not expel you. Transmute rock to mud expels you and then slays you instantly unless you make a DC 18 Fortitude save, in which case you are merely expelled. Finally, passwall expels you without damage.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Motes of Dusk And Dawn",
        type: ["utility"],
        school: "evocation",
        tags: ["darkness", "light"],
        longDesc: `When you cast this spell, you create up to four motes that shed light or darkness in a 20-foot-radius, increasing or decreasing the illumination level by up to two categories. You decide whether each individual mote sheds light or darkness when the spell is cast. The motes of dusk and dawn must stay within a 10-foot-radius area of one another but otherwise move as you desire (no concentration required): forward or back, up or down, straight or turning corners, or the like. The motes can move up to 100 feet per round. A mote winks out if the distance between you and it exceeds the spell's range.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "Up to four motes, all within a 10-ft.-radius area",
        targets: "",
        duration: "1 minute (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Quench",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `Quench is often used to put out forest fires and other conflagrations. It extinguishes all nonmagical fires in its area. The spell also dispels any fire spells in its area, though you must succeed on a dispel check (1d20 +1 per caster level, maximum +15) against each spell to dispel it. The DC to dispel such spells is 11 + the caster level of the fire spell. Each creature with the fire subtype within the area of a quench spell takes 1d6 points of damage per caster level (maximum 10d6, no save allowed, scales with cold spell power). This also hardens lava allowing it to be walked on for rounds equal to half your caster level. Alternatively, you can target the spell on a single magic item that creates or controls flame. The item loses all its fire-based magical abilities for 1d4 hours unless it succeeds on a Will save. Artifacts are immune to this effect.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "one 20-ft. cube/level (S)",
        effect: "",
        targets: "one fire-based magic item",
        duration: "instantaneous",
        savingThrow: "none or Will negates (object)",
        spellResistance: "no or yes (object)",
        components: "V, S, DF",
        },
        {
        level: "3",
        name: "Rain of Frogs",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions as summon swarm, except you summon a swarm of poisonous frogs. This swarm has the statistics of a centipede swarm (Bestiary 43), except it has the animal type and its poison deals Constitution damage instead of Dexterity damage.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one swarm of poisonous frogs",
        targets: "",
        duration: "concentration + 2 rounds",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "3",
        name: "Raven's Flight",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You can cast this spell only if it is the first action you take on your turn. In a burst of shadowy feathers, you turn into a Tiny blurred shape reminiscent of a black raven until the beginning of your next turn. You gain a fly speed of 50 feet with good maneuverability, and apply appropriate size modifiers (though your ability scores don't change). Until the beginning of your next turn, you can take only the 5-foot step, move, run, or withdraw actions. If the spell is dispelled while you are still aloft, the power of flight dissipates slowly; you float downward 60 feet on your next turn, then fall any remaining distance.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round",
        savingThrow: "",
        spellResistance: "",
        components: "V, ",
        },
        {
        level: "3",
        name: "Shrink Item",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You are able to shrink one nonmagical item (if it is within the size limit) to 1/16 of its normal size in each dimension (to about 1/4,000 the original volume and mass). This change effectively reduces the object's size by four categories. Optionally, you can also change its now shrunken composition to a clothlike one. Objects changed by a shrink item spell can be returned to normal composition and size merely by tossing them onto any solid surface or by a word of command from the original caster. Even a burning fire and its fuel can be shrunk by this spell. Restoring the shrunken object to its normal size and composition ends the spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one touched object of up to 2 cu. ft./level",
        duration: "1 day/level; see text",
        savingThrow: "Will negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Sky Swim",
        type: ["utility"],
        school: "transmutation",
        tags: ["air"],
        longDesc: `This spell grants the target the ability to swim through the air. If the target has a swim speed, it can move through the air at that speed. Otherwise, it must succeed at Swim checks to move as normal. Still air is treated as calm water, light or moderate wind is treated as rough water, strong or severe wind is treated as stormy water, and the target cannot swim through stronger winds (Core Rulebook 439). This spell does not grant the ability to breathe air to creatures that normally can't.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "Large or smaller creature touched",
        duration: "1 minute/level",
        savingThrow: "none (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Spark Hop",
        type: ["utility"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You transform into a bolt of lighting and move quickly to a new location, but like lighting, it follows a difficult to predict path. You move in a random direction in a straight line, roll a 1d8 to determine the direction, 1 being north, and each result being 1 direction in clockwise rotation. Afterwards roll a 1d6, the d6 determining how many squares in that direction you travel. At caster level 6th you can add or subtract 1 from the result of the d8, and at caster level 10th you can add or subtract 1 from the D6 as well. If you collide with a wall you move to the furthest possible location and then stop there, taking 1d6 damage for each square left to travel. If you travel through a creature you deal 1d6 points of damage for the distance left to travel, though they can make a reflex save to reduce the damage by half. This does not count as teleportation, but this movement does not provoke attacks of opportunity, nor is it reduced by anything.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "",
        spellResistance: "no",
        components: "V, S",
        },
        {
        level: "3",
        name: "Storm Step",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: ["electricity"],
        longDesc: `You are able to harness the power of the storm to transport yourself a short distance, by taking the form of a furious, sizzling bolt of elemental electricity. You must either have line of sight to your destination or you must specify a direction and distance within range. Creatures and objects in the path of your passage take 1d8 points of electricity damage per 2 caster levels (maximum 5d8). A successful Reflex save halves the damage. If your path intersects with a solid object, you damage the barrier accordingly. If the damage is enough to break through the barrier, you continue beyond the barrier as long as the spell's range permits; otherwise, your movement stops in the square adjacent to the barrier and the effect ends.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "Reflex halves",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "3",
        name: "Summon Monster III",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell summons an extraplanar creature (typically an outsider, elemental, or magical beast native to another plane). It appears where you designate and acts immediately, on your turn. It attacks your opponents to the best of its ability. If you can communicate with the creature, you can direct it not to attack, to attack particular enemies, or to perform other actions. The spell conjures one of the creatures from the level on Table from: https://www.d20pfsrd.com/magic/all-spells/s/summon-monster/ of the level equal to the level of this spell. Alternatively you can choose to summon 1d3 creatures from the list 1 level below, or 1d4+1 creatures from a list at least 2 levels lower. You choose which kind of creature to summon (one type of creature at a time if you are summoning multiple) but can only summon creatures from the core list (not alternative options), and you can choose a different one each time you cast the spell. A summoned monster cannot summon or otherwise conjure another creature, nor can it use any teleportation or planar travel abilities. Creatures cannot be summoned into an environment that cannot support them. Creatures summoned using this spell cannot use spells or spell-like abilities that duplicate spells with expensive material components (such as wish). When you use a summoning spell to summon a creature with an alignment or elemental subtype, it is a spell of that type. Creatures marked with an "*" are summoned with the celestial template, if you are good, and the fiendish template, if you are evil. If you are neutral, you may choose which template to apply to the creature. Creatures marked with an "*" always have an alignment that matches yours, regardless of their usual alignment. Summoning these creatures makes the summoning spell's type match your alignment.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, F,DF,",
        },
        {
        level: "3",
        name: "Summon Nature's Ally III",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions like summon nature's ally I, except that you can summon one 3rd-level creature, 1d3 2nd-level creatures of the same kind, or 1d4+1 1st-level creatures of the same kind.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "3",
        name: "Swarm of Fangs",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `You summon a swarm consisting of thousands of animate, flying teeth in a 10-foot-by-10-foot cube. These fangs attack all creatures within the swarm's area. You can summon the swarm so that it shares an area with other creatures, and you can move the swarm up to 40 feet each round as a move action. If you choose not to move the swarm, it automatically moves up to 40 feet to envelop the nearest creature (including you) if it has not already done so. Creatures caught inside the swarm's area of effect take 2d6 points of damage. The fangs deal damage to all creatures sharing their area when they first appear, and at the end of their movement each round.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one swarm of animate teeth",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Telepathy",
        type: ["utility"],
        school: "divination",
        tags: ["mind-affecting"],
        longDesc: `You can mentally communicate with any other creature within 100 feet that has a language. It is possible to address multiple creatures at once telepathically, although maintaining a telepathic conversation with more than one creature at a time is just as difficult as speaking and listening to multiple people simultaneously. Any effects you have that require them to hear or see you work through telepathy. While telepathy is active you always know the space an ally within its range is standing, and can can always target them for spells and abilities (though you may still suffer a 50% miss chance)`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, ",
        },
        {
        level: "3",
        name: "Wall of Split Illumination",
        type: ["utility"],
        school: "evocation",
        tags: ["darkness", "light"],
        longDesc: `An immobile curtain of illumination springs into existence. When created, one side of the wall (designated by you) radiates bright light to a range of 60 feet away from that side while the other side radiates darkness to an equal distance. This effect alters the illumination level by up to two steps toward either bright light (the light side) or darkness (the dark side). The wall also obstructs vision through it, regardless of which side of the wall the viewer is on.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "10-ft.-high vertical sheet of illumination up to 5 ft. long/level",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
            level: "4",
            name: "Dark Bolt",
            type: ["utility","buff","damage"],
            school: "evocation",
            tags: ["electricity"],
            longDesc: `You call down a bolt of dark lightning that arrives at the start of your next turn in the target location. You choose a 5-foot square to bring the bolt down; it starts from the roof and travels downward, stopping once it strikes an object or a creature. If the bolt directly strikes a creature, they are not damaged by the bolt; instead, they are empowered by it, gaining bonus electricity damage on attacks made with manufactured weapon attacks. This bonus is equal to your highest mental modifier, but is also increased by any increase you have to your caster level with this spell. This bonus damage is multiplied on critical hits, and it lasts 1 round per 4 levels, but the duration is increased by 1 round for every feat or perk that increases the DC of this spell. Once the bolt strikes a creature or a solid object, it explodes outwards in a 10-foot radius, dealing 1d6 points of electricity damage per 2 caster levels (maximum 10d6), though creatures can make a Reflex save to halve it.`,
            castingTime: "1 standard action",
            range: "close (25ft. + 5 ft./2 levels)",
            area: "5-ft square and 10-foot radius",
            effect: "",
            targets: "",
            duration: "instantaneous and 1 round/ 4 levels; see text",
            savingThrow: "none and reflex halves; see text",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
            level: "4",
            name: "Cursed Ambush",
            type: ["utility","damage"],
            school: "evocation",
            tags: ["electricity"],
            longDesc: `You rapidly retreat backward, moving half of your movement speed in a straight line in any direction, while also leaving behind a cursed mote of dark energy that explodes at the start of your next turn. The distance you can move is increased by 5 feet per 25 electricity spell power. This movement still provokes attacks of opportunity; however, you can use Spellcraft in place of Acrobatics while gaining a bonus equal to your highest mental modifier, or you can gain a bonus on your Acrobatics check equal to your caster level (your choice). The cursed mote you leave behind is invisible and explodes at the start of your next turn, dealing electricity damage to all creatures within a 10-foot radius. The damage equals 1d4 per 2 caster levels (maximum 10d4), and a successful Reflex save halves it.`,
            castingTime: "1 movement action",
            range: "0 feet",
            area: "5-foot square",
            effect: "",
            targets: "",
            duration: "instantaneous and 1 round",
            savingThrow: "reflex halves",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
            level: "5",
            name: "Dark Subjugation",
            type: ["damage"],
            school: "evocation",
            tags: ["electricity"],
            longDesc: `You begin a dark storm from your current location. At the start of your next turn, a powerful bolt strikes a 5-foot square within the area you were occupying when you cast this spell. Then every round after, the storm grows outwards in a ring from the source point, now striking a 10 foot radius around the spell's area on the previous round (but not within the area of the previous round). When an enemy is struck by this spell, they suffer 1d6 points of electricity damage per caster level (max 20d6), while allies instead suffer 1d6 per 2 caster levels (max 10d6). A reflex save halves the damage. If a creature is struck by this spell multiple times, they take a -2 penalty on the saving throw and the spell gains 20 power for the damage it deals to them (stacks every time they take damage again).`,
            castingTime: "standard action",
            range: "0 feet",
            area: "see text",
            effect: "",
            targets: "",
            duration: "3 rounds, +1 rd/5 CL",
            savingThrow: "reflex halves",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
        level: "3",
        name: "Water Breathing",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `The transmuted creatures can breathe water freely. Divide the duration evenly among all the creatures you touch. The spell does not make creatures unable to breathe air.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creatures touched",
        duration: "2 hours/level; see text",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "3",
        name: "Water Walk",
        type: ["utility"],
        school: "transmutation",
        tags: ["water"],
        longDesc: `The transmuted creatures can tread on any liquid as if it were firm ground. Mud, oil, snow, quicksand, running water, ice, and even lava can be traversed easily, since the subjects' feet hover an inch or two above the surface. Creatures crossing molten lava still take damage from the heat because they are near it. The subjects can walk, run, charge, or otherwise move across the surface as if it were normal ground. If the spell is cast underwater (or while the subjects are partially or wholly submerged in whatever liquid they are in), the subjects are borne toward the surface at 60 feet per round until they can stand on it.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one touched creature/level",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "3",
        name: "Wind Wall",
        type: ["utility"],
        school: "evocation",
        tags: ["air"],
        longDesc: `An invisible vertical curtain of wind appears. It is 2 feet thick and of considerable strength. It is a roaring blast sufficient to blow away any bird smaller than an eagle, or tear papers and similar materials from unsuspecting hands. (A Reflex save allows a creature to maintain its grasp on an object.) Tiny and Small flying creatures cannot pass through the barrier. Loose materials and cloth garments fly upward when caught in a wind wall. Arrows and bolts are deflected upward and miss, while any other normal ranged weapon passing through the wall has a 30% miss chance. (A giant-thrown boulder, a siege engine projectile, and other massive ranged weapons are not affected.) Gases, most gaseous breath weapons, and creatures in gaseous form cannot pass through the wall (although it is no barrier to incorporeal creatures). While the wall must be vertical, you can shape it in any continuous path along the ground that you like. It is possible to create cylindrical or square wind walls to enclose specific points.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "wall up to 10 ft./level long and 5 ft./level high (S)",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none; see text",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "3",
        name: "Draconic Reservoir",
        type: ["utility", "buff"],
        school: "evocation",
        tags: ["acid", "cold", "electricity", "fire"],
        longDesc: `Draconic reservoir functions as protection from energy, absorbing 6 points of one type of energy damage per caster level (acid, cold, electricity, or fire, maximum 60 points). Each round, as a swift action, the subject can release 1d6 points of the absorbed energy and apply it to any melee attack, as if using an acidic, flaming, frost, or shock weapon. The first creature the subject strikes with this attack takes the energy damage in addition to any other consequences of the attack. Releasing energy in this way does not 'free up' space to absorb still more energy; the maximum amount of energy the spell can absorb remains fixed. The subject cannot release more energy than he currently has absorbed. Once the subject has absorbed all the energy allowed by the spell, he takes damage as normal from that energy type. Once the energy has been released, the spell is discharged. Draconic reservoir does not stack with protection from energy. Draconic reservoir overlaps (and does not stack with) resist energy. If a character is warded by draconic reservoir and resist energy, draconic reservoir absorbs damage until it reaches its maximum limit.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 minutes/level or until discharged; see text",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Invisibility Sphere",
        type: ["utility", "buff"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `This spell functions like invisibility, except that this spell confers invisibility upon all creatures within 10 feet of the recipient at the time the spell is cast. The center of the effect is mobile with the recipient. Those affected by this spell can see each other and themselves as if unaffected by the spell. Any affected creature moving out of the area becomes visible, but creatures moving into the area after the spell is cast do not become invisible. Affected creatures (other than the recipient) who attack negate the invisibility only for themselves. If the spell recipient attacks, the invisibility sphere ends.`,
        castingTime: "1 standard action",
        range: "",
        area: "10-ft.-radius emanation around the creature",
        effect: "",
        targets: "",
        duration: "1 min./level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "3",
        name: "Ki Leech",
        type: ["utility", "buff"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `You place your spirit in a receptive state so when you confirm a critical hit against a living enemy or reduce a living enemy to 0 or fewer hit points, you can steal some of that creature's ki. This replenishes 2 spell points.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Hydraulic Torrent",
        type: ["utility", "control"],
        school: "evocation",
        tags: ["water"],
        longDesc: `You call forth a powerful stream of water that batters all creatures and obstacles in its path until it strikes something it cannot push past. Against creatures and moveable objects this stream acts as a bull rush. You can bull rush creatures of any size, not just those one size larger than your own. Make a combat maneuver check and apply its results to each creature within the area. Your CMB for this bull rush is equal to your caster level plus your highest mental modifier. This bull rush does not provoke an attack of opportunity. Against immovable objects this stream instead allows you to make a Strength check to destroy the target. When attempting to break an object, the stream has an effective Strength equal to your caster level plus the ability score modifier as above. The Break DC depends on the object you're trying to break. Hydraulic torrent extinguishes any normal fires it encounters along its path. Magical fires are unaffected.`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "60-ft. line",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Paladin's Sacrifice",
        type: ["utility", "healing"],
        school: "abjuration",
        tags: [],
        longDesc: `You open up a brief but powerful divine conduit between you and another creature, taking on the damage and any other effects that creature suffers. When a creature in range is hit by an attack or fails a saving throw, you can cast this spell and the wounds and/or effects are magically transmitted to you instead of the target. You are affected as if you were hit by the attack or failed the saving throw, taking all the damage and suffering all of the adverse effects. Any resistances or immunities you have are applied normally, but you cannot otherwise reduce or negate the damage or effects in any way. If you use this spell against an effect that also targets you or includes you in its area, you suffer the effects for both yourself and the target you spared, potentially taking damage or suffering other consequences twice.`,
        castingTime: "1 immediate action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "fort negates(harmless)",
        spellResistance: "yes (harmless)",
        components: "V, DF,",
        },
        {
        level: "3",
        name: "Touch Injection",
        type: ["utility", "healing"],
        school: "transmutation",
        tags: [],
        longDesc: `You must hold an elixir, infused extract, poison, or potion in hand as you cast this spell. The held substance drains from its container into a magical sac in your body. While the spell lasts, you can deliver the substance with a mere touch. To do so to an opponent, you must make a successful melee touch attack. If you hit, the substance takes effect immediately, despite any onset period, and that opponent receives the normal saving throw (if any) against the substance. In the case of a personal infused extract, the opponent receives both a Fortitude save and spell resistance. If you miss, the substance remains in the magical sac for you to use later. This spell protects you from poison in the sac, but unless you have the poison use class feature, you suffer a 5% chance of exposing yourself to the poison when you first cast the spell. If you roll a natural 1 while attempting to inject the poison into an enemy, you are exposed to it.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 hour/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Flashfire",
        type: ["utility", "damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `You cause flames to spring up in the area of effect. These flames deal 1d6 points of fire damage for every 3 caster levels you have (maximum 5d6) to each creature that enters a burning area or begins its turn in the area; these creatures also catch on fire. A creature that succeeds at a Reflex save negates the damage and avoids catching on fire. The area and all adjacent 5-foot squares are smoky, providing concealment within. You can concentrate as a standard action to ignite one 5-foot square adjacent to a currently burning square. Heavy precipitation (including sleet storm) ends the spell. Strong and severe winds spread each square of flashfire downwind by one square each round, but windstorm-force or stronger winds extinguish the fires.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "one 5-ft. square/2 levels",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Reflex negates (object) and Fortitude negates",
        spellResistance: "yes (object)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Adamantine Weapons",
        type: ["buff"],
        school: "transmutation",
        tags: ["earth", "imbument"],
        longDesc: `[imbument] The touched weapon is considered adamantine for bypassing damage reduction (this doesn't affect its hardness or hit points), and against creatures that have their damage reduction bypassed by adamantine, the weapon deals an additional 2d6 points of damage. This also allows . If the creature has damage reduction bypassed by adamantine and something else, this only deals 1d6 bonus damage to them. A weapon can have only a single imbument at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 weapon",
        duration: "1 round/level",
        savingThrow: "will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "4",
        name: "Aspect of the Stag",
        type: ["buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `When you cast this spell, you take on an aspect of a stag, including some of its physical characteristics. Your features become elongated and sinewy, and you grow a set of antlers you can use for defense. You gain a +2 dodge bonus to AC against attacks of opportunity, your base speed increases by 20 ft., you can move through any undergrowth (including magically manipulated undergrowth) at your normal speed, and can even make a 5-foot step within such terrain. Furthermore, when you are hit with an attack of opportunity, you can make a single attack with your antlers against the opponent that hit you as an immediate action. This attack uses your highest base attack bonus plus your Strength or Dexterity bonus (your choice) and deals 1d8 points of piercing damage (if you are Medium; 1d6 points of damage if Small) plus your Strength modifier on a successful hit. The antlers have a critical multiplier of 19-20/x2.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        {
            level: "4",
            name: "Blessed Rain",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: ["water"],
            longDesc: `You call down a downpour of blessed rain that heals wounds, puts out fires, and damages undead. At the start of each of your turns after this spell is cast, any creature that starts their turn in the rain is effected, however they can make a reflex save to halve, those that still potentially suffer damage can make a fortitude save to halve the damage again, down to a possible 1/4th damage. Living creatures within are healed for 1d8 points of damage per 2 caster levels, while creatures with the fire subtype and undead take that much damage. Undead with the fire subtype take double damage.`,
            castingTime: "1 standard action",
            range: "close (25ft. + 5ft./2 levels",
            area: "20 ft. square",
            effect: "",
            targets: "",
            duration: "1 round/level",
            savingThrow: "reflex and fortitude halves",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
            level: "3",
            name: "Soothing Mud",
            type: ["healing","utility"],
            school: "conjuration(healing)",
            tags: ["water","earth"],
            longDesc: `You create an area of healing mud. Water, earth, sand, and dust thicken into a wet mud. The mud functions as difficult terrain and does not sink if created in water unless weighed down by more than 100 pounds per caster level you have. Each round a creature begins its turn in or on the mud, the mud restores 1d6 hit point per 3 caster levels. If a creature spends 3 rounds within the mud, they also heal 1d4 points of ability damage, however this can only happen once per day.`,
            castingTime: "1 standard action",
            range: "medium (100 ft. + 10 ft./level)",
            area: "Dust, earth, sand, or water in 20-ft. square",
            effect: "",
            targets: "",
            duration: "1 round/level (D)",
            savingThrow: "none",
            spellResistance: "no",
            components: "V, S, DF",
        },
        {
            level: "5",
            name: "Phoenix Fire",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: ["fire"],
            longDesc: `When you cast this spell, the next fire spell you cast within this turn has its essence modified into something similar to that of phoenix fire. The spell now heals living creatures instead of damaging them, albeit at half effectiveness. The spell gains the healing type, and if it had the damage type it loses it. Abilities that you have that empower fire spells, including abilities such as additional damage per dice still effect this spell, but now benefits the healing instead. Abilities that benefit healing spells also effect this spell now. You can only choose whether the spell benefits from positive spell power or fire spell power.`,
            castingTime: "1 swift action",
            range: "personal",
            area: "",
            effect: "",
            targets: "you",
            duration: "1 round",
            savingThrow: "none",
            spellResistance: "no",
            components: "V, S, DF",
        },
        {
            level: "5",
            name: "Cryostasis",
            type: ["healing","utility"],
            school: "evocation",
            tags: ["cold"],
            longDesc: `You surround a willing target in a thick coating of soothing ice. A creature trapped within can take no actions, physical or mental, but they are also impervious to damage except from touch attacks from incorporeal creatures, though if they are undead, any physical contact with the ice causes them great pain, taking 1d6 points of damage per 3 caster levels, fortitude halves. Regardless, no creature counts as having line of sight or effect to them unless the ice is destroyed first. The ice has an armor class of 10, hardness of 10, and 20 hit points per caster level. While the creature is inside of the ice any harmful effects active on the creature before entering the ice continue to have their duration expire, but it does not effect the creature, this includes things like poison, disease, or damage over time. Each round at the start of your turn the creature inside of the ice heals 10 hit points per caster level, 1d4 points of damage to an ability score of choice, fatigue and exhaustion are removed, and if they have any reoccuring effects they are allowed to make a new save against (they are allowed to continue to make akashic paths resaves while inside of stasis), they gain a morale bonus to it equal to your highest mental modifier.`,
            castingTime: "1 standard action",
            range: "close (25ft. + 5ft./2 levels",
            area: "",
            effect: "",
            targets: "1 willing creature",
            duration: "Concentration + 1 round (max 1 round/3 levels)",
            savingThrow: "reflex negates",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
            level: "4",
            name: "Stoneshell",
            type: ["utility"],
            school: "conjuration(creation)",
            tags: ["earth"],
            longDesc: `You surround a creature in a thick coating of hard stone. While the spell is active the creature can continue to act normally, the stone moves with them and doesn't restrict movement, however it does block line of effect and line of sight, though they can still continue to attack with wielded weapons, though unless the have tremorsense, they cannot see anything, and because of the thick coating of stone they suffer a -10 penalty on perception checks to locate a creature. However, while covered in the stone they are immune to taking damage from creatures outside of the stone, unless the effect does not require line of sight or effect, such as attacks from incorporeal creatures. Otherwise in order to damage the creature the stone must be destroyed first. The stone provides an armor bonus of 8, but the creature loses the benefits of any armor or clothing they are wearing to their armor class, it has a hardness of 10, and 10 hit points per caster level. The creature also gains a +10 bonus to their CMD against any effect that would move them. While the creature is inside of the stone any harmful effects active on the creature before entering the stone continue to run their course, this includes things like poison, disease, or damage over time, though fire is automatically put out. Spells that destroy stone, such as soften earth and stone requires an opposed caster level check against this spell (and any saves if relevant), success destroys it and ends the spell. While the stone is active, any natural weapon the creature possess cannot be used, but they instead gain new natural attacks of the same type, and their damage is the same, except increased by 2 size steps, its critical threat range is 20x2, and it gains none of the magical bonuses the creature usually gains to natural attacks. It does however bypass damage reduction as if it were magical, and ignores hardness below 10.`,
            castingTime: "1 standard action",
            range: "touch",
            area: "",
            effect: "",
            targets: "1 creature",
            duration: "1 round/3 levels",
            savingThrow: "reflex negates",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
            level: "7",
            name: "Metalshell",
            type: ["utility"],
            school: "conjuration(creation)",
            tags: ["earth"],
            longDesc: `You surround a creature in a thick coating of hard metal. While the spell is active the creature can continue to act normally, the metal moves with them and doesn't restrict movement, however it does block line of effect and line of sight, though they can still continue to attack with wielded weapons, though unless the have tremorsense, they cannot see anything, and because of the thick coating of metal they suffer a -10 penalty on perception checks to locate a creature. However, while covered in the metal they are immune to taking damage from creatures outside of the metal, unless the effect does not require line of sight or effect, such as attacks from incorporeal creatures, or it is electricity damage, in which case it does not do any damage to the shell, and has a 50% chance to either do no damage at all, or damage the wearer of the armor, who automatically fails all reflex saves against electricity effects. In order to damage the creature otherwise, the metal must be destroyed first. The metal provides an armor bonus of 15, but the creature loses the benefits of any armor or clothing they are wearing to their armor class, it has a hardness of 20, and 10 hit points per caster level. The creature also gains a +20 bonus to their CMD against any effect that would move them. While the creature is inside of the metal any harmful effects active on the creature before entering the metal continue to run their course, this includes things like poison, disease, or damage over time, though fire is automatically put out. Spells that destroy metal, such as warp metal requires an opposed caster level check against this spell (and any saves if relevant), success destroys it and ends the spell. While the metal is active, any natural weapon the creature possess cannot be used, but they instead gain new natural attacks of the same type, and their damage is the same, except increased by 3 size steps, its critical threat range is 19-20x3, and it gains none of the magical bonuses the creature usually gains to natural attacks. It does however bypass damage reduction as if it were magical and adamantine, and ignores hardness below 20.`,
            castingTime: "1 standard action",
            range: "touch",
            area: "",
            effect: "",
            targets: "1 creature",
            duration: "1 round/4 levels",
            savingThrow: "reflex negates",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
            level: "4",
            name: "Blastshield",
            type: ["utility"],
            school: "conjuration(creation)",
            tags: ["earth"],
            longDesc: `You summon up a covering of stone to surround and protect you in an emergency. While this spell is active you cannot take any physical actions, and the blastshield blocks both line of sight and effect. While in the shell, unless the attack can go through physical objects, such as those from incorporeal creatures, or it is damage over time that you had before entering the shell (though the shell immediately puts out fire), damage is dealt to the rock shell before you. The rock has a hardness of 8, and 5 hit points per caster level, and has an armor class of 10. While inside of the shell you are helpless, but since the shell blocks line of effect, you cannot be targeted by most attacks, including coup-de-grace.`,
            castingTime: "1 immediate action",
            range: "personal",
            area: "",
            effect: "stone covering",
            targets: "you",
            duration: "1 round",
            savingThrow: "none",
            spellResistance: "no",
            components: "V, S, M",
        },
        {
            level: "7",
            name: "Friendly Blastshield",
            type: ["utility"],
            school: "conjuration(creation)",
            tags: ["earth"],
            longDesc: `You summon up a covering of stone to surround and protect an ally in an emergency. While this spell is active they cannot take any physical actions, and the blastshield blocks both line of sight and effect. While in the shell, unless the attack can go through physical objects, such as those from incorporeal creatures, or it is damage over time that the creature had before entering the shell (though the shell immediately puts out fire), damage is dealt to the rock shell before the creature. The rock has a hardness of 8, and 5 hit points per caster level, and has an armor class of 10. While inside of the shell the creature is helpless, but since the shell blocks line of effect, they cannot be targeted by most attacks, including coup-de-grace.`,
            castingTime: "1 immediate action",
            range: "close(25ft. + 5ft./2 levels)",
            area: "",
            effect: "stone covering",
            targets: "1 willing creature",
            duration: "1 round",
            savingThrow: "reflex",
            spellResistance: "no",
            components: "V, S, M",
        },        
        {
        level: "4",
        name: "Battle Trance",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You are transformed into a single-minded force of destruction. You gain the ferocity monster special ability, a number of temporary hit points equal to 1d6 + your caster level (maximum +10), and a +4 morale bonus on saving throws against mind-affecting effects. You cannot use the withdraw action or willingly move away from a creature that has attacked you. When you use this spell, you immediately take 4 points of Intelligence damage. You must make a DC 20 concentration check to cast spells, and all other concentration checks to cast spells have a -5 penalty.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Bestow Planar Infusion II",
        type: ["buff"],
        school: "evocation",
        tags: [],
        longDesc: `This functions as bestow planar infusion I, except that the touched creature gains the improved infusion of the current plane.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 hour/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Blade of Light",
        type: ["buff"],
        school: "transmutation",
        tags: ["good"],
        longDesc: `This spell infuses a weapon with pure sunlight (the weapon need not be a bladed weapon). A weapon enhanced by this spell sheds light as if daylight had been cast on it. It functions as a magic and good weapon for the purposes of overcoming damage reduction. The weapon grants a +2 sacred bonus on attack rolls against undead and deals +1d6 points of damage on a successful hit against such foes; against incorporeal undead, it functions as if it had the ghost touch weapon special ability. The weapon automatically confirms critical hits against foes that are vulnerable to sunlight.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one melee weapon",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S",
        },
        {
        level: "4",
        name: "Blessing Of Fervor",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `With this blessing, you call your allies to move forth and empower them to conquer and become victorious. Each round for the duration of this spell, each of your allies can choose one of the following bonuses for that round at the beginning of its turn (their choice). • Increase its speed by 30 feet. • Stand up as a swift action without provoking an attack of opportunity. • Make one extra attack as part of a full attack action, using its highest base attack bonus. • Gain a +2 bonus on attack rolls and a +2 dodge bonus to AC and Reflex saves. •Cast a single spell of 2nd level or lower as if it were an enlarged, extended, silent, or still spell. These effects are not cumulative with similar effects, such as those provided by haste or a speed weapon, nor do they actually grant an extra action, so you can't use it to cast a second spell or otherwise take an extra action in the round. Blessing of fervor does not stack with haste.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Blood Crow Strike",
        type: ["buff"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `Your unarmed strikes release blasts of energy in the form of bolts of fire or glowing red crows, which fly instantaneously to strike your target. You can make unarmed strike or flurry of blows attacks against the target as if it were in your threatened area; each successful attack deals damage as if you had hit it with your unarmed strike, except half the damage is fire and half is negative energy (this negative energy does not heal undead). For example, if you are a 14th-level monk, you can use a flurry of blows to attack five times, creating one energy crow for each successful attack against the target, and dealing 2d6 points of damage (plus appropriate unarmed strike modifiers) with each crow.`,
        castingTime: "1 round",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Bloodsworn Retribution",
        type: ["buff"],
        school: "necromancy",
        tags: [],
        longDesc: `When you cast this spell, you cut yourself and swear an oath of retribution on your own blood. You decide how much damage you want to take from this attack, up to 25 points. This damage cannot be healed for as long as the spell is in effect. You select a creature you can see, you gain a morale bonus on attack and damage rolls against the creature, and on saves against its abilities that stop you from taking actions. The bonuses are equal to the number of hit points of damage you took from the oath divided by 5. When you fulfill the oath or the duration ends, the lost hit points can be healed as normal.`,
        castingTime: "1 round",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M",
        },
        {
        level: "4",
        name: "Bloody Claws",
        type: ["buff"],
        school: "necromancy",
        tags: [],
        longDesc: `You give a creature the ability to deal bleed damage when making natural attacks so long as the attack deals slashing or piercing damage. This bleed damage for each attack is equal to one-half your caster level (limited to the creature's maximum damage with that attack), though bleed damage does not stack. When two or more attacks deal bleed damage, take the worse effect.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Cape of Wasps",
        type: ["buff"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `You summon a wasp swarm, which fills your space (up to 5 feet by 5 feet) but does not attack you. The dense cloud of vermin gives you partial concealment against ranged attacks. Any creature that makes a successful melee attack against you takes 2d6 points of swarm damage and poison from the wasp swarm, but is not affected by the swarm's distraction ability. As a free action on your turn, you may have the swarm cling to you tightly, giving you a fly speed of 20 feet (poor maneuverability); when using the swarm to fly, it does not provide concealment or harm creatures that strike you. You can return the swarm to its protective shape as a free action on your turn.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S",
        },
        {
        level: "4",
        name: "Crusader's Edge",
        type: ["buff"],
        school: "transmutation",
        tags: ["good"],
        longDesc: `This spell was created by the paladins of the Mendevian Crusades, and co-opted by inquisitors and rangers dedicated to tracking and fighting demons, devils, and other evil extraplanar creatures. When you cast this spell on a melee weapon you imbue it with a powerful holy energy, granting the weapon the bane weapon quality against evil outsiders. Furthermore, whenever you score a successful critical hit against an outsider with the evil subtype, you not only deal normal critical damage with the weapon but also nauseate the outsider for 1d3 rounds-the outsider can reduce this nauseated condition to sickened for 1 round with a successful Fortitude save.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "melee weapon touched",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Death Ward",
        type: ["buff"],
        school: "necromancy",
        tags: [],
        longDesc: `The subject gains a +4 morale bonus on saves against all death spells and magical death effects. The subject is granted a save to negate such effects even if one is not normally allowed. The subject is immune to energy drain and any negative energy effects, including channeled negative energy. This spell does not remove negative levels that the subject has already gained, but it does remove the penalties from negative levels for the duration of its effect. Death ward does not protect against other sorts of attacks, even if those attacks might be lethal.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Divine Power",
        type: ["buff"],
        school: "evocation",
        tags: [],
        longDesc: `Calling upon the divine power of your patron, you imbue yourself with strength and skill in combat. You gain a +1 luck bonus on attack rolls, weapon damage rolls, Strength checks, and Strength-based skill checks for every three caster levels you have (maximum +6). You also gain 1 temporary hit point per caster level. Whenever you make a full-attack action, you can make an additional attack at your full base attack bonus, plus any appropriate modifiers. This additional attack is not cumulative with similar effects, such as haste or weapons with the speed special ability.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Enchantment Foil",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You gain a +4 bonus on saving throws against enchantment effects. If you succeed at a save against an enchantment effect, you identify the effect as if you had succeeded at a Spellcraft check to do so. Furthermore, you can choose to act as if you had failed your saving throw. If you do so, you make a bluff check with a +20 against all creatures who believe you are enchanted, then on the round you choose to no longer act as though you have been enchanted all of your attacks against any monster you successfully bluffed are at flat-footed against you.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 hour/level (see text)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Enlarge Person, Mass",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell functions like enlarge person, except that it affects multiple creatures.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "One humanoid creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 min./level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "False Life, Greater",
        type: ["buff"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell functions as false life, except you gain temporary hit points equal to 2d10 + 1 point per caster level (maximum +20). The effects of this spell do not stack with those of false life.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 hour/level or until discharged; see text",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Firewalker's Meditation",
        type: ["buff"],
        school: "abjuration",
        tags: ["medatative"],
        longDesc: `You focus your mind on blocking out pain, allowing your body to endure punishments that would be otherwise unbearable. While under the effects of this spell, you continue to register pain-you simply don't suffer the deleterious effects such sensations bring. For example, if you were lit on fire as you slept, you would still wake from the pain of burning even though some of the fire damage you endured (perhaps all of it) would be negated by this spell. You gain DR 5/magic, resist fire 10, and a +4 bonus on saving throws to resist pain effects, this also grants a +10 bonus on concentration checks caused from damage. Once the spell has prevented a total of 10 points of damage per caster level (maximum 100 points), it is discharged. At any time during the spell's duration when you take damage that would be subject to the damage reduction or energy resistance granted by this spell, you can expend the spell's remaining duration as an immediate action in order to increase the effects to DR 10/magic, resist fire 30, and immunity to pain effects. If you do so, these enhanced effects persist for 3 rounds. After this time, the spell ends.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute per level or until discharged",
        savingThrow: "",
        spellResistance: "",
        components: "V, M,",
        },
        {
        level: "4",
        name: "Grand Cunning",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `As foxes's cunning, except it grants a +6 enhancement bonus to intelligence.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Grand Splendor",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `As eagle's splendor, except it grants a +6 enhancement bonus to charisma.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Grand Wisdom",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `As owl's wisdom, except it grants a +6 enhancement bonus to wisdom.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Guardian Of Faith",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `The target gains the benefit of shield of faith and your choice of protection from chaos, evil, good, or law. As a move action, the target can transfer this spell to a touched ally, who becomes the new target of the spell. The alignment descriptor of this spell matches the alignment descriptor of the protection spell you chose when casting it. For example, granting the target protection from evil gives this spell the good descriptor.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one ally",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Hollow Heroism",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting", "ruse"],
        longDesc: `This spell functions as heroism, except that you can reverse the spell by issuing a special command as a standard action if you are within medium range (100 feet + 10 feet per caster level) of the target. The target loses the bonuses and instead takes a -2 penalty on attack rolls, saving throws, and skill checks until the spell's duration ends (no save).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 minutes/level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Kiss of the First World",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell infuses a living creature with a surge of positive energy from the First World, filling the target with the raw energies of life. The exact effects of this spell vary, depending on the nature of the creature touched. Constructs are immune to the effects of this spell. Living Creature: A living creature gains a 20-foot increase to his base land speed and a +2 insight bonus on all Charisma based skill checks. In addition, the creature gains fast healing 2. Fire, acid, and negative energy cause this fast healing to stop functioning on the round following the attack. Undead Creature: An undead creature targeted by this spell is staggered for the duration of this spell. It does not gain the benefits of any channel resistance it might normally enjoy, and the save DCs for any of its special attacks (but not spell-like abilities or spells) are reduced by 2.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "living or undead creature touched",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M, ",
        },
        {
        level: "4",
        name: "Medusa's Bane",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell causes your eyes to take on a silvery mirror-like quality, transforming your eyes into metallic-looking orbs that reflect the world you see.
        
                Your vision is in no way impaired while this spell is in effect, but you are granted immunity to gaze attacks for the spell's duration. As an immediate action, you can reflect a creature's gaze back on itself, forcing the target of the gaze attack to save against its own gaze weapon or be affected by it. This reflection bypasses the typical immunity creatures with gaze attacks have to their own race's gaze attack, but does not bypass any other resistances or immunities the creature might have. Once you choose to reflect a gaze attack in this manner, the effect of medusa's bane immediately ends.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M",
        },
        {
        level: "4",
        name: "Mighty Agility",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `As cat's grace, except it grants a +6 enhancement bonus to dexterity.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Mighty Endurance",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `As bear's endurance, except it grants a +6 enhancement bonus to constitution.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Mighty Strength",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `As bull's strength, except it grants a +8 enhancement bonus to Strength.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Plague Carrier",
        type: ["buff"],
        school: "necromancy",
        tags: ["disease", "evil"],
        longDesc: `The target's natural attacks carry filth fever (DC 10 + 1/2 of the creature's Hit Dice + creature's Con modifier)`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 hour/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Protection from Energy, Communal",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions like protection from energy, except you divide the duration in 10-minute intervals among the creatures touched. Once the spell absorbs 12 points of energy damage per caster level (maximum 120 points) for a subject, the spell's effects end for that subject.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creatures touched",
        duration: "10 min./level or until discharged",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Reduce Person, Mass",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell functions like reduce person, except that it affects multiple creatures.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one humanoid creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 min./level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Resilient Reservoir",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell creates a magical well of retribution that a caster can unleash with blinding speed. Upon casting this spell, damage from melee attacks and touch spells gets transferred into a special pool that you then redirect before the spell's duration expires. Each time you are struck by a melee attack or touch spell that deals hit point damage, 1 point of damage is negated and transferred into the reservoir created by this spell. The total number of points in the reservoir cannot exceed your caster level (to a maximum of 20 points at 20th level). As an immediate action, anytime before the spell's duration expires, you can release some or all of the energy of the reservoir, granting yourself an insight bonus on one skill check, attack roll, damage roll, or combat maneuver check, but you must do so before the roll is made. This bonus is equal to the number of points in the reservoir. For every five caster levels, you may call upon the reservoir one additional time (maximum of four times at 15th level). If you are reduced to negative hit points while you are under the effect of this spell, the spell automatically release the remaining magic of the reservoir in a concussive blast of force. All creatures within a 15-foot radius take 1d6 points of force damage per 2 points remaining in the reserve (maximum of 10d6). A successful Reflex save halves this damage, and spell resistance applies to this effect.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "special, see text",
        effect: "",
        targets: "",
        duration: "1 round/ level",
        savingThrow: "none (see below)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Sensory Amplifier",
        type: ["buff"],
        school: "divination",
        tags: ["mind-affecting"],
        longDesc: `You open the minds of all creatures near you and enhance their sensory receptors. All living creatures other than you in the area gain a +5 bonus on Perception checks. Sighted creatures gain low-light vision, and creatures with a sense of smell gain scent. In addition, the first time each round that a creature in the area takes damage, it takes an additional 2d6 points of damage of the same type. Despite being within the area, the caster does not take this extra damage.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "10-ft.-radius emanation centered on you",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "S, ",
        },
        {
        level: "4",
        name: "Shadowform",
        type: ["buff"],
        school: "illusion(shadow)",
        tags: ["shadow"],
        longDesc: `You replace the target's body with mystic shadow material drawn from the Shadow Plane, rendering the target's physical form only quasi-real. Whenever a foe tries to directly attack the target of the spell (for instance, with a weapon or a targeted spell), that foe must attempt a Will save to disbelieve. If successful, the opponent can attack the target normally and is unaffected by shadowform for 1 round. If the foe fails, the target takes only one-fifth the normal amount of damage from the foe's successful attack or effect, and if the attack has a special effect other than damage, that effect is one-fifth as strong as normal (if applicable) or only 20% as likely to occur. Objects automatically succeed at their Will saves against this spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level (D)",
        savingThrow: "Will negates (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Shield Of Fortification, Greater",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions as shield of fortification, except there is a 50% chance that the critical hit or sneak attack is negated and damage is instead be rolled normally, rather than 25%.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Spell Immunity",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `The warded creature is immune to the effects of one specified spell for every four levels you have. The spells must be of 4th level or lower. The warded creature effectively has unbeatable spell resistance regarding the specified spell or spells. Naturally, that immunity doesn't protect a creature from spells for which spell resistance doesn't apply. Spell immunity protects against spells, spell-like effects of magic items, and innate spell-like abilities of creatures. It does not protect against supernatural or extraordinary abilities, such as breath weapons or gaze attacks. Only a particular spell can be protected against, not a certain domain or school of spells or a group of spells that are similar in effect. A creature can have only one spell immunity or greater spell immunity spell in effect on it at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Stoneskin",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `The warded creature gains resistance to blows, cuts, stabs, and slashes. The subject gains DR 10/adamantine. It ignores the first 10 points of damage each time it takes damage from a weapon, though an adamantine weapon bypasses the reduction. Once the spell has prevented a total of 10 points of damage per caster level (maximum 150 points), it is discharged.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 min./level or until discharged",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Storm Cloak",
        type: ["buff"],
        school: "evocation",
        tags: ["electricity", "air"],
        longDesc: `You create an electrical cloud around yourself, for the duration of the spell, each time you cast an electrical or air spell your cloud gains charges equal to the level of the spell, or for each 10 points of electricity damage you would take before resistances or protection you gain a charge. You can then discharge charges for various effects. You can expend as many charges as you'd like at once, but you must determine how many charges to expend before any result is determined. The effects are as follows:
        \n1: When a creature attacks you with a metal weapon, you can use an immediate action to reduce their attack by -2 per charge expended.
        \n2: When a creature attacks you, you can expend an immediate action to gain a 5% miss chance per stack expended.
        \n3: You can expend charges as a swift action to increase your movement speed by 5 per stack expended
        \n4: You can expend charges as a movement action to deal 1d6 electricity damage to a creature within 20 feet per stack expended. The creature is allowed a reflex save to reduce the damage by half.
        \n5: You can expend charges as a swift when making an attack with a metal weapon to gain a +1 bonus to the attack.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "no",
        components: "V, S, M",
        },
        {
        level: "4",
        name: "Strong Jaw",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Laying a hand upon an allied creature's jaw, claws, tentacles, or other natural weapons, as well as its unarmed attacks, you enhance its power. Each natural attack or unarmed strike that creature makes deals damage as if the creature were two sizes larger than it actually is. If the creature is already Gargantuan or Colossal-sized, double the amount of damage dealt by each of its natural attacks instead. This spell does not actually change the creature's size; all of its statistics except the amount of damage dealt by its natural attacks remain unchanged.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Temporary Graft",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You temporarily graft a dismembered body part onto yourself. You must have the body part in your possession or the spell has no effect. The graft must come from a creature the same size category as you. You can have only one graft active at a time. Grafting on a new body part immediately ends the effects of the older casting and causes that body part to fall off. The effect of the graft depends on the type of body part you choose to graft to yourself, as follows. Fins: The fins grant you a 40 foot swim speed. Head: The head grants you all-around vision. If the head came from a creature that had darkvision, low-light vision, or scent, you gain the appropriate senses at half the normal range. You can speak through either head, but not both simultaneously. You don't receive any additional special abilities the head might have had (like a medusa's petrifying gaze ability). Leg: The leg increases your base movement speed by 5 feet and grants you a +2 bonus to CMD against overrun and trip combat maneuvers (the usual bonus for having an extra leg). Wings: The wings grant you a 40-foot fly speed (poor maneuverability).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Tough Crowd",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You fortify your allies against attempts to control or mislead them. Each ally in the spell's range gains a +4 insight bonus on the saving throw to resist the next enchantment or illusion spell cast on it. In addition, the DC of any Bluff, Diplomacy, Disguise, or Intimidate check to influence an affected character increases by 4 for the duration of the spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "1 creature/level",
        duration: "10 minutes/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Ward Shield",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `With a touch, you enchant a shield and enable it to protect its wielder from hostile spells. The shield grants spell resistance 10 + your caster level against spells so long as the shield can be interposed between the wielder and the spell effect. A spell shield does not provide spell resistance against area effect spells such as fireball, but does provide a +5 bonus on Reflex saving throws against such spells.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "shield touched",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Holy Whisper",
        type: ["buff", "control"],
        school: "evocation",
        tags: ["good"],
        longDesc: `You whisper a single word in the primordial language of good that is anathema to the minions of evil and strengthens the resolve of good creatures. Evil creatures within the burst must make a Fortitude Saving Throw or become sickened for 1 round/ level. Evil outsiders with the evil subtype, evil-aligned dragons, and undead in the burst also take 2d8 points of damage if they fail their saves. Good-aligned creatures in the burst gain a +2 sacred bonus on attack and damage rolls for 1 round. If you're evil this instead weakens good creatures and empowers evil creatures. If you are an evil caster this instead deals its effects to good creatures, its bonus becomes profane. Neutral casters cannot cast this spell.`,
        castingTime: "1 standard action",
        range: "30 ft",
        area: "cone shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "fort negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Arcana Theft",
        type: ["buff", "control", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions as a targeted dispel magic spell, except it only affects creatures and it requires a melee touch attack. If the melee touch attack is successful and the spell successfully dispels one spell affecting the target, that spell is instead transferred to you, treating you as the original target. You do not receive a new saving throw or spell resistance check against this spell and must accept its affects even if they are not beneficial. This does not alter the spell's duration; for example, if the spell only has 4 rounds of duration remaining when it is stolen, it only affects you for 4 rounds. If the spell or effect has a duration of permanent, its duration continues for 1 hour per caster level of the original caster, after which it ends. The stolen spell does not revert to the original target.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Virtuoso Performance",
        type: ["buff", "control", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `While this spell is active, you may start a second bardic performance, even a performance you currently have active (doubling its bonuses), or activate the same hex on a target twice. The second hex or performance costs twice as many spell points to activate and maintain. When this spell ends, one of the performances or hexes ends immediately (your choice). If you are using this to maintain a second hex on a target it costs half the hexes cost (minimum 1) at the start of each of your turns.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V",
        },
        {
        level: "4",
        name: "Positive Pulse Greater",
        type: ["buff", "damage"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell causes a wave of positive energy to spread from a point you designate, damaging foes vulnerable to positive energy and bolstering living creatures. Each creature damaged by positive energy in the area (such as undead) must succeed at a Will save or take 3d6 points of damage, plus 1 point per caster levels (scales with positive spell power). Haunts manifesting in the spell's area also take this damage. This spell does not heal creatures healed by positive energy; such creatures instead gain a +8 bonus on saving throws against death effects, energy drain, negative energy, and effects directly caused by haunts. This bonus lasts for 1 round.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "15-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous plus 1 round (see text)",
        savingThrow: "Will negates or Will negates (harmless); see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Thorn Body",
        type: ["buff", "damage"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell causes spines to grow from your exposed skin, damaging creatures that strike you. Any creature striking you with a melee weapon, an unarmed strike, or a natural weapon takes 1d6 points of piercing damage +1 point per caster level (maximum +15). Creatures using melee weapons with reach are unaffected by this spell. Creatures that successfully grapple you take 2d6 points of piercing damage +1 point per caster level (maximum +15). In addition, your natural attacks and unarmed strikes deal an additional 1d6 points of piercing damage. Thorns created by this spell persist through any new physical shape or form you assume, such as via wild shape or any polymorph effect.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Freedom Of Movement",
        type: ["buff", "healing"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell enables you or a creature you touch to move and attack normally for the duration of the spell, even under the influence of magic that usually impedes movement, such as paralysis, solid fog, slow, and web. All combat maneuver checks made to grapple the target automatically fail. The subject automatically succeeds on any combat maneuver checks and Escape Artist checks made to escape a grapple or a pin. The spell also allows the subject to move and attack normally while underwater, even with slashing weapons such as axes and swords or with bludgeoning weapons such as flails, hammers, and maces, provided that the weapon is wielded in the hand rather than hurled. The freedom of movement spell does not, however, grant water breathing.`,
        castingTime: "1 standard action",
        range: "personal or touch",
        area: "",
        effect: "",
        targets: "you or creature touched",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Animal Aspect, Greater",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions like animal aspect, except you can either gain two aspects at once or one aspect that adds effects to the aspects that animal aspect grants, as described below. Frog: You gain a Swim speed equal to half your normal speed, and all the benefits of having a swim speed. Gorilla: You gain a +2 competence bonus on Perception checks, and a +1 competence bonus on Fortitude saves. Monkey: You gain a +4 competence bonus on Acrobatics checks. Otter: Your swim speed increases to your full normal speed, and you need not make concentration checks to cast spells underwater. Raccoon: Your competence bonuses on Disable Device, Sleight of Hand, and Stealth checks increase to +4. Raptor: Your enhancement bonus to speed increases to +30 feet, and you gain the benefit of the Run feat. Tree Lizard: You gain a +4 competence bonus on Stealth checks.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "none",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Beast Shape II",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as beast shape I, except that it also allows you to assume the form of a Tiny or Large creature of the animal type. If the form you assume has any of the following abilities, you gain the listed ability: climb 60 feet, fly 60 feet (good maneuverability), swim 60 feet, darkvision 60 feet, low-light vision, scent, grab, pounce, and trip. Tiny animal: If the form you take is that of a Tiny animal, you gain a +4 size bonus to your Dexterity, a -2 penalty to your Strength, and a +1 natural armor bonus. Small animal: If the form you take is that of a Small animal, you gain a +2 size bonus to your Dexterity and a +1 natural armor bonus. Medium animal: If the form you take is that of a Medium animal, you gain a +2 size bonus to your Strength and a +2 natural armor bonus. Large animal: If the form you take is that of a Large animal, you gain a +4 size bonus to your Strength, a -2 penalty to your Dexterity, and a +4 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Earth Glide",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `The target can pass through stone, dirt, or almost any other sort of earth except metal as easily as a fish swims through water, traveling at a speed of 5 feet. If protected against fire damage, it can move through lava. This movement leaves behind no tunnel or hole, nor does it create any ripple or other sign of its presence. It requires as much concentration as walking, so the subject can attack or cast spells normally, but cannot charge or run. Casting move earth on an area containing the target flings the target back 30 feet, stunning it for 1 round (DC 15 Fortitude negates). This spell does not give the target the ability to breathe underground, so when passing through solid material, the creature must hold its breath.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Elemental Body I",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `When you cast this spell, you can assume the form of a Small air, earth, fire, or water elemental. The abilities you gain depend upon the type of elemental into which you change. Elemental abilities based on size, such as burn, vortex, and whirlwind, use the size of the elemental you transform into to determine their effect. Air elemental: If the form you take is that of a Small air elemental, you gain a +2 size bonus to your Dexterity and a +2 natural armor bonus. You also gain fly 60 feet (perfect), darkvision 60 feet, and the ability to create a whirlwind. Earth elemental: If the form you take is that of a Small earth elemental, you gain a +2 size bonus to your Strength and a +4 natural armor bonus. You also gain darkvision 60 feet, the push ability, and the ability to earth glide. Fire elemental: If the form you take is that of a Small fire elemental, you gain a +2 size bonus to your Dexterity and a +2 natural armor bonus. You gain darkvision 60 feet, resist fire 20, vulnerability to cold, and the burn ability. Water elemental: If the form you take is that of a Small water elemental, you gain a +2 size bonus to your Constitution and a +4 natural armor bonus. You also gain swim 60 feet, darkvision 60 feet, the ability to create a vortex, and the ability to breathe water.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Eyes of the Void",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You gain darkvision, the ability to see 60 feet even in total darkness, including that created by deeper darkness. Darkvision is black-and-white only, but otherwise like normal sight. While affected, your eyes turn completely black (but appear white to anyone viewing you with darkvision).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 minutes/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Fey Form I",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You assume the form of a Small or Medium creature of the fey type. Your base speed changes to match the new form's base speed, with a maximum speed of 60 feet (even if the chosen fey form has a base speed in excess of that speed). If the form you assume has any of the following abilities, you gain those abilities: climb speed 30 feet, fly speed 30 feet (average maneuverability), swim speed 30 feet, darkvision 60 feet, low-light vision, scent, and boot stomp. If the form you assume has the aquatic subtype, you can breathe air and water. If the creature has any weaknesses, you gain those weaknesses. If a listed ability depends on an item (as is the case with boot stomp), this spell transforms the nearest counterpart among your worn gear into that item. You can more easily cast spells that the creature has as spell-like abilities, although you must still cast them as normal for your class. When you cast a spell that the creature has as a spell-like ability, it requires no verbal or somatic components and can't be countered. Small Fey: If you assume this form, you gain a +2 size bonus to your Dexterity and Constitution scores. Medium Fey: If you assume this form, you gain a +2 size bonus to your Strength and Constitution scores.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Hellmouth Lash",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: ["acid", "electricity", "fire"],
        longDesc: `Upon casting this spell, your tongue transforms into an energy whip weapon that can deal acid, electricity, or fire damage. You choose what type of energy damage the spell deals when you cast it. You attack with your tongue as if it were a whip, except you make touch attacks with it and it can harm creatures with armor or natural armor bonuses. You are considered proficient with this weapon. A successful touch attack with the tongue deals 1d8 points of energy damage per two caster levels (maximum of 5d8 points of damage at 10th level). While the spell is in effect, you cannot speak, cast spells requiring verbal components, or activate items requiring command words. The spell has the acid, electricity, or fire descriptor, depending on what type of energy damage you chose when you cast it.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Innocuous Shape",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell transforms a creature into a Medium or smaller animal or humanoid of no more than 1 Hit Die. If you use this spell to cause the target to take on the form of an animal, the spell functions as beast shape II. If the form is that of a humanoid, the spell can function as alter self, youthful appearanceUM, or both, such that you can transform a creature into a generic, youthful humanoid of any type. Any creature that interacts with the target of this spell must succeed at a Will saving throw (using the DC of the spell) or view the target in the most innocuous possible light. On a failed saving throw, the creature views all of the target's actions as inoffensive and no cause for concern unless the target becomes an obvious threat. The creature can otherwise act normally, and feels no compunction to obey or ignore the target; it simply assumes none of the target's actions are dangerous or malicious unless shown evidence that proves otherwise.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "1 minute/level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Miasmatic Form",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: ["air", "poison"],
        longDesc: `This spell functions like gaseous form, except the target's vaporous body is dangerous to creatures that touch it. A creature can make a Fortitude save on its turn to resist the vapors. When you cast this spell, you select one of the following options. Stinking cloud: The target's body nauseates creatures that fail their saving throws, as stinking cloud (Fortitude negates, see text). This form of the spell does not require a material component. Poisonous cloud: The target's body is deadly poison, dealing 1d2 points of Constitution damage to creatures that fail their saves (Fortitude halves). This form of the spell requires a material component.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "willing corporeal creature touched",
        duration: "1 minute/level",
        savingThrow: "none; see text",
        spellResistance: "no",
        components: "S, M,",
        },
        {
        level: "4",
        name: "Monstrous Physique II",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as monstrous physique I, except it also allows you to assume the form of a Tiny or Large creature of the monstrous humanoid type. If the form you assume has any of the following abilities, you gain the listed ability: climb 60 feet, fly 60 feet (good maneuverability), swim 60 feet, darkvision 60 feet, low-light vision, scent, freeze, grab, leap attack, mimicry, pounce, sound mimicry, speak with sharks, and trip. If the creature has the undersized weapons special quality, you gain that quality. Tiny monstrous humanoid: If the form you take is that of a Tiny monstrous humanoid, you gain a +4 size bonus to your Dexterity, a -2 penalty to your Strength, and a +1 natural armor bonus. Large monstrous humanoid: If the form you take is that of a Large monstrous humanoid, you gain a +4 size bonus to your Strength, a -2 penalty to your Dexterity, and a +4 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Revenant Armor",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell endows a suit of armor with a singular purpose realized only after its wearer goes unconscious or is killed; whenever the wearer of a suit of armor warded by revenant armor is brought below 0 hit points or otherwise rendered unconscious (but not paralyzed or held) in combat, the armor is immediately brought to life as a Medium animated object. This animated suit of armor still contains the unconscious (or dead) body of its former wearer and moves with a shambling gait at a speed of 20 feet. This animated object has average hit points and, if the armor is made from metal, it has the metal animated object extraordinary ability (plus additional abilities based on the type of metal). Once animated, the revenant armor remains standing (and stands if knocked prone, doing so without provoking attacks of opportunity), and prevents the wearer of the armor from being considered helpless. If an ally of the wearer is within range of the armor, she can direct it to move, though it refuses to go anywhere that requires a skill check. If grappled or otherwise restrained, it can attempt to break free with a Strength score equal to your caster level and a CMB equal to 1 + your caster level + the armor's Strength modifier. If the armor's wearer is reduced to dust, made conscious, or removed from the armor, the spell ends.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one suit of armor",
        duration: "1 day/level or 1 hour/level; see below",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Shocking Image",
        type: ["buff", "utility"],
        school: "illusion(figment)",
        tags: ["electricity"],
        longDesc: `This spell works like mirror image, except the illusory doubles it creates discharge an electric shock when destroyed. An opponent that uses a melee attack to destroy one of your images takes 2d6 points of electricity damage. You must overcome a target's spell resistance the first time you deal this electricity damage to it. Failure renders the target immune to damage from this spell.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "none",
        spellResistance: "see text",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Acid Pit",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["acid"],
        longDesc: `This spell functions as create pit, except that it places a 5-footdeep pool of acid at the bottom of the pit. The pit has a maximum depth of 100 feet. Creatures who fall into the pit take falling damage as normal (the acid counts as a yielding surface), plus 2d6 points of acid damage per round spent in contact with the acid. In addition, exposed items carried by a creature in the pit may be harmed. Refer to Table 9-2: Items Affected by Magical Attacks (Core Rulebook 216). Items are affected one at a time in the order listed on the table, and must make Fortitude saves after 3 consecutive rounds in the acid or gain the broken condition. Objects with the broken condition (regardless of how they became broken) must make a Fortitude saving throw each round spent within the acid or be destroyed. The walls of the pit are quite slippery and have a Climb DC of 30.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "10-ft.-by-10-ft. hole, 10 ft. deep/2 levels",
        targets: "",
        duration: "1 round + 1 round/level",
        savingThrow: "Reflex negates; see text",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Aggravate Affliction",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `All recurring afflictions (those with a frequency,including curses, diseases, and poison) possessed by the targeted creature immediately trigger, requiring an immediate saving throw (as described in the affliction) to avoid suffering their effects. A successful saving throw does not count toward ending the affliction, and this extra save does not change the timing of the next save against the affliction. Afflictions without a frequency are unaffected by this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Antiplant Shell",
        type: ["control"],
        school: "abjuration",
        tags: [],
        longDesc: `The antiplant shell spell creates an invisible, mobile barrier that keeps all creatures within the shell protected from attacks by plant creatures or animated plants. As with many abjuration spells, forcing the barrier against creatures that the spell keeps at bay strains and collapses the field.`,
        castingTime: "1 standard action",
        range: "10 ft.",
        area: "10-ft.-radius emanation, centered on you",
        effect: "",
        targets: "",
        duration: "1 min./level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Antithetical Constraint",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You constrain the target such that the target automatically misses with all attacks made against creatures that are not of the opposite alignment of it. For example, a lawful evil target would automatically fail at all attacks except those made against chaotic good creatures, and a neutral good target would automatically fail at all attacks except those made against neutral evil creatures. For the purposes of antithetical constraint, creatures that are chaotic evil, chaotic good, lawful evil, or lawful good are all considered to have the opposite alignment of a target whose alignment is neutral with no other alignment components. This restriction doesn't apply to effects that do not require attack rolls, such as magic missile.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "4",
        name: "Aura Of Doom",
        type: ["control"],
        school: "necromancy",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `You emanate an almost palpable aura of horror. All non-allies within this spell's area, or that later enter the area, must make a Will save to avoid becoming shaken. A successful save suppresses the effect. Creatures that leave the area and come back must save again to avoid being affected by the effect.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "20-ft.-radius emanation centered on you",
        effect: "",
        targets: "",
        duration: "10 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Bestow Curse",
        type: ["control"],
        school: "necromancy",
        tags: ["curse"],
        longDesc: `You place a curse on the subject. Choose one of the following. -6 decrease to an ability score (minimum 1). -4 penalty on attack rolls, saves, ability checks, and skill checks. Each turn, the target has a 50% chance to act normally; otherwise, it takes no action. You may also invent your own curse, but it should be no more powerful than those described above. The curse bestowed by this spell cannot be dispelled, but it can be removed with a break enchantment, limited wish, miracle, remove curse, or wish spell. Bestow curse counters remove curse.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "permanent",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Black Tentacles",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `This spell causes a field of rubbery black tentacles to appear, burrowing up from the floor and reaching for any creature in the area. Every creature within the area of the spell is the target of a combat maneuver check made to grapple each round at the beginning of your turn, including the round that black tentacles is cast. Creatures that enter the area of effect are also automatically attacked. The tentacles do not provoke attacks of opportunity. When determining the tentacles' CMB, the tentacles use your caster level as their base attack bonus and receive a +4 bonus due to their Strength and a +1 size bonus. Roll only once for the entire spell effect each round and apply the result to all creatures in the area of effect. If the tentacles succeed in grappling a foe, that foe takes 1d6+4 points of damage and gains the grappled condition. Grappled opponents cannot move without first breaking the grapple. All other movement is prohibited unless the creature breaks the grapple first. The black tentacles spell receives a +5 bonus on grapple checks made against opponents it is already grappling, but cannot move foes or pin foes. Each round that black tentacles succeeds on a grapple check, it deals an additional 1d6+4 points of damage. The CMD of black tentacles, for the purposes of escaping the grapple, is equal to 10 + its CMB. The tentacles created by this spell cannot be damaged, but they can be dispelled as normal. The entire area of effect is considered difficult terrain while the tentacles last.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "20-ft.-radius spread",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "BlackLight",
        type: ["control"],
        school: "evocation",
        tags: ["darkness"],
        longDesc: `You create an area of total darkness. The darkness is impenetrable even to darkvision, but you can see normally within it. Creatures outside the spell's area, even you, cannot see through it.
        \nYou can cast the spell on a point in space, but the effect is stationary unless cast on a mobile object. You can cast the spell on a creature, and the effect then radiates from the creature and moves as it moves. Unattended objects and points in space do not get saving throws or benefit from spell resistance.
        \nBlacklight counters or dispels any light spell of equal or lower level. Daylight counters or dispels blacklight.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "20-ft.-radius emanation",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "Will negates or none (object)",
        spellResistance: "yes or no(Object)",
        components: "V,S",
        },
        {
        level: "4",
        name: "Charm Monster",
        type: ["control"],
        school: "enchantment(charm)",
        tags: ["mind-affecting"],
        longDesc: `This charm a creature regard you as friendly. The creature will not attack you and will attempt to exclude you from all area of affect abilities or spells it has (it wont turn off that ablity if it us unable to avoid you), it can also count for flanking or as an ally for any other ability you have, and will accept harmless spells cast by you. It will not attempt to help you in any other way and you have no other control over it, such as protecting you from another creature, and will attempt to attack all other party members as normal. If you attack, damage, or cast any non-harmless spells on the creature,  it gets an immediate resave with a +5 bonus (once per attack or ability).  `,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 hour/level",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "4",
        name: "Confusion",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell causes confusion in the targets, making them unable to determine their actions. Roll on the following table at the start of each subject's turn each round to see what it does in that round. d% Behavior 01-25 Act normally 26-50 Do nothing but babble incoherently 51-75 Deal 1d8 points of damage + Str modifier to self with item in hand 76-100 Attack nearest creature (for this purpose, a familiar counts as part of the subject's self) A confused character who can't carry out the indicated action does nothing but babble incoherently. Attackers are not at any special advantage when attacking a confused character. Any confused character who is attacked automatically attacks its attackers on its next turn, as long as it is still confused when its turn comes. Note that a confused character will not make attacks of opportunity against any creature that it is not already devoted to attacking (either because of its most recent action or because it has just been attacked).`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "all creatures in a 15-ft.-radius burst",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Conjure Deadfall",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You conjure a large metal cube covered in sharp spikes. If you conjure the block so that it appears in midair, it immediately plummets downward onto all creatures below it. When you cast this spell, you select the size of the square area you wish it to affect. If you choose to create a deadfall over a single 5-foot square, the block deals 1d6 points of bludgeoning damage per caster level (maximum 15d6) to each creature in the area. A deadfall over a 10-foot square deals 1d6 points of bludgeoning damage per 2 caster levels (maximum 7d6), a deadfall over a 15- foot square deals 1d6 points of bludgeoning damage per 3 caster levels (maximum 5d6), and so on, to a maximum size of a 25- foot square. Only creatures that are on the outer edge of the area affected by a conjure deadfall spell can attempt Reflex saves to avoid the effect; creatures whose space does not touch the edge of the deadfall do not receive a save. In order to deal damage, the conjured deadfall must start at least 10 feet above the tallest creature in the area to be affected. A conjured deadfall is as tall as it is wide, and the spell fails if you attempt to conjure a deadfall in an area already occupied by a creature or object (including the ceiling). Regardless, a deadfall conjured by this spell disappears as soon as it deals damage or strikes the ground.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "see text",
        effect: "one spiked, falling block",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex negates (see text)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Contagion",
        type: ["control"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `The subject contracts one of the following diseases: blinding sickness, bubonic plague, cackle fever, filth fever, leprosy, mindfire, red ache, shakes, or slimy doom. The disease is contracted immediately (the onset period does not apply). Use the disease's listed frequency and save DC to determine further effects. For more information on these diseases, see page 557.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "instantaneous",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Control Summoned Creature",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You seize control of a summoned creature by disrupting the bond between it and the caster who summoned it. If the creature fails its save, you may command it as if you had summoned it. The original caster can attempt to regain control of the creature as a standard action by making an opposed Spellcraft check against you. When your spell ends, control reverts to the original summoner. If the summoning spell ends before this spell ends, the remaining duration of this spell is lost.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one summoned creature",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Creeping Ice",
        type: ["control"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `This spell covers the floor, the ground, or some other calm horizontal surface (such as a placid lake or a gentle river) with a sheet of slowly growing ice. The initial sheet of ice cannot form in an area occupied by physical objects or creatures. Its surface must be smooth and unbroken when created. The ice is hard, strong, and opaque, and is 1 inch thick per caster level. The ice is strong enough to support the weight of a typical horse, making it possible for creatures to cross a body of water. Each 10-foot square of ice has 3 hit points per inch of thickness. Creatures can hit the ice automatically. A section of ice whose hit points drop to 0 is destroyed, leaving an area of ice chunks, slush, and snow that counts as difficult terrain. If a creature tries to break through the ice with a single attack, the DC for the Strength check is 15 + your caster level. Each round on your turn, the sheet of ice grows 1 foot in all directions except toward you. This growth is slow enough that any creature in the area has time to move out of the way or step onto the ice. If the growing ice completely covers a creature's square, the creature must choose whether it moves onto the sheet of ice, is knocked prone on the sheet of ice, or is bull rushed into an adjacent square.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "anchored plane of ice, up to one 10-ft. square/level",
        targets: "",
        duration: "10 minutes/level",
        savingThrow: "Reflex negates (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Crushing Despair",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `An invisible cone of despair causes great sadness in the subjects. Each affected creature takes a -2 penalty on attack rolls, saving throws, ability checks, skill checks, and weapon damage rolls. Crushing despair counters and dispels good hope.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "1 min./level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Curse of Magic Negation",
        type: ["control"],
        school: "abjuration",
        tags: ["curse"],
        longDesc: `You disrupt the target creature's ability to draw upon magical energies. For the duration of the spell, it gains the negated spellblight (see page 97). Dispel checks to remove the spellblight take a -5 penalty due to this spell's interference with magical energies.`,
        castingTime: "1 round",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "10 minute/level",
        savingThrow: "Will negates",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Daze, Mass",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell functions as daze, except as noted above.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one or more humanoid creatures, no two of which may be more than 30 ft. apart",
        duration: "1 round",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Debilitating Portent",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `The target is surrounded by a glowing green aura of ill fate. Each time the spell's subject makes an attack or casts a spell, it must succeed at a Will saving throw with a DC = 10 + 1/2 caster level + highest mental stat. If it fails the saving throw, it deals half damage with the attack or spell. You can dismiss this spell as an immediate action when the target confirms a critical hit; doing so negates the critical hit. The attack that you negated still hits, but only deals half damage.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level (D) see text",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Dreadscape",
        type: ["control"],
        school: "illusion(phantasm)",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `Your targets see their surroundings as a nightmarish reflection of the world around them. Buildings and furnishings take on a dirty, ruined appearance. Even allies appear foreign and hostile, with friendly speech turning into garbled mockery and threats. Each target gains the scared condition and has a hostile attitude toward any new creature it encounters (though not toward creatures that were already present at the time of the casting). Being hostile doesn't necessarily mean the target will attack, and creatures can attempt Diplomacy checks to gain a target's trust at the normal DC. If a creature becomes frightened or panicked while under the influence of dreadscape, that creature takes 1d6 points of Wisdom damage, though only once per casting of dreadscape. If your campaign uses the sanity system (see page 12), creatures that become frightened or panicked take 2d6 sanity damage instead of Wisdom damage.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "up to one creature/level, no two of which can be more than 30 feet apart",
        duration: "10 minutes/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Fear",
        type: ["control"],
        school: "necromancy",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `An invisible cone of terror causes each living creature in the area to become panicked unless it succeeds on a Will save. If cornered, a panicked creature begins cowering. If the Will save succeeds, the creature is shaken for 1 round.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "1 round/level or 1 round; see text",
        savingThrow: "Will partial",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Forced Repentance",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You force an evil creature that does not have the evil subtype to momentarily reflect on its past actions and be overcome by grief and conscience. The target immediately drops prone and begins to loudly confess all of its sins and transgressions to the caster for the duration of the spell. The spell immediately ends if you move out of line of sight or if the target is attacked.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one evil creature without the evil subtype",
        duration: "1 round/level",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Forgetful Slumber",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell acts as the deeper slumber spell, but only affects one creature of 10 Hit Dice or fewer. In addition, a creature affected by this spell awakens with no knowledge of the events that led to the spell's casting. The target loses all memory from the 5 minutes prior to falling asleep. No effect short of a miracle or wish can restore memories lost by this spell.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Hallucinogenic Smoke",
        type: ["control"],
        school: "conjuration",
        tags: ["poison"],
        longDesc: `Dark gray smoke seeps from your eyes, ears, and mouth for the spell's duration, though the smoke doesn't significantly hamper your vision. Upon casting the spell, you may immediately exhale the smoke in a 30-foot cone or do so in a later round as a standard action, ending the spell. Each living creature caught within the cone must succeed at a Fortitude save or be nauseated for 1 round per caster level as it is wracked with waves of nausea and disorienting visions. If it succeeds at its Fortitude save, the creature is instead sickened for 1d4 rounds. If you don't expel the smoke by the end of the spell's duration, you suffer the spell's effects instead. If you cast augury during the duration of hallucinogenic smoke, treat your caster level as 5 higher when determining the chance for a meaningful reply. Additionally, you know whether a result of 'nothing' resulted from a failed or successful augury.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "3 rounds/level or until discharged; see text",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "S, M,",
        },
        {
        level: "4",
        name: "Hunger for Flesh",
        type: ["control"],
        school: "necromancy",
        tags: ["evil", "mind-affecting"],
        longDesc: `Your target's belly distends and its front teeth grow longer and sharper. The creature ravenously craves the flesh of its own kind, gaining the staggered condition as hunger pangs rack its altered body. The target gains a bite attack as a primary natural attack that deals damage appropriate for its size (1d6 if Medium, 1d4 if Small). There's a 25% chance on each of the creature's turns that it can't overcome its hunger. If so, it must move directly toward the nearest corporeal creature of its type and subtype (if applicable) and make a bite attack against it. If the target lacks enough actions to attack on that turn, it moves as close to the creature as it can, but on its next turn, if the percentile dice indicate it overcomes its hunger, the target is not forced to pursue or attack further. On any round after the target deals damage to another creature of its own type and subtype (if applicable) with its bite attack, the target loses the staggered condition. If it doesn't continue dealing bite damage to applicable creatures, the target regains the staggered condition at the beginning of its next turn.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one humanoid, magical beast, or monstrous humanoid",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Hurricane Blast",
        type: ["control"],
        school: "evocation",
        tags: [],
        longDesc: `This spell creates a severe blast of air (approximately 50 mph) that originates from you, affecting all creatures in the burst.
        \nA Tiny or smaller creature on the ground is knocked down and rolled 1d4×10 feet, taking 1d4 points of nonlethal damage per 10 feet. If flying, a Tiny or smaller creature is blown back 2d6×10 feet and takes 2d6 points of nonlethal damage due to battering and buffeting.
        \nSmall creatures are knocked prone by the force of the wind, or if flying are blown back 1d6×10 feet.
        \nMedium creatures are unable to move forward against the force of the wind, or if flying are blown back 1d6×5 feet.
        \nLarge or larger creatures may move normally within a hurricane blast effect.
        \nHurricane blast can't move a creature beyond the limit of its range. Any creature, regardless of size, takes a –4 penalty on ranged attacks and Listen checks in the area of a hurricane blast. The force of the gust automatically extinguishes candles, torches, and similar unprotected flames. It causes protected flames, such as those of lanterns, to dance wildly and has a 50% chance to extinguish those lights.
        \nIn addition to the effects noted, a hurricane blast can do anything that a sudden blast of wind would be expected to do. It can create a stinging spray of sand or dust, fan a large fire, overturn delicate awnings or hangings, and blow gases or vapors to the edge of its range.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "5-ft.-radius burst/2 levels (maximum 25-ft.-radius burst)",
        effect: "",
        targets: "you",
        duration: "1 round",
        savingThrow: "Reflex negates",
        spellResistance: "no",
        components: "V, S",
        },
        {
        level: "4",
        name: "Irregular Size",
        type: ["control"],
        school: "transmutation",
        tags: ["curse"],
        longDesc: `You curse a creature so one set of its limbs (typically its arms, legs, or wings) shrivels in size. Arms: The creature counts as one size category smaller for the purpose of determining the size of weapon it can wield. If the creature is capable of making natural attacks with its arms, the damage dealt by those attacks decreases as though the target were one size category smaller than its actual size.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "permanent",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Litany of Admonition",
        type: ["control"],
        school: "necromancy",
        tags: ["language-dependent"],
        longDesc: `You point out your target's faults and failures, staggering the target for 1 round. While subject to this spell, the target cannot be the target of another spell that has the word “litany” in the title.`,
        castingTime: "1 swift action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round",
        savingThrow: "fortitude negates",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Litany of Eloquence",
        type: ["control"],
        school: "enchantment(charm)",
        tags: ["language-dependent", "mind-affecting"],
        longDesc: `Your litany is a fascinating diatribe of grace, causing your target to do nothing but listen. The target is fascinated. If the target is attacked or threatened it is granted an additional save.
        \nWhile subject to this spell, the target cannot be the target of another spell that has the word “litany” in the title.`,
        castingTime: "1 swift action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Litany of Entanglement",
        type: ["control"],
        school: "conjuration(calling)",
        tags: ["language-dependent"],
        longDesc: `Your litany conjures chains of energy that lash upward from the ground and hamper the target's movement. The target is entangled. This spell has no effect on flying creatures, or creatures not standing upon solid ground. While subject to this spell, the target cannot be the target of another spell that has the word “litany” in the title.`,
        castingTime: "1 swift action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Malicious Spite",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You invoke feelings of a driving malicious intent. The target's malice is directed at a second individual as designated by you at the time of casting. Thereafter, the target attempts to slander, abuse, and even plot murder against the target of its spite. This loathing is not overt, and the target's actions against the object of its spite remain subtle and indirect. The enchanted target remains within its financial and ethical means when acting against the second individual, though the malice toward this other person pushes the target to the limit of what it would do to a hated individual. Each day, the target takes 2 points of Wisdom damage as the all-encompassing spite dominates its thoughts. The target can only alleviate the ability damage by acting upon the emotion and performing a spiteful act. Examples of spiteful acts are spiking the target's drink to make it an easier target for thugs, damaging the target's property, starting foul rumors about the target, framing the target for a crime, paying lepers or beggars to accost the target, extorting or blackmailing the target, or arranging for others to physically harm the target. When the spell ends, the target remembers the spiteful behavior, but not the motivation for it.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 day/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Moonstruck",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You invoke the mystical power of the moon to drive the target into a mad, bestial frenzy. If the target fails its save, it is dazed for 1 round, dropping held items as its nails and teeth elongate and sharpen. The target gains a bite attack and two claw attacks that deal damage appropriate for the creature's size, and for the remainder of the spell's duration the target behaves as if under simultaneous rage and confusion spells, attacking with its natural weapons in preference to other actions. During the final round of the spell's duration, the target is again dazed as it returns to its normal state.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one humanoid creature",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Mydriatic Spontaneity",
        type: ["control"],
        school: "evocation",
        tags: ["darkness", "light"],
        longDesc: `You overstimulate the target with alternating flashes of light and shadow within its eyes, causing its pupils to rapidly dilate and contract. While under the effects of this spell, the target is racked by splitting headaches and unable to see clearly, becoming nauseated for the spell's duration. Each round, the target's pupils randomly become dilated or contracted for 1 round. During any round that its eyes are dilated, the target is blinded if exposed to bright light or dazzled if exposed to normal light. During any round its eyes are contracted, the target is blinded if exposed to darkness or dazzled if exposed to dim light. In addition, any creature can attempt a Stealth check to avoid detection from the target, even if the creature lacks cover or concealment.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
            level: "2",
            name: "Overstimulate",
            type: ["buff"],
            school: "transmutation",
            tags: [],
            longDesc: `You deprive a creature of the blissful oblivion of unconsciousness, either to keep it going despite grievous injuries or to prolong its suffering. For the duration of the spell, the target gains the ferocity ability, allowing it to remain conscious and continue fighting even if its hit point total is below 0. The target is still staggered and loses 1 hit point each round, and the target still dies as normal when its hit points are reduced below the normal amount.`,
            castingTime: "1 standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "one creature",
            duration: "1 round/level",
            savingThrow: "Fortitude negates (harmless)",
            spellResistance: "yes(harmless)",
            components: "V, S, M/DF",
        },
        {
        level: "4",
        name: "Nixie's lure",
        type: ["control"],
        school: "enchantment(charm)",
        tags: ["mind-affecting", "sonic"],
        longDesc: `This spell creates an unearthly and infectious song that seductively summons all who hear it. Nixie's lure affects a maximum of 24 Hit Dice of creatures. Creatures in the area who fail their saves are lured by the song and move toward you using the most direct means available. If the path leads them into a dangerous area such as through fire or off a cliff, the creatures each receive a second saving throw to end the effect before moving into peril. Creatures lured by the spell's song can take no actions other than to defend themselves. A victim within 5 feet of you simply stands still and for the duration of the spell remains fascinated.`,
        castingTime: "1 standard action",
        range: "300 ft.",
        area: "",
        effect: "",
        targets: "all creatures within a 300-ft.-radius burst centered on you",
        duration: "concentration + 1 round/level (D)",
        savingThrow: "Will Negates",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "4",
        name: "Obsidian Flow",
        type: ["control"],
        school: "transmutation",
        tags: ["earth", "fire"],
        longDesc: `You convert a thin layer of the ground to molten glass that cools quickly. Creatures in the area take 1d6 points of fire damage per two caster levels (maximum of 10d6) and become entangled. Any creature within the area that makes a successful Reflex save takes half damage and is not entangled. An entangled creature can attempt to free itself by spending a move action to attempt a Strength check or Escape Artist check (the DC equals the spell's saving throw DC). The ground is covered with slippery expanses and sharp shards of obsidian. The area of effect is difficult terrain, and the DC of Acrobatics checks within the area of effect increases by 5. A successful DC 15 Acrobatics check is required to run or charge across the area. A creature that falls prone in the area takes 1d6 points of damage from sharp obsidian.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "20-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex partial, see text",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Overwhelming Grief",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You cause a single opponent to become profoundly stricken with intense grief. He can take no actions, takes a -2 penalty to Armor Class, and loses his Dexterity bonus (if any). He can attempt a new save each round to break the spell's effect.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "Will negates (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Phantasmal Asphyxiation",
        type: ["control"],
        school: "illusion(phantasm)",
        tags: ["mind-affecting"],
        longDesc: `Your target must succeed at a Will save or believe it can no longer breathe. An affected target must attempt a Fortitude save each round at the beginning of its turn. The first time it fails the Fortitude save, it is staggered until the next time it attempts a save against the spell. If the target fails a second Fortitude save in a row, it falls unconscious for the spell's remaining duration. The target breathes normally while unconscious, but is shaken for 1 minute upon awakening. If the target succeeds at two Fortitude saves in a row, it shakes off the spell's effects entirely. Otherwise, the target continues to attempt a save each round until it falls unconscious or the spell ends. This spell has no effect on creatures that don't need to breathe.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round/level (D)",
        savingThrow: "Will disbelief, then Fortitude partial (see text)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Poison",
        type: ["control"],
        school: "necromancy",
        tags: ["poison"],
        longDesc: `Calling upon the venomous powers of natural predators, you infect the subject with a horrible poison by making a successful melee touch attack. This poison deals 1d3 Constitution damage per round for 6 rounds. Poisoned creatures can make a Fortitude save each round to negate the damage and end the affliction.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "instantaneous; see text",
        savingThrow: "Fortitude negates; see text",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Rainbow Pattern",
        type: ["control"],
        school: "illusion(pattern)",
        tags: ["mind-affecting"],
        longDesc: `A glowing, rainbow-hued pattern of interweaving colors fascinates those within it. Rainbow pattern fascinates a maximum of 24 HD of creatures. Creatures with the fewest HD are affected first. Among creatures with equal HD, those who are closest to the spell's point of origin are affected first. An affected creature that fails its saves is fascinated by the pattern. With a simple gesture (a free action), you can make the rainbow pattern move up to 30 feet per round (moving its effective point of origin). All fascinated creatures follow the moving rainbow of light, trying to remain within the effect. Fascinated creatures who are restrained and removed from the pattern still try to follow it. If the pattern leads its subjects into a dangerous area, each fascinated creature gets a second save. If the view of the lights is completely blocked, creatures who can't see them are no longer affected. The spell does not affect sightless creatures.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "colorful lights with a 20-ft.-radius spread",
        targets: "",
        duration: "Concentration +1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,F,",
        },
        {
        level: "4",
        name: "Slowing Mud",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You coat the targets in thick, sticky mud. The mud acts as a slow spell and also blinds the targets. A creature can use a standard action to remove the mud from its eyes or the eyes of an adjacent creature, ending the blinded condition for that individual. Removing enough mud to end the slow effect is a full-round action. Jumping into a lake or being subject to an effect that creates a lot of water (such as create water or hydraulic pushAPG) removes all the mud in 1 round. A haste effect cast on a creature slowed by the mud allows it to act normally for the duration of the haste. Slow does not stack with the effects of slowing mud. This spell cannot counter or dispel haste.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level (see text)",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M, ",
        },
        {
        level: "4",
        name: "Solid Fog",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `This spell functions like fog cloud, but in addition to obscuring sight, the solid fog is so thick that it impedes movement. Creatures moving through a solid fog move at half their normal speed and take a -2 penalty on all melee attack and melee damage rolls. The vapors prevent effective ranged weapon attacks (except for magic rays and the like). A creature or object that falls into solid fog is slowed so that each 10 feet of vapor that it passes through reduces the falling damage by 1d6. A creature cannot take a 5-foot-step while in solid fog. Solid fog, and effects that work like solid fog, do not stack with each other in terms of slowed movement and attack penalties. Unlike normal fog, only a severe wind (31+ mph) disperses these vapors, and it does so in 1 round.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft. level)",
        area: "",
        effect: "fog spreads in 20-ft. radius",
        targets: "",
        duration: "1 min./level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Spike Stones",
        type: ["control"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `Rocky ground, stone floors, and similar surfaces shape themselves into long, sharp points that blend into the background. Spike stones impede progress through an area and deal damage. Any creature moving on foot into or through the spell's area moves at half speed. In addition, each creature moving through the area takes 1d8 points of piercing damage for each 5 feet of movement through the spiked area. Any creature that takes damage from this spell must also succeed on a Reflex save to avoid injuries to its feet and legs. A failed save causes the creature's speed to be reduced to half normal for 24 hours or until the injured creature receives a cure spell (which also restores lost hit points). Another character can remove the penalty by taking 10 minutes to dress the injuries and succeeding on a Heal check against the spell's save DC. Magic traps such as spike stones are hard to detect. A character with trapfinding can use the Perception skill to find spike stones. The DC is 25 + spell level, or DC 29 for spike stones. Spike stones is a magic trap that can't be disabled with the Disable Device skill.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "one 20-ft. square/level",
        effect: "",
        targets: "",
        duration: "1 hour/level (D)",
        savingThrow: "Reflex partial",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Spit Venom",
        type: ["control"],
        school: "transmutation",
        tags: ["poison"],
        longDesc: `You spit a stream of venom at a target using a ranged touch attack. If the venom hits, it causes blindness for 1 round. The target must also save or be poisoned by black adder venom; the DC in successive rounds of the poison is equal to the spell's DC.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one stream of venom",
        targets: "",
        duration: "instantaneous; see text",
        savingThrow: "Fortitude partial",
        spellResistance: "no",
        components: "V, ",
        },
        {
        level: "4",
        name: "Terrible Remorse",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You fill a target with such profound remorse that it begins to harm itself. Each round, the target must save or deal 1d8 points of damage + its Strength modifier to itself using an item held in its hand or with unarmed attacks. If the creature saves, it is staggered for 1 round and takes a -2 penalty to Armor Class, after which the spell ends.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 living creature",
        duration: "1 round/level",
        savingThrow: "Will partial (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Unbearable Brightness",
        type: ["control"],
        school: "evocation",
        tags: ["light"],
        longDesc: `Your body glows with a terrible light. Creatures within 30 feet of you that can see you are dazzled (no saving throw). Creatures with light sensitivity must succeed at a Reflex saving throw or be blinded. This light counts as daylight for the purpose of affecting darkness effects (and vice versa). If the emanation enters an area under the effect of magical darkness (or vice versa), both effects are temporarily negated so that the otherwise prevailing light conditions exist in the overlapping areas of effect. Dazzled and blinded conditions from your light end when the spell ends or when the creature is out of line of sight.`,
        castingTime: "1 standard action",
        range: "personal and 30 ft. (see text)",
        area: "30-ft.-radius emanation centered on you",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none and Reflex partial (see text)",
        spellResistance: "no and yes (see text)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Wall of Blindness/Deafness",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `You create a translucent wall of energy, within which can be seen indistinct images of faces with their eyes or ears sewn shut. When you create the wall, decide whether it blinds or deafens. Any creature that passes through the wall must save or become permanently blinded or deafened (as blindness/deafness). The wall must be vertical and either rectangular or a ring. It need not touch the ground. The wall must be continuous and unbroken when formed. If its surface is broken by any object or creature when it is cast, the spell fails.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "translucent wall 20 ft. long/level or a translucent ring with a radius of up to 5 ft./two levels; either form 20 ft. high",
        targets: "",
        duration: "concentration + 1 round/level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Wandering Star Motes",
        type: ["control"],
        school: "illusion(pattern)",
        tags: ["light", "mind-affecting"],
        longDesc: `You create sparkling motes of bright light that shoot toward the target and swirl around it in a complex pattern. The pattern clearly outlines the target and radiates light as if it were a sunrod, negating any concealment for the target. The target must make a successful Will save. If the target fails its save, it is dazed for 1 round and must make another save on its next turn or be dazed again for 1 round. The target must continue making Will saves each round. If a target makes its Will save, the wandering star motes jump to the nearest enemy within 30 feet, who must now make Will saves every round or be dazed. Any time a target makes its Will save, the wandering star motes jump to the next nearest enemy within 30 feet. A given creature can only be affected by the wandering star motes once; once a target has successfully saved against the spell, it cannot be affected again. If there are no new targets within 30 feet of a target that has successfully made its save, the spell immediately ends. The spell only affects enemy creatures; your allies are not affected.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature and special; see text",
        duration: "1/round per level",
        savingThrow: "Will negates; see text",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Web Cloud",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You create a cloud of flame-resistant strands of adhesive webbing that billows and flows much like a cloudkill spell. The cloud moves away from you at a rate of 10 feet per round, rolling along the surface of the ground.
        \nFigure out the cloud's new spread each round based on its new point of origin, which is 10 feet farther away from the point of origin where the caster cast the spell. Creatures trapped in the webbing remain trapped even after the cloud passes, but the area the cloud leaves behind does not count as difficult terrain.
        \nBecause the webbing is heavier than air, it sinks to the lowest level of the land, even pouring down openings. The cloud of webbing cannot penetrate liquids, nor can it be cast underwater. The cloud otherwise acts like a web spell. A creature in the cloud at the start of its turn must save against the cloud or be affected. The webbing of this spell is flammable (see the web spell), but has fire resistance 5.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "cloud spreads in 20-ft. radius, 20 ft. high",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "reflex partial; see text",
        spellResistance: "no",
        components: "V, S",
        },
        {
        level: "4",
        name: "Calcific Touch",
        type: ["control", "damage"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `Your touch progressively transmutes the substance of creatures you touch into stone. Once per round, you may deliver a touch attack that inflicts 1d4 points of Dexterity damage and slows the target (as the spell) for 1 round. A successful Fortitude save negates the slow effect but not the ability damage. A target reduced to 0 Dexterity is petrified permanently. Break enchantment, restoration, or stone to flesh can reverse the effects of calcific touch.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature or creatures touched (up to one per level)",
        duration: "1 round/level",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Masochistic Shadow",
        type: ["control", "damage"],
        school: "necromancy",
        tags: ["evil", "shadow"],
        longDesc: `You animate the target's shadow with semi-living energies drawn from the Shadow Plane, instilling a maddening hunger for its owner's life energy within it. If the target fails its Will save, it takes 1d4 points of Strength damage as a quasi-real shadow manifests in its space and attacks it. This shadow remains attached to the target and moves wherever the target moves. At the start of each subsequent round, the target must succeed at a Reflex save or take 1d4 additional points of Strength damage; a successful save reduces the Strength damage to 1 point. If its Strength score is reduced to 0 by this spell's effects, the target dies. If the target is in bright light, it gains a +2 bonus on Reflex saves against this spell. If the target is in darkness, it takes a -2 penalty on Reflex saves against this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level (D)",
        savingThrow: "Will negates, then Reflex partial; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Rigor Mortis",
        type: ["control", "damage"],
        school: "transmutation",
        tags: ["pain"],
        longDesc: `The joints of a creature affected by this spell stiffen and swell, making movement painful and slow. The target takes 1d6 points of nonlethal damage per caster level. Additionally, the target takes a -4 penalty to Dexterity and its movement speed decreases by 10 feet; these additional effects last for 1 minute per caster level, though another creature can spend 1 minute and attempt a DC 25 Heal check to end them early. A successful save halves the nonlethal damage and negates the penalty to Dexterity and movement.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "instantaneous; see text",
        savingThrow: "Fortitude partial (see text)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Dimensional Anchor",
        type: ["control", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `A green ray springs from your hand. You must make a ranged touch attack to hit the target. Any creature or object struck by the ray is covered with a shimmering emerald field that completely blocks extradimensional travel. Forms of movement barred by a dimensional anchor include astral projection, blink, dimension door, ethereal jaunt, etherealness, gate, maze, plane shift, shadow walk, teleport, and similar spell-like abilities, or any other ability that would qualify, as teleportation. The spell also prevents the use of a gate or teleportation circle for the duration of the spell. A dimensional anchor does not interfere with the movement of creatures already in ethereal or astral form when the spell is cast, nor does it block extradimensional perception or attack forms. Also, dimensional anchor does not prevent summoned creatures from disappearing at the end of a summoning spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "ray",
        targets: "",
        duration: "1 min./level",
        savingThrow: "none",
        spellResistance: "yes (object)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Sadomasochism",
        type: ["control", "utility"],
        school: "necromancy",
        tags: ["pain"],
        longDesc: `While subject to this spell, anytime you are dealt damage, your attacker must roll damage for the attack twice and take the higher result, but the attacker must also succeed at a Will saving throw or be demoralized for 1 round. Each time you deal damage to a creature demoralized by this spell, you roll damage twice and take the higher result.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "Will negates, see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Stay the Hand",
        type: ["control", "utility"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You cause a creature's arm to waver and prevent it from striking another creature. You can cast this spell when the target is about to make a melee attack against another creature. On a failed saving throw, the target does not follow through with its attack, and its entire action is wasted for the round. On a successful saving throw, the target can make its attack, forcing its strike though the compulsion but losing both accuracy and power, taking a –5 penalty on its attack and damage rolls. Whether or not the target makes its initial save or not, it is subject to a –2 penalty on attack and damage rolls against the creature it originally targeted for the duration of the spell.`,
        castingTime: "1 immediate action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level and special; see text",
        savingThrow: "will partial",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "True Form",
        type: ["control", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `True form removes any polymorph effect from a target creature, returning it to its true form, even against its will. Against creatures affected by polymorph spell effects (such as baleful polymorph or giant form), you must make a caster level check (1d20 + caster level, maximum +15) against a DC of 11 + caster level of the effect. Success means that the polymorph immediately ends. A creature with the supernatural ability to change shape (such as a lycanthrope) must make a Will saving throw or immediately revert to its true form. If it fails this first saving throw, the creature can attempt another Will saving throw to overcome the spell as a full-round action that does not provoke attacks of opportunity. If this save succeeds, the spell ends and the creature is capable of changing shape once again. If the second save fails, the creature is locked in its true form for the duration of the spell, preventing any further polymorph effects from changing its shape.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "up to one creature/3 levels, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Anti-Incorporeal Shell",
        type: ["control", "utility", "buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You bring into being a mobile, hemispherical energy field that incorporeal creatures cannot enter.
        
                This spell can be used only defensively, not aggressively. Forcing an abjuration barrier against creatures that the spell keeps at bay collapses the barrier.`,
        castingTime: "1 round",
        range: "10 ft",
        area: "10-ft.-radius emanation centered on you",
        effect: "",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Conjuration Foil",
        type: ["control", "utility", "damage"],
        school: "abjuration",
        tags: [],
        longDesc: `All creatures in the area gain a +4 bonus on saving throws against teleportation effects. If any creature would enter or depart the area via a summoning or teleportation effect, that creature takes 4d6 points of damage per spell level of the triggering effect (or half the HD of the originating creature if the effect has no spell level) and arrives in a random similar location within the triggering effect's range, rather than the intended destination.
                A successful Will save halves the damage and negates the altered destination.`,
        castingTime: "1 immediate action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "20-foot radius spread",
        effect: "",
        targets: "",
        duration: "1 round",
        savingThrow: "Will partial (see text)",
        spellResistance: "yes (object)",
        components: "S",
        },
        {
        level: "4",
        name: "Acidic Overload",
        type: ["damage"],
        school: "evocation",
        tags: ["acid"],
        longDesc: `You amplify the acidity of your acid spells, during the round you were casting this spell, if any creature took acid damage from a spell you cast not on that round, they take 1d8 acid damage per caster level (max 15d8).`,
        castingTime: "1 round action",
        range: "medium (100ft + 10ft/level)",
        area: "",
        effect: "",
        targets: "all creatures within range",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "4",
        name: "Aggressive Thundercloud, Greater",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity", "sonic"],
        longDesc: `This spell functions as aggressive thundercloud, except it deals 6d6 points of electricity damage to any creature it strikes. The first creature damaged by the cloud is also stunned for 1 round (Fortitude negates); this is a sonic effect.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "5-ft.-diameter sphere",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Reflex negates and Fortitude negates (see text)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Ball Lightning",
        type: ["damage"],
        school: "evocation",
        tags: ["air", "electricity"],
        longDesc: `You create two globes of lightning that fly in whichever direction you indicate. For every 4 caster levels above 7th, you create an additional globe of lightning (3 globes at 11th, 4 globes at 15th, to the maximum of 5 globes at 19th). These globes fly at a rate of 20 feet per round and have perfect maneuverability. Wind does not affect a flying sphere's course. If a globe enters a space with a creature, it stops moving for the round and deals 3d6 points of electricity damage to that creature, though a successful Reflex save negates the damage. Creatures wearing metal armor take a -4 penalty on this saving throw. Each globe moves as long as you actively direct it (it's a move action for you to direct all the spheres created by a single casting of this spell); otherwise they stay at rest. These globes have no mass and cannot push aside unwilling creatures or move solid objects. A ball lightning globe winks out if it exceeds the spell's range.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "two or more 5-ft.-diameter spheres",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Reflex negates",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Bloatbomb",
        type: ["damage"],
        school: "necromancy",
        tags: ["acid", "death"],
        longDesc: `The target creature dies if it fails a Fortitude saving throw and its Hit Dice are no more than half your caster level. If it dies, its corpse rapidly putrefies. The next creature to touch the corpse within 1 minute per level of the target's death causes the corpse to explode in a 10-foot-radius burst, dealing 3d6 points of acid damage (Reflex half).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "instantaneous and 1 minute/level (see text)",
        savingThrow: "Fortitude negates or Reflex half (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Boneshatter",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `The target's bones (or exoskeleton) splinter, dealing 1d6 points of damage per caster level (maximum 15d6) to the target, which is also exhausted for 1 minute per caster level from the pain and exertion of the transformation. If the target succeeds at its save, it takes half damage and is fatigued rather than exhausted. Objects made of bone, chitin, or similar material take half again as much damage (+50%) from this spell. This spell has no effect on a creature that has neither a skeleton nor a hard carapace.`,
        castingTime: "1 standard action",
        range: "close 25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one corporeal creature or object",
        duration: "instantaneous and 1 minute/level (see text)",
        savingThrow: "Fortitude partial (see text)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Burst With Light",
        type: ["damage"],
        school: "evocation",
        tags: ["light"],
        longDesc: `The target becomes filled with intense magical light, taking 2d6 points of damage as the light bursts from its wounds and orifices (if the target is an undead creature, it instead takes 2d8 points of damage). In addition, the creature radiates bright light in a 30-foot radius and increases the light level by one step for an additional 30 feet beyond that area-darkness becomes dim light, dim light becomes normal light, and normal light becomes bright light. Creatures that take penalties in bright light take them while within the 30-foot radius of this magical light. A successful Will save halves the damage and negates the light effect. For every 4 character levels you possess, the light continues to fill the creature for another round (to a maximum of 5 rounds at 20th level), though the target may make a Will save each round to halve the damage and end the effect. Any creature adjacent to the target that fails its save and takes damage takes half as much damage and is blinded for 1 round. A successful Reflex save halves this damage (to a total of one-quarter the damage taken by the target) and negates the blindness effect.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/4 levels",
        savingThrow: "see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Chaos Hammer",
        type: ["damage"],
        school: "evocation",
        tags: ["chaotic"],
        longDesc: `You unleash chaotic power to smite your enemies. The power takes the form of a multicolored explosion of leaping, ricocheting energy. Only lawful and neutral (not chaotic) creatures are harmed by the spell. The spell deals 1d8 points of damage per two caster levels (maximum 5d8) to lawful creatures (or 1d6 points of damage per caster level, maximum 10d6, to lawful outsiders) and slows them for 1d6 rounds (see the slow spell). A successful Will save reduces the damage by half and negates the slow effect. The spell deals only half damage against creatures who are neither lawful nor chaotic, and they are not slowed. Such a creature can reduce the damage by half again (down to one-quarter) with a successful Will save.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "20-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous (1d6 rounds); see text",
        savingThrow: "Will partial; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "3",
        name: "Charged Lightning",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `When you cast this spell you can hold the charge for up to 1 round/caster level. While doing so you can continue to cast spells, but the hand being used by this spell becomes occupied (meaning if you hold 2 charges you can no longer cast), and you get a -4 penalty to all concentration checks. You can choose to discharge this spell as a movement action, targeting a creature within close range. It deals 1d6 electricity damage per 2 caster levels (max 5d6) reflex halves. Until you discharge it, each round as a movement action you can charge this spell further, causing it to deal an additional 1d6 damage when discharged (max 10d6 extra damage), however you take a further -1 penalty to concentration checks. Each 2 rounds of charging also increases the DC by +1 (max +10 to DC). If the spell is not discharched within the duration you take the damage, but it instead deals 2d6 damage per round charged.`,
        castingTime: "1 standard action",
        range: "close (25ft + 5ft/2 levels)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "1 round/level then instantaneous",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "4",
        name: "Controlled Fireball",
        type: ["damage"],
        school: "evocation",
        tags: ["fire", "ruse"],
        longDesc: `This spell functions as fireball except you can cause the bead of fire to originate from anywhere you can see within range. You can choose a number of squares within the area up to your highest mental modifier to be struck by weaker flames; the controlled fireball deals minimum damage in those squares. Attempts to identify controlled fireball with a skill check incorrectly identify it as fireball (see the ruse descriptor o n page 192).`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "20-foot-radius spread",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Deafening Song Bolt",
        type: ["damage"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `Three notes you sing or perform become tangible bolts of arcane energy that shriek across the battlefield. Each bolt requires a ranged touch attack to hit and deals 3d10 points of sonic damage, deafening the target for 1d6 rounds. The bolts may be fired at the same or different targets, but all must be fired simultaneously.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "up to 3 creatures, no two of which can be more than 30 ft. apart",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Detonate",
        type: ["damage"],
        school: "evocation",
        tags: ["acid", "cold", "electricity", "fire"],
        longDesc: `You flood yourself with a potent surge of elemental energy. One round after completing the casting of the spell, the energy explodes from your body. When this spell creates the explosion of energy, choose one of the following four energy types: acid, cold, electricity, or fire. The explosion inflicts 1d8 points of damage of that energy type per caster level (maximum 10d8) to all creatures and unattended objects within 15 feet, and half that amount to targets past 15 feet but within 30 feet. You automatically take half damage from the explosion, without a saving throw, but any other energy resistance or energy immunity effects you may have in place can prevent or lessen this overflow damage caused by the explosion.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "30-ft.-radius spread centered on you",
        effect: "",
        targets: "",
        duration: "1 round, then instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Dragon's Breath",
        type: ["damage"],
        school: "evocation",
        tags: ["acid", "cold", "electricity", "fire"],
        longDesc: `You breathe out a blast of energy. Creatures in the affected area take 1d6 points of energy damage per caster level (maximum of 12d6). A successful Reflex save results in half damage. The spell's effect and energy type can be either a 30ft cone or a 60ft line, and deals a primary element damage type (fire, acid, electricity, cold)`,
        castingTime: "1 standard action",
        range: "30 ft. or 60 ft.",
        area: "cone-shaped burst or line",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Enervation",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `You point your finger and fire a black ray of negative energy that suppresses the life force of any living creature it strikes. You must make a ranged touch attack to hit. If you hit, the subject gains 1d4 temporary negative levels (see Appendix 1). Negative levels stack. Assuming the subject survives, it regains lost levels after a number of hours equal to your caster level (maximum 15 hours). Usually, negative levels have a chance of becoming permanent, but the negative levels from enervation don't last long enough to do so. An undead creature struck by the ray gains 1d4 x 5 temporary hit points for 1 hour.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "ray of negative energy",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Fire of Judgment",
        type: ["damage"],
        school: "evocation",
        tags: [],
        longDesc: `After casting this spell, the next creature you attack using your smite evil class ability is engulfed in flames of positive energy. At the start of its turn, the target takes 1d6 points of damage, and takes an additional 1d6 points of damage each time it attacks a creature other than you. If the creature is an outsider with the evil subtype, an evil-aligned dragon, or an undead creature this damage increases to 1d10. With a successful Saving Throw, a creature is affected by this spell for only 1 round. This damage is divine in nature and bypasses any DR the creature possesses.`,
        castingTime: "1 swift action",
        range: "special",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "will partial",
        spellResistance: "yes",
        components: "V,S",
        },
        {
        level: "4",
        name: "Firefall",
        type: ["damage", "control"],
        school: "transmutation",
        tags: ["fire"],
        longDesc: `Firefall causes a fire to erupt into a geyser of dazzlingly bright liquid flame. The spell uses one fire source, which is immediately extinguished. A fire larger than a 20-foot cube is only partly extinguished. Magical fires are not extinguished, but a creature of the fire subtype used as the source takes 1 point of damage per caster level (no saving throw). The coruscating rain of fire fills a hemispherical burst with a radius of 60 feet. All creatures and objects in the area take 5d6 points of fire damage and catch on fire. Creatures who make successful Reflex saves take half damage and don't catch on fire. Creatures within 120 feet of the original fire source are blinded for 1d4+1 rounds (Will negates).`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "one fire source, up to a 20-foot cube",
        duration: "instantaneous",
        savingThrow: "Will negates and Reflex negates; see text",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Flaming Sphere, Greater",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `This spell functions as flaming sphere, except that it deals 6d6 points of fire damage to any creature it strikes. Any creature that fails its save against the sphere catches on fire. If a creature catches on fire, the DC to extinguish the flames is equal to the DC of this spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "5-ft.-diameter sphere",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Reflex negates (see text)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Fleshworm Infestation",
        type: ["damage"],
        school: "conjuration(summoning)",
        tags: ["evil"],
        longDesc: `With a touch, you cause an infestation of ravenous worms to manifest in the target's flesh. The target must make a Fortitude save every round. Failure means it takes 1d6 hit points of damage and 2 points of Dexterity damage, and is staggered for 1 round. If it makes the save, it takes no hit point or Dexterity damage and is only sickened for 1 round rather than staggered. Fleshworm infestation cannot be ended early by remove disease or heal, as the infestation starts anew if the current worms are slain. Protection from evil negates this spell's effects for as long as the two durations overlap. Dispel evil automatically ends a fleshworm infestation.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level (D)",
        savingThrow: "Fortitude partial (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Force Missiles",
        type: ["damage"],
        school: "evocation",
        tags: ["force"],
        longDesc: `You fire a powerful missile of force, functioning like magic missile but instead dealing 4d6 force damage. At level 6, 10, and 14, you gain an additional missile. You can fire the missiles at different targets but all must be within 30ft of each other.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "4",
        name: "Forceful Strike",
        type: ["damage"],
        school: "evocation",
        tags: ["force"],
        longDesc: `You cast this spell as you strike a creature with a melee weapon, unarmed strike, or natural attack to unleash a concussive blast of force. You deal normal weapon damage from the blow, but also deal an additional amount of force damage equal to 1d4 points per caster level (maximum of 10d4). The force of the blow may be enough to knock the target backward as well. To determine if the target is pushed back, make a combat maneuver check with a bonus equal to your caster level to resolve a bull rush attempt against the creature struck. You do not move as a result of this free bull rush, but it can push the target back if it defeats the target's CMD. A successful Fortitude save halves the force damage and negates the bull rush effect.`,
        castingTime: "1 swift action",
        range: "touch or reach of melee weapon",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "instantaneous",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Holy Smite",
        type: ["damage"],
        school: "evocation",
        tags: ["good"],
        longDesc: `You draw down holy power to smite your enemies. Only evil and neutral creatures are harmed by the spell; good creatures are unaffected. The spell deals 1d8 points of damage per two caster levels (maximum 5d8) to each evil creature in the area (or 1d6 points of damage per caster level, maximum 10d6, to an evil outsider) and causes it to become blinded for 1 round. A successful Will saving throw reduces damage to half and negates the blinded effect. The spell deals only half damage to creatures who are neither good nor evil, and they are not blinded. Such a creature can reduce that damage by half (down to one-quarter of the roll) with a successful Will save.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "20-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous (1 round); see text",
        savingThrow: "Will partial; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Ice Storm",
        type: ["damage"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `Great magical hailstones pound down upon casting this spell, dealing 1d6 points of bludgeoning damage per 2 levels (max 5d6) and 3d6 points of cold damage to every creature in the area. The bludgeoning damage only occurs once when the spell is cast, however the cold damage occurs whenever a creature enters the area or when it ends its turn in the area. For the remaining duration of the spell, heavy snow and sleet rains down in the area. Creatures inside this area take a -4 penalty on Perception skill checks and the entire area is treated as difficult terrain. At the end of the duration, the snow and hail disappear, leaving no aftereffects (other than the damage dealt). If you cast this spell a second time on an area and it overlaps with a previous casting the cold damage stacks.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "cylinder (20-ft. radius, 40 ft. high)",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Inflict Critical Wounds",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell functions like inflict light wounds, except that you deal 8d8 points of damage + 1 point per caster level (maximum +20).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Lightning Jab",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You lash out with a lightning fast jab with your hand. Make a melee touch attack, if successful it deals 1d6 points of electricity damage per level (max 15d6). When delivering the jolt you gain a +3 bonus on attack rolls if the opponent is wearing metal armor, is carrying a metal weapon, or is made of metal. You can also choose to be cast while you are making an unarmed attack, if you do so you must make the attack against their normal armor class, but treat it as if you delivered the spell through your unarmed attack, dealing damage with your unarmed attack and potentially changing this spells critical threat range.`,
        castingTime: "1 swift action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature or object touched",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "4",
        name: "Lightning Motes",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You create a nebulous cloud of electrical motes that damage enemies that enter it or are inside of it at the start of your turn. It deals 1d6 electricity damage per 2 caster levels (max 8d6), though creatures can make a reflex save to reduce the damage by half. If you create it in a location that creatures are in, they are subject to the damage but get a reflex save as normal. Creatures that fail the reflex save must also make a will save or take extra damage from electricity-based attacks, taking 1 additional point per dice of electricity damage rolled (or 1 if no dice are rolled), this bonus applies after they take damage from the spell, and lasts 1d3+1 rounds.`,
        castingTime: "1 standard action",
        range: "medium (100ft. + 10ft./level)",
        area: "20ft radius",
        effect: "",
        targets: "",
        duration: "1 round/2 levels",
        savingThrow: "reflex half, and will",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Lightning Wall",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `An immobile, curtain of lightning spring into existence. All creatures within 10 feet of the wall take 2d4 points of electricity damage. The wall deals this damage when it appears, and to all creatures in the area on your turn each round. In addition, the wall deals 2d6 points of electricity damage + 1 point of electricity damage per caster level (maximum +20) to any creature passing through it. The wall deals double damage to undead creatures. If you evoke the wall so that it appears where creatures are, each creature takes damage as if passing through the wall. If any 5-foot length of wall takes 20 points or more of acid damage in 1 round, that length goes away. (Do not divide acid damage by 2, as normal for objects.). On the first round you cast this spell, as well as each round you concentrate on it, it deals 3x damage.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "opaque curtain of electricity up to 20 ft. long/level or a ring of electricity with a radius of up to 5 ft./two levels; either form 20 ft. high",
        targets: "",
        duration: "concentration + 1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Liquifying Ray",
        type: ["damage"],
        school: "evocation",
        tags: ["acid"],
        longDesc: `You fire a corrosive ray at a target which deals 1d6 points of acid damage per caster level (max 10d6), additionally the creature must make a fortitude save or it has multiple layers of its skin melt right off its body, reducing its natural armor bonus by 1 per 2 caster levels (max reduction of -5) for 1d4 rounds. The penalties of this spell stack up to 3 times, and for each stack it gets a -1 to the save against this spell again. If this spell would reduce a creatures natural armor below 0, then instead it deals an additional 1d6 points of acid damage for each point below 0 it would reduce its natural armor.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "1 ray",
        targets: "",
        duration: "instantaneous",
        savingThrow: "fort partial",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "4",
        name: "Named Bullet",
        type: ["damage"],
        school: "divination",
        tags: [],
        longDesc: `You imbue the target with deadly accuracy against a selected creature type (and subtype for humanoids or outsiders) or a specific creature you know and can name. When used against the selected creature, the ammunition never misfires and is unaffected by concealment (but not total concealment), and at a range of 30 feet or less, the attack targets the selected creature's touch AC. When the target hits the selected creature, you must overcome that creature's spell resistance, or this spell has no effect. A normal hit scored against the selected creature is considered to be a critical threat and deals 1 extra point of damage per caster level (maximum 20), which is not multiplied on a critical hit. A natural critical hit deals the same extra damage, but that damage is multiplied due to the critical.
                \nOnce the target is used to attack the selected creature, successfully or not, this spell is discharged.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one piece of ammunition or thrown weapon",
        duration: "until discharged",
        savingThrow: "Will negates (harmless,object)",
        spellResistance: "yes (harmless,object)",
        components: "V, S, M",
        },
        {
        level: "4",
        name: "Order's Wrath",
        type: ["damage"],
        school: "evocation",
        tags: ["lawful"],
        longDesc: `You channel lawful power to smite enemies. The power takes the form of a three-dimensional grid of energy. Only chaotic and neutral (not lawful) creatures are harmed by the spell. The spell deals 1d8 points of damage per two caster levels (maximum 5d8) to chaotic creatures (or 1d6 points of damage per caster level, maximum 10d6, to chaotic outsiders) and causes them to be dazed for 1 round. A successful Will save reduces the damage to half and negates the daze effect. The spell deals only half damage to creatures who are neither chaotic nor lawful, and they are not dazed. They can reduce the damage in half again (down to one-quarter of the roll) with a successful Will save.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "nonlawful creatures within a burst that fills a 30-ft. cube",
        effect: "",
        targets: "",
        duration: "instantaneous (1 round); see text",
        savingThrow: "Will partial; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Phantasmal Killer",
        type: ["damage"],
        school: "illusion(phantasm)",
        tags: ["fear", "mind-affecting"],
        longDesc: `You create a phantasmal image of the most fearsome creature imaginable to the subject simply by forming the fears of the subject's subconscious mind into something that its conscious mind can visualize: this most horrible beast. Only the spell's subject can see the phantasmal killer. You see only a vague shape. The target first gets a Will save to recognize the image as unreal. If that save fails, the phantasm touches the subject, and the subject must succeed on a Fortitude save or die from fear. Even if the Fortitude save is successful, the subject takes 3d6 points of damage. If the subject of a phantasmal killer attack succeeds in disbelieving and possesses telepathy or is wearing a helm of telepathy, the beast can be turned upon you. You must then disbelieve it or become subject to its deadly fear attack.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "instantaneous",
        savingThrow: "Will disbelief, then Fortitude partial; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Power Word Kill Yourself",
        type: ["damage"],
        school: "enchantment (compulsion",
        tags: ["death", "mind-affecting"],
        longDesc: `With this powerful command you demand a creatures death, your voice echoing through the air like thunder, and your eyes burning with brilliant light. The target must make a will save, on failure on their next turn they spend their full turn making a full-round action to deal damage to themselves with a single weapon or attack they have and it automatically deals critical damage. Until they take this action, as well as on the turn they do, they can take no other actions, including attacks of opportunity or immediate actions. If you cast this on an ally, they get a -5 penalty to their save. The DC of this spell increase by +1 for each natural 1 the creature has rolled in the last minute, and an additional +2 for each natural 1 it confirmed. For each rolled natural 20 and confirmed natural 20 the DC instead reduces by -1.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V",
        },
        {
        level: "4",
        name: "Pyrotechnic Eruption",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `The caster causes jets of flame to erupt from the ground and surround the target. The target takes 1d6 points of damage per caster level (maximum 15d6) unless it succeeds at a Reflex save for half damage. The blaze surrounds the target for the duration of the spell, forcing the creature to attempt a new save each round. Each round, the damage dealt is reduced to half as many d6; the spell expires when it would deal no damage. If the target moves, the pyrotechnic eruption follows, even if the target teleports. Anyone attempting to touch the target takes damage, using the same amount of dice as the last time the target attempted a save (Reflex half). A creature can take the place of the target by bull rushing or grappling it and switching places. The new creature then automatically takes the current round's damage with no saving throw and can begin to attempt Reflex saves starting on its next turn.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "see text",
        savingThrow: "Reflex half (see text)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Shield Of Dawn",
        type: ["damage"],
        school: "evocation",
        tags: ["fire", "good", "light"],
        longDesc: `You create a disk of sunlight on one arm.
                
                        Any creature that strikes you with a melee attack deals normal damage, but also takes 1d6 points of fire damage + 1 point per caster level (maximum +15).
                        
                        Creatures with reach weapons are not subject to this damage if they attack you. The shield provides illumination as if it were a continual flame spell. You can only have one instance of this spell in effect at a time. It does not stack with similar damaging aura spells such as fire shield.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Shout",
        type: ["damage"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `You emit an ear-splitting yell that deafens and damages creatures in its path. Any creature within the area is deafened for 2d6 rounds and takes 5d6 points of sonic damage. A successful save negates the deafness and reduces the damage by half. Any exposed brittle or crystalline object or crystalline creature takes 1d6 points of sonic damage per caster level (maximum 15d6). An affected creature is allowed a Fortitude save to reduce the damage by half, and a creature holding fragile objects can negate damage to them with a successful Reflex save. A shout spell cannot penetrate a silence spell.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Fortitude partial or Reflex negates (object); see text",
        spellResistance: "yes (object)",
        components: "V, ",
        },
        {
        level: "4",
        name: "Touch of Slime",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["disease"],
        longDesc: `You create a coating of slime on your hand. When you make a successful melee touch attack with the slime, it pulls free of you and sticks to the target, at which point it acts like green slime (https://www.d20pfsrd.com/gamemastering/traps-hazards-and-special-terrains/hazards/environmental-hazards/green-slime-cr-4/), dealing 1d3 points of Constitution damage per round. Anything that destroys green slime (scraping, freezing, burning, cutting, sunlight, or remove disease) destroys this slime. If the slime kills a creature, it consumes the body and then dies. It cannot transfer to a creature other than the original target, and dies if separated from the original target.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "instantaneous",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Unholy Blight",
        type: ["damage"],
        school: "evocation",
        tags: ["evil"],
        longDesc: `You call up unholy power to smite your enemies. The power takes the form of a cold, cloying miasma of greasy darkness. Only good and neutral (not evil) creatures are harmed by the spell. The spell deals 1d8 points of damage per two caster levels (maximum 5d8) to a good creature (or 1d6 per caster level, maximum 10d6, to a good outsider) and causes it to be sickened for 1d4 rounds. A successful Will save reduces damage to half and negates the sickened effect. The effects cannot be negated by remove disease or heal, but remove curse is effective. The spell deals only half damage to creatures who are neither evil nor good, and they are not sickened. Such a creature can reduce the damage by half again (down to one-quarter) with a successful Will save.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "20-ft.-radius spread",
        effect: "",
        targets: "",
        duration: "instantaneous (1d4 rounds); see text",
        savingThrow: "Will partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Vitriolic Mist",
        type: ["damage"],
        school: "evocation",
        tags: ["acid"],
        longDesc: `This functions as fire shield, except it wreathes you in yellow or green acidic mist instead of hot or cold flames. The spell deals acid damage to attackers and protects you against acid damage. This spell does not shed light.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Volcanic Storm",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `Chunks of hot volcanic rock and clumps of ash pound down when this spell is cast, dealing 1d6 points of bludgeoning damage per 2 caster levels (max 5d6) and 3d6 points of fire damage to every creature in the area. The bludgeoning damage only occurs once, when the spell is cast, whereas the fire damage is dealt each round at the start of your turn to any creature inside of its area, or to a creature who enters the area. For the remaining duration of the spell, heavy ash rains down in the area. Creatures inside this area take a -4 penalty on Perception skill checks and the entire area is treated as difficult terrain. At the end of the duration, the rock and ash disappear, leaving no aftereffects (other than the damage dealt).`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "cylinder (20-ft. radius, 40 ft. high)",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Wall of Fire",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `An immobile, blazing curtain of shimmering violet fire springs into existence. One side of the wall, selected by you, sends forth waves of heat, dealing 2d4 points of fire damage to creatures within 10 feet and 1d4 points of fire damage to those past 10 feet but within 20 feet. The wall deals this damage when it appears, and to all creatures in the area on your turn each round. In addition, the wall deals 2d6 points of fire damage + 1 point of fire damage per caster level (maximum +20) to any creature passing through it. The wall deals double damage to undead creatures. If you evoke the wall so that it appears where creatures are, each creature takes damage as if passing through the wall. If any 5-foot length of wall takes 20 points or more of cold damage in 1 round, that length goes away. (Do not divide cold damage by 2, as normal for objects.). The first round you cast this spell, as well as each round you continue to concentrate on it, it deals 3x damage.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "opaque sheet of flame up to 20 ft. long/level or a ring of fire with a radius of up to 5 ft./two levels; either form 20 ft. high",
        targets: "",
        duration: "concentration + 1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
            level: "4",
            name: "Cauldron of Flame",
            type: ["damage"],
            school: "evocation",
            tags: ["fire"],
            longDesc: `A circle of fire appears on the ground. As long as you are within it, all enemies within 10 feet take 1d6 points of damage per 2 caster levels at the start of each of your turns. Each turn after the first you are standing in the cauldron, the damage increases by 1d6. At caster level 12 and 18 it increases by an additional 1d6 every round. Enemies can make a reflex save to reduce the damage by half. Additionally, while standing in the cauldron you gain resistance 10 to fire and cold, and a 20% miss chance as if you had concealment.`,
            castingTime: "1 standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "10 foot square",
            effect: "circle of flame in a 10 foot square",
            targets: "",
            duration: "1 round/level",
            savingThrow: "none",
            spellResistance: "yes",
            components: "V, S, M",
            },
        {
            level: "5",
            name: "Flamethrower",
            type: ["damage"],
            school: "evocation",
            tags: ["fire"],
            longDesc: `A line of searing flames shoots from your hands in a straight line, burning every creature in its area. This deals 1d4 points of fire damage per caster level immediately (max 10d4), though all creatures can make a reflex save to halve this damage, then each round that you continue to concentrate on this spell it deals its damage again, which creatures can continue to roll reflex saves to halve. A creature struck by this spell multiple times takes an increased amount of damage, increasing the damage by 50% more d4's than the previous time they were struck by the spell. While concentrating on this spell, you move only at half speed, and when you concentrate on this spell to continue it, you can move the line of the spell to be a new orientation, however you cannot move it more than 90 degrees in any direction.`,
            castingTime: "1 standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "close (25 ft. + 5 ft./2 levels) line",
            effect: "",
            targets: "",
            duration: "concentration (max 1 round/2 levels)",
            savingThrow: "reflex half",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
        level: "4",
        name: "Bloody Arrows",
        type: ["damage", "buff"],
        school: "necromancy",
        tags: [],
        longDesc: `Whenever this spell's target hits a creature with a ranged weapon that successfully deals piercing or slashing damage, the struck creature takes 1 point of bleed damage. Unlike most bleed damage, the bleed damage dealt by the subject of this spell is cumulative up to an amount equal to 1/2 your caster level (to a maximum of 5 points of bleed damage at 10th level).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one willing creature",
        duration: "1 round/level",
        savingThrow: "none (harmless)",
        spellResistance: "no (harmless)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Fire Shield",
        type: ["damage", "buff"],
        school: "evocation",
        tags: ["cold", "fire"],
        longDesc: `This spell wreathes you in flame and causes damage to each creature that attacks you in melee. The flames also protect you from either cold-based or fire-based attacks, depending on if you choose cool or warm flames for your fire shield. Any creature striking you with its body or a handheld weapon deals normal damage, but at the same time the attacker takes 1d6 points of damage + 1 point per caster level (maximum +15). This damage is either cold damage (if you choose a chill shield) or fire damage (if you choose a warm shield). If the attacker has spell resistance, it applies to this effect. Creatures wielding melee weapons with reach are not subject to this damage if they attack you. When casting this spell, you appear to immolate yourself, but the flames are thin and wispy, increasing the light level within 10 feet by one step, up to normal light. The color of the flames is blue or green if the chill shield is cast, violet or red if the warm shield is employed. The special powers of each version are as follows. Chill Shield: The flames are cool to the touch. You take only half damage from fire-based attacks. If such an attack allows a Reflex save for half damage, you take no damage on a successful saving throw. Warm Shield: The flames are warm to the touch. You take only half damage from cold-based attacks. If such an attack allows a Reflex save for half damage, you take no damage on a successful saving throw.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Discordant Blast",
        type: ["damage", "control"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `You create a wave of thunder and force, either in a 10-foot radius burst centered on you or in 30-foot cone-shaped burst.
                        Creatures in the area take 3d6 points of sonic damage and are pushed away as if bull rushed. Make a combat maneuver check and apply its results to each creature in the area. Your CMB for this bull rush is equal to your caster level plus your highest mental modifier. This bull rush does not provoke an attack of opportunity. A discordant blast cannot penetrate a silence spell (or any similar magical silence effect).`,
        castingTime: "1 standard action",
        range: "10 ft. or 30 ft.",
        area: "see text",
        effect: "",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Explosion of Rot",
        type: ["damage", "control"],
        school: "necromancy",
        tags: [],
        longDesc: `You call forth a burst of decay that ravages all creatures in the area. Even nonliving creatures such as constructs and undead crumble or wither in this malignant eruption of rotting energy. Creatures in the area of effect take 1d6 points of damage per caster level (maximum 15d6) and are staggered for 1d4 rounds. A target that succeeds at a Reflex saving throw takes half damage and negates the staggered effect. Plant creatures are particularly susceptible to this rotting effect; a plant creature caught in the burst takes a –2 penalty on the saving throw and takes 1 extra point of damage per die.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "10-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "reflex half(see text)",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "4",
        name: "Fire of Vengeance",
        type: ["damage", "utility"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `After casting this spell, the next creature you successfully attack must make a will save or become engulfed in holy flames that flare up when the target attacks someone other than you. If at any time during the duration of the spell the target makes an attack that does not include you, it takes 2d6 points of fire damage. A creature can attempt a new saving throw as a full-round action to end this spell. If you have smited the target of this spell, this spell deals an additional 2d6 points of fire damage.`,
        castingTime: "1 standard action",
        range: "special",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/2 levels",
        savingThrow: "will negates;",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "4",
        name: "Ice Comet",
        type: ["damage", "utility"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `You fire a comet of ice at a target, requiring a ranged touch attack. This spell deals 1d6 points of cold damage per caster level (max 10d6), but deals an additional 1d6 points of cold damage for each 10 ft travelled by the comet. This bonus damage doesn't work if you are above the creature, but is doubled if you are below the creature by more than 30ft, if a flying creature is stuck it must make a fly check DC 1 per foot the comet travelled or fall feet equal to the amount it failed the check by`,
        castingTime: "1 standard action",
        range: "long (400ft. +40 ft./levels)",
        area: "",
        effect: "1 bolt of ice",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "4",
        name: "Melt the Shell",
        type: ["damage", "utility"],
        school: "evocation",
        tags: ["acid"],
        longDesc: `You cover a creature in acid, it deals 1d6 acid damage per level (max 10d6), if this spell does damage it also reduces the creatures armor bonus(if it has one) and natural armor by 1. This reduction lasts until the spell ends, and 1d4+1 rounds after. This spell stacks.`,
        castingTime: "1 standard action",
        range: "100ft +10ft/level",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "1 round/2 levels",
        savingThrow: "reflex negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Absolution",
        type: ["healing"],
        school: "abjuration",
        tags: [],
        longDesc: `You purge impure thoughts from the target's mind and fill him with exultant relief at the forgiveness of his sins. Absolution ends all charm or compulsion effects affecting the target (including harmless compulsions, such as heroism) as per break enchantment. Absolution automatically works if the caster and the target share the same alignment. If they don't, but their alignments are within one step of each other, absolution has a 5% chance of success per caster level, otherwise it automatically fails`,
        castingTime: "1 round",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Celestial Healing, Greater",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: ["good"],
        longDesc: `As per celestial healing, except the target gains fast healing 4 and the target radiates the aura of a good cleric.`,
        castingTime: "full-round action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "2 rounds/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Close Wounds",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell swiftly channels positive into your touch to heal a living ally, restoring 3d8 points of damage + 1 point per caster level (maximum +15).`,
        castingTime: "1 swift action",
        range: "touch",
        area: "",
        effect: "",
        targets: "ally touched",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S",
        },
        {
            level: "4",
            name: "Flash of Light",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `This spell swiftly channels positive energy into a nearby living ally, restoring 2d8 points of damage + 1 point per caster level (maximum +15). You cannot use this spell on yourself. This spell has a bonus 2% spell critical 
            \nIf you cast this spell within 1 round of casting another critical positive spell, the healing increases to 4d8 + 1 per caster level and the critical chance increases by a further 2%.`,
            castingTime: "1 movement action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "1 ally",
            duration: "instantaneous",
            savingThrow: "Will negates (harmless)",
            spellResistance: "yes (harmless)",
            components: "V, S",
        },
        {
            level: "5",
            name: "Spirit Chain",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `You create a spirit of positive energy and launch it at a living ally, healing them for 3d8 + level hit points. At the start of your next turn, the spirit leaps to a random ally within 30 feet of the current holder, healing them for same amount. If there is no ally within range at the start of your turn, this spell ends. You can have only a single spirit active at once.`,
            castingTime: "1 standard action",
            range: "30 feet",
            area: "",
            effect: "",
            targets: "1 ally",
            duration: "1 round/4 levels",
            savingThrow: "Will negates (harmless)",
            spellResistance: "yes (harmless)",
            components: "V, S",
        },
        {
            level: "6",
            name: "Chapel",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `You conjure a small chapel in a square adjacent to you. As long as the chapel remains, at the start of each of your turns it heals all allies within 10 feet of it for 3d8 + caster level hit points. The church has 5 hit points per caster level, AC 20, hardness 15, and is just a small object made of stone. You can have only a single chapel in affect at a time. All allies within 10 feet of the chapel gain a +2 sacred bonus to armor class and saves. As long as you are adjacent to your chapel, your healing spells heal an additional percentage of healing equal to your knowledge religion.`,
            castingTime: "full-round",
            range: "0 feet",
            area: "",
            effect: "",
            targets: "",
            duration: "1 round/3 levels",
            savingThrow: "Will negates (harmless)",
            spellResistance: "yes (harmless)",
            components: "V, S, M, DF",
        },
        {
        level: "4",
        name: "Cure Critical Wounds",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell functions like cure light wounds, except that it cures 8d8 points of damage + 1 point per caster level (maximum +20).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will half (harmless); see text",
        spellResistance: "yes (harmless); see text",
        components: "V, S, ",
        },
        {
            level: "5",
            name: "Cure Devastating Wounds",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `This spell functions like cure light wounds, except that it cures 10d10 points of damage + 1 point per caster level (maximum +30).`,
            castingTime: "1 standard action",
            range: "touch",
            area: "",
            effect: "",
            targets: "creature touched",
            duration: "instantaneous",
            savingThrow: "Will half (harmless); see text",
            spellResistance: "yes (harmless); see text",
            components: "V, S, ",
        },
        {
        level: "4",
        name: "Infernal Healing, Greater",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: ["evil"],
        longDesc: `As infernal healing, except the target gains fast healing 4 and the target detects as an evil cleric.`,
        castingTime: "full-round action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 minute",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Instant Restoration",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `Instant restoration channels planar energy into a summoned creature. This spell can be cast as an immediate action when a summoned creature you control drops to 0 or fewer hit points. Rather than immediately disappear, the creature is healed for 4d8 hp + 1 hit point per caster level (maximum 4d8+10 hit points). If this healing brings your summoned creature's hit point total to 1 or more hit points, it remains as if its hit points had never dropped to 0 or fewer. Creatures slain by death effects cannot be saved by instant restoration. A summoner can target his eidolon with this spell.`,
        castingTime: "1 immediate action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one summoned creature you control",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Neutralize Poison",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You detoxify any sort of venom in the creature or object touched. If the target is a creature, you must make a caster level check (1d20 + caster level) against the DC of each poison affecting the target. Success means that the poison is neutralized. A cured creature suffers no additional effects from the poison, and any temporary effects are ended, but the spell does not reverse instantaneous effects, such as hit point damage, temporary ability damage, or effects that don't go away on their own. This spell can instead neutralize the poison in a poisonous creature or object for 10 minutes per level, at the caster's option. If cast on a creature, the creature receives a Will save to negate the effect.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature or object of up to 1 cu. ft./level touched",
        duration: "instantaneous or 10 min./level; see text",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Path Of Glory, Greater",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell functions as path of glory, except as noted above, and a square provides 5 points of healing instead of 1.`,
        castingTime: "1 standard action",
        range: "touch (see text)",
        area: "four 5-ft. squares/level (see text)",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Remove Curse",
        type: ["healing"],
        school: "abjuration",
        tags: [],
        longDesc: `Remove curse can remove all curses on an object or a creature. If the target is a creature, you must make a caster level check (1d20 + caster level) against the DC of each curse affecting the target. Success means that the curse is removed. Remove curse does not remove the curse from a cursed shield, weapon, or suit of armor, although a successful caster level check enables the creature afflicted with any such cursed item to remove and get rid of it. Remove curse counters and dispels bestow curse.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature or object touched",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Restoration",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell functions like lesser restoration, except that it also dispels 1d4+1 temporary negative levels or one permanent negative level. Restoration cures 2d4 damage temporary ability damage to all scores or restores 1d4+1 points permanently drained from a single ability score (your choice if more than one is drained). It also eliminates any fatigue or exhaustion suffered by the target.`,
        castingTime: "1 round",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Song of Healing",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You must have a bardic performance or hex in effect to cast this spell. As long as that performance continues, up to 3 creatures affected by the performance or a hex gain fast healing 2. When this bardic performance or hex ends or you change to a different bardic performance, the fast healing granted by this spell ends as well, but all creatures affected by this spell heal 1d8 points of damage + 1 point per caster level (maximum +15) and are cured of any of the following conditions: exhausted, fatigued, nauseated, paralyzed, sickened, or stunned.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "up to 3 creatures, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V,S",
        },
        {
        level: "4",
        name: "Spindrift Spritz Mass",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: ["water"],
        longDesc: `You can cast this spell only as a response to one or more targets attempting a saving throw against an effect that would cause the fatigued, shaken, sickened, or staggered conditions. The targets can roll their saving throw twice and take the higher result.`,
        castingTime: "1 immediate action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 20 ft. apart",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S",
        },
        {
        level: "4",
        name: "Healing Warmth",
        type: ["healing", "buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell grants you temporary immunity to fire damage as protection from energy. As a standard action, you may sacrifice 12 points of remaining energy absorption from the spell to heal a touched creature of 1d8 points of damage. Healing a creature provokes an attack of opportunity. When the spell has absorbed 12 points of fire damage per caster level (to a maximum of 120 points at 10th level), it is discharged.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Persistent Vigor",
        type: ["healing", "buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You are filled with a persistent vigor. You gain fast healing 2 and are immune to bleed effects as well as the sickened and nauseated conditions. When you succeed at a saving throw against a disease or poison effect, that disease or poison effect ends (as if you had succeeded at enough saving throws to cure that effect). If you fail a saving throw against a disease or poison effect, you can instantly dismiss this spell to reroll that saving throw with a +4 bonus; you must take the result of this reroll, even if it is lower.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Blaze of Glory",
        type: ["healing", "damage"],
        school: "conjuration(healing)",
        tags: ["good", "mind-affecting"],
        longDesc: `You fall unconscious but also unleash a spectacular wave of holy energy that heartens and heals your allies while leaving your opponents daunted and damaged. You can cast this spell as either a standard action on your turn, or as an immediate action when brought to below 0 hit points. If cast as a standard action, you are immediately reduced to –1 hit points, but stable, after casting the spell.
        
                    When you cast this spell, any good creature within range is healed for 1d6 points of damage per two caster levels. All evil creatures within range take the same amount as damage instead (a successful Will save halves this damage). In addition, all allies and enemies within range are affected as if by the prayer spell for 1 round per caster level.`,
        castingTime: "1 standard action or immediate action; see text",
        range: "",
        area: "30-ft.-radius burst centered on you",
        effect: "",
        targets: "",
        duration: "instantaneous and 1 round/level; see text",
        savingThrow: "will partial",
        spellResistance: "yes",
        components: "V",
        },
        {
        level: "4",
        name: "Healing Flames",
        type: ["healing", "damage"],
        school: "conjuration(healing)",
        tags: ["fire", "good"],
        longDesc: `You unleash a blast of holy flames that washes over all creatures in the area in a glorious display of divine power. This deals damage to evil creatures and heals good creatures in the area. The amount of damage dealt and the number of hit points restored in each case is 1d8 points per 2 caster levels (maximum 5d8).
        
                    Half of the damage this spell deals to evil creatures is fire damage, and half of the damage is pure divine power that is therefore not subject to reduction by energy resistance to fire-based attacks.
                    
                    Neutral enemies within the spell's area of effect also take the fire damage, but do not take the divine damage. Neutral allies within the area are healed by half as much as good creatures. A successful Reflex saving throw halves the damage taken in all cases.`,
        castingTime: "1 standard action",
        range: "",
        area: "10-ft.-radius burst, centered on you",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half; see text;",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Litany of Escape",
        type: ["healing", "utility"],
        school: "conjuration(teleportation)",
        tags: ["language-dependent"],
        longDesc: `With a powerful prayer, you call upon the servants of your god to whisk a friend out of a grapple. The target loses the grappled and pinned conditions and is teleported 10 feet. If there is no available space for the target to teleport to, the spell fails.`,
        castingTime: "1 swift action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one willing creature that is grappled",
        duration: "instantaneous",
        savingThrow: "no",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Absorbing Inhalation",
        type: ["utility"],
        school: "transmutation",
        tags: ["air"],
        longDesc: `You grant your lungs inhuman strength and capacity, allowing you to harmlessly and completely inhale one gas, fog, smoke, mist, or similar cloud-like effect. If the targeted cloud is a magical effect, you must succeed at a caster level check (DC 11 + the effect's caster level) to inhale it. Inhaling the cloud removes it from the area, leaving normal air in its place. If the cloud is too large for you to affect with a single casting of this spell, you may instead inhale a portion of the cloud, but you must inhale the portion of the cloud closest to you. This spell has no effect on gaseous creatures. It can only affect an instantaneous-duration cloud (such as a breath weapon) if you ready an action to cast the spell in response. While inhaled, the cloud does not harm you. You may keep the cloud harmlessly contained within you for up to 1 round per level, but you must hold your breath to do so (even if you do not normally have to breathe). If the cloud has a duration, the time the cloud is contained within you counts toward that duration. As a standard action, you may release the stored cloud as a breath weapon, filling a 60-foot cone (or the cloud's original area, if smaller than a 60-foot cone). Any creature in the breath's area is subject to its normal effects, making saving throws and spell resistance checks as appropriate against the cloud's original DC. The exhaled cloud resumes its duration, if any. Exhaling the stored cloud ends this spell. If you do not exhale the cloud before this spell's duration expires, you suffer the cloud's effects and automatically fail any saving throw to resist it.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one cloud-like effect, up to one 10-ft. cube/level",
        duration: "1 round/level; see text",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Air Walk",
        type: ["utility"],
        school: "transmutation",
        tags: ["air"],
        longDesc: `The subject can tread on air as if walking on solid ground. Moving upward is similar to walking up a hill. The maximum upward or downward angle possible is 45 degrees, at a rate equal to half the air walker's normal speed. A strong wind (21+ miles per hour) can push the subject along or hold it back. At the end of a creature's turn each round, the wind blows the air walker 5 feet for each 5 miles per hour of wind speed. The creature may be subject to additional penalties in exceptionally strong or turbulent winds, such as loss of control over movement or physical damage from being buffeted about. Should the spell duration expire while the subject is still aloft, the magic fails slowly. The subject floats downward 60 feet per round for 1d6 rounds. If it reaches the ground in that amount of time, it lands safely. If not, it falls the rest of the distance, taking 1d6 points of damage per 10 feet of fall. Since dispelling a spell effectively ends it, the subject also descends in this way if the air walk spell is dispelled, but not if it is negated by an antimagic field. You can cast air walk on a specially trained mount so it can be ridden through the air. You can train a mount to move with the aid of air walk (counts as a trick; see Handle Animal skill) with 1 week of work and a DC 25 Handle Animal check.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature (Gargantuan or smaller) touched",
        duration: "10 min./level",
        savingThrow: "none",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Ancestral Gift",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `A ghostly manifestation of one of your ancestors appears before you bearing a weapon of your choice in its hands. The weapon may be any common, rare or epic weapon. It has a +1 enhancement bonus and one weapon special ability (your choice) with a price equivalent to a +1 bonus (if the weapon is a double weapon, the ability and the enhancement bonus only apply to one end, or the weapon can have a +1 enhancement bonus on both ends but no other magical abilities). The weapon may not be wielded by anyone else, and if removed from your grasp, it vanishes and the spell ends immediately. If you conjure a weapon with the flaming, frost, shock, or thundering property, this spell has the fire, cold, electricity, or sonic descriptor (respectively).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "magical weapon",
        targets: "",
        duration: "10 minutes/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Animate Dead",
        type: ["utility"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `This spell turns corpses into undead skeletons or zombies that obey your spoken commands. The undead can be made to follow you, or they can be made to remain in an area and attack any creature (or just a specific kind of creature) entering the place. They remain animated until they are destroyed. A destroyed skeleton or zombie can't be animated again. Regardless of the type of undead you create with this spell, you can't create more HD of undead than twice your caster level with a single casting of animate dead. The desecrate spell doubles this limit. The undead you create remain under your control indefinitely. No matter how many times you use this spell, however, you can control only 4 HD worth of undead creatures per caster level. If you exceed this number, all the newly created creatures fall under your control, and any excess undead from previous castings become uncontrolled. You choose which creatures are released. Undead you control through the Command Undead feat do not count toward this limit. Skeletons: A skeleton can be created only from a mostly intact corpse or skeleton. The corpse must have bones. If a skeleton is made from a corpse, the flesh falls off the bones. Zombies: A zombie can be created only from a mostly intact corpse. The corpse must be that of a creature with a physical anatomy.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one or more corpses touched",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Anywhere But Here",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `This spell functions similarly to teleport, but instead of transporting the targets to a destination near an intended location, anywhere but here transports affected creatures to a random location on the map. Subjects always appear in a location that is not inherently harmful, but the exact destination is otherwise random. A creature that is transported by anywhere but here cannot be affected by a subsequent casting of anywhere but here for 24 hours afterward (but can be affected normally by other forms of planar travel). This spell can be cast as a swift action, but if you do it now only affects you. You can cast it as a free action, but now it only affects you, and can place you in inherently dangerous locations, such as inside walls or lava. If you do teleport inside of a location that cannot hold you, it shunts you to the nearest available location, but you take 1d6 damage for every 5 feet you must travel.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "you and up to four willing creatures",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no",
        components: "V, ",
        },
        {
        level: "4",
        name: "Arcane Eye",
        type: ["utility"],
        school: "divination(scrying)",
        tags: [],
        longDesc: `You create an invisible magical sensor that sends you visual information. You can create the arcane eye at any point you can see, but it can then travel outside your line of sight without hindrance. An arcane eye travels at 30 feet per round if viewing an area ahead as a human would (primarily looking at the floor) or 10 feet per round if examining the ceiling and walls as well as the floor ahead. It sees exactly as you would see if you were there, however it also has low-light vision and darkvision 60ft. The eye can travel in any direction as long as the spell lasts. Solid barriers block its passage, but it can pass through a hole or space as small as 1 inch in diameter. The eye can't enter another plane of existence, even through a gate or similar magical portal. You must concentrate to use an arcane eye. If you do not concentrate, the eye is inert until you again concentrate. Because it sees things from a different angle, you may be able to use this to bypass certain concealment, as long as the eye can see both you and the target.`,
        castingTime: "1 standard action",
        range: "unlimited",
        area: "",
        effect: "magical sensor",
        targets: "",
        duration: "1 min./level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Cloud Shape",
        type: ["utility"],
        school: "transmutation",
        tags: ["air"],
        longDesc: `This spell functions like gaseous form, except you assume the shape of a Colossal cloud with a space of 30 feet. You choose the general appearance of the cloud (white, stormy, fluffy, flat, and so on), after which your appearance cannot be changed. Even the closest inspection cannot reveal that the cloud in question is actually a magically concealed creature. To all normal tests you are, in fact, a cloud, although a detect magic spell reveals a moderate transmutation aura on the cloud. Your fly speed in cloud form is 30 feet.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 minutes/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "S, M,DF,",
        },
        {
        level: "4",
        name: "Companion Transposition",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `You trade places with the other target, teleporting as if you were both affected by dimension door. Both you and the other target arrive in a square you choose in the other's former space. If the targets are different sizes, they must appear in locations that cover previously occupied squares. As with dimension door, after casting this spell, you can't take any other actions until your next turn, and the other target is staggered until the end of its next turn due to the transposition.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "yourself and one ally",
        duration: "instantaneous",
        savingThrow: "none (harmless)",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Complex Hallucination",
        type: ["utility"],
        school: "illusion(phantasm)",
        tags: ["mind-affecting"],
        longDesc: `This spell functions as audiovisual hallucination (see page 204), except that the phantasm you create can also include olfactory, tactile, and thermal effects.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "concentration + 3 rounds",
        savingThrow: "Will disbelief",
        spellResistance: "yes",
        components: "S, ",
        },
        {
        level: "4",
        name: "Control Water",
        type: ["utility"],
        school: "transmutation",
        tags: ["water"],
        longDesc: `This spell has two different applications, both of which control water in different ways. The first version of this spell causes water in the area to swiftly evaporate or to sink into the ground below, lowering the water's depth. The second version causes the water to surge and rise, increasing its overall depth and possibly flooding nearby areas. Lower Water: This causes water or similar liquid to reduce its depth by as much as 2 feet per caster level (to a minimum depth of 1 inch). The water is lowered within a squarish depression whose sides are up to caster level Ã— 10 feet long. In extremely large and deep bodies of water, such as a deep ocean, the spell creates a whirlpool that sweeps ships and similar craft downward, putting them at risk and rendering them unable to leave by normal movement for the duration of the spell. When cast on water elementals and other water-based creatures, this spell acts as a slow spell (Will negates). The spell has no effect on other creatures. Raise Water: This causes water or similar liquid to rise in height, just as the lower water version causes it to lower. Boats raised in this way slide down the sides of the hump that the spell creates. If the area affected by the spell includes riverbanks, a beach, or other land nearby, the water can spill over onto dry land. With either version of this spell, you may reduce one horizontal dimension by half and double the other horizontal dimension to change the overall area of effect.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "water in a volume of 10 ft./level by 10 ft./level by 2 ft./level",
        effect: "",
        targets: "",
        duration: "10 min./level",
        savingThrow: "none; see text",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Create Armaments",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `Unlike most spells in the Akashic Paths, this spell has a material component of 50 gold. When you cast this spell you attempt to create one common weapon or armor roll, your choice of which, then attempt a craft check DC 10, if you succeed, the roll is given, if you fail, the gold and action is wasted. Additionally, by increasing the DC of the roll by 10 you increase the rarity range of the roll, Eg: with DC 20 you gain a common-rare item. Once you increase the rarity to common-unique, by increasing the DC by a further 10 you increase the minimum rarity, Eg rare-unique. You can also increase the DC by 25% to make the item typed.`,
        castingTime: "1 round",
        range: "0 ft.",
        area: "",
        effect: "one nonmagical weapon, shield, or set of armor",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Deadman's Contingency",
        type: ["utility"],
        school: "evocation",
        tags: [],
        longDesc: `This spell functions as contingency, except as noted above. This spell also only comes into effect after your death and works only with damage spells. The companion spell triggers 1d6 rounds after your death. All decisions made involving the companion spell must be made when deadman's contingency is cast (including messages and recipients for spells like magic mouth or sending). If the spell targets an object or appears in a certain location, it must target or be centered on your corpse.`,
        castingTime: "When Descending floors or 2 rounds; see text",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "up to 1 hour/level plus 1d6 rounds (D); see text",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Dimension Door",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `You instantly transfer yourself from your current location to any other spot within range. You always arrive at exactly the spot desired--whether by simply visualizing the area or by stating direction. After using this spell, you can't take any other actions until your next turn. You can bring along objects as long as their weight doesn't exceed your maximum load. You may also bring one additional willing Medium or smaller creature (carrying gear or objects up to its maximum load) or its equivalent per three caster levels. A Large creature counts as two Medium creatures, a Huge creature counts as two Large creatures, and so forth. All creatures to be transported must be in contact with one another, and at least one of those creatures must be in contact with you. If you arrive in a place that is already occupied by a solid body, you and each creature traveling with you take 1d6 points of damage and are shunted to a random open space on a suitable surface within 100 feet of the intended location. If there is no free space within 100 feet, you and each creature traveling with you take an additional 2d6 points of damage and are shunted to a free space within 1,000 feet. If there is no free space within 1,000 feet, you and each creature travelling with you take an additional 4d6 points of damage and the spell simply fails.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "you and touched objects or other touched willing creatures",
        duration: "instantaneous",
        savingThrow: "none and Will negates (object)",
        spellResistance: "no and yes (object)",
        components: "V, ",
        },
        {
        level: "4",
        name: "Dismissal",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell forces an extraplanar creature back to its proper plane if it fails a Will save. If the spell is successful, the creature is instantly whisked away. Because all creatures are actually denizens of the Akashic Records, this only works on extraplanar creatures when the map's theme is different than their home plane. Eg: Demons on a map themed like the prime material plane could be dismissed, but demons on an abyss themed map cannot be. Once a creature is whisked away it it may make a new will save each round, for 3 rounds, if it fails all three it is permanently removed, if it fails 2 it returns in 3 rounds, but it loses half its maximum hit points and is staggered on its return for 1d4 rounds, if it fails 1, it loses 25% of its maximum hit points and returns in 3 rounds staggered for 1d4 rounds, if it fails none, it returns in 3 rounds, staggered for 1d4 rounds. If a creature has the ability to cast plane shift, it instead returns in 1 round with no ill effects.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one extraplanar creature",
        duration: "3 rounds",
        savingThrow: "Will negates;",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Fire Trap",
        type: ["utility"],
        school: "abjuration",
        tags: ["fire"],
        longDesc: `Fire trap creates a fiery explosion when a creature steps on the square or interacts with the object that the trap protects. When you cast the spell it is inert for 1 round, afterwards any creature that steps or touches it triggers it. The fiery explosion fills the area within a 5-foot radius around the spell's center, dealing 1d8+1 points of fire damage per caster level (maximum 20d8+20), though creatures can make a reflex save to reduce this damage by half. The item or area protected by the trap is not harmed by this explosion. A square or object cannot have more than 1 fire trap set on it at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "5 foot square or 1 small object",
        duration: "permanent until discharged (D)",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Fool's Teleport",
        type: ["utility"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `This spell instantly renders you unseen as per invisibility, but creates a visual and auditory display that makes it appear as if you had teleported away. You can affect one additional Medium or smaller creature or its equivalent per 3 caster levels (a Large creature counts as two Medium creatures, a Huge creature counts as four Medium creatures, and so forth). All creatures to be affected must be in contact with one another, and at least one of those creatures must be in contact with you. If a viewer identifies the spell with a successful Spellcraft check, she can attempt an immediate Will saving throw as if interacting with an illusion. With a successful Will save, the observer can correctly identify fool's teleport for what it is; otherwise, she perceives the spell to be dimension door, teleport, or similar conjuration magic. A successful Will save doesn't negate the invisibility.`,
        castingTime: "1 standard action",
        range: "personal and touch",
        area: "",
        effect: "",
        targets: "you and other touched willing creatures",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless); see text",
        spellResistance: "no",
        components: "V, ",
        },
        {
        level: "4",
        name: "Forest's Sense",
        type: ["utility"],
        school: "divination(scrying)",
        tags: [],
        longDesc: `You can detect the location of all creatures on the map as long as they are within 10 feet of a plant or fungus, this does not pin point their location and you will still suffer miss chance as normal for a creature you cannot see through other means.`,
        castingTime: "1 standard action",
        range: "300 ft.",
        area: "",
        effect: "",
        targets: "All creatures within a 300-ft-radius of you",
        duration: "1 round/2 levels (D);",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Ghost Wolf",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `This spell conjures a Large, quasi-real, wolflike creature made of roiling black smoke. It functions as phantom steed, except as noted here. In addition, the creature radiates an aura of fear. Any creature within 30 feet (except the ghost wolf ‘s rider) must make a Will save or become shaken for 1d4 rounds (this is a mind-affecting fear effect). A creature that makes its Will save is unaffected by the steed's fear aura for 24 hours. The ghost wolf may also be used in combat. Once per round, the rider may direct the ghost wolf to attack in battle as a free action (bite +10, 1d8+6 points of damage, but it gains a bonus to its damage equal to your highest mental stat); unlike an animal mount, this does not require a Ride check or any training.`,
        castingTime: "1 round",
        range: "0 ft.",
        area: "",
        effect: "",
        targets: "one quasi-real wolflike creature",
        duration: "1 round/level",
        savingThrow: "none (see description)",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Illusory Wall",
        type: ["utility"],
        school: "illusion(figment)",
        tags: [],
        longDesc: `This spell creates the illusion of a wall, floor, ceiling, or similar surface. It appears absolutely real when viewed, but physical objects can pass through it without difficulty. When the spell is used to hide pits, traps, or normal doors, any detection abilities that do not require sight work normally. Touch or a probing search reveals the true nature of the surface, though such measures do not cause the illusion to disappear. Although the caster can see through his illusory wall, other creatures cannot, even if they succeed at their will save (but they do learn that it is not real).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "image 1 ft. by 10 ft. by 10 ft.",
        targets: "",
        duration: "permanent",
        savingThrow: "Will disbelief (if interacted with)",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Liquefy",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `The object you target becomes a liquid version of itself and drips or runs like a thin oil until it pools on any flat surface. If the item has magical or alchemical properties, they become inert for the duration of the spell. If you are holding the item when you cast this spell, you can drain it into the bottle used as focus for the spell. Items with hit point damage or the broken condition regain 5 hit points/caster level if drained into a bottle in this way. The duration of temporary effects (such as applied poison or greater magic weapon) passes normally and may expire while the object is in liquid form. The liquid is clearly unsafe to drink, but if, for some reason, a creature does drink the liquid and the spell ends, the creature takes 3d6 points of damage, and brings up the solid version of the item as a standard action in a coughing fit. Any spell or effect that would disperse or dilute an object affected by liquefy forces the object to attempt a Fortitude save (using the effect's DC, or DC 15 for effects with no saving throws of their own, such as pouring a liquefied object into a stream). A failed save causes the object to gain the broken condition. If the item is already broken, it is instead destroyed on a failed save. Liquefy has no effect on artifacts, constructs, or intelligent magic items.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 object weighing up to 1 pound/level",
        duration: "1 round/level (D)",
        savingThrow: "Fortitude negates (object)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Litany of Dependability",
        type: ["utility"],
        school: "enchantment(compulsion)",
        tags: ["lawful"],
        longDesc: `By uttering this litany, you cause one creature to take the average result of its next attack roll, saving throw, skill check, or ability check. While subject to this spell, the target cannot be the target of another spell that has the word “litany” in the title.`,
        castingTime: "1 immediate action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Litany of Sight",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `This litany reveals the unseen to you. You can see invisible creatures and objects within 30 feet. While subject to this spell, the target cannot be the target of another spell that has the word "litany" in the title.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Mark Of the Reptile God",
        type: ["utility"],
        school: "transmutation",
        tags: ["curse"],
        longDesc: `If you succeed at a ranged touch attack, you burn your handprint onto the flesh of a creature, dealing 1d6 points of acid damage. The mark can be placed on any exposed portion of the creature, typically the head or forearm. The flesh around the handprint becomes rough and scaly, like the hide of a lizard. It also glows with a green radiance (shedding light as a torch) when brought within 60 feet of you. While the handprint glows, the target takes a -2 penalty to AC against your attacks and on saving throws to resist any spell you cast or spell-like ability you use. Additionally, each day the target remains cursed, more and more of its flesh becomes covered in reptilian scales. The target must succeed at a Fortitude save each day or take 1d4 points of Charisma damage, 1 point of which is Charisma drain instead. A creature reduced to 0 Charisma by this effect is immediately transformed into a small, harmless cave lizard, as the baleful polymorph spell. As with the effects of bestow curse, the curse inflicted by this spell cannot be dispelled, but it can be removed with a break enchantment, limited wish, miracle, remove curse, or wish spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "permanent",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Master's Escape",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `You create an extradimensional link between yourself and one summoned creature you control that allows you to switch places. After casting master's escape, you can teleport to your summoned creature's space as a swift action, causing your summoned creature to teleport to your former space. If your summoned creature is reduced to 0 or fewer hit points before you can use this spell's effect, you can teleport to a space that you can see within 30 feet as an immediate action. After using either of these effects, the spell ends. A summoner can target his eidolon with this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "you and one summoned creature you control",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Minor Phantom Object",
        type: ["utility"],
        school: "illusion(figment)",
        tags: ["mind-affecting"],
        longDesc: `This spell functions as the minor creation spell, except the object created is a semi-real illusion. Any creature that interacts with the object may make a Will save, with success causing the object to cease to exist. A gnome casting this spell may make a Spellcraft check in place of any Craft check required to make a complex item.`,
        castingTime: "1 minute",
        range: "0 ft.",
        area: "",
        effect: "illusory, unattended, nonmagical object of nonliving plant matter, up to 1 cu. ft./level",
        targets: "",
        duration: "10 minutes/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Ride the Waves",
        type: ["utility"],
        school: "transmutation",
        tags: ["water"],
        longDesc: `The target gains the ability to breathe water and a swim speed of 30 feet. This swim speed means the target also gains the standard +8 bonus on Swim checks and the ability to take 10 on Swim checks even while distracted or endangered. The target can use the run action while swimming, provided it swims in a straight line. The spell does not make the target unable to breathe air.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 hour/level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "River of Wind",
        type: ["utility"],
        school: "evocation",
        tags: ["air"],
        longDesc: `Summoning up the power of the tempest, you direct a current of forceful winds where you please. This spell creates a 5-foot-diameter line of wind-the direction of the wind is away from your location when you cast the spell, and remains constant in that direction for the spell duration. Creatures caught in a river of wind take 4d6 nonlethal damage and are knocked prone. A successful Fortitude save halves the damage and prevents being knocked prone. A creature that begins its turn wholly or partially within a river of wind must make a Fortitude save or be pushed 20 feet in the wind's direction of flow, take 2d6 nonlethal damage, and be knocked prone-a successful Fortitude save means the creature merely takes 1d6 nonlethal damage. Creatures under the effect of freedom of movement and creatures with the air subtype are unaffected by a river of wind.`,
        castingTime: "1 standard action",
        range: "120 ft.",
        area: "120-ft. line",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Scorching Ash Form",
        type: ["utility"],
        school: "transmutation",
        tags: ["fire"],
        longDesc: `This spell functions like gaseous form, except the target becomes a visible swirl of hot ash and smoke instead of harmless translucent gas. The target gains the fire subtype. Any creature that begins its turn sharing a space with the target takes 2d6 points of fire damage and must make a Fortitude save (DC 15, + 1 per previous check) or suffer the effects of smoke inhalation.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "willing corporeal creature touched",
        duration: "1 minute/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "S, M,",
        },
        {
        level: "4",
        name: "Scrying",
        type: ["utility"],
        school: "divination(scrying)",
        tags: [],
        longDesc: `This spell has three different variations: one is that it allows you to choose any point on the map and see a 10 ft radius around it. This doesn't see through any illusions or walls (from the point chosen), but it does see through smoke(or similar effects) and darkness, even magical darkness, and you can use this extra sight to target creatures within the scrying location. The next option is targetting it on a creature (whether you can see it or not), if you do the creature is allowed a will save, but if you've harmed the creature before with a weapon attack the DC increases by 5. If you choose this option and the creature fails the save the creature becomes tracked by your sensor and you can always see where the creature is, and automatically see through any illusions it is using to conceal itself, as well as any other concealment caused by sight. Lastly you can use this spell to see the monsters approaching for the next wave, and allows you to make a single knowledge check on one of them.`,
        castingTime: "full-round action",
        range: "see text",
        area: "",
        effect: "magical sensor",
        targets: "",
        duration: "1 round/2 levels (D);",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M, DF",
        },
        {
        level: "4",
        name: "Shadow Barbs",
        type: ["utility"],
        school: "illusion(shadow)",
        tags: ["darkness"],
        longDesc: `When you cast this spell, you create a shadowy spiked chain that shimmers and pulses with darkness. The chain exists as long as you carry it; if you ever drop the chain, give it to another, or are disarmed, it immediately vanishes and the spell's duration ends. The chain radiates darkness in a 10-foot-radius spread around you, reducing the illumination level in this area by one step, but not below the level of dim light. You can wield the shadow barbs as a spiked chain as if you were fully proficient with spiked chains. Any additional abilities or feats that you possess that apply to spiked chains apply to the shadow barbs as well. The weapon functions as a +2 vicious spiked chain. Its enhancement bonus increases to +3 at caster level 11th, to +4 at caster level 15th, and finally to +5 at caster level 19th. When the spell effect ends, you can make a Will save against the spell-if successful, all of the damage caused to you by the shadow barbs' vicious weapon quality vanishes, unless you are dead or unconscious at the time the spell ends, in which case you automatically fail this Will save and the vicious weapon damage remains.`,
        castingTime: "1 standard action",
        range: "0 ft.",
        area: "",
        effect: "spiked chain-like shadowy weapon",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Will negates (see text)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Shadow Invasion",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `Using a slashing motion with the spell's focus as part of the casting of shadow invasion, you cut open a rift to the Plane of Shadow that fills a 30-foot area with shadowy energies. This area is stationary and becomes dark and gloomy, reducing the light level by one step (as darkness). Certain spells are enhanced within the area; spells of the shadow subschool that have reduced effects when disbelieved (such as shadow evocation) have their reduced effects increased by 20% (to a maximum of 90%) when determining their effects on targets within the area of shadow invasion. In addition, the rift created by shadow invasion has a chance of attracting attention from the other side, and the spell can be inverted to bring these watchers through. When shadow invasion is dismissed as a standard action, there is a chance that a single evangelist kyton will be summoned under the caster's command (as per summon monster V). This chance is 5% for every full round that shadow invasion was active. If the caster level of shadow invasion is 16th or greater, this effect summons an interlocutor kyton instead. A kyton summoned this way remains for a number of rounds equal to what the remaining duration of shadow invasion would have been had it not been dismissed. Successfully summoning a kyton this way is a lawful and evil act, as though casting a spell with the lawful and evil descriptors.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "30-ft. radius emanation centered on you",
        effect: "",
        targets: "",
        duration: "1 round/level (D); see text",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Shadow Projection",
        type: ["utility"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `With this spell, you infuse your life force and psyche into your shadow, giving it independent life and movement as if it were an undead shadow. Your physical body lies comatose while you are projecting your shadow, however you become semi-intangible, and take 50% reduced damage, and your body has no shadow or reflection while the spell is in effect. While projecting your shadow, you gain a shadow's darkvision, defensive abilities, fly speed, racial stealth modifier, and strength damage attack. You do not gain the creature's create spawn ability, nor its skill ranks or Hit Dice. Your shadow has Hit Dice and hit points equal to your own. Your shadow projection has the undead type and may be turned or affected as undead. If your shadow projection is slain, you return to your physical body and are immediately reduced to -1 hit points. Your condition becomes dying, and you must begin making Constitution checks to stabilize.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 hour/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "S, ",
        },
        {
        level: "4",
        name: "Shadow Step",
        type: ["utility"],
        school: "illusion(shadow)",
        tags: ["shadow"],
        longDesc: `To use this spell, you must be in an area of dim light or darkness. You enter a shadow or area of darkness, which transports you along a coiling path of shadowstuff to another dim or dark location within range.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Spiritual Ally",
        type: ["utility"],
        school: "evocation",
        tags: ["force"],
        longDesc: `An ally made of pure force appears in a single 5-foot square within range. The ally takes the form of a servant of your god. The spiritual ally occupies its space, though you and your allies can move through it, since it is your ally. The spiritual ally carries a single weapon with an 19-20x2 crit. Each round on your turn, starting with the turn that you cast this spell, your spiritual ally can make an attack against a foe within its reach that you designate. The spiritual ally threatens adjacent squares and can flank and make attacks of opportunity as if it were a normal creature. The spiritual ally uses your base attack bonus (gaining extra attacks if your base attack bonus is high enough) plus your highest mental stat when it makes a melee attack. When the spiritual ally hits, it deals 1d10 points of force damage + 1 point of damage per 3 caster levels (maximum +5 at 15th level). It strikes as a spell, not a weapon, so it bypasses DR and can affect incorporeal creatures. Each round after the first, you can move the spiritual ally as a swift action. It has a speed of 30 feet, and a fly speed of 30 feet (perfect maneuverability). Being a construct of force, the spiritual ally cannot be harmed by any physical attacks, but dispel magic, disintegrate, a sphere of annihilation, or a rod of cancellation affects it. A spiritual ally's AC against touch attacks is 10. If an attacked creature has spell resistance, you make a caster level check (1d20 + caster level) against that spell resistance the first time the spiritual ally strikes it. If the ally is successfully resisted, the spell is dispelled. If not, the weapon has its normal full effect on that creature for the duration of the spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "spiritual ally of force",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Stone Shape",
        type: ["utility"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `You can form an existing piece of stone into any shape that suits your purpose. While it's possible to make crude coffers, doors, and so forth with stone shape, fine detail isn't possible. There is a 30% chance that any shape including moving parts simply doesn't work.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "stone or stone object touched, up to 10 cu. ft. + 1 cu. ft./level",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "4",
        name: "Summon Accuser",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: ["evil", "lawful"],
        longDesc: `This spell summons a single accuser devil from Hell to do the spellcaster's bidding, similar to how summon monster spells function. You can see through an accuser devils eyes as your own by closing your own eyes, this may allow you to bypass certain forms of concealment as long as the accuser devil can see both you and your targets.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "1 accuser devil",
        targets: "",
        duration: "10 minutes/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "4",
        name: "Summon Monster IV",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell summons an extraplanar creature (typically an outsider, elemental, or magical beast native to another plane). It appears where you designate and acts immediately, on your turn. It attacks your opponents to the best of its ability. If you can communicate with the creature, you can direct it not to attack, to attack particular enemies, or to perform other actions. The spell conjures one of the creatures from the level on Table from: https://www.d20pfsrd.com/magic/all-spells/s/summon-monster/ of the level equal to the level of this spell. Alternatively you can choose to summon 1d3 creatures from the list 1 level below, or 1d4+1 creatures from a list at least 2 levels lower. You choose which kind of creature to summon (one type of creature at a time if you are summoning multiple) but can only summon creatures from the core list (not alternative options), and you can choose a different one each time you cast the spell. A summoned monster cannot summon or otherwise conjure another creature, nor can it use any teleportation or planar travel abilities. Creatures cannot be summoned into an environment that cannot support them. Creatures summoned using this spell cannot use spells or spell-like abilities that duplicate spells with expensive material components (such as wish). When you use a summoning spell to summon a creature with an alignment or elemental subtype, it is a spell of that type. Creatures marked with an "*" are summoned with the celestial template, if you are good, and the fiendish template, if you are evil. If you are neutral, you may choose which template to apply to the creature. Creatures marked with an "*" always have an alignment that matches yours, regardless of their usual alignment. Summoning these creatures makes the summoning spell's type match your alignment.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, F,DF,",
        },
        {
        level: "4",
        name: "Summon Nature's Ally IV",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions like summon nature's ally I, except that you can summon one 4th-level creature, 1d3 3rd-level creatures of the same kind, or 1d4+1 lower-level creatures of the same kind.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "4",
        name: "Summoner Conduit",
        type: ["utility"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell has two different functionalities depending on whether you cast it on a hostile summon, or a friendly summon. 
                
        Friendly: Whenever you take damage, you reduce that damage by 25% and it is instead dealt to the summoned creature as if the spell shield other spell. Any excess damage over the summoned creatures hit points is dealt to you normally. If you are the target of a spell that deals damage, and your summoned creature is not, you can end this spell immediately. If you do, the summoned creature instead becomes the subject of this spell, and you do not.
                
        Hostile: Whenever the target's summoned creature is the target of a spell that deals damage, the target's summoner is also considered to be a target of that spell. Such a summoner gains his normal defenses against the spell, such as a saving throw and spell resistance, and cannot be affected if he is on another plane of existence. Additionally, if you deal damage to a summoned creature, it is reduced by 25%, and this damage is instead dealt to the summoner. The summoner does not gain any additional resistances from this damage.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one summoned creature",
        duration: "1 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Tail Current",
        type: ["utility"],
        school: "transmutation",
        tags: ["water"],
        longDesc: `This spell functions as tailwind except it creates a helpful current in water instead of in the air. It grants free movement while swimming rather than while flying and functions only underwater.`,
        castingTime: "1 standard action",
        range: "120 ft.",
        area: "",
        effect: "",
        targets: "one or more creatures, no two of which can be more than 120 feet apart",
        duration: "1 hour/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Tailwind",
        type: ["utility"],
        school: "transmutation",
        tags: ["air"],
        longDesc: `You compel the wind to push the targets in a direction of your choice. The subjects can hustle during local and overland movement without risk of fatigue. If the subjects are flying, the first 20 feet of movement each round in the chosen direction does not count against their movement for the round. Each creature remains affected only while within 120 feet of every other subject. You can change the tailwind's direction once per hour by concentrating as a standard action. This spell has no effect underwater.`,
        castingTime: "1 standard action",
        range: "120 ft.",
        area: "",
        effect: "",
        targets: "one or more creatures, no two of which can be more than 120 feet apart",
        duration: "1 hour/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Telekinetic Charge",
        type: ["utility"],
        school: "evocation",
        tags: ["force"],
        longDesc: `You telekinetically launch an ally across the battlefield to anywhere within this spell's range. While moving, your ally is flying just above the ground unless you wish otherwise. Movement from this spell provokes attacks of opportunity as normal, although you can lift your ally over objects or out of enemy reach, as long as your ally remains within this spell's range. If your ally lands adjacent to an opponent, he can spend an immediate action to make a melee attack against that opponent with a +2 bonus on the attack roll.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one willing creature",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Trade Items",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `You cause the target object and the object used as a focus for the spell to immediately swap places. To do this, both the focus item and the target item must be of the same type, weapons for weapons, armor for armor, wonderous items for wonderous items, and both targets must be willing. This spell has a chance to fail, the base chance is 10%, and for each rarity difference between the items it increases by a further 10%. If one of the items has more enchantments than the other, the failure chance increases by a further 5% per extra enchantment. Unlike most spells in the Akashic Paths, this spell requires an actual material component, the base cost is 125 gold per person, however when casting the spell you reduce the price by rolling a spellcraft check, the reduction in price is equal to the result of the check. 
                
        
        For GM's: Open a store, set the item trades in the equipment section to 2 and the price to 125, then reduced by the result of the spellcraft check, then open the store (players can by no other items in the store during this time)`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one object weighing no more than 5 lbs./level",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (object)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Umbral Infusion",
        type: ["utility"],
        school: "necromancy",
        tags: ["shadow"],
        longDesc: `You infuse the target undead creature with power drawn from the Shadow Plane, immediately granting it the advanced creature simple template. It gains a +2 bonus on all rolls, including damage rolls, a +2 bonus to special ability DCs, a +4 bonus to AC and CMD, and 2 additional hit points per Hit Die. The undead creature's destructive instincts take hold for the duration of this spell, and any attempts to control or command the undead creature have a 50% chance of failing; if uncontrolled, the undead creature attacks any living creatures it sees. This spell has no effect on undead creatures that already have the advanced creature template.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one undead creature",
        duration: "1 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Wall of Bone",
        type: ["utility"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell creates a vertical wall of skeletal arms that attaches itself to any solid surface. The wall of bone works identically to wall of stone e xcept a s n oted a bove a nd i n t his s pell description. The wall of bone is 1 inch thick per 4 caster levels and composed of up to one 5-foot square per level. The wall created must be vertical, and must rest upon a firm foundation. It cannot be used to bridge a chasm, for instance, or to act as a ramp. Each 5-foot square of the wall has hardness 4 and 7 hit points per inch of thickness. A section of wall whose hit points drops to 0 is breached. If a creature tries to break through the wall with a single attack, the DC of the Strength check is equal to 15 + 2 per inch of thickness. For each creature adjacent to the wall, the skeletal hands attempt a combat maneuver check to grapple it. The skeletal hands do not provoke attacks of opportunity. They make their attacks at the start of your turn, when the wall is summoned, or when an enemy first moves adjacent to the wall. The skeletal hands' CMB is equal to your caster level, and they can grapple a Huge or smaller creature with no penalty. If the wall successfully grapples a foe, that foe takes 1d6 points of damage and gains the grappled condition. Grappled opponents cannot move without first breaking the grapple. All other movement is prohibited unless the creature breaks the grapple first. The wall cannot move or pin foes. Each round the wall succeeds at a grapple combat maneuver check, it deals 1d6 additional points of damage. The CMD of the wall, for the purposes of escaping the grapple, is equal to 10 + its CMB.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 level)",
        area: "",
        effect: "solid wall of humanoid bones with an area of up to one 5-ft. square/level",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "none",
        spellResistance: "yes; see text",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Wall of Ice",
        type: ["utility"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `This spell creates an anchored plane of ice or a hemisphere of ice, depending on the version selected. A wall of ice cannot form in an area occupied by physical objects or creatures. Its surface must be smooth and unbroken when created. Any creature adjacent to the wall when it is created may attempt a Reflex save to disrupt the wall as it is being formed. A successful save indicates that the spell automatically fails. Fire can melt a wall of ice, and it deals full damage to the wall (instead of the normal half damage taken by objects). Suddenly melting a wall of ice creates a great cloud of steamy fog that lasts for 10 minutes. Ice Plane: A sheet of strong, hard ice appears. The wall is 1 inch thick per caster level. It covers up to a 10-foot-square area per caster level (so a 10th-level wizard can create a wall of ice 100 feet long and 10 feet high, a wall 50 feet long and 20 feet high, or any other combination of length and height that does not exceed 1,000 square feet). The plane can be oriented in any fashion as long as it is anchored. A vertical wall need only be anchored on the floor, while a horizontal or slanting wall must be anchored on two opposite sides. Each 10-foot square of wall has 3 hit points per inch of thickness. Creatures can hit the wall automatically. A section of wall whose hit points drop to 0 is breached. If a creature tries to break through the wall with a single attack, the DC for the Strength check is 15 + caster level. Even when the ice has been broken through, a sheet of frigid air remains. Any creature stepping through it (including the one who broke through the wall) takes 1d6 points of cold damage + 1 point per caster level (no save). Hemisphere: The wall takes the form of a hemisphere whose maximum radius is 3 feet + 1 foot per caster level. The hemisphere is as hard to break through as the ice plane form, but it does not deal damage to those who go through a breach.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "anchored plane of ice, up to one 10-ft. square/level, or hemisphere of ice with a radius of up to 3 ft. + 1 ft./level",
        targets: "",
        duration: "1 min./level",
        savingThrow: "Reflex negates; see text",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Warp Metal",
        type: ["utility"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `You cause metal to bend and warp, permanently destroying its straightness, form, and strength. A warped door springs open (or becomes stuck, requiring a successful Strength check to open, at your option). A vehicle grinds to a halt and ceases to operate. Warped ranged weapons are useless. A warped melee weapon imposes a -4 penalty on attack rolls. You can warp one Small or smaller object or its equivalent per caster level. A Medium object counts as two Small objects, a Large object as four, a Huge object as eight, a Gargantuan object as 16, and a Colossal object as 32. Alternatively, you can unwarp metal (effectively warping it back to normal) with this spell. Make whole, on the other hand, does nothing to repair a warped item. You can combine multiple consecutive castings of warp metal to warp (or unwarp) an object that is too large for you to warp with a single casting. Until the object is completely warped, it suffers no ill effects.`,
        castingTime: "1 standard action",
        range: "close (25 ft. plus 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 Small wooden/metal object/level, all within a 20-ft. radius; see text",
        duration: "instantaneous",
        savingThrow: "Will negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Adjustable Polymorph",
        type: ["utility", "buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as alter self, except you can as a swift action alter the disguise (within the limitations of alter self). For example, you could transform yourself into a halfling, then a lizardfolk, then an elf, and so on. You can change your form a number of times equal to your caster level.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Horrific Doubles",
        type: ["utility", "buff"],
        school: "illusion(figment)",
        tags: [],
        longDesc: `You create several illusory doubles of yourself, where you and each image all seem slightly off or wrong in appearance. Treat this spell as mirror image, except as noted. Each creature that can see the doubles must succeed at a Will save or become shaken for as long as it can see any of the doubles. A successful saving throw negates the shaken condition and renders the creature immune to the further effects of this spell (beyond the usual effects of mirror image). In addition, the first time a creature that failed its initial saving throw destroys one of the images, it must succeed at a Will save or its perception of the double shifts at the last second. The double takes on the face of the attacker, the face of a loved one, or some other equally disturbing image, causing the attacker to become frightened for 1 round and take 1d3 points of Wisdom damage from the traumatic shock. Both additional effects are mind-affecting fear effects, and spell resistance applies against them. If your campaign uses the sanity system (see page 12), a creature takes 1d8 points of sanity damage instead of Wisdom damage.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Invisibility, Greater",
        type: ["utility", "buff"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `The creature or object touched becomes invisible. If the recipient is a creature carrying gear, that vanishes, too. If you cast the spell on someone else, neither you nor your allies can see the subject, unless you can normally see invisible things or you employ magic to do so. Items dropped or put down by an invisible creature become visible; items picked up disappear if tucked into the clothing or pouches worn by the creature. Light, however, never becomes invisible, although a source of light can become so (thus, the effect is that of a light with no visible source). Any part of an item that the subject carries but that extends more than 10 feet from it becomes visible. Of course, the subject is not magically silenced, and certain other conditions can render the recipient detectable (such as swimming in water or stepping in a puddle). If a check is required, a stationary invisible creature has a +40 bonus on its Stealth checks. This bonus is reduced to +20 if the creature is moving. This spell does not end if the subject attacks.`,
        castingTime: "1 standard action",
        range: "personal or touch",
        area: "",
        effect: "",
        targets: "you or creature touched",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "4",
        name: "Oath of Peace",
        type: ["utility", "buff"],
        school: "abjuration",
        tags: [],
        longDesc: `Entreating your deity for aid, you make a temporary oath of peace, granting you superior defenses but means you can't attack for the duration of the oath. For as long as you are subject to this spell, you gain a +5 sacred bonus to AC and on saving throws, as well as DR 10/evil. If you make a direct or indirect attack or any show any hostility toward any creature, the spell immediately ends.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S",
        },
        {
        level: "4",
        name: "Quieting Weapons",
        type: ["utility", "buff"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `The target weapons and any ammunition they fire make no sound as part of their normal functions as a weapon. For instance, a firearm's firing would not make an explosive sound, but if you cast this spell on a creature's bite attack, it would not prevent it from vocalizing from its mouth. The first time a creature is struck by a weapon affected by this spell, it must succeed at a Will save (SR applies to this effect) or it becomes unable to make noise louder than a whisper (Perception DC 10 to hear) whether vocally or by other means for the duration of the effect. Because the creature can still whisper, this doesn't interfere with verbal spell components. Whether it succeeds or fails its saving throw, the creature is immune to further effects from this casting of quieting weapons.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "up to one natural or manufactured weapon per 3 caster levels",
        duration: "10 minutes/level",
        savingThrow: "Will negates (object)",
        spellResistance: "yes (object)",
        components: "S, ",
        },
        {
        level: "4",
        name: "Vermin Shape I",
        type: ["utility", "buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `When you cast this spell, you assume the form of any Small or Medium creature of the vermin type. If the form you assume has any of the following abilities, you gain the listed ability: climb 30 feet, fly 30 feet (average maneuverability), swim 30 feet, darkvision 60 feet, low-light vision, scent, and lunge. You don't gain full immunity to mind-affecting effects, but you do gain a +2 resistance bonus on all saving throws against such effects. Small vermin: If you take the form of a Small vermin, you gain a +2 size bonus to your Dexterity and a +2 natural armor bonus. Medium vermin: If you take the form of a Medium vermin, you gain a +2 size bonus to your Strength and a +3 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Mass Ghostbane Dirge",
        type: ["utility", "control"],
        school: "transmutation",
        tags: [],
        longDesc: `The targets coalesce into a semi-physical form for a short period of time. While subject to the spell, the incorporeal creatures takes half damage (50%) from nonmagical attack forms, and full damage from magic weapons, spells, spell-like effects, and supernatural effects.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one incorporeal creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will Negates",
        spellResistance: "yes",
        components: "V,S,M/DF",
        },
        {
        level: "4",
        name: "Resilient Sphere",
        type: ["utility", "control"],
        school: "evocation",
        tags: ["force"],
        longDesc: `A globe of shimmering force encloses a creature, provided the creature is small enough to fit within the diameter of the sphere. The sphere contains its subject for the spell's duration. The sphere functions as a wall of force, except that it can be negated by dispel magic. A subject inside the sphere can breathe normally. The sphere cannot be physically moved either by people outside it or by the struggles of those within.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "1-ft.-diameter/level sphere, centered around a creature",
        targets: "",
        duration: "1 min./level",
        savingThrow: "Reflex negates",
        spellResistance: "yes",
        components: "V, S, F,",
        },
        {
        level: "4",
        name: "Symbol of Laughter",
        type: ["utility", "control"],
        school: "enchantment(charm)",
        tags: ["mind-affecting"],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to cause all creatures within its radius to begin to laugh uncontrollably (as the spell hideous laughter), lasting 1 round per level. Will negates. It can continue being triggered until it has targeted creatures equal to your caster level, or up to 5 times. When it activates it activates in a burst, affecting the closest creatures first. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 12 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 15 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Symbol of Slowing",
        type: ["utility", "control"],
        school: "transmutation",
        tags: [],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to attempt to slow creatures within 15 feet of the rune for 1 round/level. It can continue being triggered until it has attempted slowed an amount of creatures up to your level, or activated 5 times. When it activates it activates in a burst, affecting the closest creatures first. A creature may make a will save to negate the effect. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 14 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 15 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "4",
        name: "Litany of Righteousness",
        type: ["utility", "damage"],
        school: "evocation",
        tags: ["good", "language-dependent"],
        longDesc: `Calling down a litany of anathema, you make an evil more susceptible to the attacks of good creatures. If the target is evil, it takes 1.5x damage from attacks made by creatures with good alignments. If the target also has the evil subtype; when it is hit with attacks made by creatures with a good alignment, it is also dazzled for 1d4 rounds. If youre evil this instead targets good creatures and increases their damage from evil sources.
                        While subject to this spell, the target cannot be the target of another spell that has the word “litany” in the title.`,
        castingTime: "1 swift action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Aligned Weapons",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument] The touched weapon gains the ability to bypass chaotic and lawful damage reduction of outsiders, and deal an additional 2d6 damage against them. If the outsider has damage reduction bypassed by chaotic/lawful and something else, this only deals 1d6 bonus damage to them. A weapon can have only a single imbument at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 weapon",
        duration: "1 round/2 levels",
        savingThrow: "will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "5",
        name: "Angelic Aspect",
        type: ["buff"],
        school: "transmutation",
        tags: ["good"],
        longDesc: `This spell functions like lesser angelic aspect, except you gain low-light vision, darkvision 60, resistance to acid 10, resistance to cold 10, and DR 5/evil, and you sprout white feathered wings allowing you to fly at a speed of 30 feet with average maneuverability. In addition, your natural weapons and any weapons you wield are considered good-aligned for the purpose of overcoming damage reduction.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Animal Growth",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `The target animal grows to twice its normal size and eight times its normal weight. This alteration changes the animal's size category to the next largest, grants it a +8 size bonus to Strength and a +4 size bonus to Constitution (and thus an extra 2 hit points per HD), and imposes a -2 size penalty to Dexterity. The creature's existing natural armor bonus increases by 2. The size change also affects the animal's modifier to AC, attack rolls, and its base damage. The animal's space and reach change as appropriate to the new size, but its speed does not change. If insufficient room is available for the desired growth, the creature attains the maximum possible size and may make a Strength check (using its increased Strength) to burst any enclosures in the process. If it fails, it is constrained without harm by the materials enclosing it--the spell cannot be used to crush a creature by increasing its size. All equipment worn or carried by the animal is similarly enlarged by the spell, though this change has no effect on the magical properties of any such equipment. Any enlarged item that leaves the enlarged creature's possession instantly returns to its normal size. The spell gives no means of command over an enlarged animal. Multiple magical effects that increase size do not stack.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one animal (Gargantuan or smaller)",
        duration: "1 min./level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Aspect of the Wolf",
        type: ["buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `When you cast this spell, you take on an aspect of a wolf, including some of its physical characteristics. You become more rugged, your ears become elongated, and you sprout sharp fangs and fur. You gain a +4 enhancement bonus to Strength and Dexterity, the scent ability, a +2 enhancement bonus on trip attacks, and can make a trip combat maneuver as a swift action. This trip attack does not provoke attacks of opportunity.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF",
        },
        {
        level: "5",
        name: "Banishing Blade",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You imbue a weapon with the power to drive foes back. The first time each round the weapon strikes a creature, the weapon attempts a free bull rush combat maneuver check against that creature. This does not provoke attacks of opportunity. The combat maneuver for the bull rush is equal to 1d20 + your caster level. You do not have to move to push creatures more than 5 feet with this bull rush. If a creature you strike has spell resistance, you must attempt a caster level check to overcome its spell resistance the first time you strike it. If you fail, that creature is immune to the effects of this casting of banishing blade. The first time each extraplanar creature whose Hit Dice don't exceed your caster level is driven back at least 10 feet by this spell, it must attempt a Will save. If it fails, it is sent back to its home plane. Whether it succeeds or fails, that creature is staggered for 1 round and banishing blade's duration ends.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one melee weapon",
        targets: "",
        duration: "1 round/level or until discharged",
        savingThrow: "none and Will partial (see text)",
        spellResistance: "yes (see text)",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Blessing of the Salamander",
        type: ["buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `When you cast this on a creature, its skin turns slick and clammy and it is able to regenerate damage each round. While under the effects of the spell, the creature gains fast healing 5, fire resistance 20 and a +2 competence bonus to its Combat Maneuver Defense.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF",
        },
        {
        level: "5",
        name: "Burst Of Glory",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `Allies in the area of this spell at the time of casting gain a +1 sacred bonus on attack rolls and saves against fear effects, plus 1 temporary hit point per caster level (maximum 20). You shine with a white or golden radiance equal to a torch for the spell's duration, though you can dismiss the glow effect as a free action. If an ally within the area confirms a critical hit, they gain 1d6 stacking temporary hit points that last for 1 minute. Each time a critical hit is confirmed by an ally within the area, the temporary hit points this spell grants increases by 1d6. You can dismiss this spell as a free action to heal every ally within a 20-foot radius burst for hit points equal to the temporary hit points gained on a critical hit, and grant a +4 sacred bonus on attack rolls and saves againt fear for 1 round.`,
        castingTime: "1 standard action",
        range: "",
        area: "10-ft.-radius burst, centered on you",
        effect: "",
        targets: "",
        duration: "1 round/level (D; see text)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Dance of a Hundred Cuts",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You become a lethal combat dancer, swirling and spinning with grace and precision.
                
        You gain a morale bonus on melee attack rolls, melee damage rolls, Acrobatics checks, and armor class equal to +1 per 3 caster levels (maximum +5 at 15th level). The bonus to AC is lost under any circumstances that would cause you to lose your Dexterity bonus to AC. You must remain moving for the spell to stay in effect. If in any round you do not either move at least 10 feet or make a melee attack, the spell's duration ends.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V",
        },
        {
        level: "5",
        name: "Disrupting Weapon",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell makes a melee weapon deadly to undead. Any undead creature with HD equal to or less than your caster level must succeed on a Will save or be destroyed utterly if struck in combat with this weapon. Spell resistance does not apply against the destruction effect.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one melee weapon",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless, object); see text",
        spellResistance: "yes (harmless, object)",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Elemental Weapons Greater",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument] You imbue the target weapon with elemental power, its deals 2d6 points of damage of your chosen element (fire, cold, electricity, acid). A weapon can have only one imbument spell at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 weapon",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "no",
        components: "V,S,M",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "5",
        name: "Grand Destiny",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You inspire the target with the power to seize a grand destiny. The target gains a +4 competence bonus that it can choose to apply before rolling any attack roll, caster level check, saving throw, or skill check. The spell ends once the bonus has been applied to two rolls. At 12th level and 15th level, the bonus can be applied an additional time before the spell is discharged. A subject can be under the effect of only one grand destiny spell at a time.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "one willing creature",
        targets: "",
        duration: "10 minutes/level or until discharged",
        savingThrow: "none (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Guardian Monument Greater",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You touch an unattended, non-magical object to create a touchstone for allies in the area, who are protected by a shimmering aura as long as they are in the area.
        
                The spell grants each subject damage reduction 4/magic. Allies who leave the area and reenter regain the damage reduction.
                
                The spell ends if the object is moved.
                
                Normally, the area of effect is 40 feet from the touched object.
                
                If the touched object is a monument, the area increases to a 60-foot radius.`,
        castingTime: "1 full round",
        range: "touch",
        area: "40-ft. radius from touched object or 60-ft. radius from touched object; see text",
        effect: "",
        targets: "",
        duration: "1 hour/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, F",
        },
        {
        level: "5",
        name: "Litany of Vengeance",
        type: ["buff"],
        school: "transmutation",
        tags: ["language-dependent"],
        longDesc: `This litany causes your enemy to feel the pain of blows more sharply. Anyone who hits the target with an attack gains a +5 sacred or profane bonus (depending on the alignment of the caster) to that attack's damage. While subject to this spell, the target cannot be the target of another spell that has the word "litany" in the title.`,
        castingTime: "1 swift action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "1 round",
        savingThrow: "no",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Planeslayer's Call",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `The magic of your allies in the area becomes more potent against certain outsiders. Choose one alignment subtype (chaotic, evil, good, or lawful). Against outsiders with that alignment component or subtype, your allies in the area gain a +2 bonus on caster level checks to overcome spell resistance, and their spells ignore the first 10 points of energy resistance (but not energy immunity). This spell gains the alignment descriptor that is opposite the outsider alignment chosen. For example, if you choose for the spell to affect evil outsiders, then this spell has the good descriptor.`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "",
        effect: "",
        targets: "allies within a 20-ft.-radius burst centered on you",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Profane Nimbus",
        type: ["buff"],
        school: "evocation",
        tags: ["evil"],
        longDesc: `You are surrounded by a nimbus of shadow shaped like your god's unholy symbol or a symbol of your faith. Any good creature striking you with unarmed strikes, natural weapons, or a handheld weapon deals normal damage, but at the same time, the attacker takes 1d6 points of damage + 1 point per caster level (maximum +15). Creatures wielding melee weapons with reach are not subject to this damage if they attack you. Spell resistance applies against this damage. You also take half damage from magical attacks with the good descriptor. If such an attack allows a Reflex save for half damage, you take no damage on a successful saving throw.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Radiant Forcefield",
        type: ["buff"],
        school: "evocation",
        tags: ["force"],
        longDesc: `You surround your target in a powerful forcefield that grants them DR -/20 for a short period. This is a force effect and is immune to dispel magic, although mage's disjunction can still dispel it, so can a sphere of annihiliation or a rod of cancellation which instantly destroys it. This barrier moves with them and doesn't hinder their movement in any way. While inside of the barrier they cannot teleport (or be teleported), cannot become incorporeal or ethereal, or use spells that originate from themselves (unless it is only affecting them).`,
        castingTime: "1 standard action",
        range: "close (25ft. + 5ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "1 round/6 levels",
        savingThrow: "will negates",
        spellResistance: "no",
        components: "V,S,M",
        },
        {
        level: "4",
        name: "Resounding Blow",
        type: ["buff"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `You must have a melee weapon in hand to cast this spell. On a successful melee attack, your weapon resounds with a thunderous clash. The target takes 1d6 points of sonic damage. Your weapon is not harmed by this attack.
                    \nIf you are using your judgment ability or smite ability against the target, it is staggered for 1 round on a successful attack. A successful Fortitude save negates the staggering effect. Once a creature makes this save, it becomes immune to this stagger for 1 round.
                    \nOn a successful critical hit, the target is stunned for 1 round and deafened for 1d6 rounds. A successful Fortitude save negates the stunning and deafening effects. If you are also using judgment or smite, your foe makes only a single save against all effects.
                    \nThis spell immediately ends if your weapon leaves your hand. Resounding blow stacks with other sources of sonic damage.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "Fortitude partial, see text;",
        spellResistance: "no",
        components: "V",
        },
        {
        level: "5",
        name: "Righteous Might",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Your height immediately doubles, and your weight increases by a factor of eight. This increase changes your size category to the next larger one. You gain a +4 size bonus to Strength and Constitution and take a -2 penalty to your Dexterity. You gain a +2 enhancement bonus to your natural armor. You gain DR 5/ evil (if you normally channel positive energy) or DR 5/good (if you normally channel negative energy). At 15th level, this DR becomes 10/evil or 10/good (the maximum). Your size modifier for AC and attacks changes as appropriate to your new size category. This spell doesn't change your speed. Determine space and reach as appropriate to your new size. If insufficient room is available for the desired growth, you attain the maximum possible size and may make a Strength check (using your increased Strength) to burst any enclosures in the process (see Chapter 7 for rules on breaking objects). If you fail, you are constrained without harm by the materials enclosing you-the spell cannot crush you by increasing your size. All equipment you wear or carry is similarly enlarged by the spell. Melee weapons deal more damage. Other magical properties are not affected by this spell. Any enlarged item that leaves your possession (including a projectile or thrown weapon) instantly returns to its normal size. This means that thrown and projectile weapons deal their normal damage. Magical effects that increase size do not stack.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Rubberskin",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Your skin becomes more elastic, distributing crushing damage efficiently. For the duration of the spell, all bludgeoning and falling damage you take is converted into nonlethal damage. This spell has no effect if you're immune to nonlethal damage.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "",
        duration: "10 minutes/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Sacred Nimbus",
        type: ["buff"],
        school: "evocation",
        tags: ["good"],
        longDesc: `You are surrounded by a nimbus of golden light shaped like your god's holy symbol or a symbol of your faith. Any evil creature striking you with unarmed strikes, natural weapons, or a handheld weapon deals normal damage, but at the same time, the attacker takes 1d6 points of damage + 1 point per caster level (maximum +15). Creatures wielding melee weapons with reach are not subject to this damage if they attack you. Spell resistance applies against this damage. You also take half damage from magical attacks with the evil descriptor. If such an attack allows a Reflex save for half damage, you take no damage on a successful saving throw.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Sanctify Weapons",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell originated among the armies of Heaven. Choose a specific subtype of evil outsider when you cast this spell, such as daemon, demon, devil, or div. All manufactured weapons in the area of effect bypass the DR of that type of outsider. The weapons do not become aligned or change composition.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "20-ft.-radius spread",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Smite Abomination",
        type: ["buff"],
        school: "evocation",
        tags: [],
        longDesc: `Drawing upon positive energy, you emulate some of a paladin's power to smite undead. Choose one undead creature as your target. Your melee attacks against that target gain a bonus equal to your highest mental stat, whichever is higher, on your attack rolls, and a bonus equal to your caster level on damage rolls. Your melee attacks also bypass the target's damage reduction. These bonuses do not stack with the bonuses from a paladin's smite.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Spell Immunity, Communal",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions like spell immunity, except you divide the duration in 10-minute intervals among the creatures touched.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creatures touched",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Stoneskin, Communal",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions like stoneskin, except you divide the duration in 10 minute intervals among the creatures touched. Once the spell has prevented 10 points of damage per caster level (maximum 150 points) for a subject, the spell's effects end for that subject.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creatures touched",
        duration: "10 min./level or until discharged",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Vampiric Shadow Shield",
        type: ["buff"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell wreathes you in shadowy energy and damages those that make melee attacks against you. Any creature that strikes you with its body or a handheld weapon deals normal damage, but at the same time the attacker takes 1d6 points of negative energy damage + 1 point per caster level (maximum +15). If the attacker has spell resistance, it applies to this effect. Creatures wielding melee weapons with reach are not subject to this damage. When an attacker takes damage from the spell, you heal a number of hit points equal to 25% of the damage the spell dealt.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Untold Wonder",
        type: ["buff", "healing"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You fill the target's mind with childlike wonder, allowing that creature to marvel at things that would be debilitating to others. Penalties that the target would take as a result of an emotion effect are instead treated as morale bonuses equal to half the penalty's value (for example, if the target were affected by a crushing despair spell, she would gain a +1 morale bonus on attack rolls, saving throws, ability checks, skill checks, and weapon damage rolls, instead of the spell's normal effect). Furthermore, morale bonuses she gains from other sources are increased by 1. Finally, the target gains a +2 bonus on saving throws to resist spells of the pattern subschool, as her childlike wonder allows her to marvel at the beauty of such effects without being overwhelmed by them.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 minutes/level (D)",
        savingThrow: "Will negates (harmless);",
        spellResistance: "yes (harmless)",
        components: "V, S",
        },
        {
        level: "5",
        name: "Beast Shape III",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as beast shape II, except that it also allows you to assume the form of a Diminutive or Huge creature of the animal type. This spell also allows you to take on the form of a Small or Medium creature of the magical beast type. If the form you assume has any of the following abilities, you gain the listed ability: burrow 30 feet, climb 90 feet, fly 90 feet (good maneuverability), swim 90 feet, blindsense 30 feet, darkvision 60 feet, low-light vision, scent, constrict, ferocity, grab, jet, poison, pounce, rake, trample, trip, and web. Diminutive animal: If the form you take is that of a Diminutive animal, you gain a +6 size bonus to your Dexterity, a -4 penalty to your Strength, and a +1 natural armor bonus. Tiny animal: If the form you take is that of a Tiny animal, you gain a +4 size bonus to your Dexterity, a -2 penalty to your Strength, and a +1 natural armor bonus. Small animal: If the form you take is that of a Small animal, you gain a +2 size bonus to your Dexterity and a +1 natural armor bonus. Medium animal: If the form you take is that of a Medium animal, you gain a +2 size bonus to your Strength and a +2 natural armor bonus. Large animal: If the form you take is that of a Large animal, you gain a +4 size bonus to your Strength, a -2 penalty to your Dexterity, and a +4 natural armor bonus. Huge animal: If the form you take is that of a Huge animal, you gain a +6 size bonus to your Strength, a -4 penalty to your Dexterity, and a +6 natural armor bonus. Small magical beast: If the form you take is that of a Small magical beast, you gain a +4 size bonus to your Dexterity, and a +2 natural armor bonus. Medium magical beast: If the form you take is that of a Medium magical beast, you gain a +4 size bonus to your Strength, and a +4 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Dispel Chaos",
        type: ["buff", "utility"],
        school: "abjuration",
        tags: ["lawful"],
        longDesc: `Shimmering, blue lawful energy surrounds you. This energy has three effects.
        \nFirst, you gain a +4 deflection bonus to AC against attacks by choatic creatures.        
        \nSecond, on making a successful melee touch attack against an chaotic creature from another plane, you can choose to drive that creature back to its home plane. The creature can negate the effects with a successful Will save (Spell Resistance applies). This use discharges and ends the spell.           
        \nThird, with a touch you can automatically dispel any one enchantment spell cast by a chaotic creature or any one chaotic spell. Spells that can't be dispelled by dispel magic also can't be dispelled by dispel evil. Saving throws and Spell Resistance do not apply to this effect. This use discharges and ends the spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "you and a touched evil creature from another plane, or you and an enchantment or evil spell on a touched creature or object",
        duration: "1 round/level or until discharged",
        savingThrow: "",
        spellResistance: "see text",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Dispel Evil",
        type: ["buff", "utility"],
        school: "abjuration",
        tags: ["good"],
        longDesc: `Shimmering, white holy energy surrounds you. This energy has three effects.
        \nFirst, you gain a +4 deflection bonus to AC against attacks by evil creatures.        
        \nSecond, on making a successful melee touch attack against an evil creature from another plane, you can choose to drive that creature back to its home plane. The creature can negate the effects with a successful Will save (Spell Resistance applies). This use discharges and ends the spell.        
        \nThird, with a touch you can automatically dispel any one enchantment spell cast by an evil creature or any one evil spell. Spells that can't be dispelled by dispel magic also can't be dispelled by dispel evil. Saving throws and Spell Resistance do not apply to this effect. This use discharges and ends the spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "you and a touched evil creature from another plane, or you and an enchantment or evil spell on a touched creature or object",
        duration: "1 round/level or until discharged",
        savingThrow: "",
        spellResistance: "see text",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Dispel Good",
        type: ["buff", "utility"],
        school: "abjuration",
        tags: ["evil"],
        longDesc: `Shimmering, black unholy energy surrounds you. This energy has three effects.
        \nFirst, you gain a +4 deflection bonus to AC against attacks by good creatures.        
        \nSecond, on making a successful melee touch attack against an good creature from another plane, you can choose to drive that creature back to its home plane. The creature can negate the effects with a successful Will save (Spell Resistance applies). This use discharges and ends the spell.        
        \nThird, with a touch you can automatically dispel any one enchantment spell cast by a good creature or any one good spell. Spells that can't be dispelled by dispel magic also can't be dispelled by dispel evil. Saving throws and Spell Resistance do not apply to this effect. This use discharges and ends the spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "you and a touched evil creature from another plane, or you and an enchantment or evil spell on a touched creature or object",
        duration: "1 round/level or until discharged",
        savingThrow: "",
        spellResistance: "see text",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Dispel law",
        type: ["buff", "utility"],
        school: "abjuration",
        tags: ["chaotic"],
        longDesc: `Shimmering, yellow chaotic energy surrounds you. This energy has three effects.
        \nFirst, you gain a +4 deflection bonus to AC against attacks by lawful creatures.         
        \nSecond, on making a successful melee touch attack against an lawful creature from another plane, you can choose to drive that creature back to its home plane. The creature can negate the effects with a successful Will save (Spell Resistance applies). This use discharges and ends the spell.        
        \nThird, with a touch you can automatically dispel any one enchantment spell cast by a lawful creature or any one lawful spell. Spells that can't be dispelled by dispel magic also can't be dispelled by dispel evil. Saving throws and Spell Resistance do not apply to this effect. This use discharges and ends the spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "you and a touched evil creature from another plane, or you and an enchantment or evil spell on a touched creature or object",
        duration: "1 round/level or until discharged",
        savingThrow: "",
        spellResistance: "see text",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Geniekind",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `Upon casting this spell, you must choose one type of genie to transform into, selecting from djinni, efreeti, marid, or shaitan. You retain your basic physical appearance but shift in some way to become more akin to the genie type you chose. While under the effects of geniekind, you gain a +2 racial bonus on all saving throws against paralysis, poison, sleep, and stunning effects, and a +4 enhancement bonus to your natural armor bonus. You also gain a +2 enhancement bonus to Constitution and a +5 bonus on all Diplomacy checks made when interacting with creatures of the same elemental subtype as your chosen genie. In addition, you gain other abilities depending upon the type of genie you choose to assume the form of, as detailed below. 
        \nDjinni: You gain the ability to fly at a speed of 60 feet with perfect maneuverability. When flying, your lower torso trails away into a vortex of wind and smoke. You gain resist electricity 10.       
        \nEfreeti: Your flesh turns a deep red and you grow large horns on your head. Your unarmed strikes and any melee weapon you wield deal +1d6 points of fire damage. You gain resist fire 10.
        \nMarid: Your flesh turns blue and you gain webbed fingers and toes. You gain a swim speed of 60 feet and can breathe water. You gain resist cold 10. 
        \nShaitan: Your flesh gains the coloration of stone and your hair appears to be sculpted from fine crystals. You gain a burrow speed of 60 feet and resist acid 10.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Monstrous Physique III",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as monstrous physique II, except it also allows you to assume the form of a Diminutive or Huge creature of the monstrous humanoid type. If the form you assume has any of the following abilities, you gain the listed ability: burrow 30 feet, climb 90 feet, fly 90 feet (good maneuverability), swim 90 feet, all-around vision, blindsense 30 feet, darkvision 60 feet, low-light vision, scent, blood frenzy, cold vigor, constrict, ferocity, freeze, grab, horrific appearance, jet, leap attack, mimicry, natural cunning, overwhelming, poison, pounce, rake, sound mimicry, speak with sharks, trample, trip, and web. If the creature has the undersized weapons special quality, you gain that quality. Diminutive monstrous humanoid: If the form you take is that of a Diminutive monstrous humanoid, you gain a +6 size bonus to your Dexterity, a -4 penalty to your Strength, and a +1 natural armor bonus. Huge monstrous humanoid: If the form you take is that of a Huge monstrous humanoid, you gain a +6 size bonus to your Strength, a -4 penalty to your Dexterity, and a +6 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Plant Shape I",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `When you cast this spell you can assume the form of any Small or Medium creature of the plant type. If the form you assume has any of the following abilities, you gain the listed ability: darkvision 60 feet, low-light vision, constrict, grab, and poison. If the form you assume does not possess the ability to move, your speed is reduced to 5 feet and you lose all other forms of movement. If the creature has vulnerability to an element, you gain that vulnerability. Small plant: If the form you take is that of a Small plant, you gain a +2 size bonus to your Constitution and a +2 natural armor bonus. Medium plant: If the form you take is that of a Medium plant, you gain a +2 size bonus to your Strength, a +2 enhancement bonus to your Constitution, and a +2 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Polymorph",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell transforms a willing creature into an animal, humanoid or elemental of your choosing; the spell has no effect on unwilling creatures, nor can the creature being targeted by this spell influence the new form assumed (apart from conveying its wishes, if any, to you verbally). If you use this spell to cause the target to take on the form of an animal or magical beast, the spell functions as beast shape II. If the form is that of an elemental, the spell functions as elemental body I. If the form is that of a humanoid, the spell functions as alter self. The subject may choose to resume its normal form as a full-round action; doing so ends the spell for that subject.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "1 min/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Quiet Fate",
        type: ["buff", "utility"],
        school: "divination",
        tags: [],
        longDesc: `When you cast this spell you gain insight into fate and the ability to manipulate it. Whenever you make an attack or saving throw, you can manipulate the natural roll of the dice as an immediate action, increasing or decreasing it by 1. Functionally this increases the result of the roll by 1, but also allows you to do things such as turn a normal hit into a critical threat, or a critical fumble into a regular miss. Additionally, while this spell is active, if a creature rolls an attack against you or a saving throw against an effect you created, you automatically know the natural roll of the dice, and as an immediate action you can choose to active this ability on them, increasing or decreasing the natural result of their dice by 1. Either use of this spell can be activated multiple times on the same roll as apart of the same immediate action, however you can only manipulate an single enemies fate a single time, and this is affected by spell resistance. You can only activate this spell once per cast, plus an additional activation every 5 caster levels, then the spell is expended and ends. This change to the dice does not count as a bonus or penalty.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level or until discharged (see text)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Shapechanger's Gift",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You change the target into an animal (as per beast shape I), humanoid (as per alter self), or monstrous humanoid (as per monstrous physique IUM). The chosen form can't have a fly speed. The subject's statistics change as per the appropriate spell except the creature's ability scores and natural armor do not change. The creature can change between its natural form and the chosen form at will as a standard action.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "willing living creature touched",
        duration: "10 minutes/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Undead Anatomy II",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as undead anatomy I, except it also allows you to assume the form of a Tiny or Large corporeal creature of the undead type. If the form you assume has any of the following abilities, you gain the listed ability: climb 60 feet, fly 60 feet (good maneuverability), swim 60 feet, darkvision 60 feet, low-light vision, blood drain, DR 5/bludgeoning, scent, freeze, grab, mimicry, pounce, shadowless, sound mimicry, and trip. In this form, you gain a +4 bonus on saves against mindaffecting effects, disease, poison, sleep, and stunning. If the form has a vulnerability to an attack (such as sunlight), you gain that vulnerability. Tiny undead: If the form you take is that of a Tiny undead, you gain a +4 size bonus to your Dexterity, a -2 penalty to your Strength, and a +1 natural armor bonus. Large undead: If the form you take is that of a Large undead, you gain a +4 size bonus to your Strength, a -2 penalty to your Dexterity, and a +4 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Vermin Shape II",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as vermin shape I, except it also allows you to assume the form of a Tiny or Large creature of the vermintype. If the form you assume has any of the following abilities, you gain the listed ability: burrow 30 feet, climb 60 feet, fly 60 feet (good maneuverability), swim 60 feet, darkvision 60 feet, low-light vision, tremorsense 30 feet, scent, blood drain, constrict, grab, lunge, poison, pull, trample, and web. You don't gain full immunity to mind-affecting effects, but you do gain a +4 bonus on all saving throws against such effects. Tiny vermin: If you take the form of a Tiny vermin, you gain a +4 size bonus to your Dexterity, a -2 penalty to your Strength, and a +1 natural armor bonus. Large vermin: If you take the form of a Large vermin, you gain a +4 size bonus to your Strength, a -2 penalty to your Dexterity, and a +5 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Augmenting Wall",
        type: ["control"],
        school: "evocation",
        tags: [],
        longDesc: `You create a wall of faintly shimmering elemental energy. Upon casting the spell, choose either acid, cold, electricity, or fire. The spell gains the chosen descriptor, and any thrown weapons or ammunition that pass through the augmenting wall as part of a ranged attack deal 1d6 points of energy damage of the specified type in addition to their normal damage. The wall has no effect on melee weapons or items not thrown as part of an attack. As you cast the spell, you can limit the wall so that it only affects ranged weapons passing through it in the direction of your choice. Doing so halves the spell's duration.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "20-ft.-high wall of energy whose area is up to one 10-ft. square/level",
        targets: "",
        duration: "1 round/2 levels (see text)",
        savingThrow: "none (object)",
        spellResistance: "no (object)",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Baleful Polymorph",
        type: ["control"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `As beast shape III, except that you change the subject into a Small or smaller animal of no more than 1 HD. If the new form would prove fatal to the creature, such as an aquatic creature not in water, the subject gets a +4 bonus on the save. If the spell succeeds, the subject must also make a Will save. If this second save fails, the creature loses its extraordinary, supernatural, and spell-like abilities, loses its ability to cast spells (if it had the ability), and gains the alignment, special abilities, and Intelligence, Wisdom, and Charisma scores of its new form in place of its own. It still retains its class and level (or HD), as well as all benefits deriving therefrom (such as base attack bonus, base save bonuses, and hit points). It retains any class features (other than spellcasting) that aren't extraordinary, supernatural, or spell-like abilities. Any polymorph effects on the target are automatically dispelled when a target fails to resist the effects of baleful polymorph, and as long as baleful polymorph remains in effect, the target cannot use other polymorph spells or effects to assume a new form. Incorporeal or gaseous creatures are immune to baleful polymorph, and a creature with the shapechanger subtype can revert to its natural form as a standard action.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "permanent",
        savingThrow: "Fortitude negates, Will partial, see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "banish Seeming",
        type: ["control"],
        school: "abjuration",
        tags: [],
        longDesc: `With a melee touch attack you can dispel an illusion or return a creature to its natural form. This functions as dispel magic directed at the effect in question, except you receive a +2 enhancement bonus on your dispel check and you can only dispel illusions or changes in form created by supernatural effects or spells. If multiple effects are changing the creature's appearance, you can dispel one such effect for every four caster levels you possess, starting with the highest caster level spells and proceeding to spells with lower caster levels.
        \nThe caster level for supernatural abilities such as change shape is equal to the target creature's Hit Dice. A creature returned to its natural form by banish seeming is prevented from changing its form again for a number of rounds equal to your caster level.
        \nBanish seeming has no effect on nonmagical means of changing appearance, such as that provided by a disguise or extraordinary ability.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one creature or object",
        duration: "instantaneous and 1 round/level; see text",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M",
        },
        {
        level: "5",
        name: "Black Spot",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `An intangible, illusory black spot manifests above the target's head and remains until the target dies or the curse is lifted. The black spot cannot be covered or hidden by any means, including other illusions. The black spot radiates a cursed aura in a 10-foot radius around its target. Anyone within the aura gains a +2 bonus on weapon attack and damage rolls against the target. In addition, the target has a -1 penalty on saving throws against control spells (except the black spot), and an additional -2 penalty on saving throws against death effects and curses, it also cannot gain luck bonuses. Every 1d4 rounds in which a creature bears a black spot, it must make a Fortitude save. On a failed save, the creature takes 1 point of Constitution damage. The damage cannot be healed until the black spot is removed. If the creature's Constitution reaches 0, it dies. The black spot cannot be dispelled, but it can be removed with break enchantment, limited wish, miracle, remove curse, or wish.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "permanent",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Charm Person, Mass",
        type: ["control"],
        school: "enchantment(charm)",
        tags: ["mind-affecting"],
        longDesc: `This charm makes multiple humanoid creature regard you as friendly. The humanoid will not attack you and will attempt to exclude you from all area of affect abilities or spells it has (it wont turn off that ablity if it us unable to avoid you), it can also count for flanking or as an ally for any other ability you have, and will accept harmless spells cast by you. It will not attempt to help you in any other way and you have no other control over it, such as protecting you from another creature, and will attempt to attack all other party members as normal. If you attack, damage, or cast any non-harmless spells on the creature,  it gets an immediate resave with a +5 bonus (once per attack or ability).  `,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one or more humanoid creatures, no two of which can be more than 30 ft. apart",
        duration: "1 hour/level",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "5",
        name: "Command, Greater",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["language-dependent", "mind-affecting"],
        longDesc: `This spell functions like command, except that up to one creature per level may be affected, and the activities continue beyond 1 round. At the start of each commanded creature's action after the first, it gets another Will save to attempt to break free from the spell. Each creature must receive the same command.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "5",
        name: "Constricting Coils",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell functions like hold monster, except that the target is constricted as if by the coils of a large snake, taking 1d6+6 points of bludgeoning damage each round that it fails its save. A successful save ends both the paralyzing and constriction effects.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round/level (D); see text",
        savingThrow: "Will negates; see text",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "5",
        name: "Contagion, Greater",
        type: ["control"],
        school: "necromancy",
        tags: ["disease", "evil"],
        longDesc: `This spell functions as contagion, except the victim cannot overcome the disease without magic-making the required number of saves does not cure it. The DC to remove the disease with magic is equal to the save DC + 5.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "instantaneous",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Curse of Disgust",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["curse", "emotion", "mind-affecting"],
        longDesc: `You place a curse upon a creature, causing it to avoid the sight of a specific trigger, which is a kind of creature, object, or condition designated by you. When the target is within 30 feet of a trigger and is aware of the trigger, it gains the sickened condition and feels an urge to leave. A successful Will save negates the urge to leave, but the sickened condition persists as long as the target is within 30 feet of a trigger and aware of it. Example triggers include beggars, filthy clothing, diseased creatures, the king, blood, spiders, rats, corpses, and sewage.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "permanent",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Dominate Person",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You can control the actions of any humanoid creature through a telepathic link that you establish with the subject's mind. If you and the subject have a common language, you can generally force the subject to perform as you desire, within the limits of its abilities. If no common language exists, you can communicate only basic commands, such as 'Come here,' 'Go there,' 'Fight,' and 'Stand still.' You know what the subject is experiencing, but you do not receive direct sensory input from it, nor can it communicate with you telepathically. Once you have given a dominated creature a command, it continues to attempt to carry out that command to the exclusion of all other activities except those necessary for day-to-day survival (such as sleeping, eating, and so forth). Because of this limited range of activity, a Sense Motive check against DC 15 (rather than DC 25) can determine that the subject's behavior is being influenced by an enchantment effect (see the Sense Motive skill description). Changing your orders or giving a dominated creature a new command is a move action. By concentrating fully on the spell (a standard action), you can receive full sensory input as interpreted by the mind of the subject, though it still can't communicate with you. You can't actually see through the subject's eyes, so it's not as good as being there yourself, but you still get a good idea of what's going on. Subjects resist this control, and any subject forced to take actions against its nature receives a new saving throw with a +2 bonus. Obviously self-destructive orders are not carried out. Once control is established, the range at which it can be exercised is unlimited, as long as you and the subject are on the same plane. You need not see the subject to control it. If you don't spend at least 1 round concentrating on the spell each day, the subject receives a new saving throw to throw off the domination. Protection from evil or a similar spell can prevent you from exercising control or using the telepathic link while the subject is so warded, but such an effect does not automatically dispel it.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one humanoid",
        duration: "1 day/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
            level: "2",
            name: "Shadow Madness",
            type: ["control"],
            school: "enchantment(compulsion)",
            tags: ["mind-affecting"],
            longDesc: `You can control the actions of an enemy creature, forcing it to immediately attack against a nearby ally. If the target fails the will save they make an immediate attack against an ally within their reach of their choice. They take this action outside of their turn.`,
            castingTime: "1 standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "one living creature",
            duration: "instantaneous",
            savingThrow: "Will negates",
            spellResistance: "yes",
            components: "V, S, ",
        },
        {
            level: "3",
            name: "Holy Word Serenity",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `A random living ally on the map heals for 5d8 + caster level hit points.`,
            castingTime: "1 standard action",
            range: "",
            area: "map",
            effect: "",
            targets: "",
            duration: "instantaneous",
            savingThrow: "Will negates",
            spellResistance: "yes",
            components: "V",
        },
        {
        level: "5",
        name: "Feast on Fear",
        type: ["control"],
        school: "necromancy",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `Each round, as a standard action, you can target a single living creature of up to 9 HD and strike it with terrifying waves of power. If the target fails its saving throw, it becomes panicked for 1d4 rounds, and you gain 5 temporary hit points (which disappear after 1 hour). After the panic ends, the creature remains shaken for 10 minutes per caster level, and it automatically becomes panicked again if it comes within sight of you during that time. These temporary hit points stack if they come from different creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one or more living creatures (see text)",
        duration: "1 round/level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Feeblemind",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `Target creature's Intelligence and Charisma scores each drop to 1. The affected creature is unable to use Intelligence- or Charisma based skills, cast spells, understand language, or communicate coherently. Still, it knows who its friends are and can follow them and even protect them. The subject remains in this state until a heal, limited wish, miracle, or wish spell is used to cancel the of the feeblemind. A creature that can cast arcane spells, such as a sorcerer or a wizard, takes a -4 penalty on its saving throw.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "Will negates; see text",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Flexile Curse",
        type: ["control"],
        school: "transmutation",
        tags: ["curse"],
        longDesc: `You curse your target with a withering aura that degrades its armor and shield (if any). This reduces the hardness, armor bonus, and enhancement bonus of any armor or shield worn by the target by 1. For every 1d4 rounds the target wears a suit of armor or a shield, the hardness, armor bonus, and enhancement bonus are reduced by an additional 1. If the armor or shield's hardness is reduced to 0, anytime the target of the curse is struck while wearing that item, there is a 20% chance that it gains the broken condition. If the enhancement bonus of magic suit of armor or shield is reduced to 0, the armor or shield loses any other special abilities it had. If the target removes the suit of armor or shield (even if it's broken or has been drained of all enhancement bonuses), the armor or shield regains its hardness, armor bonus, and enhancement bonus at the rate of 1 per 1d4 rounds. A suit of armor or shield broken by this curse that regains its full hardness ceases to be broken. A magic suit of armor or shield that lost its special abilities regains them when its enhancement bonus is fully restored.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "permanent",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Forbid Action, Greater",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["language-dependent", "mind-affecting"],
        longDesc: `This spell functions as forbid action, except up to one creature per level may be affected. Each creature must receive the same forbidden action.`,
        castingTime: "1 standard action",
        range: "close (25 ft. +5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "5",
        name: "Geyser",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["fire", "water"],
        longDesc: `You cause a column of boiling water to spring forth from any horizontal surface, knocking over creatures directly over it and exposing nearby creatures to searing droplets as its spray falls back to the ground. Any creature entering the geyser, or occupying the square it appears in, must make a Reflex saving throw to avoid being hurled into the air and then tossed to the ground. If the creature fails its saving throw, it takes 3d6 points of fire damage from the boiling water and also takes falling damage based upon the height of the geyser (e.g., if the geyser is 50 feet tall, the creature takes 5d6 falling damage), landing prone in a random square adjacent to the geyser. A successful saving throw halves the damage and negates the falling damage, and the creature is moved to the closest square adjacent to the geyser (Large-sized or larger creatures are moved enough so that they are not on top of the geyser but still adjacent to it). This movement does not provoke attacks of opportunity and does not count toward the creature's normal movement. In addition, the geyser sprays boiling water in a hemispherical emanation around its square. The radius of this emanation is equal to one-half the geyser's height (e.g., a 50-foot geyser has a 25-foot-radius emanation). Any creature within this area, including yourself, takes 1d6 points of fire damage each round as droplets of boiling water cascade on them. You can choose to make a smaller geyser than your level permits if an obstruction prevents it from reaching its full height, or if you simply want to create a spread of boiling rain that's smaller than what would be created by a full-height geyser spell.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "spout of boiling water filling a 5 ft. square and spraying upward 10 ft./2 levels",
        targets: "",
        duration: "concentration + 1 round/level",
        savingThrow: "Reflex partial (see below)",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "5",
        name: "Grease Greater",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `A grease spell covers a solid surface with a layer of slippery grease. Any creature in the area when the spell is cast must make a successful Reflex save or fall. A creature can walk within or through the area of grease at half normal speed with a DC 10 Acrobatics check. Failure means it can't move that round (and must then make a Reflex save or fall), while failure by 5 or more means it falls (see the Acrobatics skill for details). Creatures that do not move on their turn do not need to make this check and are not considered flat-footed.
                        \nThe spell can also be used to create a greasy coating on an item. Material objects not in use are always affected by this spell, while an object wielded or employed by a creature requires its bearer to make a Reflex saving throw to avoid the effect. If the initial saving throw fails, the creature immediately drops the item. A saving throw must be made in each round that the creature attempts to pick up or use the greased item. A creature wearing greased armor or clothing gains a +10 circumstance bonus on Escape Artist checks and combat maneuver checks made to escape a grapple, and to their CMD to avoid being grappled.
                        \nWhen you use this spell to cover a solid surface with slippery grease, the 10-foot squares must form a continuous area, each part of which must be within the spell's range. When you use this spell to create a greasy coating on items, no two of the targeted items can be more than 30 feet apart. You cannot target both items and surfaces with a single casting of this spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one object/2 levels or 1 10-ft. square/2 levels",
        duration: "1 minute/level",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V,S,M",
        },
        {
        level: "5",
        name: "Hold Monster",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell functions like hold person, except that it affects any living creature that fails its Will save.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round/level ; see text",
        savingThrow: "Will negates; see text",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "5",
        name: "Hungry Earth",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `The ground attempts to pull creatures beneath its surface as if hungry for the flesh of mortals. Immediately, and at the beginning of each of your turns, every creature touching the ground within the area of the spell is the target of a grapple combat maneuver. Creatures that enter the area of effect are also automatically attacked. The ground does not provoke attacks of opportunity. The earth's CMB is equal to 5 + your caster level for the purpose of this combat maneuver check. Attempt the combat maneuver check only once each round and apply the result to all creatures in the area of effect. Each time the ground succeeds at a combat maneuver check to grapple a foe, it drags the creature farther down, eventually forcing the creature below its surface. With the first successful check, the target gains the grappled condition. Grappled opponents can't move without first breaking the grapple (doing so requires a successful DC 20 combat maneuver or Escape Artist check). The ground receives a +5 bonus on combat maneuver checks to grapple opponents it is already grappling. After the second successful grapple combat maneuver check, the grappled creature is pulled to the ground and becomes prone. On the third successful grapple combat maneuver check, the creature is fully buried and must hold its breath or begin suffocating. A buried creature can't attempt to escape unless the effect ends or it breaks the grapple. The DC to escape the grapple increases to 25 for a creature that has been pulled beneath the earth.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "20-foot-radius spread",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Hungry Pit",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `This spell functions as create pit, except that the pit has the ability to squeeze and crush any creature trapped within it and has a maximum depth of 100 feet. Creatures who fall into the hole take falling damage as normal. In addition, anyone within the pit, not just those on the bottom, takes 4d6 points of bludgeoning damage each round as the pit contracts and then returns to its normal size (a successful Reflex save halves this damage). The ever-shifting walls of the pit are quite difficult to scale and have a Climb DC of 35.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "10-ft.-by-10-ft. hole, 10 ft. deep/2 levels",
        targets: "",
        duration: "1 round + 1 round/level",
        savingThrow: "Reflex negates; Reflex half; see text",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Hymn Of Mercy",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["good", "mind-affecting"],
        longDesc: `All creature within 30-ft radius deal only nonlethal damage with all of their weapon attacks. Damage taken by creatures or objects that are not subject to nonlethal damage is not converted to nonlethal and remains lethal damage. The weapon retains all of its other normal properties.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "30-ft.-radius burst centered on you",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Icy Prison",
        type: ["control"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `You trap the target in solid ice 1 inch thick per caster level. If the creature fails its save, it is helpless, but can still breathe (the ice blocks line of effect to the target). If the target makes its save, it gains the entangled condition but can otherwise act normally. Whether or not the target saves, it takes 1 point of cold damage per caster level each round it is helpless or entangled in the ice. The ice has hardness 0 and 3 hit points per inch of thickness; if broken, the creature is freed. A creature can break the ice as a full-round action with a successful Strength check (DC 15 + your caster level).`,
        castingTime: "1 standard action",
        range: "medium (10 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 minute/level; see text",
        savingThrow: "Reflex partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Impossible Angles",
        type: ["control"],
        school: "illusion(figment)",
        tags: [],
        longDesc: `You cause the surrounding area to appear to distort. The angles and corners of the area subtly twist and contort, creating unnatural and impossible shapes. Any creature entering the area must succeed at a Will save or become disoriented. Disoriented characters treat the area as difficult terrain and are sickened. In addition, whenever a disoriented creature uses an action to move (including taking a 5-foot step if it can do so in difficult terrain), roll 1d8 to see which direction it moves, in a similar manner to determining where a splash weapon lands on a miss. On a 1, the creature moves in its intended direction, with 2 through 8 rotating around the creature's starting square in a clockwise direction. Only the creature's first 5 feet of movement each round are affected in this way-it can move normally for any remaining movement, either from the same action or from later actions, as the creature acclimatizes to the distortion. An affected creature can attempt a new Will save each round to end the disoriented effect. A creature that leaves the area and re-enters must attempt the saving throw again, even if it succeeded at its initial save.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "contiguous area up to one 5-foot cube/caster level (S)",
        effect: "",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Litany of Thunder",
        type: ["control"],
        school: "evocation",
        tags: ["language-dependent", "sonic"],
        longDesc: `You call down a thunderous boom upon your enemy. The target becomes deafened until the condition is removed, and is confused for 1 round. While subject to this spell, the target cannot be the target of another spell that has the word "litany" in the title.`,
        castingTime: "1 swift action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "1 round",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Mind Fog",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `Mind fog produces a bank of thin mist that weakens the mental resistance of those caught in it. Creatures in the mind fog take a -10 penalty on Wisdom checks and Will saves. (A creature that successfully saves against the fog is not affected and need not make further saves even if it remains in the fog.) Affected creatures take the penalty as long as they remain in the fog and for 2d6 rounds thereafter. The fog is stationary and lasts for 30 minutes (or until dispersed by wind). A moderate wind (11+ mph) disperses the fog in 4 rounds; a strong wind (21+ mph) disperses the fog in 1 round. The fog is thin and does not significantly hamper vision.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "fog spreads in 20-ft. radius, 20 ft. high",
        targets: "",
        duration: "30 minutes and 2d6 rounds; see text",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Pessimism",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You erode the target's confidence and instill a sense of despair. This fear of failure manifests as a -2 penalty on attack rolls, saving throws, ability checks, skill checks, and weapon damage rolls. Additionally, the target can't gain morale bonuses of any kind while the spell remains in effect. No amount of achievement counters the spell's effects-the target simply explains away positive events with a self-critical perspective. Certain events can solidify the character's belief that it is doomed. Whenever the target rolls a natural 1 on an attack roll or saving throw, fails an ability or skill check by more than 5, or takes additional damage as a result of a foe's confirmed critical hit, the penalty to roll imposed by pessimism becomes -3 for 1 round. This increased penalty doesn't stack, even if multiple catastrophes occur on the same round.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 hour/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "5",
        name: "Phantasmal Web",
        type: ["control"],
        school: "illusion(phantasm)",
        tags: ["mind-affecting"],
        longDesc: `You implant within the minds of your targets the illusion that they are engulfed in tangled webs teeming with swarms of tiny spiders. Those who fail to disbelieve the phantasmal web are treated as if in a web spell, but must also make a Fortitude save at the beginning of each turn or become nauseated for that round by the phantasmal spiders. As the phantasmal web exists only in the minds of the targets, it cannot be burned or destroyed, and it provides no cover (though it does provide concealment) against attacks made by the targets. Targets cannot escape the phantasmal web by moving, even by teleportation. Freedom of movement allows unobstructed movement but does not negate the concealment or nausea effects. Targets of the spell perceive everyone else around them to be engulfed in webs and swarming spiders, but the spell has no visible effect to other creatures (who may assist allies to disbelieve the effect).`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which may be more than 30 ft. apart",
        duration: "1 round/level (D)",
        savingThrow: "Will disbelief, then Fortitude partial; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Roaming Pit",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `This spell functions as create pitAPG, except the pit is capable of movement. As a move action, you can direct the pit to move up to 20 feet, though it must always remain on a horizontal surface large enough to accommodate its area. If the pit's movement causes it to share a space with a creature on the same horizontal surface, that creature must succeed at a Reflex saving throw or fall into the pit. Any creature that avoids falling into the pit when it reaches its new destination moves to the nearest safe space. Creatures that fall into the pit move with it if it is relocated.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "mobile 10-ft.-by-10-ft. hole, 10 ft. deep/2 levels",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Reflex negates",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Rune of Ruin",
        type: ["control"],
        school: "transmutation",
        tags: ["curse"],
        longDesc: `You curse a magic item, such as magical clothing, a suit of armor, or a weapon. The object is reduced to 1/4 its normal hit point total, gains the broken condition, and appears damaged and worn. If it grants a numeric bonus, such as a +2 deflection bonus to AC, that bonus is reduced by 1 for every 3 caster levels you possess, to a minimum of +0. Other magical qualities fail to work 50% of the time when called upon, so a resistance bonus on saves or a weapon's flaming special ability could fail each time the item is used. If the object is an intelligent magical item, its Ego score remains unchanged despite its reduced quality. The weapon has only a 50% chance to successfully use any spells or spell-like abilities it has, and has a 25% chance of forgetting its special purpose (if any). If an intelligent weapon is actively dominating its wielder when it fails its save against rune of ruin, the wielder gains an immediate saving throw with a +4 bonus to regain control. Rune of ruin has no affect on magical artifacts.`,
        castingTime: "1 standard action",
        range: "Medium (100 ft. plus 10 ft./level)",
        area: "",
        effect: "",
        targets: "1 object",
        duration: "instantaneous",
        savingThrow: "Fortitude negates (object)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Sabotage Construct",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell functions as confusion, except that it affects only constructs. When you are rolling for a confused construct's behavior, a result of 26–50 indicates the construct twitches spasmodically. On a successful Will save, the construct is confused for only 1 round. This bypasses the usual spell immunity many constructs like golems have.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "Will partial",
        spellResistance: "yes",
        components: "V, S,",
        },
        {
        level: "5",
        name: "Smug Narcissism",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You cause your target to become overwhelmed by its own importance, talents, and attractiveness. The target cannot help but look at itself in every reflective surface at every possible opportunity. In social situations, the target always tries to comment about how attractive it is or how ugly someone else is by comparison. The target remains constantly distracted, always looking for a reflective surface to gaze upon (such as a mirror, pool of water, a polished shield, and so on). The distraction gives the target a -2 penalty on all skill checks. In combat, the target worries about enemies damaging its appearance, and focuses on defense rather than offense (casting defensive spells rather than offensive spells, using the fight defensively or total defense action, and so on).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "10 minute/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Straitjacket",
        type: ["control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You cause a straitjacket to spring into existence to restrain the target creature. You attempt a combat maneuver against the target's CMD. Your CMB for this check is equal to your caster level + 5 due to the straightjacket's Strength. This combat maneuver doesn't provoke an attack of opportunity, and if it succeeds, the target is restrained. This is similar to the grappled condition, except the target is able to move at its normal speed, the restraint doesn't cause the target to require concentration checks to use abilities that require concentration, and the target can't take actions that require one or more hands or arms to perform (including casting spells that require a somatic or material component). Once it has been restrained for 1 round, the target can attempt an additional saving throw against a magical effect that makes it confused, a curse, a fear effect, or a madness. The caster chooses which effect the target gets an extra save against. This extra save applies to only effects with durations of 10 minutes per level or less, and it doesn't apply to instantaneous effects. This extra save occurs only once per casting of straitjacket. A creature can attempt to escape the straitjacket with a combat maneuver check or Escape Artist check, with a DC equal to 10 + your caster level + your highest mental modifier.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 caster levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Suffocation",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell extracts the air from the target's lungs, causing swift suffocation. The target can attempt to resist this spell's effects with a Fortitude save-if he succeeds, he is merely staggered for 1 round as he gasps for breath. If the target fails, he immediately begins to suffocate. On the target's next turn, he falls unconscious and is reduced to 0 hit points. One round later, the target drops to -1 hit points and is dying. One round after that, the target dies. Each round, the target can delay that round's effects from occurring by making a successful Fortitude save, but the spell continues for 3 rounds, and each time a target fails his Fortitude save, he moves one step further along the track to suffocation. This spell only affects living creatures that must breathe. It is impossible to defeat the effects of this spell by simply holding one's breath-if the victim fails the initial saving throw, the air in his lungs is extracted.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "3 rounds",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Telekinesis",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `You move objects or creatures by concentrating on them. Depending on the version selected, the spell can provide a gentle, sustained force, perform a variety of combat maneuvers, or exert a single short, violent thrust. 
        \nSustained Force: A sustained force moves an object weighing no more than 25 pounds per caster level (maximum 375 pounds at 15th level) up to 20 feet per round. A creature can negate the effect on an object it possesses with a successful Will save or with spell resistance. This version of the spell can last 1 round per caster level, but it ends if you cease concentration. The weight can be moved vertically, horizontally, or in both directions. An object cannot be moved beyond your range. The spell ends if the object is forced beyond the range. If you cease concentration for any reason, the object falls or stops. An object can be telekinetically manipulated as if with one hand. For example, a lever or rope can be pulled, a key can be turned, an object rotated, and so on, if the force required is within the weight limitation. You might even be able to untie simple knots, though delicate activities such as these require DC 15 Intelligence checks. 
        \nCombat Maneuver: Alternatively, once per round, you can use telekinesis to perform a bull rush, disarm, grapple (including pin), or trip. Resolve these attempts as normal, except that they don't provoke attacks of opportunity, you use your caster level in place of your Combat Maneuver Bonus, and you add your mental modifier in place of your Strength or Dexterity modifier. No save is allowed against these attempts, but spell resistance applies normally. This version of the spell can last 1 round per caster level, but it ends if you cease concentration. 
        \nViolent Thrust: Alternatively, the spell energy can be spent in a single round. You can hurl one object or creature per caster level (maximum 15) that are within range and all within 10 feet of each other toward any target within 10 feet per level of all the objects. You can hurl up to a total weight of 25 pounds per caster level (maximum 375 pounds at 15th level). You must succeed on attack rolls (one per creature or object thrown) to hit the target with the items, using your base attack bonus + mental. Weapons cause standard damage (with no Strength bonus; note that arrows or bolts deal damage as daggers of their size when used in this manner). Other objects cause damage ranging from 1 point per 25 pounds (for less dangerous objects) to 1d6 points of damage per 25 pounds (for hard, dense objects). Objects and creatures that miss their target land in a square adjacent to the target. Creatures who fall within the weight capacity of the spell can be hurled, but they are allowed Will saves (and spell resistance) to negate the effect, as are those whose held possessions are targeted by the spell. If a telekinesed creature is hurled against a solid surface, it takes damage as if it had fallen 10 feet (1d6 points).`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "or see text",
        duration: "concentration (up to 1 round/level) or instantaneous; see text",
        savingThrow: "Will negates (object) or none; see text",
        spellResistance: "yes (object); see text",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Transmute Mud to Rock",
        type: ["control"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `This spell permanently transforms normal mud or quicksand of any depth into soft stone (sandstone or a similar mineral). Any creature in the mud is allowed a Reflex save to escape before the area is hardened to stone. Transmute mud to rock counters and dispels transmute rock to mud.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "up to two 10-ft. cubes/level",
        effect: "",
        targets: "",
        duration: "permanent",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "5",
        name: "Transmute Rock to Mud",
        type: ["control"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `This spell turns natural, uncut, or unworked rock of any sort into an equal volume of mud. Magical stone is not affected by the spell. The depth of the mud created cannot exceed 10 feet. A creature unable to levitate, fly, or otherwise free itself from the mud sinks until hip- or chest-deep, reducing its speed to 5 feet and causing a -2 penalty on attack rolls and AC. Brush or similar material thrown atop the mud can support creatures able to climb on top of it. Creatures large enough to walk on the bottom can wade through the area at a speed of 5 feet. If transmute rock to mud is cast upon the ceiling of a cavern or tunnel, the mud falls to the floor and spreads out in a pool at a depth of 5 feet. The falling mud and the ensuing cave-in deal 8d6 points of bludgeoning damage to anyone caught directly beneath the targeted area, or half damage to those who succeed on Reflex saves. Castles and large stone buildings are generally immune to the effect of the spell, since transmute rock to mud can't affect worked stone and doesn't reach deep enough to undermine such buildings' foundations. However, small buildings or structures often rest upon foundations shallow enough to be damaged or even partially toppled by this spell. The mud remains until a successful dispel magic or transmute mud to rock spell restores its substance-but not necessarily its form. Evaporation turns the mud to normal dirt over a period of days. The exact time depends on exposure to the sun, wind, and normal drainage. Transmute rock to mud counters and dispels transmute mud to rock.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "up to two 10-ft. cubes/level",
        effect: "",
        targets: "",
        duration: "permanent; see text",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "5",
        name: "Waves of Fatigue",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `Waves of negative energy render all living creatures in the spell's area fatigued. This spell has no effect on a creature that is already fatigued.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Whip of Centipedes",
        type: ["control"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions as whip of spiders, except it summons centipedes, and any creature you strike with the whip takes swarm damage as if it were attacked by a centipede swarm (2d6 points of damage plus poison and distraction, Bestiary 43). If you transform the whip into a centipede swarm, it has 10 hit points.`,
        castingTime: "1 standard action",
        range: "0 ft.",
        area: "",
        effect: "whiplike swarm",
        targets: "",
        duration: "1 round/level (D (see text)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "5",
        name: "Blight",
        type: ["control", "damage"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell withers a single plant of any size. An affected plant creature takes 2d6 points of damage per level (maximum 30d6) and may attempt a Fortitude saving throw for half damage. A plant that isn't a creature doesn't receive a save and immediately withers and dies. This spell has no effect on the soil or surrounding plant life.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "plant touched",
        duration: "instantaneous",
        savingThrow: "Fortitude half; see text",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Slough",
        type: ["control", "damage"],
        school: "transmutation",
        tags: ["evil"],
        longDesc: `The target takes 1d4 points of Constitution damage each round as its skin loosens and splits. Once it has taken 5 or more points of Constitution damage in this way, its skin falls off to reveal its musculature. The creature ceases taking Constitution damage, but takes a -4 penalty on saving throws against disease, pain effects, or poison, and on Charisma-based skill checks with the exception of Intimidate and Use Magic Device. The creature's skin regrows rapidly-once its Constitution damage is fully healed, its skin becomes intact once again and the penalties end.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "instantaneous",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "5",
        name: "Foe to Friend",
        type: ["control", "utility"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `Cast this spell when an enemy is about to make an attack against an ally. The creature makes the attack against a valid target of your choice instead or the attack is negated. In addition, the target is considered an ally for determining flanking for 1 round.`,
        castingTime: "1 immediate Action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round",
        savingThrow: "Will Negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Marks of Forbiddance",
        type: ["control", "utility"],
        school: "abjuration",
        tags: ["mind-affecting"],
        longDesc: `Marks of Forbiddance magically brand two creatures, preventing them from committing violence against one another. When you cast this spell choose one enemy and one ally within range. Both targets become branded with the sigil of forbiddance. Until the end of the spell's duration, in order for the two targets to attack one another, even with a targeted spell, each attacker must attempt a Will save. If the save succeeds, that target can attack the other normally.
                        \nIf the save fails, the target can't follow through with the attack and the action is lost. This spell does not prevent the targets from attacking each other with area of effect spells or abilities.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one enemy and one ally",
        duration: "1 round/level",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Siphon Magic",
        type: ["control", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell attempts to transfer a magical effect from a creature you touch to yourself. When you touch the creature, siphon magic attempts to end one ongoing spell that has been cast on that creature, as if via a targeted dispel magic. If you know the specific spell effect you wish to target, you can name that spell effect to target that specific spell; otherwise siphon magic begins with the highest-level spell in effect and works its way down through all spells affecting the target until it dispels one or runs out of effects, as per dispel magic. If siphon magic successfully ends a spell effect on the target, the remaining duration of that spell effect is transferred to you. That spell effect plays out for the rest of its duration as if you had been the original target. If the spell allows a saving throw to resist the effect, you gain a saving throw as if the spell were just being cast upon you, although this does not 'reset' the spell's duration.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Wall of Thorns",
        type: ["control", "utility"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `A wall of thorns spell creates a barrier of very tough, pliable, tangled brush bearing needle-sharp thorns as long as a human's finger. Any creature forced into or attempting to move through a wall of thorns takes piercing damage per round of movement equal to 25 minus the creature's AC. Dexterity and dodge bonuses to AC do not count for this calculation. (Creatures with an AC of 25 or higher, without considering Dexterity and dodge bonuses, take no damage from contact with the wall.)
        \nYou can make the wall as thin as 5 feet thick, which allows you to shape the wall as a number of 10-by-10-by-5-foot blocks equal to twice your caster level. This has no effect on the damage dealt by the thorns, but any creature attempting to break through takes that much less time to force its way through the barrier.
        \nCreatures can force their way slowly through the wall by making a Strength check as a full-round action. For every 5 points by which the check exceeds 20, a creature moves 5 feet (up to a maximum distance equal to its normal land speed). Of course, moving or attempting to move through the thorns incurs damage as described above. A creature trapped in the thorns can choose to remain motionless in order to avoid taking any more damage.
        \nAny creature within the area of the spell when it is cast takes damage as if it had moved into the wall and is caught inside. In order to escape, it must attempt to push its way free, or it can wait until the spell ends. Creatures with the ability to pass through overgrown areas unhindered can pass through a wall of thorns at normal speed without taking damage.
        \nA wall of thorns can be breached by slow work with edged weapons. Chopping away at the wall creates a safe passage 1 foot deep for every 10 minutes of work. Normal fire cannot harm the barrier, but magical fire burns it away in 10 minutes.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "wall of thorny brush, up to one 10-ft. cube/level (S)",
        targets: "",
        duration: "10 min./level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S",
        },
        {
        level: "5",
        name: "Acidic Spray",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["acid"],
        longDesc: `A spray of acid erupts from your outstretched hand, dealing 1d6 points of acid damage per caster level (maximum 15d6) to each creature within its area (Reflex half ). This acid continues to burn for 1 round, dealing 1d6 points of acid damage per two caster levels (maximum 7d6) to any creature that failed its saving throw against the spell (a second Reflex save on the creature's turn negates this additional damage).`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "",
        effect: "60-ft. line",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex partial (see text)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Biting Cold",
        type: ["damage"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `A deep and chilling cold settles into the target's body. While this persists, the creature suffers 2d6 + caster level cold damage (max +15) at the start of each of their turns. Additionally, critical spells against the creature have their critical spell power increased by 20%, and it suffers a -1 penalty against the saves of all cold spells. You can cast this spell on an individual creature up to 3 times and its effects stack. If a creature has 3 stacks on them, all critical hits with weapons gain a +1 bonus to their critical damage multiplier. Multiple casts against a creature refreshes the duration, unless the creature saves, in which case it instead just increases the duration by 3 rounds.`,
        gameDesc: `A deep and chilling cold settles into the target's body. While this persists, the creature suffers 2d6 + caster level cold damage (max +15) at the start of each of their turns. Additionally, critical spells against the creature have their critical spell power increased by 20%, and it suffers a -1 penalty against the saves of all cold spells. You can cast this spell on an individual creature up to 3 times and its effects stack. If a creature has 3 stacks on them, all critical hits with weapons gain a +1 bonus to their critical damage multiplier. Multiple casts against a creature refreshes the duration, unless the creature saves, in which case it instead just increases the duration by 3 rounds.
        \nThis spell has 3 casts per preperation, and its range is increased to medium (100 ft. + 10 ft./level).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "3 rnds + 1 rnd/2 levels",
        savingThrow: "fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Blood Boil",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `The temperature of the target creature's blood (or other similar body fluid) begins to rise over the next 3 rounds during the caster's turn. Each round starting with the first, the target creature attempts a new saving throw at the start of the caster's turn to resist that round's effect. A successful save does not end the spell effect, but does prevent that round's effect. On the round that this spell is cast, the target becomes fatigued. On the next round, as the blood temperature begins to rise, the target's capillaries burst, dealing 1d6 points of Constitution damage to the target. On the third and final round, the target's blood begins to boil; the spell deals 1d6 points of damage per caster level (to a maximum of 15d6), and-if the target is still alive-the target becomes exhausted rather than fatigued.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "3 rounds",
        savingThrow: "Fortitude negates (see text)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Burn Corruption",
        type: ["damage"],
        school: "evocation",
        tags: ["fire", "good"],
        longDesc: `This spell fills the area with violet flames that scour an area clean of life—especially of the corrupted life of the Abyss.
        \nCreatures (and foliage) in the area take 1d8 points of fire damage per 2 caster levels you possess (maximum 7d8) unless they are outsiders with the chaotic and evil subtypes or are otherwise tainted by demons, in which case they instead take 1d6 points of fire damage per caster level (maximum 15d6).        
        \nThis fire damage ignores the fire resistance granted by the demon subtype, but it does not penetrate any other form of fire resistance or immunity.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "10-ft. cube/level (S)",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Call Lightning Storm",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `This spell functions like call lightning, except that each bolt deals 5d6 points of electricity damage (or 5d10 if created outdoors in a stormy area), and you may call a maximum of 15 bolts.`,
        castingTime: "1 round",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "one or more 30-ft.-long vertical lines of lightning",
        targets: "",
        duration: "1 min./level",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Caustic Blood",
        type: ["damage"],
        school: "transmutation",
        tags: ["acid"],
        longDesc: `You imbue your blood with corrosive acid. Any time you take piercing or slashing damage, a spray of acidic blood spurts from your body in the direction of the opponent who inflicted the wound, dealing 1d6 points of acid damage per caster level (maximum 15d6, Reflex half). This spurt travels in a 10-foot line, damaging the first creature or object it touches, with no splash damage. After it contacts a creature or object, your acidic blood continues to burn that creature for 1 round, dealing 1d6 points of acid damage per 2 caster levels (maximum 7d6). A second successful Reflex save negates this additional damage.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "Reflex half or negates; see text",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Cone of Cold",
        type: ["damage"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `Cone of cold creates an area of extreme cold, originating at your hand and extending outward in a cone. It drains heat, dealing 1d6 points of cold damage per caster level (maximum 15d6).`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Corrosive Consumption",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["acid"],
        longDesc: `With a touch, this spell causes a small, rapidly growing patch of corrosive acid to appear on the target. On the first round, the acid deals 1 point of acid damage per caster level (maximum 15). On the second round, the acid patch grows and deals 1d4 points of acid damage per caster level (maximum 15d4). On the third and final round, the acid patch covers the entire creature and deals 1d6 points of acid damage per caster level (maximum 15d6). The target can spend a full-round action to scrape off the acid, or can wash it off with at least 1 gallon of liquid to halve the damage for that round and negate the remaining rounds of the spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "3 rounds",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Fire Snake",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `You create a sinuous line of flames that you may shape as desired. The fire snake affects one 5-foot square per caster level, and each square must be adjacent to the previous square, starting with you. The fire snake may not extend beyond its maximum range. Creatures in the path of the fire snake take 1d6 points of fire damage per caster level (maximum 15d6).`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "see text",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Flame Strike",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `A flame strike evokes a vertical column of divine fire. The spell deals 1d6 points of damage per caster level (maximum 15d6). Half the damage is fire damage, but the other half results directly from divine power and is therefore not subject to being reduced by resistance to fire-based attacks. Because this spell only deals half fire damage, it scales with only half of your normal fire spell power.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "cylinder (10-ft. radius, 40-ft. high)",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Furious Fire Barrage",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `Upon casting this spell, you conjure forth one or two balls of flame, each resting in a free hand. As part of casting this spell or as a standard action, you can throw one flame ball a maximum of 300 feet, dealing 1d6 points of fire damage per caster level you have (maximum 10d6) to all creatures within a 10-foot-radius spread.
                        \nSo long as the spell's duration lasts, you can channel your anger as a full-round action to create one new ball of flame, which can be thrown as a standard action. You cannot create additional balls of flame while you are under the effects of a calm emotions spell or are otherwise unable to feel anger or outrage.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Inflict Light Wounds, Mass",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `Negative energy spreads out in all directions from the point of origin, dealing 1d8 points of damage + 1 point per caster level (maximum +25) to nearby living enemies. Like other inflict spells, mass inflict light wounds cures undead in its area rather than damaging them. A cleric capable of spontaneously casting inflict spells can also spontaneously cast mass inflict spells.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "instantaneous",
        savingThrow: "Will half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Lightning Arc",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You generate an arc of lightning between two targets. The lightning deals 1d6 points of electricity damage per caster level (maximum 15d6) to both targets and any creatures in a line connecting them. Creatures damaged by the line can make a reflex saving throw to halve the damage, but the direct targets cannot. For every creature caught in the line of the spell, this spell's critical spell power increases by 5%. The spell fails if there is no line of effect between the targets. Lightning arc sets fire to combustibles and damages objects in its path. It can melt metals that have a low melting point, such as lead, gold, copper, silver, or bronze.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "two creatures or objects which must be no more than 60 ft. apart",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes (see text)",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Pain Strike, Mass",
        type: ["damage"],
        school: "evocation",
        tags: ["evil", "pain"],
        longDesc: `Pain strike racks the targeted creatures with agony, inflicting 2d6 points of nonlethal damage per round (scales with negative spell power) for 1 round per level (maximum 10 rounds) . Additionally, the affected creatures are sickened for the spell's duration, and the caster gains a +4 circumstance bonus on Intimidate checks against the target.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level (D)",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Slay Living",
        type: ["damage"],
        school: "necromancy",
        tags: ["death"],
        longDesc: `You can attempt to slay any one living creature. When you cast this spell, your hand seethes with eerie dark fire. You must succeed on a melee touch attack to touch the target. The target takes 12d6 points of damage + 1 point per caster level (scales with negative spell power). If the target's Fortitude saving throw succeeds, it instead takes 3d6 points of damage + 1 point per caster level. The subject might die from damage even if it succeeds on its saving throw.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "instantaneous",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Solar Cycles",
        type: ["damage","buff"],
        school: "transmutation",
        tags: ["fire"],
        longDesc: `You cause yourself to become infused with the power of the sun which comes in fluctuating waves of energy. Every 1d4 rounds you release a wave of heat hitting all creatures within a 20ft. radius spread of you. This deals 1d6 points of fire damage per caster level (maximum 10d6), though creatures can make a reflex save to half it. You also take this damage as the heat bursts through you, however you automatically succeed the saving throw against it, and can make a fortitude save to reduce it by half again. On the round you release the energy, you also gain cold resistance 30, you gain a movement action, you shine as the daylight spell, possibly dispelling darkness spells, and all of your fire spells gain 20 fire spell power, and 20 fire spell critical power, and have their DC increased by +1. If when rolling to determine when the next solar flare will release you roll a 4, instead of gaining a movement action, you gain an additional standard action. You cannot use this standard action to cast a spell. If when rolling to determine when the next solar flare will release you roll a 1, you do not gain an additional movement action when it releases.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "20-ft.-radius burst centered on you",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "5",
        name: "Superconductor",
        type: ["damage"],
        school: "transmutation",
        tags: ["electricity"],
        longDesc: `You can use this spell in one of two ways:
        \n1: You curse a creature to become an electrical superconductor. When the target takes electricity damage from a spell, it chains to a different nearby creature of your choice within 30 feet of them. The additional target gets the same save as whatever this creature did against the effect, and this only transmits instantaneous effects (and only affects this new target, even if the spell would normally affect more). If the target of this redirection already took damage from that redirected spell, the DC of the repeated spell is reduced by -4. You can never redirect a spell more than once from any individual creature.
        \n2:You curse a creature to act like a lightning rod. Every time a creature within 30 feet of them takes electricity damage from a spell, this creature also takes the damage. It gains whatever saving throws as the original target did against the spell, and this only transmits instantaneous effects (and only affects this new target, even if the spell would normally affect more). If the target of this redirection already took damage from that redirected spell, the DC of the repeated spell is reduced by -4. If a single spell deals damage to multiple creatures at once, this only chains to this creature a single time.`,
        gameDesc: `You can use this spell in one of two ways:
        \n1: You curse a creature to become an electrical superconductor. When the target takes electricity damage from a spell, it chains to a different nearby creature of your choice within 30 feet of them. The additional target gets the same save as whatever this creature did against the effect, and this only transmits instantaneous effects (and only affects this new target, even if the spell would normally affect more). If the target of this redirection already took damage from that redirected spell, the DC of the repeated spell is reduced by -4. You can never redirect a spell more than once from any individual creature.
        \n2:You curse a creature to act like a lightning rod. Every time a creature within 30 feet of them takes electricity damage from a spell, this creature also takes the damage. It gains whatever saving throws as the original target did against the spell, and this only transmits instantaneous effects (and only affects this new target, even if the spell would normally affect more). If the target of this redirection already took damage from that redirected spell, the DC of the repeated spell is reduced by -4. If a single spell deals damage to multiple creatures at once, this only chains to this creature a single time.
        \n\nThis spell has 3 casts per preperation, and its duration is increased to 1 round/level.`,
        castingTime: "1 standard action",
        range: "medium (100ft + 10ft/level)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "1 round per 3 levels",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "5",
        name: "Surge Anchor",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You place an electric anchor on the square you are currently standing. Thereafter, whenever a creatures casts a spell that deals electricity damage within the range of this spell, the anchor chains to them (though doesn't affect them), creating a line of electricity between them and it. Any creature in between it and the anchor takes 1d6 points of electricity damage per 2 caster levels (max 10d6), reflex halves. This electricity originates from the anchor and damages obstacles and may be blocked by them as the lightning bolt spell. A creature can be damage by multiple anchors at once, consider each a different source of damage for resistances, but it only need make one save.`,
        gameDesc: `You place an electric anchor on the square you are currently standing. Thereafter, whenever a creatures casts a spell that deals electricity damage within the range of this spell, the anchor chains to them (though doesn't affect them), creating a line of electricity between them and it. Any creature in between it and the anchor takes 1d6 points of electricity damage per 2 caster levels (max 10d6), reflex halves. This electricity originates from the anchor and damages obstacles and may be blocked by them as the lightning bolt spell. A creature can be damage by multiple anchors at once, consider each a different source of damage for resistances, but it only need make one save.
        \n\nThis spell has 2 casts per preperation and its duration is increased to 1 round/level.`,
        castingTime: "1 movement action",
        range: "0 ft, then close (25ft + 5ft./2 levels); see text",
        area: "",
        effect: "",
        targets: "5ft. square",
        duration: "1 round/2 levels",
        savingThrow: "reflex negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Wind Blades",
        type: ["damage"],
        school: "transmutation",
        tags: ["air"],
        longDesc: `You harden the air around the target into jagged invisible blades that deal damage based on how fast the target moves. On its turn, the target takes 1d8 points of slashing damage if it moves at least 5 feet, plus 1d8 points of slashing damage for each additional 10 feet of movement. Movement that doesn't pass through air (such as burrowing, swimming, or teleportation) doesn't cause this damage. In areas of strong wind, the target takes damage on its turn, even if it doesn't move. The wind deals 2d8 points of slashing damage for strong wind, plus 2d8 for every wind category above strong. Every time it is affected by a wind effect that creates strong winds, such as Gust of wind it takes 5d8 damage immediately.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "5",
        name: "Wreath of Blades",
        type: ["damage", "buff"],
        school: "abjuration",
        tags: [],
        longDesc: `The daggers serving as focus of this spell take on a deadly sharpness as they animate and spin around you, creating a 5-foot-radius emanation of spinning mithral blades that moves with you. Any creature that starts its turn within the area of the spinning blades takes 1d4 points of damage for every two caster levels (maximum 10d4 at 20th level) and the damage bypasses DR/silver. Furthermore, the daggers ward off some attacks, in a way similar to the warding weapon spell (see page 48). While subject to this spell, you do not provoke attacks of opportunity for casting spells, even from creatures with the Disruptive feat. Creatures with the Spellbreaker feat (Core Rulebook 134) can easily bypass this defensive property, though they still take damage from the spell. Your casting (even failing to cast defensively) still provokes attacks of opportunity from creatures with that feat. Lastly, the blades that serve as the focus for this spell can be enchanted for greater effect. When all of the blades share the same enhancement bonus and special weapon qualities, a creature that is damaged by this spell is also treated as if hit by one of these weapons. For example, if a 12th-level magus casts this spell using four +1 frost mithral daggers as focus, the damage dealt by the blades would be 6d4+1 plus 1d6 cold damage, as long as the daggers were commanded to be sheathed in ice. No matter the modifications made to the focus weapons, they must always be mithral daggers. No other type of weapons can serve as a focus for this spell.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "5-foot-radius emanation centered on you",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "Reflex half (special, see below)",
        spellResistance: "no (special, see below)",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Cloudkill",
        type: ["damage", "control"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `This spell generates a bank of fog, similar to a fog cloud, except that its vapors are yellowish green and poisonous. These vapors automatically kill any living creature with 3 or fewer HD (no save). A living creature with 4 to 6 HD is slain unless it succeeds on a Fortitude save (in which case it takes 1d4 points of Constitution damage on your turn each round while in the cloud). A living creature with more than 6 HD takes 1d4 points of Constitution damage on your turn each round while in the cloud (a successful Fortitude save halves this damage). Holding one's breath doesn't help, but creatures immune to poison are unaffected by the spell. Unlike a fog cloud, the cloudkill moves away from you at 10 feet per round, rolling along the surface of the ground. Figure out the cloud's new spread each round based on its new point of origin, which is 10 feet farther away from the point of origin where you cast the spell. Because the vapors are heavier than air, they sink to the lowest level of the land, even pouring down den or sinkhole openings. It cannot penetrate liquids, nor can it be cast underwater.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "cloud spreads in 20-ft. radius, 20 ft. high",
        targets: "",
        duration: "1 min./level",
        savingThrow: "Fortitude partial; see text",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Cleansing Fire",
        type: ["damage", "utility"],
        school: "evocation",
        tags: ["fire", "good"],
        longDesc: `A ring of fire surrounds the area affected by the spell. The flames radiate heat, but not enough to damage adjacent creatures. The flames deal 2d6 points of fire damage to any creatures that pass through them (or 4d6 points of damage to undead creatures). If you manifest a portion of the ring in a square that contains a creature, that creature takes damage as if it passed through the ring.
        
                    The ring of flames attempts to dispel all ongoing spell effects with the evil descriptor within it, targeting each spell effect once per round as per dispel magic. Any attempt to cast a spell with the evil descriptor inside the ring of flames is targeted by a dispel magic affect that attempts to counterspell the evil spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "30-ft. rdius emanating from the touched point",
        effect: "",
        targets: "",
        duration: "concentration, up to 1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "5",
        name: "Holy Ice",
        type: ["damage", "utility"],
        school: "transmutation",
        tags: ["cold", "good", "water"],
        longDesc: `This spell creates a large mass of frozen holy water that can be used for one of two effects. 
                
        Holy Ice Wall: This functions like wall of ice (hemisphere or plane). Any creature that takes damage from holy water takes 1 point of damage every time it touches or attacks the ice wall with melee attacks; extended contact with the wall (such as standing or walking on it) deals 1d6 points of damage. Even when the ice has been broken through, a sheet of frigid holy air remains. Any creature that steps through it (including the one who broke through the wall) takes 1d6 points of damage + 1 point per caster level (no save); half of this damage is cold damage, half is damage from holy water (creatures unharmed by holy water do not take the damage). Holy Ice Javelins: The spell creates a number of javelins of frozen holy water in your square equal to your caster level (maximum 15), which hurl themselves toward one or more targets that are no more than 10 feet away from each other. You must succeed on attack rolls (one per javelin) to hit the target with the javelin, using your base attack bonus + highest mental modifier. The javelins deal 1d6 damage each, plus 1 point of cold damage and 1 point of damage from holy water. The javelins are destroyed by this attack.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "wall of ice or flying ice javelins (see text)",
        targets: "",
        duration: "1 minute/level, instantaneous, or until expended (see text)",
        savingThrow: "Reflex negates or none (see text)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Tidal Surge",
        type: ["damage", "utility"],
        school: "conjuration(creation)",
        tags: ["water"],
        longDesc: `If you cast tidal surge on land, you create an onrushing surge of water 10 feet high in a 30-foot cone that deals 1d6 points of bludgeoning damage for every 2 caster levels you have (maximum 10d6 at 20th level) and extinguishes all nonmagical fires in the area. Magical fire effects in the area of a tidal surge are affected as if you had cast dispel magic. In addition to taking damage, creatures that fail their Reflex saves are pushed 1d4x5 feet away from you, and Medium or smaller creatures are also knocked prone. If you cast this spell in or on a body of water at least 30 feet across, you can shape the spell either as the cone described above or as a 60-foot line. In either shape, the water deals 1d10 points of bludgeoning damage for every 2 caster levels you have in addition to pushing away creatures that fail their Reflex saves.`,
        castingTime: "1 standard action",
        range: "30 ft. or 60 ft.; see text",
        area: "cone-shaped burst or line; see text",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Break Enchantment",
        type: ["healing"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell frees victims from enchantments, transmutations, and curses. Break enchantment can reverse even an instantaneous effect. For each such effect, you make a caster level check (1d20 + caster level, maximum +15) against a DC of 11 + caster level of the effect. Success means that the creature is free of the spell, curse, or effect. For a cursed magic item, the DC is equal to the DC of the curse. If the spell is one that cannot be dispelled by dispel magic or stone to flesh, break enchantment works only if that spell is 5th level or lower. If the effect comes from a permanent magic item, break enchantment does not remove the curse from the item, but it does free the victim from the item's effects.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "up to one creature per level, all within 30 ft. of each other",
        duration: "instantaneous",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Breath Of Life",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell cures 5d8 points of damage + 1 point per caster level (maximum +25). Unlike other spells that heal damage, breath of life can bring recently slain creatures back to life. If cast upon a creature that has died within 1 round, apply the healing from this spell to the creature. If the healed creature's hit point total is at a negative amount less than its Constitution score, it comes back to life and stabilizes at its new hit point total. If the creature's hit point total is at a negative amount equal to or greater than its Constitution score, the creature remains dead. Creatures brought back to life through breath of life gain a temporary negative level that lasts for 1 day. Creatures slain by death effects cannot be saved by breath of life. Like cure spells, breath of life deals damage to undead creatures rather than curing them, and cannot bring them back to life.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless) or Will half, see text",
        spellResistance: "yes (harmless) or yes, see text",
        components: "V, S, ",
        },
        {
            level: "5",
            name: "Invigorating Repose",
            type: ["healing","utility"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `This spell enhances your spells that bring the dead back to life. If you cast raise dead, the target creature is restored to full hit points. If you cast breath of life, that spell can revive a dead target as long as you cast it within a number of rounds equal to half your caster level, and the healing effect is treated as if the spell were empowered with the Empower Spell feat. Casting any of these spells discharges the invigorating repose spell.`,
            castingTime: "1 standard action",
            range: "personal",
            area: "",
            effect: "",
            targets: "you",
            duration: "1 hour or until discharged",
            savingThrow: "",
            spellResistance: "",
            components: "V, S, DF",
        },
        {
        level: "5",
        name: "Cleanse",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `Positive energy infuses and cleanses your body. This spell cures 4d8 points of damage + 1 point per caster level (maximum +25) and ends any and all of the following adverse conditions affecting you: ability damage, blinded, confused, dazzled, deafened, diseased, exhausted, fatigued, nauseated, poisoned, and sickened. In addition, cleanse functions as break enchantment upon a single additional effect of your choice that is affecting you and that can be legally affected by this effect. If used by undead or other creatures healed by negative energy, the spell cleanses with negative energy rather than positive.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "",
        spellResistance: "",
        components: "S, DF,",
        },
        {
            level: "5",
            name: "Lesser Healing Aura",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `[Healing Aura] Positive energy surrounds you, healing allies that end their turn within 10 feet of you. This heals 2d8 + level hit points. This doesn't harm undead. You can have only a single [Healing Aura] spell active at a time. This doesn't heal you.`,
            castingTime: "full-round",
            range: "personal",
            area: "15-foot emination",
            effect: "",
            targets: "you",
            duration: "1 round/2 levels",
            savingThrow: "",
            spellResistance: "yes",
            components: "S, DF,",
        },
        {
            level: "5",
            name: "Radiant Light",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `You unleash an aura of healing around you, healing allies within 15 feet of you for 3d8 + level hit points. This doesn't heal you. Gain 2% positive spell critical and 15% positive spell power for 1 round after casting this. This increases to 3 rounds if it is a critical spell.`,
            castingTime: "movement",
            range: "personal",
            area: "15-foot emination",
            effect: "",
            targets: "you",
            duration: "instantaneous",
            savingThrow: "will negates",
            spellResistance: "yes",
            components: "S, DF,",
        },
        {
            level: "6",
            name: "Greater Healing Aura",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `[Healing Aura] Positive energy surrounds you, healing allies that end their turn within 15 feet of you. This heals 4d8 + level hit points. This doesn't harm undead. You can have only a single [Healing Aura] spell active at a time. This doesn't heal you.`,
            castingTime: "full-round",
            range: "personal",
            area: "15-foot emination",
            effect: "",
            targets: "you",
            duration: "1 round/2 levels",
            savingThrow: "",
            spellResistance: "yes",
            components: "S, DF,",
        },
        {
            level: "8",
            name: "Halo",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `[Healing Aura] Positive energy surrounds you, healing allies that end their turn within 20 feet of you. This heals 6d8 + level hit points. This can harm undead, however they recieve if +4 bonus on the will saving throw, and if they succeed the save by 8, they take no damage. You can have only a single [Healing Aura] spell active at a time. This heals at 1/4 the normal rate.`,
            castingTime: "full-round",
            range: "personal",
            area: "20-foot emination",
            effect: "",
            targets: "you",
            duration: "1 round/2 levels",
            savingThrow: "",
            spellResistance: "yes",
            components: "S, DF,",
        },
        {
            level: "5",
            name: "Divine Comet",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `You fire a divine comet in a straight line a distance up to close range. Any creature the comet passes through is healed for 1d8+3 per 3 caster levels, and they gain 1d8 + level temporary hit points that last 1 rounds/4 caster levels. Undead instead suffer 1d8+3 damage per 3 caster levels. A creature can make a reflex saving throw to negate the healing/damage.`,
            castingTime: "1 standard action",
            range: "close (25ft. + 5ft./2 levels)",
            area: "",
            effect: "",
            targets: "",
            duration: "instantaneous and 1 round/4 levels",
            savingThrow: "reflex negates",
            spellResistance: "yes",
            components: "S, DF,",
        },
        {
        level: "4",
        name: "Cure Light Wounds, Mass",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You channel positive energy to cure 1d8 points of damage + 2 points per caster level (maximum +25) on each selected creature. Like other cure spells, mass cure light wounds deals damage to undead in its area rather than curing them. Each affected undead may attempt a Will save for half damage.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "instantaneous",
        savingThrow: "Will half (harmless) or Will half; see text",
        spellResistance: "yes (harmless) or yes; see text",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Pillar Of Life",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: ["light"],
        longDesc: `You conjure a pillar of positive energy in a single 5-foot square within range that radiates light as if it were a sunrod. Living creatures adjacent to the pillar can spend a standard action to touch the pillar and heal 5d8 points of damage + 1 point per caster level (maximum +20). Creatures can move into the square containing the pillar, but if an undead creature moves into the pillar it takes 1d6 points of damage per caster level (maximum 10d6). Undead creatures vulnerable to bright light take 1d8 points if damage per caster level (maximum 10d8). A creature cannot benefit or suffer more than once from a single casting of this spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "5-ft.-square pillar of positive energy, 20 ft. high",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Raise Dead",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You restore life to a deceased creature. The subject's soul must be free and willing to return. Coming back from the dead is an ordeal, the subject of the spell gains two permanent negative levels when it is raised, just as if it had been hit by an energy-draining creature. If the subject is 1st level, it takes 2 points of Constitution drain instead (if this would reduce its Con to 0 or less, it can't be raised). A character returns with half of the spell points they had when they died. A raised creature has a number of hit points equal to its current HD. Any ability scores damaged to 0 are raised to 1. Normal poison and normal disease are cured in the process of raising the subject, but magical diseases and curses are not undone. While the spell closes mortal wounds and repairs lethal damage of most kinds, the body of the creature to be raised must be whole. Otherwise, missing parts are still missing when the creature is brought back to life. None of the dead creature's equipment or possessions are affected in any way by this spell. A creature who has been turned into an undead creature or killed by a death effect can't be raised by this spell. The spell cannot bring back a creature that has died of old age.`,
        castingTime: "1 round",
        range: "touch",
        area: "",
        effect: "",
        targets: "dead creature touched",
        duration: "instantaneous",
        savingThrow: "none; see text",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
            level: "6",
            name: "Call Home",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `You call a recently dead creature to return to life. When you cast this spell, the creature hears the call and begins to return to life, rising from the dead in 1d2+1 rounds. The subject's soul must be free and willing to return. Coming back from the dead is an ordeal, the subject of the spell gains two permanent negative levels when it is raised, just as if it had been hit by an energy-draining creature. If the subject is 1st level, it takes 2 points of Constitution drain instead (if this would reduce its Con to 0 or less, it can't be raised). A character returns with half of the spell points they had when they died. A raised creature has a number of hit points equal to its current HD. Any ability scores damaged to 0 are raised to 1. Normal poison and normal disease are cured in the process of raising the subject, but magical diseases and curses are not undone. While the spell closes mortal wounds and repairs lethal damage of most kinds, the body of the creature to be raised must be whole. Otherwise, missing parts are still missing when the creature is brought back to life. None of the dead creature's equipment or possessions are affected in any way by this spell. A creature who has been turned into an undead creature or killed by a death effect can't be raised by this spell. The spell cannot bring back a creature that has died of old age.`,
            castingTime: "full-round action",
            range: "touch",
            area: "",
            effect: "",
            targets: "dead creature touched",
            duration: "instantaneous",
            savingThrow: "none; see text",
            spellResistance: "yes (harmless)",
            components: "V, S, M,DF,",
        },
        {
        level: "5",
        name: "Air Walk, Communal",
        type: ["utility"],
        school: "transmutation",
        tags: ["air"],
        longDesc: `This spell functions like air walk, except divide the duration in 10-minute intervals among the creatures touched.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creatures touched",
        duration: "10 min./level",
        savingThrow: "none",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Calm Air",
        type: ["utility"],
        school: "abjuration",
        tags: ["air"],
        longDesc: `This spell calms the air and disperses fog, dust, and other particles. The wind force in the area is reduced in strength by one step per 4 caster levels (to a minimum wind force of light) and clouds are dispersed, although parts of nonmagical clouds that extend beyond the area are not affected. If a magical cloud or wind's point of origin is inside the area of a calm air spell, the whole effect is suppressed; otherwise, only the part inside the area is suppressed. Suppression still counts against the duration of a wind or cloud effect. Magical wind and cloud effects are suppressed only if you succeed at a caster level check (DC 11 + effect's caster level). You can move the calm air effect by concentrating as a standard action.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "cylinder (5-ft./level radius, 40 ft. high)",
        effect: "",
        targets: "",
        duration: "10 minute/level (D)",
        savingThrow: "none (object)",
        spellResistance: "no (object)",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Covetous Aura",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `Anytime a harmless (so noted by a spell's saving throw description) spell of 3rd level or lower is cast within a covetous aura's area of effect, you may choose to immediately gain the benefit of that spell as if it had also targeted you. The intended target still gains the effect of the spell. You gain the benefits of this duplicated spell only if the caster is in range of the covetous aura. You are considered the caster of the additional spell effect. If the effect allows for multiple targets other than yourself, you cannot use the stolen spell effect to target other creatures—a covetous aura only aids you. Once you choose to gain the benefit of another spell, the covetous aura immediately ends.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "25-ft.-radius emanation centered on you",
        effect: "",
        targets: "",
        duration: "1 round/level or until discharged",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Damnation Stride",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: ["fire"],
        longDesc: `This spell functions like dimension door, except you leave behind a burst of fire. Choose one corner of your starting square. A 10-foot-radius burst of flame explodes from that corner the moment you leave, dealing 4d6 points of fire damage.`,
        castingTime: "1 standard action",
        range: "",
        area: "",
        effect: "",
        targets: "you (teleportation) and creatures within a 10-foot-radius burst (burst of flame) (see text)",
        duration: "instantaneous",
        savingThrow: "Reflex half, see text",
        spellResistance: "no",
        components: "V, ",
        },
        {
        level: "5",
        name: "Die for Your Master",
        type: ["utility"],
        school: "enchantment(compulsion)",
        tags: [],
        longDesc: `This spell allows a summoned creature to intercept any attack that targets you, including those that do not require attack rolls (e.g., chain lightning, hold monster, and magic missile).
                Your summon cannot intercept effects that do not affect creatures of its type (e.g., dominate person). Any individual summoned creature can only every intercept a single attack for you. If the attack deals excess damage to the summoned creatures hit points, the remaining damage is dealt to you.`,
        castingTime: "1 immediate action",
        range: "Touch",
        area: "",
        effect: "",
        targets: "A creature you summoned",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S",
        },
        {
        level: "5",
        name: "Fickle Winds",
        type: ["utility"],
        school: "transmutation",
        tags: ["air"],
        longDesc: `You create a mobile cylinder of wind encompassing every target of the spell and protecting them as wind wall, but not interfering with them in any way. For example, arrows and bolts fired at the targets are deflected upward and miss, but the targets' own arrows or bolts pass through the wall as if it were not there. A Large creature counts as 4 Medium creatures for the purpose of how many targets you can effect with the spell; a Huge creature counts as 8, a Gargantuan creature as 16, and a Colossal creature as 32. This spell has no effect within the area of a higher-level wind or weather spell.`,
        castingTime: "1 standard action",
        range: "",
        area: "",
        effect: "",
        targets: "one or more Medium creatures/level, no two of which can be more than 30 ft. apart",
        duration: "1 minute/level (D)",
        savingThrow: "none (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Flash Forward",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `You cheat the laws of time and enter into combat before reverting back to your original position. As part of the action to cast the spell, you make a charge attack against an enemy. You make this charge attack normally, accounting for terrain, obstacles, attacks of opportunity, attack rolls, and damage rolls. At the end of your charge action, you instantly teleport back to your original location as a free action. Any damage or conditions dealt by you or to you during this action are real and remain when you return to your original location.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "none (harmless)",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Foretell Failure",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `You cast this spell immediately before you would take an action that requires a d20 roll, such as a skill check, attack roll, or ability check. The action must be something you can complete in a single round. The spell magically informs you whether the action will succeed if you roll a 10 or better on the d20 roll involved. If the action would be successful under those circumstances, you must take the action. If the action would not be successful, you can take a different action.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Ghoul Army",
        type: ["utility"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `By scattering a handful of ghoul's teeth across the ground, you cause 1d4+1 ghouls led by a single ghast to rise up from the ground around you. The ghouls and their ghast leader must appear in squares adjacent to you, but after that they follow your spoken commands unerringly.
                
                        If one of the ghouls is destroyed while the spell's duration is still in effect, it bursts into a spray of rotten flesh and necromantic energy that deals 1d6 points of negative energy damage to all adjacent targets—this energy heals undead targets as typical for negative energy damage. If the ghast is destroyed in this manner, it deals twice as much negative energy damage as a ghoul. A successful Fortitude save halves the negative energy damage dealt. When this spell's duration expires, any remaining undead created by this spell crumble apart into dust and blow away without dealing any additional negative energy damage.`,
        castingTime: "1 standard action",
        range: "5 feet",
        area: "",
        effect: "1d4+1 ghouls and 1 ghast",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Fortitude half (see text)",
        spellResistance: "",
        components: "no",
        },
        {
        level: "5",
        name: "Glimpse of Truth",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `This spell functions like true seeing, except as noted above.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Globe of Tranquil Water",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `Upon casting this spell, a rippling bubble of calm water extends outward from you to a radius of 20 feet and remains centered on you when you move. The bubble blocks all natural and magical precipitation such as rain, snow, and hail (including spells such as ice storm). This bubble also pushes out any fog or mist within the area, though it does not affect temperature and can't block natural or magical lightning. All water in this radius counts as calm water for the purposes of Swim checks, and the bubble prevents sprays and blasts of mundane and magic water from striking with enough force to deal damage, move creatures or halt their movement, or perform any action that requires an attack roll or combat maneuver check. Water elementals are affected by a globe of tranquil water the same way creatures of the plant type are affected by an antiplant shell.`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "20-ft.-radius emanation, centered on you",
        effect: "",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "5",
        name: "Hostile Juxtaposition",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `You create a dimensional link to the target creature. When attacked or the subject of a spell that deals damage to you, you can spend an immediate action to cause yourself and the target creature to teleport and switch places. The target then becomes the target of the triggering attack or spell instead of you. If you fail to teleport out of the area of an effect, that effect might still affect you. If the target creature cannot fit safely into the new space without squeezing, or you try to teleport the target into an occupied space or a space it could not normally stand within, the juxtaposition fails. Further, if the target is unconscious or dead when you attempt to switch places, the juxtaposition fails. Once you have used it to teleport once, this spell is discharged.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature of your size or smaller",
        duration: "1 round/level or until discharged",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Insect Plague",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `You summon a number of swarms of wasps (one per three levels, to a maximum of six swarms at 18th level). The swarms must be summoned so that each one is adjacent to at least one other swarm (that is, the swarms must fill one contiguous area). You may summon the wasp swarms so that they share the area of other creatures. Each swarm attacks any creatures occupying its area. The swarms are stationary after being summoned, and won't pursue creatures that flee.`,
        castingTime: "1 round",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "one swarm of wasps per three levels, each of which must be adjacent to at least one other swarm",
        targets: "",
        duration: "1 min./level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Interposing Hand",
        type: ["utility"],
        school: "evocation",
        tags: ["force"],
        longDesc: `Interposing hand creates a Large magic hand that appears between you and one opponent. This floating, disembodied hand then moves to remain between the two of you, regardless of where you move or how the opponent tries to get around it, providing cover (+4 AC) for you against that opponent. Nothing can fool the hand-it sticks with the selected opponent in spite of darkness, invisibility, polymorphing, or any other attempt at hiding or disguise. The hand does not pursue an opponent, however. An interposing hand is 10 feet long and about that wide with its fingers outstretched. It has as many hit points as you do when you're undamaged, and is AC 20 (-1 size, +11 natural). It takes damage as a normal creature, but most magical effects that don't cause damage do not affect it. The hand never provokes attacks of opportunity from opponents. It cannot push through a wall of force or enter an antimagic field, but it suffers the full effect of a prismatic wall or prismatic sphere. The hand makes saving throws as its caster. Disintegrate or a successful dispel magic destroys it. Any creature weighing 2,000 pounds or less that tries to push past the hand is slowed to half its normal speed. The hand cannot reduce the speed of a creature weighing more than 2,000 pounds, but it still affects the creature's attacks. Directing the spell to a new target is a move action.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "10-ft. hand",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, F,",
        },
        {
        level: "5",
        name: "Life Bubble",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `You surround the touched creatures with a constant and moveable 1-inch shell of tolerable living conditions. This shell enables the subjects to breathe freely, even underwater or in a vacuum, as well as making them immune to harmful gases and vapors, including inhaled diseases and poisons and spells like cloudkill and stinking cloud. In addition, the shell protects subjects from extremes of temperature (per endure elements) as well as extremes of pressure. Life bubble does not provide protection from negative or positive energy (such as found on the Negative and Positive Energy planes), the ability to see in conditions of poor visibility (such as in smoke or fog), nor the ability to move or act normally in conditions that impede movement (such as underwater). When you cast this spell it has a total duration of 2 hours per caster level. You can divide this duration up in any manner you wish, not necessarily equally, between up to 1 creature per caster level.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creatures touched, up to one/level",
        duration: "2 hours/level; see text",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "5",
        name: "Master's Mutation",
        type: ["utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You can mold the ephemeral substance of the Outer Planes, mutating one summoned creature that you control to better suit your needs. Select up to two of the following abilities and grant them to the target for the spell's duration: burrow 30 feet, climb 40 feet, constrict, darkvision 90 feet, ferocity, fly 60 feet (average maneuverability), grab, jet, low-light vision, poison, rake, scent, swim 60 feet, trample, trip, or water breathing. Additionally, instead of selecting an ability, you can replace one of the target's primary natural attacks with another natural attack that deals the same amount of damage, such as replacing a Medium target's bite attack (1d6) with a gore attack (1d6). If you choose to alter a creature's natural attacks, all attacks of the chosen type are altered. A summoner can target his eidolon with this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./level)",
        area: "",
        effect: "",
        targets: "you and one summoned creature you control",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Passwall",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You create a passage through wooden, plaster, or stone walls, but not through metal or other harder materials. The passage is 10 feet deep plus an additional 5 feet deep per three caster levels above 9th (15 feet at 12th, 20 feet at 15th, and a maximum of 25 feet deep at 18th level). If the wall's thickness is more than the depth of the passage created, then a single passwall simply makes a niche or short tunnel. Several passwall spells can then form a continuing passage to breach very thick walls. When passwall ends, creatures within the passage are ejected out the nearest exit. If someone dispels the passwall or you dismiss it, creatures in the passage are ejected out the far exit, if there is one, or out the sole exit if there is only one. You can cast this as a movement action while moving to cause the passage to appear only momentarily, only long enough for you to finish your movement action, then it ends.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "5-ft.-by-8-ft. opening, 10 ft. deep plus 5 ft. deep per three additional levels",
        targets: "",
        duration: "1 hour/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Permanency",
        type: ["utility"],
        school: "universal",
        tags: [],
        longDesc: `This spell causes the duration of another spell to become permanent. It does however have some restrictions:
                    
        You can only have a single permanent spell at a time, and if you cast it when you already had a permanent spell active, that spell ends immediately, even if it would otherwise still have a remaining duration. 
                    
        If this spell is cast on a spell currently affecting a creature, that creature must be willing for the spell to become permanent, unless it was a spell that targeted an unattended object or an area.
                    
        The spell must have a duration longer than 1 round per 2 caster levels.
                    
        Permanent spells can still be dispelled as normal.
                    
        If it was a spell that targeted multiple creatures, the spell is only permanent on one creature.
                    
        Spells that are permanent last through floors.
                    
        
        Unlike most spells in the Akashic Paths, this spell has a real material component, and casting it costs 10 gold per the level of the spell you want to become permanent.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "",
        duration: "permanent",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "5",
        name: "Persistent Image",
        type: ["utility"],
        school: "illusion(figment)",
        tags: [],
        longDesc: `This spell functions like silent image, except that the figment includes visual, auditory, olfactory, and thermal components, and the figment follows a script determined by you. The figment follows that script without your having to concentrate on it. The illusion can include intelligible speech if you wish.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "visual figment that cannot extend beyond four 10-ft. cubes + one 10-ft. cube/level (S)",
        targets: "",
        duration: "1 min./level",
        savingThrow: "Will disbelief (if interacted with)",
        spellResistance: "no",
        components: "V, S, F,",
        },
        {
        level: "5",
        name: "Phase Door",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `This spell creates an ethereal passage on a wall or the ground. The phase door is invisible to all creatures except you, though any creature you allow may enter it. You disappear when you enter the phase door and appear when you exit. All phase doors on the map are linked together by an ethereal network, allowing you to step into one phase door and out another, no matter the distance only consuming 5 feet of movement. Creatures may also remain inside of the phase door, but they must leave by the end of their next turn or be shunted out a random door. The door does not allow light, sound, or spell effects through it, nor can you see through it without using it. True seeing or similar magic reveals the presence of a phase door but does not allow its use. A phase door is subject to dispel magic. If anyone is within the passage when it is dispelled, he is harmlessly ejected out a random door just as if he were inside a passwall effect. The creatures must still physically move into the phase door and out the other, so any restrictions to movement still restrict this, and it offers no escape from things or creatures currently attached to them.`,
        castingTime: "1 movement action",
        range: "touch",
        area: "",
        effect: "ethereal 5-ft.-by-8-ft. opening",
        targets: "",
        duration: "one usage per two levels",
        savingThrow: "none",
        spellResistance: "no",
        components: "V",
        },
        {
        level: "5",
        name: "Possess Object",
        type: ["utility"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell functions as magic jar, except you transfer your mind to a single object, animating it as if using animate objects, except your mind controls the object as if it were your own body. You cannot speak or cast spells while possessing the object. Because your original body is effectively dead while under the effect of this spell, this temporarily suspends disease, poisons, and other afflictions affecting you.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one object; see text",
        duration: "1 hour/level or until you return to your body",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Prying Eyes",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `You create a number of semitangible, visible magical orbs (called 'eyes') equal to 1d4 + your caster level. These eyes move out, scout around, and return as you direct them when casting the spell. Each eye can see 120 feet (normal vision only) in all directions. While the individual eyes are quite fragile, they're small and difficult to spot. Each eye is a Fine construct, about the size of a small apple, that has 1 hit point, AC 18 (+8 bonus for its size), flies at a speed of 30 feet with a +20 bonus on Fly skill checks and a +16 bonus on Stealth skill checks. It has a Perception modifier equal to your caster level (maximum +15) and is subject to illusions, darkness, fog, and any other factors that affect your ability to receive visual information about your surroundings. An eye traveling in darkness must find its way by touch. When you create the eyes, you specify instructions you want them to follow in a command of no more than 25 words. Any knowledge you possess is known by the eyes as well. In order to report their findings, the eyes must return to your hand. Each replays in your mind all it has seen during its existence. It takes an eye 1 round to replay 1 hour of recorded images. After relaying its findings, an eye disappears. If an eye ever gets more than 1 mile away from you, it instantly ceases to exist. However, your link with the eye is such that you won't know if the eye was destroyed because it wandered out of range or because of some other event. The eyes exist for up to 1 hour per caster level or until they return to you. Dispel magic can destroy eyes. Roll separately for each eye caught in an area dispel. Of course, if an eye is sent into darkness, it could hit a wall or similar obstacle and destroy itself.`,
        castingTime: "1 round",
        range: "1 mile",
        area: "",
        effect: "10 or more levitating eyes",
        targets: "",
        duration: "1 hour/level; see text",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Release The Hounds",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell summons a pack of canines that respond to the spellcaster's commands and act in perfect unison, causing them to function like a swarm. The pack uses the statistics for a winter wolf, except it loses its breath weapon, the cold subtype, and its cold special attack and gains the swarm subtype, a swarm attack that deals 3d6 points of damage, and the distraction special attack (DC 17). Whenever the pack damages an opponent with its swarm attack, it can immediately attempt a trip combat maneuver check against that creature with its trip special attack. The pack does not gain any damage reduction or immunity to damage and can be attacked by effects that target a specific number of creatures, though such attacks deal 1/4 the normal amount of damage (25%) and effects that don't deal hit point damage are only 25% likely to work.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one pack of canines",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "5",
        name: "Ride The Current",
        type: ["utility"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You cast this while casting another spell that deals electricity damage, you turn into electricity and travel through the effect of the spell as if teleporting, and re-appearing adjacent to any creature that took electricity damage from the spell, or along its area of effect within range.`,
        castingTime: "1 swift action",
        range: "100ft +10ft/level",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Snake Staff",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `With a long hissing whisper, you transform ordinary pieces of wood into various sorts of snakes that immediately attack your foes. As long as the snakes remain within sight, you can direct their actions telepathically as a free action. You can only apply this spell to wooden objects not in a creature's possession or not part of a larger structure or plant. Each time you cast this spell you can create a number of snakes equal to your caster level. More powerful snakes take up more than one of your available total, as noted below. Venomous Snake: A stick or piece of firewood. Counts as 1 snake. Constrictor Snake: A staff or tree branch. Counts as 2 snakes. Advanced Venomous Snake: A stick or piece of firewood. Counts as 2 snakes. Advanced Constrictor Snake: A staff or tree branch. Counts as 3 snakes. Advanced Giant Venomous Snake: A log or pile of debris. Counts as 4 snakes. Advanced Giant Constrictor Snake: A fallen tree or a large pile of debris. Counts as 5 snakes.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "1 or more pieces of wood, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Spellsteal",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `You create a discordant blast of energy that disrupts the target's available magic and transfers knowledge of that magic to you. If the target prepares spells, it must choose one of its prepared 3rd-level spells, which is immediately lost. If the target has no 3rd-level spells prepared, it loses a 2nd-level spell it has prepared. This progresses down to a 1st-level spell if the target has no 2nd-level spells prepared, and this spell has no effect if the target also has no 1st-level spells prepared. If the spell is on your spell list, you can cast this lost spell (using your caster level) on your next turn. If the target is a spontaneous spellcaster, it loses one of its available 3rd-level spell slots. If the target has no available 3rd-level spell slots, it must lose a 2nd-level spell slot (progressing as above). Randomly select one of the target's spells known of that spell level; if that spell is on your spell list, you can cast it (using your caster level) on your next turn. You must provide any focus or material components to cast the stolen spell. If the target has more than one spellcasting class, choose one at random to be affected. This spell has no effect on spell-like abilities. Any spell or spell slot lost because of this spell is treated as if the caster had failed a concentration check while trying to cast-the spell or spell slot is wasted and has no effect, but it is recovered normally the next time the character prepares spells or regains spell slots.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous and see text",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Summon Infernal Host",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: ["evil", "lawful"],
        longDesc: `This spell functions as summon monster V, save that it can only be used to summon host devils. These noxious flying devils, known also as gaavs and magaavs.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "1d4+1 lesser host devils or 1 greater host devil",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Summon Lesser Psychopomp",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions like summon monster, except that it summons 1d3 esobok psychopomps or 1d4+1 nosoi psychopomps.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one or more summoned psychopomps (see text)",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Summon Monster V",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell summons an extraplanar creature (typically an outsider, elemental, or magical beast native to another plane). It appears where you designate and acts immediately, on your turn. It attacks your opponents to the best of its ability. If you can communicate with the creature, you can direct it not to attack, to attack particular enemies, or to perform other actions. The spell conjures one of the creatures from the level on Table from: https://www.d20pfsrd.com/magic/all-spells/s/summon-monster/ of the level equal to the level of this spell. Alternatively you can choose to summon 1d3 creatures from the list 1 level below, or 1d4+1 creatures from a list at least 2 levels lower. You choose which kind of creature to summon (one type of creature at a time if you are summoning multiple) but can only summon creatures from the core list (not alternative options), and you can choose a different one each time you cast the spell. A summoned monster cannot summon or otherwise conjure another creature, nor can it use any teleportation or planar travel abilities. Creatures cannot be summoned into an environment that cannot support them. Creatures summoned using this spell cannot use spells or spell-like abilities that duplicate spells with expensive material components (such as wish). When you use a summoning spell to summon a creature with an alignment or elemental subtype, it is a spell of that type. Creatures marked with an "*" are summoned with the celestial template, if you are good, and the fiendish template, if you are evil. If you are neutral, you may choose which template to apply to the creature. Creatures marked with an "*" always have an alignment that matches yours, regardless of their usual alignment. Summoning these creatures makes the summoning spell's type match your alignment.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, F,DF,",
        },
        {
        level: "5",
        name: "Summon Nature's Ally V",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions like summon nature's ally I, except that you can summon one 5th-level creature, 1d3 4th-level creatures of the same kind, or 1d4+1 lower-level creatures of the same kind.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "5",
        name: "Teleport",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `This spell instantly transports you to a designated destination. You can bring along objects as long as their weight doesn't exceed your maximum load. You may also bring one additional willing Medium or smaller creature (carrying gear or objects up to its maximum load) or its equivalent per three caster levels. A Large creature counts as two Medium creatures, a Huge creature counts as four Medium creatures, and so forth. All creatures to be transported must be in contact with one another, and at least one of those creatures must be in contact with you. Only objects held or in use (attended) by another person receive saving throws and spell resistance. If you are attempting to teleport to a part of the map you have not seen before you must roll a % mishap chance, if you roll below 10% you are teleported to a random square on the map and take 1d10 points of damage (roll 1dwidth of map and 1dheight of map). If there is not enough space in the random square you take an additional 1d10 damage and roll again, continue until they teleport to a square with enough space. If you are travelling with others they all teleport adjacent, unless there isn't enough space, in which case they continue rolling random locations individually until they find a safe square.`,
        castingTime: "1 standard action",
        range: "personal and touch",
        area: "",
        effect: "",
        targets: "you and touched objects or other touched willing creatures",
        duration: "instantaneous",
        savingThrow: "none and Will negates (object)",
        spellResistance: "no and yes (object)",
        components: "V",
        },
        {
        level: "5",
        name: "Wall of Force",
        type: ["utility"],
        school: "evocation",
        tags: ["force"],
        longDesc: `A wall of force creates an invisible wall of pure force. The wall cannot move and is not easily destroyed. A wall of force is immune to dispel magic, although a mage's disjunction can still dispel it. A wall of force can be damaged by spells as normal, except for disintegrate, which automatically destroys it. It can be damaged by weapons and supernatural abilities, but a wall of force has hardness 30 and a number of hit points equal to 20 per caster level. Contact with a sphere of annihilation or rod of cancellation instantly destroys a wall of force. Breath weapons and spells cannot pass through a wall of force in either direction, although dimension door, teleport, and similar effects can bypass the barrier. It blocks ethereal creatures as well as material ones (though ethereal creatures can usually circumvent the wall by going around it, through material floors and ceilings). Gaze attacks can operate through a wall of force. The caster can form the wall into a flat, vertical plane whose area is up to one 10-foot square per level. The wall must be continuous and unbroken when formed. If its surface is broken by any object or creature, the spell fails.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "wall whose area is up to one 10-ft. square/level",
        targets: "",
        duration: "1 round /level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Wall of Light",
        type: ["utility"],
        school: "evocation",
        tags: ["light"],
        longDesc: `An immobile, blinding curtain of white light that blocks line of sight springs into existence. The wall sheds bright light to a range of 60 feet in all directions. A creature adjacent to the wall is blinded as long as it remains adjacent plus an additional 1d4 rounds thereafter-closing its eyes or succeeding at a Fortitude save negates the effect for 1 round. A creature that passes through the wall is automatically blinded, even if its eyes are closed. A creature from the Plane of Shadow gains 1d4 negative levels each round it spends within 5 feet of the wall (Fortitude negates). Passing through the wall imposes a -4 penalty on the save for that round. Twenty-four hours after gaining these negative levels, the subject must attempt a new Fortitude saving throw for each negative level. If a save succeeds, 1 negative level is removed. If it fails, the negative level becomes permanent. Wall of light can be made permanent with permanency (with a minimum caster level of 13th and cost of 11,000 gp).`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "10-ft.-high vertical sheet of light up to 5 ft. long/level",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "Fortitude partial, see text",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "5",
        name: "Wall of Sound",
        type: ["utility"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `A translucent barrier of pure sound springs into existence. This wall is silent except for a faint hum, but bursts with discordant noise when touched by an object or creature. The wall deflects arrows, bolts, loose debris, and Small or smaller flying creatures like a wind wall spell, except these things rebound harmlessly rather than being directed upward. The burst of discordant noise deals 2d4 points of sonic damage to creatures within 10 feet of the triggering object or creature; touching or passing through the wall deals 2d6 points of sonic damage + 1 point of sonic damage per caster level (maximum +20). If you evoke the wall so that it appears where creatures are, each creature takes damage as if passing through the wall. A silence spell suppresses the wall within its area, but the wall reappears when the silence ends.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "translucent wall of sound up to 20 ft. long/level or a ring of sound with a radius of up to 5 ft./two levels; either form 20 ft. high",
        targets: "",
        duration: "concentration + 1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Wall of Stone",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: ["earth"],
        longDesc: `This spell creates a wall of rock that merges into adjoining rock surfaces. A wall of stone is 1 inch thick per four caster levels and composed of up to one 5-foot square per level. You can double the wall's area by halving its thickness. The wall cannot be conjured so that it occupies the same space as a creature or another object. Unlike a wall of iron, you can create a wall of stone in almost any shape you desire. The wall created need not be vertical, nor rest upon any firm foundation; however, it must merge with and be solidly supported by existing stone. It can be used to bridge a chasm, for instance, or as a ramp. For this use, if the span is more than 20 feet, the wall must be arched and buttressed. This requirement reduces the spell's area by half. The wall can be crudely shaped to allow crenellations, battlements, and so forth by likewise reducing the area. Like any other stone wall, this one can be destroyed by a disintegrate spell or by normal means such as breaking and chipping. Each 5-foot square of the wall has hardness 8 and 15 hit points per inch of thickness. A section of wall whose hit points drop to 0 is breached. If a creature tries to break through the wall with a single attack, the DC for the Strength check is 20 + 2 per inch of thickness. It is possible, but difficult, to trap mobile opponents within or under a wall of stone, provided the wall is shaped so it can hold the creatures. Creatures can avoid entrapment with successful Reflex saves.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "stone wall whose area is up to one 5-ft. square/level (S)",
        targets: "",
        duration: "instantaneous",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "5",
        name: "Dispel Balance",
        type: ["utility", "buff"],
        school: "abjuration",
        tags: [],
        longDesc: `Pulsing bronze energy surrounds you, bestowing three effects. First, you gain a +3 deflection bonus to AC against attacks by chaotic neutral, lawful neutral, neutral evil, and neutral good creatures. Against attacks by creatures whose alignment is neutral with no other alignment components, this deflection bonus is instead +5. Second, upon making a successful melee touch attack against a creature from another plane with a neutral component to its alignment, you can banish that creature back to its home plane. The creature's spell resistance applies to this attempt, and the creature can negate this effect with a successful Will save. If the creature's alignment is neutral with no other alignment components, the creature takes a -2 penalty on this saving throw. This use discharges and ends the spell. Third, with a touch, you can automatically dispel any one enchantment spell cast by a creature with a neutral component to its alignment. Spells that can't be dispelled by dispel magic also can't be dispelled by dispel balance. Saving Throws and spell resistance do not apply to this effect. This use discharges and ends the spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "you and a touched, neutral creature from another plane, or you and an enchantment on a touched creature or object",
        duration: "1 round/level or until discharged, whichever comes first",
        savingThrow: "see text",
        spellResistance: "see text",
        components: "V, S, DF,",
        },
        {
        level: "5",
        name: "Echolocation",
        type: ["utility", "buff"],
        school: "transmutation",
        tags: ["sonic"],
        longDesc: `You can perceive the world by creating high-pitched noises and listening to their echoes. This gives you blindsight to a range of 40 feet. The echo-producing noises are too highpitched to be heard by most creatures, and can only be detected by dragons, other creatures with this ability (such as bats), and creatures with hearing-based blindsense or blindsight. You cannot use this ability if you are deaf, and cannot detect anything in an area of silence.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 minutes/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, ",
        },
        {
        level: "5",
        name: "Elemental Body II",
        type: ["utility", "buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as elemental body I, except that it also allows you to assume the form of a Medium air, earth, fire, or water elemental. The abilities you gain depend upon the elemental. Air elemental: As elemental body I except that you gain a +4 size bonus to your Dexterity and a +3 natural armor bonus. Earth elemental: As elemental body I except that you gain a +4 size bonus to your Strength and a +5 natural armor bonus. Fire elemental: As elemental body I except that you gain a +4 size bonus to your Dexterity and a +3 natural armor bonus. Water elemental: As elemental body I except that you gain a +4 size bonus to your Constitution and a +5 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Ooze Form I",
        type: ["utility", "buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You assume the form of a Small or Medium ooze. Regardless of the type of ooze you transform into, you gain base speed 10 feet, climb speed 10 feet, swim speed 20 feet, and blindsense 30 feet. You gain a +4 resistance bonus on saving throws against mindaffecting effects and poison. A wood or metal weapon that strikes you takes acid damage as if from your slam unless the wielder succeeds at a Reflex saving throw. Small Ooze: If you assume this form, you gain a +4 size bonus to your Constitution score, a slam attack (1d3 plus 1d3 acid), and constrict (1d3), and take , a -4 penalty to your Dexterity score. Medium Ooze: If you assume this form, you gain a +6 size bonus to your Constitution score, a -6 penalty to your Dexterity score, a slam attack (1d4 plus 1d4 acid), and constrict (1d4).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Symbol Of Pain",
        type: ["utility", "control"],
        school: "necromancy",
        tags: ["evil", "pain"],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to attempt to wrack creatures within 15 feet of the rune with intense pain for 1 round/level. Creatures in pain take a -4 penalty to attack rolls, skill checks, and ability checks. It can continue being triggered until it has attempted to wrack an amount of creatures up to your level times, or activated 5 times. When it activates it activates in a burst, affecting the closest creatures first. A creature may make a fortitude save to negate the effect. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 15 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 15 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Symbol of Sleep",
        type: ["utility", "control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to attempt to cause all creatures within 15 feet of the rune to fall asleep. It can continue being triggered until it has targeted creatures equal to your level, or been activated 5 times. When it activates it activates in a burst, affecting the closest creatures first. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 15 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 15 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "will save",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Bladed Dash, Greater",
        type: ["utility", "damage"],
        school: "transmutation",
        tags: [],
        longDesc: `When you cast this spell, you immediately move up to 30 feet in a straight line any direction, momentarily leaving a multi-hued cascade of images behind you. This movement does not provoke attacks of opportunity. You may make a single melee attack at your highest base attack bonus against every creature you are adjacent to at any point along this 30 feet. You cannot attack a single creature more than once with this attack. You gain a circumstance bonus on your attack roll equal to your highest mental stat. You must end the bonus movement granted by this spell in an unoccupied square. If no such space is available along the trajectory, the spell fails. Despite the name, the spell works with any melee weapon.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "You",
        duration: "instantaneous",
        savingThrow: "None",
        spellResistance: "",
        components: "V, ",
        },
        {
        level: "5",
        name: "Sonic Thrust",
        type: ["utility", "damage"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `You produce a sweeping rush of sound that can hurl creatures or objects away from you, like the violent thrust version of telekinesis. You can hurl one object or creature per caster level (maximum 15) that is within range; it flies in a straight line away from you. Any objects of creatures thrown must be within 10 feet of each other. You can hurl a total weight of up to 25 pounds per caster level (maximum 375 pounds at 15th level).
                        You can use this spell to hurl an object or creature toward a particular target. You must succeed on attack rolls (one per creature or object thrown) to hit the target with the items, using your base attack bonus + highest mental stat. Hurled weapons cause standard damage (with no Strength bonus; note that arrows or bolts deal damage as daggers of their size when used in this manner). Other objects cause damage ranging from 1 point per 25 pounds (for less dangerous objects) to 1d6 points of damage per 25 pounds (for hard, dense objects). Objects and creatures that miss their target land in a square adjacent to the target.
                        Creatures that fall within the weight capacity of the spell can be hurled, but they are allowed Will saves (and spell resistance) to negate the effect, as are those whose held possessions are targeted by the spell.
                        If a hurled creature is thrown against a solid surface, it takes damage as if it had fallen 10 feet (1d6 points).`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "see text",
        duration: "instantaneous",
        savingThrow: "Will negates (object) or none (see text)",
        spellResistance: "yes (object) (see text)",
        components: "V, S, ",
        },
        {
        level: "5",
        name: "Symbol of Striking",
        type: ["utility", "damage"],
        school: "illusion(shadow)",
        tags: [],
        longDesc: `You inscribe a rune on a square adjacent to you, when you do you choose a melee weapon you have as its focus, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to attack all creatures within 10 feet of the rune. These attacks are made using your highest mental modifier and your caster level, and any enchantments on the weapon when it was used as the focus for this spell, and deals its damage dice plus 1.5x your highest mental modifier, plus any enchantment. It can continue being triggered until it has attacked creatures equal to your level, or been activated 5 times. When it activates it activates in a burst, affecting the closest creatures first. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 15 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 10 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Unholy Ice",
        type: ["utility", "damage"],
        school: "transmutation",
        tags: ["cold", "evil", "water"],
        longDesc: `This spell creates a large mass of frozen unholy water that can be used for one of two effects: Holy Ice Wall: This functions like wall of ice (hemisphere or plane). Any creature that takes damage from holy water takes 1 point of damage every time it touches or attacks the ice wall with melee attacks; extended contact with the wall (such as standing or walking on it) deals 1d6 points of damage. Even when the ice has been broken through, a sheet of frigid holy air remains. Any creature that steps through it (including the one who broke through the wall) takes 1d6 points of damage + 1 point per caster level (no save); half of this damage is cold damage, half is damage from holy water (creatures unharmed by holy water do not take the damage).
        
                Holy Ice Javelins: The spell creates a number of javelins of frozen holy water in your square equal to your caster level (maximum 15), which hurl themselves toward one or more targets that are no more than 10 feet away from each other. You must succeed on attack rolls (one per javelin) to hit the target with the javelin, using your base attack bonus + highest mental modifier. The javelins deal 1d6 damage each, plus 1 point of cold damage and 1 point of damage from holy water. The javelins are destroyed by this attack.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "wall of ice or flying ice javelins (see text)",
        targets: "",
        duration: "1 minute/level, instantaneous, or until expended (see text)",
        savingThrow: "Reflex negates or none (see text)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "5",
        name: "Spell Absorption",
        type: ["utility", "healing"],
        school: "abjuration",
        tags: [],
        longDesc: `If you successfully counterspell a 3rd-level or lower level spell (through either dispel magic or normal means) while spell absorption is in effect, you absorb the countered spell and use it to regain spell points equal to 2x the level of the spell countered.`,
        castingTime: "1 round",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Battlemind Link",
        type: ["buff"],
        school: "divination",
        tags: ["mind-affecting"],
        longDesc: `You fuse your thoughts with an ally's, allowing the two of you to fight in tandem, perfectly coordinated. You and the ally each roll initiative in combat and use the higher die result before adding modifiers. This has three effects. Attack: If you both make attacks against the same creature, you both make attack rolls and both use the higher of the two dice for your attack rolls (plus bonuses) (your attacks must be of the same kind, melee/ranged). Spell: If you both cast spells and target the same area or same creature, affected creatures take a -2 penalty on their saving throw against the spells. You and the target lose these benefits if you cannot see each other or if you or the target is unconscious or helpless.`,
        castingTime: "1 standard action",
        range: "personal and close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "you and 1 ally",
        duration: "1 minute/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Bear's Endurance, Mass",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `Mass bear's endurance works like bear's endurance, except that it affects multiple creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "creature one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Borrowed Time",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell allows you to reach ahead in time and draw alacrity from the future at the expense of your own health. For the duration of this spell, you gain an extra swift action you can use only during your turn. You can't use this swift action to take a second immediate action between turns, but you can use it to take a swift action the turn after you've taken an immediate action. Each time you take an extra swift action in this fashion you take 1 point of Constitution damage. If you're immune to ability damage, you take 10 points of hit point damage instead.
                
        When the spell ends, you are staggered for 1d4+1 rounds from the temporal backlash.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Bull's Strength, Mass",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell functions like bull's strength, except that it affects multiple creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Cat's Grace, Mass",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell functions like cat's grace, except that it affects multiple creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Deadly Weapons",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument] The touched weapon becomes incredibly deadly, the weapon deals bonus damage equal to the weapons base damage dice (unmodified by other abilities, spells, or modifiers, except for size modifiers), so a greatsword deals 2d6 extra damage. This damage is not multiplied on critical hits. This bonus damage does not modify other abilities such as vital strike, it instead would be added to the total, so vital strike on a deadly greatsword deals 6d6 damage. A weapon can have only a single imbument at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 weapon",
        duration: "1 round/3 levels",
        savingThrow: "will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "6",
        name: "Defending Sword",
        type: ["buff"],
        school: "evocation",
        tags: ["force"],
        longDesc: `You create a sword of force that functions as mage's sword except as described here. The sword does not receive the additional +3 enhancement bonus a mage's sword receives, and deals 3d6 points of force damage. You cannot command the sword. Until the sword is triggered, it hovers in your space without interfering with your actions. While hovering in this way, the sword attempts to defend you from incoming attacks, granting you a +4 shield bonus to your AC. The first time a foe within close range damages you or forces you to attempt a saving throw that you fail, the sword is triggered and begins attacking that target as described in mage's sword for the duration of the spell. This ends the shield bonus. You cannot direct the sword to defend against a new target once it has begun to attack. If its target moves beyond the sword's range, the sword returns to you and hovers until the target is again within range. The sword's return does not restore the spell's shield bonus to AC.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, F",
        },
        {
        level: "6",
        name: "Dimensional Blade",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument] This spell gives you the power to turn one melee weapon in your hand into a two-dimensional object with length and height but no width. A sword becomes a flat image of a sword, a mace is reduced to a flat outline, and so on. The magic of the spell allows the weapon to be wielded by you normally, creating just enough depth to grasp it. Attacks made with the weapon are melee touch attacks that ignore all armor. Force effects, such as mage armor and shield, still apply their AC against attacks made with a dimensional blade. Bludgeoning weapons used to make attacks with this spell deal half damage and are treated as slashing weapons. If the weapon leaves your hand before the end of the spell, the effect ends. A weapon can have only a single imbument at a time.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "6",
        name: "Dust Form",
        type: ["buff"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `Upon casting this spell, you keep your relative form, but you and your equipment become composed entirely of dust. While in this dust form, you take no penalties for squeezing, and can move through spaces as if you were a creature three size categories smaller without penalty. You are also considered incorporeal, though any nonmagical attack you make deals half damage (50%). Magic attacks are unaffected, and you can still use your magic items and other equipment as normal. If the duration ends in a square that your normal space cannot occupy, you take 3d6 damage and are shunted to the nearest open space that you can normally occupy.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Eagle's Splendor, Mass",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell functions like eagle's splendor, except that it affects multiple creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "One creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Eaglesoul",
        type: ["buff"],
        school: "conjuration(summoning)",
        tags: ["good"],
        longDesc: `When you cast this spell, you beseech a good-aligned outsider for their aid against evil. The outsider infuses a small portion of its own power into you, making you a powerful force for good. You gain a +2 morale bonus on all Perception checks made against evil creatures, a +2 bonus on Initiative checks, and detect evil as a constant spell-like ability.                        
                        
        A +2 sacred bonus to AC
        A +4 sacred bonus to Strength
        Resistance 5 to acid and fire
        A +5 sacred bonus on all Intimidate checks made against evil creatures
        Fast healing 2
        Any critical threat roll made against an evil creature with a weapon you wield is automatically confirmed.
                        
        This spell can be cast by evil spellcasters and instead becomes ravensoul and grants the bonuses against good creatures and the bonuses become profane bonuses. Neutral casters cannot cast this spell.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V,S,M",
        },
        {
        level: "6",
        name: "Emblem of Greed",
        type: ["buff"],
        school: "transmutation(polymorph)",
        tags: ["imbument"],
        longDesc: `[imbument] You transform one melee weapon into a burning glaive. The target of your spell must be a melee weapon appropriate to your size. The weapon gains +1 enhancement bonus and the flaming weapon special ability. When wielding it, you can use your caster level with buff spells as your base attack bonus (which may give you multiple attacks). When you reach caster level 14th, the glaive gains the spell-storing weapon special ability. When you reach caster level 17th, it loses the flaming weapon special ability, and gains the flaming burst weapon special ability. The glaive's enhancement bonus increases to +2 at caster level 15th, and +3 at caster level 19th. A weapon can have only a single imbument at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 melee weapon touched",
        duration: "1 minute/level",
        savingThrow: "none (object)",
        spellResistance: "no",
        components: "V, S, M,",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "6",
        name: "Fox's Cunning, Mass",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell functions like fox's cunning, granting a +4 enhancement bonus to intelligence, except that it affects multiple creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Heroism, Greater",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell functions like heroism, except the creature gains a +4 morale bonus on attack rolls, saves, and skill checks, immunity to fear effects, and temporary hit points equal to your caster level (maximum 20).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Invoke Deity",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `By holding aloft a holy symbol and calling your deity's name, you take on an aspect of that divinity. When you cast this spell, choose a domain, and you gain that domain's benefits from the list below, along with the listed physical changes; abilities that allow a saving throw use this spell's DC. At any point during the duration of this spell, you can change which domain benefit you gain by concentrating for 1 round-this provokes attacks of opportunity and reduces the remaining duration of the spell by 10 minutes. If you have less than 10 minutes of the spell's duration remaining, you cannot change the selected domain in this way. If you change your domain, all ongoing effects from your previously chosen domain end. Invoke deity has the same alignment descriptors ([chaotic], [evil], [good], or [lawful]) as you. If an ability duplicates a spell, it functions as that spell heightened to a level equal to your invoke deity spell. 
        \nAir: You gain a fly speed of 60 feet with perfect maneuverability, or you increase your current fly speed by 30 feet-whichever results in a faster speed. While flying, you gain a +1 dodge bonus to your AC. 
        \nAnimal: You gain low-light vision, scent, a +6 natural armor bonus, and a bite attack that deals damage as normal for a creature of your size. If you already have a bite attack, the damage increases as if you increased one size category. You can use speak with animals at will. 
        \nArtifice: You can be affected by spells that specifically affect constructs (such as make whole). You are immune to bleed, disease, and poison effects, and you gain a +4 bonus on saving throws against death effects, mind-affecting effects, and necromancy effects. 
        \nChaos: You are immune to additional damage from critical hits and precision damage (such as sneak attack damage), and weapons you wield count as chaotic for the purpose of overcoming damage reduction. 
        \nCharm: You gain a +6 enhancement bonus to Charisma.         
        \nCommunity: Increase any flat numerical bonuses you gain from teamwork feats as long as another creature is involved, and increase the bonuses you give and gain from aid another by +2. 
        \nDarkness: You become immune to blindness and can see perfectly in darkness of any kind, even that created by a deeper darkness spell. 
        \nDeath: You are healed by both positive and negative energy, are immune to energy drain and death effects, and automatically stabilize when reduced below 0 hit points. 
        \nDestruction: You gain a +2 bonus on damage rolls with two-handed melee weapons. Spells you cast that cause hit point damage have their save DCs (if any) increased by 1. You gain a +4 bonus on Strength checks to break objects, and you ignore the first 5 points of hardness any object has when you attack it with a melee weapon. 
        \nEarth: You gain DR 10/bludgeoning and are immune to petrification effects. 
        \nEvil: You automatically confirm critical hits, and weapons you wield count as evil for the purpose of overcoming damage reduction. 
        \nFire: You are immune to fire. As a swift action once per 1d6 rounds, you can fire a ray of flame, as per scorching ray (limit one ray at a time). 
        \nGlory: You gain the benefits of heroism and protection from evil, and your first successful attack each round against an undead target deals an additional 1d6 points of positive energy damage. 
        \nGood: You are immune to fear and compulsion effects, and weapons you wield count as good for the purpose of overcoming damage reduction. 
        \nHealing: You gain fast healing 3, and your spells and class features that restore hit points each restore an additional 1d8 hit points. 
        \nKnowledge: You gain a +6 enhancement bonus to Intelligence. 
        \nLaw: You are immune to hostile transmutation effects and all confusion effects, and weapons you wield count as lawful for the purpose of overcoming damage reduction. 
        \nLiberation: You gain a +6 enhancement bonus to Dexterity. 
        \nLuck: You gain a +1 luck bonus to your Armor Class and on attack rolls, ability checks, saving throws, and skill checks. As an immediate action, you can force a single creature within 10 feet to reroll a single d20 it just rolled-you must use this ability before the results of the d20 roll are known. Each time you use this ability, the remaining duration of invoke deity decreases by 10 minutes, and you can't use this ability if you have less than 10 minutes remaining of the spell's duration. 
        \nMadness: As a standard action, you can inflict madness on a creature within 30 feet; that creature must succeed at a Will save or become confused for 1d4 rounds. You cannot target a creature more than once every 1d6 rounds with this effect. 
        \nMagic: You gain spell resistance equal to 11 + your caster level against hostile spells. 
        \nNobility: As a move action, you can issue one order to a single creature within 30 feet. This effect functions as if you had cast the spell command. 
        \nPlant: You become immune to paralysis, poison, polymorph effects, sleep effects, and stunning. 
        \nProtection: Select three of the following spells: delay poison, false life, mage armor, protection from chaos, protection from evil, protection from good, protection from law, resist energy, shield, or shield of faith; you gain the protective benefits of those spells. 
        \nRepose: You gain a +6 enhancement bonus to Wisdom. 
        \nRune: When casting another spell you can subtract 30 minutes from the duration of this spell to increase the DC of that spell by +2 (only once per spell). 
        \nScalykind: You gain a bite attack that deals damage as normal for a creature of your size; if you already have a bite attack, the damage increases as if you had increased one size category. Each creature you bite must succeed at a Fortitude save or become sickened for 1d4 rounds (or if already sickened, staggered for 1 round); this is a poison effect. 
        \nStrength: You gain a +6 enhancement bonus to Strength. 
        \nSun: You are immune to blindness, the dazzled condition, and all effects generated by powerful light (such as searing light, sunray, or the blinding light of a shining child), and you radiate light as the daylight spell. Creatures that are harmed or hindered by sunlight take a -2 penalty on attack rolls against you, and you gain a +2 bonus on saving throws against effects originating from such creatures. 
        \nTravel: You gain a +6 enhancement bonus to Constitution. 
        \nTrickery: Your first attack each round the creature is flat-footed. A creature can only be flat-footed this way once per casting of the spell. 
        \nVoid: You are immune to cold damage and no longer need to breathe. You can exist comfortably in the depths of outer space. 
        \nWar: You gain a +2 insight bonus on attack rolls with a weapon of choice (when casting the spell) and deal an additional 1d6 points of damage with it. 
        \nWater: You gain a swim speed of 40 feet, can breathe water, and ignore the usual penalties on weapon attack and damage rolls from fighting underwater. 
        \nWeather: You do not take penalties or damage or suffer from reduced visibility or other effects due to natural weather. You are immune to electricity damage, and your call lightning and call lightning storm spells and effects always function as though called outdoors in stormy weather.`,
        castingTime: "1 round",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 minutes/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Lash of the Astradaemon",
        type: ["buff"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `You draw on the essence of astradaemons to cause one of your hands to elongate and sprout fearsome translucent claws that radiate a cold phosphorescence. You gain one claw attack, which is a primary natural attack that deals 1d6 points of slashing damage on a hit (1d4 for a Small spellcaster) and forces the creature struck to succeed at a Fortitude save against the spell (spell resistance applies) to resist gaining 1 negative level.
                
                        Each time you inflict a negative level with this spell, you gain 5 temporary hit points that persist for 1 hour. A creature that succeeds at the saving throw against your claw's negative level is immune to further negative levels inflicted from this casting of lash of the astradaemon but not to the claw's damage. The claw does not interfere with your ability to cast spells or perform other actions that require hands. You can use your claw attack up to 1 time per 2 caster levels. Your claw reverts to a normal hand once you've delivered all of your potential attacks or after 24 hours (whichever comes first).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "fort negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Owl's Wisdom, Mass",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell functions like owl's wisdom, except that it affects multiple creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, M, DF",
        },
        {
        level: "6",
        name: "Planar Weapons",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument] The touched weapon gains the ability to bypass good and evil damage reduction of outsiders, and deal an additional 2d6 damage against them. If the outsider has damage reduction bypassed by good/evil and something else, this only deals 1d6 bonus damage to them. A weapon can have only a single imbument at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 weapon",
        duration: "1 round/level",
        savingThrow: "will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "6",
        name: "Transformation",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You become a fighting machine- stronger, tougher, faster, and more skilled in combat. Your mindset changes so that you relish combat and you can't cast spells, even from magic items. You gain a +4 enhancement bonus to Strength, Dexterity, and Constitution, a +4 natural armor bonus to AC, a +5 competence bonus on Fortitude saves, and +2 bonus on attacks with weapons. Your base attack bonus equals your character level (which may give you multiple attacks). You lose your spellcasting ability, including your ability to use spell activation or spell completion magic items, just as if the spells were no longer on your class list.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Primal Regression",
        type: ["buff", "control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell sequesters the targets' ability for higher reasoning, allowing their darker impulses to come to the fore. An affected target becomes a ravening monster-savage, bloodthirsty, and brutish. Until the spell ends, the targets have all of the following benefits and drawbacks. 
        • Targets' Intelligence and Charisma scores drop to 3 (if the scores were higher), and they are unable to use Intelligence-or Charisma-based skills, cast spells, understand language, or communicate coherently. 
        • Targets take a -4 penalty on Will saves. 
        • Targets gain a +6 enhancement bonus to Strength, a +2 natural armor bonus to AC, and 2d8 temporary hit points. These temporary hit points disappear at the end of the spell's duration. When the spell ends, each affected creature must succeed at a Will saving throw or take 1d4 points of Intelligence drain and 1d4 points of Charisma damage.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/2 levels, no two of which can be more than 30 feet apart",
        duration: "1 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "S, ",
        },
        {
        level: "6",
        name: "Globe of Invulnerability",
        type: ["buff", "control", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions like lesser globe of invulnerability, except that it also excludes 4th-level spells and spell-like effects.`,
        castingTime: "1 standard action",
        range: "10 ft.",
        area: "10-ft.-radius spherical emanation, centered on you",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Repulsion",
        type: ["buff", "control", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `An invisible, mobile field surrounds you and prevents creatures from approaching you. You decide how big the field is at the time of casting (to the limit your level allows). Any creature within or entering the field must attempt a save. If it fails, it becomes unable to move toward you for the duration of the spell. Repelled creatures' actions are not otherwise restricted. They can fight other creatures and can cast spells and attack you with ranged weapons. If you move closer to an affected creature, nothing happens. The creature is not forced back. The creature is free to make melee attacks against you if you come within reach. If a repelled creature moves away from you and then tries to turn back toward you, it cannot move any closer if it is still within the spell's area.`,
        castingTime: "1 standard action",
        range: "up to 10 ft./level",
        area: "up to 10-ft.-radius/level emanation centered on you",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, F,DF,",
        },
        {
        level: "6",
        name: "Beast Shape IV",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as beast shape III except that it also allows you to assume the form of a Tiny or Large creature of the magical beast type. If the form you assume has any of the following abilities, you gain the listed ability: burrow 60 feet, climb 90 feet, fly 120 feet (good maneuverability), swim 120 feet, blindsense 60 feet, darkvision 90 feet, low-light vision, scent, tremorsense 60 feet, breath weapon, constrict, ferocity, grab, jet, poison, pounce, rake, rend, roar, spikes, trample, trip, and web. If the creature has immunity or resistance to any elements, you gain resistance 20 to those elements. If the creature has vulnerability to an element, you gain that vulnerability. Diminutive animal: If the form you take is that of a Diminutive animal, you gain a +6 size bonus to your Dexterity, a -4 penalty to your Strength, and a +1 natural armor bonus. Tiny animal: If the form you take is that of a Tiny animal, you gain a +4 size bonus to your Dexterity, a -2 penalty to your Strength, and a +1 natural armor bonus. Small animal: If the form you take is that of a Small animal, you gain a +2 size bonus to your Dexterity and a +1 natural armor bonus. Medium animal: If the form you take is that of a Medium animal, you gain a +2 size bonus to your Strength and a +2 natural armor bonus. Large animal: If the form you take is that of a Large animal, you gain a +4 size bonus to your Strength, a -2 penalty to your Dexterity, and a +4 natural armor bonus. Huge animal: If the form you take is that of a Huge animal, you gain a +6 size bonus to your Strength, a -4 penalty to your Dexterity, and a +6 natural armor bonus. Tiny magical beast: If the form you take is that of a Tiny magical beast, you gain a -2 penalty to your Strength, a +8 size bonus to your Dexterity, and a +3 natural armor bonus. Small magical beast: If the form you take is that of a Small magical beast, you gain a +4 size bonus to your Dexterity, and a +2 natural armor bonus. Medium magical beast: If the form you take is that of a Medium magical beast, you gain a +4 size bonus to your Strength, and a +4 natural armor bonus. Large magical beast: If the form you take is that of a Large magical beast, you gain a +6 size bonus to your Strength, a -2 penalty on your Dexterity, a +2 size bonus to your Constitution, and a +6 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Elemental Body III",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as elemental body II, except that it also allows you to assume the form of a Large air, earth, fire, or water elemental. The abilities you gain depend upon the type of elemental into which you change. You are also immune to critical hits and sneak attacks while in elemental form. Air elemental: As elemental body I except that you gain a +2 size bonus to your Strength, +4 size bonus to your Dexterity, and a +4 natural armor bonus. Earth elemental: As elemental body I except that you gain a +6 size bonus to your Strength, a -2 penalty on your Dexterity, a +2 size bonus to your Constitution, and a +6 natural armor bonus. Fire elemental: As elemental body I except that you gain a +4 size bonus to your Dexterity, a +2 size bonus to your Constitution, and a +4 natural armor bonus. Water elemental: As elemental body I except that you gain a +2 size bonus to your Strength, a -2 penalty on your Dexterity, a +6 size bonus to your Constitution, and a +6 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Fey Form II",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as fey form I, except it also allows you to assume the form of a Tiny or Large creature of the fey type. Your base speed can't increase above 90 feet this way. If the form you assume has any of the following abilities, you gain those abilities: burrow speed 30 feet, climb speed 90 feet, fly speed 60 feet (good maneuverability), swim speed 60 feet, all-around vision, blindsense 30 feet, darkvision 60 feet, low-light vision, scent, see in darkness, abduct, animated hair, bleed, blood rage, boot stomp, burn, compression, constrict, crushing leap, DR 2/cold iron, grab, heavy weapons, icewalking, kneecapper, nasal spray, no shadow, oversized weapons, poison, putrid vomit, rock throwing (50 feet, 1d6 damage), sound mimicry, trackless step, trample, tree meld, undersized weapons, and woodland stride. If the creature has immunity to mind-affecting effects or poison, you gain a +4 resistance bonus on saves against those effects. If the creature has any weaknesses, you gain them. Tiny Fey: If you assume this form, you gain a +6 size bonus to your Dexterity score and take a -2 penalty to your Strength score. Large Fey: If you assume this form, you gain a +4 size bonus to your Strength and Constitution scores and take a -2 penalty to your Dexterity score.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Fluid Form",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: ["water"],
        longDesc: `When you cast this spell, your body takes on a slick, oily appearance. For the duration of this spell, your form can stretch and shift with ease and becomes slightly transparent, as if you were composed of liquid. This transparency is not enough to grant concealment. You gain DR 10/slashing and your reach increases by 10 feet. In addition, you can pass through small holes or narrow openings, even mere cracks, with anything you were carrying at the time the spell was cast (except other creatures). Finally, you can move through water with a swim speed of 60 feet and can breathe both water and air for the duration of this effect. You are treated as if you had the water subtype while this spell is in effect, and you cast water and cold spells at one level higher (bypassing the usual limit level damage cap), and their DC's are increased by +1.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "S, M,",
        },
        {
        level: "6",
        name: "Form of the Alien Dragon I",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You become a Medium esoteric or outer dragon. Psychics can choose from the esoteric dragon (astral, dream, etheric, nightmare, or occult) forms only. You gain a +4 size bonus to your Strength, a +2 size bonus to your Constitution, a +4 natural armor bonus, a fly speed of 60 feet (poor), darkvision with a range of 60 feet, a breath weapon, and resistance to one form of energy or effect. You also gain one bite attack (1d8), two claw attacks (1d6), and two wing attacks (1d4). Your breath weapon and resistance depend on the type of dragon. You can use the breath weapon only once per casting of this spell. All breath weapons deal 6d8 points of damage unless noted otherwise and allow a Reflex save to halve the normal damage. In addition, some of the dragon types grant additional abilities, as noted below. Astral Dragon: 30-foot cone of force (damage dice are d4s instead of d8s), psychic resilience. Dream Dragon: 30-foot cone of electricity, dream fortress, dreamsight (Bestiary 5 90). Etheric Dragon: 30-foot line of force (damage dice are d4s instead of d8s), gaseous form (only when taking no actions other than move actions for a round, and only for a maximum of 1 round/caster level for each casting of form of the alien dragon). Lunar Dragon: 60-foot line of cold, cold resistance 20, burrow 20 feet. Nightmare Dragon: 30-foot cone of acid, see in darkness, +4 on saves vs. mind-affecting effects. Occult Dragon: 30-foot cone of cold or fire, +4 resistance bonus on saving throws against evil spells and effects, natural armor bonus to AC increases to +6. Solar Dragon: 60-foot line of fire, fire resistance 30, vulnerability to cold. Time Dragon: 30-foot cone of electricity, cold resistance 20, +4 bonus on initiative checks. Void Dragon: 30-foot cone of cold, cold resistance 20, +4 bonus on saves vs. emotion spells and effects. Vortex Dragon: 30-foot cone of fire, fire resistance 30, vulnerability to cold.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Form of the Dragon I",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You become a Medium chromatic or metallic dragon. You gain a +4 size bonus to Strength, a +2 size bonus to Constitution, a +4 natural armor bonus, fly 60 feet (poor), darkvision 60 feet, a breath weapon, and resistance to one element. You also gain one bite (1d8), two claws (1d6), and two wing attacks (1d4). Your breath weapon and resistance depend on the type of dragon. You can only use the breath weapon once per casting of this spell. All breath weapons deal 6d8 points of damage and allow a Reflex save for half damage. In addition, some of the dragon types grant additional abilities, as noted below. Black dragon: 60-foot line of acid, resist acid 20, swim 60 feet Blue dragon: 60-foot line of electricity, resist electricity 20, burrow 20 feet Green dragon: 30-foot cone of acid, resist acid 20, swim 40 feet Red dragon: 30-foot cone of fire, resist fire 30, vulnerability to cold White dragon: 30-foot cone of cold, resist cold 20, swim 60 feet, vulnerability to fire Brass dragon: 60-foot line of fire, resist fire 20, burrow 30 feet, vulnerability to cold Bronze dragon: 60-foot line of electricity, resist electricity 20, swim 60 feet Copper dragon: 60-foot line of acid, resist acid 20, spider climb (always active) Gold dragon: 30-foot cone of fire, resist fire 20, swim 60 feet Silver dragon: 30-foot cone of cold, resist cold 30, vulnerability to fire`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "see below",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Form of the Exotic Dragon I",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You become a Medium imperial or primal dragon. Druids can choose from the primal dragon (brine, cloud, crystal, magma, or umbral) forms only. You gain a +4 size bonus to your Strength, a +2 size bonus to your Constitution, a +4 natural armor bonus, a fly speed of 60 feet (poor), darkvision with a range of 60 feet, a breath weapon, and either resistance to one form of energy or some other bonus. You also gain one bite attack (1d8), two claw attacks (1d6), and either a gore attack (1d8) if you assume the form of an imperial dragon or two wing attacks (1d4) if you assume the form of a primal dragon. Your breath weapon, resistance, and any other benefits you gain depend on the type of dragon. You can use the breath weapon only once per casting of this spell. All breath weapons deal 6d8 points of damage unless noted otherwise and allow a Reflex save to halve the normal damage. In addition, some of the dragon types grant additional abilities, as noted below. Brine Dragon: 60-foot line of acid, acid resistance 20, swim 60 feet. Cloud Dragon: 30-foot cone of electricity, electricity resistance 20, swim 40 feet. Crystal Dragon: 30-foot cone of sonic (damage dice are d6s instead of d8s), sonic resistance 20, climb 20 feet, burrow 20 feet. Forest Dragon: 30-foot cone of piercing, burrow 20 feet, climb 30 feet. Magma Dragon: 30-foot cone of fire, fire resistance 30, vulnerability to cold. Sea Dragon: 30-foot cone of fire, electricity resistance 20, swim 40 feet. Sky Dragon: 30-foot cone of electricity, electricity resistance 20, improve fly speed maneuverability to average. Sovereign Dragon: 30-foot cone of sonic (damage dice are d6s instead of d8s), spell resistance equal to 13 + the spell's level. Umbral Dragon: 30-foot cone of negative energy (damage dice are d6s instead of d8s; doesn't heal undead creatures), cold resistance 20, +4 on saves vs. death effects. Underworld Dragon: 30-foot cone of fire, fire resistance 20, vulnerability to cold, burrow 20 feet.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "see below",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Monstrous Physique IV",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as monstrous physique III except it allows you to use more abilities. If the form you assume has any of the following abilities, you gain the listed ability: burrow 60 feet, climb 90 feet, fly 120 feet (good maneuverability), swim 120 feet, blindsense 60 feet, darkvision 90 feet, low-light vision, scent, tremorsense 60 feet, blood frenzy, breath weapon, cold vigor, constrict, ferocity, freeze, grab, horrific appearance, jet, leap attack, mimicry, natural cunning, overwhelming, poison, pounce, rake, rend, roar, sound mimicry, speak with sharks, spikes, trample, trip, and web. If the creature has immunity or resistance to any energy types, you gain resistance 20 to those energy types. If the creature has vulnerability to an energy type, you gain that vulnerability. If the creature has immunity to poison, you gain a +8 bonus on saves against poison.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Ooze Form II",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as ooze form I except you can also assume the form of a Large ooze. You gain blindsight 30 feet and immunity to critical hits and precision damage as well. Large Ooze: If you assume this form, you gain a +2 size bonus to your Strength score, a +8 size bonus to your Constitution score, a slam attack (2d4 plus 1d6 acid and grab), and constrict (2d4), and you take a -8 penalty to your Dexterity score.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Plant Shape II",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as plant shape I except that it also allows you to assume the form of a Large creature of the plant type. If the creature has immunity or resistance to any elements, you gain resistance 20 to those elements. If the creature has vulnerability to an element, you gain that vulnerability. Large plant: If the form you take is that of a Large plant, you gain a +4 size bonus to your Strength, a +2 size bonus to your Constitution, and a +4 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Sonic Form",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: ["sonic"],
        longDesc: `Upon casting this spell, you keep your relative shape, but you and your equipment are transformed into semisolid sound. While in this sonic form, you take no penalties for squeezing, and you can move through spaces without penalty as if you were a creature three size categories smaller. You can make a melee touch attack once per round that deals 1d6 points of sonic damage + 1 point per caster level. You are considered incorporeal (although you cannot move through solid objects). Any nonmagical attacks you make deal half damage. Magical attacks are unaffected, and you can use your magic items and other equipment as normal. You cannot enter an area of silence. If you are in the area of a silence spell, you take 1d6 points of sonic damage per caster level of the silence spell in the round it is cast and in each round when you end your turn within the spell's area. You can attempt a Fortitude saving throw each round to take half damage. If this spell's duration ends when you are in a square that a creature of your size cannot normally occupy, you take 3d6 points of damage and are shunted to the nearest open space that you can normally occupy. Sonic spells you cast while in sound form have their caster level and DC increased by 1, (bypassing the usual limit level damage cap)`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
            level: "6",
            name: "Shadow Transmutation",
            type: ["buff", "utility"],
            school: "illusion (shadow)",
            tags: ["shadow"],
            longDesc: `You suffuse one subject's body with energy from the Shadow Plane, altering its form to match a creature from the Shadow Plane.
            \nShadow transmutation can mimic any of the following spells: animal growth, anthropomorphic animal, enlarge person, fins to feet, longarm, polymorph, reduce person, and stone fist.
            \nIf using shadow transmutation as polymorph, the target does not gain any sensory abilities that its new form has (such as low-light vision or darkvision) and the speed of any movement types gained from the spell cannot exceed the target's base speed or natural speed with those movement types (whichever is higher).
            \nA creature under the effects of shadow transmutation deals normal damage and has all the normal abilities and weaknesses of whatever form it assumes using the spell.
            \nAny creature that interacts with a target under the effects of the spell (including attacking or being attacked by that creature) can attempt a Will save to recognize the target's true nature. Creatures that succeed at their Will saves to disbelieve the illusion take one-fifth (20%) of the normal damage from the target's natural attacks or special abilities granted by the target's shadowy form (if any), and the target's special abilities that don't deal damage have only a 20% chance of working against them. Creatures that succeed at their saves see the shadow transmutation as transparent images superimposed over the target.`,
            castingTime: "1 standard action",
            range: "see text",
            area: "",
            effect: "",
            targets: "see text",
            duration: "1 round/level",
            savingThrow: "Will disbelief (if interacted with)",
            spellResistance: "yes; see text",
            components: "V, S",
        },
        {
        level: "6",
        name: "Undead Anatomy III",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as undead anatomy II, except it also allows you to assume the form of a Diminutive or Huge corporeal creature of the undead type. If the form you assume has any of the following abilities, you gain the listed ability: burrow 30 feet, climb 90 feet, fly 90 feet (good maneuverability), swim 90 feet, all-around vision, blindsense 30 feet, darkvision 60 feet, low-light vision, scent, constrict, disease, DR 5/-, fear aura, grab, jet, natural cunning, overwhelming, poison, pounce, rake, trample, trip, unnatural aura, and web. If the creature has immunity or resistance to any energy types, you gain resistance 20 to those energy types. If the creature has vulnerability to an energy type, you gain that vulnerability. In this form, you gain a +8 bonus on saves against mind-affecting effects, disease, poison, sleep, and stunning. If the form has a vulnerability to an attack (such as sunlight), you gain that vulnerability. Diminutive undead: If the form you take is that of a Diminutive undead, you gain a +6 size bonus to your Dexterity, a -4 penalty to your Strength, and a +1 natural armor bonus. Huge undead: If the form you take is that of a Huge undead, you gain a +6 size bonus to your Strength, a -4 penalty to your Dexterity, and a +6 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Undeath Ward",
        type: ["buff", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `You create a pale silver barrier that repels undead. Mindless undead and intelligent undead with fewer Hit Dice than your caster level cannot enter the area or penetrate the barrier. Undead of Hit Dice equal to or greater than your caster level can pass through this barrier by making a successful Will save against the spell, but as they do so, they take 3d6 points of damage. Once an undead creature makes its save again this spell and takes this damage, it can come and go without further penalty. This spell may only be used defensively, not aggressively. Forcing an undeath ward against creatures that the spell keeps at bay collapses the barrier.`,
        castingTime: "1 standard action",
        range: "10 ft.",
        area: "10-ft.-radius emanation, centered on you",
        effect: "",
        targets: "",
        duration: "1 minute/level (D)",
        savingThrow: "none or Will negates (see text)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Acid Fog",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["acid"],
        longDesc: `Acid fog creates a billowing mass of misty vapors like the solid fog spell. In addition to slowing down creatures and obscuring sight, this spell's vapors are highly acidic. Each round on your turn, starting when you cast the spell, the fog deals 5d6 points of acid damage to each creature and object within it. Acid fog also deals its damage to all weapons and armor in it as well, granting no save and bypassing the weapon or armors hardness. Additionally, as long as creatures remain in the fog, their armor bonus to their armor class is reduced by -4.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "fog spreads in 20-ft. radius, 20 ft. high",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Binding Earth, Mass",
        type: ["control"],
        school: "transmutation",
        tags: ["earth"],
        longDesc: `This spell functions as binding earth, except it targets multiple creatures. Binding Earth: If the target of this spell fails its Fortitude save, areas of earth and stone floor act as a snapping quagmire that pulls the target down and damages it if it attempts to move through such terrain. If the target is a creature, it treats all areas of earth and stone it moves through as difficult terrain. Furthermore, for each 5 feet a creature moves through such areas, it takes 1d6 points of damage. Creatures with a burrow speed or the earth glide ability are unaffected by binding earth. If cast on an unattended object resting on an area of stone or earth, the stone or earth warps and wraps around it, pulling it firmly to the ground. A DC 15 Strength check is required to pull the object free from snapping earth or stone.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature or object/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "6",
        name: "Cacophonous Call Mass",
        type: ["control"],
        school: "evocation",
        tags: [],
        longDesc: `You fill your target's mind with a blaring cacophony of discordant sounds, making it hard for the targets to act and concentrate. The creature gains the nauseated condition for the duration of the spell if it fails its Will save.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "One Creature/level (all of which must be within 30 feet)",
        duration: "1 round/level",
        savingThrow: "Will Negates",
        spellResistance: "yes",
        components: "V,S,M",
        },
        {
        level: "6",
        name: "Chains Of Light",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["good"],
        longDesc: `A creature targeted by this spell is held immobile by glowing golden chains composed of pure light. The creature is paralyzed and held in place, but may attempt a new saving throw each round to end the effect. While held by the golden chains, a creature cannot use any sort of spell or spell like ability, or any extradimensional travel, such as astral projection, blink, dimension door, ethereal jaunt, etherealness, gate, maze, plane shift, shadow walk, teleport, and similar abilities. The spell does not affect creatures that are already in ethereal or astral form when the spell is cast.`,
        castingTime: "1 standard action",
        range: "short (25 ft. + 5 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level (D)",
        savingThrow: "Reflex negates",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Cloak of Dreams",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You are surrounded by a soporific aroma that causes living creatures that begin their turn or end their movement within 5 feet of you to fall asleep for 1 minute. Creatures must save each time they begin their turn or end their movement within the cloak of dreams, even if they have previously saved against the effect. Sleeping creatures are helpless but can be awakened with a standard action or after being wounded. Creatures with the scent special quality have a -4 penalty on their saves.`,
        castingTime: "1 round",
        range: "5 ft.",
        area: "5-ft.-radius emanation centered on you",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Curse, Major",
        type: ["control"],
        school: "necromancy",
        tags: ["curse"],
        longDesc: `You place a curse on the subject. Choose one of the following. -6 decrease to an ability score (minimum 1). -4 penalty on attack rolls, saves, ability checks, and skill checks. Each turn, the target has a 50% chance to act normally; otherwise, it takes no action. You may also invent your own curse, but it should be no more powerful than those described above. The curse bestowed by this spell cannot be dispelled, but it can be removed with a break enchantment, limited wish, miracle, remove curse, or wish spell, but the DC to remove it is equal to the save DC + 5. Bestow curse counters remove curse.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "permanent",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Debilitating Pain Mass",
        type: ["control"],
        school: "enchantment (compulsion)",
        tags: ["mind-affecting", "pain"],
        longDesc: `The targets are overcome with intense pain, causing them to be stunned on a failed save or dazed for 1 round on a successful save. Once a creature is dazed by this spell it cannot be dazed by it again.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/4 levels",
        duration: "1 round/3 levels",
        savingThrow: "Will partial (see text)",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "6",
        name: "Envious Urge",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You fill creatures with feelings of seething envy. Affected targets turn upon the nearest creature (whether an ally or enemy) and attempt to disarm it of a valuable weapon, steal something it is holding, or grapple it and strip it of something it prizes (your choice). Affected targets can attempt a new Will save each round as a free action to end this effect.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Epidemic",
        type: ["control"],
        school: "necromancy",
        tags: ["disease", "evil"],
        longDesc: `The target contracts one of the following diseases: blinding sickness, bubonic plague, cackle fever, filth fever, leprosy, mindfire, red ache, shakes, or slimy doom (Core Rulebook 557), as the spell contagion. However, the disease is highly contagious, and any creature that touches the infected target, is touched by the target, or spends more than an hour in a confined space with the target must make a save against the disease's normal DC (not the spell DC) or contract the disease. If the initial target overcomes the disease by making the required number of saving throws, it remains a carrier of the disease for a length of time equal to the disease's frequency, and can continue to infect others during this time.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "living creature",
        duration: "instantaneous",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Eyebite",
        type: ["control"],
        school: "necromancy",
        tags: ["emotion", "pain"],
        longDesc: `Each round, you can target a single living creature, striking it with waves of power. Depending on the target's HD, this attack has as many as three effects. HD Effect 10 or more Sickened 5-9 Panicked, sickened 4 or less Comatose, panicked, sickened The effects are cumulative and concurrent. Sickened: Sudden pain and fever sweeps over the subject's body. A creature affected by this spell remains sickened for 10 minutes per caster level. The effects cannot be negated by a remove disease or heal spell, but a remove curse is effective. Panicked: The subject becomes panicked for 1d4 rounds. Even after the panic ends, the creature remains shaken for 10 minutes per caster level, and it automatically becomes panicked again if it comes within sight of you during that time. This is a fear effect. Comatose: The subject falls into a catatonic coma for 10 minutes per caster level. During this time, it cannot be awakened by any means short of dispelling the effect. This is not a sleep effect, and thus elves are not immune to it. You must spend a swift action each round after the first to target a foe.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round/level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Fester Mass",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `Necrotic energy permeates the targets, blocking healing abilities. The subjects gains Spell Resistance equal to 12 + your caster level against effects that restore hit points or grant temporary hit points. In addition, any healing provided by effects that ignore Spell Resistance (such as fast healing, regeneration, and some spells) are halved. If the target succeeds on a Fortitude Saving Throw, fester lasts only a single round.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level or 1 round; see text",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Flesh to Stone",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `The subject, along with all its carried gear, turns into a mindless, inert statue. If the statue resulting from this spell is broken or damaged, the subject (if ever returned to its original state) has similar damage or deformities. The creature is not dead, but it does not seem to be alive either when viewed with spells such as deathwatch. Only creatures made of flesh are affected by this spell. A creature may resave as normal from this spell, but then it is paralyzed until it makes an additional fortitude save, then it becomes staggered until it makes an additional fortitude save. While stone the creature gains hardness 8, but if the creature takes more than 50% of its remaining hit points while stone, it dies even if it returns to flesh.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Forbiddance",
        type: ["control"],
        school: "abjuration",
        tags: [],
        longDesc: `Forbiddance seals an area against all planar travel into or within it. This includes all teleportation spells (such as dimension door and teleport), plane shifting, astral travel, ethereal travel, and all summoning spells. Such effects simply fail automatically. In addition, it damages entering creatures whose alignments are different from yours. The effect on those attempting to enter the warded area is based on their alignment relative to yours (see below). A creature inside the area when the spell is cast takes no damage unless it exits the area and attempts to reenter, at which time it is affected as normal. Alignments identical: No effect. The creature may enter the area freely (although not by planar travel). Alignments different with respect to either law/chaos or good/evil: The creature takes 6d6 points of damage. A successful Will save halves the damage, and spell resistance applies. Alignments different with respect to both law/chaos and good/evil: The creature takes 12d6 points of damage. A successful Will save halves the damage, and spell resistance applies. At your option, the abjuration can include a password, in which case creatures of alignments different from yours can avoid the damage by speaking the password as they enter the area. You must select this option (and the password) at the time of casting. Adding a password requires the burning of additional rare incenses worth at least 1,000 gp, plus 1,000 gp per 60-foot cube. Dispel magic does not dispel a forbiddance effect unless the dispeller's level is at least as high as your caster level. You can't have multiple overlapping forbiddance effects. In such a case, the more recent effect stops at the boundary of the older effect.`,
        castingTime: "6 rounds",
        range: "medium (100 ft. + 10 ft./level)",
        area: "60-ft. cube/level",
        effect: "",
        targets: "",
        duration: "permanent",
        savingThrow: "see text",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Frozen Note",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting", "sonic"],
        longDesc: `You produce and sustain a single perfect musical note that holds nearby creatures, friend as well as foe, utterly spellbound until you stop singing. Affected creatures are both paralyzed and oblivious to their surroundings so long as you maintain the note.
                
        Maintaining this note requires your absolute attention; if you take damage or take any other action, including moving from your current square, the spell instantly ends. Creatures that succeed in their initial Saving Throw must make a new one for each round they spend within the area of the spell until they fail and become captivated. The note is so clear and flawless that less than extraordinary attempts to avoid hearing it merely grant targets a bonus on their saving throws. Targets get a +2 circumstance bonus on their Saving Throw for each barrier between your voice and their ears. This includes such things as a creature stopping up its ears with wax, closing all windows and doors in a nearby building, or even crawling into a barrel and pulling down the top.
                
        If a target that had previously made its Saving Throw loses the benefit of one or more of its barriers it must immediately make a new Saving Throw. Similarly, any target that had previously failed its Saving Throw gets a new save each time it gains the protection of a barrier.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "30-ft.-radius emanation centered on you",
        effect: "",
        targets: "any number of creatures within area",
        duration: "concentration (up to 1 round/level)",
        savingThrow: "Will partial",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "6",
        name: "Leashed Shackles",
        type: ["control"],
        school: "evocation",
        tags: ["force"],
        longDesc: `You create shackles of force that attach to the target's limbs. You designate an object or location within 30 feet of the target for the shackles to anchor themselves to; this must be the ground, a wall, or a sturdy structure for the anchoring to occur. The target is entangled, and cannot move more than 30 feet from the anchor point of the spell. The shackle itself cannot be attacked (though it can be dispelled), but if the object or area it is attached to is broken, the target is free to move away (though it is still entangled). At the start of each of its turns it must make a strength check vs the DC of the spell, if they fail they are yanked 10ft towards the chained spot, and are knocked prone. After it succeeds this check 3 times it is also freed from the spell (instead of the normal re-save). It can also spend a standard action making a CMB check vs the DC of the spell to count as one of these saves.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. +10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 minute/level",
        savingThrow: "Reflex negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Phantasmal Putrefaction",
        type: ["control"],
        school: "illusion(phantasm)",
        tags: ["fear", "mind-affecting"],
        longDesc: `You implant within the minds of your targets the illusion that their skin is rotting away, large rents are appearing all over their bodies, and their internal organs are spilling out into a putrid half-liquid mass at their feet. Those who fail to disbelieve phantasmal putrefaction immediately take 1d4 points of Wisdom damage. This damage occurs only once. Each round at the beginning of its turn, an affected target receives another Will save to disbelieve the effect, and targets that fail must succeed at a Fortitude save or faint, falling asleep as per sleep (except that it isn't a magical sleep effect). Waking up doesn't end the spell for a target; it must continue to attempt Will saves to disbelieve and Fortitude saves to avoid fainting each round until the spell ends or the target successfully disbelieves. Targets of the spell perceive everyone else around them to be rotting away, but other creatures see no visible effect of the spell, so they, in addition to those who disbelieve, can communicate the nature of the illusion to allies, providing those allies with a +4 bonus on the saving throw to disbelieve. If your campaign uses the sanity system, a creature takes 1d8 points of sanity damage instead of Wisdom damage.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level (D)",
        savingThrow: "Will disbelief, then Fortitude partial (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Phobia",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `You instill the target with an intense, instinctual fear of another creature or an elemental damage type, if you make it a creature and it is a hostile creature to the target, the target has a -4 penalty on all attack rolls against it, the DC's of its targeted abilities against it, and has a -6 penalty on saves against fear effects from it. If the phobia target is an ally to it, it cannot receive any kind of automatic benefitial effect from it, must make saves against all the effects it can, cannot receive bonuses from aid or teamwork feats. If its an elemental type the creature becomes shaken every time it is affected by the elemental type for 1 round no save. (you can also pick hazards as with the default spell) The first time the creature comes into contact with the phobia target it must make a will save dc 20 or become panicked for 1 minute.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one intelligent creature",
        duration: "instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Serenity",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You fill the targets' minds with feelings of tranquility. Those attempting to commit violence become stricken with wracking pain and take 3d6 points of nonlethal damage each time they attempt to harm another creature. If attacked, affected individuals can defend themselves and may participate in combat by using Combat Expertise, fighting defensively, or taking the total defense action without triggering the spell's nonlethal damage.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Spellblight Jinx",
        type: ["control"],
        school: "evocation",
        tags: ["curse"],
        longDesc: `You inflict a curse similar to the spell burn spellblight on a creature. Each time a spellcaster who is afflicted with this curse casts a spell or uses a spell-like ability, her skin seems to burn as though she were on fire. With a successful concentration check (DC = 15 + double the spell level of the spell cast or spell-like ability used), the spellcaster can ignore the pain of the effect, but if she fails, she loses the spell or spell slot and is staggered for a round.
                
                        Unlike with the spell burn spellblight, the burning sensation is a tangible effect, visible during the act of spellcasting as an incorporeal, violet flame surrounding the caster.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "permanent",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "6",
        name: "Spellcrash",
        type: ["control"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions as lesser spellcrash, except it affects 5th-level or lower prepared spells or spell slots.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level",
        savingThrow: "Will negates; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Stunning Finale",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You must have a bardic performance or hex in effect to cast this spell.
                        With a flourish, you immediately end your bardic performance or hex, assaulting the senses of the targets with your finale. Each target is stunned for 1 round. On a successful Saving Throw, a target is staggered for 1 round. If you use a hex to activate this ability it can only target creatues that were previously targeted by your hex. The hexes effect lingers until after the creature makes its saving throw.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "up to 3 creatures, no two of which can be more than 30 ft. apart",
        duration: "1 round",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Unwilling Shield",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `Like shield other, unwilling shield creates a mystic connection between you and the target, but unlike shield other, the target shares the wounds that you receive. In addition, the link draws upon the target's life force to supplement your own defenses. You gain a +1 luck bonus to AC and on saving throws. You take only half damage from all wounds and attacks (including those dealt by special abilities) that deal hit point damage. The amount of damage not taken by you is taken by the target. Forms of harm that do not involve hit points, such as charm effects, ability damage, level draining, and death effects are not affected. If you take a reduction in hit points from a lowered Constitution score, the reduction is not split with the target because it is not hit point damage. When the spell ends, subsequent damage is no longer divided between you and the subject, but damage already split is not assigned to you. If you and the target of the spell move out of range of each other, the spell remains active, but damage is no longer shared until you are once again within range of each other.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Vengeful Outrage",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "language-dependent", "mind-affecting"],
        longDesc: `You place a magical command upon a creature to seek out and destroy a single enemy that has inflicted damage against you. The DC of this spell increase by +1 for every 40 points of damage you have taken from the creature you direct the target of this spell against, or for every 2 harmful non-damaging affects you have been harmed by from them.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Whip of Ants",
        type: ["control"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions as whip of spiders, except it summons army ants, and any creature you strike with the whip takes swarm damage as if it were attacked by an army ant swarm (3d6 points of damage plus poison and distraction). If you transform the whip into an army ant swarm, it has 16 hit points.`,
        castingTime: "1 standard action",
        range: "0 ft.",
        area: "",
        effect: "whiplike swarm",
        targets: "",
        duration: "1 round/level (D (see text)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Wither Limb",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `You cause one limb of the target to shrivel and weaken. The target takes 2d6 points of damage. The points are permanently lost until the target's limb is restored by heal, limited wish, miracle, regenerate, or wish. Wither limb affects only living creatures of the humanoid or monstrous humanoid type, or similar bipedal creatures at the GM's discretion. You choose the limb affected. This spell's effects stack, until all a target's arms and legs (or equivalent limbs) are withered. Arm: The target looses the use of one arm, which might affect what weapons and shields it can use. The creature must immediately drop all objects held in the withered limb, though it can shift a two-handed weapon it is holding in both hands to a remaining arm as an immediate action. Worn objects-gauntlets, rings, and magic items in the wrist slot-remain. This prevents the creature from using two-weapon fighting, claw attacks from that arm, and so on. If multiple castings of this spell wither all of a creature's arms, it can't manipulate objects or cast spells requiring somatic components. Leg: The creature's movement speeds are halved, except for flying or other speeds that don't involve its legs. If multiple castings of this spell wither all of a creature's legs, it can only crawl at a speed of 5 feet each round. Wing: The creature loses access to any fly speed that depends on its wings if even a single wing is withered.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "instantaneous",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Sirocco",
        type: ["control", "damage"],
        school: "evocation",
        tags: ["air", "fire"],
        longDesc: `A blast of furnace-hot wind blasts downward, inflicting 4d6 fire damage +1 point per caster level to all creatures in the area and knocking them prone. A successful Fortitude save halves the fire damage and negates being knocked prone. Flying creatures forced into the ground by the powerful downdraft take damage as if they fell unless they make a Fly check (spells DC + 10), in which case they remain at their original altitude. Any creature that takes damage from a sirocco becomes fatigued (or exhausted, if already fatigued, such as from a previous round of exposure to a sirocco spell). Creatures with the water subtype take a -4 penalty on all saving throws against this spell and take double normal damage.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "cylinder (20-ft. radius, 60 ft. high)",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "Fortitude partial, see text",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Blazing Rainbow",
        type: ["control", "utility"],
        school: "evocation",
        tags: ["light"],
        longDesc: `You create a spectrum of multicolored solid light that can be used for one of two effects. Bow: The spell creates a longbow or shortbow appropriate for your size, and you are proficient in the use of this weapon. When drawn, the bow automatically creates a +1 seeking brilliant energy arrow; it cannot fire any other arrows. A creature struck by one of these arrows is surrounded by faerie fire and dazzled for 1 minute. This version of the spell ends when you have fired a number of arrows equal to your caster level. Bridge: The light forms a bridge or ramp 5 feet wide and up to 10 feet long per caster level. Creatures on the bridge are dazzled. Allies gain a bonus equal to your highest mental modifier (minimum 1) on checks, saves, and to their CMD to resist being moved from the bridge against their will. Enemies take a penalty equal to your highest mental modifier (minimum 1) checks, saves, and to their CMD to resist being moved from the bridge against their will.`,
        castingTime: "full-round action",
        range: "0 ft. or 10 ft./level",
        area: "",
        effect: "bow or bridge of light",
        targets: "",
        duration: "1 minute/level or until discharged (see text)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M, ",
        },
        {
        level: "6",
        name: "Expend",
        type: ["control", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `You cause all creatures in the affected area to use up one or more of their limited-use magical abilities without any actual effect. A limited-use magical ability is any supernatural or spell-like ability which a creature can only activate a certain number of times during a set interval (3/day, 1/hour, etc.) or abilities that recharge in a set amount of times. The spell does not affect abilities which the creature can use at will or which are constant. It also does not apply to magical items or anything else external to a creature. A creature in the spell's area must make a Will saving throw or expend a single use of one of its abilities. Abilities with the greatest number of uses per day are affected first; if more than one ability has the same number of uses, randomly determine which one is affected first. Creatures must continue making Will saves, expending an additional use of an ability for each failed save, until they succeed, at which point the spell has no further effect.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "20-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Forceful Hand",
        type: ["control", "utility"],
        school: "evocation",
        tags: ["force"],
        longDesc: `This spell functions as interposing hand, except that it can also pursue and bull rush one opponent you select. The forceful hand gets one bull rush attack per round. This attack does not provoke an attack of opportunity. Its CMB for bull rush checks uses your caster level in place of its base attack bonus, with a +8 bonus for its Strength score (27), and a +1 bonus for being Large. The hand always moves with the opponent to push them back as far as possible. It has no movement limit for this purpose. Directing the spell to a new target is a move action. Forceful hand prevents the opponent from moving closer to you without first succeeding on a bull rush attack, moving both the forceful hand and the target closer to you. The forceful hand can instead be directed to interpose itself, as interposing hand does.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "10-ft. hand",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, F,",
        },
        {
        level: "6",
        name: "Ice Crystal Teleport",
        type: ["control", "utility"],
        school: "conjuration(teleportation)",
        tags: ["cold"],
        longDesc: `This spell functions like teleport, except you use it to teleport yourself and another creature to different locations, you can teleport anywhere you desire on the map as teleportation spell (Akashic Paths version), the target is teleported to a different location, which cannot be inherently harmful or the spell automatically fails, and must be a place on the map you have seen before. You teleport immediately, however first the target is trapped in ice (hardness 0, 3 hit points per inch of thickness, 1 inch thick per caster level) for 1d4 rounds, during which time it is paralyzed, aware but unable to take any physical actions, and begins to fade away as the teleportation aspect takes effect. At the end of the 1d4 rounds, the target teleports to the specified location, and the ice's hit points drop to 0 and it quickly melts away. If the ice is destroyed before the target teleports, the spell ends and the teleport doesn't occur.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1d4 rounds and instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V",
        },
        {
        level: "6",
        name: "Acid Stomp",
        type: ["damage"],
        school: "evocation",
        tags: ["acid"],
        longDesc: `You can only cast this spell while on the ground. You stomp on the ground, unleashing a blast of acid around you in a 10 ft radius around you splashing all creatures within the area, this deals 1d6 points of acid damage per caster level (max 15d6), though the creature is allowed to make a reflex save to half the damage.`,
        castingTime: "1 standard action",
        range: "10-ft.",
        area: "burst centered on you",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "6",
        name: "Blade Barrier",
        type: ["damage"],
        school: "evocation",
        tags: ["force"],
        longDesc: `An immobile, vertical curtain of whirling blades shaped of pure force springs into existence. Any creature passing through the wall takes 1d6 points of damage per caster level (maximum 15d6), with a Reflex save for half damage. If you evoke the barrier so that it appears where creatures are, each creature takes damage as if passing through the wall. Each such creature can avoid the wall (ending up on the side of its choice) and thus take no damage by making a successful Reflex save. A blade barrier provides cover (+4 bonus to AC, +2 bonus on Reflex saves) against attacks made through it.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "wall of whirling blades up to 20 ft. long/level, or a ringed wall of whirling blades with a radius of up to 5 ft. per two levels; either form is 20 ft. high",
        targets: "",
        duration: "1 min./level (D)",
        savingThrow: "Reflex half or Reflex negates; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Caustic Blossom",
        type: ["damage"],
        school: "evocation",
        tags: ["acid"],
        longDesc: `You stomp on the ground launching a caustic blossom that travels 60 feet in a straight line, exploding in an acidic blast. This deals 1d6 acid damage per caster level (max 15d6), reflex half. You must be on the ground to cast this spell, and it deals damage to all creatures within 15 feet of it (above or below ground). At the end of the 60 foot line an acid blossom blooms for 1 round, and any creature who finishes their turn in the square takes the damage a second time. Then at the end of your next turn as long as you are on the ground still, the blossom travels in a straight line back to you (as long as you are on the same plane) dealing its damage again, reflex save for half. If a creature takes damage from both instances of the spell, the return damage increases to 1d8 per caster level (max 15d8) for that creature. This spell travels up or down cliffs (counting as part of its range), but cant go through the air, ending its movement if it reaches such a boundry.`,
        castingTime: "full-round action",
        range: "60ft.",
        area: "60ft. line",
        effect: "",
        targets: "",
        duration: "instantaneous and 1 round; see text",
        savingThrow: "Reflex half (see text)",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "6",
        name: "Chain Lightning",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `This spell creates an electrical discharge that begins as a single stroke commencing from your fingertips. Unlike lightning bolt, chain lightning strikes one object or creature initially, then arcs to other targets. The bolt deals 1d6 points of electricity damage per caster level (maximum 20d6) to the primary target. After it strikes, lightning can arc to a number of secondary targets equal to your caster level (maximum 20). The secondary bolts each strike one target and deal as much damage as the primary bolt. Each target can attempt a Reflex saving throw for half damage. The Reflex DC to halve the damage of the secondary bolts is 2 lower than the DC to halve the damage of the primary bolt. You choose secondary targets as you like, but they must all be within 30 feet of the primary target, and no target can be struck more than once. You can choose to affect fewer secondary targets than the maximum.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "one primary target, plus one secondary target/level (each of which must be within 30 ft. of the primary target)",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
            level: "7",
            name: "Tyrant's Judgement",
            type: ["damage"],
            school: "evocation",
            tags: ["electricity","good","choatic"],
            longDesc: `This spell calls lighting down on the wicked and tyranical. Each enemy within range is struck by a bolt of lighting that deals 1d6 points of damage per caster level (maximum 20d6), as well as any creature who is also above their space. Half of this damage is from electricity, but the other half results directly from divine power. Each target can attempt a Reflex saving throw for half damage. This deals no damage to creature's who's alignment is within 1 step of chaotic good, however for every alignment step past the 1st the target creature is away from chaotic good, this spells DC increases by +1, and the damage increases by 1 point per dice rolled. If you are also chaotic good, the DC and damage per dice rolled are both increased by 1. If your alignment includes either lawful or evil, the DC and damage per dice decreases by 1. This stacks if you are both.`,
            castingTime: "full-round action",
            range: "medium (100 ft. + 10 ft./level)",
            area: "",
            effect: "",
            targets: "1 creatures/4 levels",
            duration: "instantaneous",
            savingThrow: "Reflex half",
            spellResistance: "yes",
            components: "V, S",
        },
        {
            level: "2",
            name: "Power Word Shield",
            type: ["healing"],
            school: "conjuration(creation)",
            tags: [],
            longDesc: `You utter a single powerful word of defense. Choose an ally, they gain 1d6 temporary hit points per 2 caster levels (max 10d6). These last 1 round, plus an additional round for every 8 caster levels. Once an ally benefits from this spell, they cannot benefit from it again until the next combat.`,
            castingTime: "swift action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "1 ally",
            duration: "1rd, +1 rd/8 levels",
            savingThrow: "will negates (harmless)",
            spellResistance: "yes",
            components: "V",
        },
        {
            level: "4",
            name: "Power Word Glory",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `You utter a single powerful word of an allies heroics. Choose an ally, they next time they make a weapon attack within 1 round, they heal hit points equal to the damage they deal. If the attack hits multiple creatures, it only heals for the highest amount of damage done to a creature, increased by 10% per additional creature struck.`,
            castingTime: "standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "1 ally",
            duration: "1 round",
            savingThrow: "will negates (harmless)",
            spellResistance: "yes",
            components: "V",
        },
        {
            level: "4",
            name: "Power Word Protection",
            type: ["healing"],
            school: "conjuration(creation)",
            tags: [],
            longDesc: `You utter a single powerful word of defense. Choose an ally, they gain 1d6 temporary hit points per caster level (max 15d6). These last 1 round. Once an ally benefits from this spell, they cannot benefit from it again until the next combat.`,
            castingTime: "immediate action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "1 ally",
            duration: "1 round",
            savingThrow: "will negates (harmless)",
            spellResistance: "yes",
            components: "V",
        },
        {
            level: "4",
            name: "Power Word Fortitude",
            type: ["healing"],
            school: "conjuration(creation)",
            tags: [],
            longDesc: `You utter a single powerful word of defense. Targeted allies gain 1d6 temporary hit points per caster levels (max 15d6). These last 1 round, plus 1 round per 8 caster levels.`,
            castingTime: "standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "one creature/level, no two of which can be more than 30 ft. apart",
            duration: "1 round + 1rd/8 levels",
            savingThrow: "will negates (harmless)",
            spellResistance: "yes",
            components: "V",
        },
        {
            level: "4",
            name: "Divine Shield",
            type: ["healing","utility"],
            school: "conjuration(creation)",
            tags: [],
            longDesc: `The next time the ally takes damage, reduce the damage taken to 0.`,
            castingTime: "standard action",
            range: "touch",
            area: "",
            effect: "",
            targets: "one creature",
            duration: "1 round/2 levels or until expended",
            savingThrow: "will negates (harmless)",
            spellResistance: "yes",
            components: "V,S,M",
        },
        {
            level: "7",
            name: "Power Word Divine Shield",
            type: ["healing","utility"],
            school: "conjuration(creation)",
            tags: [],
            longDesc: `The next time the ally takes damage, reduce the damage taken to 0.`,
            castingTime: "standard action",
            range: "close (25ft. + 5ft./2 levels)",
            area: "",
            effect: "",
            targets: "one creature",
            duration: "1 round/level or until expended",
            savingThrow: "will negates (harmless)",
            spellResistance: "yes",
            components: "V",
        },
        {
            level: "3",
            name: "Binding Light",
            type: ["healing"],
            school: "conjuration(creation)",
            tags: [],
            longDesc: `You create a channel of positive energy between you and a different ally. As long as you end your turn within 15 feet of the ally, they heal for 2d8 + caster level hit points. If you dont, this spell ends. You can have only a single binding light or conduit of light connected to someone, and you cannot cast this on yourself.`,
            gameDesc: `You create a channel of positive energy between you and a different ally. As long as you end your turn within 15 feet of the ally, they heal for 2d8 + caster level hit points. If you dont, this spell ends. You can have only a single binding light or conduit of light connected to someone, and you cannot cast this on yourself. This actually lasts 1 rd/level.`,
            castingTime: "standard action",
            range: "15 feet",
            area: "",
            effect: "",
            targets: "one ally",
            duration: "1 round/2 levels",
            savingThrow: "will negates (harmless)",
            spellResistance: "yes",
            components: "V,S,M",
        },
        {
            level: "6",
            name: "Conduit of Light",
            type: ["healing"],
            school: "conjuration(creation)",
            tags: [],
            longDesc: `You create a channel of positive energy between you and a different ally. As long as you end your turn within 30 feet of the ally, they heal for 4d8 + 2x caster level hit points. If you dont, this spell ends. All allies in between a line drawn from the center of their square to yours, is also healed for 2d8 + 1 per 2 levels hit points. You can have only a single conduit of light or binding light connected to someone, and you cannot cast this on yourself. If the line runs through another character you have a binding light or conduit of light on, they are not healed by the line.`,
            gameDesc: `You create a channel of positive energy between you and a different ally. As long as you end your turn within 30 feet of the ally, they heal for 4d8 + 2x caster level hit points. If you dont, this spell ends. All allies in between a line drawn from the center of their square to yours, is also healed for 2d8 + 1 per 2 levels hit points. You can have only a single conduit of light or binding light connected to someone, and you cannot cast this on yourself. If the line runs through another character you have a binding light or conduit of light on, they are not healed by the line. This actually lasts 1 rd/level.`,
            castingTime: "standard action",
            range: "30 feet",
            area: "",
            effect: "",
            targets: "one ally",
            duration: "1 round/2 levels",
            savingThrow: "will negates (harmless)",
            spellResistance: "yes",
            components: "V,S,M",
        },
        {
            level: "3",
            name: "Power Word Renewal",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `You utter a single powerful word of healing to aid an ally on the brink of death. The ally must be below 25% of its maximum hit points to be affected by this spell. The touched ally heals 7d8 + caster level hit points. If the ally is below 0 hit points, this spells healing gains 25 spell power, 1% spell critical, and 25 spell critical power.`,
            castingTime: "standard action",
            range: "Touch",
            area: "",
            effect: "",
            targets: "one ally",
            duration: "instantaneous",
            savingThrow: "will negates (harmless)",
            spellResistance: "yes",
            components: "V",
        },
        {
            level: "3",
            name: "Guardian Spirit",
            type: ["healing","utility"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `You summon a guardian spirit to watch over an ally. This acts like unseen servent, except that once cast it immediately runs towards the targeted ally and stands directly next to the ally empowering healing against it. Every time they are healed with positive energy, the healing is increased by 20%. If during the duration the ally would be reduced below 0 hit points, the spirit sacrifices itself and heals the ally 2d8 + caster level hit points (unaffected by the bonus healing this spell usually gives). A creature can have only a single guardian spirit or angel protecting them at a time.`,
            castingTime: "standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "one invisible, mindless, shapeless servant",
            targets: "one ally",
            duration: "1 round/level",
            savingThrow: "none",
            spellResistance: "yes",
            components: "V, S, M",
        },       
        {
            level: "6",
            name: "Guardian Angel",
            type: ["healing", "utility"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `You summon a guardian angel to watch over an ally. This acts like unseen servent, except that once cast it immediately runs towards the targeted ally and stands directly next to the ally empowering healing against it. Every time they are healed by positive energy, the healing is increased by 25%. If during the duration the ally would be reduced below 0 hit points, the angel as an immediate action heals the ally 5d8 + caster level hit points, (unaffected by the bonus healing this spell usually gives), however, the bonus healing the angel gives from now on is reduced by 10%. Once the bonus healing reaches 0%, this spell ends. A creature can have only a single guardian spirit or angel protecting them at a time.`,
            castingTime: "standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "one invisible, mindless, shapeless servant",
            targets: "one ally",
            duration: "1 round/level",
            savingThrow: "none",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
            level: "1",
            name: "Divine Hymn",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: ["sonic"],
            longDesc: `You begin to sing a hymn of healing. Unlike most spells, you do not need to roll a concentration check for this spell when you take damage. At the start of your next turn, all allies within 60 feet of you that could hear you for the whole round are healed 1d8 + caster level (max +15) hit points. For every 4 caster levels you have, you can continue singing the hymn the next round, doing so requires another 1 round action, but also increases the healing it gives by 2d8 + caster level. This stacks for consecutive rounds. Each time you continue singing, you must spend 2 spell points per rounds singing.`,
            gameDesc: `You begin to sing a hymn of healing. Unlike most spells, you do not need to roll a concentration check for this spell when you take damage. At the start of your next turn, all allies within 60 feet of you that could hear you for the whole round are healed 1d8 + caster level (max +15) hit points. For every 4 caster levels you have, you can continue singing the hymn the next round, doing so requires another 1 round action, but also increases the healing it gives by 2d8 + caster level. This stacks for consecutive rounds. Each time you continue singing, you must spend 2 spell points per rounds singing.`,
            castingTime: "1 round",
            range: "60 feet centered on you",
            area: "60 feet",
            effect: "",
            targets: "allies",
            duration: "concentration; see text",
            savingThrow: "will negates (harmless)",
            spellResistance: "yes",
            components: "V",
        },
        {
            level: "3",
            name: "Divine Star",
            type: ["healing","damage"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `You fire a bolt of divine energy at a creature, requiring a ranged touch attack and dealing 1d6 points of force damage per 2 caster levels. If the spell hits and deals damage to a creature, a random ally within close range of the struck target gains temporary hit points equal to the damage dealt. These last 1 round per 4 caster levels.`,
            castingTime: "1 standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "1 enemy",
            duration: "1 round/4 levels",
            savingThrow: "none; and will negates (harmless)",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
            level: "7",
            name: "Signifer's Rally",
            type: ["utility"],
            school: "conjuration (teleportation)",
            tags: ["evil"],
            longDesc: `You teleport up to one ally per five caster levels to your location. You determine which allies you want to teleport at the time of casting; these allies have 1 round to decide to allow or refuse your spell, and they teleport immediately upon accepting. Allies are teleported as if you had cast teleport on them (your current location is at least “studied carefully” for this purpose), appearing in a puff of brimstone in a space adjacent to you. The spell does not function in areas warded against intrusion by evil creatures (such as a magic circle against evil effect).`,
            castingTime: "standard action",
            range: "medium (100 ft. + 10 ft./level)",
            area: "",
            effect: "",
            targets: "1 willing ally/5 levels",
            duration: "instantaneous",
            savingThrow: "Will negates (harmless);",
            spellResistance: "yes (harmless)",
            components: "V, S, M",
        },
        {
            level: "7",
            name: "Purifying Flame",
            type: ["damage","healing"],
            school: "evocation",
            tags: ["fire","good","lawful"],
            longDesc: `This spell calls forth the wrath of the heavens to remove the corrupt. The area each targeted enemy is standing on is marked, then 1 round later at the start of your next turn a pillar of flame descends upon the location, dealing damage 1d6 points of damager per caster level (maximum 20d6) to the creature and every creature above them. Half of this damage is from fire, but the other half results directly from divine power. Each target can attempt a Reflex saving throw for half damage. This deals no damage to creatures who's alignment is within 1 step of lawful good, instead heals them for half the damage this spell would deal, however for every alignment step past the first the target creature is away from lawful good, this spells DC increases by +1, and the damage increases by 1 point per dice rolled. If you are also lawful good, the DC and damage per dice rolled are both increased by 1. If your alignment includes either choatic or evil, the DC and damage per dice decreases by 1. This stacks if you are both.`,
            castingTime: "1 standard action",
            range: "medium (100 ft. + 10 ft./level)",
            area: "",
            effect: "",
            targets: "1 enemy/4 levels",
            duration: "1 round then instantaneous",
            savingThrow: "Reflex half",
            spellResistance: "yes",
            components: "V, S",
        },
        {
            level: "7",
            name: "Abyssid Pulse",
            type: ["damage"],
            school: "evocation",
            tags: ["acid","evil","chaotic"],
            longDesc: `You unleash a pulse of corrossive and destructive acid that tears down everything in its path. This pulse originates from your square extending out 20 feet in a circle around you, rolling along the ground and striking all creatures in its way. Then, at the start of each of your turns it extends out another 20 feet, continuing to strike creatures until it reaches its maximum area, then the spell ends. For every 10 feet this pulse travels, its height also raises 5 feet. This pulse deals 1d6 points of damager per caster level (maximum 20d6) to every creature in its way, however when you cast this spell you can designate any creature you would want to be unaffected. Half of this damage is from acid, but the other half results directly from unholy power. Each target can attempt a fortitude saving throw for half damage, however if they fail the fortitude saving throw, they are also staggered for 1 round. This spell has no effect on creatures who's alignment is within 1 step of chaotic evil, however for every alignment step past the 1st the target creature is away from chaotic evil, this spells DC increases by +1, and the damage increases by 1 point per dice rolled. If you are also chaotic evil, the DC and damage per dice rolled are both increased by 1. If your alignment includes either lawful or good, the DC and damage per dice decreases by 1. This stacks if you are both. This spell also destroys objects within its path, ignoring hardness.`,
            castingTime: "1 standard action",
            range: "0 feet",
            area: "80 feet",
            effect: "",
            targets: "",
            duration: "instantaneous",
            savingThrow: "fortitude half",
            spellResistance: "yes",
            components: "V, S",
        },
        {
            level: "7",
            name: "Frozen Grasp of Hell",
            type: ["damage"],
            school: "conjuration(calling)",
            tags: ["cold","evil","lawful"],
            longDesc: `You mark creatures that would resist the order of the hells, calling upon its custodians to eradicate them. Each targeted creature becomes marked for eradication as a giant frozen hand slowly reaches through a portal towards them. This takes 3 rounds to do, in which time the creature must deal at least 10 points of damage to the hand per caster level. It has DR/10 good, resistance 20 to acid and electricity, immunity to cold, and vulnerability to fire or good. This portal follows the creature no matter where they go. Once the hand reaches them, it grips them, its icy hand dealing 1d6 points of damage per caster level (maximum 20d6). Half of this damage is from cold, but the other half results directly from unholy power, and additionally they are paraylzed for 1d4 rounds. Targets receive no saving throw to halve this damage but can make a fortitude saving throw to halve the paralysis duration. This spell has no effect on creatures who's alignment is within 1 step of lawful evil, however for every alignment step past the 1st the target creature is away from lawful evil, this spells DC increases by +1, and the damage increases by 1 point per dice rolled. If you are also lawful evil, the DC and damage per dice rolled are both increased by 1. If your alignment includes either chaotic or good, the DC and damage per dice decreases by 1. This stacks if you are both.`,
            castingTime: "1 standard action",
            range: "medium (100 ft. + 10 ft./level)",
            area: "",
            effect: "",
            targets: "1 creature/4 levels",
            duration: "3 rounds",
            savingThrow: "foritude partial(see text)",
            spellResistance: "yes",
            components: "V, S",
        },
        {
        level: "6",
        name: "Chains of Fire",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `This spell creates a fiery ray that begins as a single stroke commencing from your fingertips. Chains of Fire strikes one object or creature initially, then arcs to other targets. The bolt deals 1d6 points of fire damage per caster level (maximum 20d6) to the primary target. After it strikes, fire can arc to a number of secondary targets equal to your caster level (maximum 20). The secondary bolts each strike one target and deal as much damage as the primary bolt. Each target can attempt a Reflex saving throw for half damage. The Reflex DC to halve the damage of the secondary bolts is 2 lower than the DC to halve the damage of the primary bolt. You choose secondary targets as you like, but they must all be within 30 feet of the primary target, and no target can be struck more than once. You can choose to affect fewer secondary targets than the maximum.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one primary target, plus one secondary target/level (each of which must be within 30 ft. of the primary target)",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Circle of Death",
        type: ["damage"],
        school: "necromancy",
        tags: ["death"],
        longDesc: `Circle of death damages the life force of living creatures, giving them 1d4 negative levels. This effects 1 creature per 8 levels, those who are closest to the burst's point of origin are affected first.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "several living creatures within a 40-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Cold Ice Strike",
        type: ["damage"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `You create a shredding flurry of ice slivers, which blast from your hand in a line. The line deals 1d6 points of cold damage per caster level (maximum 15d6). If this spell scores a successful critical hit, the next time you cast it this floor, the spell gains 25% critical spell power.`,
        gameDesc: `You create a shredding flurry of ice slivers, which blast from your hand in a line. The line deals 1d6 points of cold damage per caster level (maximum 15d6). If your last spell was a critical ice spell, TODO something here for this spell`,
        castingTime: "1 swift action",
        range: "30 ft.",
        area: "30-ft. line",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Contagious Flame",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `You blast several enemies with beams of fire. You may fire three rays, plus one additional ray for every four levels beyond 11th (to a maximum of five rays at 19th level). Each ray requires a ranged touch attack to hit and deals 4d6 points of fire damage. The rays may be fired at the same or different targets, but all rays must be aimed at targets within 30 feet of each other and fired simultaneously. Every round on your turn, a new ray of fire launches from each creature who took damage from the spell in the previous round-these new rays attack as if you fired them, but their point of origin is the previous creature damaged. You can choose the new targets as a free action, all of whom must be within close range (25 ft. + 5 ft./2 levels) of their new starting point. This contagion of flame continues for a total of three rounds-a creature can be struck more than once by this spell over the course of these three rounds, although never by a ray of fire that launches from itself.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "three or more rays",
        duration: "3 rounds",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Corrosion Beam",
        type: ["damage"],
        school: "evocation",
        tags: ["acid"],
        longDesc: `You fire a single devastingly corrosive ray, which functions as both a line and a ray spell, draw a line to the maximum distance of this spell, as if it was a line spell, but make a touch attack against each creature this line intersects with as if it was a ray spell. If you hit, the creature takes 1d8 points of acid damage per caster level, (maximum 20d8), however each creature can make a reflex save to reduce this damage by half, however if the creature fails this save by 10 or more, the spell deals critical damage to them. This spell deals damage to objects in its way, and can potentially deal enough damage to penetrate through them. Unlike most elemental damage, this deals full damage to objects.`,
        castingTime: "1 standard action",
        range: "short (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "1 ray",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Corrosive Blob",
        type: ["damage"],
        school: "evocation",
        tags: ["acid"],
        longDesc: `You summon a rolling 5ft. ball of acid. At the start of each of your turns it rolls 15ft. towards the nearest enemy (within 100ft + 10ft/level of the blob), any creature that comes in contact with the blob must make a reflex save or take 1d6 points of acid damage per caster level (max 10d6). Each time the blob does damage it grows in acidity, for the rest of the duration it deals an extra 1d6 damage, and for each 2d6 extra damage the DC also increases by +1. Once the duration ends it explodes in a 20ft radius, dealing 2d6 damage for each time it did acid damage during its duration, reflex for half. Creatures that fail this reflex save take half as many d6 of acid damage on their next turn (fortitude negates). The blob rolls over any obstacle in its way, rolls across the surface of liquid without issue, but anything that would physically stop it and it is unable to cling to, such as a wall of force it cannot pass and instead becomes stuck.`,
        castingTime: "1 standard action",
        range: "15 ft",
        area: "",
        effect: "",
        targets: "",
        duration: "1 round/2 levels",
        savingThrow: "reflex negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Disintegrate",
        type: ["damage"],
        school: "transmutation",
        tags: [],
        longDesc: `A thin, green ray springs from your pointing finger. You must make a successful ranged touch attack to hit. Any creature struck by the ray takes 2d6 points of damage per caster level (to a maximum of 40d6), and this spell gains double your bonus universal critical power (universal critical power -50%). Any creature reduced to 0 or fewer hit points by this spell is entirely disintegrated, leaving behind only a trace of fine dust. A disintegrated creature's equipment is unaffected. When used against an object, the ray simply disintegrates as much as a 10-foot cube of nonliving matter. Thus, the spell disintegrates only part of any very large object or structure targeted. The ray affects even objects constructed entirely of force, such as forceful hand or a wall of force, but not magical effects such as a globe of invulnerability or an antimagic field. A creature or object that makes a successful Fortitude save is partially affected, taking only 5d6 points of damage. If this damage reduces the creature or object to 0 or fewer hit points, it is entirely disintegrated. Only the first creature or object struck can be affected; that is, the ray affects only one target per casting.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "ray",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Fortitude partial (object)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Explode Head",
        type: ["damage"],
        school: "evocation",
        tags: [],
        longDesc: `You cause incredible pressure to build in the target's head; this spell works only on a creature that has a head and would die from the loss of a head. The spell kills any such target that has 20 hit points or fewer, exploding its head and spreading debris in a 10-foot radius.
                \nEach creature in the area must succeed at a Reflex saving throw or take 2d6 points of slashing damage from the flying debris.
                \nA target with more than 20 hit points takes 1d6 points of damage per caster level (maximum 20d6), but can attempt a Fortitude save to take only half damage. If this damage would cause the target to become disabled or dying, the target dies and its head explodes as described above.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living corporeal creature",
        duration: "instantaneous",
        savingThrow: "special",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Fire Seeds",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["fire"],
        longDesc: `Depending on the version of fire seeds you choose, you turn acorns into splash weapons that you or another character can throw, or you turn holly berries into bombs that you can detonate on command. Acorn Grenades: As many as four acorns turn into special thrown splash weapons. An acorn grenade has a range increment of 20 feet. A ranged touch attack roll is required to strike the intended target. Together, the acorns are capable of dealing 1d6 points of fire damage per caster level (maximum 20d6) divided among the acorns as you wish, each acorn additionally deals damage equal to your highest mental modifier. No acorn can deal more than 10d6 points of damage. Each acorn grenade explodes upon striking any hard surface. In addition to its regular fire damage, all creatures adjacent to the explosion take 1 point of fire damage per die of the explosion. This explosion of fire ignites any combustible materials adjacent to the target. Holly Berry Bombs: You turn as many as eight holly berries into special bombs. The holly berries are usually placed by hand, since they are too light to make effective thrown weapons (they can be tossed only 5 feet). If you are within 200 feet and speak a word of command, each berry instantly bursts into flame, causing 2d8 points of fire damage + 1 point per caster level to every creature in a 5-foot-radius burst and igniting any combustible materials within 5 feet. A creature in the area that makes a successful Reflex saving throw takes only half damage.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "up to four acorns or up to eight holly berries",
        duration: "10 min./level or until used",
        savingThrow: "none or Reflex half; see text",
        spellResistance: "no",
        components: "V, S, M, ",
        },
        {
        level: "6",
        name: "Flame Spin",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `You summon a line of fire at the desired square, stretching out 15ft on two opposite sides. Any creature passing through the line, or who the line passes through, takes 1d6 points of fire damage per level (max 15d6), with a reflex save for half. This line can be vertical or horizontal, your choice. If you evoke the line so that it appears where creatures are, each creature takes damage as if passing through, though each such creature can avoid the wall with a reflex save (ending up on the side of its choice) and thus taking no damage. Each turn at the start of your turn the line rotates 90 degrees striking all the creatures it passes through.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "45ft line",
        effect: "45ft line of fire",
        targets: "",
        duration: "1 round/level",
        savingThrow: "reflex half or reflex negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Flurry of Ice",
        type: ["damage"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `You fire a rapid volley of ice shards, you may fire 1 shard, plus one additional shard for every 3 caster levels, to a maximum of 6 shards at caster level 15. Each shard requires its own touch attack, and each shard deals 4d6 points of cold damage. You can choose to fire the shards at different targets, and they can all be different targets as long as they are within the range of the spell. If you kill a creature with this spell you gain shards equal to half the amount you started with, which you can continue to fire, and each shard deals an additional 1d6 cold damage.`,
        castingTime: "1 standard action",
        range: "short (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "1 or more rays",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Freezing Sphere",
        type: ["damage"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `Freezing sphere creates a frigid globe of cold energy that streaks from your fingertips to the location you select, where it explodes in a 40-foot-radius burst, dealing 1d6 points of cold damage per caster level (maximum 15d6) to each creature in the area. A creature of the water subtype instead takes 1d8 points of cold damage per caster level (maximum 15d8) and is staggered for 1d4 rounds. If the freezing sphere explodes in a body of water or a liquid that is principally water (not including water-based creatures), it freezes the liquid in a 40-foot radius. This ice lasts for 1 round per caster level. Creatures that were swimming in the targeted body of water become trapped in the ice. Attempting to break free is a full-round action. A trapped creature must make a DC 25 Strength check or a DC 25 Escape Artist check to do so. the area becomes difficult terrain as long as the ice lasts. You can refrain from firing the globe after completing the spell, if you wish. Treat this as a touch spell for which you are holding the charge. You can hold the charge for as long as 1 round per level, at the end of which time the freezing sphere bursts centered on you (and you receive no saving throw to resist its effect). Firing the globe in a later round is a standard action.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "see Text",
        duration: "instantaneous or 1 round/level; see text",
        savingThrow: "Reflex half; see text",
        spellResistance: "yes",
        components: "V, S, F,",
        },
        {
        level: "6",
        name: "God's Fury",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You summon a bolt of lightning that surges with the rage of gods, which you can then launch as part of casting the spell. You can launch one bolt, plus one additional bolt for every 4 caster levels beyond 11th (to a maximum of three bolts at 19th level). Each bolt requires a ranged touch attack to hit and deals 1d6 points of damage per caster level (maximum 15d6). Half the damage is electricity damage, but the other half results directly from divine power and is therefore not subject to being reduced by electricity resistance. The bolts can be launched at the same target or at different targets, but all bolts must be launched simultaneously and aimed at targets within 30 feet of each other. Because this spell only deals half electricity damage, it scales with only half of your normal electricity spell power.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "ray",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none (see text)",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "6",
        name: "Harm",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `Harm charges a subject with negative energy that deals 10 points of damage per caster level (to a maximum of 150 points at 15th level). If the creature successfully saves, harm deals half this amount. Harm cannot reduce the target's hit points to less than 1. If used on an undead creature, harm acts like heal.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will half; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Hellfire Ray",
        type: ["damage"],
        school: "evocation",
        tags: ["evil"],
        longDesc: `A blast of hellfire blazes from your hands. You can fire one ray, plus one additional ray for every 4 caster levels beyond 11th (to a maximum of three rays at 19th level). Each ray requires a ranged touch attack to hit and deals 1d6 points of damage per caster level (maximum 15d6). Half the damage is fire damage, but the other half results directly from unholy power and is therefore not subject to being reduced by fire resistance. The rays can be fired at the same target or at different targets, but all rays must be fired simultaneously and aimed at targets within 30 feet of each other. If you have abilities that effect fire damage per dice rolled, treat the spell as if half of its damage dice are fire damage. Because this spell only deals half fire damage, it scales with only half of your normal fire spell power.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "ray",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none (see text)",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "6",
        name: "Inflict Moderate Wounds, Mass",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell functions like mass inflict light wounds, except that it deals 3d8 points of damage + 2 points per caster level (maximum +30).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "instantaneous",
        savingThrow: "Will half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Named Bullet, Greater",
        type: ["damage"],
        school: "divination",
        tags: [],
        longDesc: `You imbue the target with deadly accuracy against a selected creature type (and subtype for humanoids or outsiders) or a specific creature you know and can name. When used against the selected creature, the ammunition never misfires and is unaffected by concealment (but not total concealment), and at a range of 30 feet or less, the attack targets the selected creature's touch AC. When the target hits the selected creature, you must overcome that creature's spell resistance, or this spell has no effect. A normal hit scored using the target against the selected creature is considered to be a critical threat and deals 2 extra points of damage per caster level (maximum 40), which is not multiplied on a critical hit. A natural critical hit deals the same extra damage, but that damage is multiplied due to the critical.
        
                Once the target is used to attack the selected creature, successfully or not, this spell is discharged.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one piece of ammunition or thrown weapon",
        duration: "until discharged",
        savingThrow: "will negates (harmless,object)",
        spellResistance: "yes (harmless,object)",
        components: "V, S, M",
        },
        {
        level: "6",
        name: "Tactical Detonation",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity", "fire", "force"],
        longDesc: `Causes an unstable ball of plasma to streak towards your intended location, exploding on impact with a surface (or creature, possible requiring a ranged touch attack). The explosion deals 1d6 points of damage per level (max 20d6), half of this damage is fire damage and the other half is electricity (treat this as half the dice deal fire damage and the other half deal electricity for other abilities). This spell also deals 1d6 points of force damage per 2 caster levels, (max 10d6), this force damage is not halved on a successful save. This force explosion has an unstable effect, and the force damage is instead dealt in a radius of 1d8 x 5ft. radius burst. Creatures who fail the reflex save also fall prone, unless they are flying, in which case they must make a fly check DC equal to the force damage they took (if any) or fall 2 feet for each point they missed the DC by. Abilities that modify either a fire or electricity effect have their bonuses halved.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10ft./level)",
        area: "20-ft.-radius spread, and variable",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Undeath to Death",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell functions like circle of death, except that it destroys undead creatures as noted above.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "several undead creatures within a 40-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Acid Pool",
        type: ["damage", "control"],
        school: "transmutation",
        tags: ["acid", "earth"],
        longDesc: `You convert a layer of the ground to corrosive goo. Creatures in the area when the good appears take 1d6 points of acid damage per two caster levels (maximum of 10d6) and must succeed at a Reflex save or become entangled to the spot. An entangled creature receives a saving throw each round to free itself from the goo, but can also attempt to free itself by spending a movement action to attempt a Strength check (DC = spell saving throw DC) or Escape Artist check (DC = spell saving throw DC+10). A creature that moves into or ends its turn in the area takes 4d6 points of acid damage and must attempt this Reflex save or become entangled. The whole area is difficult terrain and the DC of Acrobatics checks within the area of effect increases by 5.. The pool of goo also periodically has large bubbles that pop and spray acidic goo around, each round at the start of your turn roll a d100, on 76 or above the goo releases a bubble, spraying acid in a 15 foot radius around the pit, all creatures within the area must make the take the acid damage again, and become entangled(though not to the spot), though they may make a reflex to halve the damage and negate the entanglement. Creatures flying with wings over the pit when it pops must make a fly check (DC= spells DC + 8) or fall into the pit.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "20-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Reflex partial, see text",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Banshee Blast",
        type: ["damage", "control"],
        school: "necromancy",
        tags: ["death", "fear", "mind-affecting", "sonic"],
        longDesc: `You create a cone of spectral energy resembling screaming elven ghosts that deals 1d4 points of damage per caster level (maximum 15d4); a successful Reflex save halves this damage. Any creature that fails its Reflex save must succeed at a Will save or become panicked for 1 round/level.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous and 1 round/level (see text)",
        savingThrow: "Reflex half and Will negates (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Cosmic Ray",
        type: ["damage", "control"],
        school: "evocation",
        tags: [],
        longDesc: `You fling a ray of deadly cosmic energy at the target creature.
                        If you succeed at a ranged touch attack with the ray, the target takes 1d6 points of damage per caster level (maximum 20d6) and must make a Fortitude save. On a failed save, the target becomes sickened for 1 round per caster level and emits toxic cosmic energy for as long as it is sickened; any creature that comes within 5 feet of the affected target must succeed at a Fortitude save (DC = spell's DC) or become sickened for 1 round per 2 caster levels.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "ray",
        targets: "",
        duration: "instantaneous and 1 round/level (see text)",
        savingThrow: "fortitude partial",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Enemy Hammer",
        type: ["damage", "control"],
        school: "transmutation",
        tags: [],
        longDesc: `You grab a creature with telekinesis and use it to batter nearby opponents or objects. You must target a specific creature when casting this spell and once you select that creature you cannot switch to another. Each round, as a standard action, you can attempt to hurl the target at any creature or object within 30 feet of it. You must make an attack roll whenever you use the target as a weapon. The attack bonus for this attack is equal to your caster level plus your highest mental modifier. If you successfully hit the new target with the creature both it and the creature take damage based on the creature's size. Creature Size Damage Dealt Fine 1d4 Diminutive 1d6 Tiny 1d8 Small 1d10 Medium 2d6 Large 2d8 Huge 2d10 Gargantuan 3d6 Colossal 3d8 The target creature can make a Fortitude saving throw each time you attempt to use it as a weapon. If it makes its saving throw it can act normally, but if it fails its save it loses all actions for the round and ends its turn prone in a square adjacent to the target of your attack. However, if the creature chooses to resist your efforts to move it, taking no other actions for the round, it gets a +4 circumstance bonus on its saving throw. The spell ends immediately if the target creature dies or is destroyed.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level (D)",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Tar Pool",
        type: ["damage", "control"],
        school: "transmutation",
        tags: ["earth", "fire"],
        longDesc: `You convert a layer of the ground to hot tar. Creatures in the area when the tar appears take 1d6 points of fire damage per two caster levels (maximum of 10d6) and must succeed at a Reflex save or become entangled. An entangled creature receives a saving throw each round to free itself from the tar, and can also attempt to free itself by spending a move action to attempt a Strength check or Escape Artist check (DC = spell saving throw DC). It costs 2 squares of movement to enter a square in the area of effect, and the DC of Acrobatics checks within the area of effect increases by 5. The area is difficult terrain. A creature that moves into or starts its turn in the area takes 2d6 points of fire damage and must reattempt this Reflex save or become entangled. A creature that falls prone in the area takes a -4 penalty on its Reflex save against the tar and on Strength and Escape Artist checks to escape the tar. A creature that escapes the tar still takes fire damage from the tar until the spell ends or that creature spends a full-round action removing the tar. A creature with tar on it takes a -4 penalty on Acrobatics and Fly checks made to fly with wings or similar appendages.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "20-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Reflex partial, see text",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Call to the Earth",
        type: ["damage", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You massively increase gravity on a flying creature attempting to pull them to earth. The target must make a reflex save or immediately be slammed into the ground, taking 3d6 points of damage for each 10 ft. above the ground it was. It takes no additional falling damage. If it succeeds the reflex save, it takes 1d6 per 10 ft. above the ground it was, and must instead make a fly check DC equal to the DC of this spell +10. If it fails this fly check it falls 5 feet per caster level/2. You must be on the ground to cast this spell, and it can only target a creature that is within 10ft./level of the ground.`,
        castingTime: "1 standard action",
        range: "medium (100ft + 10ft/ level)",
        area: "",
        effect: "",
        targets: "1 flying creature",
        duration: "instantaneous",
        savingThrow: "Reflex partial",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "6",
        name: "Decapitate",
        type: ["damage", "utility"],
        school: "evocation",
        tags: [],
        longDesc: `You can cast this spell only as a response to a confirmed critical hit against the target that would deal slashing damage. If the target fails the saving throw and has a discernible head, the attack deals an extra 4d6 points of damage and the critical multiplier of the critical hit increases by 1. If the critical hit then brings the target to 0 hit points or fewer, the target is instantly decapitated and dies unless it can survive decapitation. Even on a successful saving throw, the critical hit deals an extra 4d6 points of damage.`,
        castingTime: "1 immediate action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature (see text)",
        duration: "instantaneous",
        savingThrow: "Fortitude partial (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Elemental Assessor",
        type: ["damage", "utility"],
        school: "evocation",
        tags: ["acid", "cold", "electricity", "fire"],
        longDesc: `A ray of spiraling colors springs from your hand and streaks to its target. You must make a successful ranged touch attack to hit your target with the ray, which deals 3d6 points of acid damage, 3d6 points of cold damage, 3d6 points of electricity damage, and 3d6 points of fire damage. The type of energy that does the most points of damage to the target then persists, dealing another 6d6 points of that type of damage per round for 1d4 rounds.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one elemental ray",
        targets: "",
        duration: "1d4+1 rounds (see text)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Seismic Stomp",
        type: ["damage", "utility"],
        school: "evocation",
        tags: ["earth", "force"],
        longDesc: `You stomp on a creature, delivering a massive amount of kinetic energy. This requires requires a touch attack, If you succeed you deal 1d6 points of bludgeoning damage per caster level (max 15d6), and it must make a reflex save or be launched away from you, moving feet equal to the result of your attack roll. If your attack roll is a critical hit, the DC for the reflex save also increases by 2 * your critical multiplier and your effective attack to determine how far it moves increases by 25% * your critical multiplier. If the creature strikes a wall both it and the the creature takes additional untyped damage equal to the amount of feet it had left to travel. If this damage destroys the wall, the creature only takes damage up to what it took to destroy the wall, but then keeps moving. This spell can also be cast to launch creatures towards the ground, to do so you must be at a higher elevation than the creature, but they instead move downwards feet equal to 2x the attack roll, and the DC of the reflex save is increased by +4.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "instantaneous",
        savingThrow: "reflex half partial;see text",
        spellResistance: "no",
        components: "V, S",
        },
        {
        level: "5",
        name: "Cure Moderate Wounds, Mass",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell functions like mass cure light wounds, except that it cures 3d8 points of damage + 2 points per caster level (maximum +30).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "instantaneous",
        savingThrow: "Will half (harmless) or Will half; see text",
        spellResistance: "yes (harmless) or yes; see text",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Heal",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `Heal enables you to channel positive energy into a creature to wipe away injury and afflictions. It immediately ends any and all of the following adverse conditions affecting the target: ability damage, blinded, confused, dazed, dazzled, deafened, diseased, exhausted, fatigued, feebleminded, insanity, nauseated, poisoned, sickened, and stunned. It also cures 10 hit points of damage per level of the caster, to a maximum of 150 points at 15th level. Heal does not remove negative levels or restore permanently drained ability score points. If used against an undead creature, heal instead acts like harm.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Stone to Flesh",
        type: ["healing"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell restores a petrified creature to its normal state, restoring life and goods. The creature must make a DC 15 Fortitude save to survive the process. Any petrified creature, regardless of size, can be restored. The spell also can convert a mass of stone into a fleshy substance. Such flesh is inert and lacking a vital life force unless a life force or magical energy is available.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one petrified creature or a cylinder of stone from 1 ft. to 3 ft. in diameter and up to 10 ft. long",
        duration: "instantaneous",
        savingThrow: "Fortitude negates (object); see text",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Inspiring Recovery",
        type: ["healing", "buff"],
        school: "conjuration(healing)",
        tags: ["mind-affecting"],
        longDesc: `You can heal a creature, harm an undead creature, or call upon a very recently dead creature to fight beyond death's reach. The target creature regains 1d8 hit points per 2 caster levels (maximum 10d8).
        
                    This healing can even bring back to life creatures that have been dead within the previous 1 round (but they cannot have been dead for any longer). If you apply this spell's healing to such a creature and its hit point total is at a negative amount less than its Constitution score, it comes back to life and stabilizes at its new hit point total. If you awaken a dead creature in this way, all allies of that creature within 60 feet who can see it regain consciousness gain a +2 morale bonus on attack rolls, damage rolls, and saving throws for 1 minute thereafter, as the healing powers of your deity have imbued them with renewed vigor. Creatures restored to life this way gain 1 negative level as breath of life.
                    
                    Creatures killed by death effects cannot be revived this way. This spell deals damage to undead creatures rather than curing them, and it cannot bring them back to life.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one target creature and all its allies within 60 feet; see text",
        duration: "instantaneous and 1 minute",
        savingThrow: "Will half (harmless);",
        spellResistance: "yes (harmless)",
        components: "V, S, DF",
        },
        {
        level: "6",
        name: "Music of the Spheres",
        type: ["healing", "buff"],
        school: "conjuration(healing)",
        tags: ["sonic"],
        longDesc: `With this spell, one can amplify the underlying music of the spheres in the spell's area of effect to infuse yourself and all creatures within 20 feet of you, friend and foe alike. All creatures that begin their turn within the area of this spell's effect gain fast healing 10, resistance 20 to all energy types, and a +3 sacred bonus on all saving throws. Any creature that enters the area of effect does not gain the benefits of the music of the spheres until it begins its turn in that area. You must maintain concentration on the amplification of the music (after the initial duration) or the effects immediately end, but you can move around to prevent enemies from gaining the benefits of this spell.`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "20-ft.-radius spherical emanation, centered on you",
        effect: "",
        targets: "",
        duration: "3 rounds, + concentration, up to 1 round per level",
        savingThrow: "none",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Withdraw Affliction",
        type: ["healing", "control"],
        school: "necromancy",
        tags: [],
        longDesc: `You push your hand into the subject, then withdraw an affliction from the body of the sufferer as a tangible object.
        
                This extraction appears as a slimy mass of flesh. The target creature is cured as if affected by remove disease, remove curse, or neutralize poison.
                
                In addition, this slimy mass allows you to deliver the affliction to another as a touch attack, as if holding the charge for a touch spell. It has the same effect as the original affliction, with the same saving throw and DC.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one afflicted creature",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "6",
        name: "Analyze Dweomer",
        type: ["utility"],
        school: "divination",
        tags: [],
        longDesc: `You can observe magical auras. Each round, you may examine a single creature or object that you can see as a free action. In the case of a magic item, you learn its functions (including any curse effects), how to activate its functions (if appropriate), and how many charges are left (if it uses charges). In the case of an object or creature with active spells cast upon it, you learn each spell, its effect, and its caster level. An attended object may attempt a Will save to resist this effect if its holder so desires. If the save succeeds, you learn nothing about the object except what you can discern by looking at it. An object that makes its save cannot be affected by any other analyze dweomer spells for 24 hours.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one object or creature per caster level",
        duration: "1 round/level",
        savingThrow: "none or Will negates; see text",
        spellResistance: "no",
        components: "V, S, F,",
        },
        {
        level: "6",
        name: "Animate Objects",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You imbue inanimate objects with mobility and a semblance of life. Each such animated object then immediately attacks whomever or whatever you initially designate. An animated object can be of any nonmagical material. You may animate one Small or smaller object or a corresponding number of larger objects as follows: A Medium object counts as two Small or smaller objects, a Large object as four, a Huge object as eight, a Gargantuan object as 16, and a Colossal object as 32. You can change the designated target or targets as a move action, as if directing an active spell. See https://www.d20pfsrd.com/bestiary/monster-listings/constructs/animated-object/ for the statistics of animated objects. This spell cannot affect objects carried or worn by a creature.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one Small object per caster level; see text",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Antilife Shell",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `You bring into being a mobile, hemispherical energy field that prevents the entrance of most types of living creatures. The effect hedges out animals, aberrations, dragons, fey, giants, humanoids, magical beasts, monstrous humanoids, oozes, plants, and vermin, but not constructs, elementals, outsiders, or undead. This spell may be used only defensively, not aggressively. Forcing an abjuration barrier against creatures that the spell keeps at bay collapses the barrier.`,
        castingTime: "1 round",
        range: "10 ft.",
        area: "10-ft.-radius emanation, centered on you",
        effect: "",
        targets: "",
        duration: "1 min./level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "7",
        name: "Antimagic Field",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `An invisible barrier surrounds you and moves with you. The space within this barrier is impervious to most magical effects, including spells, spell-like abilities, and supernatural abilities. Likewise, it prevents the functioning of any magic items or spells within its confines. An antimagic field suppresses any spell or magical effect used within, brought into, or cast into the area, but does not dispel it. Time spent within an antimagic field counts against the suppressed spell's duration. Summoned creatures of any type wink out if they enter an antimagic field. They reappear in the same spot once the field goes away. Time spent winked out counts normally against the duration of the conjuration that is maintaining the creature. If you cast antimagic field in an area occupied by a summoned creature that has spell resistance, you must make a caster level check (1d20 + caster level) against the creature's spell resistance to make it wink out. (The effects of instantaneous conjurations are not affected by an antimagic field because the conjuration itself is no longer in effect, only its result.) A normal creature can enter the area, as can normal missiles. Furthermore, while a magic sword does not function magically within the area, it is still a sword (and a masterwork sword at that). The spell has no effect on golems and other constructs that are imbued with magic during their creation process and are thereafter self-supporting (unless they have been summoned, in which case they are treated like any other summoned creatures). Elementals, undead, and outsiders are likewise unaffected unless summoned. These creatures' spell-like or supernatural abilities may be temporarily nullified by the field. Dispel magic does not remove the field. Two or more antimagic fields sharing any of the same space have no effect on each other. Certain spells, such as wall of force, prismatic sphere, and prismatic wall, remain unaffected by antimagic field. Artifacts and deities are unaffected by mortal magic such as this. Should a creature be larger than the area enclosed by the barrier, any part of it that lies outside the barrier is unaffected by the field.`,
        castingTime: "1 standard action",
        range: "10 ft.",
        area: "10-ft.-radius emanation, centered on you",
        effect: "",
        targets: "",
        duration: "10 min./level (D)",
        savingThrow: "none",
        spellResistance: "see text",
        components: "V, S, M,DF,",
        },
        {
            level: "7",
            name: "Envelop",
            type: ["utility"],
            school: "abjuration",
            tags: [],
            longDesc: `An invisible barrier surrounds the target, protecting it from the extremes of damage. It cannot take more than 20% its max hit points in damage from any single attack. This applies after and DR or resistances reduce damage.`,
            castingTime: "1 standard action",
            range: "close (25ft. + 5ft/2 levels)",
            area: "",
            effect: "",
            targets: "1 creature",
            duration: "1 round + 1 round/9 levels",
            savingThrow: "will negates",
            spellResistance: "yes",
            components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Banishment",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `A banishment spell is a more powerful version of the dismissal spell. It enables you to force extraplanar creatures out of your home plane permanently if it fails the safe. If the creature has the ability to cast plane shift, if will still return the following round when it casts it.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one extraplanar creature",
        duration: "instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, F,",
        },
        {
        level: "6",
        name: "Bard's Escape",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `You whisk yourself and willing allies out of a tight jam, or instantly transfer yourselves to another location to achieve greater strategic positioning. You can move any allies within range to any other space of your choosing within range. Those spaces need not be in line of sight or line of effect from your original position, but must be open locations on surfaces able to support the creatures teleported. Except as noted above, this spell otherwise functions as dimension door.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "you and up to 1 willing creature/2 caster levels, no two of which can be more than 30 ft. apart",
        duration: "instantaneous",
        savingThrow: "",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Conjure Black Pudding",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: ["acid"],
        longDesc: `You summon a black pudding that immediately attacks creatures near it. You have no control over the creature, and it may attack you if there are no more obvious opponents. The black pudding is treated as a summoned creature and has the extraplanar subtype. The black pudding's split ability works normally, but all puddings derived from the summoned one disappear when the spell ends.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 level)",
        area: "",
        effect: "one summoned black pudding",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Contingency",
        type: ["utility"],
        school: "evocation",
        tags: [],
        longDesc: `You can place another spell upon your person so that it comes into effect under some condition you dictate when casting contingency, additionally you can cast contingency while decending floors, however it costs 3x the spell points, and cannot be a spell that takes longer than a standard action to cast. The contingency spell and the companion spell are cast at the same time. If the companion spell has a casting time longer than 1 round, use that instead. You must pay any costs associated with the companion spell when you cast contingency. The spell to be brought into effect by the contingency must be one that affects your person and be of a spell level no higher than one-third your caster level (rounded down, maximum 6th level). The conditions needed to bring the spell into effect must be clear, although they can be general. In all cases, the contingency immediately brings into effect the companion spell, the latter being 'cast' instantaneously when the prescribed circumstances occur. If complicated or convoluted conditions are prescribed, the whole spell combination (contingency and the companion magic) may fail when triggered. The companion spell occurs based solely on the stated conditions, regardless of whether you want it to. You can use only one contingency spell at a time; if a second is cast, the first one (if still active) is dispelled.`,
        castingTime: "At the start of each floor or 2 rounds",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 day/level (D) or until discharged",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Create Undead",
        type: ["utility"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `A much more potent spell than animate dead, this evil spell allows you to infuse a dead body with negative energy to create more powerful sorts of undead: ghouls, ghasts, mummies, and mohrgs. The type or types of undead you can create are based on your caster level, as shown on the table below. Caster Level Undead Created 11th or lower Ghoul 12th-14th Ghast 15th-17th Mummy 18th or higher Mohrg You may create less powerful undead than your level would allow if you choose. Created undead are not automatically under the control of their animator. If you are capable of commanding undead, you may attempt to command the undead creature as it forms. This spell must be cast at night.`,
        castingTime: "1 hour",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one corpse",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Cruel Jaunt",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: ["evil", "fear", "mind-affecting"],
        longDesc: `You gain the ability to detect fear, as per sense fear (see page 127), but you sense creatures within medium range. Once per round as a standard action, you can teleport to a creature suffering from a fear effect within the spell's range if you are aware of the creature and its rough location. You can carry objects with you so long as you don't transport more than your maximum load. You arrive in a random open space within 20 feet of the creature and immediately begin sensing the location of creatures with a fear condition from your new location. Once you teleport to a new location with this spell, you can take no additional actions for the round, as if casting dimension door. You can't teleport if there are no creatures suffering from a fear effect in range.`,
        castingTime: "1 standard action",
        range: "medium (100 feet + 10 ft./level)",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Dispel Magic, Greater",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions like dispel magic, except that it can end more than one spell on a target and it can be used to target multiple creatures. You choose to use greater dispel magic in one of three ways: a targeted dispel, area dispel, or a counterspell: Targeted Dispel: This functions as a targeted dispel magic, but it can dispel one spell for every four caster levels you possess, starting with the highest level spells and proceeding to lower level spells. Additionally, greater dispel magic has a chance to dispel any effect that remove curse can remove, even if dispel magic can't dispel that effect. The DC of this check is equal to the curse's DC. Area Dispel: When greater dispel magic is used in this way, the spell affects everything within a 20-foot-radius burst. Roll one dispel check and apply that check to each creature in the area, as if targeted by dispel magic. For each object within the area that is the target of one or more spells, apply the dispel check as with creatures. Magic items are not affected by an area dispel. For each ongoing area or effect spell whose point of origin is within the area of the greater dispel magic spell, apply the dispel check to dispel the spell. For each ongoing spell whose area overlaps that of the greater dispel magic spell, apply the dispel check to end the effect, but only within the overlapping area. If an object or creature that is the effect of an ongoing spell (such as a monster summoned by summon monster) is in the area, apply the dispel check to end the spell that conjured that object or creature (returning it whence it came) in addition to attempting to dispel one spell targeting the creature or object. You may choose to automatically succeed on dispel checks against any spell that you have cast. Counterspell: This functions as dispel magic, but you receive a +4 bonus on your dispel check to counter the other spellcaster's spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "20-ft.-radius burst",
        effect: "",
        targets: "one spellcaster, creature, or object",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Eagle Aerie",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: ["good"],
        longDesc: `You summon a flight of giant eagles (one per three caster levels, maximum of six; Bestiary 118) to ferry you and your allies across the skies. The eagles avoid combat if possible but defend themselves if attacked; if the eagles attack, the remaining duration of the spell changes from 1 hour per level to 1 round per level (so if the spell had 5 full hours left, the eagles remain in combat for 5 rounds before the spell ends).`,
        castingTime: "1 round",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "summoned eagles",
        targets: "",
        duration: "1 hour/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "6",
        name: "Ether Step",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You step into the Ethereal Plane long enough to dodge a blow or confound a spell; you must cast ether step after you are targeted by an attack or effect but before you learn the results of the attack or effect. This spell functions as ethereal jaunt, except that you become ethereal until the beginning of your next turn. On the turn after you cast this spell and return to your starting point, you can take only move actions or free actions.`,
        castingTime: "1 immediate action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "see text",
        savingThrow: "",
        spellResistance: "",
        components: "S, ",
        },
        {
        level: "6",
        name: "Flesh Wall",
        type: ["utility"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `You animate corpses, forming them into a wall of joined flesh and limbs. The wall inserts itself into any surrounding nonliving material if its area is sufficient to do so. The wall can't be created so that it occupies the same space as a creature or another object. The wall must be vertical, but can be shaped as you see fit. The wall is considered to be undead. It uses your Will saving throw to resist channel energy. A flesh wall is 2 feet thick. Each 5-foot square of the wall has 12 hit points and DR 5/slashing. A section of wall whose hit points drop to 0 is breached. As a move action, you can cause the fleshwall to constrict, shrinking it by a 5-foot square to fill the hole. Additionally, as a standard action, you can cause a 5-foot square of the wall to permanently detach, forming a human zombie (Bestiary 288) under your verbal control (this zombie doesn't count against your normal limit of commanded undead). The zombie reverts back into a normal corpse when the spell's effect ends. Each 5-foot square of the wall makes a single slam attack against an adjacent enemy on your turn, as a human zombie. The squares of the wall threaten their adjacent squares and can even provide flanking. Creatures can force their way slowly through the wall by making a Strength check as a full-round action. The DC to move through the wall is equal to 15 + your caster level. A creature that fails the check is trapped in the wall, takes 3d6 points of crushing damage, and is denied its Dexterity bonus to AC against the wall's slam attack. The creature can make an attempt to escape the wall on its next turn. You can use zombies already under your control as the material components for a flesh wall. However, they and any other corpses in the wall revert back to inanimate corpses when the spell ends.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "a wall of corpses with an area of up to one 5-ft. square/ level (S)",
        targets: "",
        duration: "concentration + 1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "6",
        name: "Getaway",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `You specify a 5ft square within 30 feet of you, then all allies you touch while casting the spell can use a swift action to teleport to the location. This teleportation also automatically triggers if the creature goes unconcious, dies or becomes helpless. A creature can only teleport a single time per casting of getaway. You can at any time spend a standard action to teleport all willing creatures (that haven't teleported yet) to the getaway location. Creatures appear adjacent to the nearest empty square if the 5ft square is full.`,
        castingTime: "full round action",
        range: "touch, 30ft, and unlimited",
        area: "",
        effect: "",
        targets: "You",
        duration: "1 hour/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Hardening",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell increases the hardness of materials by 1 point per 2 caster levels. The hardening spell does not in any way affect resistance to other forms of transformation. This spell cannot affect an item multiple times.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one weapon or armor",
        duration: "permanent",
        savingThrow: "none",
        spellResistance: "yes (object)",
        components: "V, S",
        },
        {
        level: "6",
        name: "King's Castle",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `This spell allows you to switch places with an ally. When you cast this spell, choose a single ally within range. You teleport to your ally's space while your ally teleports to your former space. If they were physically restrained in any way that being teleported would free them from, you take on those restraints (such as being chained up, grappled, etc.)`,
        castingTime: "1 movement action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "will negates(harmless)",
        spellResistance: "yes (harmless)",
        components: "V,S,M",
        },
        {
        level: "6",
        name: "Litany of Truth",
        type: ["utility"],
        school: "divination",
        tags: ["language-dependent"],
        longDesc: `With a tirade against deceit, you strip the target of any illusions cloaking it. Any illusion spells or effects affecting the target are suppressed for the spell's duration. In addition, the target can't benefit from concealment. While subject to this spell, the target cannot be the target of another spell that has the word “litany” in the title.`,
        castingTime: "1 swift action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "6",
        name: "Mislead",
        type: ["utility"],
        school: "illusion(figment, glamer)",
        tags: [],
        longDesc: `You become invisible (as greater invisibility, a glamer), and at the same time, an illusory double of you (as major image, a figment) appears. You are then free to go elsewhere while your double moves away. The double appears within range but thereafter moves as you direct it (which requires concentration beginning on the first round after the casting). You can make the figment appear superimposed perfectly over your own body so that observers don't notice an image appearing and you turning invisible. You and the figment can then move in different directions. The double moves at your speed and can talk and gesture as if it were real, but it cannot attack or cast spells, though it can pretend to do so. The illusory double lasts as long as you concentrate upon it, plus 3 additional rounds. After you cease concentration, the illusory double continues to carry out the same activity until the duration expires. The greater invisibility lasts for 1 round per level, regardless of concentration.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one illusory double",
        targets: "you",
        duration: "1 round/level (D) and concentration + 3 rounds; see text",
        savingThrow: "none or Will disbelief (if interacted with); see text",
        spellResistance: "no",
        components: "S, ",
        },
        {
        level: "6",
        name: "Path of the Winds",
        type: ["utility"],
        school: "evocation",
        tags: ["air"],
        longDesc: `With a sweeping gesture, you call forth mighty winds to clear a path ahead of you. The winds are the equivalent of a windstorm. During the first round of the spell, the winds sweep the designated area clear of anything of Small or smaller size, blowing it outward to the sides of the spell's effect (50% chance of landing on either side). You may move within the effect without penalty, though all other creatures are subject to the wind's effects. On the second and all later rounds of the spell, the edges of the effect are treated as a wind wall. If the effect includes a body of water or other liquid, the winds create a channel up to 40 feet deep into the surface of the liquid. On your turn as a move action, you can move the effect of this spell, either rotating it at one of its ends up to 45 degrees, or moving it up to 50 feet in line with its current orientation (toward you or away from you).`,
        castingTime: "1 standard action",
        range: "100 ft.",
        area: "",
        effect: "40-ft.-high downdraft of wind in a 100-foot line",
        targets: "",
        duration: "concentration + 1 round",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Programmed Image",
        type: ["utility"],
        school: "illusion(figment)",
        tags: [],
        longDesc: `This spell functions like silent image, except that this spell's figment activates when a specific condition occurs. The figment includes visual, auditory, olfactory, and thermal elements, including intelligible speech. You set the triggering condition (which may be a special word) when casting the spell. The event that triggers the illusion can be as general or as specific and detailed as desired but must be based on an audible, tactile, olfactory, or visual trigger. The trigger cannot be based on some quality not normally obvious to the senses, such as alignment. See magic mouth for more details about such triggers.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "visual figment that cannot extend beyond a 20-ft. cube + one 10-ft. cube/level (S)",
        targets: "",
        duration: "permanent until triggered, then 1 round/level",
        savingThrow: "Will disbelief (if interacted with)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Source Severance",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `You create an invisible barrier that surrounds you and moves with you, inhibiting one category of magic. When you cast this spell, choose either arcane or divine magic. This spell functions like antimagic field, but it suppresses only spells of the chosen type and supernatural and spell-like class abilities from classes that grant spellcasting of the selected type. Magic items, other spell-like abilities, and other supernatural abilities are unaffected. While this spell is in effect, you must succeed at a concentration check (DC 20 + twice the spell level) to cast any spell, whether arcane or divine. If you fail at the check, you lose the spell as if you had cast it to no effect.`,
        castingTime: "1 standard action",
        range: "5 feet",
        area: "5-ft.-radius emanation, centered on you",
        effect: "",
        targets: "",
        duration: "10 minutes/level (D)",
        savingThrow: "none",
        spellResistance: "see text",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Summon Monster VI",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell summons an extraplanar creature (typically an outsider, elemental, or magical beast native to another plane). It appears where you designate and acts immediately, on your turn. It attacks your opponents to the best of its ability. If you can communicate with the creature, you can direct it not to attack, to attack particular enemies, or to perform other actions. The spell conjures one of the creatures from the level on Table from: https://www.d20pfsrd.com/magic/all-spells/s/summon-monster/ of the level equal to the level of this spell. Alternatively you can choose to summon 1d3 creatures from the list 1 level below, or 1d4+1 creatures from a list at least 2 levels lower. You choose which kind of creature to summon (one type of creature at a time if you are summoning multiple) but can only summon creatures from the core list (not alternative options), and you can choose a different one each time you cast the spell. A summoned monster cannot summon or otherwise conjure another creature, nor can it use any teleportation or planar travel abilities. Creatures cannot be summoned into an environment that cannot support them. Creatures summoned using this spell cannot use spells or spell-like abilities that duplicate spells with expensive material components (such as wish). When you use a summoning spell to summon a creature with an alignment or elemental subtype, it is a spell of that type. Creatures marked with an "*" are summoned with the celestial template, if you are good, and the fiendish template, if you are evil. If you are neutral, you may choose which template to apply to the creature. Creatures marked with an "*" always have an alignment that matches yours, regardless of their usual alignment. Summoning these creatures makes the summoning spell's type match your alignment.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, F,DF,",
        },
        {
        level: "6",
        name: "Summon Nature's Ally VI",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions like summon nature's ally I, except that you can summon one 6th-level creature, 1d3 5th-level creatures of the same kind, or 1d4+1 lower-level creatures of the same kind.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "6",
        name: "Summon Stampede",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `You conjure a herd of aurochs or similar herd animal that immediately stampedes in the direction you indicate. The herd takes up a 20-foot-radius space and moves at a rate of 120 feet per round in a straight line. Any creatures caught in the herd's path take 4d6+9 points of damage that round as they are trampled beneath dozens of animals' hooves. A successful Reflex save halves this damage. If the stampede's path would put it in an obviously dangerous area (such as over a cliff or through a fire) or force it to move through a solid barrier, the herd stops at the obstacle and moves in a new randomly determined direction until it reaches another obstacle or the spell's duration ends.`,
        castingTime: "1 round",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "20-ft.-radius herd of animals",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Reflex halves (see text)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Summon Vanth",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions like summon monster, except that it summons a single vanth psychopomp.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned vanth psychopomp",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "6",
        name: "Swarm Skin",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You convert all of your soft tissue into swarms of insects or other creatures and send them off to do your bidding, leaving nothing but your bones and gear behind. These swarms have all their normal qualities and abilities but also bear a tiny portion of your consciousness that allows you to perceive what they do and to control their actions. While in this form, you cannot use any of your own abilities or take any actions other than controlling the swarms. Each time you cast this spell you get a total allotment of levels equal to your caster level and any swarm you choose to create costs one or more of those levels. You can "spend" your allotment of levels to create any combination of swarms so long as their total does not exceed your caster level. Number of Levels S warm Type(s) 2 caster levels Spider swarm 4 caster levels Rat swarm (Bestiary 232) 6 caster levels Crab swarm, wasp swarm (Bestiary 50, 275) 8 caster levels Centipede swarm, leech swarm (Bestiary 43, 187) 10 caster levels Army ant swarm (Bestiary 16) Once you create these swarms they remain in existence until destroyed or you order them to return to your body. When all swarms have returned to your body or are destroyed, your flesh wraps itself back around your bones and you regain the ability to act normally. If your bones are not where you left them you must first locate them in order to regain access to your body. You always know if your bones are destroyed and your consciousness remains in control of the swarms until they too are destroyed (and your die). If you can use the swarms to get help and arrange for someone to repair your bones (using anything that would normally restore you to life), at which point you can return the swarms to your body.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "see text",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M, DF",
        },
        {
        level: "6",
        name: "Symbol of Teleportation",
        type: ["utility"],
        school: "conjuration (teleportation)",
        tags: [],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to teleport within the area of the rune. It can continue being triggered until it has teleported creatures equal to your caster level/4. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 16 + your level/2, but it cannot be activated more than once per round. You can only have a single symbol of teleportation active at a time.`,
        castingTime: "1 standard action",
        range: "5 ft. then 10-feet radius;",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Teleport Greater",
        type: ["utility"],
        school: "conjuration (teleportation)",
        tags: [],
        longDesc: `This spell instantly transports you to a designated destination. You can bring along objects as long as their weight doesn't exceed your maximum load. You may also bring one additional willing Medium or smaller creature (carrying gear or objects up to its maximum load) or its equivalent per three caster levels. A Large creature counts as two Medium creatures, a Huge creature counts as four Medium creatures, and so forth. All creatures to be transported must be in contact with one another, and at least one of those creatures must be in contact with you. Only objects held or in use (attended) by another person receive saving throws and spell resistance. If the squares you try to teleport to do not have enough space to fit you, you appear in the closest safe square, this applies to all creatures travelling with you.`,
        castingTime: "1 standard action",
        range: "personal and touch",
        area: "",
        effect: "",
        targets: "you and touched objects or other touched willing creatures",
        duration: "instantaneous",
        savingThrow: "none and Will negates (object)",
        spellResistance: "no and yes (object)",
        components: "V, ",
        },
        {
        level: "6",
        name: "Veil",
        type: ["utility"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `You instantly change the appearance of the subjects and then maintain that appearance for the spell's duration. You can make the subjects appear to be anything you wish. The subjects look, feel, and smell just like the creatures the spell makes them resemble. Affected creatures resume their normal appearances if slain. You must succeed on a Disguise check to duplicate the appearance of a specific individual. This spell gives you a +10 bonus on the check. Unwilling targets can negate the spell's effect on them by making Will saves or with spell resistance. Those who interact with the subjects can attempt Will disbelief saves to see through the glamer, but spell resistance doesn't help. The first time you attack a creature you can make a bluff or diplomacy check vs their sense motive, if you succeed the attack catches them flat-footed.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "one or more creatures, no two of which can be more than 30 ft. apart",
        duration: "concentration + 1 hour/level",
        savingThrow: "Will negates; see text",
        spellResistance: "yes; see text",
        components: "V, S, ",
        },
        {
        level: "6",
        name: "Wall of Iron",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You cause a flat, vertical iron wall to spring into being. The wall inserts itself into any surrounding nonliving material if its area is sufficient to do so. The wall cannot be conjured so that it occupies the same space as a creature or another object. It must always be a flat plane, though you can shape its edges to fit the available space. A wall of iron is 1 inch thick per four caster levels. You can double the wall's area by halving its thickness. Each 5-foot square of the wall has 30 hit points per inch of thickness and hardness 10. A section of wall whose hit points drop to 0 is breached. If a creature tries to break through the wall with a single attack, the DC for the Strength check is 25 + 2 per inch of thickness. If you desire, the wall can be created vertically resting on a flat surface but not attached to the surface, so that it can be tipped over to fall on and crush creatures beneath it. The wall is 50% likely to tip in either direction if left unpushed. Creatures can push the wall in one direction rather than letting it fall randomly. A creature must make a DC 40 Strength check to push the wall over. Creatures with room to flee the falling wall may do so by making successful Reflex saves. Any Large or smaller creature that fails takes 10d6 points of damage while fleeing from the wall. The wall cannot crush Huge and larger creatures. Like any iron wall, this wall is subject to rust, perforation, and other natural phenomena. Iron created by this spell is not suitable for use in the creation of other objects and cannot be sold.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "iron wall whose area is up to one 5-ft. square/level; see text",
        targets: "",
        duration: "instantaneous",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Enlightened Step",
        type: ["utility", "buff"],
        school: "transmutation",
        tags: ["air", "medatative"],
        longDesc: `Through careful regulation of your body's mystical energies, thoughtful control of your poise and balance, and the focus in your mind on the surety of each and every step you take, you are able to make your steps lighter than air. This grants you the benefits of air walk, except as noted above. Additionally, at any time during the spell's duration, you can expend the spell's remaining duration as a swift action in order to gain a fly speed of 120 feet with perfect maneuverability for 1 minute. After this time, the spell ends.`,
        castingTime: "1 full round action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "24 hours or until discharged",
        savingThrow: "",
        spellResistance: "",
        components: "V, M, ",
        },
        {
        level: "6",
        name: "True Seeing",
        type: ["utility", "buff"],
        school: "divination",
        tags: [],
        longDesc: `You confer on the subject the ability to see all things as they actually are. The subject sees through normal and magical darkness, notices secret doors hidden by magic, sees the exact locations of creatures or objects under blur or displacement effects, sees invisible creatures or objects normally, sees through illusions, and sees the true form of polymorphed, changed, or transmuted things. Further, the subject can focus its vision to see into the Ethereal Plane (but not into extradimensional spaces). The range of true seeing conferred is 120 feet. True seeing, however, does not penetrate solid objects. It in no way confers X-ray vision or its equivalent. It does not negate concealment, including that caused by fog and the like. True seeing does not help the viewer see through mundane disguises, spot creatures who are simply hiding, or notice secret doors hidden by mundane means. In addition, the spell effects cannot be further enhanced with known magic, so one cannot use true seeing through a crystal ball or in conjunction with clairaudience/clairvoyance.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Wind Walk",
        type: ["utility", "buff"],
        school: "transmutation",
        tags: ["air"],
        longDesc: `You alter the substance of your body to a cloudlike vapor (as the gaseous form spell) and move through the air, possibly at great speed. You can take other creatures with you, each of which acts independently. Normally, a wind walker flies at a speed of 10 feet with perfect maneuverability. If desired by the subject, a magical wind wafts a wind walker along at up to 600 feet per round (60 mph) with poor maneuverability. Wind walkers are not invisible but rather appear misty and translucent. If fully clothed in white, they are 80% likely to be mistaken for clouds, fog, vapors, or the like. A wind walker can regain its physical form as desired and later resume the cloud form. Each change to and from vaporous form takes 5 rounds, which counts toward the duration of the spell (as does any time spent in physical form). As noted above, you can dismiss the spell, and you can even dismiss it for individual wind walkers and not others. For the last minute of the spell's duration, a wind walker in cloud form automatically descends 60 feet per round (for a total of 600 feet), though it may descend faster if it wishes. This descent serves as a warning that the spell is about to end.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "you and one touched creature per three levels",
        duration: "1 hour/level ; see text",
        savingThrow: "none and Will negates (harmless)",
        spellResistance: "no and yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "6",
        name: "Symbol of Distraction",
        type: ["utility", "control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to attempt to fascinate all creatures within 20 feet of the rune for 1 round per level. It can continue being triggered until it has targeted creatures equal to your level, or been activated 5 times. When it activates it activates in a burst, affecting the closest creatures first. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 16 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 20 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "will save",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Symbol of Fear",
        type: ["utility", "control"],
        school: "necromancy",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to attempt to panic all creatures within 15 feet of the rune for 1 round per level. It can continue being triggered until it has targeted creatures equal to your level, or been activated 5 times. When it activates it activates in a burst, affecting the closest creatures first. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 16 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 15 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "will save",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "6",
        name: "Symbol of Persuasion",
        type: ["utility", "control"],
        school: "enchantment(charm)",
        tags: ["mind-affecting"],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to attempt to charm all creatures within 20 feet of the rune for 1 round per level, charming them with by whoever spoke the command word. It can continue being triggered until it has targeted creatures equal to your level, or been activated 5 times. When it activates it activates in a burst, affecting the closest creatures first. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 16 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word. (This uses akashic paths charm rules)`,
        castingTime: "1 standard action",
        range: "5 ft.; then 20 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "will save",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Bestow Grace of the Champion",
        type: ["buff"],
        school: "transmutation",
        tags: ["good"],
        longDesc: `You channel the power of good and law into the target, temporarily giving it powers similar to those of a paladin. The target gains the ability to use detect evil at will as a spell-like ability, immunity to disease (suppressing any diseases currently affecting it), and immunity to fear (ending any fear effects currently affecting it); can lay on hands (on itself only) once as a paladin of 1/2 your caster level; and can smite evil once as a paladin of 1/2 your caster level. It adds its highest mental bonus to all its saving throws. Any abilities not used by the time the spell expires are lost. If this spell is cast by an evil caster it instead allows the target to use detect good, smite good, and touch of corruption. Neutral casters cannot cast this spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "lawful creature touched",
        duration: "1 round/level (see text)",
        savingThrow: "yes (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "7",
        name: "Bestow Planar Infusion III",
        type: ["buff"],
        school: "evocation",
        tags: [],
        longDesc: `This functions as bestow planar infusion I, except that the touched creature gains the greater infusion of the current plane.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 hour/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Dance of a Thousand Cuts",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You become a lethal combat dancer, swirling and spinning with grace and precision.
                
        You gain the benefits of haste and a morale bonus on melee attack rolls, melee damage rolls, Acrobatics checks, and armor class equal to +1 per 3 caster levels (maximum +5 at 15th level). The bonus to AC is lost under any circumstances that would cause you to lose your Dexterity bonus to AC. You must remain moving for the spell to stay in effect. If in any round you do not either move at least 10 feet or make a melee attack, the spell's duration ends.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V",
        },
        {
        level: "7",
        name: "Firebrand",
        type: ["buff"],
        school: "transmutation",
        tags: ["fire"],
        longDesc: `You mark several allies with a flaming rune. This rune does not cause damage, and sheds light as if it were a torch. While the firebrand burns, any creature it marks is immune to damage from any fire spell you cast. All of the target's weapons (both natural and manufactured) inflict +1d6 points of fire damage on a hit (this bonus fire damage stacks with any amount of fire damage a creature's weapons might already inflict). At any point during the spell's duration, a creature bearing a firebrand can launch a beam of fire at any target within 30 feet as a swift action. This ray requires a ranged touch attack to hit and deals 6d6 points of fire damage. Once a creature uses its firebrand to fire a ray in this manner, the effects of the spell end for that creature.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/4 levels, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless), but see below",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Holy Sword",
        type: ["buff"],
        school: "evocation",
        tags: ["good", "imbument"],
        longDesc: `This spell allows you to channel holy power into your sword, or any other melee weapon you choose. The weapon gains a +3 holy weapon (+3 enhancement bonus on attack and damage rolls, extra 2d6 damage against evil opponents). It also emits a magic circle against evil effect (as the spell). If the magic circle ends, the sword creates a new one on your turn as a free action. The spell is automatically canceled 1 round after the weapon leaves your hand. You cannot have more than one holy sword at a time. If you're evil this instead gives a +3 unholy enchantment, and cant be used by neutral spellcasters`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 melee weapon touched",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "7",
        name: "Legendary Proportions",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `You call upon the primordial power of ancient megafauna to boost the size of your target. Because of its connection to living creatures of the distant past, the spell does not function on outsiders, undead, and summoned creatures. Your target grows to legendary proportions, increasing in size by one category. The creature's height doubles and its weight increases by a factor of 8. The target gains a +6 size bonus to its Strength score and a +4 size bonus to its Constitution score. It gains a +6 size bonus to its natural armor, and DR 10/adamantine. Its carrying capacity changes to reflect its new size. The creature's equipment and weapons, if any, also increase in size. Any enlarged item that leaves the creature's possession returns to its original size (though thrown weapons and ammunition deal damage at their enlarged size before returning to their true proportions). If insufficient room is available to accommodate the creature's growth, it attains the maximum possible size and can attempt a Strength check (using its increased Strength score) to burst any enclosures in the process. If it fails, it is constrained without harm by the materials enclosing it. The spell cannot crush a creature by enclosing it.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 creature (see text)",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Magic Army",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument] You imbue all manufactured weapons carried by allies within range with magic, granting each weapon a +1 enhancement bonus on attack rolls and damage rolls per 5 caster levels (maximum +4).`,
        castingTime: "1 standard action",
        range: " long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "weapons carried by allies",
        duration: "1 hour/level",
        savingThrow: "Will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, DF",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "7",
        name: "Elemental Body IV",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as elemental body III, except that it also allows you to assume the form of a Huge air, earth, fire, or water elemental. The abilities you gain depend upon the type of elemental into which you change. You are also immune to critical hits and sneak attacks while in elemental form and gain DR 5/-. Air elemental: As elemental body I except that you gain a +4 size bonus to your Strength, +6 size bonus to your Dexterity, and a +4 natural armor bonus. You also gain fly 120 feet (perfect). Earth elemental: As elemental body I except that you gain a +8 size bonus to your Strength, a -2 penalty on your Dexterity, a +4 size bonus to your Constitution, and a +6 natural armor bonus. Fire elemental: As elemental body I except that you gain a +6 size bonus to your Dexterity, a +4 size bonus to your Constitution, and a +4 natural armor bonus. Water elemental: As elemental body I except that you gain a +4 size bonus to your Strength, a -2 penalty on your Dexterity, a +8 size bonus to your Constitution, and a +6 natural armor bonus. You also gain swim 120 feet.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Ethereal Jaunt",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You become ethereal, along with your equipment. For the duration of the spell, you are in the Ethereal Plane, which overlaps the Material Plane. When the spell expires, you return to material existence. An ethereal creature is invisible, insubstantial, and capable of moving in any direction, even up or down, albeit at half normal speed. As an insubstantial creature, you can move through solid objects, including living creatures. An ethereal creature can see and hear on the Material Plane, but everything looks gray and ephemeral. Sight and hearing onto the Material Plane are limited to 60 feet. Force effects and abjurations affect an ethereal creature normally. Their effects extend onto the Ethereal Plane from the Material Plane, but not vice versa. An ethereal creature can't attack material creatures, and spells you cast while ethereal affect only other ethereal things. Certain material creatures or objects have attacks or effects that work on the Ethereal Plane. Treat other ethereal creatures and ethereal objects as if they were material. If you end the spell and become material while inside a material object (such as a solid wall), you are shunted off to the nearest open space and take 1d6 points of damage per 5 feet that you so travel.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Fey Form III",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as fey form II except it allows you to assume the form of a Diminutive or Huge creature of the fey type. If the form you assume has any of the following abilities, you gain those abilities: burrow speed 60 feet, climb speed 90 feet, fly speed 90 feet (good maneuverability), swim speed 90 feet, all-around vision, blindsense 60 feet, blindsight 30 feet, darkvision 90 feet, low-light vision, scent, see in darkness, tremorsense 60 feet, abduct, animated hair, bleed, blood rage, boot stomp, burn, compression, constrict, crushing leap, DR 5/cold iron, fear aura, frightful presence, grab, heavy weapons, icewalking, kneecapper, luminous, nasal spray, no shadow, oversized weapons, poison, putrid vomit, rend, rock throwing (100 feet, 2d6 damage), sound mimicry, supernatural speed, tear shadow, trackless step, trample, tree meld, undersized weapons, and woodland stride. If the creature has immunity or resistance to any energy types, you gain resistance 20 to those energy types. If the creature has immunity to mind-affecting effects or poison, you gain a +8 resistance bonus on saves against those effects. If the creature has any weaknesses, you gain those weaknesses. Diminutive Fey: If you assume this form, you gain a +8 size bonus to your Dexterity score and take a -4 penalty to your Strength score. Huge Fey: If you assume this form, you gain a +6 size bonus to your Strength and Constitution scores and take a -4 penalty to your Dexterity score.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Fly, Mass",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell functions as fly (Core Rulebook 284), save that it can target numerous creatures and lasts longer.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "10 minutes/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Form of the Alien Dragon II",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as per form of the alien dragon I, except it also allows you to assume the form of a Large esoteric or outer dragon. Psychics can choose from the esoteric dragon (astral, dream, etheric, nightmare, or occult) forms only. You gain the following abilities: a +6 size bonus to your Strength, a +4 size bonus to your Constitution, a +6 natural armor bonus, a fly speed of 90 feet (poor), darkvision with a range of 60 feet, a breath weapon, damage reduction 5/magic, and resistance to one form of energy or effect. You also gain one bite attack (2d6), two claw attacks (1d8), a tail slap attack (1d8), and two wing attacks (1d6). All breath weapons deal 6d8 points of damage unless noted otherwise and allow a Reflex save to halve the normal damage. Line breath weapons increase to 80-foot lines and cones increase to 40-foot cones.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Form of the Dragon II",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as form of the dragon I except that it also allows you to assume the form of a Large chromatic or metallic dragon. You gain the following abilities: a +6 size bonus to Strength, a +4 size bonus to Constitution, a +6 natural armor bonus, fly 90 feet (poor), darkvision 60 feet, a breath weapon, DR 5/magic, and resistance to one element. You also gain one bite (2d6), two claws (1d8), two wing attacks (1d6), and one tail slap attack (1d8). You can only use the breath weapon twice per casting of this spell, and you must wait 1d4 rounds between uses. All breath weapons deal 8d8 points of damage and allow a Reflex save for half damage. Line breath weapons increase to 80-foot lines and cones increase to 40-foot cones.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "see below",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Form of the Exotic Dragon II",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as per form of the exotic dragon I, except it also allows you to assume the form of a Large imperial or primal dragon. Druids can choose from the primal dragon (brine, cloud, crystal, magma, or umbral) forms only. You gain the following abilities: a +6 size bonus to your Strength, a +4 size bonus to your Constitution, a +6 natural armor bonus, a fly speed of 90 feet (poor), darkvision with a range of 60 feet, a breath weapon, damage reduction 5/magic, and resistance to one form of energy or some other bonus. You gain one bite attack (2d6), two claw attacks (1d8), a tail slap attack (1d8), and either a gore attack (2d6) if you assume the form of an imperial dragon or two wing attacks (1d6) if you assume the form of a primal dragon. All breath weapons deal 8d8 points of damage unless noted and allow a Reflex save to halve the normal damage. Line breath weapons increase to 80-foot lines and cones increase to 40-foot cones.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "see below",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Giant Form I",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `When you cast this spell you can assume the form of any Large humanoid creature of the giant subtype. Once you assume your new form, you gain the following abilities: a +6 size bonus to Strength, a -2 penalty to Dexterity, a +4 size bonus to Constitution, a +4 natural armor bonus, and low-light vision. If the form you assume has any of the following abilities, you gain the listed ability: darkvision 60 feet, rend (2d6 damage), regeneration 5, rock catching, and rock throwing (range 60 feet, 2d6 damage). If the creature has immunity or resistance to any elements, you gain resistance 20 to those elements. If the creature has vulnerability to an element, you gain that vulnerability.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Ice Body",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: ["cold"],
        longDesc: `Your form transmutes into living ice, granting you several abilities. You gain the cold subtype and damage reduction 5/ magic. You are immune to ability score damage, blindness, critical hits, deafness, disease, drowning, electricity, poison, stunning, and all spells or attacks that affect your physiology or respiration, because you have no physiology or respiration while this spell is in effect. You cannot drink (and thus can't use potions) or play wind instruments. Your unarmed attack deals damage equal to a club sized for you (1d4 for Small characters or 1d6 for Medium characters) plus 1 point of cold damage, and you are considered armed when making unarmed attacks. You may burrow through nonmagical ice or snow at your base speed as easily as a fish swims through water. You can move through magical ice and snow if you succeed on a caster level check (1d20 + caster level) against a DC of 11 + the caster level of the effect; you automatically succeed on caster level checks against effects that you created. Your passage through snow and ice in this fashion leaves behind no tunnel or hole.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Invisibility, Mass",
        type: ["buff", "utility"],
        school: "illusion(glamer)",
        tags: [],
        longDesc: `This spell functions like invisibility, except that the effect moves with the group and is broken when anyone in the group attacks. Individuals in the group cannot see each other. The spell is broken for any individual who moves more than 180 feet from the nearest member of the group. If only two individuals are affected, the one moving away from the other one loses its invisibility. If both are moving away from each other, they both become visible when the distance between them exceeds 180 feet.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "any number of creatures, no two of which can be more than 180 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Magical Beast Shape",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as beast shape IV except you can assume the form of only a magical beast of a size between Diminutive and Huge. If the form you assume has any of the following abilities, you gain those abilities: burrow speed 60 feet, climb speed 90 feet, fly speed 120 feet (good maneuverability), swim speed 120 feet, blindsense 60 feet, blindsight 30 feet, darkvision 90 feet, low-light vision, scent, see in darkness, tremorsense 60 feet, blood drain, blood frenzy, breath weapon (if damage, up to 12d6 points), constrict, fast healing 5, ferocity, grab, hold breath, jet, no breath, poison, pounce, powerful charge, pull, rake, rend, roar, spikes, trample, trip, and web. If the creature has immunity to poison, you gain a +8 resistance bonus on saves against poison. If the creature has immunity or resistance to any energy types, you gain resistance 20 to those energy types. If the creature has vulnerability to an energy type, you gain that vulnerability. Diminutive Magical Beast: If you assume this form, you gain a +10 size bonus to your Dexterity score and take a -4 penalty to your Strength score. Huge Magical Beast: If you assume this form, you gain a +8 size bonus to your Strength score, take a -4 penalty on your Dexterity score, a +2 size bonus to your Constitution score, and gain a +7 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Ooze Form III",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as ooze form II except you can also assume the form of a Huge ooze. You gain blindsight 60 feet and a +8 resistance bonus on saving throws against mind-affecting effects and poison as well. Huge Ooze: If you assume this form, you gain a +4 size bonus to your Strength, a +10 size bonus to your Constitution score, a -10 penalty to your Dexterity score, base speed 20 feet, climb speed 20 feet, swim speed 30 feet, a slam attack (2d6 plus 2d6 acid and grab), and constrict (2d6).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Particulate Form",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `The targets' physical forms undergo a bizarre transformation. They look and function normally, but are composed of countless particles that separate and reconnect to remain whole. Each target gains fast healing 1 and is immune to bleed damage, critical hits, sneak attacks, and other forms of precision damage. The value of this fast healing increases by 1 at caster levels 10th, 15th, and 20th. Any target can end the spell effect on itself as a swift action; the target then regains 5d6 hit points and can attempt an additional saving throw against any one disease or poison affecting it (at the original save DC), ending that disease or poison with a successful saving throw.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 creature/level, no two of which can be more than 30 feet apart",
        duration: "1 round/level (D)",
        savingThrow: "none (harmless)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Plant Shape III",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as plant shape II except that it also allows you to assume the form of a Huge creature of the plant type. If the form you assume has any of the following abilities, you gain the listed ability: DR, regeneration 5, and trample. Huge plant: If the form you take is that of a Huge plant, you gain a +8 size bonus to your Strength, a -2 penalty to your Dexterity, a +4 size bonus to your Constitution, and a +6 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Polymorph, Greater",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as polymorph except that it allows the creature to take on the form of a dragon or plant creature. If you use this spell to cause the target to take on the form of an animal or magical beast, it functions as beast shape IV. If the form is that of an elemental, the spell functions as elemental body III. If the form is that of a humanoid, the spell functions as alter self. If the form is that of a plant, the spell functions as plant shape II. If the form is that of a dragon, the spell functions as form of the dragon I. The subject may choose to resume its normal form as a full-round action; doing so ends the spell.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "1 min/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Walk Through Space",
        type: ["buff", "utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `When under the effects of this spell, you can teleport up to 30 feet as a move action. You must end this movement in an unoccupied space that you can stand on within line of sight. Alternatively, you can spend a move action to teleport to a standing position from lying prone. Teleporting does not provoke attacks of opportunity.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Arbitrament",
        type: ["control"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `All chaotic evil, chaotic good, lawful evil, and lawful good creatures within the area of this spell suffer the following conditions, based on their save against the spell. If you are a neutral caster the DC increases by 1, if you are true neutral it increases by 2.
                
        Succeed by less than 4: Sickened 
                
        Fail: Sickened, staggered 
                
        Fail by 4 or more: Nauseated, sickened, staggered 
                
        Fail by 6 or more: harmed, nauseated, sickened, staggered
                
        
        The details of the effects are listed below: 
                
        Sickened: The creature is sickened for 1d4 rounds
                
        Staggered: The creature is staggered for 1d4 rounds
                
        Nauseated: The creature is nauseated for 1d6 rounds
                
        Harmed: Take 10 damage per caster level (max 150 damage)
                
        
        This effect takes place regardless of whether the creatures hear the arbitrament.`,
        castingTime: "1 standard action",
        range: "40 ft.",
        area: "",
        effect: "",
        targets: "non-neutral creatures in a 40-ft.-radius spread centered on you",
        duration: "instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "7",
        name: "Archon's Trumpet",
        type: ["control"],
        school: "evocation",
        tags: ["good", "sonic"],
        longDesc: `Upon hearing a booming report, as if from a trumpet archon's mighty horn, all creatures in the area of the burst are paralyzed for 1d4 rounds.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Black Tentacles, Greater",
        type: ["control"],
        school: "conjuration (creation)",
        tags: [],
        longDesc: `This spell causes tall grass, weeds, and other plants to swell into Gargantuan vines and tendrils that erupt from the ground, reaching for any structure or any creature of evil alignment, functioning like black tentacles except as noted. When you are determining the tendrils' CMB, the tendrils use your caster level as their base attack bonus and have a +13 bonus due to their Strength. Any tendril that succeeds in grappling a foe deals 4d6+13 points of damage to the grappled creature. Additionally, the tendrils created by this spell can detect evil auras, as if they had spent 3 rounds observing all creatures and objects within the spell's area using detect evil, and attack and impede the movement of only evil creatures, though they also attack any structures in their area. Each structure suffers a single attack each round; your caster level acts as the base attack bonus for these attacks, and the tendrils deal 4d6+13 points of damage on each successful attack. Creatures that lack evil auras are not attacked or impeded by this spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "120-ft.-radius spread",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M",
        },
        {
        level: "7",
        name: "Blasphemy",
        type: ["control"],
        school: "evocation",
        tags: ["evil", "sonic"],
        longDesc: `Any nonevil creature within the area of a blasphemy spell suffers the following ill effects depending on their save against the spell. Good creatures take a -2 penalty to their save
                
        Succeed by 4 or less: Dazed
                
        Fail: Weakened, dazed 
                
        Fail by 4 or more: Paralyzed, weakened, dazed 
                
        Fail by 8 or more: Harmed, paralyzed, weakened, dazed 
                
        
        The effect durations are concurrent. The effects are listed below: 
                
        Dazed: The creature can take no actions for 1 round, though it defends itself normally.
                
        Weakened: The creature's Strength score decreases by 2d6 points for 2d4 rounds. 
                
        Paralyzed: The creature is paralyzed and helpless for 1d6 rounds. 
                
        Harmed: creature takes 10 points of damage per level (max 150). 
                
        This effect takes place regardless of whether the creatures hear the blasphemy or not.`,
        castingTime: "1 standard action",
        range: "40 ft.",
        area: "nonevil creatures in a 40-ft.-radius spread centered on you",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Will",
        spellResistance: "yes",
        components: "V",
        },
        {
        level: "7",
        name: "Control Undead",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell enables you to control undead creatures for a short period of time. You command them by voice and they understand you, no matter what language you speak. Even if vocal communication is impossible, the controlled undead do not attack you. At the end of the spell, the subjects revert to their normal behavior. Intelligent undead creatures remember that you controlled them, and they may seek revenge after the spell's effects end.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "up to 2 HD/level of undead creatures, no two of which can be more than 30 ft. apart",
        duration: "1 min./level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Dictum",
        type: ["control"],
        school: "evocation",
        tags: ["lawful", "sonic"],
        longDesc: `Any nonlawful creature within the area of a dictum spell suffers the following ill effects depending on their save against the spell. Chaotic creatures receive a -2 penalty to the save.
                
        Succeed by 4 or less: Deafened Up to caster level -1 
                
        Fail: Staggered, deafened 
                
        Fail by 4 or more: Paralyzed, staggered, deafened 
                
        Fail by 8 or more: Harmed, paralyzed, staggered, deafened
                
        
        The effects are cumulative and concurrent. Creatures affected by multiple effects make only one save and apply the result to all the effects. 
                
        Deafened: The creature is deafened for 1d4 rounds. 
                
        Staggered: The creature is staggered for 2d4 rounds. 
                
        Paralyzed: The creature is paralyzed and helpless for 1d6 rounds.
                
        Harmed: The creature takes 10 damage per caster level (max 150 damage)
                
        This effect takes place regardless of whether the creatures hear the dictum or not.`,
        castingTime: "1 standard action",
        range: "40 ft.",
        area: "nonlawful creatures in a 40-ft.-radius spread centered on you",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V",
        },
        {
        level: "7",
        name: "Forcecage",
        type: ["control"],
        school: "evocation",
        tags: ["force"],
        longDesc: `This spell creates an immobile, invisible cubical prison composed of either bars of force or solid walls of force (your choice). Creatures within the area are caught and contained unless they are too big to fit inside, in which case the spell automatically fails. Teleportation and other forms of astral travel provide a means of escape, but the force walls or bars extend into the Ethereal Plane, blocking ethereal travel. Like a wall of force, a forcecage resists dispel magic, although a mage's disjunction still functions. The walls of a forcecage can be damaged by spells as normal, except for disintegrate, which automatically destroys it. The walls of a forcecage can be damaged by weapons and supernatural abilities, but they have a Hardness of 30 and a number of hit points equal to 20 per caster level. Contact with a sphere of annihilation or rod of cancellation instantly destroys a forcecage. Barred Cage: This version of the spell produces a 20-foot cube made of bands of force (similar to a wall of force spell) for bars. The bands are a half-inch wide, with half-inch gaps between them. Any creature capable of passing through such a small space can escape; others are confined within the barred cage. You can't attack a creature in a barred cage with a weapon unless the weapon can fit between the gaps. Even against such weapons (including arrows and similar ranged attacks), a creature in the barred cage has cover. All spells and breath weapons can pass through the gaps in the bars. Windowless Cell: This version of the spell produces a 10-foot cube with no way in and no way out. Solid walls of force form its six sides.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "barred cage (20-ft. cube) or windowless cell (10-ft. cube)",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Reflex negates",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Hold Person, Mass",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell functions like hold person, except as noted above.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one or more humanoid creatures, no two of which can be more than 30 ft. apart",
        duration: "1 round/level ; see text",
        savingThrow: "Will negates; see text",
        spellResistance: "yes",
        components: "V, S, F,DF,",
        },
        {
        level: "7",
        name: "Holy Word",
        type: ["control"],
        school: "evocation",
        tags: ["good", "sonic"],
        longDesc: `Any nongood creature within the area of a holy word spell suffers the following ill effects. Evil creatures take a -2 penalty to their save.
                
        Succeed by 4 or less: Deafened 
                
        Fail: Blinded, deafened 
                
        Fail by 4 or more: Paralyzed, blinded, deafened
                
        Fail by 8 or more: Harmed, paralyzed, blinded, deafened
                
        
        These effects are concurent, the details of the effects are listed below:
                
        Deafened: The creature is deafened for 1d4 rounds. 
                
        Blinded: The creature is blinded for 2d4 rounds. 
                
        Paralyzed: The creature is paralyzed and helpless for 1d6 rounds. 
                
        Harmed: The creature takes 10 damage per caster level (max 150).`,
        castingTime: "1 standard action",
        range: "40 ft.",
        area: "nongood creatures in a 40-ft.-radius spread centered on you",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V",
        },
        {
        level: "7",
        name: "Hymn Of Peace",
        type: ["control"],
        school: "abjuration",
        tags: ["good"],
        longDesc: `Each time a subject of this spell attempts to attack another creature or object, or otherwise perform an aggressive or damaging action toward a creature or object, it must attempt a Will save. If the save succeeds, the subject can attack normally. If the save fails, the subject cannot follow through with the attack and loses that part of its action. Creatures not taking violent actions are unaffected by this spell.`,
        castingTime: "1 standard action",
        range: "40 ft.",
        area: "40-ft.-radius burst centered on you",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Insanity",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `The affected creature suffers from a continuous confusion effect, as the spell. Remove curse does not remove insanity. Greater restoration, heal, limited wish, miracle, or wish can restore the creature.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Power Word Blind",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You utter a single word of power that causes a creature to become blinded, whether the creature can hear the word or not. The duration of the spell depends on the target's current hit point total. Any creature that currently has 201 or more hit points is unaffected. Hit Points Duration 50 or less Permanent 51-100 1d4+1 minutes 101-200 1d4+1 rounds`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature with 200 hp or less",
        duration: "see text",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "7",
        name: "Prismatic Spray",
        type: ["control"],
        school: "evocation",
        tags: [],
        longDesc: `This spell causes seven shimmering, multicolored beams of light to spray from your hand. Each beam has a different power. Creatures in the area of the spell with 8 HD or less are automatically blinded for 2d4 rounds. Every creature in the area is randomly struck by one or more beams, which have additional effects. Color 1d8 of Beam 1 
                
        1: Red 20 points fire damage (Reflex half ) 
                
        2: Orange 40 points acid damage (Reflex half ) 
                
        3: Yellow 80 points electricity damage (Reflex half) 
                
        4: Green Poison (Frequency 1/rd. for 6 rd.; Init. effect death; Sec. effect 1 Con/rd.; Cure 2 consecutive Fort saves)* 
                
        5: Blue Flesh to stone (Fortitude negates) 
                
        6: Indigo Insane, as insanity spell (Will negates) 
                
        7: Violet Sent to another plane (Will negates) 
                
        8: Struck by Roll twice more, ignoring any '8' two rays results.`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Reverse Gravity",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell reverses gravity in an area, causing unattached objects and creatures in the area to fall upward and reach the top of the area in 1 round. If a solid object (such as a ceiling) is encountered in this fall, falling objects and creatures strike it in the same manner as they would during a normal downward fall. If an object or creature reaches the top of the area without striking anything, it remains there, oscillating slightly, until the spell ends. At the end of the spell duration, affected objects and creatures fall downward. Provided it has something to hold onto, a creature caught in the area can attempt a Reflex save to secure itself when the spell strikes. Creatures who can fly or levitate can keep themselves from falling.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "up to one 10-ft. cube/level (S)",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none; see text",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "7",
        name: "Scouring Winds",
        type: ["control"],
        school: "evocation",
        tags: ["air", "earth"],
        longDesc: `This spell brings forth a windstorm of stinging sand that blocks all vision. You can move the storm up to 30 feet each round as a move action. Any creature in the area takes 3d6 points of piercing damage each round. The area is considered a windstorm (see Table 13-10: Wind Effects, Core Rulebook 439). If a creature with spell resistance successfully resists this spell, it is unaffected by the winds and sand, but still unable to see within the area of the spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "sandstorm in 20-ft. radius, 20 ft. high",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes (see text)",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Transmute Metal to Wood",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell enables you to change all metal objects within its area to wood. Weapons, armor, and other metal objects carried by creatures are affected as well. A magic object made of metal effectively has spell resistance equal to 20 + its caster level against this spell. Artifacts cannot be transmuted. Weapons converted from metal to wood take a -2 penalty on attack and damage rolls. The armor bonus of any armor converted from metal to wood is reduced by 2. Weapons changed by this spell splinter and break on any natural attack roll of 1 or 2, and armor changed by this spell loses an additional point of armor bonus every time it is struck with a natural attack roll of 19 or 20. Only limited wish, miracle, wish, or similar magic can restore a transmuted object to its metallic state.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "all metal objects within a 40-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes (object; see text)",
        components: "V, S, DF",
        },
        {
        level: "7",
        name: "Vortex",
        type: ["control"],
        school: "evocation",
        tags: ["water"],
        longDesc: `You create a powerful and immobile whirlpool in any body of liquid large enough to contain the spell's effect. Any Large or smaller creature that comes in contact with the spell effect must succeed on a Reflex save or take 3d6 points of bludgeoning damage. A Medium or smaller creature that fails its first save must succeed on a second one or be pulled into the whirlpool and held suspended in its powerful currents, taking 1d8 points of damage each round on your turn with no save allowed. You may direct the whirlpool to eject any carried creatures whenever you wish. A boat that is equal in length or shorter than the vortex's width that passes through a vortex takes 6d6 points of damage and is caught up by the current. If the boat's captain makes a DC 25 Profession (sailor) check (or if the boat is longer than the vortex's width), the boat takes only half damage and is not caught up by the vortex.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "whirlpool 50 ft. deep, 30 ft. wide at top, and 5 ft. wide at base",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "Reflex negates, see text",
        spellResistance: "yes",
        components: "",
        },
        {
        level: "7",
        name: "Waves of Ecstasy",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You emanate waves of intense pleasure that cause all targets within range to falter. Affected creatures are stunned for 1 round and are staggered for the remainder of the spell. A creature that makes its save is staggered for the first round and can act normally thereafter.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "1 round/level; see text",
        savingThrow: "Will partial (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Waves of Exhaustion",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `Waves of negative energy cause all living creatures in the spell's area to become exhausted. This spell has no effect on a creature that is already exhausted.`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Word Of Chaos",
        type: ["control"],
        school: "evocation",
        tags: ["chaotic", "sonic"],
        longDesc: `Any nonchaotic creature within the area of a word of chaos spell suffers the following ill effects, depending on their save against the spell. Lawful creatures receive a -2 penalty to their saves.
                
        Succeed the save by less than 4: Deafened 
                
        Fail: Stunned, deafened 
                
        Fail by 4 or more: Confused, stunned, deafened 
                
        Fail by more than 8: Harmed, confused, stunned
                
        
        The details of the effects are listed below:
                
        Deafened: The creature is deafened for 1d4 rounds.
                
        Stunned: The creature is stunned for 1 round. 
                
        Confused: The creature is confused for 1d6 rounds. This is a mind-affecting enchantment effect. 
                
        Harmed: The creatures take 10 damage per caster level, (max 150 damage).
                
        
        This effect takes place regardless of whether the creatures hear the word of chaos or not.`,
        castingTime: "1 standard action",
        range: "40 ft.",
        area: "nonchaotic creatures in a 40-ft.-radius spread centered on you",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none or Will negates; see text",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "7",
        name: "Hunger for Flesh, Mass",
        type: ["control", "buff"],
        school: "necromancy",
        tags: ["evil", "mind-affecting"],
        longDesc: `This spell functions like hunger for flesh, except that it affects multiple targets. When forced to feed by the spell, affected creatures attack creatures not affected by this spell if there are any such appropriate creatures nearby, but otherwise they attack other affected creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one humanoid, magical beast, or monstrous humanoid/ level, no two of which can be more than 30 feet apart",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "7",
        name: "Hungry Darkness",
        type: ["control", "damage"],
        school: "evocation",
        tags: ["darkness", "force"],
        longDesc: `This spell creates an area of intense blackness, as deeper darkness, but filled with unseen chewing teeth and ravenous maws. Any creatures beginning its turn within the hungry darkness is gnawed and slashed by these unseen fangs of force, dealing 3d6 points of force damage and 2 points of Constitution damage per round. Once a creature leaves the cloud, it continues to take 1d6 points of bleed damage each round until it receives magical healing or enters an area of bright light. Spell resistance can prevent damage from the hungry darkness but not against the darkness it creates.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "60-ft.-radius spread",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes (see text)",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Plague Storm",
        type: ["control", "damage"],
        school: "necromancy",
        tags: ["disease", "evil"],
        longDesc: `You create a hideous gray cloud, similar to fog cloud, that occasionally crackles with foul-smelling bolts of sickly green lightning. Creatures in the area must save or contract one of the following diseases: blinding sickness, bubonic plague, cackle fever, demon fever, devil chills, filth fever, leprosy, mindfire, red ache, shakes, or slimy doom (the disease is chosen by you when you cast the spell and applies to all creatures that fail the save). The disease is contracted immediately (the onset period does not apply) and is an instantaneous effect. Use the disease's listed frequency to determine further effects, but the disease's save DC increases by +2. For more information see page 557 of the Core Rulebook. Unlike a fog cloud, the plague storm moves away from you at 10 feet per round, rolling along the surface of the ground. Figure out the cloud's new spread each round based on its new point of origin, which is 10 feet farther away from the point of origin where you cast the spell. Because the vapors are heavier than air, they sink to the lowest level of the terrain, even pouring down den or sinkhole openings. The cloud cannot penetrate liquids, nor can it be cast underwater.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "cloud spreads in 20-ft. radius, 20 ft. high",
        targets: "",
        duration: "1 minute/level and instantaneous (see text)",
        savingThrow: "Fortitude negates",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Resonating Word",
        type: ["control", "damage"],
        school: "transmutation",
        tags: ["sonic"],
        longDesc: `You speak a terrible word of power, setting up potentially lethal vibrations in the chosen target. The target must save once each round on your turn, and the effects grow stronger for each saving throw the creature fails. On the first round, the target takes 5d6 points of sonic damage and is staggered for 1 round. A successful save halves the damage and negates the staggered effect. On the second round, the target takes 5d6 points of damage and is stunned for 1 round. A successful save halves the damage and negates the stunning effect. On the third round, the target takes 10d6 points of damage and is stunned for 1d4+1 rounds. A successful save halves the damage and negates the stunning effect. The resonating word has no power after the third round, even if the spell's duration is increased.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "3 rounds",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "7",
        name: "Artificer's Curse",
        type: ["control", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You temporarily suppress the most powerful qualities of a magical item. This item can be any object you suspect bears a magical enchantment, but if the targeted item is not magical, your spell has no effect. The spell reduces the object's caster level by an amount equal to your caster level, to a minimum of 0. If the item grants a competence, deflection, enhancement, insight, luck, morale, natural armor, profane, resistance, or sacred bonus, the bonus is reduced by 1 for every 4 caster levels the item loses. If the item's caster level is reduced to 0, all its magic qualities are suppressed (as if dispelled) for the duration of the spell. This spell has no effect on artifacts.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 magical item",
        duration: "1 minute/level (D)",
        savingThrow: "Will negates (object)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Circle of Clarity",
        type: ["control", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `You create a magical emanation that interferes with all figments and glamers within it, giving creatures a +4 bonus on saving throws to recognize them as illusions. The emanation negates concealment less than total concealment within the area. Perception checks to notice creatures or objects within the area gain a bonus equal to half your caster level (maximum +10). The spell is stationary if cast on a point in space. It is mobile if centered on a creature or object, though creatures or attended objects can negate the spell with a saving throw or spell resistance.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "20-ft.-radius emanation centered on a creature, object, or point in space",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Grasping Hand",
        type: ["control", "utility"],
        school: "evocation",
        tags: ["force"],
        longDesc: `This spell functions as interposing hand, except that it can also grapple one opponent you select. The grasping hand gets one grapple attack per round. This attack does not provoke an attack of opportunity. Its CMB and CMD for grapple checks use your caster level in place of its base attack bonus, with a +10 bonus for its Strength (31) score and a +1 bonus for being Large (its Dexterity is 10, granting no bonus on the Combat Maneuver Defense). The hand holds but does not harm creatures that it grapples. Directing the spell to a new target is a move action. The grasping hand can instead be directed to bull rush a target, using the same bonuses outlined above, or it can be directed to interpose itself, as interposing hand does.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "10-ft. hand",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, F,",
        },
        {
        level: "7",
        name: "Absolute Zero",
        type: ["damage"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `You inflict a creature with a slow creeping cold. When you cast the spell the creature does not make a save, but it suffers no ill effect immediately, instead in 5 rounds they are struck by extreme cold that penatrates straight to their heart, causing them to take take 4d6 cold damage (max 60d6) per caster level. Each turn at the start of their turn they make a fortitude save, if they succeed the onset is extended by 1 round (meaning the time till its onset is not changed). You can cast this spell on a creature a multiple times, each time you do the onset is lowered by 1 round, the damage is increased by 1d6 per caster level (no save), and the DC increases by +1. If the save vs this effect is a natural 20 the spell ends, if it is a natural 1, the onset is reduced by your spell critical damage multiplier (default 2 rounds).`,
        castingTime: "1 standard action",
        range: "close (25 + 5ft/2 levels)",
        area: "",
        effect: "",
        targets: "",
        duration: "special; see text",
        savingThrow: "fortitude partial; see text",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "7",
        name: "Acid Cannon",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["acid"],
        longDesc: `You stomp on the ground beneath you, causing a cannon of rock to form and fire acid in a 60-foot line dealing 1d6 points of acid damage per level (max 15d6), all creatures in the area can make a reflex save to reduce the damage by half, the cannon continues to fire for 1 round/4 levels, and any creature that enters the area or is inside of it at the start of your turn takes the damage again (they are still entitled to a reflex save for half.)`,
        castingTime: "1 standard action",
        range: "60-ft line",
        area: "60-ft line",
        effect: "",
        targets: "",
        duration: "1 round/4 levels",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Caustic Eruption",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["acid"],
        longDesc: `Acid erupts from your space in all directions, causing 1d6 points of damage per caster level (maximum 20d6) to creatures and unattended objects in the area. On your turn in each of the next 2 rounds, creatures and objects that failed their saves against the initial burst take an additional 1d6 points of acid damage per 2 caster levels (maximum 10d6) unless the acid is neutralized, dispelled, or washed away.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "30-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous and 2 rounds; see text",
        savingThrow: "Reflex half (see text)",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Caustic Lash",
        type: ["damage"],
        school: "transmutation",
        tags: ["acid"],
        longDesc: `When a creature attacks and deals damage to you with a melee attack you can lash out with a whip of acid from your mouth, making a retributive strike, make a touch attack against the creature, even if the creature is out of your reach you can make this attack as long as the attack against you was a melee attack, and you were aware of it and not flat-footed. This deals 1d6 points of acid damage per caster level (max 10d6), and for the rest of the creatures turn if it strikes you with another melee attack you can lash it again, up to one additional time per 8 caster levels.`,
        castingTime: "1 immediate action",
        range: "0ft",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Deadly Finale",
        type: ["damage"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `You must have a bardic performance or hex in effect to cast this spell. With a flourish, you immediately end your performance or hexes, dealing 2d8 points of sonic damage to each target. If you used a hex to activate this ability the targets must targets under the effects of that hex. In addition, each target takes 3d6 points of bleed damage for 1d6 rounds. A save negates the bleed damage but not the sonic damage. A hexes effect lingers until after the save is rolled`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 creature/3 levels no two of which can be more than 30 ft. apart",
        duration: "instantaneous",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Destruction",
        type: ["damage"],
        school: "necromancy",
        tags: ["death"],
        longDesc: `This spell instantly delivers 10 points of damage per caster level. If the spell slays the target, it consumes the remains utterly in holy (or unholy) fire (but not its equipment or possessions). If the target's Fortitude saving throw succeeds, it instead takes 10d6 points of damage. The only way to restore life to a character who has failed to save against this spell (and was slain) is to use true resurrection, a carefully worded wish spell followed by resurrection, or miracle.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, F,",
        },
        {
        level: "7",
        name: "Finger of Death",
        type: ["damage"],
        school: "necromancy",
        tags: ["death"],
        longDesc: `This spell instantly delivers 10 points of damage per caster level. If the target's Fortitude saving throw succeeds, it instead takes 3d6 points of damage + 1 point per caster level. The subject might die from damage even if it succeeds on its saving throw.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Glacial Tempest",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["cold"],
        longDesc: `You conjure a blisteringly cold storm that slowly moves away from you. Any creature that enters (whether it moved on top of them or they moved into it) or ends their turn in it, takes 1d6 cold damage per caster level (max 15d6), and becomes slowed as the spell for 1 round. Fortitude halves the cold damage and negates the slow. Creatures who take no cold damage from the spell are not subject to the slow. Each round at the start of your turn the storm moves 20ft. further away from the point you cast it from, however at the start of your turn you can spend a move action to increase or decrease its speed for that round by 10ft., or move it left, right, up, or down 10ft. You can also spend a standard action to make it remain in place that turn, and it deals 1d6+1 cold damage per level (max 15d6+15), and the fortitude save DC is increased by +2. A creature who takes damage from this spell multiple times has the DC increased by +2 and the slow lasts for an additional round for each previous time it has been affected.`,
        castingTime: "1 standard action",
        range: "15 ft",
        area: "cloud spreads in 15-ft. radius, 15 ft. high",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "fortitude half; see text",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "7",
        name: "Inflict Serious Wounds, Mass",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell functions like mass inflict light wounds, except that it deals 5d8 points of damage + 2 points per caster level (maximum +35).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "instantaneous",
        savingThrow: "Will half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Ki Shout",
        type: ["damage"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `With a guttural bark, you unleash a sudden blast of sonic energy that strikes your opponent. The target takes 1d6 points of sonic damage per level (maximum 20d6) and is stunned for 1 round; a successful Fortitude save reduces the damage by half and negates the stun.`,
        castingTime: "1 standard action",
        range: "close (25 ft + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "instantaneous",
        savingThrow: "Fortitude partial (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Lightning Rod",
        type: ["damage"],
        school: "transmutation",
        tags: ["electricity"],
        longDesc: `The targeted creature must make a fortitude save, if it fails, it becomes negatively charged for 1 round per caster level, causing it to attract lightning. Whenever a creature within 30 feet of it takes electricity damage, this creature also takes that electricity damage, but can make a fortitude save to reduce it by half (it makes this save once per round and applies it to all damage in that round). This cannot activate more than once per ability that deals electricity damage, nor does it activate when this creature itself takes electricity damage. For the duration of the spell this creature takes -2 on any save it would take due to electricity based abilities, and attacks that deal electricity damage gain a +3 bonus to hit it (except damage from this spell). At the start of each of its turns the creature can make a fortitude save to reduce the duration by 1 round, or a save as a full-round action to reduce the duration by 6 rounds.`,
        castingTime: "1 standard action",
        range: "short (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "1 round/level",
        savingThrow: "fort negates",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "7",
        name: "Mage's Sword",
        type: ["damage"],
        school: "evocation",
        tags: ["force"],
        longDesc: `This spell brings into being a shimmering, sword-like plane of force. The sword strikes at any opponent within its range, as you desire, starting in the round that you cast the spell. The sword attacks its designated target once each round on your turn. Its attack bonus is equal to your caster level + your highest mental with an additional +3 enhancement bonus. As a force effect, it can strike ethereal and incorporeal creatures. It deals 4d6+3 points of force damage, with a threat range of 19-20 and a critical multiplier of x2. The sword always strikes from your direction. It does not get a bonus for flanking or help a combatant get one. If the sword goes beyond the spell range from you, goes out of your sight, or you are not directing it, it returns to you and hovers. Each round after the first, you can use a standard action to switch the sword to a new target. If you do not, the sword continues to attack the previous round's target. The sword cannot be attacked or harmed by physical attacks, but dispel magic, disintegrate, a sphere of annihilation, or a rod of cancellation affects it. The sword's AC is 13 (10, +0 size bonus for Medium object, +3 deflection bonus). If an attacked creature has spell resistance, the resistance is checked the first time mage's sword strikes it. If the sword is successfully resisted, the spell is dispelled. If not, the sword has its normal full effect on that creature for the duration of the spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one sword",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, F,",
        },
        {
        level: "7",
        name: "Phantasmal Revenge",
        type: ["damage"],
        school: "illusion(phantasm)",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `When you cast this eerie spell upon a recently slain creature, you cause a ghastly, spectral image of it to rise up from its corpse, shrieking for vengeance before it vanishes in a burst of unnatural light. This phantom then unerringly seeks out the creature that killed it, as long as that creature is on the same plane, and tries to slay its killer in turn. Only the corpse's killer can see the phantasmal image created by this spell. You and any others who witness the spell's casting or its ultimate effects see only a vague shape. The target first gets a Will save to disbelieve the illusion. If that save fails, the target must succeed on Fortitude saving throw or take 20 points of damage per caster level from the phantasmal image. Even if the Fortitude save is successful, the target takes 10d6 points of damage + 2 points of damage per caster level. You know immediately if the spell succeeded or failed to kill its target but gain no other information. Any given body can only be targeted by a phantasmal revenge spell once.`,
        castingTime: "1 standard action",
        range: "touch and unlimited; see text",
        area: "",
        effect: "",
        targets: "dead body touched",
        duration: "instantaneous",
        savingThrow: "Will disbelief then Fortitude partial; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Solar Immolation",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `This spell always suffers a 10% failure chance, on top of any other chance to fail this spell may have. You attempt to create a ball of fire so intense its is reminiscent of the heat of the sun right inside of a creature, this deals 1d6 points fire damage per level (max 20d6), and 1d6 points of untyped damage per caster level (max 20d6), if a creature is vulnerable to light the untyped damage increases to 1d8 per level instead (max 20d8). A creature can make a reflex save to reduce this damage by half. This spell has a bonus +50% critical damage, and a +2% spell critical change. If the spell is a critical spell, the spell deals its damage to all creatures in a 250 foot burst centered on the original target of the spell, and the target of the spell no longer gets a reflex save to halve it.`,
        castingTime: "1 standard action",
        range: "close (25ft. + 5ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "instantaneous",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Spit Fire",
        type: ["damage"],
        school: "evocation",
        tags: ["language-dependent", "fire"],
        longDesc: `You unleash some sick heat from your mouth, unleasing a blast of flame to strike all creatures in a 15-ft. cone. This deals 1d6 points of fire damage per caster level (maximum 15d6), though creatures can make a reflex save to reduce the damage by half. When casting this spell you can roll a performance check, you can use the result of that check -10 as the DC for the spell instead of the normal DC. Bonuses to the DC of the spell from other sources are not included if you determine the DC this way.`,
        castingTime: "1 swift action",
        range: "15-ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "7",
        name: "Sunbeam",
        type: ["damage"],
        school: "evocation",
        tags: ["light"],
        longDesc: `For the duration of this spell, you can use a standard action to evoke a dazzling beam of intense light each round. You can call forth one beam per three caster levels (maximum six beams at 18th level). The spell ends when its duration runs out or your allotment of beams is exhausted. Each creature in the beam is blinded and takes 4d6 points of damage. Any creatures to which sunlight is harmful or unnatural take double damage. A successful Reflex save negates the blindness and reduces the damage by half. An undead creature caught within the beam takes 1d6 points of damage per caster level (maximum 20d6), or half damage if a Reflex save is successful. In addition, the beam results in the destruction of any undead creature specifically harmed by bright light if it fails its save. The ultraviolet light generated by the spell deals damage to fungi, mold, oozes, and slimes just as if they were undead creatures.`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "line from your hand",
        effect: "",
        targets: "",
        duration: "1 round/level or until all beams are exhausted",
        savingThrow: "Reflex negates and Reflex half; see text",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "7",
        name: "Umbral Strike",
        type: ["damage"],
        school: "necromancy(shadow)",
        tags: ["darkness"],
        longDesc: `You create a bolt of dark energy and use it to make a ranged touch attack that ignores concealment (but not total concealment). If you hit, the target takes 1d6 points of damage per caster level (maximum 20d6). Half of this damage is cold damage and half of it is negative energy. The bolt's shadow expands and covers the target, rendering him blind for the duration of the spell. A successful Fortitude save halves the damage and negates the blind condition.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "1 round/level",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Jolting Portent",
        type: ["damage", "control"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `The creature you designate is surrounded by a glowing red aura of vengeful fate. Once per round when the target makes an attack or casts a spell, it must succeed at a Fortitude saving throw with a DC = 10 + 1/2 caster level + highest mental stat. If the target fails the saving throw, it takes 4d6 + your highest mental stat electricity damage. It takes no damage on a successful saving throw. You can dismiss this spell as an immediate action when its subject confirms a critical hit to negate the critical hit and daze the creature for 1 round. The attack still hits its target and deals normal damage. The effects of the daze occur after the attack.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level (D) see text",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, DF,",
        },
        {
        level: "7",
        name: "Arcane Cannon",
        type: ["damage", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `Your focus becomes a Medium arcane cannon that appears in an unoccupied square within the spell's range. If no unoccupied square is within range, the spell fails. The cannon comes into existence loaded. Each round thereafter, the cannon can either fire or load. A cannon must be loaded to fire. You do not need to supply ammunition for the cannon. On your turn, you can spend a move action to direct the cannon to wheel itself to a new location, moving the cannon up to 20 feet. If the arcane cannon ever leaves your line of sight, it winks out of existence, and the spell's duration ends. The cannon has a range increment of 50 feet. It targets touch attack in the first range increment, and it has no misfire chance. The cannon acts as a weapon with the conductive special weapon ability (see page 286 of the Advanced Player's Guide), which you can use to channel your spell-like or supernatural abilities as long as you are within the range of arcane cannon. The cannon's attack bonus is equal to your caster level + your highest mental stat with an additional +1 per four caster levels (maximum +5 at 20th level). On a hit, the cannon deals 4d10 damage. The arcane cannon attacks have a critical modifier of x4. The cannon has AC 10, hardness 10, and 80 hit points. If the cannon is subject to a spell or effect that requires a save, it uses your saving throw modifiers. The cannon never provokes attacks of opportunity. If the cannon is destroyed, so is your focus.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one magically animated cannon",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Delayed Blast Fireball",
        type: ["damage", "utility"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `This spell functions like fireball, except that it is more powerful and can detonate up to 5 rounds after the spell is cast. The burst of flame deals 1d6 points of fire damage per caster level (maximum 20d6). The glowing bead created by delayed blast fireball can detonate immediately if you desire, or you can choose to delay the burst for as many as 5 rounds. You select the amount of delay upon completing the spell, and that time cannot change once it has been set unless someone touches the bead. If you choose a delay, the glowing bead sits at its destination until it detonates. A creature can pick up and hurl the bead as a thrown weapon (range increment 10 feet). If a creature handles and moves the bead within 1 round of its detonation, there is a 25% chance that the bead detonates while being handled.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "20-ft.-radius spread",
        effect: "",
        targets: "",
        duration: "5 rounds or less; see text",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Mortum's Storm",
        type: ["damage", "utility"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You summon a storm over a location, inside of the storm counts as a windstorm, including the penalties for that, such as requiring medium and smaller creatures to make a DC 15 strength check to move through it, and making ranged attacks with normal ranged weapons through it impossible. The caster can as a standard action to concentrate and move the storm 30 feet in any direction. Additionally while the storm is active the caster may once per turn as a movement action call a lightning bolt from the storm to strike a 5-ft line within the storms area (starting from the top and ending at a barrier), dealing 4d6 damage to creatures in the area (reflex half). Each round the damage of the lightning bolt damage increases by 2d6, if you actually call the lightning bolt it increases by an additional 1d6. At the end of its duration the storm finishing with a final blast of electricity, it deals 1d6 electricity damage per caster level in a 20ft +1d8x5ft radius (max 15d6), plus an additional 1d6 for each bolt called (reflex halves).`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "cylinder (20-ft. radius, 40 ft. high)",
        effect: "",
        targets: "",
        duration: "1 round/2 levels;",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "6",
        name: "Cure Serious Wounds, Mass",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell functions like mass cure light wounds, except that it cures 5d8 points of damage + 2 points per caster level (maximum +40).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "instantaneous",
        savingThrow: "Will half (harmless) or Will half; see text",
        spellResistance: "yes (harmless) or yes; see text",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Joyful Rapture",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: ["emotion"],
        longDesc: `Your inspired words overwhelm others with transcendental bliss. All allies within the area of effect are freed from any harmful emotion effects. The spell also cures 1d4 points of Intelligence, Wisdom, or Charisma damage (your choice) to all allies in the area.`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "all allies within a 60-ft.-radius burst centered on you",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Litany of Unbreaking",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `Positive energy infuses your body curing 6d8 points of damage + 1 point per caster level (maximum +25). This cures fatigue, reduces exhaustion to fatigued, and cures sickened. For 1 round after casting this spell you gain a +2 bonus on fortitude saving throws. If you are currently subject to a spell that restricts ability to take actions, such as staggered, and its remaining duration is longer than 1 round, you reduce the duration of the stagger by 1 round. While subject to this spell, the target cannot be the target of another spell that has the word 'litany' in the title.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "instantaneous and 1 round",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "7",
        name: "Power Word Life",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `You utter a single word of power that instantly wipes away injury and afflictions. It immediately ends any and all of the following adverse conditions affecting the target: ability damage, blinded, confused, dazed, dazzled, deafened, diseased, exhausted, fatigued, feebleminded, insanity, nauseated, poisoned, sickened, and stunned. It also cures 10 hit points of damage per level of the caster, to a maximum of 150 points at 15th level. This does not remove negative levels or restore permanently drained ability score points. If used on a creature that has died within 1 round, this spell can still be used on them, possibly restoring them to life in the same way as the breath of life spell. Creatures that are restored to life this way receive a negative level as normal. If used against an undead creature, it can apply spell resistance, and can attempt a Will save to take half damage, if the creature fails it receives a permanent negative level. This permanent negative level bypasses an undead creatures normal immunity to negative levels.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless) or Will half, see text",
        spellResistance: "yes (harmless) or yes, see text",
        components: "V",
        },
        {
            level: "6",
            name: "Power Word Solace",
            type: ["utility"],
            school: "abjuration",
            tags: [],
            longDesc: `You utter a single word of power that brings peace in the midst of combat. The chosen creature does not need to roll concentration checks due to damage and they automatically succeed on concentration checks to combat cast. They also have all damage reduced against them by 25% and are immune to pain effects for 1 round. This spell does not require a concentration check to cast due to damage.`,
            castingTime: "1 swift action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "1 creature",
            duration: "1 round",
            savingThrow: "Will negates (harmless) or Will half, see text",
            spellResistance: "yes (harmless) or yes, see text",
            components: "V",
        },
        {
            level: "9",
            name: "Power Word Salvation",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `You utter a single word of power that blesses all allies within 60 feet of you, causing them to heal 6d8 + level hit points and restore 1d4 points of ability damage at the start of each of their turns for the next caster level/4 rounds. The healing of this spell has its spell critical multiplier increased by 50%. When you cast the spell, it immediately restores fatigue and exhaustion from all affected characters, and they recieve an immediate new saving throw against the conditions: blinded, confused, dazed, dazzled, deafened, diseased, exhausted, fatigued, feebleminded, insanity, nauseated, poisoned, sickened, and stunned. It only grants a new save if the initial application allowed a save, and this additional save never has any penalties for failing it.`,
            castingTime: "full-round",
            range: "60 feet",
            area: "",
            effect: "",
            targets: "all allies within 60 feet of you",
            duration: "caster level/4 rounds",
            savingThrow: "will negates (harmless)",
            spellResistance: "yes (harmless)",
            components: "V",
        },
        {
        level: "7",
        name: "Regenerate",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `The subject's severed body members (fingers, toes, hands, feet, arms, legs, tails, or even heads of multiheaded creatures), broken bones, and ruined organs grow back. After the spell is cast, the physical regeneration is complete in 1 round if the severed members are present and touching the creature. It takes the full duration of the spell otherwise. Regenerate also cures 6d8 points of damage + 1 point per caster level each round at the start of each of your turns, and when it ends it rids the subject of exhaustion and fatigue and any nonlethal damage it had. It has no effect on nonliving creatures (including undead).`,
        castingTime: "1 Full-round Action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "1d4+1 rounds",
        savingThrow: "Fortitude negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "7",
        name: "Restoration, Greater",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell functions like lesser restoration, except that it dispels 1d3+1 permanent negative levels and all temporary negative levels afflicting the healed creature. Greater restoration also dispels all magical effects penalizing the creature's abilities, cures all temporary ability damage, and either restores 2d6 points permanently drained from a single ability score, or 1d4+1 to all ability scores. It also eliminates fatigue and exhaustion, and removes all forms of insanity, confusion, and similar mental effects. This spell, unlike most spells, costs 10 gold to cast.`,
        castingTime: "1 round",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
            level: "8",
            name: "Immediate Restoration",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `This spell functions like lesser restoration, except that it dispels 1 permanent negative level or 1d3 temporary negative levels afflicting the healed creature. Immediate restoration also dispels all magical effects penalizing the creature's abilities, cures 2d6 temporary ability damage from 1 ability score, or 1d6 temporary ability damage from all ability scores, and either restores 1d6 points permanently drained from a single ability score, or 1d2 to all ability scores. It also eliminates fatigue and exhaustion. This spell, unlike most spells, costs 10 gold to cast.`,
            castingTime: "standard",
            range: "touch",
            area: "",
            effect: "",
            targets: "creature touched",
            duration: "instantaneous",
            savingThrow: "Will negates (harmless)",
            spellResistance: "yes (harmless)",
            components: "V, S, M,",
        },
        {
        level: "7",
        name: "Resurrection",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell functions like raise dead, except that you are able to restore life and complete strength to any deceased creature. The condition of the remains is not a factor. So long as some small portion of the creature's body still exists, it can be resurrected, but the portion receiving the spell must have been part of the creature's body at the time of death. (The remains of a creature hit by a disintegrate spell count as a small portion of its body.) Upon completion of the spell, the creature is immediately restored to full hit points, vigor, and health, with no loss of prepared spells. The subject of the spell gains one permanent negative level when it is raised, just as if it had been hit by an energy-draining creature. If the subject is 1st level, it takes 2 points of Constitution drain instead (if this would reduce its Con to 0 or less, it can't be resurrected). You can resurrect someone killed by a death effect or someone who has been turned into an undead creature and then destroyed. You cannot resurrect someone who has died of old age. This spell, unlike most spells, costs 25 gold to cast.`,
        castingTime: "1 round",
        range: "touch",
        area: "",
        effect: "",
        targets: "dead creature touched",
        duration: "instantaneous",
        savingThrow: "none; see text",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "7",
        name: "Control Weather",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You change the weather in the local area. It takes 10 minutes to cast the spell and an additional 10 minutes for the effects to manifest. You can call forth weather appropriate to the climate and season of the area you are in. You can also use this spell to cause the weather in the area to become calm and normal for the season. Season Possible Weather Spring Tornado, thunderstorm, sleet storm, or hot weather Summer Torrential rain, heat wave, or hailstorm Autumn Hot or cold weather, fog, or sleet Winter Frigid cold, blizzard, or thaw Late winter Hurricane-force winds or early spring You control the general tendencies of the weather, such as the direction and intensity of the wind. You cannot control specific applications of the weather-where lightning strikes, for example, or the exact path of a tornado. The weather continues as you left it for the duration, or until you use a standard action to designate a new kind of weather (which fully manifests itself 10 minutes later). Contradictory conditions are not possible simultaneously. Control weather can do away with atmospheric phenomena (naturally occurring or otherwise) as well as create them.`,
        castingTime: "1 minute",
        range: "2 miles",
        area: "2-mile-radius circle, centered on you; see text",
        effect: "",
        targets: "",
        duration: "4d12 hours; see text",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Create Variant Mummy",
        type: ["utility"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `This spell functions as create undead spell, except it creates one of the following variant mummies: bog mummy, ice mummy, or Osirian tomb guardian.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "1 corpse",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Dimensional Bounce",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `You designate two locations within range and create a dimensional link between them; you must have line of effect to both locations when casting this spell. As a swift action, you can teleport from your current location to either of the designated locations as if you had cast dimension door, though you cant bring any creatures along with you. The spell is discharged once you have used it to teleport a number of times equal to 1/2 caster level (maximum 10 times). If you are not on one of the two linked squares when you teleport, it counts as two uses of this spell. If another creature steps on one of your designated squares you can as an immediate action attempt to teleport them, though they are allowed a will save to resist, this counts as 4 uses of the spell. If you designate a square a creature is already on with this ability, it fails. You must have enough uses left to activate any use of this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "you and two 5ft. squares",
        duration: "1 round/level or until discharged",
        savingThrow: "none and Will negates ",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Instant Summons",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `You teleport a piece of equipment from your inventory into your hands, or a unattended object you can see. This even works across planes and allows you to summon potions to drink while ethereal. You can even use this this withdraw grenades or ammunition that was just fired and missed.`,
        castingTime: "1 immediate action",
        range: "see text",
        area: "",
        effect: "",
        targets: "one object",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Magnetic Field",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `You create a spherical magnetic field that surrounds you to a range of 30 feet and follows you for the duration of the spell. Unattended metal objects in range-including weapons, armor, and anything made primarily out of metal-are pulled violently toward you, stopping just short of your space and falling harmlessly to the ground. Objects secured to a nonmetallic fixture remain where they are unless a forceful tug would be enough to detach them. Loose objects weighing more than 500 pounds are not affected. If the magnetic field would cause a dangerous metal object such as a sword or anvil to intersect a square occupied by a creature, that creature must succeed at a Reflex save or take damage as if from an improvised weapon of the object's size (or smaller or larger, at the GM's discretion). A creature in the area wearing metal armor, wielding a metal weapon, or holding a metal object must succeed at a Reflex save or be dragged 5 feet closer to you in a straight line, as if affected by the pull universal monster rule (Bestiary 303). A creature can drop a metal object it's holding as a free action to avoid the effect if it's not wearing metal armor; a creature being dragged by its shield can loosen it as a move action and drop it as a free action. Creatures made entirely or mostly of metal take a -2 penalty on their Reflex saves. Creatures that fail their saves by 5 or more are pulled an additional 5 feet closer for every increment of 5 by which they failed their saves.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "30-ft.-radius emanation",
        effect: "",
        targets: "",
        duration: "1 round/2 levels (D)",
        savingThrow: "Reflex negates (object; see text)",
        spellResistance: "yes (object)",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Memory of Function",
        type: ["utility"],
        school: "transmutation",
        tags: [],
        longDesc: `Even a broken object remembers what it means to be a functioning whole. You restore a broken object or damaged construct to a functional state, as if it were new and intact. Any pieces missing from the object or construct remain missing. Significant missing pieces may prevent proper functioning. If the object uses charges, the object becomes fully charged. A timeworn object becomes fully charged, but doesn't lose the timeworn condition (this spell is one of the few ways a timeworn item can be recharged). For 1 hour after this spell is cast on a timeworn object, that object does not suffer any chance of glitching. Other consumables such as ammunition are not restored. When this spell is cast upon a damaged construct, all hit point damage dealt to that construct is healed. When this spell is cast upon a destroyed construct, it is restored to full functionality and full hit points, provided no significant portion of the destroyed construct (such as an entire limb) is missing. Constructs brought back in this fashion regain their memories up to the moment of their destruction and have no particular inclination to serve the caster. If you attempt to cast this spell on an object or a construct that has been destroyed for more than 10 years per caster level you possess, the spell fails.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "object or construct touched",
        duration: "instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Permanent Hallucination",
        type: ["utility"],
        school: "illusion(phantasm)",
        tags: ["mind-affecting"],
        longDesc: `This spell functions as audiovisual hallucination, except that the phantasm you create includes visual, auditory, olfactory, tactile, and thermal components, and the phantasm follows a complex script. The phantasm follows that script without your having to concentrate on it and can react to stimuli the target perceives, as appropriate for the script. Unlike most illusions with a save to disbelieve, if the target disbelieves a permanent hallucination, she can choose to end the effect entirely at any time.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "permanent (D)",
        savingThrow: "Will disbelief",
        spellResistance: "yes",
        components: "S, ",
        },
        {
        level: "7",
        name: "Plundered Power",
        type: ["utility"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `Once you cast this spell on a creature you must kill it within 3 rounds or this spell fails. When the creature dies, its blood or ichor pools and hardens into a single red bloodstone. This bloodstone contains the essence and spirit of the sacrificed creature, allowing anyone holding the stone to activate the creature's highest-level activated racial spell-like ability, taking the actions necessary to activate the stored spell-like ability. Any creature who holds the stone can activate it, but the stone can be used only once per day (or the frequency of the creature's spell-like ability, whichever is less). If a creature has several racial spell-like abilities of the same spell level, choose randomly from among them to determine which one is stored in the bloodstone. The bloodstone can only store racial spell-like abilities that emulate a spell, including altered spells, like invisibility (self only), but not unique spell-like abilities possessed by the creature. Abilities with altered effects are still altered, so a creature activating the bloodstone for greater teleport (self only) would affect only itself and a bloodstone storing summon monster II (Small fire elemental only) would still only be able to summon a Small fire elemental. Additionally, the bloodstone can't store spell-like abilities that duplicate spells with expensive components costing more than 250 gp. The save DC, caster level, and other attributes of this ability remain the same as when the creature was still alive, though the creature who activates the bloodstone can choose the targets, area, or shape of the spell, and make other decisions, such as controlling the target of dominate person. The bloodstone can take any actions necessary to manipulate aspects of the spell, concentrating on the spell, redirecting the spell, and so on, up to a full normal round's worth of actions. If the sacrificed creature doesn't die during the casting of the spell (for instance if it was merely a summoned creature) or is brought back to life before the spell's duration expires, the bloodstone loses its magical power. The fragment of the creature's spirit trapped in the bloodstone does not hinder attempts to restore the creature to life.`,
        castingTime: "full-round action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "24 hours",
        savingThrow: "Will negates",
        spellResistance: "no",
        components: "V, S, M, ",
        },
        {
        level: "7",
        name: "Project Image",
        type: ["utility"],
        school: "illusion(shadow)",
        tags: ["shadow"],
        longDesc: `You tap energy from the Plane of Shadow to create a quasi-real, illusory version of yourself. The projected image looks, sounds, and smells like you but is intangible. The projected image mimics your actions (including speech) unless you direct it to act differently (which is a move action). You can see through its eyes and hear through its ears as if you were standing where it is, and during your turn you can switch from using its senses to using your own, or back again, as a free action. While you are using its senses, your body is considered blinded and deafened. If you desire, any spell you cast whose range is touch or greater can originate from the projected image instead of from you. The projected image can't cast any spells on itself except for illusion spells. The spells affect other targets normally, despite originating from the projected image. Objects are affected by the projected image as if they had succeeded on their Will save. You must maintain line of effect to the projected image at all times. If your line of effect is obstructed, the spell ends. If you use dimension door, teleport, plane shift, or a similar spell that breaks your line of effect, even momentarily, the spell ends.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "one shadow duplicate",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Will disbelief (if interacted with)",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Rampart",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: ["earth"],
        longDesc: `You create a massive rampart of hard-packed earth and stone 5 feet thick. The rampart cannot be conjured so that it occupies the same space as another creature or object. Each 5-foot-wide section of the rampart has hardness 0 and 180 hit points. A section of the rampart whose hit points drop to 0 is breached. If a creature tries to break through the rampart with a single attack, the DC for the Strength check is 60. A creature can climb over the rampart with a DC 20 Climb check.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "10-ft.-high earthen wall, in a line up to 10 ft. long/2 levels, or a circle with radius of up to 3 ft. + 1 ft./level",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Scrying, Greater",
        type: ["utility"],
        school: "divination(scrying)",
        tags: [],
        longDesc: `This spell has three different variations: one is that it allows you to choose any point on the map and see a 20 ft radius around it. This doesn't see through any illusions or walls (from the point chosen), but it does see through smoke(or similar effects) and darkness, even magical darkness, and you can use this extra sight to target creatures within the scrying location and negate any concealment those creatures have based on sight affects. The next option is targetting it on a creature (whether you can see it or not), if you do the creature is allowed a will save at a normal DC +5, and if you've harmed the creature before with a weapon attack the DC increases by another +5. If you choose this option and the creature fails the save the creature becomes tracked by your sensor and you can always see where the creature is, and automatically see through any illusions it is using to conceal itself, as well as any other concealment caused by sight. Lastly you can use this spell to see the monsters approaching for the next 2 waves, and allows you to make knowledge checks on all the creatures in the next wave.`,
        castingTime: "1 standard action",
        range: "see text",
        area: "",
        effect: "magical sensor",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "7",
        name: "Summon Monster VII",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell summons an extraplanar creature (typically an outsider, elemental, or magical beast native to another plane). It appears where you designate and acts immediately, on your turn. It attacks your opponents to the best of its ability. If you can communicate with the creature, you can direct it not to attack, to attack particular enemies, or to perform other actions. The spell conjures one of the creatures from the level on Table from: https://www.d20pfsrd.com/magic/all-spells/s/summon-monster/ of the level equal to the level of this spell. Alternatively you can choose to summon 1d3 creatures from the list 1 level below, or 1d4+1 creatures from a list at least 2 levels lower. You choose which kind of creature to summon (one type of creature at a time if you are summoning multiple) but can only summon creatures from the core list (not alternative options), and you can choose a different one each time you cast the spell. A summoned monster cannot summon or otherwise conjure another creature, nor can it use any teleportation or planar travel abilities. Creatures cannot be summoned into an environment that cannot support them. Creatures summoned using this spell cannot use spells or spell-like abilities that duplicate spells with expensive material components (such as wish). When you use a summoning spell to summon a creature with an alignment or elemental subtype, it is a spell of that type. Creatures marked with an "*" are summoned with the celestial template, if you are good, and the fiendish template, if you are evil. If you are neutral, you may choose which template to apply to the creature. Creatures marked with an "*" always have an alignment that matches yours, regardless of their usual alignment. Summoning these creatures makes the summoning spell's type match your alignment.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, F,DF,",
        },
        {
        level: "7",
        name: "Summon Nature's Ally VII",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions like summon nature's ally I, except that you can summon one 7th-level creature, 1d3 6th-level creatures of the same kind, or 1d4+1 lower-level creatures of the same kind.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "7",
        name: "Symbol of Sealing",
        type: ["utility"],
        school: "abjuration",
        tags: ["force"],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as an immediate action speak the a trigger word to trigger it, causing a wall of force to appear on each side of the area of the spell, including on top, which lasts for 1 round. If a creature is in the middle of where the wall would appear, it can make a reflex save to be on whichever side of the wall it wants. It can be triggered a maximum of 3 times. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 17 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 5 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "reflex save; see text",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Teleport Object",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `This spell functions like teleport, except that it teleports an object, not you. Creatures and magical forces cannot be teleported. If desired, the target object can be sent to a distant location on the Ethereal Plane. In this case, the point from which the object was teleported remains faintly magical until the item is retrieved. A successful targeted dispel magic spell cast on that point brings the vanished item back from the Ethereal Plane.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one touched object of up to 50 lbs./level and 3 cu. ft./level",
        duration: "instantaneous",
        savingThrow: "Will negates (object)",
        spellResistance: "yes (object)",
        components: "V, ",
        },
        {
        level: "7",
        name: "Spell Turning",
        type: ["utility", "buff"],
        school: "abjuration",
        tags: [],
        longDesc: `Spells and spell-like effects targeted on you are turned back upon the original caster. This only turns spells that have you as a target. Effect and area spells are not affected. Spell turning also fails to stop touch range spells. From seven to ten (1d4+6) spell levels are affected by the turning. The exact number is rolled secretly. When you are targeted by a spell of higher level than the amount of spell turning you have left, that spell is partially turned. Subtract the amount of spell turning left from the spell level of the incoming spell, then divide the result by the spell level of the incoming spell to see what fraction of the effect gets through. For damaging spells, you and the caster each take a fraction of the damage. For nondamaging spells, each of you has a proportional chance to be the one who is affected. If you and a spellcasting attacker are both warded by spell turning effects in operation, a resonating field is created. Roll randomly to determine the result. d% Effect 01-70 Spell drains away without effect. 71-80 Spell affects both of you equally at full effect. 81-97 Both turning effects are rendered nonfunctional for 1d4 minutes. 98-100 Both of you go through a rift into another plane.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "until expended or 10 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,DF,",
        },
        {
        level: "7",
        name: "Statue",
        type: ["utility", "buff"],
        school: "transmutation",
        tags: [],
        longDesc: `A statue spell turns the subject to solid stone, along with any garments and equipment worn or carried. In statue form, the subject gains hardness 8. The subject retains its own hit points. The subject can see, hear, and smell normally, but it does not need to eat or breathe. Feeling is limited to those sensations that can affect the granite-hard substance of the individual's body. Chipping is equal to a mere scratch, but breaking off one of the statue's arms constitutes serious damage. The subject of a statue spell can return to its normal state, act, and then return instantly to the statue state (a free action) if it so desires as long as the spell duration is in effect.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 hour/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Subjective Reality",
        type: ["utility", "control"],
        school: "illusion(phantasm)",
        tags: ["mind-affecting"],
        longDesc: `Choose one object, creature, or force you can see within long range (400 ft. + 40 ft./level). You alter your perceptions to become convinced the target is an illusion. For you, the target becomes transparent and does not create sound or smell. Until the spell ends, you can move through the target unimpeded and the target can move through you. The target's nonmagical attacks cannot harm you, and the target's magical attacks deal half damage to you. The target's non-damaging magical abilities have a 50% chance not to affect you, and you are immune to all its sonic, language-dependent, and scent-based attacks. However, your attacks deal no damage to the target, and your magical abilities do not affect the target at all. You or the target can affect each other normally through intermediaries. For instance, while the target would be immune to the direct effects of your earthquake spell, if the spell caused a room's ceiling to collapse, the target would not be immune to the effects of the collapse.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "none",
        components: "V, ",
        },
        {
        level: "7",
        name: "Symbol of Insanity",
        type: ["utility", "control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to attempt to drive all creatures within 15 feet of the rune insane, becoming permanently confused, which can only be removed with greater restoration, heal, limited wish, miracle, or wish. It can continue being triggered until it has targeted creatures equal to your level, or been activated 5 times. When it activates it activates in a burst, affecting the closest creatures first. Will negates. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 18 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 15 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "fortitude save",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Symbol of Stunning",
        type: ["utility", "control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to attempt to stun all creatures within 15 feet of the rune for 1d6 rounds. It can continue being triggered until it has targeted creatures equal to your level, or been activated 5 times. When it activates it activates in a burst, affecting the closest creatures first. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 17 + your level/2, but it cannot be activated more than once per round, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 20 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "will save",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Symbol of Weakness",
        type: ["utility", "control"],
        school: "necromancy",
        tags: [],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to attempt to weaken all creatures within 15 feet of the rune, taking 3d6 points of strength damage. It can continue being triggered until it has targeted creatures equal to your level, or been activated 5 times. When it activates it activates in a burst, affecting the closest creatures first. Fortitude negates. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 17 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 15 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "fortitude save",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Teleport Trap",
        type: ["utility", "control"],
        school: "abjuration",
        tags: [],
        longDesc: `Teleport trap wards an area, redirecting all teleportation into or out of the area to a specific point within the area determined by you at the time of casting. The destination must be an open space on a solid surface. The spell's area overlaps walls and other solid and liquid objects (preventing intruders from bypassing the ward by teleporting into a wall or through similar means). A teleporting creature that is affected by a teleport trap can resist the effect with a Will save-if the save is successful, the creature simply doesn't teleport at all (but the use of the teleport effect is still consumed)-either to the intended location or the teleport trap's actual destination. A DC 27 Knowledge (arcana) allows such a creature to recognize the teleport trap's presence, but does not reveal the trap's linked destination. At your discretion, the teleport trap can exclude a category of creatures, such as an alignment, or a type of creature (though this only works if the creature is teleporting out of the area, not into it). You select this option and the conditions at the time you cast the spell. Multiple castings of teleport trap can be linked to cover a larger area, allowing teleported creatures to be directed to a single point within the combined area of the spells.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "one 15-ft. cube/level (S)",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "7",
        name: "Creeping Doom",
        type: ["utility", "damage"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell summons four massive swarms of biting and stinging insects. These swarms appear adjacent to one another, but can be directed to move independently. Treat these swarms as centipede swarms with the following adjustments. The swarms have 60 hit points each and deal 4d6 points of damage with their swarm attack. The save to resist their poison and distraction effects is equal to the save DC of this spell. Creatures caught in multiple swarms only take damage and make saves once. You may summon the swarms so that they share the area of other creatures. As a standard action, you can command any number of the swarms to move toward any target within 100 feet of you. You cannot command any swarm to move more than 100 feet away from you, and if you move more than 100 feet from any swarm, that swarm remains stationary, attacking any creatures in its area (but can be commanded again if you move within 100 feet).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)/100 ft.; see text",
        area: "",
        effect: "four swarms of insects",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Fortitude partial; see text",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Angelic Aspect, Greater",
        type: ["buff"],
        school: "transmutation",
        tags: ["good"],
        longDesc: `This spell functions like lesser angelic aspect, except you gain low-light vision; darkvision 60 feet; DR 10/evil; immunity to acid, cold, and petrification; resistance to electricity 10 and fire 10; a +4 racial bonus on saves against poison; and protective aura and truespeech as supernatural abilities for the duration of the spell. Also, your wings give you a fly speed of 60 feet with good maneuverability. Protective aura provides a +4 deflection bonus to AC and a +4 resistance bonus on saving throws against attacks made or effects created by evil creatures to anyone within 20 feet. Otherwise, it functions as a magic circle against evil and a lesser globe of invulnerability, both with a radius of 20 feet. Truespeech allows you to speak with any creature that has a language, as though using the tongues spell.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Brilliant Inspiration",
        type: ["buff"],
        school: "evocation",
        tags: ["language-dependent"],
        longDesc: `You open a link between your mind and the subject's mind, giving advice and encouragement for as long as the spell is in effect. Each time the subject of the spell makes an attack roll, ability check, or skill check, it rolls two d20s and takes the better result. If any roll is a natural 20, the spell's effect ends-your brilliant advice is spent.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round/level and special (see below)",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, ",
        },
        {
        level: "8",
        name: "Cloak Of Chaos",
        type: ["buff"],
        school: "abjuration",
        tags: ["chaotic"],
        longDesc: `A random pattern of color surrounds the subjects, protecting them from attacks, granting them resistance to spells cast by lawful creatures, and causing lawful creatures that strike the subjects to become confused. This abjuration has four effects. First, each warded creature gains a +4 deflection bonus to AC and a +4 resistance bonus on saves. Unlike protection from law, the benefit of this spell applies against all attacks, not just against attacks by lawful creatures. Second, each warded creature gains spell resistance 25 against lawful spells and spells cast by lawful creatures. Third, the abjuration protects from possession and mental influence, just as protection from law does. Finally, if a lawful creature succeeds on a melee attack against a warded creature, the offending attacker is confused for 1 round (Will save negates, as with the confusion spell, but against the save DC of cloak of chaos).`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "",
        effect: "",
        targets: "one creature/level in a 20-ft.-radius burst centered on you",
        duration: "1 round/level",
        savingThrow: "see text",
        spellResistance: "yes (harmless)",
        components: "V, S, F,",
        },
        {
        level: "8",
        name: "Counterbalancing Aura",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `An oscillating bronze glow surrounds the targets, protecting them from attacks, granting them resistance to spells cast by neutral creatures, and sickening or nauseating neutral creatures that strike the targets. This abjuration has four effects. First, each warded creature gains a +4 deflection bonus to AC and a +4 resistance bonus on saving throws. This benefit applies against all attacks and effects, not just attacks by neutral creatures. Second, a warded creature gains spell resistance 23 against spells cast by chaotic neutral, lawful neutral, neutral evil, and neutral good creatures, and spell resistance 27 against spells cast by neutral creatures with no other alignment components. Third, the spell protects warded creatures from possession and influence by such creatures (otherwise as protection from evil). Finally, if a chaotic neutral, lawful neutral, neutral evil, or neutral good creature successfully hits a warded creature with a melee attack, the attacker is sickened for 1d6 rounds (Fortitude negates). If a neutral creature successfully hits a warded creature with a melee attack, the attacker is instead nauseated for 1d6 rounds (Fortitude negates).`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "",
        effect: "",
        targets: "one creature/level in a 20-ft.-radius burst centered on you",
        duration: "1 round/level",
        savingThrow: "see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Divine Vessel",
        type: ["buff"],
        school: "transmutation",
        tags: ["chaotic", "evil", "good", "lawful"],
        longDesc: `You accept otherworldly energies into your body and transform. Your size increases by one category, your height doubles, and your weight increases by a factor of eight. Your features shift into those of a cold and alien being of logic, a creature of primal chaos, an angelic presence, or a fiendish monster, as chosen by you. You gain a +6 size bonus to Strength and Constitution, a +3 natural armor bonus, darkvision 60 ft., and SR of 12 + your caster level. These modifiers replace the normal modifiers for increasing your size. The size modifier for AC, attacks, CMB, and CMD changes as appropriate for your new size category. This spell doesn't change your base speed. If insufficient room is available for the desired growth, you attain the maximum possible size and may make a Strength check (using your increased Strength) to burst any enclosures in the process. All equipment you wear or carry is similarly enlarged by this spell. Any enlarged item that leaves your possession (including a projectile or thrown weapon) instantly returns to its normal size. This means that thrown and projectile weapons deal their normal damage. Magical effects that increase size do not stack. You gain additional abilities as noted below. 
        \nAnarchic aspect: You gain the following abilities: an additional +2 bonus to Constitution, DR 10/lawful, resist acid 10, electricity 10, and sonic 10, a +4 bonus on saves against poison, blindsense 30 feet, and a fly speed of 60 feet (good maneuverability). You gain a bite attack dealing 2d6 points of damage. Your natural weapons and any weapons you wield are considered chaotic-aligned for the purpose of overcoming damage resistance. 
        \nAxiomatic aspect: You gain the following abilities: an additional +2 bonus to Strength, DR 10/chaotic, resist cold 10, electricity 10, and fire 10, a +4 bonus on saves against poison, low-light vision, and a fly speed of 60 feet (good maneuverability). You gain 2 slam attacks dealing 1d6 points of damage each. Your natural weapons and any weapons you wield are considered lawful-aligned for the purpose of overcoming damage resistance. 
        \nCelestial aspect: You gain the following abilities: a +2 bonus to Dexterity, DR 10/evil, resist acid 10, cold 10, and electricity 10, a +4 bonus on saves against poison, low-light vision, and a fly speed of 60 feet (good maneuverability). You gain 2 slam attacks dealing 1d6 points of damage each. Your natural weapons and any weapons you wield are considered goodaligned for the purpose of overcoming damage resistance. 
        \nFiendish aspect: You gain the following abilities: an additional +2 bonus to Strength, DR 10/good, resist acid 10, cold 10, and fire 10, a +4 bonus on saves against poison, see in darkness, and a fly speed of 60 feet (good maneuverability). You gain 2 claw attacks dealing 1d6 points of damage each. Your natural weapons and any weapons you wield are considered evil-aligned for the purpose of overcoming damage resistance. 
        \n\nWhen used to assume an anarchic, axiomatic, celestial, or fiendish aspect, this spell is a chaotic, lawful, good, or evil spell respectively.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Executing Weapons",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument] The touched weapon becomes incredibly honed, increasing its critical damage multiplier by +1. A weapon can have only a single imbument at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 weapon",
        duration: "1 round/2 levels",
        savingThrow: "will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "8",
        name: "Heavy Weapons",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument] The touched weapon becomes incredibly heavy, and increases its kinetic energy massively, causing it to deal damage as if it was two size catagories larger. This stacks with other effective size increases, however you gain a -4 penalty to attack with this weapon while the spell is active. A weapon can have only a single imbument at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 weapon",
        duration: "1 round/2 levels",
        savingThrow: "will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "8",
        name: "Holy Aura",
        type: ["buff"],
        school: "abjuration",
        tags: ["good"],
        longDesc: `A brilliant divine radiance surrounds the subjects, protecting them from attacks, granting them resistance to spells cast by evil creatures, and causing evil creatures to become blinded when they strike the subjects. This abjuration has four effects. First, each warded creature gains a +4 deflection bonus to AC and a +4 resistance bonus on saves. Unlike protection from evil, this benefit applies against all attacks, not just against attacks by evil creatures. Second, each warded creature gains spell resistance 25 against evil spells and spells cast by evil creatures. Third, the abjuration protects the recipient from possession and mental influence, just as protection from evil does. Finally, if an evil creature succeeds on a melee attack against a creature warded by a holy aura, the offending attacker is blinded (Fortitude save negates, as blindness/deafness, but against holy aura's save DC).`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "",
        effect: "",
        targets: "one creature/level in a 20-ft.-radius burst centered on you",
        duration: "1 round/level",
        savingThrow: "see text",
        spellResistance: "yes (harmless)",
        components: "V, S, F,",
        },
        {
        level: "8",
        name: "Iron Body",
        type: ["buff"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell transforms your body into living iron, which grants you several powerful resistances and abilities. You gain damage reduction 15/adamantine. You are immune to blindness, critical hits, ability score damage, deafness, disease, drowning, electricity, poison, stunning, and all spells or attacks that affect your physiology or respiration, because you have no physiology or respiration while this spell is in effect. You take only half damage from acid and fire. However, you also become vulnerable to all special attacks that affect iron golems. You gain a +6 enhancement bonus to your Strength score, but you take a -6 penalty to Dexterity as well (to a minimum Dexterity score of 1), and your speed is reduced to half normal. You have an arcane spell failure chance of 35% and a -6 armor check penalty, just as if you were clad in full plate armor. You cannot drink (and thus can't use potions) or play wind instruments. Your unarmed attack deals damage equal to a club sized for you (1d4 for Small characters or 1d6 for Medium characters), and you are considered armed when making unarmed attacks. Your weight increases by a factor of 10, causing you to sink in water like a stone. However, you could survive the lack of air at the bottom of the ocean-at least until the spell duration expires.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,DF,",
        },
        {
        level: "8",
        name: "Moment of Prescience",
        type: ["buff"],
        school: "divination",
        tags: [],
        longDesc: `This spell grants you a sixth sense. Once during the spell's duration, you may choose to use its effect. This spell grants you an insight bonus equal to your caster level (maximum +25) on any single attack roll, combat maneuver check, opposed ability or skill check, or saving throw. Alternatively, you can apply the insight bonus to your AC against a single attack (even if flat-footed). Activating the effect doesn't take an action; you can even activate it on another character's turn. You must choose to use the moment of prescience before you make the roll it is to modify. Once used, the spell ends. You can't have more than one moment of prescience active on you at the same time.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 hour/level or until discharged",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Nine Lives",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `Despite its name, this powerful ward does not grant the target multiple lives, but rather gives the target the ability to get out of trouble and relieves harmful effects and conditions. For the spell's duration, the target can use any of the following abilities as an immediate action, but only up to a total of nine times, at which point the spell ends. 
                
        Cat's Luck: The target can use this ability when it fails a saving throw. The target can reroll the failed saving throw, but must take the new result even if it is worse. 
                
        Fortitude: The target uses this ability when a critical hit or sneak attack is scored against it. The critical hit or sneak attack is negated and the damage is instead rolled normally. 
                
        Rejuvenate: The target uses this ability when it is reduced to 0 or fewer hit points. The target is instantly healed 3d6 points of damage. If enough hit points are regained to bring the target to positive hit points, it does not fall unconscious. If it is not enough to leave the target with positive hit points, the target automatically stabilizes. Both of these effects work even if the damage was originally enough to kill the target. 
                
        Shake Off: The target uses this ability when it is under the effects of any of the following conditions: blinded, confused, cowering, dazed, dazzled, entangled, exhausted, fatigued, frightened, nauseated, panicked, shaken, sickened, or staggered. Using this ability ends one of those conditions. 
                
        Shimmy Out: The target uses this ability when it is grappled or pinned. The target automatically escapes the grapple as if it had succeeded at an Escape Artist check to escape the grapple. 
                
        Stay Up: The target uses this ability when it is tripped or otherwise knocked prone. The target steadies itself and stays upright.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "one creature touched",
        duration: "1 hour/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "8",
        name: "Protection from Spells",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `The subject gains a +8 resistance bonus on saving throws against spells and spell-like abilities (but not against supernatural and extraordinary abilities).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "up to one creature touched per four levels",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,F,",
        },
        {
        level: "8",
        name: "Seamantle",
        type: ["buff"],
        school: "conjuration(creation)",
        tags: ["water"],
        longDesc: `You sheathe yourself within a churning column of pure elemental water up to 30 feet high that fills your space. You gain a swim speed equal to your land speed and can see, hear, and breathe normally within the seamantle, but attacks against you are treated as if you were under the surface of the water. You gain improved cover (+8 cover bonus to AC, +4 bonus on Reflex saves) against foes that do not have freedom of movement effects. The cover granted by the seamantle does not enable you to make Stealth checks or prevent attacks of opportunity. Magical attacks against you are unaffected unless they require attack rolls or state that they do not function underwater (such as cloudkill). The seamantle blocks line of effect for any fire spell or supernatural fire effect, but enemies can attempt to use fire spells within the seamantle; this requires a caster level check (DC 20 + spell level), and if successful the fire spell takes as a bubble of steam contained within the seamantle rather than its usual effect. The seamantle allows you to make a slam attack by forming a pseudopod of water, inflicting damage appropriate for your size. This slam attack has a reach of 30 feet. In addition, as a standard action, you can attempt to extinguish fires by touch. You automatically extinguish up to a 10-foot cube of normal fire. Against magical fire effects, your touch acts as dispel magic; this also applies to any non-instantaneous fire affect that comes into contact with you (such as flame blade, flaming sphere, or incendiary cloud). Even if you fail to extinguish a fire, you are not harmed by it. A flaming or flaming burst weapon that strikes you has its power suppressed for 1d4 rounds if the wielder fails a Fortitude save.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Shield Of Law",
        type: ["buff"],
        school: "abjuration",
        tags: ["lawful"],
        longDesc: `A dim, blue glow surrounds the subjects, protecting them from attacks, granting them resistance to spells cast by chaotic creatures, and slowing chaotic creatures when they strike the subjects. This abjuration has four effects. First, each warded creature gains a +4 deflection bonus to AC and a +4 resistance bonus on saves. Unlike protection from chaos, this benefit applies against all attacks, not just against attacks by chaotic creatures. Second, a warded creature gains spell resistance 25 against chaotic spells and spells cast by chaotic creatures. Third, the abjuration protects you from possession and mental influence, just as protection from chaos does. Finally, if a chaotic creature succeeds on a melee attack against a warded creature, the attacker is slowed (Will save negates, as the slow spell, but against shield of law's save DC).`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "",
        effect: "",
        targets: "one creature/level in a 20-ft.-radius burst centered on you",
        duration: "1 round/level",
        savingThrow: "see text",
        spellResistance: "yes (harmless)",
        components: "V, S, F,",
        },
        {
        level: "8",
        name: "Spell Absorption, Greater",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions as spell absorption, save that you can absorb countered spells of 6th level or lower.`,
        castingTime: "1 round",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Spell Immunity, Greater",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions like spell immunity, except the immunity applies to spells of 8th level or lower. A creature can have only one spell immunity or greater spell immunity spell in effect on it at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "8",
        name: "Swift Weapons",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument] The touched weapon becomes incredibly light and swift, it deals damage as if it were one size catagory smaller, however when making a full-attack action you can take an additional attack at your highest attack modifier (this stacks with similar abilities), additionally whenever you score a critical hit with the weapon, it provokes an attack of opportunity from you against the creature you scored the critical hit against. A weapon can have only a single imbument at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 weapon",
        duration: "1 round/2 levels",
        savingThrow: "will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "8",
        name: "Umbral Infusion, Mass",
        type: ["buff"],
        school: "necromancy",
        tags: ["shadow"],
        longDesc: `This spell functions as umbral infusion except it can affect multiple undead creatures. You infuse the target undead creatures with power drawn from the Shadow Plane, immediately granting it the advanced creature simple template. It gains a +2 bonus on all rolls, including damage rolls, a +2 bonus to special ability DCs, a +4 bonus to AC and CMD, and 2 additional hit points per Hit Die. The undead creature's destructive instincts take hold for the duration of this spell, and any attempts to control or command the undead creature have a 50% chance of failing; if uncontrolled, the undead creature attacks any living creatures it sees. This spell has no effect on undead creatures that already have the advanced creature template.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one mindless undead creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 minute/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Unholy Aura",
        type: ["buff"],
        school: "abjuration",
        tags: ["evil"],
        longDesc: `A malevolent darkness surrounds the subjects, protecting them from attacks, granting them resistance to spells cast by good creatures, and weakening good creatures when they strike the subjects. This abjuration has four effects. First, each warded creature gains a +4 deflection bonus to AC and a +4 resistance bonus on saves. Unlike the effect of protection from good, this benefit applies against all attacks, not just against attacks by good creatures. Second, a warded creature gains SR 25 against good spells and spells cast by good creatures. Third, the abjuration protects the subjects from possession and mental influence, just as protection from good does. Finally, if a good creature succeeds on a melee attack against a warded creature, the offending attacker takes 1d6 points of Strength damage (Fortitude negates).`,
        castingTime: "1 standard action",
        range: "20 ft.",
        area: "",
        effect: "",
        targets: "one creature/level in a 20-ft.-radius burst centered on you",
        duration: "1 round/level",
        savingThrow: "see text",
        spellResistance: "yes (harmless)",
        components: "V, S, F,",
        },
        {
        level: "8",
        name: "Frightful Aspect",
        type: ["buff", "control"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `You become a larger, awful version of yourself. You grow to size Large, and take on features that horrify your enemies. You gain the following abilities: a +6 size bonus to Strength, a +4 size bonus to Constitution, a +6 natural armor bonus, DR 10/magic, and spell resistance equal to 10 + half your caster level. You also emit an aura that emanates 30 feet from you. Enemy creatures within the aura are shaken. Each time a creature shaken by this aura hits you with a melee attack, that creature becomes frightened for 1d4 rounds, though at the end of that duration it is no longer affected by this aura. The aura's effect is a fear and mind-affecting effect.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Animal Shapes",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `As beast shape III, except you change the form of up to one willing creature per caster level into an animal of your choice; the spell has no effect on unwilling creatures. All creatures must take the same kind of animal form. Recipients remain in the animal form until the spell expires or until you dismiss it for all recipients. In addition, an individual subject may choose to resume its normal form as a full-round action; doing so ends the spell for that subject alone.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "up to one willing creature per level, all within 30 ft. of each other.",
        duration: "1 hour/level",
        savingThrow: "none; see text",
        spellResistance: "yes (harmless)",
        components: "V, S, DF",
        },
        {
        level: "8",
        name: "Form of the Alien Dragon III",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as per form of the alien dragon II, except it also allows you to take the form of a Huge esoteric or outer dragon. Psychics can choose from the esoteric dragon (astral, dream, etheric, nightmare, or occult) forms only. You gain the following: a +10 size bonus to your Strength, a +8 size bonus to your Constitution, a +8 natural armor bonus, a fly speed of 120 feet (poor), blindsense with a range of 60 feet, darkvision with a range of 120 feet, a breath weapon, damage reduction 10/magic, frightful presence (DC = DC for this spell), and immunity to one form of energy or effect (of the same type form of the alien dragon I grants either a bonus against or resistance to, if any). You also gain one bite attack (2d8), two claw attacks (2d6), two wing attacks (1d8), and one tail slap attack (2d6). You can use the breath weapon as often as you like, but must wait 1d4 rounds between uses. All breath weapons deal 12d8 points of damage unless noted otherwise and allow a Reflex save to halve the normal damage. Line breath weapons increase to 100-foot lines and cones increase to 50-foot cones.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Form of the Dragon III",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as form of the dragon II save that it also allows you to take the form of a Huge chromatic or metallic dragon. You gain the following abilities: a +10 size bonus to Strength, a +8 size bonus to Constitution, a +8 natural armor bonus, fly 120 feet (poor), blindsense 60 feet, darkvision 120 feet, a breath weapon, DR 10/magic, frightful presence (DC equal to the DC for this spell), and immunity to one element (of the same type form of the dragon I grants resistance to). You also gain one bite (2d8), two claws (2d6), two wing attacks (1d8), and one tail slap attack (2d6). You can use the breath weapon as often as you like, but you must wait 1d4 rounds between uses. All breath weapons deal 12d8 points of damage and allow a Reflex save for half damage. Line breath weapons increase to 100-foot lines and cones increase to 50-foot cones.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "see below",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Form of the Exotic Dragon III",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as per form of the exotic dragon II except that it also allows you to take the form of a Huge imperial or primal dragon. Druids can choose from the primal dragon (brine, cloud, crystal, magma, or umbral) forms only. You gain the following abilities: a +10 size bonus to your Strength, a +8 size bonus to your Constitution, a +8 natural armor bonus, a fly speed of 120 feet (poor), blindsense with a range of 60 feet, darkvision with a range of 120 feet, a breath weapon, damage reduction 10/ magic, frightful presence (DC = DC for this spell), and immunity to one form of energy (of the same type form of the exotic dragon I grants a resistance to, if any). You gain one bite attack (2d8), two claw attacks (2d6), a one tail slap attack (2d6), and either a gore attack (2d8) if you assume the form of an imperial dragon or two wing attacks (1d8) if you assume the form of a primal dragon. You can use the breath weapon as often as you like, but must wait 1d4 rounds between uses. All breath weapons deal 12d8 points of damage unless noted otherwise and allow a Reflex save to halve the normal damage. Line breath weapons increase to 100-foot lines and cones increase to 50-foot cones.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "see below",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Giant Form II",
        type: ["buff", "utility"],
        school: "Transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as giant form I except that it also allows you to assume the form of any Huge creature of the giant type. You gain the following abilities: a +8 size bonus to Strength, a -2 penalty to Dexterity, a +6 size bonus to Constitution, a +6 natural armor bonus, low-light vision, and a +10 foot enhancement bonus to your speed. If the form you assume has any of the following abilities, you gain the listed ability: swim 60 feet, darkvision 60 feet, rend (2d8 damage), regeneration 5, rock catching, and rock throwing (range 120 feet, 2d10 damage). If the creature has immunity or resistance to one element, you gain that immunity or resistance. If the creature has vulnerability to an element, you gain that vulnerability.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Mind Blank",
        type: ["buff", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `The subject is protected from all devices and spells that gather information about the target through divination magic (such as detect evil, locate creature, scry, and see invisible). This spell also grants a +8 resistance bonus on saving throws against all mindaffecting spells and effects. Mind blank even foils limited wish, miracle, and wish spells when they are used in such a way as to gain information about the target. In the case of scrying that scans an area the creature is in, such as arcane eye, the spell works but the creature simply isn't detected. Scrying attempts that are targeted specifically at the subject do not work at all.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "24 hours",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Undead Anatomy IV",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as undead anatomy III, except it allows you to use more abilities. If the form you assume has any of the following abilities, you gain the listed ability: burrow 60 feet, climb 90 feet, fly 120 feet (good maneuverability), swim 120 feet, blindsense 60 feet, darkvision 90 feet, lifesense 60 feet, low-light vision, scent, tremorsense 60 feet, breath weapon, constrict, DR 10/magic and silver, DR 15/bludgeoning and magic, fast healing 5, fiery death, fire aura, grab, incorporeal, jet, poison, pounce, rake, rend, roar, spikes, trample, trip, and web. If the creature's form is incorporeal, the spell's duration is in rounds per level instead of minutes per level, and your bite and claw (or slam) attacks are incorporeal touch attacks. If the creature has immunity or resistance to any energy types, you gain resistance 30 to those energy types. If the creature has vulnerability to an energy type, you gain that vulnerability. In this form, you gain a +8 bonus on saves against mindaffecting effects, disease, poison, sleep, and stunning. If the form has a vulnerability to an attack (such as sunlight), you gain that vulnerability. Tiny undead: If the form you take is that of a Tiny undead, you gain a -2 penalty to your Strength, a +8 size bonus to your Dexterity, and a +3 natural armor bonus. Large undead: If the form you take is that of a Large undead, you gain a +6 size bonus to your Strength, a -2 penalty on your Dexterity, a +2 size bonus to your Constitution, and a +6 natural armor bonus.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D) (see text)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Binding",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `A binding spell creates a magical restraint to hold a creature. This spell has its DC lowered by 5, however your knowledge of other magic increases the DC of the spell, for each spell you have from the following list, the DC increases by +1 (a mass version satisfies the condition, but does not stack with the original spell to increase the DC). If another caster knows the binding spell, they can cast the spell in tandem with you, increasing the DC by +4, +1 for every 4 spells from the list they know. (assuming the successfully cast the spell when you do).
        The spells are: Command, Command Greater, Suggestion, Dominate Animal, Dominate Person, Dominate Monster, Charm Animal, Charm Person, Sacramental Seal, Maze, Imprisonment, Hold Monster, Hold Person, Temporal Stasis, Dimensional Lock, Forcecage, Freedom. 
        \nThe binding spell has four versions. Choose one of the following versions when you cast the spell.
        Chained: The subject is unable to move from its current square, becomes entangled, and grappled, and all melee attacks against it bypass any magical illusion that would grant miss chance. The DC for this version is 2 higher. The resave to escape this version is a reflex save.
        Held: The subject becomes paralyzed by a near infinite amount of magical bindings, though it can still take purely mental actions. Lasts 1 round per level, and the resave DC increases by +2.
        Slumber: The subject to become comatose. If the creature receives damage on its turn it makes its resave with a +4. This is a sleep effect. This lasts minutes per level.
        Banishment From the World: The subject is permanently removed from the universe and trapped in an eternal prison, treat the creature as slain. The DC of this version is reduced by 6.
        \nYou can't dispel a binding spell with dispel magic or a similar effect, though an antimagic field or mage's disjunction affects it normally.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "see text",
        savingThrow: "Will negates; see text",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Blood Mist",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["poison"],
        longDesc: `This spell summons forth a misty cloud of rust-red toxic algae. Any creature within the mist is coated by it, turning the creature the same reddish color. All targets within the mist gain concealment. Any creature within the mist must save or take 1d4 points of Wisdom damage and become enraged, attacking any creatures it detects nearby (as the "attack nearest creature" result of the confused condition). An enraged creature remains so as long as the spell is in effect. A creature only needs to save once each time it is within the mist (though leaving and returning requires another save).`,
        castingTime: "1 standard action",
        range: "medium (100ft. +10ft./level)",
        area: "60-ft. radius",
        effect: "",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "Fortitude negates (see text)",
        spellResistance: "yes",
        components: "V, S, M, ",
        },
        {
        level: "8",
        name: "Charm Monster, Mass",
        type: ["control"],
        school: "enchantment(charm)",
        tags: ["mind-affecting"],
        longDesc: `This charm makes multiple creatures regard you as friendly. The creatures will not attack you and will attempt to exclude you from all area of affect abilities or spells it has (it wont turn off that ablity if it us unable to avoid you), it can also count for flanking or as an ally for any other ability you have, and will accept harmless spells cast by you. It will not attempt to help you in any other way and you have no other control over it, such as protecting you from another creature, and will attempt to attack all other party members as normal. If you attack, damage, or cast any non-harmless spells on the creature,  it gets an immediate resave with a +5 bonus (once per attack or ability).  `,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one or more living creatures, no two of which can be more than 30 ft. apart",
        duration: "1 hour/level",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V",
        },
        {
        level: "8",
        name: "Control Plants",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell enables you to control the actions of one or more plant creatures for a short period of time. You command the creatures by voice and they understand you, no matter what language you speak. Even if vocal communication is impossible, the controlled plants do not attack you. At the end of the spell, the subjects revert to their normal behavior. Suicidal or self-destructive commands are simply ignored.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "up to 2 HD/level of plant creatures, no two of which can be more than 30 ft. apart",
        duration: "1 min./level",
        savingThrow: "Will negates",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
        level: "8",
        name: "Earthquake",
        type: ["control"],
        school: "evocation",
        tags: ["earth"],
        longDesc: `When you cast earthquake, an intense but highly localized tremor rips the ground. The powerful shockwave created by this spell knocks creatures down, collapses structures, opens cracks in the ground, and more. The effect lasts for 1 round, during which time creatures on the ground can’t move or attack. A spellcaster on the ground must make a Concentration check (DC 20 + spell level) or lose any spell he or she tries to cast. The earthquake affects all terrain, vegetation, structures, and creatures in the area. The specific effect of an earthquake spell depends on the nature of the terrain where it is cast.
        \nCave, Cavern, or Tunnel: The roof collapses, dealing 8d6 points of damage to any creature caught under the cave-in (Reflex DC 15 half) and pinning that creature beneath the rubble (see below). An earthquake cast on the roof of a very large cavern could also endanger those outside the actual area but below the falling debris and rubble.
        \nCliffs: Earthquake causes a cliff to crumble, creating a landslide that travels horizontally as far as it falls vertically. Any creature in the path takes 8d6 points of bludgeoning damage (Reflex DC 15 half) and is pinned beneath the rubble (see below).
        \nOpen Ground: Each creature standing in the area must make a DC 15 Reflex save or fall down. Fissures open in the earth, and every creature on the ground has a 25% chance to fall into one (Reflex DC 20 to avoid a fissure). The fissures are 40 feet deep. At the end of the spell, all fissures grind shut. Treat all trapped creatures as if they were in the bury zone of an avalanche, trapped without air (see Environment for more details).
        \nStructure: Any structure standing on open ground takes 100 points of damage, enough to collapse a typical wooden or masonry building, but not a structure built of stone or reinforced masonry. Hardness does not reduce this damage, nor is it halved as damage dealt to objects normally is. Any creature caught inside a collapsing structure takes 8d6 points of bludgeoning damage (Reflex DC 15 half) and is pinned beneath the rubble (see below).
        \nRiver, Lake, or Marsh: Fissures open under the water, draining away the water from that area and forming muddy ground. Soggy marsh or swampland becomes quicksand for the duration of the spell, sucking down creatures and structures. Each creature in the area must make a DC 15 Reflex save or sink down in the mud and quicksand. At the end of the spell, the rest of the body of water rushes in to replace the drained water, possibly drowning those caught in the mud.
        \nPinned Beneath Rubble: Any creature pinned beneath rubble takes 1d6 points of nonlethal damage per minute while pinned. If a pinned character falls unconscious, he or she must make a DC 15 Constitution check or take 1d6 points of lethal damage each minute thereafter until freed or dead.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "80-ft.-radius spread (S)",
        effect: "",
        targets: "",
        duration: "1 round",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, DF,",
        },
        {
        level: "8",
        name: "Euphoric Tranquility",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `A creature under the effect of this enchantment enters a state of euphoria. The target treats all creatures as dear friends and abhors violence, but may rise up to protect itself if violence is perpetrated against it. Until the end of the spell's duration, the creature's speed is halved, and it cannot make attacks or cast spells. If the creature is attacked, it gets a Will saving throw. If the saving throw succeeds, the creature can make act normally for 1 round. If the saving throw fails, the creature moves half its speed away from the attacker as its next action. Furthermore, if the creature is interacted with, or questioned while under the effects of this spell, it is considered to have an attitude of Helpful (see the Diplomacy skill, Core Rulebook 94), though any advice or answers it gives may be disjointed or stream of consciousness due to its euphoric state.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "1 round/level",
        savingThrow: "none and Will partial (see below)",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "8",
        name: "Irresistible Dance",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `The subject feels an undeniable urge to dance and begins doing so, complete with foot shuffling and tapping. The spell effect makes it impossible for the subject to do anything other than caper and prance in place. The effect imposes a -4 penalty to Armor Class and a -10 penalty on Reflex saves, and it negates any AC bonus granted by a shield the target holds. The dancing subject provokes attacks of opportunity each round on its turn. A successful Will save reduces the duration of this effect to 1 round.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "living creature touched",
        duration: "1d4+1 rounds",
        savingThrow: "Will partial",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "8",
        name: "Maze",
        type: ["control"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `You banish the subject into an extradimensional labyrinth. Each round on its turn, it may attempt a DC 20 Intelligence check to escape the labyrinth as a full-round action. If the subject doesn't escape, the maze disappears after 10 minutes, freeing the subject. On escaping or leaving the maze, the subject reappears where it had been when the maze spell was cast. If this location is filled with a solid object, the subject appears in the nearest open space. Spells and abilities that move a creature within a plane, such as teleport and dimension door, do not help a creature escape a maze spell, although a plane shift spell allows it to exit to whatever plane is designated in that spell. Minotaurs are not affected by this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "see text",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Power Word Stun",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You utter a single word of power that instantly causes one creature of your choice to become stunned, whether the creature can hear the word or not. The duration of the spell depends on the target's current hit point total. Any creature that currently has 151 or more hit points is unaffected by power word stun. If it has 50 hit points or less it lasts 4d4 rounds, between 51-100 2d4 rounds, and between 101-150 1d4 rounds. The creature gets a resave as normal, but for each d4 rounds the stun lasts, the DC on the resave increases by +1.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature with 150 hp or less",
        duration: "See text",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "8",
        name: "Prediction of Failure",
        type: ["control"],
        school: "divination",
        tags: ["curse", "fear", "mind-affecting"],
        longDesc: `You wrack the target's body and mind with the anguish and suffering of every bitter failure it will ever experience, rendering it permanently shaken and sickened. A successful Will save reduces the duration to 1 round per level. If the target is a spellcaster, failing this saving throw means it also gains a random minor spellblight https://www.d20pfsrd.com/magic/variant-magic-rules/spellblights/.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "permanent or 1 round/level (see text)",
        savingThrow: "Will partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Repel Metal or Stone",
        type: ["control"],
        school: "abjuration",
        tags: ["earth"],
        longDesc: `This spell creates waves of invisible energy that roll forth from you. All metal or stone objects in the path of the spell are pushed away from you to the limit of the range. Fixed metal or stone objects larger than 3 inches in diameter and loose objects weighing more than 500 pounds are not affected. Anything else, including animated objects, small boulders, and creatures in metal armor, moves back. Fixed objects 3 inches in diameter or smaller bend or break, and the pieces move with the wave of energy. Objects affected by the spell are repelled at the rate of 40 feet per round. Objects such as metal armor, swords, and the like are pushed back, dragging their bearers with them. Even magic items with metal components are repelled, although an antimagic field blocks the effects. A creature being dragged by an item it is carrying can let go. A creature being dragged by a shield can loose it as a move action and drop it as a free action. The waves of energy continue to sweep down the set path for the spell's duration. After you cast the spell, the path is set, and you can then do other things or go elsewhere without affecting the spell's power.`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "60-ft. line from you",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Sacramental Seal",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `You trap the target in an object decorated with the holy symbols of your god or faith. This spell can only affect a creature at least 2 or more alignment steps away from you. If the creature is 3 or more alignment steps away from you the DC of this spell increases by 2, if they are 4 or more alignment steps away from you the DC increases by 4. While trapped in the object, the creature can't take any actions and is immune to spells and spell-like abilities. Only a freedom, miracle, or wish spell can dispel the enchantment, though destroying the object frees the creature, and the creature gets its save every turn as normal. However, you can spend 8 spell points at the start of their turn to increase the DC of escaping by 1 permanently. If a creature fails to escape for 3 rounds in a row, it is captured forever. If it escapes, it appears adjacent to you.`,
        castingTime: "1 round",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Scintillating Pattern",
        type: ["control"],
        school: "illusion(pattern)",
        tags: ["mind-affecting"],
        longDesc: `A twisting pattern of coruscating colors weaves through the air, affecting creatures within. The spell affects a total number of HD of creatures equal to your caster level (maximum 20). Creatures with the fewest HD are affected first, and among creatures with equal HD, those who are closest to the spell's point of origin are affected first. HD that are not sufficient to affect a creature are wasted. The spell affects each subject according to its HD. 6 or less: Unconscious for 1d4 rounds, then stunned for 1d4 rounds, and then confused for 1d4 rounds. (Treat an unconscious result as stunned for nonliving creatures.) 7 to 12: Stunned for 1d4 rounds, then confused for an additional 1d4 rounds. 13 or more: Confused for 1d4 rounds. Sightless creatures are not affected by scintillating pattern.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "colorful lights in a 20-ft.-radius spread",
        targets: "",
        duration: "concentration + 2 rounds",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Sympathy",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `You cause an object or location to emanate magical vibrations that attract either a specific kind of intelligent creature or creatures of a particular alignment, as defined by you. The particular kind of creature to be affected must be named specifically. A creature subtype is not specific enough. Likewise, the specific alignment must be named. It radiats 60ft from the location or object.
                    
        Creatures of the specified kind or alignment that fail the save must enter into the area or touch the object. Every turn it may make a resave as normal, but as long as the effect persists at the start of its turn it must make another save or return to the location or touch the object. Touching an object is a free action a creature can do while being adjacent to it, unless a creature holds it, in which case it requires a movement action that provokes, but it can also touch it while making a successful melee attack with a natural weapon as long as the attack roll is also higher than the creatures CMD. A creature that fails to touch the object or enter the area on its turn gets a cumulative -2 to all d20 rolls until it saves against the spell or it ends.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one location (up to a 10-ft. cube/level) or one object",
        duration: "1 round/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "8",
        name: "Temporal Stasis",
        type: ["control"],
        school: "transmutation",
        tags: [],
        longDesc: `You must succeed on a melee touch attack. You place the subject into a state of suspended animation. For the creature, time ceases to flow, and its condition becomes fixed. The creature does not grow older. Its body functions virtually cease, and no force or effect can harm it. This state persists until the magic is removed (such as by a successful dispel magic spell or a freedom spell).`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "permanent",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Trap the Soul",
        type: ["control"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `Trap the soul forces a creature's life force (and its material body) into a gem, while in the gem they are immune to any spells or abilities. When casting the spell you may make a bluff or diplomacy check vs the creatures sense motive, if you succeed the DC of the spell increases by 1. For each 10 you beat their sense motive by the DC increases by another +1. If you know certain spells from the list below you can expend spell points as if casting that spell to increase your bluff or diplomacy by the listed amount (the mass version counts but does not stack with the original). You can only spend spell points for a bonus from a single option once. If the creature would be immune to that spell you only get half the listed bonus. The creature gets its resave, but it cannot begin making resaves for 1 round plus 1 round per 20 that you beat it sense motive check by, but the increased DC does not include additional DC gained by the bluff or diplomacy check.     
        \nThe spells are:\nCharm Person/Animal/Monster: +10\nDominate Person/Animal/Monster: +20\nSympathy: +30`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "permanent; see text",
        savingThrow: "see text",
        spellResistance: "yes; see text",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Vinetrap",
        type: ["control"],
        school: "conjuration",
        tags: [],
        longDesc: `Vines choked with thorns, blossoms, leaflets, and other floral debris burst to life on and around the subject of this spell, winding around limbs and armor and making it progressively more difficult for the subject to maneuver. When this spell is cast, the subject may attempt a Reflex save. Success indicates that the vines fail to take root and the spell has no effect. On a failed save, the subject's base speed is immediately reduced by 5 feet. Each round thereafter, the subject must make another successful Reflex save or his speed is reduced by another 5 feet. This occurs each round until he is reduced to a speed equal to half of what it was before the spell was cast. As a full-round action, the subject or an adjacent creature can tear the vines off the subject's body, resetting the speed penalty to just 5 feet, though the vines continue to grow each round thereafter for the spell's duration, requiring additional checks, unless it is actually dispelled. The spell's effects can also be prematurely ended by dealing at least 20 points of fire damage to the subject. When the spell's duration ends or the effect is terminated, the vines immediately wilt and the subject's speed returns to normal. Regardless of the subject's base speed, the vines cannot reduce a creature's speed below 5 feet. This spell has additional effects depending on which version you cast, chosen when you cast the spell. Blessed Thorns: The vines sprout vicious thorns made of celestial steel. Each round at the beginning of your turn, the subject takes 2d4 points of damage, plus 1 point of damage for each round since the creature last took a full-round action to tear the vines off. When you cast this version of the spell, you can also choose to make the thorns either cold iron or silver for the purposes of overcoming damage reduction. Noxious Vines: The vines emit noxious fumes that act as a lung and eye irritant. The subject and any creatures adjacent to the subject must attempt a DC 15 Fortitude check each round at the beginning of their turn. On a failed save, the creatures becomes blinded for that round and can't cast spells with verbal components. Swift Vines: The vines act twice as quickly as normal, and slow the creature by 10 feet per round instead of 5 feet (though they still can't decrease the creature's speed to less than half). In addition, once the creature is slowed to half-speed, it becomes staggered until the vines are torn off or the spell ends.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 round/level (D)",
        savingThrow: "Reflex negates (see text)",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "8",
        name: "Whirlwind",
        type: ["control"],
        school: "evocation",
        tags: ["air"],
        longDesc: `This spell creates a powerful cyclone of raging wind that moves through the air, along the ground, or over water at a speed of 60 feet per round. You can concentrate on controlling the cyclone's every movement or specify a simple program. Directing the cyclone's movement or changing its programmed movement is a standard action for you. The cyclone always moves during your turn. If the cyclone exceeds the spell's range, it moves in a random, uncontrolled fashion for 1d3 rounds and then dissipates. (You can't regain control of the cyclone, even if it comes back within range.) Any Large or smaller creature that comes in contact with the spell effect must succeed on a Reflex save or take 3d6 points of damage. A Medium or smaller creature that fails its first save must succeed on a second one or be picked up bodily by the cyclone and held suspended in its powerful winds, taking 1d8 points of damage each round on your turn with no save allowed. You may direct the cyclone to eject any carried creatures whenever you wish, depositing the hapless souls wherever the cyclone happens to be when they are released.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "cyclone 10 ft. wide at base, 30 ft. wide at top, and 30 ft. tall",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Reflex negates; see text",
        spellResistance: "yes",
        components: "V, S, DF",
        },
        {
        level: "8",
        name: "Sunburst",
        type: ["control", "damage"],
        school: "evocation",
        tags: ["light"],
        longDesc: `Sunburst causes a globe of searing radiance to explode silently from a point you select. All creatures in the globe are blinded and take 6d6 points of damage. A creature to which sunlight is harmful or unnatural takes double damage. A successful Reflex save negates the blindness and reduces the damage by half. An undead creature caught within the globe takes 1d6 points of damage per caster level (maximum 25d6), or half damage if a Reflex save is successful. In addition, the burst results in the destruction of any undead creature specifically harmed by bright light if it fails its save. The ultraviolet light generated by the spell deals damage to fungi, mold, oozes, and slimes just as if they were undead creatures. Sunburst dispels any darkness spells of lower than 9th level within its area.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "80-ft.-radius burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex partial; see text",
        spellResistance: "yes",
        components: "V, S, M, DF,",
        },
        {
        level: "8",
        name: "Clenched Fist",
        type: ["control", "utility"],
        school: "evocation",
        tags: ["force"],
        longDesc: `This spell functions like interposing hand, except that the hand can also push or strike one opponent that you select. The floating hand can move as far as 60 feet and can attack in the same round. Since this hand is directed by you, its ability to notice or attack invisible or concealed creatures is no better than yours. The hand attacks once per round, and its attack bonus equals your caster level + your highest mental + 11 for the hand's Strength score (33), -1 for being Large. The hand deals 1d8+11 + mental points of damage on each attack, and any creature struck must make a Fortitude save (against this spell's save DC) or be stunned for 1 round. Directing the spell to a new target is a move action. The clenched fist can also interpose itself as interposing hand does, or it can bull rush an opponent as forceful hand does. Its CMB for bull rush checks uses your caster level in place of its base attack bonus, with a +11 bonus for its Strength score and a +1 bonus for being Large.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "10-ft. hand",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, F, DF,",
        },
        {
        level: "8",
        name: "Dimensional Lock",
        type: ["control", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `You create a shimmering emerald barrier that completely blocks extradimensional travel. Forms of movement barred include astral projection, blink, dimension door, ethereal jaunt, etherealness, gate, maze, plane shift, shadow walk, teleport, and similar spell-like abilities. Once dimensional lock is in place, extradimensional travel into or out of the area is not possible. A dimensional lock does not interfere with the movement of creatures already in ethereal or astral form when the spell is cast, nor does it block extradimensional perception or attack forms. Also, the spell does not prevent summoned creatures from disappearing at the end of a summoning spell.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "20-ft.-radius emanation centered on a point in space",
        effect: "",
        targets: "",
        duration: "1 day/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Phasic Challenge",
        type: ["control", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `You select one enemy and one willing ally as targets. The enemy gains a new Will saving throw at the beginning of each turn, and on a successful saving throw the spell ends. Both targets remain visible and audible, and can see and hear other creatures, but cannot physically interact with any creature save one another. Spells or weapon attacks from the affected creatures impact only each other, though spells might affect terrain or other factors not related to other creatures. If one of the creatures becomes unconscious or dies, or if the effect is dispelled, the effect ends for both of them.`,
        castingTime: "1 standard action",
        range: "short (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "two creatures within 60 feet of one another; see text",
        duration: "1 round/level (D)",
        savingThrow: "Will negates (see below)",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Prismatic Wall",
        type: ["control", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `Prismatic wall creates a vertical, opaque wall-a shimmering, multicolored plane of light that protects you from all forms of attack. The wall flashes with seven colors, each of which has a distinct power and purpose. The wall is immobile, and you can pass through and remain near the wall without harm. The wall's maximum proportions are 4 feet wide per caster level and 2 feet high per caster level. A prismatic wall spell cast to materialize in a space occupied by a creature is disrupted, and the spell is wasted. Each color in the wall has a special effect. The accompanying table shows the seven colors of the wall, the order in which they appear, their effects on creatures trying to attack you or pass through the wall, and the magic needed to negate each color. The wall can be destroyed, color by color, in consecutive order, by casting specific spells on the wall. A rod of cancellation or a mage's disjunction spell destroys a prismatic wall, but an antimagic field fails to penetrate it. Dispel magic and greater dispel magic can only be used on the wall once all the other colors have been destroyed. Spell resistance is effective against a prismatic wall, but the caster level check must be repeated for each color present. 
        \n1st Red Stops nonmagical ranged weapons. Deals 20 points of fire damage (Reflex half).         
        \n2nd Orange Stops magical ranged weapons. 40 points of acid damage (Reflex half). 
        \n3rd Yellow Stops poisons, gases, and petrification. Deals 80 points of electricity damage (Reflex half ). 
        \n4th Green Stops breath weapons. Poison (frequency: 1/rd. for 6 rd.; init. effect: death, sec. effect: 1 Con/rd.; cure 2 consecutive Fort saves). 
        \n5th Blue Stops divination and mental attacks. Turned to stone (Fortitude negates). \n6th Indigo Stops all spells. Will save or become insane (as insanity spell). 
        \n7th Violet Energy field destroys all objects and effects. Creatures sent to another plane (Will negates). 
        \n\n*The violet effect makes the special effects of the other six colors redundant, but these six effects are included here because certain magic items can create prismatic effects one color at a time, and spell resistance might render some colors ineffective (see above). If you actually need the list of spells that destroy a prismatic wall, check full spell details.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "wall 4 ft./level wide, 2 ft./level high",
        targets: "",
        duration: "10 min./level",
        savingThrow: "see text",
        spellResistance: "see text",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Telekinetic Sphere",
        type: ["control", "utility"],
        school: "evocation",
        tags: ["force"],
        longDesc: `This spell functions like resilient sphere, but the creatures or objects caught inside the globe created by the spell are made nearly weightless. Anything contained within a telekinetic sphere weighs only one-sixteenth of its normal weight. You can telekinetically lift anything in the sphere that normally weighs 5,000 pounds or less. The telekinetic control extends from you out to medium range (100 feet + 10 feet per caster level) after the sphere has succeeded in encapsulating its contents. You can move the sphere, along with the objects and creatures it contains that weigh a total of 5,000 pounds or less, by concentrating on the sphere. You can begin moving a sphere in the round after casting the spell. If you concentrate on doing so (a standard action), you can move the sphere as much as 30 feet in a round. If you cease concentrating, the sphere does not move in that round (if on a level surface) or descends at its falling rate (if aloft) until it reaches a level surface. You can resume concentrating on your next turn or any later turn during the spell's duration. The sphere falls at a rate of only 60 feet per round, which is not fast enough to cause damage to the contents of the sphere. You can move the sphere telekinetically even if you are in it.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "1-ft.-diameter/level sphere, centered around creatures or objects",
        targets: "",
        duration: "1 min./level",
        savingThrow: "Reflex negates (object)",
        spellResistance: "yes (object)",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Black Dragon Bolt",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["acid"],
        longDesc: `You fire a bolt of devastatingly corrosive acid. This bolt requires a ranged touch attack, and if it hits it immediately deals 1d6 acid damage per caster level. Then at the start of each of the creatures turns it takes an additional 1d6 points of acid damage per caster level/2. Once per round the creature can make a fortitude save as a free action to reduce the duration of the spell by 1 round. It can make a fortitude save as a full-round action to reduce the duration by 6 rounds. This spell can also be fired at a creature's weapon or armor, requiring a touch attack as normal, and instead deals damage to the weapon or armor, however the creature can also make a reflex save to avoid the effect. This deals full damage to objects, although reduced by hardness as normal (the creature can save to reduce the duration still). If the spell destroyed the item, the spells remaining duration is transfered to the creature.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "1 bolt of acid",
        targets: "",
        duration: "1 round/level",
        savingThrow: "fort partial, see text",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "8",
        name: "Death Clutch",
        type: ["damage"],
        school: "necromancy",
        tags: ["death", "evil"],
        longDesc: `Chanting an unholy litany, you reach out with a grasping motion toward your target and cause its heart to leap out of its chest and into your hand. A target with 200 or fewer hit points remaining that fails its saving throw is instantly reduced to a number of negative hit points equal to your caster level or its Constitution score - 1, whichever is less negative. The creature is staggered until the beginning of your next turn, at which point it dies. If the affected creature receives a regenerate spell before the beginning of your next turn, the creature gains the normal benefits of that spell and, thanks to its heart's regeneration, it doesn't immediately die when your next turn begins. If a creature that dies from death clutch is brought back from the dead by a breath of life or raise dead spell, it must also be targeted with regenerate on the following round to restore its missing heart or be unable to return to life. A target with 201 or more hit points that fails its saving throw manages to keep its heart from leaping out of its chest, but it is still staggered for 1 minute and takes 1d4 points of Constitution drain and 1d4 points of Constitution bleed. Regardless of its current hit points, if the target succeeds at its Fortitude save, it is still staggered until the beginning of your next turn as it feels its heart wrenching within its chest.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "instantaneous",
        savingThrow: "Fortitude partial (see text)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Devouring Void",
        type: ["damage"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `A Devouring Void consumes all heat from objects and creatures within its area of effect, turning it into more energy for itself. It initially deals 1d6 per caster level (maximum 15d6) cold damage to every creature in the area, Fortitude halves. At the start of every creature's turn within the area (except the turn this spell came into effect), or when a creature enters the area, they take 1d6 per 2 caster levels cold damage(maximum 10d6), Fortitude halves (any creature can only take this damage once per round). The area of this spell is difficult terrain for its duration.
        \nFor each creature that fails its save against this spell (whether against the initial or secondary effect), the radius increases by 5 ft. and for every two creatures that fail their save against this spell, the secondary damage increases by 1d6 (to a maximum of 10d6).  
        \nWhenever a creatures dies within its area, treat the void as if two additional creatures had failed its save, and then it lashes out at all creatures within its area, dealing 1d6+1 cold damage per failed fortitude save (reflex half).`,
        castingTime: "1 standard action",
        range: "short (25 ft. + 5 ft. level/2)",
        area: "10ft. radius spread, see text",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "fortitude half",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "8",
        name: "Electric Loop",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `When you cast this spell you fire it at a target as a ranged touch attack, dealing 1d6 electricity damage per caster level (max 20d6) reflex negates, if the creature fails, the spell clings to them, and all of their melee attacks deal 1d6 electricity damage for 1 round, however, at the start of your next turn the bolt jumps from them to another creature of your choice within 30 feet of it. If you choose no targets to redirect this spell to, you can choose to leave it lingering, however all of the attacks of the creature now deal another additional 1d6 electricity damage, and the duration of the spell is reduced by 1 round. You cannot target the same creature twice in a row with this spell.`,
        castingTime: "1 standard action",
        range: "close (25 ft + 5ft/2 levels)",
        area: "",
        effect: "",
        targets: "1 creature",
        duration: "1 round/2 levels",
        savingThrow: "reflex negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Fire Storm",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `When a fire storm spell is cast, the whole area is shot through with sheets of roaring flame. The raging flames do not harm natural vegetation, ground cover, or any plant creatures in the area that you wish to exclude from damage. Any other creature within the area takes 1d6 points of fire damage per caster level (maximum 20d6). Creatures that fail their Reflex save catch on fire, taking 4d6 points of fire damage each round until the flames are extinguished. Extinguishing the flames is a full-round action that requires a DC 20 Reflex save.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "two 10-ft. cubes per level (S)",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Horrid Wilting",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell evaporates moisture from the body of each subject living creature, causing flesh to wither and crack and crumble to dust. This deals 1d6 points of damage per caster level (maximum 20d6). This spell is especially devastating to water elementals and plant creatures, which instead take 1d8 points of damage per caster level (maximum 20d8).`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "",
        targets: "living creatures, no two of which can be more than 60 ft. apart",
        duration: "instantaneous",
        savingThrow: "Fortitude half",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "8",
        name: "Incendiary Cloud",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["fire"],
        longDesc: `An incendiary cloud spell creates a cloud of roiling smoke shot through with white-hot embers. The smoke obscures all sight as a fog cloud does. In addition, the white-hot embers within the cloud deal 10d6 points of fire damage to everything within the cloud on your turn each round. All targets can make Reflex saves each round to take half damage. As with a cloudkill spell, the smoke moves away from you at 10 feet per round. Figure out the smoke's new spread each round based on its new point of origin, which is 10 feet farther away from where you were when you cast the spell. By concentrating, you can make the cloud move as much as 60 feet each round. Any portion of the cloud that would extend beyond your maximum range dissipates harmlessly, reducing the remainder's spread thereafter. As with fog cloud, wind disperses the smoke, and the spell can't be cast underwater.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "cloud spreads in 20-ft. radius, 20 ft. high",
        effect: "",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Reflex half; see text",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Inflict Critical Wounds, Mass",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell functions like mass inflict light wounds, except that it deals 8d8 points of damage + 2 points per caster level (maximum +50).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "instantaneous",
        savingThrow: "Will half",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Orb of the Void",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `You create a small weightless sphere of pure negative energy. As a move action, you can move it up to 30 feet per round in any direction. If it enters a space with a living creature, it stops moving for the round and that creature gains one negative level (Fortitude negates). Any creature passing through or ending its turn in the space occupied by the sphere gains one negative level (Fortitude negates). Twenty-four hours after gaining a negative level from the sphere, the subject must make a Fortitude saving throw (the DC of this save is equal to the DC of this spell) for each negative level. If the save succeeds, that negative level is removed. If it fails, that negative level becomes permanent. If more than one orb (from different castings of the spell) enters the same space, the orbs automatically fuse together. The resulting orb uses the higher of the two orbs' DCs as its DC and whichever duration has more time left. If the orbs are from different casters, each must make an opposed Intelligence check to move the sphere. An undead creature that passes through or ends its turn in the space occupied by the orb gains 2d4 x 5 temporary hit points for 1 hour.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "1-ft.-diameter sphere",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Polar Ray",
        type: ["damage"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `A blue-white ray of freezing air and ice springs from your hand. You must succeed on a ranged touch attack with the ray to deal damage to a target. The ray deals 1d10 points of cold damage per caster level (maximum 25d10) and 1d4 points of Dexterity drain. Critical hits with this spell have their critical multiplier increased by +1, and its default ranged touch attack critical threat range increases by +1. This is a flat bonus unmodified by other effects. Critical hits with this spell paralyze the target for 1 round, no save. For each critical multiplier you have beyond x3 the duration of the paralysis increases by 1 round.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "ray",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Rain of Arrows",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `You point your finger and conjure a cloud of magical arrows that rain down on any creatures and objects in the indicated area. You must have line of sight to the intended area. The arrows deal 1d6+5 points of piercing damage per 2 caster levels (maximum 10d6+50) to each creature and object in a 15-foot radius centered on the targeted square or intersection. The arrows bypass DR as if they were +5 arrows. On the following round a second volley of arrows is fired in the same location.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "15-ft.-radius cloud of arrows",
        targets: "",
        duration: "1 round.",
        savingThrow: "Reflex halves",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Shout, Greater",
        type: ["damage"],
        school: "evocation",
        tags: ["sonic"],
        longDesc: `This spell functions like shout, except that the cone deals 10d6 points of sonic damage (or 1d6 points of sonic damage per caster level, maximum 20d6, against exposed brittle or crystalline objects or crystalline creatures). It also causes creatures to be stunned for 1 round and deafened for 4d6 rounds. A creature in the area of the cone can negate the stunning and halve both the damage and the duration of the deafness with a successful Fortitude save. A creature holding vulnerable objects can attempt a Reflex save to negate the damage to those objects.`,
        castingTime: "1 standard action",
        range: "60 ft.",
        area: "cone-shaped burst",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Fortitude partial or Reflex negates (object); see text",
        spellResistance: "yes (object)",
        components: "V, S, F,",
        },
        {
        level: "8",
        name: "Stormbolts",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `When you cast this spell, lightning spills forth from your body in all directions. The bolts do not harm natural vegetation or creatures in the area you wish to exclude from damage. Any other creatures within the area take 1d8 points of electricity damage per caster level (maximum 20d8) and are stunned for 1 round. A successful saving throw halves the damage and negates the stun effect.`,
        castingTime: "1 standard action",
        range: "30 ft.",
        area: "a 30-ft.-radius spread, centered on you",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "8",
        name: "Vitriolic Cloud",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["acid"],
        longDesc: `You create a slow moving cloud that rolls across the surface of the ground, the cloud is 5 feet tall, and does obscure vision as the fog cloud spell. The cloud is 15 feet wide, extending 5 feet from each side of you, and 5 feet thick, it starts in the square directly in front of you, and each turn at the start of your turn it moves 15 feet away from where you cast the spell from, up to its maximum range. It can also be blown away the same way the fog cloud spell can be. Any creature that comes in contact with the spell takes 1d6 points of acid damage per caster level, no save. Every 30 feet the cloud moves, it extends 5 feet on each side. If you create this spell in the air it slowly falls towards the ground before moving away, and it moves of the surface of water as easily as the ground, and move around or over barriers. If you create this spell so that a creature would be inside of it, the creature gets a reflex save to move 5 feet out of it. This movement does not provoke.`,
        castingTime: "1 standard action",
        range: "medium (100ft. + 10ft./level",
        area: "15 ft. by 5ft. cloud",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
        level: "8",
        name: "Wall of Lava",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["earth", "fire"],
        longDesc: `This spell creates a vertical wall of lava that is 1 inch thick for every 4 caster levels and composed of up to one 5-foot square per level. A wall of lava's maximum height cannot exceed half of its width (with a minimum height of 5 feet). The wall cannot be conjured so that it occupies the same space as a creature or object. A section of a wall of lava can be destroyed by damage (hardness 4, hp 90), but if a section is destroyed, the remaining lava in the wall immediately fills in any such hole created, reducing the wall's overall size by one 5-foot square but remaining a contiguous barrier. Each time a weapon strikes a wall of lava, it takes 2d6 points of fire damage (or the creature who strikes the wall takes 2d6 fire damage if the attack was via an unarmed strike or natural attack). A creature can move through a wall of lava as a full-round action by making a DC 25 Strength check-failure indicates that the creature is pushed back out of the wall to the point he just attempted to leave. A creature with a burrow speed can move through the wall using its burrow speed. An attempt to move through a wall of lava inflicts 20d6 fire damage. A wall of lava also radiates heat as if it were a wall of fire, although the heat from a wall of lava radiates from both sides. Once per round as a move action, you can direct the wall of lava to erupt. This causes a plume of lava to fire at any target within 60 feet of either side of the wall, but reduces the wall's overall size by 1d4 5-foot square sections. You must make a ranged touch attack to hit the target, which takes 10d6 points of fire damage on a hit. Holes created in a wall of lava from this effect instantly reseal, reducing the overall size of the wall. All damage inflicted by physical contact with a wall of lava continues for 1d3 rounds after exposure ceases, but this additional damage is only half that dealt during actual contact (that is, 1d6 or 5d6 or 10d6 points per round).`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "lava wall whose area is up to one 5-ft. square/level (S)",
        duration: "1 round/level (D)",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, M,DF,",
        },
        {
        level: "7",
        name: "Cure Critical Wounds, Mass",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell functions like mass cure light wounds, except that it cures 8d8 points of damage + 2 points per caster level (maximum +50).`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "instantaneous",
        savingThrow: "Will half (harmless) or Will half; see text",
        spellResistance: "yes (harmless) or yes; see text",
        components: "V, S, ",
        },
        {
            level: "8",
            name: "Cure Devastating Wounds, Mass",
            type: ["healing"],
            school: "conjuration(healing)",
            tags: [],
            longDesc: `This spell functions like mass cure light wounds, except that it cures 10d10 points of damage + 2 points per caster level (maximum +50).`,
            castingTime: "1 standard action",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "one creature/level, no two of which can be more than 30 ft. apart",
            duration: "instantaneous",
            savingThrow: "Will half (harmless) or Will half; see text",
            spellResistance: "yes (harmless) or yes; see text",
            components: "V, S, ",
            },
        {
        level: "8",
        name: "Stitch",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell swiftly channels positive into your touch to heal a living ally, restoring 8d8 points of damage + 2 points per caster level (maximum +30). Additionally this cures fatigue, sickened, dazzled, reduces exhausted to fatigued, and restores 1d4 points of ability damage to an ability score of choice.`,
        castingTime: "1 swift action",
        range: "touch",
        area: "",
        effect: "",
        targets: "ally touched",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S",
        },
        {
        level: "8",
        name: "Create Greater Undead",
        type: ["utility"],
        school: "necromancy",
        tags: ["evil"],
        longDesc: `This spell functions like create undead, except that you can create more powerful and intelligent sorts of undead: shadows, wraiths, spectres, and devourers. The type or types of undead created is based on caster level, as shown: 15th or lower Shadow 16th-17th Wraith 18th-19th Spectre 20th or higher Devourer. These undead are permanent and last through floors, they only attack enemies but are otherwise not under your control unless you would have a way to control them.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one corpse",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Polymorph Any Object",
        type: ["utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions like greater polymorph, except that it changes one object or creature into another. You can use this spell to transform all manner of objects and creatures into new forms-you aren't limited to transforming a living creature into another living form. The duration of the spell depends on how radical a change is made from the original state to its transmuted state. The duration is determined by using the following guidelines. 
        \nSame kingdom (animal, vegetable, mineral): +5         \nSame class (mammals, fungi, metals, etc.): +2         \nSame size: +2         \nRelated (twig is to tree, wolf fur is to wolf, etc.): +2         \nSame or lower Intelligence: +2 
        \nAdd all that apply, then check the duration based on the duration factor:
        \nDuration Factor: \n0: 20 minutes Pebble to human         \n2: 1 hour Marionette to human         \n4: 3 hours Human to marionette         \n5: 12 hours Lizard to manticore         \n6: 2 days Sheep to wool coat         \n7: 1 week Shrew to manticore         \n9+: Permanent Manticore to shrew 
        \n\nIf the target of the spell does not have physical ability scores (Strength, Dexterity, or Constitution), this spell grants a base score of 10 to each missing ability score. If the target of the spell does not have mental ability scores (Intelligence, Wisdom, or Charisma), this spell grants a score of 5 to such scores. Damage taken by the new form can result in the injury or death of the polymorphed creature. In general, damage occurs when the new form is changed through physical force. A nonmagical object cannot be made into a magic item with this spell. Magic items aren't affected by this spell. It also cannot reproduce the special properties of cold iron in order to overcome the damage reduction of certain creatures. This spell can also be used to duplicate the effects of baleful polymorph, greater polymorph, flesh to stone, stone to flesh, transmute mud to rock, transmute metal to wood, or transmute rock to mud.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature, or one nonmagical object of up to 100 cu. ft./level",
        duration: "see text",
        savingThrow: "Fortitude negates (object); see text",
        spellResistance: "yes (object)",
        components: "V, S, M,DF,",
        },
        {
        level: "8",
        name: "Rift of Ruin",
        type: ["utility"],
        school: "conjuration(calling)",
        tags: ["chaotic", "evil"],
        longDesc: `This spell tears a rift in reality, creating an extradimensional hole with a depth of 60 feet. You must create the rift on a horizontal surface of sufficient size. Since the rift extends into the Abyss, it does not displace the original underlying material or allow access to areas below the surface-you can create the rift on the deck of a ship as easily as in a dungeon floor or the ground of a forest. Any Large or smaller creature standing in the area where you conjure the rift must succeed at a Reflex save to avoid falling into the hole. If successful, the creature picks which side of the rift it remains on once the rift opens. Unattended objects and structures that can be fully engulfed by the rift automatically fall into it. The walls of the rift are covered with razor-sharp blades, while the floor seethes with boiling pools of acid, strange chewing vermin, writhing shards of ice, and all manner of other chaotic and deadly manifestations of the Abyss. A creature that falls into the rift takes 6d6 points of falling damage. Any creature in the rift (starting on the round it enters) takes an additional 6d6 points of damage from the rift's environs, even if the creature is merely climbing or flying within the rift rather than standing at the bottom. This additional damage changes from round to round and is randomly selected from acid, bludgeoning, cold, electricity, fire, piercing, slashing, or sonic. Each round, a creature in the rift can attempt a Reflex save to take half damage that round. The rift's walls have a Climb DC of 25. When this spell's duration ends, the rift snaps shut, violently expelling all creatures still within. These creatures take double damage from the rift's environs in that round and are knocked prone as they are returned to the surface above. At any time during the spell's duration, you can use it to conjure a number of Abyssal denizens into the surrounding region as a standard action. Doing so causes the rift to snap shut, ending the spell's duration and returning any creatures that had fallen into it to the ground as detailed above. As the rift snaps shut, choose one of the following creatures or groups of creatures to appear in the area; these Abyssal denizens are treated as if you had summoned them via summon monster VII and remain for a number of rounds equal to the remaining duration of the rift of ruin spell. You can choose to summon one of the following: one bebilith, one vrock, 1d3 shadow demons, 1d3 succubi, 1d4+1 babaus, or 1d4+1 brimoraksB6.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "5-ft.-wide, 60-ft.-deep extradimensional hole, up to 5 ft. long per level (S)",
        targets: "",
        duration: "1 round/level (see text)",
        savingThrow: "Reflex partial",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "8",
        name: "Summon Monster VIII",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell summons an extraplanar creature (typically an outsider, elemental, or magical beast native to another plane). It appears where you designate and acts immediately, on your turn. It attacks your opponents to the best of its ability. If you can communicate with the creature, you can direct it not to attack, to attack particular enemies, or to perform other actions. The spell conjures one of the creatures from the level on Table from: https://www.d20pfsrd.com/magic/all-spells/s/summon-monster/ of the level equal to the level of this spell. Alternatively you can choose to summon 1d3 creatures from the list 1 level below, or 1d4+1 creatures from a list at least 2 levels lower. You choose which kind of creature to summon (one type of creature at a time if you are summoning multiple) but can only summon creatures from the core list (not alternative options), and you can choose a different one each time you cast the spell. A summoned monster cannot summon or otherwise conjure another creature, nor can it use any teleportation or planar travel abilities. Creatures cannot be summoned into an environment that cannot support them. Creatures summoned using this spell cannot use spells or spell-like abilities that duplicate spells with expensive material components (such as wish). When you use a summoning spell to summon a creature with an alignment or elemental subtype, it is a spell of that type. Creatures marked with an "*" are summoned with the celestial template, if you are good, and the fiendish template, if you are evil. If you are neutral, you may choose which template to apply to the creature. Creatures marked with an "*" always have an alignment that matches yours, regardless of their usual alignment. Summoning these creatures makes the summoning spell's type match your alignment.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one or more summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, F,DF,",
        },
        {
        level: "8",
        name: "Summon Nature's Ally VIII",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions like summon nature's ally I, except that you can summon one 8th-level creature, 1d3 7th-level creatures of the same kind, or 1d4+1 lower-level creatures of the same kind.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, DF",
        },
        {
            level: "9",
            name: "Summon Nature's Ally IX",
            type: ["utility"],
            school: "conjuration(summoning)",
            tags: [],
            longDesc: `This spell functions like summon nature's ally I, except that you can summon one 9th-level creature, 1d3 8th-level creatures of the same kind, or 1d4+1 lower-level creatures of the same kind.`,
            castingTime: "1 round",
            range: "close (25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "one summoned creature",
            targets: "",
            duration: "1 round/level",
            savingThrow: "none",
            spellResistance: "no",
            components: "V, S, DF",
        },
        {
        level: "8",
        name: "Symbol of Dispelling",
        type: ["utility"],
        school: "abjuration",
        tags: [],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to attempt to dispel magic as the area dispel effect of dispel magic. It can continue being triggered until it has attempted to dispel spells equal to your caster level, or up to 5 times. When it activates it activates in a burst, affecting the closest creatures first. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 18 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 20 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Word of Recall",
        type: ["utility"],
        school: "conjuration(teleportation)",
        tags: [],
        longDesc: `Word of recall teleports you instantly back to the either starting point of the map, or any other location you have been on the map and spent a swift action marking. You can transport, in addition to yourself, any objects you carry, as long as their weight doesn't exceed your maximum load. You may also bring one additional willing Medium or smaller creature (carrying gear or objects up to its maximum load) or its equivalent per three caster levels. A Large creature counts as two Medium creatures, a Huge creature counts as two Large creatures, and so forth. All creatures to be transported must be in contact with one another, and at least one of those creatures must be in contact with you. Exceeding this limit causes the spell to fail. An unwilling creature can't be teleported by word of recall. Likewise, a creature's Will save (or spell resistance) prevents items in its possession from being teleported. Unattended, nonmagical objects receive no saving throw.`,
        castingTime: "1 movement action",
        range: "unlimited",
        area: "",
        effect: "",
        targets: "you and touched objects or other willing creatures",
        duration: "instantaneous",
        savingThrow: "none or Will negates (harmless, object)",
        spellResistance: "no or yes (harmless, object)",
        components: "V, ",
        },
        {
        level: "8",
        name: "Symbol of Death",
        type: ["utility", "damage"],
        school: "necromancy",
        tags: ["death"],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to attempt to kill creatures within 15 feet of the rune. It can continue being triggered until it has dealt damage equal to 1d12 per caster level damage (this scales with negative spell power), or up to 5 times. When it activates it activates in a burst, affecting the closest creatures first, skipping creatures with too many hit points to affect. A creature may make a fortitude save to negate the effect. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 18 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 15 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "8",
        name: "Clone",
        type: ["utility", "healing"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell makes an inert duplicate of yourself. If the original individual has been slain, its soul immediately transfers to the clone, creating a replacement (provided that the soul is free and willing to return). The original's physical remains, should they still exist, become inert and cannot thereafter be restored to life. If the original creature has reached the end of its natural life span (that is, it has died of natural causes), any cloning attempt fails. Once the spell is cast, the duplicate appears in an adjacent square after 1d4 rounds, and can be harmed as normal (though it isn't alive and only counts as an object), but will also teleport through floors with the party. When the clone is completed, the original's soul enters it immediately if that creature is already dead. Treat the clone as if it were the original character raised from the dead, including its gaining of two permanent negative levels, although it is at the same hit points and spell points as when the spell was cast, and has all the ailments and bonuses it had when cast (though durations of those effects act as normal, and only affect it if they would affect an object). If the subject is 1st level, it takes 2 points of Constitution drain instead (if this would reduce its Con to 0 or less, it can't be cloned). If the original creature gained permanent negative levels since the spell was cast, the clone gains these negative levels as well. 
                 \nThe spell duplicates only the original's body and mind, not its equipment. A duplicate can be grown while the original still lives, but only a single clone of any creature can exist at a time, if you create a new one, the other disintegrates.`,
        castingTime: "1 full round action",
        range: "0 ft.",
        area: "",
        effect: "one clone",
        targets: "you",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,F",
        },
        {
        level: "9",
        name: "Defending Sword, Mass",
        type: ["buff"],
        school: "evocation",
        tags: ["force"],
        longDesc: `You create a one sword per 5 caster levels, each of which must defend a different creature within range of force that functions as mage's sword except as described here. The sword does not receive the additional +3 enhancement bonus a mage's sword receives, and deals 3d6 points of force damage. You cannot command the sword. Until the sword is triggered, it hovers in your space without interfering with your actions. While hovering in this way, the sword attempts to defend you from incoming attacks, granting you a +4 shield bonus to your AC. The first time a foe within close range damages you or forces you to attempt a saving throw that you fail, the sword is triggered and begins attacking that target as described in mage's sword for the duration of the spell. This ends the shield bonus. You cannot direct the sword to defend against a new target once it has begun to attack. If its target moves beyond the sword's range, the sword returns to you and hovers until the target is again within range. The sword's return does not restore the spell's shield bonus to AC.`,
        castingTime: "1 standard action",
        range: "",
        area: "",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, F",
        },
        {
        level: "9",
        name: "Earth Body",
        type: ["buff"],
        school: "transmutation",
        tags: ["earth", "acid"],
        longDesc: `This spell transforms your body into living acid and rock. You and your equipment are immune to acid damage. In fact, every time you would normally take damage from acid, you are instead healed of damage at a rate of 1 point per 3 points of damage the acid attack would have normally inflicted. You are immune to blindness, critical hits, ability score damage, deafness, disease, drowning, poison, stunning, and all spells that affect your physiology or respiration. You take only half damage from fire and cold. You take 150% as much damage from electricity than normal. You gain a +4 enhancement bonus to your constitution and a +2 to your strength score and you can earth glide with a speed of 30 ft. Your unarmed attack deals an additional 3d6 points of acid damage, and you are considered armed when making unarmed attacks. You also gain a +4 natural armor bonus and DR 5/-. If you end your turn not in contact with the earth you take 5d6 damage and reduce your damage reduction and natural armor gained from this spell by 1 until you return to the ground for 1 round. Acid spells you cast have their save DCs increased by +1, you gain 15 acid spell power, but electricity spells have their DC reduced by -2 and their spell power by 50. You cant swim because you sink like a rock.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V",
        },
        {
        level: "9",
        name: "Fiery Body",
        type: ["buff"],
        school: "transmutation",
        tags: ["fire"],
        longDesc: `This spell transforms your body into living flame. You and your equipment are immune to fire damage. In fact, every time you would normally take damage from fire, you are instead healed of damage at a rate of 1 point per 3 points of damage the fire attack would have normally inflicted. You are immune to blindness, critical hits, ability score damage, deafness, disease, drowning, poison, stunning, and all spells that affect your physiology or respiration. You take only half damage from acid and electricity. You take 150% as much damage from cold than normal. You gain a +6 enhancement bonus to your Dexterity score and a fly speed of 40 ft. (perfect maneuverability). Your unarmed attack deals an additional 3d6 points of fire damage, and you are considered armed when making unarmed attacks. Your body burns so brightly that creatures who do not avert their gaze from you are dazzled. Fire spells you cast have their save DCs increased by +1 and gain 15 fire spell power, but cold spells have their save DCs reduced by -2 and lose 50 spell power. If you enter water, you are surrounded by a 5-foot radius of steam and bubbles that grant you concealment (50% miss chance) but you take 2d6 points of damage each round you remain in water.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V",
        },
        {
        level: "9",
        name: "Foresight",
        type: ["buff"],
        school: "divination",
        tags: [],
        longDesc: `This spell grants you a powerful sixth sense in relation to yourself or another. Once foresight is cast, you receive instantaneous warnings of impending danger or harm to the subject of the spell, and you instantly know the DC of any ability used on the subject. You are never surprised or flat-footed. In addition, the spell gives you a general idea of what action you might take to best protect yourself, and gives you an insight bonus to AC and on Reflex saves equal to half your highest mental mod. This insight bonus is lost whenever you would lose a Dexterity bonus to AC. When another creature is the subject of the spell, you receive warnings about that creature. You must communicate what you learn to the other creature for the warning to be useful, and the creature can be caught unprepared in the absence of such a warning. Shouting a warning, yanking a person back, and even telepathically communicating (via an appropriate spell) can all be accomplished before some danger befalls the subject, provided you act on the warning without delay. You can spend a movement action on your turn to give the insight to the creature to grant it an insight bonus to its armor class and reflex saves equal to half your highest mental modifier, however if it loses its dexterity to armor class it loses these bonuses as well.`,
        castingTime: "1 standard action",
        range: "personal or touch",
        area: "",
        effect: "",
        targets: "see text",
        duration: "10 min./level",
        savingThrow: "none or Will negates (harmless)",
        spellResistance: "no or yes (harmless)",
        components: "V, S, M, DF,",
        },
        {
        level: "9",
        name: "Heroic Invocation",
        type: ["buff"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `Using worlds of ancient power, you bestow heroic powers on all creatures subject to this spell. They gain a +5 morale bonus on attack, damage, and all saves, gain 1d4 per caster level temporary hit points, and become immune to both fear and charm effects for the spell's duration. At the end of the spell's duration, the subjects become fatigued.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one or more creatures, no two of which can be more than 30 ft. apart",
        duration: "1 round/2 levels",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Icy Body",
        type: ["buff"],
        school: "transmutation",
        tags: ["cold"],
        longDesc: `This spell transforms your body into living Ice. You and your equipment are immune to cold damage. In fact, every time you would normally take damage from cold, you are instead healed of damage at a rate of 1 point per 3 points of damage the cold attack would have normally inflicted. You are immune to blindness, critical hits, ability score damage, deafness, disease, drowning, poison, stunning, and all spells that affect your physiology or respiration. You take only half damage from electricity and acid. You take 150% as much damage from fire than normal. You gain a +4 enhancement bonus to your Dexterity score, a +2 enhancement bonus to constitution and a swim speed of 80 ft. and water doesn't have any negative effects on your ability to move or cast spells (except fire spells). You can also move across the surface of water or with this speed, and move through ice as if it were liquid. Your unarmed attack deals an additional 3d6 points of cold damage, and you are considered armed when making unarmed attacks. Creatures that end their turn adjacent to you take 2d6 + caster level cold damage, and if either dice is a natural 6 (and they took cold damage) they must also make a fortitude save or be staggered for 1 round. Cold spells you cast have their save DCs increased by +1 and gain 15 cold spell power, but fire spells DC's are reduced by -2 and lose 50 spell power. If you enter water, you are surrounded by a 5-foot radius of ice that grants you improved cover (+8 AC), and 20% concealment.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V",
        },
        {
        level: "9",
        name: "Impenetrable Veil",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `You enchant the target so it is nearly impossible to detect by both magical and mundane means, granting it the following benefits. The target gains a bonus on Stealth checks equal to half your caster level, and can use Stealth to hide from all creatures attempting to perceive it, even when it lacks concealment or cover. It can attempt a Stealth check to avoid detection from creatures using blindsight, blindsense, or any ability that functions as either (such as lifesense or tremorsense). Furthermore, the target leaves no trail and cannot be tracked unless it chooses to leave a trail. If a creature attempts to discern the target's presence or location using divination magic (including magic items with a divination aura such as a crystal ball), that creature must succeed at a caster level check with a DC equal to the target's Stealth bonus to discern any information about the target, and on a failed check cannot do so for the spell's duration.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "10 minutes/level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, M,",
        },
        {
        level: "9",
        name: "Lightning Body",
        type: ["buff"],
        school: "transmutation",
        tags: ["electricity"],
        longDesc: `This spell transforms your body into living electricity. You and your equipment are immune to electricity damage. In fact, every time you would normally take damage from electricity, you are instead healed of damage at a rate of 1 point per 3 points of damage the electricity attack would have normally inflicted. You are immune to blindness, critical hits, ability score damage, deafness, disease, drowning, poison, stunning, and all spells that affect your physiology or respiration. You take only half damage from fire and cold. You take 150% as much damage from acid than normal. You gain a +10 enhancement bonus to your Dexterity, but a -2 reduction to constitution, and a fly speed of 80ft. (perfect maneuverability). Any time you end your turn within 10ft of the ground, a wall, or a ceiling you take 5d6 damage. Your unarmed attack deals an additional 3d6 points of electricity damage, and you are considered armed when making unarmed attacks. You gain a +3 bonus on melee attacks or ranged electricity attacks against creatures with metal armor, weapons, or are that are primarily made of metal, but creatures primarily made of metal or wielding metal weapons also gain that bonus against you. Electricity spells you cast have their save DCs increased by +1 and gain 15 electricity spell power, but acid/earth spells have their save DCs reduced by -2 and lose 50 spell power. If you enter water, you are staggered and all creatures within 30ft of you also in contact with that water take 1d6 electricity damage per caster level at the start of each of your turns (fortitude halves).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V",
        },
        {
        level: "9",
        name: "Spell Immunity, Greater Communal",
        type: ["buff"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions like greater spell immunity, except you divide the duration among the creatures in 10-minute intervals among the creatures touched.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creatures touched",
        duration: "10 min./level",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, DF,",
        },
        {
        level: "9",
        name: "Weapon of Legend",
        type: ["buff"],
        school: "transmutation",
        tags: ["imbument"],
        longDesc: `[imbument] The touched weapon becomes becomes a weapon of legendary power, it gains an enhancement bonus equal to your highest mental modifier, and additionally when making an attack, you can reduce the duration of this spell by 1 round to make the attack benefit from the true strike spell for that attack. A weapon can have only a single imbument at a time.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "1 weapon",
        duration: "1 round/3 levels",
        savingThrow: "will negates (harmless, object)",
        spellResistance: "yes (harmless, object)",
        components: "V, S, M,",
        additionalInfoTags:["Imbument"],
        },
        {
        level: "9",
        name: "Winds of Vengeance",
        type: ["buff"],
        school: "evocation",
        tags: ["air"],
        longDesc: `You surround yourself with a buffeting shroud of supernatural, tornado-force winds. These winds grant you a fly speed of 60 feet with perfect maneuverability. Neither your armor nor your load affects this fly speed. The winds shield you from any other wind effects, and form a shell of breathable air around you, allowing you to fly and breathe underwater or in outer space. Ranged weapons (including giant-thrown boulders, siege weapon projectiles, and other massive ranged weapons) passing through the winds are deflected by the winds and automatically miss you. Gases and most gaseous breath weapons cannot pass though the winds. In addition, when a creature hits you with a melee attack, you can shape your winds so they lash out at that creature as an immediate action. The creature must make a Fortitude saving throw or take 5d8 points of bludgeoning damage and be knocked prone (if on the ground, scales with electricity spell power). On a failed save, Huge flying creatures are checked and Large-sized or smaller flying creatures are blown away instead of knocked prone. On a successful save, the damage is halved and the creature is not knocked prone (or checked or blown away).`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, DF,",
        },
        {
        level: "9",
        name: "Etherealness",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell functions like ethereal jaunt, except that you and other willing creatures joined by linked hands (along with their equipment) become ethereal. Besides yourself, you can bring one creature per three caster levels to the Ethereal Plane. Once ethereal, the subjects need not stay together. When the spell expires, all affected creatures on the Ethereal Plane return to material existence.`,
        castingTime: "1 standard action",
        range: "touch; see text",
        area: "",
        effect: "",
        targets: "you and one other touched creature per three levels",
        duration: "1 min./level",
        savingThrow: "",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Fey Form IV",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell functions as fey form III except it doesn't limit your base speed and also allows you to use more abilities. If the form you assume has any of the following abilities, you gain those abilities: burrow speed 60 feet, climb speed 90 feet, fly speed 120 feet (good maneuverability), swim speed 120 feet, all-around vision, blindsense 60 feet, blindsight 30 feet, darkvision 90 feet, low-light vision, scent, see in darkness, tremorsense 60 feet, abduct, animated hair, beguiling aura, bleed, blood rage, boot stomp, burn, compression, constrict, crushing leap, DR 5/cold iron, fast healing 5, fear aura, frightful presence, grab, heavy weapons, hide in plain sight, icewalking, kneecapper, luminous, nasal spray, no shadow, oversized weapons, poison, putrid vomit, rend, rock throwing (120 feet, 2d10 damage), sound mimicry, supernatural speed, tear shadow, trackless step, trample, transparency, tree meld, undersized weapons, vault, and woodland stride. If the creature has immunity or resistance to any energy types, you gain resistance 30 to those energy types. If the creature has immunity to mindaffecting effects or poison, you gain a +8 resistance bonus on saves against those effects. If the creature has spell resistance, you gain spell resistance 6 + your caster level. If the creature has any weaknesses, you gain those weaknesses.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 minute/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, M,",
        },
        {
        level: "9",
        name: "Shapechange",
        type: ["buff", "utility"],
        school: "transmutation(polymorph)",
        tags: [],
        longDesc: `This spell allows you to take the form of a wide variety of creatures. This spell can function as alter self, beast form IV, elemental body IV, form of the dragon III, giant form II, and plant shape III depending on what form you take. You can change form once each round as a free action. The change takes place either immediately before your regular action or immediately after it, but not during the action.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "10 min./level",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, F,",
        },
        {
        level: "9",
        name: "Time Stop",
        type: ["buff", "utility"],
        school: "transmutation",
        tags: [],
        longDesc: `This spell seems to make time cease to flow for everyone but you. In fact, you speed up so greatly that all other creatures seem frozen, though they are actually still moving at their normal speeds. You are free to act for 1d4+1 rounds of apparent time. Normal and magical fire, cold, gas, and the like can still harm you. While the time stop is in effect, other creatures are invulnerable to your attacks and spells; you cannot target such creatures with any attack or spell. A spell that affects an area and has a duration longer than the remaining duration of the time stop have their normal effects on other creatures once the time stop ends. You cannot move or harm items held, carried, or worn by a creature stuck in normal time, but you can affect any item that is not in another creature's possession. You are undetectable while time stop lasts. You cannot enter an area protected by an antimagic field while under the effect of time stop. Once time stop ends, you cannot recast time stop for rounds equal to as many rounds as you spent in time stop.`,
        castingTime: "1 standard action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1d4+1 rounds (apparent time); see text",
        savingThrow: "",
        spellResistance: "",
        components: "V, ",
        },
        {
        level: "9",
        name: "Crushing Hand",
        type: ["buff", "utility", "control"],
        school: "evocation",
        tags: ["force"],
        longDesc: `This spell functions as interposing hand, except that it can also grapple one opponent as grasping hand. Its CMB and CMD for grapple checks use your caster level in place of its base attack bonus, with a +12 bonus for its Strength score (35) and a +1 bonus for being Large (its Dexterity is 10, granting no bonus to the CMD) plus an insight bonus equal to half your highest mental mod. A crushing hand deals 2d6+12 + highest mental mod points of damage on each successful grapple check against an opponent. The crushing hand can instead be directed to bull rush a target (as forceful hand), using the same bonuses outlined above, or it can be directed to interpose itself, as interposing hand does.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "10-ft. hand",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, F,",
        },
        {
        level: "9",
        name: "Dominate Monster",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell functions like dominate person, except that the spell is not restricted by creature type.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "1 day/level",
        savingThrow: "Will negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Hold Monster, Mass",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `This spell functions like hold person, except that it affects multiple creatures and holds any living creature that fails its Will save.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one or more creatures, no two of which can be more than 30 ft. apart",
        duration: "1 round/level ; see text",
        savingThrow: "Will negates; see text",
        spellResistance: "yes",
        components: "V, S, M,DF,",
        },
        {
        level: "9",
        name: "Icy Prison, Mass",
        type: ["control"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `You trap the targets in solid ice 1 inch thick per caster level. If the creature fails its save, it is helpless, but can still breathe (the ice blocks line of effect to the target). If the target makes its save, it gains the entangled condition but can otherwise act normally. Whether or not the target saves, it takes 1 point of cold damage per caster level each round it is helpless or entangled in the ice. The ice has hardness 0 and 3 hit points per inch of thickness; if broken, the creature is freed. A creature can break the ice as a full-round action with a successful Strength check (DC 15 + your caster level).`,
        castingTime: "1 standard action",
        range: "medium (10 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart.",
        duration: "1 minute/level; see text",
        savingThrow: "Reflex partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Imprisonment",
        type: ["control"],
        school: "abjuration",
        tags: [],
        longDesc: `When you cast imprisonment and touch a creature, it is entombed in a state of suspended animation (see the temporal stasis spell) in a small sphere far beneath the surface of the ground. The subject remains there unless a freedom spell is cast at the locale where the imprisonment took place. Because this is an instantaneous effect, it is not allowed to resave against it.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "",
        effect: "",
        targets: "creature touched",
        duration: "instantaneous",
        savingThrow: "Will negates; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Mage's Excellent Enclosure",
        type: ["control"],
        school: "abjuration",
        tags: ["force"],
        longDesc: `You call into being around you an invisible barrier of force within which magic cannot persist.
        \nWithin the area of the spell, effects are suppressed and creatures are affected as by antimagic field. An immobile sphere of impenetrable force surrounds the field, equivalent in all ways to a spherical wall of force, including its immunity to dispel magic and vulnerability to a sphere of annihilation or rod of cancellation. The barrier has hardness 40 and 20 hit points per caster level, and can be damaged by both mundane attacks and spells cast from outside the field. If the bubble of force is destroyed, the spell's duration ends.
        \nSpells cannot be cast within, into, or out of the enclosure, and teleportation effects that ignore a wall of force (such as dimension door or teleport) are thwarted by the enclosure's field of antimagic.
        \nMage's magnificent enclosure has the same effect on summoned creatures of any type and incorporeal undead that an antimagic field does, causing them to wink out of existence for the duration of Mage's magnificent enclosure unless their spell resistance, if any, allows them to remain where they are within the field.`,
        castingTime: "1 standard action",
        range: "touch",
        area: "immobile 10-ft.-radius emanation",
        effect: "",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "see text",
        components: "V, S, M",
        },
        {
        level: "9",
        name: "Maze of Madness and Suffering",
        type: ["control"],
        school: "conjuration(teleportation)",
        tags: ["evil", "mind-affecting"],
        longDesc: `This spell works like maze, except the DC of the Intelligence check to escape is 22 and each round a creature remains in the maze a different effect occurs depending on which section of the maze it is in. Roll on the following table each time the creature attempts an Intelligence check to escape the maze to see which part of the maze it wanders through; if a creature doesn't attempt an Intelligence check, it stays in the same section and suffers that section's effects. Any conditions or damage taken persist for the listed duration even if the creature exits the maze before then, but conditions don't stack with themselves. d% Maze Section 1-20 Circus 21-40 Haunted forest 41-60 Hellscape 61-80 Oasis of respite 81-100 
        \nStrange city Circus: The creature must succeed at a Will save or take 2d4 points of charisma damage. The save uses the madness's normal DC. 
        \nHaunted Forest: The creature takes 3d6 points of slashing and piercing damage and must succeed at a Will save or become frightened for 2d4 rounds. This is a fear effect. A frightened creature can still attempt Intelligence checks to escape the maze, but it takes 3d6 points of slashing and piercing damage each time 
        \nHellscape: The creature must succeed at a Will save or become paralyzed by fear and potential torment for 1 round. This is a fear effect. The creature can't attempt to escape the maze while paralyzed, and if it fails three consecutive saving throws against this paralysis, the hellscape delivers a coup de grace, dealing the creature 4d6 points of fire damage. The creature must succeed at a Fortitude save (DC = 10 + the damage dealt) or die. A creature that survives the coup de grace escapes from the paralysis as well. 
        \nOasis of Respite: The creature must succeed at a Will save or become fascinated for 1 round. The creature can't attempt to escape the maze while fascinated. A creature that fails three consecutive saving throws to this fascination enters a state of lethargy and gives up ever escaping the maze, remaining in this area until the spell ends on its own in 10 minutes (as per maze). 
        \nStrange City: The creature must succeed at a Will save or take 2d4 points of Wisdom damage.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "see text, max 10 minutes",
        savingThrow: "Will partial, see below",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "9",
        name: "Overwhelming Presence",
        type: ["control"],
        school: "enchantment(compulsion)",
        tags: ["emotion", "mind-affecting"],
        longDesc: `Your presence inspires incredible awe in those nearby. A creature that fails a save against this spell falls to the ground and prostrates itself before you, believing it bows before a divine presence. A flying creature incapable of hovering must land immediately in order to prostrate itself. These creatures are considered to be helpless for the duration of the spell. Each round on its turn, a target of this spell may attempt a new saving throw to end the effect; this is a full-round action that does not provoke attacks of opportunity. A creature that recovers from this spell early after being affected by it for at least 1 round takes 1d6 points of Wisdom drain and is staggered for 1d4 rounds. A creature that makes the initial save to resist this spell is merely staggered for 1 round.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "one creature/level, no two of which can be more than 30 ft. apart",
        duration: "1 round/level",
        savingThrow: "Will negates, see text",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "9",
        name: "Prismatic Sphere",
        type: ["control"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell functions like prismatic wall, except you conjure up an immobile, opaque globe of shimmering, multicolored light that surrounds you and protects you from all forms of attack. The sphere flashes in all colors of the visible spectrum. The sphere's blindness effect on creatures with less than 8 HD lasts 2d4 x 10 minutes. You can pass into and out of the prismatic sphere and remain near it without harm. When you're inside it, however, the sphere blocks any attempt to project something through the sphere (including spells). Other creatures that attempt to attack you or pass through suffer the effects of each color, one at a time. Typically, only the upper hemisphere of the globe exists, since you are at the center of the sphere, so the lower half is usually occluded by the floor surface you are standing on. The colors of the sphere have the same effects as the colors of a prismatic wall.`,
        castingTime: "1 standard action",
        range: "10 ft.",
        area: "",
        effect: "10-ft.-radius sphere centered on you",
        targets: "",
        duration: "10 min./level (D)",
        savingThrow: "see text",
        spellResistance: "see text",
        components: "V, ",
        },
        {
        level: "9",
        name: "Spellbane",
        type: ["control"],
        school: "abjuration",
        tags: [],
        longDesc: `This spell creates an area within which spells selected by you simply do not function.
        \nSelect one spell per five caster levels at the time of casting. The spells selected cannot be changed after the spell is cast. This spell otherwise functions like antimagic field, except its emanation only prevents the functioning of the selected spells. Only the exact spells mentioned are affected—a spellbane set to prevent the casting of summon nature's ally II would not prevent castings of summon nature's ally I or summon nature's ally III. If you move into an area where a previously cast spell you have selected as a banned spell is in effect, that spell is affected as if by antimagic field. If the spell affects a summoned creature that has spell resistance, you must make a caster level check against the creature's spell resistance to make it wink out.
        \nThis spell can even negate an antimagic field, another instance of this spell, or any spell that specifies immunity to antimagic field (such as wall of force, prismatic sphere, and prismatic wall). Multiple spellbane effects can overlap. Their effects stack, preventing the functioning of every spell targeted by any of the multiple spellbane emanations. Spell effects created by artifacts or deities cannot be suppressed by this spell.`,
        castingTime: "1 standard action",
        range: "10 ft.",
        area: "10-ft.-radius emanation, centered on you",
        effect: "",
        targets: "",
        duration: "1 hour/level (D)",
        savingThrow: "none",
        spellResistance: "see text",
        components: "V, S, F",
        },
        {
        level: "9",
        name: "Suffocation, Mass",
        type: ["control"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell extracts the air from the target's lungs, causing swift suffocation. The target can attempt to resist this spell's effects with a Fortitude save-if he succeeds, he is merely staggered for 1 round as he gasps for breath. If the target fails, he immediately begins to suffocate. On the target's next turn, he falls unconscious and is reduced to 0 hit points. One round later, the target drops to -1 hit points and is dying. One round after that, the target dies. Each round, the target can delay that round's effects from occurring by making a successful Fortitude save, but the spell continues for many rounds, and each time a target fails his Fortitude save, he moves one step further along the track to suffocation. If a creature succeeds 3 saves in a row it ends this spell on them. This spell only affects living creatures that must breathe. It is impossible to defeat the effects of this spell by simply holding one's breath-if the victim fails the initial saving throw, the air in his lungs is extracted.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature/2 levels (no two of which may be more than 30 feet apart)",
        duration: "1 round/level",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "9",
        name: "Tsunami",
        type: ["control"],
        school: "conjuration(creation)",
        tags: ["water"],
        longDesc: `You create a massive wave of water that then moves in a straight line across water or land-you select the direction the wave travels (which must be perpendicular to its width), but once set in motion, the wave cannot change course. Over the surface of open water, the wave travels at a speed of 60 feet per round-on land or underwater, the wave travels at a speed of 30 feet per round. Creatures struck by a tsunami take 15d6 points of bludgeoning damage (a Fortitude save halves this damage, scales with cold spell power). In addition, the tsunami makes a special CMB check against any creature it strikes-the wave's CMB is equal to your caster level + your relevant spellcasting ability score modifier (whichever is highest) + 8 (for the wave's size). If this CMB check defeats a creature's CMD, the creature is knocked prone and carried along by the wave. A creature carried along by a tsunami can attempt to escape the wave on its turn as a standard action by making a CMB or Swim check opposed by the wave's CMB check-if a creature fails to escape, it takes another 10d6 points of bludgeoning damage (Fortitude save for half ) and continues being carried along by the wave. Objects struck by a tsunami are swept up if they are Huge or smaller and are carried along by the wave, deposited in a pile at the end of the wave's journey. Gargantuan or larger objects, as well as structures or objects firmly attached to the ground, take 15d6 points of bludgeoning damage when a tsunami passes through its space-if this is enough to destroy the object or structure, the remains are carried along by the wave. Hardness does not reduce this damage, nor is it halved as damage dealt to objects normally is. Freedom of movement prevents a creature from being carried along by a tsunami but does not prevent damage caused by it hitting a creature. A solid barrier that is taller than the tsunami that is not destroyed by the wave stops that portion of the wave from continuing onward, leaving a gap in the wave as the rest of it continues forward.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "10-ft.-deep wave 10 ft. wide/level and 2 ft. tall/level",
        targets: "",
        duration: "5 rounds",
        savingThrow: "see text",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Polar Midnight",
        type: ["control", "damage"],
        school: "transmutation",
        tags: ["cold", "darkness"],
        longDesc: `You plunge an area into the brutal chill of the arctic night. Illumination conditions are dropped by two steps (though only to darkness, not supernatural darkness), and all creatures in the area take 5d6 points of cold damage and 1d6 points of Dexterity damage per round. For each level above your actual level you cast this spell, the cold damage increases by 1d6, and the dexterity damage increases by +1. A successful Fortitude save each round negates the Dexterity damage but not the cold damage. Any creature that doesn't move at least 5 feet on its turn becomes encased in a sheath of ice equivalent to wall of ice, is helpless, and cannot breathe. Corpses in the area for longer than 1 round are transmuted into solid ice; reviving the icy corpse requires true resurrection, miracle, or wish. As a move action, you may move the area of effect up to 10 feet in any direction.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "30-ft. spread",
        targets: "",
        duration: "1 round/level",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Storm of Vengeance",
        type: ["control", "damage"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `You create a huge black storm cloud in the air. Each creature under the cloud must succeed on a Fortitude save or be deafened for 1d4 x 10 minutes. Each round the spell is active, the following effects happens on your turn, however you can choose omit any effect you want, and you are unaffected by your own storm of vengeance. The following effects occur on your turn:        
        \n1: Acid rains down in the area, dealing 1d6 points of acid damage (no save).        
        \n2: You call six bolts of lightning down from the cloud. You decide where the bolts strike. No two bolts may be directed at the same target. Each bolt deals 10d6 points of electricity damage. A creature struck can attempt a Reflex save for half damage.        
        \n3: Hailstones rain down in the area, dealing 5d6 points of bludgeoning damage (no save).        
        \n4: Violent rain and wind gusts reduce visibility. The rain obscures all sight, including darkvision, beyond 5 feet. A creature 5 feet away has concealment (attacks have a 20% miss chance). Creatures farther away have total concealment (50% miss chance, and the attacker cannot use sight to locate the target). Speed is reduced by three-quarters.
        \nadditionally, Ranged attacks within the area of the storm are impossible. Spells cast within the area are disrupted unless the caster succeeds on a Concentration check against a DC equal to the storm of vengeance‘s save DC + the level of the spell the caster is trying to cast.`,
        castingTime: "1 round",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "360-ft.-radius storm cloud",
        targets: "",
        duration: "concentration (maximum 10 rounds) (D)",
        savingThrow: "see text",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "9",
        name: "Mage's Disjunction",
        type: ["control", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `All magical effects and magic items within the radius of the spell, except for those that you carry or touch, are disjoined. That is, spells and spell-like effects are unraveled and destroyed completely (ending the effect as a dispel magic spell does), and each permanent magic item must make a successful Will save or be turned into a normal item for the duration of this spell. An item in a creature's possession uses its own Will save bonus or its possessor's Will save bonus, whichever is higher. If an item's saving throw results in a natural 1 on the die, the item is destroyed instead of being suppressed. You also have a 1% chance per caster level of destroying an antimagic field. If the antimagic field survives the disjunction, no items within it are disjoined. You can also use this spell to target a single item. The item gets a Will save at a -5 penalty to avoid being permanently destroyed. Even artifacts are subject to mage's disjunction, though there is only a 1% chance per caster level of actually affecting such powerful items. If successful, the artifact's power unravels, and it is destroyed (with no save). If an artifact is destroyed, you must make a DC 25 Will save or permanently lose all spellcasting abilities. These abilities cannot be recovered by mortal magic, not even miracle or wish. Destroying artifacts is a dangerous business, and it is 95% likely to attract the attention of some powerful being who has an interest in or connection with the device.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "all magical effects and magic items within a 40-ft.-radius burst, or one magic item (see text)",
        effect: "",
        targets: "",
        duration: "1 minute/level",
        savingThrow: "Will negates (object)",
        spellResistance: "no",
        components: "V, ",
        },
        {
        level: "9",
        name: "Wall of Suppression",
        type: ["control", "utility"],
        school: "abjuration",
        tags: [],
        longDesc: `You create a wall of glittering motes that suppresses or even negates any magical effect passing through it. The wall appears to have no actual substance and does not physically obstruct or impede anything attempting to move through it. However, the wall exerts a powerful anti-magical effect. Any magic item or magical spell or effect of your caster level or lower that passes through the wall is suppressed for 1 round per level. Spells or effects with durations expire normally, even while thus suppressed. A spell or with a duration greater than that of the suppression resumes functioning normally when the suppression ends. The wall affects all magical effects, including spells, spelllike abilities, magical items, and any effects stemming from them that pass through the wall. The wall does not suppress a creature's ability to cast spells, use spell-like abilities, or any other sort of limited-use abilities even if the wall suppresses a particular application of those abilities. However, if a creature with magical abilities that are constant or otherwise always active passes through the wall, those abilities are suppressed for the normal duration. The wall blocks line of effect, so no spell or effect can pass through the wall, but it does not block line of sight. Magic items or spell effects with a higher caster level than yours are unaffected by the wall of suppression. The wall does not affect artifacts, anything stemming from the direct action of a deity, or similarly powerful sorts of magic.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "anti-magic wall occupying up to two 5 ft. cubes/level (S)",
        targets: "",
        duration: "10 minutes/level; see text",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "9",
        name: "Acid Geyser",
        type: ["damage"],
        school: "evocation",
        tags: ["acid"],
        longDesc: `You summon a geyser that spews acid from the square in a 20ft radius, and 50ft into the air, dealing its damage immediately upon casting it, when a creature enters the area, or ends their turn in the area. Creatures damaged take 1d6 of acid damage per caster level (reflex half). One round after casting the spell you can reduce the duration of the spell by 2 rounds as a swift action to cause the geyser to launch an additional spray of acid at a specific target within 30 feet of the geyser, dealing 1d6 acid damage per 2 caster levels. This additional attack is a ranged touch attack, and has no save.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "20ft radius, 50ft up",
        effect: "",
        targets: "5-ft square of earth",
        duration: "1 round/2 levels",
        savingThrow: "Reflex partial",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "9",
        name: "Canopic Conversion",
        type: ["damage"],
        school: "necromancy",
        tags: ["death", "evil"],
        longDesc: `This spell eviscerates the target, drawing forth its life essence as well as its internal organs. The target takes 1d6 hit points of damage per caster level (maximum 20d6, scales with negative spell power). If this damage kills the target, the spell pulls the creature's organs into a set of 4 canopic jars and seals them; 1d4 rounds later, the corpse revives as a mummy (if 8 HD or fewer) or an advanced mummy (if 9 HD or more). You have control over the mummy, and all of its abilities and affects do not harm any allies. The mummy gains a bonus to attack and damage rolls equal to your caster level, and a deflection bonus to armor class, and a profane bonus to saves equal to your highest mental. Creatures summoned by this spell last through floors.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living humanoid",
        duration: "instantaneous and see text",
        savingThrow: "Fortitude half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "9",
        name: "Clashing Rocks",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["earth"],
        longDesc: `You create two Colossal-sized masses of rock, dirt, and stone and slam them together against a single creature between them. The clashing rocks appear up to 30 feet away from the target on opposite sides and rush toward it with a mighty grinding crash. You must make a ranged touch attack to hit the target with the rocks. The clashing rocks ignore concealment and cover, and if there is a solid barrier between the target and either of the clashing rocks, the spell has a +28 bonus on the Strength check to burst through the barrier and continue unimpeded to the target. A creature struck by the clashing rocks takes 20d6 points of bludgeoning damage and is knocked prone. If the target fails a Reflex saving throw, it is also buried under the resulting rubble requiring a DC 25 strength check to free itself. If the clashing rocks miss the target, the target still takes 10d6 points of bludgeoning damage from falling rocks and is knocked prone. A successful Reflex save reduces this damage to half and the target remains standing. Creatures other than the target that occupy the spaces where the clashing rocks appear or within their path (30 feet wide, 30 feet high, and up to 60 feet long) must also make Reflex saves or take 10d6 points of bludgeoning damage and be knocked prone (save for half and remain standing). A creature can only take damage once from the clashing rocks, no matter how many times the clashing rocks pass over a target creature. This spell's damage scales with acid spell power.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "",
        effect: "see text",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Reflex partial, see text",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Cryolith Descent",
        type: ["damage"],
        school: "evocation",
        tags: ["cold"],
        longDesc: `You drop a massive pillar of ice on a location, all creatures within the radius must make a reflex save or take 1d6 cold damage per level. Any creature that rolls a natural 1 on the save takes critical damage. this spell has +50% cold critical damage. If there was a creature in the square the spell was centered on that creature also takes an additional 1d6 bludgeoning damage per caster level (the initial reflex save halves this as well, but isn't doubled on failure by more than 10 or a natural 1), and is knocked to the ground(if flying) and becomes prone.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "10-ft radius centered on a square",
        duration: "instantaneous",
        savingThrow: "Reflex partial",
        spellResistance: "yes",
        components: "V, S",
        },
        {
        level: "9",
        name: "Energy Drain",
        type: ["damage"],
        school: "necromancy",
        tags: [],
        longDesc: `This spell functions like enervation, except that the creature struck gains 2d4 temporary negative levels. Twenty-four hours after gaining them, the subject must make a Fortitude saving throw (DC = energy drain spell's save DC) for each negative level. If the save succeeds, that negative level is removed. If it fails, that negative level becomes permanent. An undead creature struck by the ray gains 2d4x5 temporary hit points for 1 hour.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "ray of negative energy",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Fortitude partial; see text for enervation",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Implosion",
        type: ["damage"],
        school: "evocation",
        tags: [],
        longDesc: `This spell causes a destructive resonance in a corporeal creature's body. Each round you concentrate (including the first), you can cause one creature to collapse in on itself, inflicting 10 points of damage per caster level. If you break concentration, the spell immediately ends, though any implosions that have already happened remain in effect. You can target a particular creature only once with each casting of the spell. Implosion has no effect on creatures in gaseous form or on incorporeal creatures.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one corporeal creature/round",
        duration: "concentration (up to 1 round per 2 levels)",
        savingThrow: "Fortitude negates",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Keraunos",
        type: ["damage"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You charge an incredibly powerful bolt of lightning, when you first start casting this spell you choose its path for when you finish casting it. When you do finish casting it you fire the bolt along that chosen path, it deals 4d6 electricity damage per caster level (maximum 60d6) reflex half. This otherwise acts like lightning bolt. Creatures who succeed the spellcraft check know where you are aiming the spell unless you also make a successful bluff while casting the spell. This spell cannot be cast any faster than 1 round.`,
        castingTime: "1 round",
        range: "250 ft.",
        area: "250ft. line",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
            level: "9",
            name: "100 Shards",
            type: ["damage"],
            school: "evocation",
            tags: ["cold"],
            longDesc: `You target a creature to face the full onslaught of dozens of tiny cutting shards of ice, roll 1d100 to determine how many potential shards strike the creature, then the creature rolls a reflex saving throw, subtract the total of the reflex save from the total shards rolled, that is how many shards strike it. If a creature has evasion, increase the result of their save by 50%, if they have greater evasion, increase it by 100%. Each shard deals 1d4 points of damage, half of this is cold damage, half of this is piercing damage. Resistances and damage reduction applies only once per casting of the spell. If you roll a perfect 100 on the dice, you add another d100 shards to the spell, though the creature gets an additional reflex saving throw to reduce the shard count again. This can continue as long as you roll 100s.`,
            castingTime: "1 standard action",
            range: "close(25ft. + 5ft./2 levels)",
            area: "",
            effect: "",
            targets: "1 creature",
            duration: "instantaneous",
            savingThrow: "reflex partial; see text",
            spellResistance: "yes",
            components: "V, S, M,",
        },
        {
            level: "9",
            name: "Sheer Voltage",
            type: ["damage"],
            school: "evocation",
            tags: ["electricity"],
            longDesc: `You channel an incredible charge of electricty through yourself to your target. After completion of this spell and at the end of each of your turns that you continue to concentrate the target takes 1d10 points of electricity damage per caster level. The target may make a fortitude saving throw to reduce the damage by half, but if it fails it becomes paralyzed for 1 round from the sheer voltage flowing through it.`,
            castingTime: "1 standard action",
            range: "close(25 ft. + 5 ft./2 levels)",
            area: "",
            effect: "",
            targets: "1 creature",
            duration: "concentration",
            savingThrow: "fortitude partial",
            spellResistance: "yes",
            components: "V, S, M,",
        },
        {
        level: "9",
        name: "Kill Word Murder",
        type: ["damage"],
        school: "enchantment (compulsion)",
        tags: ["death", "mind-affecting"],
        longDesc: `You utter a single word of power that potentially kills one creature of your choice, whether the creature can hear the word or not. The creature makes any save of its choice, if it fails it dies instantly. A creature that rolls a natural 1 does not automatically fail to save against this spell unless that would also count as a critical failure on the save. Any creature that currently has 300 or more hit points is unaffected by kill word murder. For every level your caster level is above your actual level, the amount of hit points the creature can have increases by 25.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "instantaneous",
        savingThrow: "yes",
        spellResistance: "yes",
        components: "V",
        },
        {
        level: "9",
        name: "Massacre",
        type: ["damage"],
        school: "necromancy",
        tags: ["death"],
        longDesc: `You unleash a wave of necromantic energy that snuffs out the life force of those in its path. This wave pulses out from you in a line 5 feet wide and 60 feet long. The wave visibly rips the souls from the bodies of those it passes through, which manifest as screaming, transparent versions of the affected creatures. This spell instantly kills any creature with less than 50 hit points, if a creature saves or has too many hit points and doesn't save, it instead receives 2d4 temporary negative levels. If it has too many hit points and saves it takes only 1d4 temporary negative levels. For each previous creature struck by this spell the DC increases by +2, and it now has its stronger effects against creatures with 25 more hit points (so 75 instead of 50), and deals an additional 1 negative level for all following creatures affected by the pulse. If it kills a creature double these bonuses. This stacks. If the spell does not kill any creatures, the unreleased necromantic energy violently explodes in the final square of the 60-foot line, dealing 15d6 points of damage + 1 point per caster level to any creature in that square with no saving throw. If several creatures occupy the same square, it affects all of them.`,
        castingTime: "1 standard action",
        range: "",
        area: "60-ft. line",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "Fortitude partial",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "9",
        name: "Meteor Swarm",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `Meteor swarm is a very powerful and spectacular spell that is similar to fireball in many aspects. When you cast it, four 2-foot-diameter spheres spring from your outstretched hand and streak in straight lines to the spots you select. The meteor spheres leave a fiery trail of sparks. If you aim a sphere at a specific creature, you may make a ranged touch attack to strike the target with the meteor. Any creature struck by a sphere takes 4d6 points of bludgeoning damage (no save) and takes a -4 penalty on the saving throw against the sphere's fire damage (see below). If a targeted sphere misses its target, it simply explodes at the nearest corner of the target's space. You may aim more than one sphere at the same target. Once a sphere reaches its destination, it explodes in a 40-foot-radius spread, dealing 4d6 fire damage. If this spell is cast at a higher level than your actual level, it deals an additional 1d6 fire per 2 caster levels higher you are than your actual level. If a creature is within the area of more than one sphere, it must save separately against each. Despite stemming from separate spheres, all of the fire damage is added together after the saves have been made, and fire resistance is applied only once.`,
        castingTime: "1 standard action",
        range: "long (400 ft. + 40 ft./level)",
        area: "four 40-ft.-radius spreads, see text",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none or Reflex half, see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Power Word Kill",
        type: ["damage"],
        school: "enchantment(compulsion)",
        tags: ["death", "mind-affecting"],
        longDesc: `You utter a single word of power that instantly kills one creature of your choice, whether the creature can hear the word or not. Any creature that currently has 101 or more hit points is unaffected by power word kill.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature with 100 hp or less",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "9",
        name: "The Unmatched Power of The Sun",
        type: ["damage"],
        school: "evocation",
        tags: ["fire"],
        longDesc: `The power of the sun, right in the palm of your hand, what could go wrong? This spell deals 2d6 fire damage per character level, and your fire mastery (not including universal mastery) counts as 50% higher for this spell. The spell deals damage in a 100-ft. radius burst, reflex save for half. Creatures that fail this save are also blinded permanently. Creatures vulnerable to sunlight take 50% more damage and the damage becomes untyped. This also dispels all darkness spells in its area. This spell has a +50% spell critical damage, +1% spell critical chance, and +1% spell fumble chance. If you critically fumble this spell it deals an additional 20d6 untyped damage, but the target square becomes your own, and you are instantly killed and reduced to nothing, requiring a true resurrection spell to bring you back to life. When you are restored to life, you also receive 2 additional negative levels. You can choose to critically fumble this spell at will.`,
        castingTime: "1 standard action",
        range: "close (25ft. + 5ft./2 levels)",
        area: "100-ft.-radius spread",
        effect: "",
        targets: "",
        duration: "instantaneous",
        savingThrow: "reflex half",
        spellResistance: "yes",
        components: "V, S, M",
        },
        {
            level: "9",
            name: "Hammer of Dawn",
            type: ["damage"],
            school: "evocation",
            tags: ["fire"],
            longDesc: `You choose a 10ft. square within range, then 1d3 rounds later a massive beam of fire originating 62 miles above blasts the square for 1 round per 2 levels. This deals 2d6 points of fire damage per caster level. Creatures who are in the square on the round it reaches the location are not allowed a reflex saving throw, though if a creature enters the area later or if they start their turn in the beam, they are allowed a reflex saving throw to half the damage. As a movement action you can direct the beam to a new location within 50 feet of the previous location, which it will move too in 1 round, damaging all creatures along the way (reflex halves). The spell is imprecise, and it always ends its movement 1d3 x5 feet in a random direction from where it was intended. If the targeted location is inside of a structure the beam requires an extra 1 round to reach it per 20 feet of material in the way, this counts against the spells duration. However, because of its ability to pierce any material, it also creates 20 foot deep pits whenever it remains in a location for 1 round. It is easy to tell the hammer is coming by the large light in the sky, or the sound of the roof melting, though its exact location is unknown except to the caster of the spell.`,
            castingTime: "1 standard action",
            range: "close (25ft. + 5ft./2 levels)",
            area: "10-ft. square",
            effect: "",
            targets: "",
            duration: "1 round/2 levels",
            savingThrow: "reflex half",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
            level: "9",
            name: "Ice Age",
            type: ["damage","control"],
            school: "evocation",
            tags: ["cold"],
            longDesc: `You bring about an ice age. All creature on the map take 20d6 cold damage, and become staggered for 1 round. A successful fortitude halves this damage and negates the stagger. If a creature fails this saving throw twice in a row it instead becomes paralyzed for 1 round, though creatures immune to cold damage are immune to the stagger and paralysis as well. At the start of each of your turns this effect continues to damage and possibly stagger all creatures. Additionally, all cold spells cast have their DC increased by 2, gain 20 spell power, 25% spell critical damage. Fire spells have their DC reduced by 2 and their spell power reduced by 25. The entire map becomes difficult terrain, and all vision is blocked further than 60 feet by the falling snow.`,
            castingTime: "1 full-round action",
            range: "",
            area: "Map",
            effect: "",
            targets: "",
            duration: "1 round/2 levels",
            savingThrow: "fortitude partial",
            spellResistance: "yes",
            components: "V, S, M",
        },
        {
        level: "9",
        name: "Transmute Blood to Acid",
        type: ["damage"],
        school: "transmutation",
        tags: ["acid", "pain"],
        longDesc: `You transmute blood in the target's body to acid, dealing 1d6 points of acid damage/2 levels (maximum 12d6) each round. The creature is staggered and sickened by the debilitating pain. A successful Fortitude save each round halves the damage and negates the staggered condition for 1 round. If this damage reduces the creature to 0 or fewer hit points, it dissolves, leaving only the barest trace of remains. Anyone who strikes the target with a non-reach melee weapon, natural weapon, or unarmed attack takes 3d6 points of acid damage as the acidic blood sprays on the attacker. If the attack is from a piercing or slashing manufactured weapon, the weapon also takes this damage. This spell has no effect on creatures immune to critical hits or bleed effects.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature",
        duration: "1 round/4 levels",
        savingThrow: "Fortitude half",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "9",
        name: "Universal Solvent",
        type: ["damage"],
        school: "conjuration(creation)",
        tags: ["acid"],
        longDesc: `You launch a globe of universal salvent to coat a creature. It lasts 5 rounds, it immediately deals 1d6 damage, then at the start of each of your turns it deals more damage, the first round dealing 2d6, the second round 4d6, the third 8d6, the forth 16d6, the fifth 32d6. Each turn the creature can make a fortitude save to halve the damage. If you cast this spell on a creature that is already effected by universal solvent, it instead takes the damage it would take the next turn immediately, essentially reducing the spells duration by 1 round, however the fortitude save DC increases by 1 for each round it has been active on them.`,
        castingTime: "1 standard action",
        range: "close (25ft. + 5ft./2 levels)",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "5 rounds",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "9",
        name: "Wail of the Banshee",
        type: ["damage"],
        school: "necromancy",
        tags: ["death", "sonic"],
        longDesc: `When you cast this spell, you emit a terrible, soul-chilling scream that possibly kills creatures that hear it (except for yourself). The spell affects up to one creature per caster level, inflicting 1d10 points of damage per caster level (scales with negative spell power). Creatures closest to the point of origin are affected first. A successful fortitude save reduces the damage to 3 points per caster level. This scales with negative power.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one living creature/level within a 40-ft.-radius spread",
        duration: "instantaneous",
        savingThrow: "Fortitude halves",
        spellResistance: "yes",
        components: "V, ",
        },
        {
        level: "9",
        name: "Weird",
        type: ["damage"],
        school: "illusion(phantasm)",
        tags: ["emotion", "fear", "mind-affecting"],
        longDesc: `This spell functions like phantasmal killer, except it can affect more than one creature. Only the affected creatures see the phantasmal creatures attacking them, though you see the attackers as shadowy shapes. If a subject's Fortitude save succeeds, it still takes 3d6 points of damage and is stunned for 1 round. The subject also takes 1d4 points of Strength damage.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "",
        targets: "any number of creatures, no two of which can be more athan 30 ft. apart",
        duration: "instantaneous",
        savingThrow: "Will disbelief, then Fortitude partial; see text",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Ride the Lightning",
        type: ["damage", "utility", "buff"],
        school: "evocation",
        tags: ["electricity"],
        longDesc: `You may transform into lightning as a standard action and instantly travel in a straight line to a distance of up to 120 feet, rematerializing in the new location as a free action. This movement does not provoke attacks of opportunity. Creatures in this line take 15d6 points of electrical damage and are staggered for 1 round (a successful Reflex save halves the damage and negates the staggered condition, spell resistance applies). Objects in your path are damaged as well, with combustible objects being set ablaze and metals with low melting points melted. If your path is interrupted by a barrier or otherwise deflected, you materialize short of your final destination in the nearest open space; targets in the line to that point take damage as normal. You are immune to electricity while this spell lasts. Alternatively you can transform and move as a movement action, but you only move 60 feet, and the spell only deals 8d6 damage, or transform and move as a swift action, but you only move 10 feet and the spell no longer possibly staggers and only deals 4d6 damage.`,
        castingTime: "1 swift action",
        range: "personal",
        area: "",
        effect: "",
        targets: "you",
        duration: "1 round/level (D)",
        savingThrow: "",
        spellResistance: "",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Freedom",
        type: ["healing"],
        school: "abjuration",
        tags: [],
        longDesc: `The subject is freed from spells and effects that restrict movement, including binding, entangle, grappling, imprisonment, maze, paralysis, petrification, pinning, sleep, slow, stunning, temporal stasis, and web. To free a creature from imprisonment or maze, you must know its name, and you must cast this spell at the spot where it was entombed or banished into the maze.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels) or see text",
        area: "",
        effect: "",
        targets: "one creature",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Heal, Mass",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `Heal enables you to channel positive energy into a creature to wipe away injury and afflictions. It immediately ends any and all of the following adverse conditions affecting the target: ability damage, blinded, confused, dazed, dazzled, deafened, diseased, exhausted, fatigued, feebleminded, insanity, nauseated, poisoned, sickened, and stunned. It also cures 10 hit points of damage per level of the caster, to a maximum of 250 points at 25th level.
                \nHeal does not remove negative levels or restore permanently drained ability score points.
                \nIf used against an undead creature, heal instead acts like harm.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "one or more creatures, no two of which can be more than 30 ft. apart",
        duration: "instantaneous",
        savingThrow: "Will negates (harmless)",
        spellResistance: "yes (harmless)",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "True Resurrection",
        type: ["healing"],
        school: "conjuration(healing)",
        tags: [],
        longDesc: `This spell functions like raise dead, except that you can resurrect a creature that has been dead for as long as 10 years per caster level. This spell can even bring back creatures whose bodies have been destroyed, provided that you unambiguously identify the deceased in some fashion (reciting the deceased's time and place of birth or death is the most common method). Upon completion of the spell, the creature is immediately restored to full hit points, vigor, and health, gaining no additional negative levels or constitution drain, and all of the spell points possessed by the creature when it died. You can revive someone killed by a death effect or someone who has been turned into an undead creature and then destroyed. This spell can also resurrect elementals or outsiders, but it can't resurrect constructs or undead creatures. Even true resurrection can't restore to life a creature who has died of old age. This spell, unlike most spells, costs 25 gold to cast.`,
        castingTime: "2 rounds",
        range: "touch",
        area: "",
        effect: "",
        targets: "dead creature touched",
        duration: "instantaneous",
        savingThrow: "none; see text",
        spellResistance: "yes (harmless)",
        components: "V, S, M,DF,",
        },
        {
        level: "9",
        name: "Elemental Swarm",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell opens a portal to an Elemental Plane and summons elementals from it. The caster can choose any plane (Air, Earth, Fire, or Water);. When the spell is complete, 2d4+2 Large elementals appear. 3 rounds later, 1d4+1 Huge elementals appear. 3 rounds after that, two greater elementals appears. Each elemental has maximum hit points per HD. Once these creatures appear, they serve you for the duration of the spell. The elementals obey you explicitly and never attack you, even if someone else manages to gain control over them. You do not need to concentrate to maintain control over the elementals. You can dismiss them singly or in groups at any time. When you use a summoning spell to summon an air, earth, fire, or water creature, it is a spell of that type.`,
        castingTime: "1 round",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "two or more summoned creatures, no two of which can be more than 30 ft. apart",
        targets: "",
        duration: "10 min./level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Gate",
        type: ["utility"],
        school: "conjuration(creation, calling)",
        tags: [],
        longDesc: `You may then call a particular individual or kind of being through the gate. The gate itself is a circular hoop or disk from 5 to 20 feet in diameter (caster's choice) oriented in the direction you desire when it comes into existence (typically vertical and facing you). It is a two-dimensional window looking into the plane you specified when casting the spell, and the called creature instantly steps out of it. By naming a particular being or kind of being as you cast the spell, you cause the gate to open in the immediate vicinity of the desired creature and pull the subject through, willing or unwilling, and it instanly comes under your control. The gate remains open just long enough to transport the called creatures. If you choose to call a kind of creature instead of a known individual, you may call either a single creature or several creatures. In either case, their total HD cannot exceed twice your caster level. You cannot summon any creature with more HD than your caster level. Note: When you use a calling spell such as gate to call an air, chaotic, earth, evil, fire, good, lawful, or water creature, it becomes a spell of that type. You can only have a gated in creatures from a single gate spell at a time, and if cast a second time all creatures from the previous gate spell vanish immediately.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "see text",
        targets: "",
        duration: "instantaneous",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, M,",
        },
        {
        level: "9",
        name: "Shadow Transmutation, Greater",
        type: ["utility"],
        school: "illusion(shadow)",
        tags: ["shadow"],
        longDesc: `This spell functions like shadow transmutation, except it can mimic greater polymorph instead of polymorph. The illusory attacks and special abilities of any shape assumed using greater shadow transmutation deal three-fifths (60%) damage to nonbelievers, and nondamaging effects are 60% likely to work against nonbelievers.`,
        castingTime: "1 standard action",
        range: "see text",
        area: "",
        effect: "",
        targets: "see text",
        duration: "see text",
        savingThrow: "Will disbelief (if interacted with); varies; see text",
        spellResistance: "yes; see text",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Shambler",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: [],
        longDesc: `The shambler spell creates 1d4+2 shambling mounds with the advanced template. They do whatever bidding you have for them and remain until the end of the next floor. If you cast this spell while another casting is still in effect, the previous casting is dispelled.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "three or more shambling mounds, no two of which can be more than 30 ft. apart; see text",
        targets: "",
        duration: "2 floors",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Stone Phalanx",
        type: ["utility"],
        school: "conjuration(creation)",
        tags: ["earth"],
        longDesc: `You create 1d4+2 stone golems, they gain a bonus to their attack and damage equal to half your caster level. The golems willingly aid you in combat or battle, perform a specific mission, or serve as bodyguards. You can only have one stone phalanx spell in effect at one time. If you cast this spell while another casting is still in effect, the previous casting is dispelled.`,
        castingTime: "1 standard action",
        range: "medium (100 ft. + 10 ft./level)",
        area: "",
        effect: "three or more stone golems, no two of which can be more than 30 ft. apart (see text)",
        targets: "",
        duration: "1 hour/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Summon Elder Worm",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions as summon nature's ally VIII, except you summon a purple worm with the giant creature simple template and it gains your highest mental stat to attack and damage. Additionally, the DC for its poison is also increased by half your highest mental stat.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Summon Froghemoth-hemoth-hemoth",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell functions as summon nature's ally IX, except you summon a froghemoth with the giant simple template three times, giving it a +9 natural armor bonus to ac, increase its damage by 2 size steps, it gains +12 strength and constitution, -6 to dexterity, -8 to attack and AC, +8 to CMB and CMD (+6 to attacks, bite: 8d6+16, tentacles: 3d8+8, tongue: 2d6+8, 336 hp, 33 ac, 40ft space and reach, 80 reach with tongue). Additionally, it gains a bonus on its attacks equal to half your highest mental stat.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level (D)",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, ",
        },
        {
        level: "9",
        name: "Summon Monster IX",
        type: ["utility"],
        school: "conjuration(summoning)",
        tags: [],
        longDesc: `This spell summons an extraplanar creature (typically an outsider, elemental, or magical beast native to another plane). It appears where you designate and acts immediately, on your turn. It attacks your opponents to the best of its ability. If you can communicate with the creature, you can direct it not to attack, to attack particular enemies, or to perform other actions. The spell conjures one of the creatures from the level on Table from: https://www.d20pfsrd.com/magic/all-spells/s/summon-monster/ of the level equal to the level of this spell. Alternatively you can choose to summon 1d3 creatures from the list 1 level below, or 1d4+1 creatures from a list at least 2 levels lower. You choose which kind of creature to summon (one type of creature at a time if you are summoning multiple) but can only summon creatures from the core list (not alternative options), and you can choose a different one each time you cast the spell. A summoned monster cannot summon or otherwise conjure another creature, nor can it use any teleportation or planar travel abilities. Creatures cannot be summoned into an environment that cannot support them. Creatures summoned using this spell cannot use spells or spell-like abilities that duplicate spells with expensive material components (such as wish). When you use a summoning spell to summon a creature with an alignment or elemental subtype, it is a spell of that type. Creatures marked with an "*" are summoned with the celestial template, if you are good, and the fiendish template, if you are evil. If you are neutral, you may choose which template to apply to the creature. Creatures marked with an "*" always have an alignment that matches yours, regardless of their usual alignment. Summoning these creatures makes the summoning spell's type match your alignment.`,
        castingTime: "1 round",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "one summoned creature",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "no",
        components: "V, S, F,DF,",
        },
        {
        level: "9",
        name: "Soul Bind",
        type: ["utility", "buff"],
        school: "necromancy",
        tags: [],
        longDesc: `You draw the soul from a newly dead body and imprison it in a black sapphire gem. The subject must have been dead no more than 3 rounds. The soul, once trapped in the gem, cannot be returned through clone, raise dead, reincarnation, resurrection, true resurrection, or even a miracle or a wish. The black saphire gem has energy points equal to the HD/2 of the creature trapped, and you can expend the energy to empower yourself. You can expend energy whenever you so choose (even when not your turn), as long as you can take mental actions, and the bonuses stack. You can only have a single soul gem at a time, and it remains through floors, the ways to exchange energy is as follows:
        \n1 Energy: Restore 2 spell points or 4 hit points
        \n1 Energy: Increase the damage of a spell by 1d6 damage, this bonus damage only applies to a single damage roll, and it is of whatever damage type the spell deals, but it only applies to actual hit point damage
        \n2 Energy: Gain a +1 bonus to saving throws for 1 round
        \n3 Energy: Restore 1 point of ability drain or 2 points of ability damage
        \n4 Energy: While casting a spell you can reduce the level modification of a metamagic feat by 1 (though it doesn't change the spell point cost) 
        \n4 Energy: Increase your effective level for a spell by 1, or necromancy spell by 2  
        \n10 Energy: Your spell ignores any immunities the soul bound creature has that the target of the spell also has, however it gets a +6 to any saving throws, and gains a fortitude saving throw if the spell would not allow it.`,
        castingTime: "1 standard action",
        range: "close (25 ft. + 5 ft./2 levels)",
        area: "",
        effect: "",
        targets: "corpse",
        duration: "permanent",
        savingThrow: "Will negates",
        spellResistance: "no",
        components: "V, S, F,",
        },
        {
        level: "9",
        name: "Symbol of Strife",
        type: ["utility", "control"],
        school: "enchantment(compulsion)",
        tags: ["mind-affecting"],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to attempt to compel all creature within its radius to attack the nearest conscious creature for 1 round per 2 levels (as the attack nearest creature result of confusion). Will negates. It can continue being triggered until it has targeted creatures equal to your caster level, or up to 5 times. When it activates it activates in a burst, affecting the closest creatures first. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 19 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 20 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "will negates",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
        level: "9",
        name: "Symbol of Vulnerability",
        type: ["utility", "control"],
        school: "abjuration",
        tags: [],
        longDesc: `You inscribe a rune on a square adjacent to you, then 3 rounds after you have inscribed it, it becomes active. Once it is active, you can as a swift action speak the a trigger word to trigger it to weaken all creature within its radius. Weakened creatures take a -4 penalty to spell resistance, a -4 penalty on saving through, energy resistance and damage reduction are reduced by 10 (min 0). This effect lasts as long as the creature is within 45 feet of the symbol. It can continue being triggered until it has targeted creatures equal to your caster level, or up to 5 times. When it activates it activates in a burst, affecting the closest creatures first. Creatures that hear the trigger word can repeat the trigger word as long as they can make a spellcraft check DC 19 + your level/2, but it cannot be activated more than once per round. All symbols of the same type are triggered at the same time with a single trigger word.`,
        castingTime: "1 standard action",
        range: "5 ft.; then 20 feet radius",
        area: "",
        effect: "one symbol",
        targets: "",
        duration: "1 round/level",
        savingThrow: "none",
        spellResistance: "yes",
        components: "V, S, M,",
        },
        {
            level: "9",
            name: "Black Hole",
            type: ["damage", "control"],
            school: "conjuration",
            tags: ["force"],
            longDesc: `When summoned and at the start of each of your turns, all creatures within the radius take 1d6 force damage per caster level and the creature must make a CMB check DC equal to the DC of the spell +10, or they are pulled to the closest adjacent square of the black hole. Success pulls them 5 feet instead (but no closer than adjacent). To move away from the black hole a creature must also make a CMB check as well. If a creature every moves directly into the black holes square, or If on your turn they are adjacent to the black hole and fail the CMB check, they are pulled into the square of the black hole and instead take 2d6 per caster level force damage and they must make a fortitude save with a +4 bonus to the DC or they are stunned for 1 round.`,
            castingTime: "1 standard action",
            range: "close (25ft. + 5ft./2 levels)",
            area: "5ft cube with 20ft. radius",
            effect: "",
            targets: "",
            duration: "1 round/2 levels",
            savingThrow: "fortitude partial",
            spellResistance: "yes",
            components: "V, S, M",
        },
]